'use client';
import { css, keyframes, useTheme, Global, ClassNames } from '@emotion/react';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import _styled from '@emotion/styled/base';
import { FONT_STYLE, ResizeImage, MEDIA_QUERY, HOVER as HOVER$1, pxToRem, useSnackbar, Box, useResponsive, TruckIcon, ChevronDownIcon as ChevronDownIcon$1, CallIcon, ChevronUpIcon, RESET_BUTTON, getImageUrl, CircleFilledIcon, Avatar as Avatar$1, Flex, Text as Text$3, ScrapFilledIcon, ScrapIcon, StackedImagesIcon, StackedImagesFilledIcon, ArrowLeftIcon, TextButton as TextButton$1, LaunchIcon, DotBadge, FOCUS, useMedia, BREAK_POINT, ZINDEX as ZINDEX$1, useResize, hexToRgba, IntersectionObserver as IntersectionObserver$1, SearchIcon, StoreIcon, ChevronRightIcon, ClockIcon, safeAreaInset, CircleBadge, CartIcon, useIsInApp, MenuIcon, DismissCircleIcon, Input as Input$1, getNearestSize, ODS_FONT_STYLE, BoxButton, DeleteFilledIcon, PhotoIcon, SquareBadge as SquareBadge$1, Chip, useMatchMedia, DismissIcon, getCookie as getCookie$1, Heading } from '@bucketplace/design-system';
import { Icon as Icon$2, Button as Button$9, DividerListItem, Modal, EmptyPage, ToggleButton, SquareBadge, OutlineButton, OutlineButtonWithIcon, Divider, Responsive, TextButton, OutlineSelectChip, Drawer, OutlineAnchorButton, AnchorButton, Avatar as Avatar$2, useNodeHeight, useScrollDirection, Sticky, Container as Container$G, Popper as Popper$1, TabItem, Tab, CircleImage, Search as Search$1, getWithIconOptions, IconNotification, NotificationType, NavigationTopBanner, RadioWithText, ListItem as ListItem$1, Dim as Dim$1, Toggle, VirtualizedList, Loading, CheckboxWithText, Textarea, TextareaWithCountHint, CarouselScrollControl, SEARCH_TYPE as SEARCH_TYPE$1, SocialLink } from '@bucketplace/design-system/bds';
import * as React from 'react';
import React__default, { useEffect, Children, cloneElement, useCallback, useState, useRef, useMemo, memo, Fragment as Fragment$1, forwardRef, createContext, useContext, isValidElement, useImperativeHandle, createElement } from 'react';
import { sendBridgeAction } from '@bucketplace/owap-sdk';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { createPortal } from 'react-dom';
import { jsxs as jsxs$1, jsx as jsx$1 } from 'react/jsx-runtime';
import { useNodeHeight as useNodeHeight$1, useScrollDirection as useScrollDirection$1, DEFAULT_STICKY_STATE, Sticky as Sticky$1, ResizeImage as ResizeImage$1 } from '@bucketplace/ui';
import { useTranslation } from 'react-i18next';

const USERABLE_TYPE = {
  normal: 'NormalUser',
  expert: 'ExpertUser',
  seller: 'SalesUser'
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$J = process.env.NODE_ENV === "production" ? {
  name: "fhxb3m",
  styles: "display:flex;flex-direction:row;align-items:center"
} : {
  name: "10eyhqw-Container",
  styles: "display:flex;flex-direction:row;align-items:center;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1H
};
const Container$F = ({
  children,
  direction = 'vertical',
  ...restProps
}) => {
  return jsx("div", {
    css: [direction === 'horizontal' && _ref$J, process.env.NODE_ENV === "production" ? "" : ";label:Container;"],
    ...restProps,
    children: children
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Content$7 = ({
  subHead,
  headLine,
  children
}) => {
  return jsxs(Root$4, {
    children: [subHead && jsx(SubHead, {
      children: subHead
    }), jsx(HeadLine, {
      className: "head-line",
      children: headLine
    }), children && jsx(Body$1, {
      children: children
    })]
  });
};
const Root$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eweii2c3"
} : {
  target: "eweii2c3",
  label: "Root"
})();
const SubHead = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eweii2c2"
} : {
  target: "eweii2c2",
  label: "SubHead"
})(({
  theme
}) => /*#__PURE__*/css("margin-bottom:4px;", FONT_STYLE.detail12L16, " color:", theme.content.base2, ";word-break:break-all;" + (process.env.NODE_ENV === "production" ? "" : ";label:SubHead;")));
const HeadLine = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eweii2c1"
} : {
  target: "eweii2c1",
  label: "HeadLine"
})(({
  theme
}) => /*#__PURE__*/css("overflow:hidden;max-height:36px;", FONT_STYLE.body14L18, ";color:", theme.content.base1, ";word-break:break-all;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word;transition:.1s opacity;" + (process.env.NODE_ENV === "production" ? "" : ";label:HeadLine;")));
const Body$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eweii2c0"
} : {
  target: "eweii2c0",
  label: "Body"
})(process.env.NODE_ENV === "production" ? {
  name: "1i95zwv",
  styles: "display:flex;flex-direction:column;margin-top:4px"
} : {
  name: "1i95zwv",
  styles: "display:flex;flex-direction:column;margin-top:4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1G
});

/** TODO: 기본 ProductCard 컴포넌트랑 네이밍 겹쳐서 임시로 Commerce prefix를 추가합니다. 추후 정리 예정 */
function CommerceDeliveryStartAt({
  children,
  className
}) {
  return jsx(Text$2, {
    className: className,
    children: children
  });
}
const Text$2 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "el1qmi80"
} : {
  target: "el1qmi80",
  label: "Text"
})(({
  theme
}) => /*#__PURE__*/css(FONT_STYLE.caption1, ";color:", theme.content.primary4.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Text;")));

var DepartureTodayIconImage = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$1F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$I = process.env.NODE_ENV === "production" ? {
  name: "1vft4ef",
  styles: "display:inline-flex;height:15px"
} : {
  name: "5s1myt-DepartureTodayIcon",
  styles: "display:inline-flex;height:15px;label:DepartureTodayIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1F
};
var _ref2$k = process.env.NODE_ENV === "production" ? {
  name: "reg8qv",
  styles: "width:auto;height:100%"
} : {
  name: "1s0xxao-DepartureTodayIcon",
  styles: "width:auto;height:100%;label:DepartureTodayIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1F
};
const DepartureTodayIcon$1 = ({
  className
}) => {
  return jsx("div", {
    css: _ref$I,
    className: className,
    children: jsx("img", {
      src: DepartureTodayIconImage,
      alt: "\uC624\uB298\uCD9C\uBC1C\uBC43\uC9C0",
      css: _ref2$k
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function IconWithTextBadge$1({
  title,
  image,
  className
}) {
  return jsxs(Container$E, {
    className: className,
    children: [jsx(Icon$1, {
      src: image,
      alt: "icon-with-text-badge"
    }), jsx(Title$d, {
      children: title
    })]
  });
}
const Container$E = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ea11xjv2"
} : {
  target: "ea11xjv2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "16nm088",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF"
} : {
  name: "16nm088",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1E
});
const Icon$1 = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "ea11xjv1"
} : {
  target: "ea11xjv1",
  label: "Icon"
})(process.env.NODE_ENV === "production" ? {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px"
} : {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1E
});
const Title$d = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "ea11xjv0"
} : {
  target: "ea11xjv0",
  label: "Title"
})(process.env.NODE_ENV === "production" ? {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
} : {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1E
});

var OhouseDeliveryIconImage = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$1D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$H = process.env.NODE_ENV === "production" ? {
  name: "1vft4ef",
  styles: "display:inline-flex;height:15px"
} : {
  name: "5sqgtz-OhouseDeliveryIcon",
  styles: "display:inline-flex;height:15px;label:OhouseDeliveryIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1D
};
var _ref2$j = process.env.NODE_ENV === "production" ? {
  name: "reg8qv",
  styles: "width:auto;height:100%"
} : {
  name: "enb68p-OhouseDeliveryIcon",
  styles: "width:auto;height:100%;label:OhouseDeliveryIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1D
};
const OhouseDeliveryIcon$1 = ({
  className
}) => {
  return jsx("div", {
    css: _ref$H,
    className: className,
    children: jsx("img", {
      src: OhouseDeliveryIconImage,
      alt: "\uC624\uB298\uC758\uC9D1\uBC30\uC1A1\uBC43\uC9C0",
      css: _ref2$j
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Price$1 = ({
  rate,
  amount,
  priceToken,
  disabled = false,
  variant = 'lg',
  className
}) => {
  return jsxs(Root$3, {
    variant: variant,
    className: className,
    children: [rate && jsx(Rate$2, {
      disabled: disabled,
      children: `${rate}%`
    }), jsx(Amount$2, {
      disabled: disabled,
      children: amount
    }), priceToken && jsx(PriceToken, {
      children: priceToken
    })]
  });
};
const Root$3 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e30n2fh3"
} : {
  target: "e30n2fh3",
  label: "Root"
})(({
  variant
}) => /*#__PURE__*/css("display:flex;align-items:center;flex-wrap:wrap;gap:2px;", variant === 'sm' && FONT_STYLE.caption1, ";", variant === 'md' && FONT_STYLE.subTitle2, ";", variant === 'lg' && FONT_STYLE.title3, ";font-weight:700;" + (process.env.NODE_ENV === "production" ? "" : ";label:Root;")));
var _ref2$i = process.env.NODE_ENV === "production" ? {
  name: "zw93mq",
  styles: "opacity:0.26"
} : {
  name: "nxe75c-Rate",
  styles: "opacity:0.26;label:Rate;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1C
};
const Rate$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e30n2fh2"
} : {
  target: "e30n2fh2",
  label: "Rate"
})(({
  disabled,
  theme
}) => /*#__PURE__*/css("color:", theme.content.primary1.basic, ";", disabled && _ref2$i, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Rate;")));
var _ref$G = process.env.NODE_ENV === "production" ? {
  name: "5b2tzs",
  styles: "opacity:0.14"
} : {
  name: "ruk4nf-Amount",
  styles: "opacity:0.14;label:Amount;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1C
};
const Amount$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e30n2fh1"
} : {
  target: "e30n2fh1",
  label: "Amount"
})(({
  disabled,
  theme
}) => /*#__PURE__*/css("color:", theme.content.base1, ";", disabled && _ref$G, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Amount;")));
const PriceToken = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e30n2fh0"
} : {
  target: "e30n2fh0",
  label: "PriceToken"
})(({
  theme
}) => /*#__PURE__*/css(FONT_STYLE.caption1, ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PriceToken;")));

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$1(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles$1(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}
function _createForOfIteratorHelper$1(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray$1(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
}
function _toConsumableArray$1(r) {
  return _arrayWithoutHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread$1();
}
function _toPrimitive$1(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey$1(t) {
  var i = _toPrimitive$1(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$1(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
    index = assocIndexOf$1(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = listCacheClear$1;
ListCache$1.prototype['delete'] = listCacheDelete$1;
ListCache$1.prototype.get = listCacheGet$1;
ListCache$1.prototype.has = listCacheHas$1;
ListCache$1.prototype.set = listCacheSet$1;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$1();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$1(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$1(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$1(key) {
  return this.__data__.has(key);
}

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = (typeof global === "undefined" ? "undefined" : _typeof$2(global)) == 'object' && global && global.Object === Object && global;
var freeGlobal$1$1 = freeGlobal$2;

/** Detect free variable `self`. */
var freeSelf$1 = (typeof self === "undefined" ? "undefined" : _typeof$2(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$1$1 || freeSelf$1 || Function('return this')();
var root$1$1 = root$2;

/** Built-in value references. */
var _Symbol = root$1$1.Symbol;
var _Symbol$1 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1$1 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1$1),
    tag = value[symToStringTag$1$1];
  try {
    value[symToStringTag$1$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1$1] = tag;
    } else {
      delete value[symToStringTag$1$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString$2.call(value);
}

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
  undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1$1(value) {
  var type = _typeof$2(value);
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$1(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag$1 || tag == proxyTag$1;
}

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$1$1['__core-js_shared__'];
var coreJsData$1$1 = coreJsData$2;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = function () {
  var uid = /[^.]+$/.exec(coreJsData$1$1 && coreJsData$1$1.keys && coreJsData$1$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}

/** Used for built-in method references. */
var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1$1 = Function.prototype,
  objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1$1 = funcProto$1$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' + funcToString$1$1.call(hasOwnProperty$d).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$1$1(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$1(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1$1 = getNative$1(root$1$1, 'Map');
var Map$2$1 = Map$1$1;

/* Built-in method references that are verified to be native. */
var nativeCreate$2 = getNative$1(Object, 'create');
var nativeCreate$1$1 = nativeCreate$2;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$1$1 ? nativeCreate$1$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$e$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e$1.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$1$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2$1 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$d$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b$1 = objectProto$d$1.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1$1 ? data[key] !== undefined : hasOwnProperty$b$1.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1$1 && value === undefined ? HASH_UNDEFINED$1$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear$1;
Hash$1.prototype['delete'] = hashDelete$1;
Hash$1.prototype.get = hashGet$1;
Hash$1.prototype.has = hashHas$1;
Hash$1.prototype.set = hashSet$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1(),
    'map': new (Map$2$1 || ListCache$1)(),
    'string': new Hash$1()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$1(value) {
  var type = _typeof$2(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$1(map, key) {
  var data = map.__data__;
  return isKeyable$1(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$1(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$1(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData$1(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear$1;
MapCache$1.prototype['delete'] = mapCacheDelete$1;
MapCache$1.prototype.get = mapCacheGet$1;
MapCache$1.prototype.has = mapCacheHas$1;
MapCache$1.prototype.set = mapCacheSet$1;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2$1 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = stackClear$1;
Stack$1.prototype['delete'] = stackDelete$1;
Stack$1.prototype.get = stackGet$1;
Stack$1.prototype.has = stackHas$1;
Stack$1.prototype.set = stackSet$1;

/** Built-in value references. */
var Uint8Array$3 = root$1$1.Uint8Array;
var Uint8Array$1$1 = Uint8Array$3;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = _Symbol$1 ? _Symbol$1.prototype : undefined;
  symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$1(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1$1 = Array.isArray;
var isArray$2 = isArray$1$1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$1(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$1() {
  return [];
}

/** Used for built-in method references. */
var objectProto$c$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1$1 = objectProto$c$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$1$1 ? stubArray$1 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1$1(object), function (symbol) {
    return propertyIsEnumerable$1$1.call(object, symbol);
  });
};
var getSymbols$1$1 = getSymbols$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$1(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return value != null && _typeof$2(value) == 'object';
}

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$1(value) && baseGetTag$1(value) == argsTag$3;
}

/** Used for built-in method references. */
var objectProto$b$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a$1 = objectProto$b$1.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$b$1.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments$1(function () {
  return arguments;
}()) ? baseIsArguments$1 : function (value) {
  return isObjectLike$1(value) && hasOwnProperty$a$1.call(value, 'callee') && !propertyIsEnumerable$2.call(value, 'callee');
};
var isArguments$1$1 = isArguments$2;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse$1() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1$1 = moduleExports$2 ? root$1$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer$1 = Buffer$1$1 ? Buffer$1$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer$2 = nativeIsBuffer$1 || stubFalse$1;
var isBuffer$1$1 = isBuffer$2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = _typeof$2(value);
  length = length == null ? MAX_SAFE_INTEGER$1$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint$1.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$1(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

/** `Object#toString` result references. */
var argsTag$2$1 = '[object Arguments]',
  arrayTag$2 = '[object Array]',
  boolTag$3 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$2 = '[object Error]',
  funcTag$1$1 = '[object Function]',
  mapTag$5 = '[object Map]',
  numberTag$3 = '[object Number]',
  objectTag$4 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$5 = '[object Set]',
  stringTag$3 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$2] = typedArrayTags$1[float64Tag$2] = typedArrayTags$1[int8Tag$2] = typedArrayTags$1[int16Tag$2] = typedArrayTags$1[int32Tag$2] = typedArrayTags$1[uint8Tag$2] = typedArrayTags$1[uint8ClampedTag$2] = typedArrayTags$1[uint16Tag$2] = typedArrayTags$1[uint32Tag$2] = true;
typedArrayTags$1[argsTag$2$1] = typedArrayTags$1[arrayTag$2] = typedArrayTags$1[arrayBufferTag$2] = typedArrayTags$1[boolTag$3] = typedArrayTags$1[dataViewTag$3] = typedArrayTags$1[dateTag$2] = typedArrayTags$1[errorTag$2] = typedArrayTags$1[funcTag$1$1] = typedArrayTags$1[mapTag$5] = typedArrayTags$1[numberTag$3] = typedArrayTags$1[objectTag$4] = typedArrayTags$1[regexpTag$2] = typedArrayTags$1[setTag$5] = typedArrayTags$1[stringTag$3] = typedArrayTags$1[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$1(value.length) && !!typedArrayTags$1[baseGetTag$1(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$1(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1$1 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1$1 = freeExports$1$1 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1$1 = freeModule$1$1 && freeModule$1$1.exports === freeExports$1$1;

/** Detect free variable `process` from Node.js. */
var freeProcess$1 = moduleExports$1$1 && freeGlobal$1$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil$2 = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1$1 && freeModule$1$1.require && freeModule$1$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess$1 && freeProcess$1.binding && freeProcess$1.binding('util');
  } catch (e) {}
}();
var nodeUtil$1$1 = nodeUtil$2;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$1$1 && nodeUtil$1$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray$1 ? baseUnary$1(nodeIsTypedArray$1) : baseIsTypedArray$1;
var isTypedArray$1$1 = isTypedArray$2;

/** Used for built-in method references. */
var objectProto$a$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9$1 = objectProto$a$1.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$2(value),
    isArg = !isArr && isArguments$1$1(value),
    isBuff = !isArr && !isArg && isBuffer$1$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes$1(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$9$1.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$9$1 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$9$1;
  return value === proto;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$1(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$1(Object.keys, Object);
var nativeKeys$1$1 = nativeKeys$2;

/** Used for built-in method references. */
var objectProto$8$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8$1 = objectProto$8$1.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys$1$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8$1.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols$1$1);
}

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$1(root$1$1, 'DataView');
var DataView$1$1 = DataView$2;

/* Built-in method references that are verified to be native. */
var Promise$1$1 = getNative$1(root$1$1, 'Promise');
var Promise$2$1 = Promise$1$1;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$1(root$1$1, 'Set');
var Set$1$1 = Set$3;

/* Built-in method references that are verified to be native. */
var WeakMap$3 = getNative$1(root$1$1, 'WeakMap');
var WeakMap$1$1 = WeakMap$3;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
  objectTag$3 = '[object Object]',
  promiseTag$1 = '[object Promise]',
  setTag$4 = '[object Set]',
  weakMapTag$1$1 = '[object WeakMap]';
var dataViewTag$2$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$1(DataView$1$1),
  mapCtorString$1 = toSource$1(Map$2$1),
  promiseCtorString$1 = toSource$1(Promise$2$1),
  setCtorString$1 = toSource$1(Set$1$1),
  weakMapCtorString$1 = toSource$1(WeakMap$1$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$2 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1$1 && getTag$2(new DataView$1$1(new ArrayBuffer(1))) != dataViewTag$2$1 || Map$2$1 && getTag$2(new Map$2$1()) != mapTag$4 || Promise$2$1 && getTag$2(Promise$2$1.resolve()) != promiseTag$1 || Set$1$1 && getTag$2(new Set$1$1()) != setTag$4 || WeakMap$1$1 && getTag$2(new WeakMap$1$1()) != weakMapTag$1$1) {
  getTag$2 = function getTag(value) {
    var result = baseGetTag$1(value),
      Ctor = result == objectTag$3 ? value.constructor : undefined,
      ctorString = Ctor ? toSource$1(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$2$1;
        case mapCtorString$1:
          return mapTag$4;
        case promiseCtorString$1:
          return promiseTag$1;
        case setCtorString$1:
          return setTag$4;
        case weakMapCtorString$1:
          return weakMapTag$1$1;
      }
    }
    return result;
  };
}
var getTag$1$1 = getTag$2;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return _typeof$2(value) == 'symbol' || isObjectLike$1(value) && baseGetTag$1(value) == symbolTag$2;
}

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$2(value)) {
    return false;
  }
  var type = _typeof$2(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object != null && value in Object(object);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$4 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1$1.Cache || MapCache$1)();
  return memoized;
}

// Expose `MapCache`.
memoize$1$1.Cache = MapCache$1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$1$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$1(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : number || match);
  });
  return result;
});
var stringToPath$1$1 = stringToPath$2;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1$1 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolToString$1 = symbolProto$1$1 ? symbolProto$1$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$2(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey$1(value, object) ? [value] : stringToPath$1$1(toString$2(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$1$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$1(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath$1(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey$1(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey$1(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$1(length) && isIndex$1(key, length) && (isArray$2(object) || isArguments$1$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath$1(object, path, baseHasIn$1);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$1(value) {
  return value;
}
var defineProperty$2 = function () {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1$1 = defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty$1$1) {
    defineProperty$1$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var queryString$2 = {};
var strictUriEncode$2 = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};
var token$2 = '%[a-f0-9]{2}';
var singleMatcher$2 = new RegExp('(' + token$2 + ')|([^%]+?)', 'gi');
var multiMatcher$2 = new RegExp('(' + token$2 + ')+', 'gi');
function decodeComponents$2(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents$2(left), decodeComponents$2(right));
}
function decode$3(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher$2) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents$2(tokens, i).join('');
      tokens = input.match(singleMatcher$2) || [];
    }
    return input;
  }
}
function customDecodeURIComponent$2(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher$2.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode$3(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher$2.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent$2 = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + _typeof$2(encodedURI) + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent$2(encodedURI);
  }
};
var splitOnFirst$2 = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  var separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};
var filterObj$1 = function filterObj(obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};
(function (exports) {
  var strictUriEncode$1 = strictUriEncode$2;
  var decodeComponent = decodeUriComponent$2;
  var splitOnFirst$1 = splitOnFirst$2;
  var filterObject = filterObj$1;
  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value === null || value === undefined;
  };
  var encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[', index, ']'].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };
      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[]'].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };
      case 'colon-list-separator':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [[encode(key, options), ':list='].join('')]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), ':list=', encode(value, options)].join('')]);
          };
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          var keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return function (key) {
            return function (result, value) {
              if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
                return result;
              }

              // Translate null to an empty string so that it doesn't serialize as 'null'
              value = value === null ? '' : value;
              if (result.length === 0) {
                return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
              }
              return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
            };
          };
        }
      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }
            if (value === null) {
              return [].concat(_toConsumableArray$1(result), [encode(key, options)]);
            }
            return [].concat(_toConsumableArray$1(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }
  function parserForArrayFormat(options) {
    var result;
    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return function (key, value, accumulator) {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          }) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return function (key, value, accumulator) {
          var isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          });
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (_typeof$2(input) === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }
    return input;
  }
  function removeHash(input) {
    var hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    var _iterator = _createForOfIteratorHelper$1(query.split('&')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;
        if (param === '') {
          continue;
        }
        var _splitOnFirst = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '='),
          _splitOnFirst2 = _slicedToArray(_splitOnFirst, 2),
          _key = _splitOnFirst2[0],
          _value = _splitOnFirst2[1];

        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        _value = _value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? _value : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var _i = 0, _Object$keys = Object.keys(ret); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      var value = ret[key];
      if (_typeof$2(value) === 'object' && value !== null) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(value); _i2 < _Object$keys2.length; _i2++) {
          var k = _Object$keys2[_i2];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];
      if (Boolean(value) && _typeof$2(value) === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function shouldFilter(key) {
      return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };
    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};
    for (var _i3 = 0, _Object$keys3 = Object.keys(object); _i3 < _Object$keys3.length; _i3++) {
      var key = _Object$keys3[_i3];
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(function (key) {
      var value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };
  exports.parseUrl = function (url, options) {
    options = Object.assign({
      decode: true
    }, options);
    var _splitOnFirst3 = splitOnFirst$1(url, '#'),
      _splitOnFirst4 = _slicedToArray(_splitOnFirst3, 2),
      url_ = _splitOnFirst4[0],
      hash = _splitOnFirst4[1];
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = function (object, options) {
    options = Object.assign(_defineProperty$1({
      encode: true,
      strict: true
    }, encodeFragmentIdentifier, true), options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = "?".concat(queryString);
    }
    var hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = "#".concat(options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    }
    return "".concat(url).concat(queryString).concat(hash);
  };
  exports.pick = function (input, filter, options) {
    options = Object.assign(_defineProperty$1({
      parseFragmentIdentifier: true
    }, encodeFragmentIdentifier, false), options);
    var _exports$parseUrl = exports.parseUrl(input, options),
      url = _exports$parseUrl.url,
      query = _exports$parseUrl.query,
      fragmentIdentifier = _exports$parseUrl.fragmentIdentifier;
    return exports.stringifyUrl({
      url: url,
      query: filterObject(query, filter),
      fragmentIdentifier: fragmentIdentifier
    }, options);
  };
  exports.exclude = function (input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function (key) {
      return !filter.includes(key);
    } : function (key, value) {
      return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString$2);

/**
 * 웹 페이지가 모바일 앱 내의 웹뷰에서 실행되고 있는지 여부를 확인합니다.
 * 이 함수는 서버 사이드와 클라이언트 사이드 렌더링 환경 모두에서 사용 가능합니다.
 *
 * @param {Object} query - 서버 사이드 렌더링 시 사용할 쿼리 파라미터 객체입니다. (선택적)
 * @returns {boolean} 웹 페이지가 앱 내의 웹뷰에서 실행되고 있다면 true, 그렇지 않다면 false를 반환합니다.
 */
function isInApp(query) {
  if (typeof window === 'undefined') {
    if (query != null) {
      return query['os_type'] != null || query['app'] != null;
    }
    return false;
  }
  var triggered = false;
  try {
    triggered = sessionStorage['webviewTriggered'] === 'yes';
  } catch (e) {
    console.error(e);
  }
  var search = queryString$2.parse(location.search);
  var isExpertCenterAndroid = search['pro_app'] != null && search['os_type'] === 'Android';
  if (!isExpertCenterAndroid && (triggered || search['os_type'] != null && search['os_type'] !== '' || search['app'] != null)) {
    try {
      sessionStorage['webviewTriggered'] = 'yes';
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
}

// 모바일 장치를 포괄하는 정규 표현식
var MOBILE_USER_AGENT_REGEX = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone|Kindle|Silk|PlayBook/;
/**
 * 브라우저의 사용자 에이전트 또는 제공된 사용자 에이전트 문자열을 기반으로 현재 환경이 모바일 장치인지 여부를 확인합니다.
 *
 * @param {string} [userAgent=''] - (선택적) 확인할 사용자 에이전트입니다.
 * @returns {boolean} 모바일 장치면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * 브라우저 환경에서 사용할 경우:
 * isMobile();
 *
 * 사용자 에이전트 문자열을 제공할 경우:
 * isMobile("Mozilla/5.0 (iPhone; CPU iPhone OS 10_3 like Mac OS X)");
 */
function isMobileDevice() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (userAgent !== '') {
    return MOBILE_USER_AGENT_REGEX.test(userAgent);
  }
  // 브라우저 환경에서 실행 중인지 확인
  if (typeof window !== 'undefined' && navigator) {
    var isMobileUA = MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
    // 터치 기능에 대한 추가 검사
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    // 모바일 장치를 나타내는 검사 중 하나라도 참이면 true 반환
    return isMobileUA || isTouchDevice;
  }
  return false;
}

/**
 * 주어진 값이 배열인지 여부를 확인합니다.
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 배열이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * // 배열인 경우
 * isArray([1, 2, 3]); // true
 *
 * @example
 * // 배열이 아닌 경우
 * isArray({ 'a': 1, 'b': 2, 'c': 3 }); // false
 *
 * @example
 * // null 값을 검사하는 경우
 * isArray(null); // false
 */
var isArray$3 = isArray$2;

/** Built-in value references. */
var getPrototype$2 = overArg$1(Object.getPrototypeOf, Object);
var getPrototype$1$1 = getPrototype$2;

/** `Object#toString` result references. */
var objectTag$1$1 = '[object Object]';

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
  objectProto$3$1 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3$1 = objectProto$3$1.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$3.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike$1(value) || baseGetTag$1(value) != objectTag$1$1) {
    return false;
  }
  var proto = getPrototype$1$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$3$1.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$3.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil$1(value) {
  return value == null;
}

/**
 * 주어진 값이 null 또는 undefined인지 여부를 확인합니다.
 *
 * @param {any} value - 검사할 값.
 * @returns {boolean} 값이 null 또는 undefined이면 true, 그렇지 않으면 false를 반환합니다.
 *
 * @example
 * isNil(null); // true
 * isNil(undefined); // true
 *
 * @example
 * isNil(0); // false
 * isNil(false); // false
 * isNil(''); // false
 * isNil(NaN); // false
 */
var isNil$2 = isNil$1;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/** Used for built-in method references. */
var objectProto$2$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2$1 = objectProto$2$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$1(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2$1.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$1(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$1(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1$1 = objectProto$1$1.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$1$1(object)) {
    return nativeKeysIn$1(object);
  }
  var isProto = isPrototype$1(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object, true) : baseKeysIn$1(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn$1(source), object);
}

/** Detect free variable `exports`. */
var freeExports$3 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$3 = freeExports$3 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$3 = freeModule$3 && freeModule$3.exports === freeExports$3;

/** Built-in value references. */
var Buffer$2 = moduleExports$3 ? root$1$1.Buffer : undefined,
  allocUnsafe = Buffer$2 ? Buffer$2.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1$1(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols$2 ? stubArray$1 : function (object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1$1(object));
    object = getPrototype$1$1(object);
  }
  return result;
};
var getSymbolsIn$1$1 = getSymbolsIn$2;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1$1(source), object);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys$1(object, keysIn$1, getSymbolsIn$1$1);
}

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$i.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$f.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1$1(result).set(new Uint8Array$1$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = _Symbol$1 ? _Symbol$1.prototype : undefined,
  symbolValueOf$1 = symbolProto$3 ? symbolProto$3.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1$1 = '[object Boolean]',
  dateTag$1$1 = '[object Date]',
  mapTag$2$1 = '[object Map]',
  numberTag$1$1 = '[object Number]',
  regexpTag$1$1 = '[object RegExp]',
  setTag$2$1 = '[object Set]',
  stringTag$1$1 = '[object String]',
  symbolTag$1$1 = '[object Symbol]';
var arrayBufferTag$1$1 = '[object ArrayBuffer]',
  dataViewTag$1$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1$1:
      return cloneArrayBuffer(object);
    case boolTag$1$1:
    case dateTag$1$1:
      return new Ctor(+object);
    case dataViewTag$1$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2$1:
      return new Ctor();
    case numberTag$1$1:
    case stringTag$1$1:
      return new Ctor(object);
    case regexpTag$1$1:
      return cloneRegExp(object);
    case setTag$2$1:
      return new Ctor();
    case symbolTag$1$1:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject$1$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var baseCreate$1 = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype$1(object) ? baseCreate$1(getPrototype$1$1(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$1$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike$1(value) && getTag$1$1(value) == mapTag$1$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1$1 && nodeUtil$1$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

/** `Object#toString` result references. */
var setTag$1$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike$1(value) && getTag$1$1(value) == setTag$1$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1$1 && nodeUtil$1$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG$1 = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
  arrayTag$3 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$3 = '[object Date]',
  errorTag$3 = '[object Error]',
  funcTag$3 = '[object Function]',
  genTag$2 = '[object GeneratorFunction]',
  mapTag$6 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$5 = '[object Object]',
  regexpTag$3 = '[object RegExp]',
  setTag$6 = '[object Set]',
  stringTag$2 = '[object String]',
  symbolTag$3 = '[object Symbol]',
  weakMapTag$3 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]',
  dataViewTag$4 = '[object DataView]',
  float32Tag$3 = '[object Float32Array]',
  float64Tag$3 = '[object Float64Array]',
  int8Tag$3 = '[object Int8Array]',
  int16Tag$3 = '[object Int16Array]',
  int32Tag$3 = '[object Int32Array]',
  uint8Tag$3 = '[object Uint8Array]',
  uint8ClampedTag$3 = '[object Uint8ClampedArray]',
  uint16Tag$3 = '[object Uint16Array]',
  uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$3] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$2] = cloneableTags[dateTag$3] = cloneableTags[float32Tag$3] = cloneableTags[float64Tag$3] = cloneableTags[int8Tag$3] = cloneableTags[int16Tag$3] = cloneableTags[int32Tag$3] = cloneableTags[mapTag$6] = cloneableTags[numberTag$2] = cloneableTags[objectTag$5] = cloneableTags[regexpTag$3] = cloneableTags[setTag$6] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$3] = cloneableTags[uint8ClampedTag$3] = cloneableTags[uint16Tag$3] = cloneableTags[uint32Tag$3] = true;
cloneableTags[errorTag$3] = cloneableTags[funcTag$3] = cloneableTags[weakMapTag$3] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG$1,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1$1(value)) {
    return value;
  }
  var isArr = isArray$2(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1$1(value),
      isFunc = tag == funcTag$3 || tag == genTag$2;
    if (isBuffer$1$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$5 || tag == argsTag$4 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$1());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys$1 : isFlat ? keysIn$1 : keys$1;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue$1(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
    length = array.length;
  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet$1(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$1(last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/** Built-in value references. */
var spreadableSymbol$1 = _Symbol$1 ? _Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$2(value) || isArguments$1$1(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable$1);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$1(func, start, transform) {
  start = nativeMax$2(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$2(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply$1(func, this, otherArgs);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant$1(value) {
  return function () {
    return value;
  };
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$2 = !defineProperty$1$1 ? identity$1 : function (func, string) {
  return defineProperty$1$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$1(string),
    'writable': true
  });
};
var baseSetToString$1$1 = baseSetToString$2;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT$1 = 800,
  HOT_SPAN$1 = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow$1 = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow$1(),
      remaining = HOT_SPAN$1 - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT$1) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut$1(baseSetToString$1$1);
var setToString$1$1 = setToString$2;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString$1$1(overRest$1(func, undefined, flatten$1), func + '');
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit$1 = flatRest$1(function (object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$1(paths, function (path) {
    path = castPath$1(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn$1(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});
var omit$2 = omit$1;

/**
 * 주어진 객체에서 선택된 키들에 해당하는 속성들을 제외한 나머지 속성들을 포함하는 새 객체를 반환합니다.
 * @param {Object} object - 원본 객체.
 * @param {string[]} paths - 제외할 속성의 키들을 나타내는 문자열 배열.
 * @returns {Object} 제외된 속성들을 제외한 나머지 속성들을 포함하는 새 객체.
 *
 * @example
 * // 객체에서 'b' 속성을 제외
 * omit({ 'a': 1, 'b': '2', 'c': 3 }, ['b']); // { 'a': 1, 'c': 3 }
 *
 * @example
 * // 객체에서 여러 속성을 제외
 * omit({ 'name': 'apple', 'color': 'red', 'weight': 100 }, ['color', 'weight']); // { 'name': 'apple' }
 */
var omit = omit$2;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$1$1(object)) {
    return object;
  }
  path = castPath$1(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$1$1(objValue) ? objValue : isIndex$1(path[index + 1]) ? [] : {};
      }
    }
    assignValue$1(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet$1(object, path);
    if (predicate(value, path)) {
      baseSet$1(result, castPath$1(path, object), value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy$1(object, paths, function (value, path) {
    return hasIn$1(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
flatRest$1(function (object, paths) {
  return object == null ? {} : basePick$1(object, paths);
});

/**
 * 숫자에 천자리 단위 (,)를 추가합니다.
 * @param x 천자리 단위 (,) 넣을 숫자
 * @returns 천자리 단위 (,) 포함된 숫자
 * @example
 * ```
 * formatComma(1000000);
 * 1,000,000
 * ```
 */
function formatComma(x) {
  if (x == null || Number.isNaN(Number(x))) {
    return '';
  }
  return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
(',r,R,rt,s,sw,sg,e,f,fr,fa,fq,ft,fx,fv,fg,a,q,qt,t,T,' + 'd,w,c,z,x,v,g').split(',');
(',r,R,rt,s,sw,sg,e,E,f,fr,fa,fq,ft,fx,fv,fg,a,q,Q,qt,t,' + 'T,d,w,W,c,z,x,v,g,k,o,i,O,j,p,u,P,h,hk,ho,hl,y,n,nj,np,nl,b,m,ml,l').split(',');

/**
 * 주어진 숫자를 지정된 기준(base)를 기반으로 승수(step)를 구하고 정규화된 값을 반환합니다.
 *
 * 정규화된 값은 입력된 숫자를 해당 숫자를 나누는 기준(base)의 최고 차수로 나눈 결과입니다.
 * 단계는 입력된 숫자를 나누는 기준(base)의 최고 차수의 지수를 나타냅니다.
 *
 * @example calculateExponentStep(2312111, 1000) -> [2.3, 2]
 *
 * @param input 계산할 숫자
 * @param base 기준 값
 * @returns 정규화된 값과 단계를 포함하는 배열을 반환합니다.
 */
function calculateExponentStep(input, base) {
  if (input === 0) {
    return [0, 0];
  }
  var step = Math.floor(Math.log10(Math.abs(input)) / Math.log10(base));
  var divisor = Math.pow(base, step);
  return [input / divisor, step];
}

/**
 * 큰 수를 줄임 표기 형태로 변환합니다.
 *
 * @example 2312111 -> 2.3M
 * @example 126057 -> 126K
 *
 * @param number 변환할 숫자
 * @param base 기준값
 * @params markers 기준값에 따른 표기
 * @returns 변환된 문자열
 */
function formatLargeNumber(number) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var markers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['', 'K', 'M', 'B'];
  var formatNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (n) {
    return String(Math.floor(n * 10) / 10);
  };
  var _calculateExponentSte = calculateExponentStep(number, base),
    _calculateExponentSte2 = _slicedToArray(_calculateExponentSte, 2),
    value = _calculateExponentSte2[0],
    step = _calculateExponentSte2[1];
  if (step >= markers.length) {
    var cappedStep = markers.length - 1;
    var accumulated = value * Math.pow(base, step - cappedStep);
    return "".concat(accumulated.toFixed(1)).concat(markers[cappedStep]);
  }
  return "".concat(formatNumber(value)).concat(markers[step]);
}

/**
 * text를 clipboard로 복사합니다.
 * @param text 복사할 text
 * @returns 성공 여부
 * @example
 * ```
 * copyTextToClipboard('오늘의집')
 * true or false
 * ```
 */
var copyTextToClipboard = function copyTextToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '20em';
  textArea.style.height = '20em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.value = text;
  document.body.appendChild(textArea);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textArea.contentEditable = 'true';
    textArea.readOnly = true;
    var range = document.createRange();
    range.selectNodeContents(textArea);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 9999999);
  } else {
    textArea.select();
  }
  var successful = false;
  try {
    /** execCommand: deprecated된 메소드 입니다. */
    successful = document.execCommand('copy');
  } catch (err) {
    throw new Error('Unable to copy');
  } finally {
    window.document.body.removeChild(textArea);
  }
  return successful;
};

/**
 * url에서 쿼리 파라미터를 추출하여 객체 형태로 변환합니다.
 * @param {string} url url
 * @returns url 쿼리 객체
 * @example
 * ```
 * getQuery('https://ohou.se?a=1&b=2');
 * { a: 1, b: 2 }
 * ```
 */
var getQuery = memoize$1$1(function (url) {
  var search = (/\?(.+)$/.exec(url) || ['', ''])[1];
  return queryString$2.parse(search.replace(/&amp;/g, '&'));
});

const Stats$1 = ({
  reviewCount = 0,
  reviewAvg = 0,
  scrapCount = 0,
  className
}) => {
  if (reviewCount > 0) {
    return jsxs(Root$2, {
      className: className,
      children: [jsx(StyledIcon, {
        name: "star",
        size: 12
      }), jsx(Avg, {
        children: Math.round(reviewAvg * 10) / 10
      }), jsx("span", {
        children: `리뷰 ${formatComma(reviewCount)}`
      })]
    });
  }
  if (scrapCount > 0) {
    return jsx(Root$2, {
      className: className,
      children: `스크랩 ${formatComma(scrapCount)}`
    });
  }
  return null;
};
const Root$2 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1j07bzq2"
} : {
  target: "e1j07bzq2",
  label: "Root"
})(({
  theme
}) => /*#__PURE__*/css("display:flex;align-items:center;", FONT_STYLE.detail12L16, ";color:", theme.content.base2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Root;")));
const StyledIcon = /*#__PURE__*/_styled(Icon$2, process.env.NODE_ENV === "production" ? {
  target: "e1j07bzq1"
} : {
  target: "e1j07bzq1",
  label: "StyledIcon"
})(({
  theme
}) => /*#__PURE__*/css("margin-right:1px;width:1.1em;height:1.1em;vertical-align:-2px;color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledIcon;")));
const Avg = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1j07bzq0"
} : {
  target: "e1j07bzq0",
  label: "Avg"
})(({
  theme
}) => /*#__PURE__*/css("margin-right:4px;font-weight:700;color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Avg;")));

var ThirdPartyApplianceIconImage = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$1B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$F = process.env.NODE_ENV === "production" ? {
  name: "1vft4ef",
  styles: "display:inline-flex;height:15px"
} : {
  name: "eqox5m-ThirdPartyApplianceIcon",
  styles: "display:inline-flex;height:15px;label:ThirdPartyApplianceIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1B
};
var _ref2$h = process.env.NODE_ENV === "production" ? {
  name: "reg8qv",
  styles: "width:auto;height:100%"
} : {
  name: "10j1zxv-ThirdPartyApplianceIcon",
  styles: "width:auto;height:100%;label:ThirdPartyApplianceIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1B
};
const ThirdPartyApplianceIcon$1 = ({
  className
}) => {
  return jsx("div", {
    css: _ref$F,
    className: className,
    children: jsx("img", {
      src: ThirdPartyApplianceIconImage,
      alt: "\uBE60\uB978\uAC00\uC804\uBC30\uC1A1\uBC43\uC9C0",
      css: _ref2$h
    })
  });
};

var ThirdPartyFurnitureIconImage = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$1A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$E = process.env.NODE_ENV === "production" ? {
  name: "1vft4ef",
  styles: "display:inline-flex;height:15px"
} : {
  name: "r8nsgx-ThirdPartyFurnitureIcon",
  styles: "display:inline-flex;height:15px;label:ThirdPartyFurnitureIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1A
};
var _ref2$g = process.env.NODE_ENV === "production" ? {
  name: "reg8qv",
  styles: "width:auto;height:100%"
} : {
  name: "1v23bo7-ThirdPartyFurnitureIcon",
  styles: "width:auto;height:100%;label:ThirdPartyFurnitureIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1A
};
const ThirdPartyFurnitureIcon$1 = ({
  className
}) => {
  return jsx("div", {
    css: _ref$E,
    className: className,
    children: jsx("img", {
      src: ThirdPartyFurnitureIconImage,
      alt: "\uBE60\uB978\uAC00\uAD6C\uBC30\uC1A1\uBC43\uC9C0",
      css: _ref2$g
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Thumbnail$3 = ({
  src,
  children,
  className
}) => {
  return jsxs(Root$1, {
    className: className,
    children: [jsx(ImageWrapper$1, {
      children: jsx(StyledResizeImage$1, {
        src: src,
        className: "thumbnail-image"
      })
    }), children]
  });
};
const Root$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "erxw59u2"
} : {
  target: "erxw59u2",
  label: "Root"
})("position:relative;overflow:hidden;width:100%;padding-bottom:100%;background-color:", ({
  theme
}) => theme.content.base5, ";border-radius:4px;&:after{content:'';position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(5, 3, 3, 0.02);border-radius:4px;}");
const ImageWrapper$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "erxw59u1"
} : {
  target: "erxw59u1",
  label: "ImageWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden"
} : {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1z
});
const StyledResizeImage$1 = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "erxw59u0"
} : {
  target: "erxw59u0",
  label: "StyledResizeImage"
})(process.env.NODE_ENV === "production" ? {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform"
} : {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1z
});

function SoldOutBanner$1() {
  return jsx(Container$D, {
    children: "\uD488\uC808"
  });
}
const Container$D = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee4oelg0"
} : {
  target: "ee4oelg0",
  label: "Container"
})(FONT_STYLE.caption1, " position:absolute;left:0;right:0;bottom:0;padding:2px 0;text-align:center;font-weight:bold;", ({
  theme
}) => /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content.base3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")), " border-radius:0 0 4px 4px;z-index:2;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const badgeSizeLookup$1 = {
  extraSmall: [29, 29],
  small: [29, 26],
  large: [23, 20]
};
const BASE_BADGE_SIZE$1 = 100;
const SEGMENTS$1 = 3;
const calculateColumn$1 = (elementSize, position) => {
  const base = BASE_BADGE_SIZE$1 / SEGMENTS$1;
  const pos = Math.floor(position / SEGMENTS$1);
  return base * pos + (base - elementSize) / 2 * pos;
};
const calculateRow$1 = (elementSize, position) => {
  const base = BASE_BADGE_SIZE$1 / SEGMENTS$1;
  const pos = position % SEGMENTS$1;
  return base * pos + (base - elementSize) / 2 * pos;
};
function ThumbnailBadge$1({
  badgeList,
  size
}) {
  const badgeSize = badgeSizeLookup$1[size ?? 'small'];
  const filteredBadgeList = badgeList.map(badge => ({
    ...badge,
    position: Math.max(1, Math.min(badge.position, 9))
  }));
  return jsx(Container$C, {
    children: filteredBadgeList.map((badge, index) => jsx(Content$6, {
      calculateColumn: calculateColumn$1,
      calculateRow: calculateRow$1,
      size: badgeSize,
      position: badge.position - 1,
      children: jsx(Image$2, {
        src: badge.image.url
      })
    }, `thumbnail-badge-${index + 1}`))
  });
}
const Container$C = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1587n1a2"
} : {
  target: "e1587n1a2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none"
} : {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1y
});
const Content$6 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1587n1a1"
} : {
  target: "e1587n1a1",
  label: "Content"
})("position:absolute;", ({
  calculateColumn,
  calculateRow,
  size,
  position
}) => `
    top: ${calculateColumn(size[0], position)}%;
    left: ${calculateRow(size[0], position)}%;
    width: ${size[0]}%;
    height: ${size[0]}%;
    ${MEDIA_QUERY.min('tablet', `
      top: ${calculateColumn(size[1], position)}%;
      left: ${calculateRow(size[1], position)}%;
      width: ${size[1]}%;
      height: ${size[1]}%;
    `)}
  `, ";");
const Image$2 = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1587n1a0"
} : {
  target: "e1587n1a0",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}"
} : {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1y
});

var _g$8;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
var SvgProductBadgeNonSelling$1 = function SvgProductBadgeNonSelling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 20
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "#000",
    opacity: 0.07,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M12.66 14.8h-1.3V5h1.3zm-4.3-3.52V6.93H6.29v4.35h2.06zm1.3-5.38v6.4H5V5.9h4.65zm12.51 8.78H15.7v-3.94h1.29v.98h3.9v-.99h1.3v3.95zm-1.29-1.02v-.95h-3.9v.95zm1.28-3.43h-1.28V5h1.28v5.22zm-7.78-2.47c0-1.34 1.11-2.34 2.6-2.34 1.5 0 2.6.98 2.6 2.34 0 1.39-1.1 2.25-2.6 2.25-1.49 0-2.6-.86-2.6-2.25m1.3-.01c0 .76.57 1.2 1.3 1.2.71 0 1.3-.44 1.3-1.2 0-.81-.56-1.26-1.3-1.26s-1.3.48-1.3 1.26m16 6.93h-6.5v-3.62h6.5zm-7.76-8V5.63h5.17v1.05h-1.88a3.05 3.05 0 0 0 2.18 2.69l-.7 1a4.2 4.2 0 0 1-2.13-1.92 3.92 3.92 0 0 1-2.28 2.22l-.76-1.02c1.37-.5 2.3-1.54 2.37-2.97zm7.77 3.9h-1.3V8.4h-1.44V7.36h1.45V5h1.29v5.59zm-1.3 3.1v-1.63h-3.94v1.63h3.95z"
  }))));
};
var NonSellingIconSvg = SvgProductBadgeNonSelling$1;

const NonSellingIcon = () => {
  return jsx(NonSellingIconSvg, {
    "aria-label": "\uBBF8\uC785\uC810"
  });
};

var _g$7;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
var SvgProductBadgeDiscontinued$1 = function SvgProductBadgeDiscontinued(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.38 8.8h-1.4v3.34h-1.3V5.07h1.3v2.67h1.4zm-1.16 5.78H5.7v-3.12H7v2.09h5.22zm-6.3-5.11c1.43 0 2.83-.08 3.84-.29.05.33.11.66.18.98-.92.22-2.53.34-4.33.34h-.96V5.87h4.37v1.01h-3.1zm15.77 3.57c0 1.14-1.25 1.83-3.41 1.83s-3.42-.7-3.42-1.83c0-1.1 1.25-1.8 3.4-1.8 2.18 0 3.43.7 3.43 1.8m.6-4.91-.56 1c-1.37-.11-2.9-.87-3.45-1.85-.49 1-1.92 1.75-3.47 1.87l-.53-1c1.49-.08 2.83-.74 3.22-1.7h-2.76v-1h7.1v1h-2.76c.43.97 1.94 1.63 3.2 1.68zm.41 2.67h-8.86V9.76h3.77V8.54h1.28v1.24h3.81v1.03zm-2.33 2.25c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8.81.8 2.08.8 2.1-.3 2.1-.8"
  }))));
};
var DiscontinuedIconSvg = SvgProductBadgeDiscontinued$1;

const DiscontinuedIcon = () => {
  return jsx(DiscontinuedIconSvg, {
    "aria-label": "\uB2E8\uC885"
  });
};

var _g$6;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
var SvgProductBadgeOverseasPurchase$1 = function SvgProductBadgeOverseasPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.349 14.801h-1.221V9.994h-.814v4.356h-1.199V5.176h1.199V8.96h.814V5h1.221zm-3.85-4.037c0 1.232-.869 2.035-2.145 2.035-1.265 0-2.145-.869-2.145-2.035 0-1.243.891-2.035 2.145-2.035 1.276 0 2.145.803 2.145 2.035M5 8.366V7.343h4.675v1.023zm3.344 2.398c0-.605-.418-1.023-.99-1.023-.561 0-.979.418-.979 1.023 0 .616.418 1.023.979 1.023.572 0 .99-.429.99-1.023M6.067 6.782V5.759h2.64v1.023zm14.861 5.797c-1.694.209-4.29.341-6.127.341a34 34 0 0 1-.187-1.034c.825 0 1.65 0 2.442-.022v-1.562c-1.177-.209-2.002-1.045-2.002-2.233 0-1.364 1.122-2.387 2.629-2.387s2.662 1.012 2.662 2.387c0 1.166-.825 1.991-1.991 2.222v1.518c.913-.055 1.76-.121 2.486-.22zM22.666 5v9.801h-1.298V5zm-3.597 3.069c0-.825-.638-1.309-1.386-1.309-.737 0-1.364.517-1.364 1.309 0 .759.638 1.221 1.364 1.221s1.386-.462 1.386-1.221m5.412-1.353V5.693h5.17v1.023H27.77c.099 1.408 1.1 2.343 2.2 2.695l-.715 1.012c-.748-.286-1.705-1.045-2.134-1.947-.275.957-1.32 1.87-2.277 2.2l-.759-1.001c1.386-.495 2.31-1.529 2.365-2.959zm1.034 4.477h6.644v3.619h-1.298v-2.607h-5.346zm6.633-.484h-1.287V5.011h1.287zm9.13-5.181c0 1.584-.099 3.058-.319 4.18h1.452v1.023h-3.806v4.07h-1.287v-4.07h-3.762V9.708h6.182c.176-.847.264-1.947.264-3.146h-5.357V5.528z"
  }))));
};
var OverseasPurchaseIconSvg = SvgProductBadgeOverseasPurchase$1;

const OverseasPurchaseIcon = () => {
  return jsx(OverseasPurchaseIconSvg, {
    "aria-label": "\uD574\uC678\uC9C1\uAD6C"
  });
};

var _g$5;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
var SvgProductBadgeFreeDelivery$1 = function SvgProductBadgeFreeDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    d: "M12.73 5.38v3.96h-6.6V5.38zm-2.68 9.43H8.76v-3.25H5v-1.03h8.86v1.03h-3.81zm1.4-6.49V6.41H7.43v1.91h4.04zm11.08 2.7h-1.42v1.54h2.26v1.02h-8.86v-1.02h2.24v-1.53h-1.1V7.78h5.32V6.65H15.6V5.63h6.66V8.8h-5.33v1.18h5.61v1.04zm-4.53 0v1.54h1.87v-1.53H18zm14.37 3.78h-1.23V9.86h-.8v4.49h-1.2V5.18h1.2v3.66h.8V5h1.23zm-4.2-2.54h-3.9V6.01h1.27v2.26h1.36V6h1.28v6.26zm-1.27-1.01v-2h-1.36v2zm14.49 1.71c0 1.13-1.25 1.82-3.41 1.82s-3.42-.7-3.42-1.82 1.25-1.82 3.4-1.82c2.18 0 3.43.7 3.43 1.82m-3.41-6.05c-.5 1.13-2.1 1.9-3.51 2.1l-.54-1c1.64-.17 3.39-1.06 3.39-2.54V5.2h1.33v.28c0 1.48 1.99 2.47 3.4 2.53l-.55 1.01c-1.31-.18-3.03-.97-3.52-2.1zm4.42 3.78h-8.86V9.66h3.79V8.4h1.29v1.26h3.78zm-2.33 2.27c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8c0 .51.81.8 2.08.8s2.1-.29 2.1-.8"
  }))));
};
var FreeDeliveryIconSvg = SvgProductBadgeFreeDelivery$1;

const FreeDeliveryIcon = () => {
  return jsx(FreeDeliveryIconSvg, {
    "aria-label": "\uBB34\uB8CC\uBC30\uC1A1"
  });
};

var _rect, _path$6;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
var SvgProductBadgeCheapestPrice = function SvgProductBadgeCheapestPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#F77",
    rx: 4
  })), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.83 7.93v-.97h-4.9v-.555h5.228v-.991H6.655v4.063h6.59v-.992H7.928V7.93zm-6.295 3.747v1.002h5.326v2.037h1.274v-3.04zm7.733-.588v-1.024H5.5v1.024zm9.642-1.307V8.725h-1.405V5H21.24v9.705h1.264V9.782h1.405zm-3.954-3.79h-4.53v1.056h3.147c-.174 1.938-1.623 3.975-3.736 4.945l.773.958c2.974-1.612 4.259-4.03 4.346-6.96z"
  })));
};

const CheapestPriceIcon = () => {
  return jsx(SvgProductBadgeCheapestPrice, {
    "aria-label": "\uD2B9\uAC00"
  });
};

const ChipList$1 = ({
  disabled,
  maxLength,
  children,
  className
}) => {
  const childArray = React__default.Children.toArray(children);
  if (childArray.length === 0) {
    return null;
  }
  return jsx("div", {
    css: /*#__PURE__*/css("display:flex;flex-wrap:wrap;gap:4px;opacity:", disabled ? 0.32 : undefined, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ChipList;")),
    className: className,
    children: childArray.slice(0, maxLength)
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
// 실험 종료 시점에 대체 됨
var _ref$D = process.env.NODE_ENV === "production" ? {
  name: "pr10xp",
  styles: "margin-bottom:10px"
} : {
  name: "higvki-ViewProductCard",
  styles: "margin-bottom:10px;label:ViewProductCard;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1x
};
const ViewProductCard = ({
  src,
  subHead,
  headLine,
  thumbnailContent,
  content,
  isHorizontal
}) => {
  return jsxs(StyledContainer$2, {
    direction: isHorizontal ? 'horizontal' : 'vertical',
    children: [jsx("div", {
      css: isHorizontal && _ref$D,
      children: jsx(Thumbnail$3, {
        src: src,
        children: thumbnailContent
      })
    }), jsx("div", {
      children: jsx(Content$7, {
        subHead: subHead,
        headLine: headLine,
        children: content
      })
    })]
  });
};
const StyledContainer$2 = /*#__PURE__*/_styled(Container$F, process.env.NODE_ENV === "production" ? {
  target: "e1gvmkvu0"
} : {
  target: "e1gvmkvu0",
  label: "StyledContainer"
})(HOVER$1`
    .thumbnail-image {
      transform: translate(-50%, -50%) scale(1.1);
    }
    .head-line {
      opacity: 0.5;
    }
  `, ";");

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};
function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = React.useState(null);
  const callback = React.useRef();
  const [state, setState] = React.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  React.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = React.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

var B = Object.create;
var v$1 = Object.defineProperty;
var F = Object.getOwnPropertyDescriptor;
var $$1 = Object.getOwnPropertyNames;
var C$1 = Object.getPrototypeOf,
  D = Object.prototype.hasOwnProperty;
var G = (e, t) => () => (t || e((t = {
  exports: {}
}).exports, t), t.exports);
var K = (e, t, n, i) => {
  if (t && typeof t == "object" || typeof t == "function") for (let s of $$1(t)) !D.call(e, s) && s !== n && v$1(e, s, {
    get: () => t[s],
    enumerable: !(i = F(t, s)) || i.enumerable
  });
  return e;
};
var A$1 = (e, t, n) => (n = e != null ? B(C$1(e)) : {}, K(t || !e || !e.__esModule ? v$1(n, "default", {
  value: e,
  enumerable: !0
}) : n, e));
var _ = G((b, l) => {
  (function (e) {
    var t = function (o, r, a) {
        if (!z(r) || j(r) || E(r) || R(r) || P(r)) return r;
        var c,
          u = 0,
          y = 0;
        if (U(r)) for (c = [], y = r.length; u < y; u++) c.push(t(o, r[u], a));else {
          c = {};
          for (var m in r) Object.prototype.hasOwnProperty.call(r, m) && (c[o(m, a)] = t(o, r[m], a));
        }
        return c;
      },
      n = function (o, r) {
        r = r || {};
        var a = r.separator || "_",
          c = r.split || /(?=[A-Z])/;
        return o.split(c).join(a);
      },
      i = function (o) {
        return T(o) ? o : (o = o.replace(/[\-_\s]+(.)?/g, function (r, a) {
          return a ? a.toUpperCase() : "";
        }), o.substr(0, 1).toLowerCase() + o.substr(1));
      },
      s = function (o) {
        var r = i(o);
        return r.substr(0, 1).toUpperCase() + r.substr(1);
      },
      p = function (o, r) {
        return n(o, r).toLowerCase();
      },
      g = Object.prototype.toString,
      P = function (o) {
        return typeof o == "function";
      },
      z = function (o) {
        return o === Object(o);
      },
      U = function (o) {
        return g.call(o) == "[object Array]";
      },
      j = function (o) {
        return g.call(o) == "[object Date]";
      },
      E = function (o) {
        return g.call(o) == "[object RegExp]";
      },
      R = function (o) {
        return g.call(o) == "[object Boolean]";
      },
      T = function (o) {
        return o = o - 0, o === o;
      },
      d = function (o, r) {
        var a = r && "process" in r ? r.process : r;
        return typeof a != "function" ? o : function (c, u) {
          return a(c, o, u);
        };
      },
      f = {
        camelize: i,
        decamelize: p,
        pascalize: s,
        depascalize: p,
        camelizeKeys: function (o, r) {
          return t(d(i, r), o);
        },
        decamelizeKeys: function (o, r) {
          return t(d(p, r), o, r);
        },
        pascalizeKeys: function (o, r) {
          return t(d(s, r), o);
        },
        depascalizeKeys: function () {
          return this.decamelizeKeys.apply(this, arguments);
        }
      };
    typeof define == "function" && define.amd ? define(f) : typeof l < "u" && l.exports ? l.exports = f : e.humps = f;
  })(b);
});
var N = e => `${e.object_type}#${e.object_id}#${e.object_idx}#${e.object_section}#${e.object_section_id}#${e.object_section_idx}`.toUpperCase();
var I$1 = A$1(_());
function x$1(e, t) {
  let n = {};
  for (let i in e) Object.prototype.hasOwnProperty.call(e, i) && t(e[i], i) && (n[i] = e[i]);
  return n;
}
var L = e => x$1({
    data: e.data,
    category: e.category,
    object_section: e.section,
    object_section_id: e.section_id,
    object_section_idx: e.section_idx,
    object_type: e.type && (0, I$1.decamelize)(e.type.toLowerCase()),
    object_id: e.id,
    object_idx: e.index,
    object_url: e.url,
    page_id: e.page_id,
    page_params: e.page_params
  }, t => t != null),
  O$1 = e => {
    window.bucketLog = window.bucketLog || [], window.bucketLog.push(L(e));
  },
  Y$1 = (e, t) => {
    window.bucketLog = window.bucketLog || [], window.bucketLog.registerEventHandler(e, t);
  },
  ee$1 = (e, t) => {
    window.bucketLog = window.bucketLog || [], window.bucketLog.unregisterEventHandler(e, t);
  },
  te = e => {
    let t = window.bucketLog;
    return t && t.get ? t.get(e) : null;
  };
function q(e) {
  O$1({
    category: "impression",
    data: [{
      ...L(e),
      time: Date.now()
    }]
  });
}
function de({
  logData: e,
  threshold: t,
  disable: n
}) {
  let {
    ref: i,
    inView: s
  } = useInView({
    threshold: t,
    skip: n,
    triggerOnce: !0
  });
  return useEffect(() => {
    if (s && !n && e) {
      let {
        category: p,
        ...g
      } = e;
      q(g);
    }
  }, [s, n, e]), {
    ref: i
  };
}

const LogClick = ({
  children,
  params
}) => {
  const child = Children.only(children);
  return /*#__PURE__*/cloneElement(child, {
    onClick: (...args) => {
      O$1({
        category: 'click',
        ...params
      });
      if (child.props && typeof child.props['onClick'] === 'function') {
        return child.props['onClick'](...args);
      }
    }
  });
};

const TextList = ({
  children,
  className
}) => {
  const childArray = React__default.Children.toArray(children);
  if (childArray.length === 0) {
    return null;
  }
  return jsx("div", {
    css: theme => ({
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      color: theme.content.base1
    }),
    className: className,
    children: childArray.map((child, index) => jsxs(React__default.Fragment, {
      children: [child, index < childArray.length - 1 && jsx("span", {
        css: theme => ({
          color: theme.content.base3
        }),
        children: "\xA0\xB7\xA0"
      })]
    }, `text-item-${index}`))
  });
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var humps = {exports: {}};

(function (module) {
  (function (global) {
    var _processKeys = function (convert, obj, options) {
      if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
        return obj;
      }
      var output,
        i = 0,
        l = 0;
      if (_isArray(obj)) {
        output = [];
        for (l = obj.length; i < l; i++) {
          output.push(_processKeys(convert, obj[i], options));
        }
      } else {
        output = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            output[convert(key, options)] = _processKeys(convert, obj[key], options);
          }
        }
      }
      return output;
    };

    // String conversion methods

    var separateWords = function (string, options) {
      options = options || {};
      var separator = options.separator || '_';
      var split = options.split || /(?=[A-Z])/;
      return string.split(split).join(separator);
    };
    var camelize = function (string) {
      if (_isNumerical(string)) {
        return string;
      }
      string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : '';
      });
      // Ensure 1st char is always lowercase
      return string.substr(0, 1).toLowerCase() + string.substr(1);
    };
    var pascalize = function (string) {
      var camelized = camelize(string);
      // Ensure 1st char is always uppercase
      return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };
    var decamelize = function (string, options) {
      return separateWords(string, options).toLowerCase();
    };

    // Utilities
    // Taken from Underscore.js

    var toString = Object.prototype.toString;
    var _isFunction = function (obj) {
      return typeof obj === 'function';
    };
    var _isObject = function (obj) {
      return obj === Object(obj);
    };
    var _isArray = function (obj) {
      return toString.call(obj) == '[object Array]';
    };
    var _isDate = function (obj) {
      return toString.call(obj) == '[object Date]';
    };
    var _isRegExp = function (obj) {
      return toString.call(obj) == '[object RegExp]';
    };
    var _isBoolean = function (obj) {
      return toString.call(obj) == '[object Boolean]';
    };

    // Performant way to determine if obj coerces to a number
    var _isNumerical = function (obj) {
      obj = obj - 0;
      return obj === obj;
    };

    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    var _processor = function (convert, options) {
      var callback = options && 'process' in options ? options.process : options;
      if (typeof callback !== 'function') {
        return convert;
      }
      return function (string, options) {
        return callback(string, convert, options);
      };
    };
    var humps = {
      camelize: camelize,
      decamelize: decamelize,
      pascalize: pascalize,
      depascalize: decamelize,
      camelizeKeys: function (object, options) {
        return _processKeys(_processor(camelize, options), object);
      },
      decamelizeKeys: function (object, options) {
        return _processKeys(_processor(decamelize, options), object, options);
      },
      pascalizeKeys: function (object, options) {
        return _processKeys(_processor(pascalize, options), object);
      },
      depascalizeKeys: function () {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    if (module.exports) {
      module.exports = humps;
    } else {
      global.humps = humps;
    }
  })(commonjsGlobal);
})(humps);
var humpsExports = humps.exports;

/**
 * 웹뷰에서 앱에게 braze custom log를 전송하라고 합니다.
 * braze custom log가 웹이 아니라 앱으로 찍을 때 사용합니다.
 * 사용하는 웹뷰에 ipc 설정이 되어 있을 때만 사용 가능합니다.
 * @param name 이벤트 이름 e.g 'add_cart', 'add_scarp'
 * @param properties 로깅할 데이터
 */
const logAppBraze = (name, properties) => {
  if (window.webkit?.messageHandlers?.ohouseBrazeInterface != null) {
    window.webkit.messageHandlers.ohouseBrazeInterface.postMessage({
      name,
      properties
    });
  } else if (window?.ohouseBrazeInterface != null) {
    window.ohouseBrazeInterface.sendLog(name, JSON.stringify(properties));
  }
};

var mapObj = {exports: {}};

const isObject$1 = value => typeof value === 'object' && value !== null;
const mapObjectSkip = Symbol('skip');

// Customized for this use-case
const isObjectCustom = value => isObject$1(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObject = (object, mapper, options, isSeen = new WeakMap()) => {
  options = {
    deep: false,
    target: {},
    ...options
  };
  if (isSeen.has(object)) {
    return isSeen.get(object);
  }
  isSeen.set(object, options.target);
  const {
    target
  } = options;
  delete options.target;
  const mapArray = array => array.map(element => isObjectCustom(element) ? mapObject(element, mapper, options, isSeen) : element);
  if (Array.isArray(object)) {
    return mapArray(object);
  }
  for (const [key, value] of Object.entries(object)) {
    const mapResult = mapper(key, value, object);
    if (mapResult === mapObjectSkip) {
      continue;
    }
    let [newKey, newValue, {
      shouldRecurse = true
    } = {}] = mapResult;

    // Drop `__proto__` keys.
    if (newKey === '__proto__') {
      continue;
    }
    if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject(newValue, mapper, options, isSeen);
    }
    target[newKey] = newValue;
  }
  return target;
};
mapObj.exports = (object, mapper, options) => {
  if (!isObject$1(object)) {
    throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
  }
  return mapObject(object, mapper, options);
};
mapObj.exports.mapObjectSkip = mapObjectSkip;
var mapObjExports = mapObj.exports;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign$1.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
  return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.splitRegexp,
    splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a,
    _b = options.stripRegexp,
    stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b,
    _c = options.transform,
    transform = _c === void 0 ? lowerCase : _c,
    _d = options.delimiter,
    delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length;
  // Trim the delimiter from around the output string.
  while (result.charAt(start) === "\0") start++;
  while (result.charAt(end - 1) === "\0") end--;
  // Transform each token independently.
  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce(function (input, re) {
    return input.replace(re, value);
  }, input);
}

function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign$1({
    delimiter: "."
  }, options));
}

function snakeCase$1(input, options) {
  if (options === void 0) {
    options = {};
  }
  return dotCase(input, __assign$1({
    delimiter: "_"
  }, options));
}

var dist_es2015 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  snakeCase: snakeCase$1
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(dist_es2015);

const map = mapObjExports;
const {
  snakeCase
} = require$$1;
var snakecaseKeys = function (obj, options) {
  options = Object.assign({
    deep: true,
    exclude: [],
    parsingOptions: {}
  }, options);
  return map(obj, function (key, val) {
    return [matches(options.exclude, key) ? key : snakeCase(key, options.parsingOptions), val];
  }, options);
};
function matches(patterns, value) {
  return patterns.some(function (pattern) {
    return typeof pattern === 'string' ? pattern === value : pattern.test(value);
  });
}
var snakecaseKeys$1 = /*@__PURE__*/getDefaultExportFromCjs(snakecaseKeys);

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * 웹에서 braze custom log를 전송합니다.
 * @param name 이벤트 이름 e.g 'add_cart', 'add_scarp'
 * @param properties 로깅할 데이터이며 object 형태여야 로깅이 동작합니다.
 */
const logBraze = (eventName, properties) => {
  if (window.braze?.logCustomEvent != null) {
    window.braze.logCustomEvent(eventName, snakecaseKeys$1(properties));
  }
};

/* eslint-disable @typescript-eslint/no-explicit-any */

const BRAZE_TOKEN = '5195e134-c2c9-4bdb-8431-ee5fca29b935';
const BRAZE_BASE_URL = 'sdk.iad-03.appboy.com';
let brazeInitialized = false;
let ohouseUserId = '';
/**
 * window.braze 에 Braze 를 세팅하고 초기화하기 위한 함수이며, logBraze 이전에 호출되어야 합니다.
 * 앱 내부일 경우 웹뷰에서 logAppBraze 를 사용할 경우 (ipc 세팅이 되어있을 경우) 호출하지 않아도 됩니다.
 * @param userId braze에 기록될 userId이며, 오늘의집 유저 id 를 주입하면 됩니다.
 * @param isDevelopment 개발환경이라면 debug log를 표시합니다.
 * @example
 * ```
 * <Script
 *   src="https://js.appboycdn.com/web-sdk/4.8/braze.min.js"
 *   onLoad={() => initBraze({ userId, isDevelopment })}
 * />
 * ```
 */
const initBraze = ({
  userId,
  isDevelopment = false,
  isAutomaticallyShowInAppMessages = false
}) => {
  const isUserAlreadyInBraze = brazeInitialized && ohouseUserId === userId;
  if (isUserAlreadyInBraze || !window.braze) {
    return;
  }
  const Braze = window.braze;
  Braze.initialize(BRAZE_TOKEN, {
    baseUrl: BRAZE_BASE_URL,
    allowUserSuppliedJavascript: true,
    enableLogging: isDevelopment
  });
  if (isAutomaticallyShowInAppMessages) {
    Braze.automaticallyShowInAppMessages();
  }
  Braze.changeUser(userId);
  Braze.openSession();
  ohouseUserId = userId;
  brazeInitialized = true;
};

const AIRBRIDGE = {
  prod: {
    appName: 'ohouse',
    token: '2bd43efc5ef8401baece946c84ba155d'
  },
  qa: {
    appName: 'ohouseqa',
    token: '8a0b134914404cd187995f1dc379544f'
  },
  dev: {
    appName: 'ohousedevelopment',
    token: 'de291f3fe36e4e76b3302865f5aa3848'
  }
};
const GLOBAL_AIRBRIDGE = {
  prod: {
    appName: 'globalohouse',
    token: '71707709882c4d9f8bcaf137232a2646'
  },
  qa: {
    appName: 'globalohouseqa',
    token: '2d7043487ec84facafb9bd382c31ca76'
  },
  dev: {
    appName: 'globalohousedevelopment',
    token: 'c55bf99ce4344965bb4337471cc73362'
  }
};
const ALLOW_ENVS = ['prod', 'qa', 'dev'];
const isAllowEnv = env => {
  return ALLOW_ENVS.includes(env);
};

/**
 * airbridge 전역 객체를 초기화합니다.
 * prod, qa, dev 환경에서만 init합니다.
 * @param user 로그인 유저 데이터
 * @param env 환경
 * @param isGlobal 글로벌 서비스 여부
 * @example
 * ```
 * <Script
 *   src="/js/airbridge.js"
 *   onLoad={() => initAirbridge(user)}
 * />
 * ```
 */
const initAirbridge = ({
  user,
  env,
  isGlobal = false
}) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!isAllowEnv(env)) {
    return;
  }
  const userConfig = user ? {
    user: {
      externalUserID: `${user.id}`,
      externalUserEmail: `${user.id}@bucketplace.net`
    }
  } : {};
  const config = {
    app: isGlobal ? GLOBAL_AIRBRIDGE[env].appName : AIRBRIDGE[env].appName,
    webToken: isGlobal ? GLOBAL_AIRBRIDGE[env].token : AIRBRIDGE[env].token,
    cookieWindow: 1,
    userHash: false,
    urlQueryMapping: {
      channel: 'utm_source',
      campaign: 'utm_campaign',
      term: 'utm_term',
      ad_creative: 'utm_content',
      ad_group: 'bp_adset',
      content: 'bp_content',
      sub_id: 'bp_sub_id',
      sub_id_1: 'bp_sub_id_1',
      sub_id_2: 'bp_sub_id_2',
      sub_id_3: 'utm_medium'
    },
    ...userConfig
  };
  window.airbridge.init?.(config);
};

/**
 * airbridge 로그를 전송합니다.
 * @param {string} category event 카테고리
 * @param {EventOption} attritube event 옵션
 * @example
 * ```
 * logAirbridge('category', {
 *   label: 'label',
 *   action: 'action',
 *   value: 1,
 *   ...
 * });
 * ```
 */
const logAirbridge = ({
  category,
  attribute
}) => {
  if (!window?.airbridge) {
    return;
  }
  window.airbridge.events?.send(category, attribute);
};

/**
 * signout 시 airbridge 정보도 clear 합니다.
 * @example
 * ```
 * signoutAirbridge();
 * ```
 */
const signoutAirbridge = () => {
  logAirbridge({
    category: 'airbridge.user.signout'
  });
  window.airbridge?.clearUser();
};

/**
 * signin 시 airbridge 정보에 사용자 정보를 설정합니다.
 * @example
 * ```
 * signinAirbridge({userId, provider});
 * ```
 */
const signinAirbridge = ({
  userId,
  provider
}) => {
  if (userId == null || !provider) {
    return;
  }
  window.airbridge?.setUserID(`${userId}`);
  window.airbridge?.setUserEmail(`${userId}@bucketplace.net`);
  logAirbridge({
    category: 'airbridge.user.signin',
    attribute: {
      customAttributes: {
        login_method: provider
      }
    }
  });
};

/**
 * signup 시 airbridge 정보에 사용자 정보를 설정합니다.
 * @example
 * ```
 * signupAirbridge({id, provider});
 * ```
 */
const signupAirbridge = ({
  userId,
  provider
}) => {
  if (userId == null) {
    return;
  }
  window.airbridge?.setUserID(`${userId}`);
  window.airbridge?.setUserEmail(`${userId}@bucketplace.net`);
  logAirbridge({
    category: 'airbridge.user.signup',
    attribute: {
      customAttributes: {
        signup_method: provider
      }
    }
  });
};

const getAmplitude = () => {
  if (!window.amplitude) {
    return null;
  }
  return window.amplitude?.getInstance?.() || null;
};

/**
 * 앰플리튜드 로그를 남깁니다.
 * @param {string} type 이벤트 타입
 * @param {unknown} data 이벤트 데이터
 */
const logAmplitude$1 = (type, data) => {
  const amplitude = getAmplitude();
  if (!amplitude) {
    return;
  }
  amplitude.logEvent(type, data);
};

/**
 * 버킷 클릭 로그를 남깁니다.
 * @param {object} data `category`를 제외한 로그 데이터
 */
const bucketClickLog = data => {
  O$1({
    category: 'click',
    ...data
  });
};

/**
 * 버킷 임프레션 로그를 남깁니다.
 * @param {object} data `category`를 제외한 로그 데이터
 */
const bucketImpressionLog = data => {
  O$1({
    category: 'impression',
    data: [{
      ...L(data),
      time: Date.now()
    }]
  });
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$e.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$d.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray$1 = isArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$1 = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$c = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
  HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
    lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
      remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1 = defineProperty;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty$1 ? identity : function (func, string) {
  return defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};
var baseSetToString$1 = baseSetToString;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
      index = -1,
      length = nativeMax$1(args.length - start, 0),
      array = Array(length);
    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$a;
  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$8.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Built-in value references. */
var Buffer$1 = moduleExports$1 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag = '[object Function]',
  mapTag$3 = '[object Map]',
  numberTag$1 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$1 = '[object RegExp]',
  setTag$3 = '[object Set]',
  stringTag$1 = '[object String]',
  weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$2 = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$3] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$3] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$5.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$3.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function () {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray$1(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString$1(value));
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$3(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray$1(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString$1(overRest(func, undefined, flatten), func + '');
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root$1, 'DataView');
var DataView$1 = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$2 = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$2),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$1 || Map$2 && getTag(new Map$2()) != mapTag$2 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$2 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function (value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$2;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$2;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Built-in value references. */
var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
  COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
  COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  mapTag$1 = '[object Map]',
  numberTag = '[object Number]',
  regexpTag = '[object RegExp]',
  setTag$1 = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
    othIsArr = isArray$1(other),
    objTag = objIsArr ? arrayTag : getTag$1(object),
    othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'),
      othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
    length = index,
    noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
      objValue = object[key],
      srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
    length = result.length;
  while (length--) {
    var key = result[length],
      value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments$1(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
  COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get$3(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
      iterable = Object(object),
      props = keysFunc(object),
      length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();
var baseFor$1 = baseFor;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys);
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function () {
  return root$1.Date.now();
};
var now$1 = now;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function (value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey$1(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate), baseForOwn);
}

/** `Object#toString` result references. */
var mapTag = '[object Map]',
  setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer$1(value) || isTypedArray$1(value) || isArguments$1(value))) {
    return !value.length;
  }
  var tag = getTag$1(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$2(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  return function () {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
    length = paths.length,
    result = {};
  while (++index < length) {
    var path = paths[index],
      value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function (prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function (value, path) {
    return predicate(value, path[0]);
  });
}

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick$1 = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick$2 = pick$1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

const GLOBAL_INFO = {
  /** 미국 */
  US: {
    currency: 'USD',
    locale: 'en'
  },
  /** 일본 */
  JP: {
    currency: 'JPY',
    locale: 'ja'
  },
  /** 인도네시아 */
  ID: {
    currency: 'IDR',
    locale: 'id'
  },
  /** 한국 */
  KR: {
    currency: 'KRW',
    locale: 'ko'
  }
};
const GLOBAL_COUNTRY_TO_LANGUAGE = {
  US: 'en',
  JP: 'ja',
  ID: 'id'
};
const GLOBAL_LANGUAGE_TO_COUNTRY = {
  en: 'US',
  ja: 'JP',
  id: 'ID'
};
const COUNTRY_TO_LANGUAGE = {
  ...GLOBAL_COUNTRY_TO_LANGUAGE,
  KR: 'ko'
};
const LANGUAGE_TO_COUNTRY = {
  ...GLOBAL_LANGUAGE_TO_COUNTRY,
  ko: 'KR'
};
const GLOBAL_DEFAULT_LANGUAGE = 'en';
const GLOBAL_DEFAULT_COUNTRY = 'US';
const GLOBAL_DEFAULT_LOCALE = `${GLOBAL_DEFAULT_LANGUAGE}-${GLOBAL_DEFAULT_COUNTRY}`;
const GLOBAL_PREFERRED_LOCALES = ['en-US', 'ja-JP', 'id-ID'];

/**
 * 국가별 통화에 맞게 가격을 formatting 합니다.
 */
const formatPriceByCurrency = (price, currency) => {
  if (!currency) {
    return price.toLocaleString();
  }
  const country = findKey$1(GLOBAL_INFO, global => global.currency === currency) ?? 'KR';
  const locale = GLOBAL_INFO[country].locale;
  const intl = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  });
  const originalFormattedPrice = intl.format(price);
  let formattedPrice = '';
  switch (currency) {
    /** 미국 */
    case 'USD':
      formattedPrice = originalFormattedPrice.replace('.00', '');
      break;
    /** 인도네시아 */
    case 'IDR':
      formattedPrice = originalFormattedPrice.replace(',00', '').replace(/\u00A0/, '');
      break;
    /** 일본 */
    case 'JPY':
    case 'KRW':
    default:
      formattedPrice = originalFormattedPrice;
      break;
  }
  return formattedPrice;
};

class HTTPError extends Error {
  constructor(status, body) {
    super(`HTTP ${status} occurred while sending fetch request.`);
    this.status = status;
    this.body = body;
    this.hasMessage = false;
  }
}

const globalLanguages = ['en', 'ja', 'id'];
const languages = [...globalLanguages, 'ko'];
const globalCountries = ['US', 'JP', 'ID'];
const countries = [...globalCountries, 'KR'];
const globalLocales = globalLanguages.flatMap(lang => globalCountries.map(country => `${lang}-${country}`));
const locales = languages.flatMap(lang => countries.map(country => `${lang}-${country}`));

const fetchSugar = async ({
  url,
  method,
  body = {},
  headers = {},
  credentials = 'same-origin',
  ignoreError = false
}) => {
  const response = await fetch(url, {
    credentials,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    method,
    ...(method === 'GET' ? {} : {
      body: JSON.stringify(body)
    })
  });
  if (!ignoreError && !response.ok) {
    const error = new HTTPError(response.status, {
      url: response.url,
      method,
      body
    });
    try {
      const json = await response.json();
      if (json.message) {
        error.message = json.message;
        error.hasMessage = true;
      }
    } catch (e) {
      // noop
    }
    throw error;
  }
  return response;
};
const fetchGet = async (url, options) => {
  return await fetchSugar({
    url,
    method: 'GET',
    ...options
  });
};
const fetchDelete = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'DELETE',
    body,
    ...options
  });
};
const fetchPut = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'PUT',
    body,
    ...options
  });
};
const fetchPost = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'POST',
    body,
    ...options
  });
};
const fetchPatch = async (url, body = {}, options) => {
  return await fetchSugar({
    url,
    method: 'PATCH',
    body,
    ...options
  });
};

const COMMERCE_PATTERN = /^\/productions|^\/store|^\/commerces|^\/exhibitions|^\/cart/;
const O2O_PATTERN = /^\/experts|^\/expert_users/;

/**
 * 현재 URL과 매칭되는 서비스 타입을 반환합니다.
 * @returns {string} 'hnc' | 'commerce | 'o2o'
 */
const getServiceType = (subdomain, pathname) => {
  switch (subdomain) {
    case 'store':
    case 'partner':
    case 'events':
      return 'commerce';
    case 'o2o':
    case 'expert':
      return 'o2o';
    case 'content':
      return 'hnc';
    case 'home':
      {
        if (COMMERCE_PATTERN.test(pathname)) {
          return 'commerce';
        }
        if (O2O_PATTERN.test(pathname)) {
          return 'o2o';
        }
        return 'hnc';
      }
    default:
      return 'hnc';
  }
};

/** 국외향 도메인 */
const GLOBAL_DOMAINS = {
  prod: {
    home: 'https://www.ohouse.com',
    content: 'https://content.ohouse.com',
    store: 'https://store.ohouse.com',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  qa: {
    home: 'https://qa-web.ohouse.in',
    content: 'https://content.qa-web.ohouse.in',
    store: 'https://store.qa-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  stage: {
    home: 'https://global.stage-web.dailyhou.se',
    content: 'https://content-global.stage-web.dailyhou.se',
    store: 'https://store-global.stage-web.dailyhou.se',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  dev: {
    home: 'https://dev-web.ohouse.in',
    content: 'https://content.dev-web.ohouse.in',
    store: 'https://store.dev-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  },
  local: {
    home: 'https://qa-web.ohouse.in',
    content: 'https://content.qa-web.ohouse.in',
    store: 'https://store.qa-web.ohouse.in',
    o2o: undefined,
    events: undefined,
    partner: undefined,
    expert: undefined
  }
};

/** 국내향 도메인 */
const DOMAINS = {
  prod: {
    home: 'https://ohou.se',
    content: 'https://contents.ohou.se',
    store: 'https://store.ohou.se',
    o2o: 'https://o2o.ohou.se',
    events: 'https://events.ohou.se',
    partner: 'https://partners.ohou.se',
    expert: 'https://pro.ohou.se'
  },
  qa: {
    home: 'https://qa-web.dailyhou.se',
    content: 'https://contents.qa-web.dailyhou.se',
    store: 'https://store.qa-web.dailyhou.se',
    o2o: 'https://o2o.qa-web.dailyhou.se',
    events: 'https://events.qa-web.dailyhou.se',
    partner: 'https://partners.qa.dailyhou.se',
    expert: 'https://pro.qa-web.dailyhou.se'
  },
  stage: {
    home: 'https://stage-web.dailyhou.se',
    content: 'https://contents.stage-web.dailyhou.se',
    store: 'https://store.stage-web.dailyhou.se',
    o2o: 'https://o2o.stage-web.dailyhou.se',
    events: 'https://events.stage-web.dailyhou.se',
    partner: 'https://partners.stage.dailyhou.se',
    expert: 'https://pro.stage-web.dailyhou.se'
  },
  dev: {
    home: 'https://dev-web.dailyhou.se',
    content: 'https://contents.dev-web.dailyhou.se',
    store: 'https://store.dev-web.dailyhou.se',
    o2o: 'https://o2o.dev-web.dailyhou.se',
    events: 'https://events.dev-web.dailyhou.se',
    partner: 'https://partners.dev.dailyhou.se',
    expert: 'https://pro.dev-web.dailyhou.se'
  },
  local: {
    home: 'https://dev-web.dailyhou.se',
    content: 'https://contents.dev-web.dailyhou.se',
    store: 'https://store.dev-web.dailyhou.se',
    o2o: 'https://o2o.dev-web.dailyhou.se',
    events: 'https://events.dev-web.dailyhou.se',
    partner: 'https://partners.stage.dailyhou.se',
    expert: 'https://pro.dev-web.dailyhou.se'
  }
};
const API_AUTOCOMPLETE_HOST = {
  prod: 'https://autocomplete.datahou.se',
  qa: 'https://autocomplete.qa.datahou.se',
  stage: 'https://autocomplete.stage.datahou.se',
  dev: 'https://autocomplete.stage.datahou.se',
  local: 'https://autocomplete.stage.datahou.se'
};

/** 국외향 API GATEWAY */
const GLOBAL_API_GATEWAY = {
  prod: 'http://global-mbff.common',
  qa: 'http://global-mbff.common',
  stage: 'http://global-mbff.common',
  dev: 'http://global-mbff.common',
  local: 'https://mbff.qa-web.ohouse.in'
};

// TODO: 문제 없을 지 체크 필요
/** 국외향에서 사용하는 default metadata */
const GLOBAL_DEFAULT_METADATA = {
  ko: {
    title: '라이프스타일 슈퍼앱, 오늘의집',
    description: '감도높은 유저들의 일상 구경부터 제품 구매까지 한번에'
  },
  en: {
    title: 'Ohouse | Community driven interior design and inspiration',
    description: 'See how interior design enthusiasts decorate and furnish their home',
    siteName: 'Ohouse'
  },
  ja: {
    title: 'Ohouse(オーハウス)|部屋と家具のインテリア写真が見放題',
    description: '世界中の様々なテイストや間取りのインテリア写真が見放題！実際のユーザーの写真から欲しい家具や雑貨を見つけるインテリアコミュニティーサービス。',
    siteName: 'Ohouse'
  },
  id: {
    title: 'Ohouse | Komunitas no. 1 home styling di Indonesia',
    description: 'Intip ke dalam rumah-rumah estetik untuk mendapatkan inspirasi nge-bangun dan nge-dekor',
    siteName: 'Ohouse'
  }
};
const DEFAULT_OG_IMAGE = {
  global: 'https://image.ohouse.com/oh-image-ap-northeast-2/site/1_Ohouse_mark_horizontal_black_og.png',
  domestic: 'https://image.ohousecdn.com/i/bucketplace-v2-development/uploads/default_images/open_graph_icon_2.png'
};

/**
 * url에서 protocol을 제거한 값을 리턴합니다.
 * @param url
 */
const getUrlWithoutProtocol = url => {
  if (url.startsWith('http://')) {
    return url.replace('http://', '');
  }
  if (url.startsWith('https://')) {
    return url.replace('https://', '');
  }
  return url;
};
/**
 * url에서 hostname을 리턴합니다.
 * @param url
 */
const getHostname = url => {
  const urlWithoutProtocol = getUrlWithoutProtocol(url);
  const splittedUrl = urlWithoutProtocol.split('/');
  return splittedUrl[0] ?? '';
};

/**
 * 글로벌에서 허용하는 locale인지 확인합니다.
 * @param locale string
 * @returns 허용하는 locale이라면 true를 리턴합니다.
 */
const isAllowedGlobalLocale = locale => {
  if (!locale) {
    return false;
  }
  return Boolean(globalLocales.find(allowedLocale => allowedLocale === locale));
};

/**
 * 글로벌에서 허용하는 language인지 확인합니다.
 * @param language string
 * @returns 허용하는 language이라면 true를 리턴합니다.
 */
const isAllowedGlobalLanguage = language => {
  if (!language) {
    return false;
  }
  return Boolean(globalLanguages.find(allowedLanguage => allowedLanguage === language));
};

/**
 * 글로벌에서 허용하는 country인지 확인합니다.
 * @param country string
 * @returns 허용하는 country이라면 true를 리턴합니다.
 */
const isAllowedGlobalCountry = country => {
  if (!country) {
    return false;
  }
  return Boolean(globalCountries.find(allowedCountry => allowedCountry === country));
};

/**
 * 글로벌에서 권장하는 locale인지 확인합니다.
 * @param locale string
 * @returns 권장하는 locale이라면 true를 리턴합니다.
 */
const isPreferredGlobalLocale = locale => {
  return GLOBAL_PREFERRED_LOCALES.includes(locale);
};

/**
 * 주어진 url에 포함된 locale 위치의 값을 리턴합니다.
 * @param url
 */
const getTextAtLocalePositionInUrl = url => {
  const urlWithoutProtocol = getUrlWithoutProtocol(url);
  const pathname = urlWithoutProtocol.split('?')[0];
  const localeFromUrl = pathname?.split('/')[1];
  return localeFromUrl || null;
};

/**
 * 주어진 url에 포함되어 있는 locale 값을 changeLocale로 변경하여 전달합니다.
 * 만약 locale이 없는 경우 추가하여 전달합니다.
 * @param url
 * @param changeLocale 변경하려는 Locale
 * @returns locale이 바뀐 Url
 */
const getUrlWithExchangeLocale = (url, changeLocale) => {
  const prevLocale = getTextAtLocalePositionInUrl(url);
  const hostname = getHostname(url);
  if (prevLocale && isAllowedGlobalLocale(prevLocale)) {
    return url.replace(`${hostname}/${prevLocale}`, `${hostname}/${changeLocale}`);
  } else {
    return url.replace(`${hostname}`, `${hostname}/${changeLocale}`);
  }
};
/**
 * @param localeString
 * @returns 주어진 localeString에서 language 부분을 반환합니다. 해당 값이 사용하지 않는 값이라면, GLOBAL_DEFAULT_LANGUAGE를 전달합니다.
 */
const getGlobalLanguageFromLocaleString = (localeString = '') => {
  const languageString = localeString.split('-')?.[0] ?? '';
  return isAllowedGlobalLanguage(languageString) ? languageString : GLOBAL_DEFAULT_LANGUAGE;
};

/**
 * @param localeString
 * @returns 주어진 localeString에서 country 부분을 반환합니다. 해당 값이 사용하지 않는 값이라면, GLOBAL_DEFAULT_COUNTRY를 전달합니다.
 */
const getGlobalCountryFromLocaleString = (localeString = '') => {
  const countryString = localeString.split('-')?.[1] ?? '';
  return isAllowedGlobalLocale(localeString) && isAllowedGlobalCountry(countryString) ? countryString : GLOBAL_DEFAULT_COUNTRY;
};
const checkIsGlobal = ({
  serviceType
}) => {
  return serviceType === 'OG';
};

/**
 * 도메인에 따른 URL을 리턴합니다.
 * 이동하려는 URL과 현재 도메인이 다를 경우에만 full URL을 리턴합니다.
 * @param {string} subdomain - 현재 서브도메인
 * @param {string} env - 현재 서비스 환경
 * @param {string} url - 이동하려는 URL
 * @param {string} serviceType - 국내 또는 국외향 판단
 * @returns {string}
 */
const getURL = (subdomain, env, url, serviceType) => {
  const SERVICE_TYPE_DOMAINS = checkIsGlobal({
    serviceType
  }) ? GLOBAL_DOMAINS : DOMAINS;
  const redirectURL = url.replace(SERVICE_TYPE_DOMAINS[env][subdomain] ?? '', '');
  return redirectURL === '' ? '/' : redirectURL;
};

/**
 * 로그인을 위한 리다이렉션
 */
const REDIRECTION_PATH_MAP = {
  home: undefined,
  content: '/contents-web',
  store: '/stores',
  o2o: '/o2o-web',
  events: '/events',
  partner: undefined,
  expert: undefined
};

/**
 * 유저 정보가 없을 경우, 로그인 URL을 리턴합니다.
 * 유저 정보가 있을 경우, 이동하려는 URL 그대로를 리턴합니다.
 * @param {Object|null} user - 유저 정보
 * @param {string} subdomain - 현재 서브도메인
 * @param {string} env - 현재 서비스 환경
 * @param {string} url - 이동하려는 URL
 * @returns {string}
 */
const getLoginURL = (user, subdomain, env, url, serviceType, locale) => {
  // Check if it is correct URL
  try {
    const isGlobal = checkIsGlobal({
      serviceType
    });
    const {
      pathname,
      search,
      hash
    } = new URL(url);
    if (user != null) {
      return url;
    }
    if (isGlobal) {
      const loginURL = `${GLOBAL_DOMAINS[env].home}/${locale}/sign-in?redirect-to=`;
      switch (subdomain) {
        case 'home':
          {
            const redirectURL = [pathname, search, hash].join('');
            return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
          }
        default:
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(url)}`, serviceType);
      }
    }
    const loginURL = `${DOMAINS[env].home}/users/sign_in?redirect_to=`;
    switch (subdomain) {
      case 'content':
      case 'store':
      case 'o2o':
      case 'events':
        {
          const redirectURL = [REDIRECTION_PATH_MAP[subdomain], pathname, search, hash].join('');
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
        }
      default:
        {
          const redirectURL = [pathname, search, hash].join('');
          return getURL(subdomain, env, `${loginURL}${encodeURIComponent(redirectURL)}`, serviceType);
        }
    }
  } catch (error) {
    return '';
  }
};
const getCookieDomain = (env, subdomain, serviceType) => {
  try {
    const domain = checkIsGlobal({
      serviceType
    }) ? GLOBAL_DOMAINS[env].home : DOMAINS[env].home;
    const {
      host
    } = new URL(domain);
    if (typeof window !== 'undefined' && env === 'local' && subdomain === 'home') {
      return `${window.location.hostname}`;
    }
    // NOTE: 글로벌 환경은 www.ohouse.com 을 도메인으로 사용하지만 쿠키 도메인은 모든 서브도메인을 대응하기 위해서 .ohouse.com 으로 설정합니다.
    if (host === 'www.ohouse.com') {
      return `.ohouse.com`;
    }
    return `.${host}`;
  } catch (error) {
    return '.ohou.se';
  }
};
/**
 * 주어진 URL 배열을 '|'로 연결된 regex 로 반환하는 함수
 */
const convertUrlsToRegex = urlList => {
  const regexString = urlList.map(url => url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');

  // 문자열로부터 RegExp 객체 생성
  return new RegExp(regexString);
};

/**
 * 콘텐츠 서버에서 내려오는 landingUrl 을 각 host 에 맞게 변환해주는 함수
 * @param hostType 'content' | 'home' | 'store' landingUrl 의 host 는 content, home, store 기반으로만 내려온다고 전달받았으므로, 해당 경우에는 각 MSA 도메인에서는 상대 경로로 이동하게 하기 위해 hostType을 받습니다.
 *   만약 content, home, store 기반이 아닌 다른 도메인 기반의 host를 가진 url이 내려온다면 그대로 반환합니다.
 * @param landingUrl 컨버팅할 url로 서버에서 내려오는 landingUrl 필드입니다.
 * @return 변환된 url을 반환합니다.
 */
const convertLandingUrlByHost = ({
  hostType,
  landingUrl,
  serviceType,
  env
}) => {
  const landingUrlHostMap = {
    content: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.content, DOMAINS.prod.content]),
      targetHost: checkIsGlobal({
        serviceType
      }) ? GLOBAL_DOMAINS[env].content : DOMAINS[env].content
    },
    home: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.home, DOMAINS.prod.home]),
      targetHost: checkIsGlobal({
        serviceType
      }) ? GLOBAL_DOMAINS[env].home : DOMAINS[env].home
    },
    store: {
      originalHost: convertUrlsToRegex([GLOBAL_DOMAINS.prod.store, DOMAINS.prod.store]),
      targetHost: checkIsGlobal({
        serviceType
      }) ? GLOBAL_DOMAINS[env].store : DOMAINS[env].store
    }
  };
  switch (hostType) {
    case 'content':
      landingUrlHostMap.content.targetHost = '';
      break;
    case 'home':
      landingUrlHostMap.home.targetHost = '';
      break;
    case 'store':
      landingUrlHostMap.store.targetHost = '';
      break;
  }
  let convertedUrl = landingUrl;
  Object.values(landingUrlHostMap).forEach(({
    originalHost,
    targetHost
  }) => {
    convertedUrl = convertedUrl.replace(originalHost, targetHost);
  });
  return convertedUrl;
};

/**
 * NextJS 서버 요청 중 웹 페이지 요청인지를 판단합니다.
 * @param relativeUrl 요청 url
 * @returns 웹 페이지 요청인지
*/
const isNextJsPageRequest = relativeUrl => {
  const PUBLIC_FILE_REGEXP = /\.[^.]*$/;
  const pathname = relativeUrl.split('?')[0] ?? '';
  return !pathname.startsWith('/_next') && !pathname.startsWith('/api/') && !PUBLIC_FILE_REGEXP.test(pathname);
};

const getClientIp = req => {
  const ip = req.headers['x-forwarded-for']?.toString().split(',').shift();
  if (ip) {
    return ip;
  }
  return req.socket.remoteAddress;
};

const formatTwoDigitNumber = number => {
  return `${Math.floor(number / 10)}${number % 10}`;
};
const getMinuteFromTotalSeconds = totalSeconds => {
  return Math.floor(totalSeconds / 60);
};
const getOnlySecondFromTotalSeconds = totalSeconds => {
  return Math.floor(totalSeconds % 60);
};

/**
 * 입력된 초를 {mm:dd} 형태로 출력합니다.
 * @param totalSeconds
 * @returns
 */
const formatTimeStringFromTotalSeconds = totalSeconds => {
  return `${formatTwoDigitNumber(getMinuteFromTotalSeconds(totalSeconds))}:${formatTwoDigitNumber(getOnlySecondFromTotalSeconds(totalSeconds))}`;
};

const logGtm = (event, data) => {
  if (!window) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...data
  });
};

/* eslint-disable @typescript-eslint/no-explicit-any */

const useScrapLogger = () => {
  const logScrap = useCallback(({
    contentType,
    contentId,
    bucketLogData = {},
    brazeLogData
  }) => {
    O$1({
      ...bucketLogData,
      category: 'scrap',
      type: humpsExports.decamelize(contentType),
      id: contentId
    });
    if (brazeLogData) {
      logBraze('add_scrap', {
        ...brazeLogData,
        type: contentType,
        productionId: contentId
      });
    }

    /**
     * 상품인 경우 customAttributes가 아닌 semanticAttributes 활용해야 포스트백 정규양식에 맞음
     * 포스트백 정규양식에 맞아야 매체(네이버 구글 등)에 광고를 노출할 수 있음
     */
    if (['Production', 'Deal'].includes(contentType)) {
      logAirbridge({
        category: 'add_to_wishlist',
        attribute: {
          action: 'type',
          label: 'PRODUCT',
          semanticAttributes: {
            products: [{
              productID: contentId,
              quantity: null,
              price: null,
              name: null,
              currency: null,
              position: null
            }]
          }
        }
      });
      return;
    }
    logAirbridge({
      category: 'add_to_wishlist',
      attribute: {
        action: 'type',
        label: contentType === 'Advice' && 'KNOWHOW' || contentType === 'CardCollection' && 'CARD_COLLECTION' || contentType === 'Card' && 'CARD' || contentType === 'Exhibition' && 'EXHIBITION' || contentType === 'Project' && 'PROJECT' || contentType === 'Brand' && 'BRAND' || '',
        customAttributes: {
          id: contentId
        }
      }
    });
  }, []);
  const logUnScrap = useCallback(({
    contentType,
    contentId,
    bucketLogData = {}
  }) => {
    O$1({
      ...bucketLogData,
      category: 'unscrap',
      type: contentType,
      id: contentId
    });
  }, []);
  const logScrapSuccess = useCallback(({
    contentType,
    contentId,
    count,
    amplitudeLogData
  }) => {
    logGtm('content_scrap', {
      type: humpsExports.decamelize(contentType),
      id: contentId
    });
    const amplitude = window.amplitude;
    const amplitudeClient = getAmplitude();
    if (amplitudeLogData && amplitude && amplitudeClient) {
      const identify = new amplitude.Identify();
      identify.set('Total Number of 스크랩 - 전체', count);
      if (['Production', 'Deal'].includes(contentType)) {
        identify.add('Total Number of 스크랩 - 상품', 1);
      }
      amplitudeClient.identify(identify);
      const getAmplitudeLogEventType = () => {
        switch (contentType) {
          case 'Production':
          case 'Deal':
            return '상품 Added to Scrapbook Success';
          case 'Exhibition':
            return '프로모션 Added to Scrapbook Success';
          default:
            return '컨텐츠 Added to Scrapbook Success';
        }
      };
      logAmplitude$1(getAmplitudeLogEventType(), amplitudeLogData);
    }
  }, []);
  const logUnscrapSuccess = useCallback(({
    contentType,
    contentId
  }) => {
    logGtm('content_unscrap', {
      type: contentType,
      id: contentId
    });
  }, []);
  const logClickScrapBook = useCallback(() => {
    O$1({
      category: 'click',
      section_id: 'SNACK_BAR',
      section: 'snack bar',
      type: 'BUTTON',
      id: 'collection_book'
    });
  }, []);
  const logClickScrapBookTo = useCallback(() => {
    O$1({
      category: 'click',
      section_id: 'SNACK_BAR',
      section: 'snack bar',
      type: 'BUTTON',
      id: 'collection_book'
    });
  }, []);
  const logClickScrapBookFolder = useCallback(() => {
    O$1({
      category: 'click',
      section_id: 'SNACK_BAR',
      section: 'snack bar',
      id: 'folder',
      type: 'BUTTON'
    });
  }, []);
  return {
    logScrap,
    logUnScrap,
    logScrapSuccess,
    logUnscrapSuccess,
    logClickScrapBook,
    logClickScrapBookTo,
    logClickScrapBookFolder
  };
};

function useToggle$1(options = {}) {
  const [open, setOpen] = useState(options.initialValue);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleToggle = useCallback(flag => {
    setOpen(prevState => flag ?? !prevState);
  }, []);
  return {
    open: open ?? false,
    isInitial: open == null,
    handleOpen,
    handleClose,
    handleToggle
  };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * webview 이벤트에 리스너를 연결합니다.
 * 컴포넌트가 언마운트 되면 연결해둔 리스너도 같이 제거됩니다.
 * **최적화를 위해 이벤트 리스너는 useCallback으로 memoize 하는 것을 권장합니다**
 * @param {WebviewEventType} type 웹뷰 이벤트 타입
 * @param {WebviewEventListener} listener 이벤트 리스너
 */
const useWebviewEventListener = (type, listener) => {
  // 특정한 event type인 경우만 리스너를 실행
  const callback = useCallback(event => {
    if (type !== event.type) {
      return;
    }
    listener(event);
  }, [type, listener]);
  useEffect(() => {
    const windowObj = window;

    // BucketUtils 전역객체 초기화
    if (!windowObj.BucketUtils) {
      windowObj.BucketUtils = {};
    }

    // BucketUtils.sendEvent,
    // BucketUtils.sendEvent.callback 초기화
    if (!windowObj.BucketUtils.sendEvent) {
      windowObj.BucketUtils.sendEvent = event => {
        (windowObj.BucketUtils.sendEvent.callbacks || []).forEach(callback => callback(event));
      };
      windowObj.BucketUtils.sendEvent.callbacks = [];
    }

    // 리스너 등록
    const {
      callbacks
    } = windowObj.BucketUtils.sendEvent;
    callbacks.push(callback);

    // 언마운트 시 리스너 제거
    return () => {
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    };
  }, [callback]);
};

/**
 * 앱으로 이벤트를 전송하는 webview 이벤트 dispatcher를 반환합니다.
 * @return {function} 이벤트 dispatcher
 */
const useWebviewEventDispatcher = () => {
  const dispatchWebviewEvent = event => {
    try {
      const windowObj = window;
      windowObj.webkit?.messageHandlers?.ohouseEventInterface?.postMessage?.(event);
      windowObj.ohouseEventInterface?.sendEvent?.(JSON.stringify(event));
    } catch (e) {
      // noop
    }
  };
  return dispatchWebviewEvent;
};

const useIntersectionObserver = ({
  options,
  onIntersect
}) => {
  const {
    ref: target,
    inView
  } = useInView(options);
  useEffect(() => {
    if (inView) {
      onIntersect();
    }
  }, [inView, onIntersect]);
  return target;
};

const useMergeRef = (...refs) => {
  return useCallback(node => refs.forEach(ref => {
    if (ref === null) {
      return;
    }
    if (typeof ref === 'function') {
      ref(node);
      return;
    }
    ref.current = node;
  }), [refs]);
};

/**
 * 콜백을 ref로 변환하여 prop으로 전달될 때 리렌더링을 방지하거나,
 * 의존성으로 전달될 때 재실행하지 않도록 해주는 커스텀 훅입니다.
 */
function useCallbackRef(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(() => (...args) => callbackRef.current?.(...args), []);
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof$1(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$1(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$2 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$3 = formatDistance$2;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative$2 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
};
var formatRelative$3 = formatRelative$2;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues$1 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues$1 = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale$1;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameYear(dirtyDate, Date.now());
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

const ONE_DAY_IN_MINUTES = 60 * 24;
function formatRelativeTime(date, t) {
  const minutesDiff = differenceInMinutes(new Date(), date);
  if (minutesDiff < 1) {
    return t('COMMON__TIMESTAMP_NOW', '방금');
  }
  if (minutesDiff < 60) {
    return `${minutesDiff}${t('COMMON__TIMESTAMP_MINUTE', '분')}`;
  }
  if (minutesDiff < ONE_DAY_IN_MINUTES) {
    const hoursDiff = Math.floor(minutesDiff / 60);
    return `${hoursDiff}${t('COMMON__TIMESTAMP_HOUR', '시간')}`;
  }
  const daysDiff = Math.floor(minutesDiff / ONE_DAY_IN_MINUTES);
  return `${daysDiff}${t('COMMON__TIMESTAMP_DAY', '일')}`;
}
function formatAbsoluteTime(date) {
  return isThisYear(date) ? format(date, 'MM.dd') : format(date, 'yyyy.MM.dd');
}

/**
 * 콘텐츠, 리뷰 등 사용자가 업로드하는 게시물의 실시간성과 신선도를 강조하기 위해 사용됩니다.
 * 클레임, 문의 등 날짜가 중요하고 정확한 정보가 요구되는 영역에서는 사용하지 않습니다.
 * @see https://www.notion.so/ohouse/0d2575f1fd8f4cf5898de6b5b1f77d52?pvs=4
 * @returns 다국어가 적용된 업로드 시간을 반환합니다.
 * 글로벌 환경에서는 react-i18next(next-i18next)가 설치되어 있어야 하고, COMMON 네임스페이스 문서가 필요합니다.
 */
const useUploadTimeFormatter = () => {
  const {
    t
  } = useTranslation('COMMON');
  const formatCreatedAt = createdAt => {
    const createdDate = new Date(createdAt);
    const isMoreThan7Days = differenceInDays(new Date(), createdDate) > 7;
    if (isMoreThan7Days) {
      return formatAbsoluteTime(createdDate);
    }
    return formatRelativeTime(createdDate, t);
  };
  return {
    formatCreatedAt
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ScrapBookCreateForm = ({
  onSubmit
}) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState('');
  if (!editing) {
    return jsx(Container$B, {
      size: "basic",
      variant: "thin",
      children: jsxs(CreateButton, {
        type: "button",
        onClick: () => setEditing(true),
        children: [jsx(IconBox, {
          blue: true,
          children: jsx(Icon$2, {
            name: "add_thick",
            size: 18
          })
        }), jsx(CreateButtonText, {
          children: "\uC0C8\uB85C\uC6B4 \uD3F4\uB354 \uCD94\uAC00\uD558\uAE30"
        })]
      })
    });
  }
  return jsxs(Container$B, {
    size: "basic",
    variant: "thin",
    children: [jsx(IconBox, {
      children: jsx(Icon$2, {
        name: "add_thick",
        size: 18
      })
    }), jsx(Input, {
      placeholder: "\uD3F4\uB354\uBA85\uC744 \uC785\uB825\uD558\uC138\uC694",
      maxLength: 15,
      value: value,
      onChange: e => setValue(e.target.value)
    }), jsx(Button$9, {
      size: 32,
      type: "button",
      variant: "primary1",
      disabled: value.length === 0,
      onClick: () => onSubmit(value),
      children: "\uC644\uB8CC"
    })]
  });
};
const Container$B = /*#__PURE__*/_styled(DividerListItem, process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y4"
} : {
  target: "e1tlor0y4",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "vjnku4",
  styles: "display:flex;align-items:center;width:100%;box-sizing:border-box"
} : {
  name: "vjnku4",
  styles: "display:flex;align-items:center;width:100%;box-sizing:border-box",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1w
});
const CreateButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y3"
} : {
  target: "e1tlor0y3",
  label: "CreateButton"
})("overflow-x:hidden;display:flex;align-items:center;width:100%;padding:0;border:0;box-sizing:border-box;color:", ({
  theme
}) => theme.content.base1, ";background:none;");
const CreateButtonText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y2"
} : {
  target: "e1tlor0y2",
  label: "CreateButtonText"
})("display:inline-block;margin-left:", pxToRem(10), ";font-size:", pxToRem(16), ";font-weight:700;");
const IconBox = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y1"
} : {
  target: "e1tlor0y1",
  label: "IconBox"
})("position:relative;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:", pxToRem(4), ";color:", ({
  theme
}) => theme.content.white, ";background:", ({
  theme,
  blue
}) => blue ? theme.content.primary1.basic : theme.content.base3, ";");
const Input = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "e1tlor0y0"
} : {
  target: "e1tlor0y0",
  label: "Input"
})("flex:1 1 0%;min-width:0;margin:0 ", pxToRem(8), " 0 ", pxToRem(10), ";border:0;color:", ({
  theme
}) => theme.content.base1, ";caret-color:", ({
  theme
}) => theme.content.primary1.basic, ";background:none;font-size:", pxToRem(16), ";&::placeholder{color:", ({
  theme
}) => theme.content.base3, ";}");

const ScrapBookItem = /*#__PURE__*/memo(({
  id,
  name,
  lastImageUrl,
  onSelect
}) => {
  return jsx(DividerListItem, {
    size: "basic",
    variant: "thin",
    children: jsxs(Button$8, {
      type: "button",
      onClick: () => onSelect(id, name),
      children: [jsx(ImageBox$1, {
        children: lastImageUrl && jsx(ResizeImage, {
          src: lastImageUrl,
          intrinsicAspect: 1,
          intrinsicInitialWidth: 40,
          objectFit: "cover"
        })
      }), jsx(ButtonText, {
        children: name
      })]
    })
  });
});
const Button$8 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "etdzwz22"
} : {
  target: "etdzwz22",
  label: "Button"
})("overflow-x:hidden;display:flex;align-items:center;width:100%;padding:0;border:0;box-sizing:border-box;color:", ({
  theme
}) => theme.content.base1, ";background:none;");
const ImageBox$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etdzwz21"
} : {
  target: "etdzwz21",
  label: "ImageBox"
})("position:relative;flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;width:", pxToRem(40), ";height:", pxToRem(40), ";border-radius:", pxToRem(4), ";color:", ({
  theme
}) => theme.content.white, ";background:", ({
  theme
}) => theme.content.base4, ";");
const ButtonText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "etdzwz20"
} : {
  target: "etdzwz20",
  label: "ButtonText"
})("display:inline-block;margin-left:", pxToRem(10), ";font-size:", pxToRem(16), ";");

const ScrapBookSelectModal = ({
  contentIds,
  onClose,
  onClickTo,
  getList,
  create,
  select
}) => {
  const [scrapBooks, setScrapBooks] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedFolder, setSelectedFolder] = useState();
  const {
    open: openSnackbar
  } = useSnackbar();
  const {
    logClickScrapBookTo
  } = useScrapLogger();
  const handleConfirmClick = async () => {
    if (!selectedFolder) {
      return;
    }
    if (contentIds.length === 0) {
      openSnackbar({
        content: '이동할 수 있는 콘텐츠가 없습니다. 잠시 후 다시 시도해주세요.'
      });
      return;
    }
    const {
      id,
      name
    } = selectedFolder;
    try {
      const response = await select(id, contentIds);
      if (!response.success) {
        throw new Error();
      }
      openSnackbar({
        content: `'${name}'폴더로 이동했습니다.`,
        buttons: [{
          children: '스크랩북 보기',
          type: 'button',
          onClick: () => {
            logClickScrapBookTo();
            onClickTo(id);
          }
        }]
      });
      onClose();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      openSnackbar({
        content: error.message || '잠시 후 다시 시도해주세요.'
      });
    }
  };
  const handleSelect = (id, name) => {
    setSelectedFolder({
      id,
      name
    });
  };
  const handleCreate = useCallback(async name => {
    try {
      const response = await create(name);
      if (!response.success) {
        openSnackbar({
          content: '올바른 폴더 이름을 입력해주세요.'
        });
        return;
      }
      handleSelect(response.id, name);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
      openSnackbar({
        content: error.message || '새로운 폴더를 생성하지 못했습니다.'
      });
    }
  }, [create, handleSelect]);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const scrapBooks = await getList();
        setScrapBooks(scrapBooks);
      } catch (error) {
        openSnackbar({
          content: '스크랩북 목록을 가져오지 못했습니다.'
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [getList]);
  return jsxs(Fragment, {
    children: [jsx(Modal, {
      width: 400,
      header: {
        title: '폴더 선택',
        onClose
      },
      onBlur: onClose,
      disableBackgroundScroll: true,
      children: jsxs(ModalBody, {
        children: [jsx(ScrapBookCreateForm, {
          onSubmit: handleCreate
        }), scrapBooks.length === 0 && !isLoading && jsx(EmptyMessage, {
          description: '이동할 폴더가 없습니다.\n새로운 폴더를 만들어보세요.'
        }), scrapBooks.length > 0 && scrapBooks.map(scrapBook => jsx(ScrapBookItem, {
          ...scrapBook,
          onSelect: handleSelect
        }, scrapBook.id))]
      })
    }), selectedFolder?.id && selectedFolder?.name && jsx(Modal, {
      width: 400,
      disableBackgroundScroll: true,
      footer: {
        action: {
          primary: {
            text: '확인',
            onClick: handleConfirmClick
          },
          secondary: {
            text: '취소',
            onClick: () => setSelectedFolder(undefined)
          }
        }
      },
      children: jsx(Content$5, {
        children: `선택한 컨텐츠를 '${selectedFolder.name}'으로 이동하시겠습니까?`
      })
    })]
  });
};
const ModalBody = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eetj5dr2"
} : {
  target: "eetj5dr2",
  label: "ModalBody"
})("overflow-y:auto;height:", pxToRem(446), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("height:", pxToRem(466), ";padding:0 ", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ModalBody;"))), ";");
const EmptyMessage = /*#__PURE__*/_styled(EmptyPage, process.env.NODE_ENV === "production" ? {
  target: "eetj5dr1"
} : {
  target: "eetj5dr1",
  label: "EmptyMessage"
})("margin-top:", pxToRem(100), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("margin-top:", pxToRem(120), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:EmptyMessage;"))), ";");
const Content$5 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eetj5dr0"
} : {
  target: "eetj5dr0",
  label: "Content"
})(FONT_STYLE.body1_1, ";color:", ({
  theme
}) => theme.content.base1, ";padding:16px 16px 10px 16px;text-align:center;word-break:keep-all;white-space:pre-line;");

/* eslint-disable react-hooks/exhaustive-deps */
const Scrap$1 = ({
  contentType,
  contentId,
  initialActive = false,
  initialCount = 0,
  children,
  scrap,
  onScrap,
  unscrap,
  onUnscrap,
  isLoggedIn,
  redirectToLogin,
  onClickScrapBook,
  onClickScrapBookTo,
  getScrapBooks,
  createScrapBook,
  selectScrapBook,
  isGlobal,
  localeData,
  isOwap
}) => {
  const [scrapItem, setScrapItem] = useState({
    active: initialActive,
    count: initialCount
  });
  const [pending, setPending] = useState(false);
  const [isScrapBookSelectModalOpen, setScrapBookSelectModalOpen] = useState(false);
  const {
    open: openSnackBar
  } = useSnackbar();
  const dispatchWebviewEvent = useWebviewEventDispatcher();
  const {
    logScrap,
    logUnScrap,
    logScrapSuccess,
    logUnscrapSuccess,
    logClickScrapBook,
    logClickScrapBookFolder
  } = useScrapLogger();
  useEffect(() => {
    setScrapItem(item => ({
      ...item,
      active: initialActive,
      count: initialCount
    }));
  }, [initialActive, initialCount]);
  const handleScrap = useCallback(async ({
    bucketLogData,
    brazeLogData,
    amplitudeLogData
  }) => {
    if (pending) {
      return;
    }
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    setPending(true);
    logScrap({
      contentType,
      contentId,
      bucketLogData,
      brazeLogData
    });
    try {
      const response = await scrap();
      if (!response.success) {
        throw new Error(response.message);
      }
      setScrapItem({
        id: response.id,
        active: true,
        count: response.count
      });
      openSnackBar({
        content: localeData?.successScrap ?? '스크랩했습니다.',
        buttons: [{
          children: localeData?.goToScrapBookPage ?? '스크랩북 보기',
          type: 'button',
          onClick: () => {
            logClickScrapBook();
            onClickScrapBook();
          }
        }, isGlobal ? {} : {
          children: '폴더에 담기',
          type: 'button',
          onClick: () => {
            setScrapBookSelectModalOpen(true);
            logClickScrapBookFolder();
          }
        }]
      });
      if (isOwap) {
        sendBridgeAction('scrap', {
          eventData: {
            type: 'scrap',
            contentType,
            contentId,
            performed: true,
            count: response.count
          }
        });
      } else {
        dispatchWebviewEvent({
          type: 'scrap',
          contentType,
          contentId,
          performed: true,
          count: response.count
        });
      }
      logScrapSuccess({
        contentType,
        contentId,
        count: response.count,
        amplitudeLogData
      });
      onScrap?.();
    } catch (error) {
      console.error(error);
      openSnackBar({
        content: localeData?.failScrap ?? '스크랩 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.'
      });
    } finally {
      setPending(false);
    }
  }, [pending, contentType, contentId, scrap, onScrap, isLoggedIn, redirectToLogin]);
  const handleUnscrap = useCallback(async ({
    bucketLogData
  }) => {
    if (pending) {
      return;
    }
    if (!isLoggedIn) {
      redirectToLogin();
      return;
    }
    setPending(true);
    logUnScrap({
      contentType,
      contentId,
      bucketLogData
    });
    try {
      const response = await unscrap();
      if (!response.success) {
        throw new Error(response.message);
      }
      setScrapItem({
        active: false,
        count: response.count
      });
      openSnackBar({
        content: localeData?.successUnscrap ?? '스크랩북에서 삭제했습니다.'
      });
      if (isOwap) {
        sendBridgeAction('scrap', {
          eventData: {
            type: 'scrap',
            contentType,
            contentId,
            performed: false,
            count: response.count
          }
        });
      } else {
        dispatchWebviewEvent({
          type: 'scrap',
          contentType,
          contentId,
          performed: false,
          count: response.count
        });
      }
      logUnscrapSuccess({
        contentType,
        contentId
      });
      onUnscrap?.();
    } catch (error) {
      console.error(error);
      openSnackBar({
        content: localeData?.failUnscrap ?? '스크랩북에서 삭제 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.'
      });
    } finally {
      setPending(false);
    }
  }, [pending, contentType, contentId, unscrap, onUnscrap, isLoggedIn, redirectToLogin]);
  const handleToggle = useCallback(({
    scrap
  }) => {
    if (scrapItem.active) {
      return handleUnscrap(scrap);
    }
    return handleScrap(scrap);
  }, [scrapItem.active, handleScrap, handleUnscrap]);
  const handleWebviewScrap = useCallback(event => {
    if (event.contentId !== contentId) {
      return;
    }
    setScrapItem(item => ({
      ...item,
      count: event.count ?? (event.performed ? ++item.count : --item.count),
      active: event.performed,
      pending: false
    }));
  }, [contentId]);
  useWebviewEventListener('scrap', handleWebviewScrap);
  return jsxs(Fragment, {
    children: [children({
      active: scrapItem.active,
      count: scrapItem.count,
      scrap: handleScrap,
      unscrap: handleUnscrap,
      toggle: handleToggle
    }), isScrapBookSelectModalOpen && jsx(ScrapBookSelectModal, {
      contentIds: scrapItem.id ? [scrapItem.id] : [],
      onClose: () => setScrapBookSelectModalOpen(false),
      onClickTo: onClickScrapBookTo,
      getList: getScrapBooks,
      create: createScrapBook,
      select: selectScrapBook
    })]
  });
};

function HOVER(template, ...args) {
  return /*#__PURE__*/css("&.focus-visible:focus{", /*#__PURE__*/css(template, ...args), ";}@media(hover: hover) and (pointer: fine){&:hover,&:active{", /*#__PURE__*/css(template, ...args), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:HOVER;"));
}

function ProductCardScrap({
  scrapData,
  product,
  logData,
  isOwap = false
}) {
  const {
    initialActive,
    initialCount,
    isLoggedIn,
    userId,
    scrap,
    unscrap,
    onScrap,
    onUnscrap,
    createScrapBook,
    selectScrapBook,
    getScrapBooks,
    onClickScrapBook,
    onClickScrapBookTo,
    redirectToLogin,
    onClickScrap
  } = scrapData;
  const getScrapLogData = ({
    bucketLogData
  } = {}) => {
    return {
      bucketLogData,
      brazeLogData: {
        userId: userId || 0,
        productName: product.name
      }
    };
  };
  return jsx(Scrap$1, {
    contentType: product.type ?? 'Production',
    contentId: product.id,
    initialActive: initialActive,
    initialCount: initialCount,
    getScrapBooks: getScrapBooks,
    isLoggedIn: isLoggedIn,
    scrap: scrap,
    unscrap: unscrap,
    onScrap: onScrap,
    onUnscrap: onUnscrap,
    createScrapBook: createScrapBook,
    selectScrapBook: selectScrapBook,
    onClickScrapBook: onClickScrapBook,
    onClickScrapBookTo: onClickScrapBookTo,
    redirectToLogin: redirectToLogin,
    isOwap: isOwap,
    children: ({
      active,
      scrap,
      unscrap
    }) => jsx(ScrapButton$1, {
      name: "scrap",
      size: 24,
      active: active,
      initialActive: active,
      onActive: () => {
        onClickScrap?.();
        scrap({
          ...getScrapLogData({
            bucketLogData: logData
          })
        });
      },
      onInactive: () => unscrap({
        ...getScrapLogData({
          bucketLogData: logData
        })
      })
    })
  });
}
const ScrapButton$1 = /*#__PURE__*/_styled(ToggleButton, process.env.NODE_ENV === "production" ? {
  target: "ena0pzo0"
} : {
  target: "ena0pzo0",
  label: "ScrapButton"
})("position:absolute;bottom:4px;right:4px;z-index:10;", HOVER`
    opacity: 0.5;
  `, ";");

const Scrap = ProductCardScrap;

function _EMOTION_STRINGIFIED_CSS_ERROR__$1v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TodayDealBadge = () => {
  return jsx(Root, {
    children: jsx(Badge$1, {
      children: "\uC624\uB298\uC758\uB51C"
    })
  });
};
const Root = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1cecsro1"
} : {
  target: "e1cecsro1",
  label: "Root"
})(process.env.NODE_ENV === "production" ? {
  name: "dnsd85",
  styles: "position:relative;top:0;left:0;z-index:1"
} : {
  name: "dnsd85",
  styles: "position:relative;top:0;left:0;z-index:1",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1v
});
const Badge$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1cecsro0"
} : {
  target: "e1cecsro0",
  label: "Badge"
})(({
  theme
}) => /*#__PURE__*/css("position:absolute;top:0;left:0;padding:5px 8px;border-radius:4px 0 4px 0;", FONT_STYLE.detail13L18, ";font-weight:600;color:", theme.content.white, ";background-color:", theme.content.primary2.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Badge;")));

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Amount: Amount$2,
  CheapestPriceIcon: CheapestPriceIcon,
  ChipList: ChipList$1,
  CommerceDeliveryStartAt: CommerceDeliveryStartAt,
  Container: Container$F,
  Content: Content$7,
  DepartureTodayIcon: DepartureTodayIcon$1,
  DiscontinuedIcon: DiscontinuedIcon,
  FreeDeliveryIcon: FreeDeliveryIcon,
  IconWithTextBadge: IconWithTextBadge$1,
  LogClick: LogClick,
  NonSellingIcon: NonSellingIcon,
  OhouseDeliveryIcon: OhouseDeliveryIcon$1,
  OverseasPurchaseIcon: OverseasPurchaseIcon,
  Price: Price$1,
  PriceToken: PriceToken,
  Rate: Rate$2,
  Root: Root$3,
  Scrap: Scrap,
  SoldOutBanner: SoldOutBanner$1,
  Stats: Stats$1,
  TextList: TextList,
  ThirdPartyApplianceIcon: ThirdPartyApplianceIcon$1,
  ThirdPartyFurnitureIcon: ThirdPartyFurnitureIcon$1,
  Thumbnail: Thumbnail$3,
  ThumbnailBadge: ThumbnailBadge$1,
  TodayDealBadge: TodayDealBadge,
  ViewProductCard: ViewProductCard
});

/**
 * 뱃지 관련 로그 데이터 가공을 위한 hooks
 */
function useProductCardLogData({
  product,
  badgeMaxCount
}) {
  const {
    benefitBadges,
    couponBadge,
    deliveryServiceCode,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    isSoldOut,
    isSelling,
    isDiscontinued,
    price
  } = product;
  const badgeLogData = useMemo(() => {
    const initialData = {
      isOverseasPurchase,
      isFreeDelivery,
      isSpecialPrice
    };
    if (isDiscontinued || !isSelling) {
      return {};
    }
    if (badgeMaxCount != null && Object.values(initialData).filter(val => !!val).length > badgeMaxCount) {
      return Object.keys(initialData).filter(val => !!val).slice(0, badgeMaxCount).reduce((acc, cur) => ({
        ...acc,
        [cur]: initialData[cur]
      }), {});
    }
    return initialData;
  }, [badgeMaxCount, isDiscontinued, isSelling, isOverseasPurchase, isFreeDelivery, isSpecialPrice]);
  const {
    regularPrice,
    sellingPrice,
    salePrice,
    discountPlans
  } = price ?? {};
  const hasInstantDiscount = discountPlans?.[0]?.planType === 'INSTANT_DISCOUNT';
  const instantDiscountPrice = Number(salePrice) - (hasInstantDiscount ? Number(discountPlans?.[0]?.discountAmount) : 0);
  const _detailLogData = {
    delivery_service_code: deliveryServiceCode,
    is_overseas_purchase: badgeLogData['isOverseasPurchase'] ?? false,
    is_free_delivery: badgeLogData['isFreeDelivery'] ?? false,
    is_special_price: badgeLogData['isSpecialPrice'] ?? false,
    is_soldout: isSoldOut,
    is_discontinued: isDiscontinued,
    is_selling: isSelling,
    coupon_badge: couponBadge != null ? {
      fixed_discount_amount: couponBadge?.fixedDiscountAmount,
      discount_ratio: Math.round(Number(couponBadge?.discountRatio ?? '0') * 100),
      display_text: couponBadge?.title
    } : undefined,
    card_promotion: benefitBadges?.[0] != null ? {
      fixed_discount_amount: benefitBadges?.[0]?.fixedDiscountAmount,
      discount_ratio: benefitBadges?.[0]?.discountRatio,
      display_text: benefitBadges?.[0]?.title,
      promotion_payment_method: benefitBadges?.[0]?.promotionPaymentMethod
    } : undefined,
    instant_discount_text_display: false,
    ...(hasInstantDiscount && {
      instant_discount_id: discountPlans?.[0]?.planId,
      instant_discount: {
        fixed_discount_amount: discountPlans?.[0]?.discountAmount ?? null,
        discount_ratio: null
      },
      instant_discount_price: instantDiscountPrice ?? null
    }),
    regular_price: regularPrice ?? null,
    sale_price: salePrice ?? null,
    selling_price: sellingPrice ?? null
  };
  const detailLogData = Object.fromEntries(Object.entries(_detailLogData).filter(([_, v]) => v != null));
  return {
    detailLogData
  };
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (typeof arg !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

function PlaceholderAnimation(props) {
  const {
    children,
    className
  } = props;
  return jsx(Container$A, {
    className: className,
    children: children
  });
}
const keyframesPlaceholderAnimation = keyframes`
  0% {
    transform: translate3d(-30%, 0, 0);
  }
  100% {
    transform: translate3d(30%, 0, 0);
  }
`;
const Container$A = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2uolej0"
} : {
  target: "e2uolej0",
  label: "Container"
})("position:relative;display:block;overflow:hidden;", ({
  theme
}) => /*#__PURE__*/css("color:", theme.content.base5, ";background-color:", theme.content.base5, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")), " &:after{content:'\\00a0';position:absolute;top:0;right:0;bottom:0;left:50%;z-index:1;width:500%;margin-left:-250%;animation:", keyframesPlaceholderAnimation, " 0.8s linear infinite;background:linear-gradient(to right,\n      rgba(255, 255, 255, 0) 44%,\n      rgba(255, 255, 255, .35) 50%,\n      rgba(255, 255, 255, 0) 56%) 50% 50%;}");

const KAKAO_TEMPLATE_ID = {
  INVITE_FRIEND: 55328,
  PROJECT: 7230,
  CARD: 7231,
  ADVICE: 7281,
  SELLING_PRODUCT: 7282,
  NOT_SELLING_PRODUCT: 7286,
  /** 상품4개인 기획전 */
  EXHIBITION: 7289,
  /** 상품없는 기획전 */
  NO_PRODUCT_EXHIBITION: 96825,
  MY_HOME: 7325,
  QUESTION: 8237,
  CONTEST: 7331,
  SCRAP_BOOK: 9425,
  TODAY_PRODUCT: 12318,
  COMMON: 35477,
  COMMON_BUTTON_TEXT_CUSTOM: 77289,
  /** 브랜드 홈 */
  BRAND_HOME: 115214
};

function getBrandHomeKakaoTemplate({
  brandId,
  brandName,
  thumbnail
}) {
  return {
    templateId: KAKAO_TEMPLATE_ID.BRAND_HOME,
    templateArgs: {
      brandId,
      brandName,
      thumbnail
    }
  };
}

/**
 * 상품쿠폰으로 인한 할인금액 계산
 * @param price 상품가격
 * @param mold 상품쿠폰틀
 * @returns 할인금액
 * @example
 * ```
 * getDiscountPrice(10000, {
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * });
 * ```
 */
const getDiscountPrice = (price, mold) => {
  const {
    discountType,
    discountRate = 0
  } = mold;
  const discountAmount = Number.parseInt(mold.discountAmount ?? '0', 10);
  const maxDiscountAmount = Number.parseInt(mold.maxDiscountAmount ?? '0', 10);

  // 정률일경우
  if (discountType === 'FIXED_RATE') {
    return Math.min(price * discountRate, maxDiscountAmount);
  }

  // 정액일경우
  return Math.min(discountAmount, price);
};

/**
 * 할인금액이 가장 큰 쿠폰틀 계산
 * @param price 상품가격
 * @param molds 상품에 적용 가능한 쿠폰틀 리스트
 * @retuns 할인금액 가장 큰 쿠폰틀
 * @example
 * ```
 * getMaxDiscountCouponMold(1000, [{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * }]);
 * ```
 */

const getMaxDiscountCouponMold = (price, molds) => {
  if (!molds.length) {
    return;
  }
  return molds.reduce((prev, curr) => {
    const prevDiscountPrice = getDiscountPrice(price, prev);
    const currDiscountPrice = getDiscountPrice(price, curr);
    return prevDiscountPrice > currDiscountPrice ? prev : curr;
  });
};

/**
 * 최소주문금액이 가장 작은 쿠폰틀 계산
 * @param molds 쿠폰틀 리스트
 * @returns 최소주문금액이 가장 작은 쿠폰틀
 * @example
 * ```
 * getMinBaseAmountCouponMold([{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * }, {
 *   title: '(연지) Order + 정률 20% 쿠폰',
 *   discountType: 'FIXED_RATE',
 *   couponType: 'GOODS',
 *   discountRate: 0.2,
 *   minBaseAmount: '500',
 *   maxDiscountAmount: '20000',
 * }]);
 * ```
 */
const getMinBaseAmountCouponMold = molds => {
  if (!molds.length) {
    return;
  }
  return molds.reduce((prev, curr) => {
    const prevMinBaseAmount = Number.parseInt(prev.minBaseAmount, 10);
    const currMinBaseAmount = Number.parseInt(curr.minBaseAmount, 10);
    return prevMinBaseAmount > currMinBaseAmount ? curr : prev;
  });
};

/**
 * 상품카드에 노출되는 상품쿠폰
 * @param sellingPrice 판매가
 * @param goodsCouponMolds 상품쿠폰 리스트
 * @returns 상품카드에 노출되는 상품쿠폰
 * @example
 * ```
 * getCouponBadge('50', [{
 *   title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *   discountType: 'FIXED_AMOUNT',
 *   couponType: 'GOODS',
 *   discountAmount: '5500',
 *   minBaseAmount: '100',
 * },
 * {
 *   title: '(연지) Order + 정률 20% 쿠폰',
 *   discountType: 'FIXED_RATE',
 *   couponType: 'GOODS',
 *   discountRate: 0.2,
 *   minBaseAmount: '500',
 *   maxDiscountAmount: '20000',
 * }]);
 * ```
 */
function getCouponBadge(sellingPrice, goodsCouponMolds) {
  if (!goodsCouponMolds.length) {
    return;
  }
  const price = Number.parseInt(sellingPrice, 10);

  // 최소주문금액이 가장 작은 쿠폰틀
  const minBaseAmountCouponMold = getMinBaseAmountCouponMold(goodsCouponMolds);
  const minBaseAmount = Number.parseInt(minBaseAmountCouponMold?.minBaseAmount ?? '0', 10);
  if (price > minBaseAmount) {
    // sellingPrice가 최소주문금액보다 클경우 할인금액이 가장 큰 쿠폰틀
    return getMaxDiscountCouponMold(price, goodsCouponMolds);
  } else {
    // sellingPrice가 최소주문금액보다 작을경우 최소주문금액이 가장 작은 쿠폰틀
    return minBaseAmountCouponMold;
  }
}

const THOUSAND_MATCH_REGX = /^((\d)[0]{3})$/;
const MILLION_MATCH_REGX = /(\d{1,})[0]{4}/;

/**
 * 상품카드 내 할인가격을 규칙에 맞게 노출합니다.
 * e.g) 100 -> 100원, 1000원 -> 1천원, 10000원 -> 1만원
 * @param number 할인가격
 * @returns 규칙이 적용된 할인가격
 * @example
 * ```
 * getShortenPrice(1000)
 * 1천원
 * ```
 */
const getShortenPrice = amount => {
  const strAmount = amount.toString();
  if (THOUSAND_MATCH_REGX.test(strAmount)) {
    return strAmount.replace('000', '천원');
  }
  if (MILLION_MATCH_REGX.test(strAmount)) {
    return `${formatComma(amount / 10000)}만원`;
  }
  return `${formatComma(amount)}원`;
};

/**
 * 상품카드에 노출되는 상품쿠폰 뱃지 텍스트
 * e.g) 할인쿠폰, 최대 10% 할인, 최대 10,000원 할인
 * @param goodsCouponMold 상품쿠폰틀
 * @param isLoggedIn 로그인 유무
 * @returns 상품쿠폰 뱃지 텍스트
 * @example
 * ```
 * getCouponBadgeTitle({
 *  title: '(연지) claim_재발행 + 고정만료 5,500원 쿠폰',
 *  discountType: 'FIXED_AMOUNT',
 *  couponType: 'GOODS',
 *  discountAmount: '5500',
 *  minBaseAmount: '100',
 *}, true);
 * ```
 */
const getCouponBadgeTitle = (goodsCouponMold, isLoggedIn) => {
  if (!isLoggedIn) {
    return '할인쿠폰';
  }
  if (goodsCouponMold.discountType === 'FIXED_RATE') {
    return `최대 ${Math.round((goodsCouponMold.discountRate ?? 0) * 100)}% 할인`;
  }
  const maxDiscountAmount = Number.parseInt(goodsCouponMold.maxDiscountAmount ?? '0', 10);
  const discountAmount = Number.parseInt(goodsCouponMold.discountAmount ?? '0', 10);
  const discountPrice = maxDiscountAmount > 0 ? Math.min(maxDiscountAmount, discountAmount) : discountAmount;
  const shortPrice = getShortenPrice(discountPrice);
  return `최대 ${shortPrice} 할인`;
};

/** 사용자에게 노출되는 메시지를 커스텀합니다. */
const CUSTOM_COUPON_PUBLISH_MESSAGE = {
  SUCCESS: '쿠폰이 발급되었습니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.',
  PART_SUCCESS: '발급 불가 쿠폰을 제외하고 발급되었습니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.',
  ERROR: '쿠폰 발급이 마감됐습니다.',
  DONE: '이미 발급된 쿠폰입니다. 발급된 쿠폰은 주문서에 자동 적용됩니다.'
};
const COUPON_PUBLISH_DONE_MESSAGE = '이미 발급된 쿠폰입니다.';
let CouponErrorCode = /*#__PURE__*/function (CouponErrorCode) {
  CouponErrorCode["COUPON_PUBLISH_LIMIT_EXCEED"] = "ERROR-COUPON-2006";
  CouponErrorCode["COUPON_PUBLISH_END"] = "ERROR-COUPON-2007";
  CouponErrorCode["COUPON_PUBLISH_NOT_AVAILABLE"] = "ERROR-COUPON-2008";
  CouponErrorCode["COUPON_PUBLISH_NOT_RANDOM"] = "ERROR-COUPON-2009";
  CouponErrorCode["COUPON_RANDOM_NOT_FOUND"] = "ERROR-COUPON-4016";
  CouponErrorCode["COUPON_ALREADY_RECEIVED"] = "ERROR-COUPON-4017";
  return CouponErrorCode;
}({});
/**
 * publish_coupons의 결과값들을 상태별로 분류
 * @param coupons publish_coupons의 response
 * @returns publish_coupons 의 status (성공, 실패, 이미발급)
 */
const getPublishCartCouponStatus = coupons => {
  return coupons.reduce((acc, coupon) => {
    const {
      success,
      message
    } = coupon;
    if (success) {
      return {
        ...acc,
        success: acc.success.concat(coupon)
      };
    }
    if (message === COUPON_PUBLISH_DONE_MESSAGE) {
      return {
        ...acc,
        done: acc.done.concat(coupon)
      };
    }
    return {
      ...acc,
      errors: acc.errors.concat(coupon)
    };
  }, {
    errors: [],
    success: [],
    done: []
  });
};
const getPublishProductCouponStatus = coupons => {
  return coupons.reduce((acc, coupon) => {
    if ('response' in coupon) {
      const success = coupon.response?.map(coupon => coupon) ?? [];
      return {
        ...acc,
        success: acc.success.concat(success)
      };
    }
    const {
      message
    } = coupon;
    if (message === COUPON_PUBLISH_DONE_MESSAGE) {
      return {
        ...acc,
        done: acc.done.concat(coupon)
      };
    }
    return {
      ...acc,
      errors: acc.errors.concat(coupon)
    };
  }, {
    errors: [],
    success: [],
    done: []
  });
};

/**
 * 쿠폰팩 메시지 헨들링
 * @see {@link https://wiki.dailyhou.se/x/GP_0Bw}
 */
const getCouponsPublishMessage = (cartCoupons, productCoupons) => {
  const {
    success: cartSuccess,
    done: cartDone,
    errors: cartErrors
  } = getPublishCartCouponStatus(cartCoupons);
  const {
    success: productSuccess,
    done: productDone,
    errors: productErrors
  } = getPublishProductCouponStatus(productCoupons);
  const coupons = [...cartCoupons, ...productCoupons];
  const success = [...cartSuccess, ...productSuccess];
  const done = [...cartDone, ...productDone];
  const errors = [...cartErrors, ...productErrors];

  // 전부 이미 받음
  if (coupons.length === done.length) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.DONE;
  }
  // 발급 성공 & 발급 실패
  if (success.length > 0 && errors.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.PART_SUCCESS;
  }
  // 발급 성공 & 발급 완료
  if (success.length > 0 && done.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.PART_SUCCESS;
  }
  // 발급 성공
  if (success.length > 0) {
    return CUSTOM_COUPON_PUBLISH_MESSAGE.SUCCESS;
  }
  // 전부 실패
  const hasSameError = errors.every(({
    message
  }) => message === errors[0]?.message);
  const errorMessage = hasSameError && errors[0]?.message ? errors[0].message : CUSTOM_COUPON_PUBLISH_MESSAGE.ERROR;
  return errorMessage;
};

/** 쿠폰 발급 메시지 헨들링 */
const getPublishCouponsMessage = coupons => {
  const successCoupons = coupons.filter(coupon => coupon.isSuccess);
  const errorCoupons = coupons.filter(coupon => !coupon.isSuccess);
  const doneCoupons = errorCoupons.filter(coupon => coupon.failReasonCode === CouponErrorCode.COUPON_PUBLISH_LIMIT_EXCEED);
  let message = '';

  // 전부 이미 받음
  if (coupons.length === doneCoupons.length) {
    message = CUSTOM_COUPON_PUBLISH_MESSAGE.DONE;
  } else if (successCoupons.length > 0 && errorCoupons.length > 0) {
    // 발급 성공 & 발급 실패
    message = CUSTOM_COUPON_PUBLISH_MESSAGE.PART_SUCCESS;
  } else if (successCoupons.length > 0 && doneCoupons.length > 0) {
    // 발급 성공 & 발급 완료
    message = CUSTOM_COUPON_PUBLISH_MESSAGE.PART_SUCCESS;
  } else if (successCoupons.length > 0) {
    // 발급 성공
    message = CUSTOM_COUPON_PUBLISH_MESSAGE.SUCCESS;
  } else {
    // 전부 실패
    const hasSameError = errorCoupons.every(coupon => coupon.failReasonMessage === errorCoupons[0]?.failReasonMessage);
    message = hasSameError && errorCoupons[0]?.failReasonMessage ? errorCoupons[0].failReasonMessage : CUSTOM_COUPON_PUBLISH_MESSAGE.ERROR;
  }
  return message;
};

/**
 * 기획전 카카오 템플릿
 * @param exhibitionId 기획전 ID
 * @param title 기획전 제목
 * @param coverImageUrls 기획전 커버 이미지
 * @param products 상품 리스트
 * @returns 카카오 템플릿
 */
const getExhibitionKakaoTemplate = ({
  exhibitionId,
  title,
  coverImageUrls,
  products
}) => {
  const hasMoreThreeFormattedProducts = products && products.length > 3;
  const templateId = hasMoreThreeFormattedProducts ? KAKAO_TEMPLATE_ID.EXHIBITION : KAKAO_TEMPLATE_ID.NO_PRODUCT_EXHIBITION;
  if (hasMoreThreeFormattedProducts) {
    return {
      templateId,
      templateArgs: {
        exhibitionId,
        title,
        coverImgUrl: coverImageUrls[0],
        product0ImgUrl: products[0]?.originalImageUrl,
        product0Name: products[0]?.name,
        product0Id: products[0]?.id,
        product0CostInfo: products[0]?.sellingPrice,
        product1ImgUrl: products[1]?.originalImageUrl,
        product1Name: products[1]?.name,
        product1Id: products[1]?.id,
        product1CostInfo: products[1]?.sellingPrice,
        product2ImgUrl: products[2]?.originalImageUrl,
        product2Name: products[2]?.name,
        product2Id: products[2]?.id,
        product2CostInfo: products[2]?.sellingPrice,
        product3ImgUrl: products[3]?.originalImageUrl,
        product3Name: products[3]?.name,
        product3Id: products[3]?.id,
        product3CostInfo: products[3]?.sellingPrice
      }
    };
  }
  return {
    templateId,
    templateArgs: {
      exhibitionId,
      title,
      coverImgUrl: coverImageUrls[0]
    }
  };
};

/**
 * 카드 프로모션 중 가장 혜택 좋은 프로모션을 추출합니다. (내부에서만 사용)
 * @param cardPromotions 카드 프로모션 리스트
 * @param sellingPrice 판매가격
 * @returns 가장 혜택 좋은 카드 프로모션
 */
const getBestCardPromotion = (cardPromotions, sellingPrice) => {
  const bestPromotion = (cardPromotions ?? []).reduce((acc, promotion) => {
    const {
      discountType,
      discountRate,
      discountAmount,
      maximumDiscountAmount
    } = promotion;
    let bestPromotion = acc;
    if (!sellingPrice) {
      return promotion;
    }

    // 정률 혜택
    if (discountType === 'FIXED_RATE') {
      const discountAmount = Math.ceil(Number(sellingPrice) * ((discountRate ?? 1) / 100));
      bestPromotion = {
        ...promotion,
        bestPrice: Number(sellingPrice) - Math.min(Number(maximumDiscountAmount) ?? 1, discountAmount)
      };
    }
    if (discountType === 'FIXED_AMOUNT') {
      bestPromotion = {
        ...promotion,
        bestPrice: discountAmount ? Number(sellingPrice) - discountAmount : undefined
      };
    }
    if (acc.bestPrice && bestPromotion.bestPrice) {
      return acc.bestPrice < bestPromotion.bestPrice ? acc : bestPromotion;
    }
    return bestPromotion;
  }, {});
  return bestPromotion;
};

/**
 * 카드 프로모션 타이틀을 추출합니다. (내부에서만 사용)
 * @param cardPromotion 카드 프로모션
 * @returns 정액 / 정률 결제할인
 */
const getCardPromotionTitle = cardPromotion => {
  const {
    discountType,
    discountRate,
    discountAmount
  } = cardPromotion;
  if (discountType === 'FIXED_RATE') {
    return `최대 ${discountRate}% 결제할인`;
  }
  if (discountType === 'FIXED_AMOUNT') {
    return `최대 ${discountAmount}원 결제할인`;
  }
  return undefined;
};

/**
 * 카드 프로모션을 나타낼 badge를 추출합니다.
 * @param cardPromotions 카드 프로모션 리스트
 * @param sellingPrice 판매자
 * @returns 카드 프로모션 badge 리스트
 * @example
 * ```
 * getCardPromotionBadges([
 *   {
 *     cardName: '페이코',
 *     discountType: 'FIXED_RATE',
 *     discountRate: 20,
 *     minimumApplyPrice: '1000',
 *     maximumDiscountAmount: '30000',
 *     promotionPaymentMethod: 'PAYCO',
 *   },
 *   {
 *     cardName: 'KB국민',
 *     discountType: 'FIXED_RATE',
 *     discountRate: 10,
 *     minimumApplyPrice: '10',
 *     maximumDiscountAmount: '10000',
 *     promotionPaymentMethod: 'CREDIT_CARD',
 *   }),
 *   '24500'
 *  )
 * ```
 */
const getCardPromotionBadges = (cardPromotions, sellingPrice) => {
  const cardPromotion = getBestCardPromotion(cardPromotions, sellingPrice);
  const promotionTitle = getCardPromotionTitle(cardPromotion);
  return promotionTitle ? [{
    ozipTitle: '',
    image: 'https://image.ohousecdn.com/i/bucketplace-v2-development/static/productions/card-promotion-v2.png',
    title: promotionTitle,
    discountRatio: cardPromotion.discountRate?.toString(),
    fixedDiscountAmount: cardPromotion.discountAmount?.toString()
  }] : undefined;
};

/**
 * @bucketplace/contents-ui의 Scrap 컴포넌트를 사용하기 위한 헬퍼 함수
 * refs
 *  - https://github.com/bucketplace/contents-web-common/blob/main/packages/ui/src/stories/Scrap/README.stories.mdx
 *  - https://www.notion.so/Scrap-16df6cb18a93435eb513d20b6b32d9f0
 *
 * @param {CreateProductScrapDataProps}
 * @returns {ScrapData}
 */
function createProductScrapData({
  product,
  active,
  count,
  userId,
  scrappedFrom,
  onScrap,
  onUnscrap,
  onCreateScrap,
  onDeleteScrap,
  onCreateCollectionBook,
  onMoveCollectionBookItemList,
  onClickScrapBook,
  onClickScrapBookTo,
  getCollectionBookList,
  redirectToLogin,
  onClickScrap
}) {
  const isLoggedIn = userId != null;
  // contents-ui 옮길 때 ScrapResponse 로 적용
  const handleScrap = async () => {
    const {
      success,
      collectionId,
      collectCount,
      message
    } = await onCreateScrap({
      type: product.type ?? 'Production',
      id: product.id
    });
    if (success) {
      return {
        success: true,
        id: collectionId ?? -1,
        count: collectCount ?? 0
      };
    }
    return {
      success: false,
      message
    };
  };
  // contents-ui 옮길 때 UnscrapResponse 로 적용
  const handleDeleteScrap = async () => {
    const {
      success,
      collectCount,
      message
    } = await onDeleteScrap({
      type: product.type ?? 'Production',
      id: product.id
    });
    if (success) {
      return {
        success: true,
        count: collectCount ?? 0
      };
    }
    return {
      success: false,
      message
    };
  };
  // contents-ui 옮길 때 CreateScrapBookResponse 로 적용
  const handleCreateScrapBook = async name => {
    const {
      success,
      id
    } = await onCreateCollectionBook({
      name
    });
    return {
      success,
      id
    };
  };
  const handleSelectScrapBook = async (scrapBookId, contentIds) => {
    // contents-ui 옮길 때 SelectScrapBookResponse 로 적용
    const {
      success
    } = await onMoveCollectionBookItemList({
      collectionBookId: scrapBookId,
      ids: contentIds // FIXME: remove Type assertion
    });
    return {
      success
    };
  };
  const handleGetScrapBookList = async () => {
    const {
      collectionBooks
    } = await getCollectionBookList();
    return collectionBooks ?? [];
  };
  return {
    contentType: product.type ?? 'Production',
    contentId: product.id,
    initialActive: active,
    initialCount: count,
    isLoggedIn,
    scrappedFrom,
    onScrap,
    onUnscrap,
    scrap: handleScrap,
    unscrap: handleDeleteScrap,
    createScrapBook: handleCreateScrapBook,
    selectScrapBook: handleSelectScrapBook,
    getScrapBooks: handleGetScrapBookList,
    onClickScrapBook,
    onClickScrapBookTo,
    redirectToLogin,
    onClickScrap
  };
}

/**
 * ThumbnailBadge를 Badge 타입으로 반환합니다.
 * @param thumbnailBadges 썸네일 뱃지
 * @returns 뱃지
 * @example
 * ```
 * convertThumbnailBadgeToBadge([{
 *  position: 2,
 *  imageUrl: 'https://image.ohousecdn.com/i/bucketplace-v2-development/uploads/admins/thumbnail_badges/162817329513046453.png',
 * }])
 * ```
 */
function convertThumbnailBadgeToBadge(thumbnailBadges) {
  return thumbnailBadges?.map(badge => ({
    id: Math.random() * 0x4FFFF | 0,
    thumbnailBadgeId: 0,
    position: badge.position,
    image: {
      url: badge.imageUrl,
      width: null,
      height: null
    }
  })) ?? [];
}

/**
 * convertGoodsToProduct, convertDealToProduct에서 default로 넣는 deprecated fields
 */
const DEPRECATED_FIELDS = {
  usedCardCount: 0,
  viewCount: 0,
  isDepartureTodayExp: 'A',
  isDiscounted: false,
  isRetailDelivery: false,
  isThirdPartyLogistic: false,
  status: 0,
  deliveryType: 0,
  userId: 0,
  isHidden: false,
  isDeliveryDateSpecified: false,
  isBuyable: true,
  isConsultable: false,
  isRemodel: false,
  weekRank: 0
};

/**
 * 상품 아이템을 Product 형태로 전환하는 함수
 * @param goods 상품 아이템
 * @param isScrap 스크랩 유무
 * @param showCouponBadge 쿠폰 뱃지 유무
 * @param showCouponAppliedPrice 쿠폰 적용가 유무
 * @returns 상품
 */
const convertGoodsToProduct = ({
  goods,
  showCouponBadge,
  showCouponAppliedPrice = false,
  isLoggedIn
}) => {
  const goodsCouponMold = getCouponBadge(goods?.price?.sellingPrice ?? '0', goods?.additionalProperties?.goodsCouponMold ?? []);
  const isDepartureToday = goods?.additionalProperties?.departureToday?.[0]?.status === 'ENABLED';
  const deadline = goods?.delivery?.policy?.releasePolicy?.orderDeadline ?? '';

  // 정률 할인
  const maxDiscountAmount = Number.parseInt(goodsCouponMold?.maxDiscountAmount ?? '0', 10);
  // 정액 할인
  const minBaseAmount = Number.parseInt(goodsCouponMold?.minBaseAmount ?? '0', 10);
  const discountAmount = Number.parseInt(goodsCouponMold?.discountAmount ?? '0', 10);
  const sellingPrice = Number.parseInt(goods?.price?.sellingPrice ?? '0', 10);

  // 정률 할인의 경우 최대할인가와 비교하여 최소값 반환
  const getFixedRateDiscountPrice = () => {
    // 정률 할인가
    const fixedRateDiscountPrice = Math.ceil(sellingPrice * (goodsCouponMold?.discountRate ?? 0));
    return maxDiscountAmount === 0 ? fixedRateDiscountPrice : Math.min(fixedRateDiscountPrice, maxDiscountAmount);
  };

  // 최소 주문금액 만족 여부
  const canCouponAppliedPrice = sellingPrice >= minBaseAmount;

  // 쿠폰할인가
  const discountPrice = goodsCouponMold?.discountType === 'FIXED_RATE' ? getFixedRateDiscountPrice() : discountAmount;
  return {
    ...DEPRECATED_FIELDS,
    type: 'Production',
    id: Number.parseInt(goods?.id ?? '0', 10),
    name: goods?.name ?? '',
    reviewAvg: goods?.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: goods?.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: Number.parseInt(goods?.price?.sellingPrice ?? '0', 10),
    originalPrice: Number.parseInt(goods?.price?.originalPrice ?? '0', 10),
    originalImageUrl: goods?.imageUrl ?? '',
    brand: goods?.brand ?? {
      id: 0,
      name: ''
    },
    badges: convertThumbnailBadgeToBadge(goods?.additionalProperties?.thumbnailBadges),
    deliveryStartAt: isDepartureToday && deadline ? {
      template: {
        text: '평일 %s까지 결제시',
        values: [deadline]
      }
    } : undefined,
    deliveryServiceCode: goods?.delivery?.serviceCode ?? 'NONE',
    isDepartureToday,
    isSpecialPrice: goods?.price?.isSpecialPrice ?? false,
    isSelling: goods?.isSelling ?? true,
    isSoldOut: goods?.isSoldOut ?? false,
    isDiscontinued: goods?.isDiscontinued ?? false,
    isFreeDelivery: goods?.delivery?.isFree ?? false,
    isOverseasPurchase: goods?.isOverseasPurchase ?? false,
    couponBadge: goodsCouponMold && showCouponBadge ? {
      title: getCouponBadgeTitle(goodsCouponMold, isLoggedIn ?? false),
      image: 'https://image.ohousecdn.com/i/bucketplace-v2-development/static/productions/goods-coupon-badge.png',
      discountRatio: goodsCouponMold.discountRate ? goodsCouponMold.discountRate.toString() : '',
      fixedDiscountAmount: goodsCouponMold.discountAmount,
      couponAppliedPrice: goodsCouponMold && showCouponAppliedPrice && canCouponAppliedPrice ? Math.max(sellingPrice - discountPrice, 0) : undefined
    } : undefined,
    benefitBadges: getCardPromotionBadges(goods?.additionalProperties?.cardPromotions, goods?.price?.sellingPrice),
    isScrap: goods?.isScrap ?? false,
    scrapCount: goods?.scrapCount ?? 0,
    price: goods?.price
  };
};

/** 브랜드 */

/** 뱃지 */

/** 쿠폰 뱃지 */

/** 카드 할인 혜택 뱃지 */

/** 가격 정보 */

/** 즉시할인 정보 */

const DELIVERY_PAYMENT = {
  /** 무료 */
  FREE: 'FREE',
  /** 조건부 무료 */
  CONDITIONAL_FREE: 'CONDITIONAL_FREE',
  /** 유료 */
  CHARGE: 'CHARGE'
};
const DELIVERY_SERVICE_CODE = {
  /** 일반 택배 */
  NORMAL: 'NORMAL',
  /** 판매자 직접 배송 */
  SELLER: 'SELLER',
  /** 화물택배 */
  CARGO: 'CARGO',
  /** 오늘의집 배송 */
  OHOUSE: 'OHOUSE',
  /** 빠른가전 배송 */
  THIRD_PARTY: 'THIRD_PARTY',
  /** 미노출 */
  NONE: 'NONE',
  /** 빠른가전배송 */
  THIRD_PARTY_APPLIANCE: 'THIRD_PARTY_APPLIANCE',
  /** 빠른가구배송 */
  THIRD_PARTY_FURNITURE: 'THIRD_PARTY_FURNITURE'
};

/** 배송비 유형 */

/** 배송 유형 */

/**
 * @type sm : name -> caption1, price -> caption1
 * @type md : name -> caption1, price -> subTitle2
 * @type lg : name -> subTitle2, price -> title3
 */

const STORE_ITEM_TYPE = {
  /** 상품 */
  GOODS: 'Goods',
  /** 모음전 */
  DEAL: 'Deal'
};

/** 'Goods' 와 'Deal' 에서 동일하게 사용하는 필드들입니다. */

/** type = 'Goods' 일때만 값을 가집니다. */

/** 굿스플로 상세 정보 */

/** 굿스플로 상세 정보 목록 */

/** 배송 조회 타입 - 배송중, 수거중, 재배송중 */
const DELIVERY_TARGET_TYPE = {
  ORDER: 'ORDER',
  PICKUP: 'PICKUP',
  REDELIVERY: 'REDELIVERY'
};
/** 배송  상태 */
const DELIVERY_TRACKING_STATUS = {
  READY: 'READY',
  SCHEDULED: 'SCHEDULED',
  INPROGRESS: 'INPROGRESS',
  COMPLETE: 'COMPLETE'
};
/** 배송방식 */
const SHIPMENT_TYPE = {
  NORMAL: 'NORMAL',
  SELLER: 'SELLER',
  CARGO: 'CARGO',
  OHOUSE: 'OHOUSE',
  THIRD_PARTY: 'THIRD_PARTY'
};

/**
 * 모음전 아이템을 Product 형태로 전환하는 함수
 * @param deal 모음전 아이템
 * @param isScrap 스크랩 유무
 * @returns 상품
 */
const convertDealToProduct = deal => {
  return {
    ...DEPRECATED_FIELDS,
    type: 'Deal',
    id: Number.parseInt(deal?.id ?? '0', 10),
    name: deal?.name ?? '',
    reviewAvg: deal?.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: deal?.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: Number.parseInt(deal?.price?.representativeSellingPrice ?? '0', 10),
    originalPrice: Number.parseInt(deal?.price?.representativeOriginalPrice ?? '0', 10),
    originalImageUrl: deal?.imageUrl ?? '',
    brand: deal?.brand ?? {
      id: 0,
      name: ''
    },
    badges: convertThumbnailBadgeToBadge(deal?.additionalProperties?.thumbnailBadges),
    deliveryStartAt: undefined,
    deliveryServiceCode: DELIVERY_SERVICE_CODE.NONE,
    isDepartureToday: deal?.additionalProperties?.departureToday?.[0]?.status === 'ENABLED',
    isSpecialPrice: deal?.price?.isSpecialPrice ?? false,
    isSelling: deal?.isSelling ?? true,
    isSoldOut: deal?.isSoldOut ?? false,
    isDiscontinued: false,
    isFreeDelivery: deal?.isFreeDelivery ?? false,
    isOverseasPurchase: deal?.isOverseasPurchase ?? false,
    benefitBadges: getCardPromotionBadges(deal?.additionalProperties?.cardPromotions, deal?.price?.representativeSellingPrice),
    isScrap: deal?.isScrap ?? false,
    scrapCount: deal?.scrapCount ?? 0
  };
};

/**
 * Goods, Deal 둘중 하나의 형태를 지닌 StoreItem을 Product로 변환하는 함수
 * @param storeItem goods 또는 deal을 포함한 storeItem
 * @param showCouponBadge 쿠폰뱃지 노출 여부, 해당값이 true여야 쿠폰뱃지를 보여줌
 * @param isLoggedIn 로그인 여부, 로그인 상태가 아니면 상품쿠폰 뱃지의 타이틀을 할인쿠폰으로 보여줌
 * @returns 상품 Product
 * @example
 * ```
 * convertStoreItemToProduct({
 *   storeItem,
 *   showCouponBadge: true,
 *   isLoggedIn,
 * });
 * ```
 */
const convertStoreItemToProduct = ({
  storeItem,
  showCouponBadge = false,
  showCouponAppliedPrice = false,
  isLoggedIn = false
}) => {
  return storeItem.type === 'Goods' ? convertGoodsToProduct({
    goods: storeItem.goods,
    showCouponBadge,
    showCouponAppliedPrice,
    isLoggedIn
  }) : convertDealToProduct(storeItem.deal);
};

/**
 * store-mobile-bff 의 GoodsSummary 타입을
 * ProductCard 에서 사용하는 Product 타입으로 변환해주는 함수
 */
function convertGoodsSummaryToProduct({
  goodsSummary,
  type
}) {
  return {
    type,
    id: Number.parseInt(goodsSummary.id, 10),
    name: goodsSummary.name ?? '',
    reviewAvg: goodsSummary.reviewStatistic?.reviewAverage ?? 0,
    reviewCount: goodsSummary.reviewStatistic?.reviewCount ?? 0,
    sellingPrice: type === 'Deal' ? Number.parseInt(goodsSummary.price?.representativeSellingPrice ?? '0', 10) : Number.parseInt(goodsSummary.price?.sellingPrice ?? '0', 10),
    originalPrice: type === 'Deal' ? Number.parseInt(goodsSummary.price?.representativeOriginalPrice ?? '0', 10) : Number.parseInt(goodsSummary.price?.originalPrice ?? '0', 10),
    originalImageUrl: goodsSummary.imageUrl ?? '',
    brand: {
      id: Number.parseInt(goodsSummary.brand?.id ?? '0', 10),
      name: goodsSummary.brand?.name ?? ''
    },
    badges: goodsSummary.badgeProperties?.thumbnailBadges?.map(thumbnailBadge => ({
      id: 0,
      thumbnailBadgeId: 0,
      position: thumbnailBadge.position,
      image: {
        url: thumbnailBadge.imageUrl ?? '',
        width: null,
        height: null
      }
    })),
    benefitBadges: goodsSummary.badgeProperties?.cardPromotion != null ? [{
      image: goodsSummary.badgeProperties.cardPromotion.imageUrl,
      title: goodsSummary.badgeProperties.cardPromotion.displayText,
      ozipTitle: '',
      discountRatio: goodsSummary.badgeProperties.cardPromotion.discountRatio,
      fixedDiscountAmount: goodsSummary.badgeProperties.cardPromotion.fixedDiscountAmount
    }] : undefined,
    couponBadge: goodsSummary.badgeProperties?.couponBadge?.imageUrl != null && goodsSummary.badgeProperties?.couponBadge?.displayText != null ? {
      image: goodsSummary.badgeProperties.couponBadge.imageUrl,
      title: goodsSummary.badgeProperties?.couponBadge.displayText,
      couponAppliedPrice: goodsSummary.badgeProperties?.couponBadge.couponAppliedPrice ? Number.parseInt(goodsSummary.badgeProperties.couponBadge.couponAppliedPrice, 10) : undefined
    } : undefined,
    deliveryStartAt: goodsSummary.badgeProperties?.departureToday ? {
      template: {
        text: '평일 %s까지 결제시',
        values: [goodsSummary.badgeProperties.departureToday.orderDeadline]
      }
    } : undefined,
    deliveryServiceCode: goodsSummary.badgeProperties?.deliveryServiceCode ?? 'NONE',
    scrapCount: goodsSummary.scrapInfo?.scrapCount ?? 0,
    isSpecialPrice: goodsSummary.badgeProperties?.isSpecialPrice ?? false,
    isSelling: goodsSummary.badgeProperties?.isSelling ?? true,
    isSoldOut: goodsSummary.isSoldOut ?? false,
    isScrap: goodsSummary.scrapInfo?.isScrap ?? false,
    isFreeDelivery: goodsSummary.badgeProperties?.isFreeDelivery ?? false,
    isDiscontinued: goodsSummary.badgeProperties?.isDiscontinued ?? false,
    isOverseasPurchase: goodsSummary.badgeProperties?.isOverseasPurchase ?? false,
    isDepartureToday: goodsSummary.badgeProperties?.departureToday !== undefined,
    ...DEPRECATED_FIELDS
  };
}

const getProductPriceInfo = ({
  originalPrice,
  sellingPrice,
  currency,
  couponBadge,
  type
}) => {
  const discountRate = originalPrice === 0 ? 0 : Math.floor((originalPrice - sellingPrice) / originalPrice * 100);
  const isGlobal = !!currency;
  const price = isGlobal ? formatPriceByCurrency(sellingPrice, currency) : formatComma(sellingPrice);
  const hasCouponAppliedPrice = couponBadge?.couponAppliedPrice != null && type !== 'Deal';
  const showDiscountRate = discountRate > 0 && originalPrice > 0 && !hasCouponAppliedPrice;
  return {
    discountRate,
    price,
    showDiscountRate
  };
};

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: '1초 미만',
    other: '{{count}}초 미만'
  },
  xSeconds: {
    one: '1초',
    other: '{{count}}초'
  },
  halfAMinute: '30초',
  lessThanXMinutes: {
    one: '1분 미만',
    other: '{{count}}분 미만'
  },
  xMinutes: {
    one: '1분',
    other: '{{count}}분'
  },
  aboutXHours: {
    one: '약 1시간',
    other: '약 {{count}}시간'
  },
  xHours: {
    one: '1시간',
    other: '{{count}}시간'
  },
  xDays: {
    one: '1일',
    other: '{{count}}일'
  },
  aboutXWeeks: {
    one: '약 1주',
    other: '약 {{count}}주'
  },
  xWeeks: {
    one: '1주',
    other: '{{count}}주'
  },
  aboutXMonths: {
    one: '약 1개월',
    other: '약 {{count}}개월'
  },
  xMonths: {
    one: '1개월',
    other: '{{count}}개월'
  },
  aboutXYears: {
    one: '약 1년',
    other: '약 {{count}}년'
  },
  xYears: {
    one: '1년',
    other: '{{count}}년'
  },
  overXYears: {
    one: '1년 이상',
    other: '{{count}}년 이상'
  },
  almostXYears: {
    one: '거의 1년',
    other: '거의 {{count}}년'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' 후';
    } else {
      return result + ' 전';
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

var dateFormats = {
  full: 'y년 M월 d일 EEEE',
  long: 'y년 M월 d일',
  medium: 'y.MM.dd',
  short: 'y.MM.dd'
};
var timeFormats = {
  full: 'a H시 mm분 ss초 zzzz',
  long: 'a H:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['BC', 'AD'],
  abbreviated: ['BC', 'AD'],
  wide: ['기원전', '서기']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1분기', '2분기', '3분기', '4분기']
};
var monthValues = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
};
var dayValues = {
  narrow: ['일', '월', '화', '수', '목', '금', '토'],
  short: ['일', '월', '화', '수', '목', '금', '토'],
  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
};
var dayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = String(options === null || options === void 0 ? void 0 : options.unit);
  switch (unit) {
    case 'minute':
    case 'second':
      return String(number);
    case 'date':
      return number + '일';
    default:
      return number + '번째';
  }
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */
var locale = {
  code: 'ko',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var ko = locale;

const DATE_FORMAT = 'M/d (EE)';

/**
 * 배송의 타입, 상태에 따라 배송 추적 날짜 정보를 반환합니다.
 * ex)
 *  M/d (EE) 도착예정
 *  M/d (EE) 도착완료
 *  M/d (EE) 수거예정
 *  M/d (EE) 수거완료 예정 , ...
 * @param param
 */
const getDeliveryTackingNoticeFormat = param => {
  const {
    date,
    deliveryStatus,
    deliveryTargetType,
    isWithinDue
  } = param;
  if (deliveryTargetType === DELIVERY_TARGET_TYPE.PICKUP) {
    return getPickupDateFormat({
      date,
      deliveryStatus
    });
  } else {
    return getOrderDeliveryFormat({
      date,
      isWithinDue,
      isCompleted: deliveryStatus === DELIVERY_TRACKING_STATUS.COMPLETE
    });
  }
};

/**
 * 배송/재배송시의 배송조회 예정 날짜 및 문구 포맷을 반환한다.
 * @param dayDiff 오늘과 배송예정 날짜의 차이
 * @param isCompleted 배송 완료 여부포맷
 * @param isWithinDue ~이내로 표시해야 하는지 여부 (해외배송, 판매자 직접 배송 등 배송일자가 밀릴 수 있는 경우)
 */
const getOrderDeliveryFormat = ({
  date,
  isCompleted,
  isWithinDue
}) => {
  const formatDate = format(date, DATE_FORMAT, {
    locale: ko
  });
  const dayDiff = differenceInCalendarDays(date, new Date());
  if (isCompleted) {
    return {
      due: formatDate,
      status: '도착완료',
      isDelayed: false
    };
  }
  if (dayDiff <= -1) {
    return {
      due: '',
      status: '배송지연중',
      isDelayed: true
    };
  }
  if (isWithinDue) {
    return {
      due: `${formatDate} 이내`,
      status: '도착예정',
      isDelayed: false
    };
  }
  let [monthAndDay, week] = formatDate.split(' ');
  if (dayDiff === 0) {
    monthAndDay = '오늘';
  } else if (dayDiff === 1) {
    monthAndDay = '내일';
  }
  return {
    due: `${monthAndDay} ${week}`,
    status: '도착예정',
    isDelayed: false
  };
};

/**
 * 수거관련 날짜 및 문구 포맷을 반환합니다.
 * @param deliveryStatus 배송상태
 * @param date 날짜
 */
const getPickupDateFormat = ({
  deliveryStatus,
  date
}) => {
  const formatDate = format(date, DATE_FORMAT, {
    locale: ko
  });
  const dayDiff = differenceInCalendarDays(date, new Date());
  if (deliveryStatus === DELIVERY_TRACKING_STATUS.COMPLETE) {
    return {
      due: formatDate,
      status: '수거완료',
      isDelayed: false
    };
  }
  if (deliveryStatus === DELIVERY_TRACKING_STATUS.SCHEDULED) {
    if (dayDiff <= -1) {
      return {
        due: '',
        status: '수거 지연중',
        isDelayed: true
      };
    }
    return {
      due: formatDate,
      status: '수거예정',
      isDelayed: false
    };
  }
  if (dayDiff <= -1) {
    return {
      due: '',
      status: '수거완료 지연중',
      isDelayed: true
    };
  }
  return {
    due: formatDate,
    status: '수거완료 예정',
    isDelayed: false
  };
};

function formatPhoneNumber(value) {
  return value.replace(/\D/g, '').replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3').replace('--', '-');
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Price(props) {
  const {
    originalPrice,
    sellingPrice,
    type,
    isDiscontinued,
    isSoldOut,
    variant = 'lg',
    renderSuffix,
    currency,
    priceToken,
    couponBadge
  } = props;
  const disabled = !isDiscontinued && isSoldOut;
  const isGlobal = !!currency;
  const hasCouponAppliedPrice = couponBadge?.couponAppliedPrice != null && type !== 'Deal';
  const {
    discountRate,
    price,
    showDiscountRate
  } = getProductPriceInfo({
    originalPrice,
    sellingPrice,
    currency,
    couponBadge,
    type
  });
  return jsxs(Container$z, {
    className: "price",
    hasCouponAppliedPrice: hasCouponAppliedPrice,
    children: [showDiscountRate && jsxs(Rate$1, {
      disabled: disabled,
      variant: variant,
      children: [discountRate, jsx("span", {
        className: "percentage",
        children: '% '
      })]
    }), jsxs(Amount$1, {
      disabled: disabled,
      variant: variant,
      children: [price, renderSuffix != null && renderSuffix()]
    }), hasCouponAppliedPrice && jsxs(CouponAppliedPriceContainer, {
      disabled: disabled,
      children: [jsx(CouponAppliedPrice, {
        children: formatComma(couponBadge.couponAppliedPrice)
      }), jsx(CouponAppliedPriceSuffix, {
        children: "\uCFE0\uD3F0\uC801\uC6A9\uC2DC"
      })]
    }), isGlobal && priceToken && jsx(EsportsToken, {
      children: priceToken
    })]
  });
}
function PricePlaceholder(props) {
  const {
    className
  } = props;
  return jsx(Placeholder$1, {
    className: className
  });
}
var _ref4$5 = process.env.NODE_ENV === "production" ? {
  name: "1o7d3sk",
  styles: "display:flex;align-items:center;flex-wrap:wrap"
} : {
  name: "y4h1y-Container",
  styles: "display:flex;align-items:center;flex-wrap:wrap;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1u
};
const Container$z = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e175igv97"
} : {
  target: "e175igv97",
  label: "Container"
})("display:block;margin-top:4px;", ({
  hasCouponAppliedPrice
}) => !hasCouponAppliedPrice && _ref4$5, ";");
const getPriceFontStyle = variant => {
  switch (variant) {
    case 'sm':
      return FONT_STYLE.caption1;
    case 'md':
      return FONT_STYLE.subTitle2;
    default:
      return FONT_STYLE.title3;
  }
};
var _ref3$9 = process.env.NODE_ENV === "production" ? {
  name: "zw93mq",
  styles: "opacity:0.26"
} : {
  name: "nxe75c-Rate",
  styles: "opacity:0.26;label:Rate;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1u
};
const Rate$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv96"
} : {
  target: "e175igv96",
  label: "Rate"
})(({
  variant
}) => getPriceFontStyle(variant), ";font-weight:bold;margin-right:2px;color:", ({
  theme
}) => theme.content.primary1.basic, ";", ({
  disabled
}) => disabled && _ref3$9, ";");
var _ref2$f = process.env.NODE_ENV === "production" ? {
  name: "5b2tzs",
  styles: "opacity:0.14"
} : {
  name: "ruk4nf-Amount",
  styles: "opacity:0.14;label:Amount;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1u
};
const Amount$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv95"
} : {
  target: "e175igv95",
  label: "Amount"
})(({
  variant
}) => getPriceFontStyle(variant), ";font-weight:700;color:#2F3438;", ({
  disabled
}) => disabled && _ref2$f, ";");
const Placeholder$1 = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "e175igv94"
} : {
  target: "e175igv94",
  label: "Placeholder"
})(process.env.NODE_ENV === "production" ? {
  name: "1l6via1",
  styles: "font-size:17px;line-height:23px;&:before{content:'\\00a0';}"
} : {
  name: "1l6via1",
  styles: "font-size:17px;line-height:23px;&:before{content:'\\00a0';}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1u
});
const EsportsToken = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv93"
} : {
  target: "e175igv93",
  label: "EsportsToken"
})(FONT_STYLE.caption1, " color:", ({
  theme
}) => theme.content.base2, ";margin-left:2px;");
var _ref$C = process.env.NODE_ENV === "production" ? {
  name: "5b2tzs",
  styles: "opacity:0.14"
} : {
  name: "1ulbck8-CouponAppliedPriceContainer",
  styles: "opacity:0.14;label:CouponAppliedPriceContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1u
};
const CouponAppliedPriceContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e175igv92"
} : {
  target: "e175igv92",
  label: "CouponAppliedPriceContainer"
})("display:flex;align-items:center;flex-wrap:wrap;color:", ({
  theme
}) => theme.colors.foregroundCritical, ";", ({
  disabled
}) => disabled && _ref$C, ";");
const CouponAppliedPrice = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv91"
} : {
  target: "e175igv91",
  label: "CouponAppliedPrice"
})(FONT_STYLE.heading18, " font-weight:700;margin-right:4px;");
const CouponAppliedPriceSuffix = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e175igv90"
} : {
  target: "e175igv90",
  label: "CouponAppliedPriceSuffix"
})(FONT_STYLE.detail12L16, ";font-weight:400;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STATS_TYPES = {
  review(stats) {
    return jsxs(Fragment, {
      children: [jsx(Icon$2, {
        name: "star",
        className: "icon",
        size: 12
      }), jsx("strong", {
        className: "avg",
        children: stats.reviewAvg != null ? Math.round(stats.reviewAvg * 10) / 10 : 0
      }), jsx("span", {
        className: "count",
        children: `리뷰 ${formatComma(stats.reviewCount || 0)}`
      })]
    });
  },
  scrap(stats) {
    return `스크랩 ${formatComma(stats.scrapCount || 0)}`;
  }
};
function getStatsType({
  stats,
  isMdPick,
  hideReview
}) {
  if (stats.reviewCount != null && stats.reviewCount >= 1 && !hideReview) {
    return 'review';
  }
  if (stats.scrapCount != null && stats.scrapCount >= 1 && !isMdPick) {
    return 'scrap';
  }
  return null;
}
function Stats(props) {
  const {
    stats,
    isMdPick,
    hideReview,
    hideStats,
    className
  } = props;
  const {
    type = getStatsType({
      stats,
      isMdPick,
      hideReview
    })
  } = props;
  if (type == null || hideStats) {
    return null;
  }
  return jsx(Container$y, {
    className: `${type} ${className || ''}`,
    children: STATS_TYPES[type](stats)
  });
}
function StatsPlaceholder(props) {
  const {
    className
  } = props;
  return jsx(Placeholder, {
    className: className
  });
}
const Container$y = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eib94ex1"
} : {
  target: "eib94ex1",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1i2ilfc",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px;&.review{>.icon{color:#0AA5FF;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px;}>.avg{margin-right:4px;color:#2F3438;}>.count{font-size:12px;line-height:16px;font-weight:normal;color:#828C94;text-overflow:ellipsis;overflow:hidden;}}"
} : {
  name: "1i2ilfc",
  styles: "font-size:12px;line-height:16px;color:#828C94;display:flex;align-items:center;margin-top:4px;&.review{>.icon{color:#0AA5FF;width:1.1em;height:1.1em;margin-right:1px;vertical-align:-2px;}>.avg{margin-right:4px;color:#2F3438;}>.count{font-size:12px;line-height:16px;font-weight:normal;color:#828C94;text-overflow:ellipsis;overflow:hidden;}}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1t
});
const Placeholder = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "eib94ex0"
} : {
  target: "eib94ex0",
  label: "Placeholder"
})(FONT_STYLE.caption1, ";&:before{content:'\\00a0';}");

var OhouseDeliveryIcon = "data:image/png;base64,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";

var ThirdPartyApplianceIcon = "data:image/png;base64,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";

var ThirdPartyFurnitureIcon = "data:image/png;base64,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";

var DepartureTodayIcon = "data:image/png;base64,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";

function _EMOTION_STRINGIFIED_CSS_ERROR__$1s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function shouldShowDeliveryBadge(product) {
  const {
    deliveryServiceCode,
    isDepartureToday
  } = product;
  const showBadge = [DELIVERY_SERVICE_CODE.OHOUSE, DELIVERY_SERVICE_CODE.THIRD_PARTY_APPLIANCE, DELIVERY_SERVICE_CODE.THIRD_PARTY_FURNITURE].some(code => code === deliveryServiceCode ?? DELIVERY_SERVICE_CODE.NONE);
  return Boolean(showBadge || isDepartureToday);
}
function DeliveryBadge({
  deliveryServiceCode = DELIVERY_SERVICE_CODE.NONE,
  isDepartureToday
}) {
  return jsxs(Container$x, {
    children: [deliveryServiceCode === DELIVERY_SERVICE_CODE.OHOUSE && jsx("img", {
      src: OhouseDeliveryIcon,
      className: "icon",
      alt: "\uC624\uB298\uC758\uC9D1\uBC30\uC1A1\uBC43\uC9C0"
    }), deliveryServiceCode === DELIVERY_SERVICE_CODE.THIRD_PARTY_APPLIANCE && jsx("img", {
      src: ThirdPartyApplianceIcon,
      className: "icon",
      alt: "\uBE60\uB978\uAC00\uC804\uBC30\uC1A1\uBC43\uC9C0"
    }), deliveryServiceCode === DELIVERY_SERVICE_CODE.THIRD_PARTY_FURNITURE && jsx("img", {
      src: ThirdPartyFurnitureIcon,
      className: "icon",
      alt: "\uBE60\uB978\uAC00\uAD6C\uBC30\uC1A1\uBC43\uC9C0"
    }), isDepartureToday && jsx("img", {
      src: DepartureTodayIcon,
      className: "icon",
      alt: "\uC624\uB298\uCD9C\uBC1C\uBC43\uC9C0"
    })]
  });
}
const Container$x = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1l7cet60"
} : {
  target: "e1l7cet60",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1vaw5w5",
  styles: "display:flex;margin-top:4px;>.icon{width:auto;height:15px;}"
} : {
  name: "1vaw5w5",
  styles: "display:flex;margin-top:4px;>.icon{width:auto;height:15px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1s
});

function DeliveryStartAt({
  deliveryStartAt
}) {
  const {
    template
  } = deliveryStartAt;
  const {
    text,
    values
  } = template;
  const startAt = text.replace('%s', values[0] ?? '');
  return jsx(Text$1, {
    children: startAt
  });
}
const Text$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "enkhhyt0"
} : {
  target: "enkhhyt0",
  label: "Text"
})("display:inline-block;margin-top:4px;", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.primary4.basic, ";");

var _g$4;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgProductBadgeFreeDelivery = function SvgProductBadgeFreeDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    fillRule: "nonzero",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    d: "M12.73 5.38v3.96h-6.6V5.38zm-2.68 9.43H8.76v-3.25H5v-1.03h8.86v1.03h-3.81zm1.4-6.49V6.41H7.43v1.91h4.04zm11.08 2.7h-1.42v1.54h2.26v1.02h-8.86v-1.02h2.24v-1.53h-1.1V7.78h5.32V6.65H15.6V5.63h6.66V8.8h-5.33v1.18h5.61v1.04zm-4.53 0v1.54h1.87v-1.53H18zm14.37 3.78h-1.23V9.86h-.8v4.49h-1.2V5.18h1.2v3.66h.8V5h1.23zm-4.2-2.54h-3.9V6.01h1.27v2.26h1.36V6h1.28v6.26zm-1.27-1.01v-2h-1.36v2zm14.49 1.71c0 1.13-1.25 1.82-3.41 1.82s-3.42-.7-3.42-1.82 1.25-1.82 3.4-1.82c2.18 0 3.43.7 3.43 1.82m-3.41-6.05c-.5 1.13-2.1 1.9-3.51 2.1l-.54-1c1.64-.17 3.39-1.06 3.39-2.54V5.2h1.33v.28c0 1.48 1.99 2.47 3.4 2.53l-.55 1.01c-1.31-.18-3.03-.97-3.52-2.1zm4.42 3.78h-8.86V9.66h3.79V8.4h1.29v1.26h3.78zm-2.33 2.27c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8c0 .51.81.8 2.08.8s2.1-.29 2.1-.8"
  }))));
};

var _g$3;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgProductBadgeNonSelling = function SvgProductBadgeNonSelling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 20
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "#000",
    opacity: 0.07,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M12.66 14.8h-1.3V5h1.3zm-4.3-3.52V6.93H6.29v4.35h2.06zm1.3-5.38v6.4H5V5.9h4.65zm12.51 8.78H15.7v-3.94h1.29v.98h3.9v-.99h1.3v3.95zm-1.29-1.02v-.95h-3.9v.95zm1.28-3.43h-1.28V5h1.28v5.22zm-7.78-2.47c0-1.34 1.11-2.34 2.6-2.34 1.5 0 2.6.98 2.6 2.34 0 1.39-1.1 2.25-2.6 2.25-1.49 0-2.6-.86-2.6-2.25m1.3-.01c0 .76.57 1.2 1.3 1.2.71 0 1.3-.44 1.3-1.2 0-.81-.56-1.26-1.3-1.26s-1.3.48-1.3 1.26m16 6.93h-6.5v-3.62h6.5zm-7.76-8V5.63h5.17v1.05h-1.88a3.05 3.05 0 0 0 2.18 2.69l-.7 1a4.2 4.2 0 0 1-2.13-1.92 3.92 3.92 0 0 1-2.28 2.22l-.76-1.02c1.37-.5 2.3-1.54 2.37-2.97zm7.77 3.9h-1.3V8.4h-1.44V7.36h1.45V5h1.29v5.59zm-1.3 3.1v-1.63h-3.94v1.63h3.95z"
  }))));
};

var _g$2;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgProductBadgeDiscontinued = function SvgProductBadgeDiscontinued(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.38 8.8h-1.4v3.34h-1.3V5.07h1.3v2.67h1.4zm-1.16 5.78H5.7v-3.12H7v2.09h5.22zm-6.3-5.11c1.43 0 2.83-.08 3.84-.29.05.33.11.66.18.98-.92.22-2.53.34-4.33.34h-.96V5.87h4.37v1.01h-3.1zm15.77 3.57c0 1.14-1.25 1.83-3.41 1.83s-3.42-.7-3.42-1.83c0-1.1 1.25-1.8 3.4-1.8 2.18 0 3.43.7 3.43 1.8m.6-4.91-.56 1c-1.37-.11-2.9-.87-3.45-1.85-.49 1-1.92 1.75-3.47 1.87l-.53-1c1.49-.08 2.83-.74 3.22-1.7h-2.76v-1h7.1v1h-2.76c.43.97 1.94 1.63 3.2 1.68zm.41 2.67h-8.86V9.76h3.77V8.54h1.28v1.24h3.81v1.03zm-2.33 2.25c0-.5-.83-.8-2.1-.8s-2.08.3-2.08.8.81.8 2.08.8 2.1-.3 2.1-.8"
  }))));
};

var _g$1;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgProductBadgeOverseasPurchase = function SvgProductBadgeOverseasPurchase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 20
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 20,
    fill: "#EAEDEF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828C94",
    fillRule: "nonzero",
    d: "M13.349 14.801h-1.221V9.994h-.814v4.356h-1.199V5.176h1.199V8.96h.814V5h1.221zm-3.85-4.037c0 1.232-.869 2.035-2.145 2.035-1.265 0-2.145-.869-2.145-2.035 0-1.243.891-2.035 2.145-2.035 1.276 0 2.145.803 2.145 2.035M5 8.366V7.343h4.675v1.023zm3.344 2.398c0-.605-.418-1.023-.99-1.023-.561 0-.979.418-.979 1.023 0 .616.418 1.023.979 1.023.572 0 .99-.429.99-1.023M6.067 6.782V5.759h2.64v1.023zm14.861 5.797c-1.694.209-4.29.341-6.127.341a34 34 0 0 1-.187-1.034c.825 0 1.65 0 2.442-.022v-1.562c-1.177-.209-2.002-1.045-2.002-2.233 0-1.364 1.122-2.387 2.629-2.387s2.662 1.012 2.662 2.387c0 1.166-.825 1.991-1.991 2.222v1.518c.913-.055 1.76-.121 2.486-.22zM22.666 5v9.801h-1.298V5zm-3.597 3.069c0-.825-.638-1.309-1.386-1.309-.737 0-1.364.517-1.364 1.309 0 .759.638 1.221 1.364 1.221s1.386-.462 1.386-1.221m5.412-1.353V5.693h5.17v1.023H27.77c.099 1.408 1.1 2.343 2.2 2.695l-.715 1.012c-.748-.286-1.705-1.045-2.134-1.947-.275.957-1.32 1.87-2.277 2.2l-.759-1.001c1.386-.495 2.31-1.529 2.365-2.959zm1.034 4.477h6.644v3.619h-1.298v-2.607h-5.346zm6.633-.484h-1.287V5.011h1.287zm9.13-5.181c0 1.584-.099 3.058-.319 4.18h1.452v1.023h-3.806v4.07h-1.287v-4.07h-3.762V9.708h6.182c.176-.847.264-1.947.264-3.146h-5.357V5.528z"
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function BadgeList(props) {
  const {
    isDiscontinued,
    isSoldOut,
    isSelling,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    isGlobal,
    badgeMaxCount,
    className
  } = props;
  const disabled = !isDiscontinued && isSoldOut;
  const badgeList = useMemo(() => [isOverseasPurchase && jsx(SvgProductBadgeOverseasPurchase, {
    className: "icon",
    "aria-label": "\uD574\uC678\uC9C1\uAD6C"
  }, 0), isFreeDelivery && jsx(SvgProductBadgeFreeDelivery, {
    className: "icon",
    "aria-label": "\uBB34\uB8CC\uBC30\uC1A1"
  }, 1), isSpecialPrice && jsx(SvgProductBadgeCheapestPrice, {
    className: "icon",
    "aria-label": "\uD2B9\uAC00"
  }, 2)].filter(value => !!value), [isOverseasPurchase, isFreeDelivery, isSpecialPrice]);
  if (isDiscontinued || !isSelling && !isGlobal) {
    return jsxs(Container$w, {
      disabled: disabled,
      "data-testid": "badge-list-container",
      className: className,
      children: [!isSelling && !isGlobal && jsx(SvgProductBadgeNonSelling, {
        className: "icon",
        "aria-label": "\uBBF8\uC785\uC810"
      }), !(!isSelling && !isGlobal) && isDiscontinued && jsx(SvgProductBadgeDiscontinued, {
        className: "icon",
        "aria-label": "\uB2E8\uC885"
      })]
    });
  }
  return jsx(Container$w, {
    disabled: disabled,
    "data-testid": "badge-list-container",
    className: className,
    children: badgeMaxCount != null ? badgeList.slice(0, badgeMaxCount) : badgeList
  });
}
var _ref$B = process.env.NODE_ENV === "production" ? {
  name: "1s0bkzx",
  styles: "opacity:0.32"
} : {
  name: "15iych5-Container",
  styles: "opacity:0.32;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1r
};
const Container$w = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e132f8k40"
} : {
  target: "e132f8k40",
  label: "Container"
})("display:flex;flex-wrap:wrap;gap:4px;margin-top:8px;", ({
  disabled
}) => disabled && _ref$B, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function IconWithTextBadge({
  title,
  image,
  className
}) {
  return jsxs(Container$v, {
    className: className,
    children: [jsx(Icon, {
      src: image,
      alt: "icon-with-text-badge"
    }), jsx(Title$c, {
      children: title
    })]
  });
}
const Container$v = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etn6hd12"
} : {
  target: "etn6hd12",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1b1ga6k",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;margin-top:6px;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF"
} : {
  name: "1b1ga6k",
  styles: "display:flex;align-items:center;max-width:100%;width:fit-content;margin-top:6px;padding:2px 5px;font-size:10px;line-height:14px;font-weight:700;letter-spacing:-0.3px;border-radius:4px;color:#2F3438;border:1px solid #EAEDEF",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1q
});
const Icon = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "etn6hd11"
} : {
  target: "etn6hd11",
  label: "Icon"
})(process.env.NODE_ENV === "production" ? {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px"
} : {
  name: "spvu94",
  styles: "display:block;width:11px;margin-right:5px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1q
});
const Title$c = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "etn6hd10"
} : {
  target: "etn6hd10",
  label: "Title"
})(process.env.NODE_ENV === "production" ? {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
} : {
  name: "sqm42b",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1q
});

function Badges({
  product,
  isMdPick,
  badgeMaxCount
}) {
  const {
    isSelling,
    isDiscontinued,
    deliveryServiceCode,
    isDepartureToday,
    deliveryStartAt,
    isSoldOut,
    isOverseasPurchase,
    isFreeDelivery,
    isSpecialPrice,
    currency,
    couponBadge,
    benefitBadges
  } = product;
  const showBadge = isSelling && !isDiscontinued;
  return jsxs(Fragment, {
    children: [showBadge && shouldShowDeliveryBadge(product) && jsx(DeliveryBadge, {
      deliveryServiceCode: deliveryServiceCode,
      isDepartureToday: isDepartureToday
    }), showBadge && deliveryStartAt && jsx(DeliveryStartAt, {
      deliveryStartAt: deliveryStartAt
    }), jsx(BadgeList, {
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      isSelling: isSelling,
      isOverseasPurchase: isOverseasPurchase,
      isFreeDelivery: isFreeDelivery,
      isSpecialPrice: isSpecialPrice,
      isGlobal: !!currency,
      badgeMaxCount: badgeMaxCount != null && isMdPick ? 2 : undefined
    }), showBadge && couponBadge != null && couponBadge.couponAppliedPrice == null && jsx(IconWithTextBadge, {
      title: couponBadge.title,
      image: couponBadge.image
    }), showBadge && benefitBadges?.map((badge, index) => jsx(IconWithTextBadge, {
      title: badge.title,
      image: badge.image
    }, `benefit-badge-${index + 1}`))]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Info$1({
  product,
  renderDescription,
  badgeMaxCount,
  isMdPick,
  flex,
  variant = 'lg',
  localeData = {},
  hideBadge,
  hideReview,
  hideStats,
  hidePriceCurrency = true,
  className,
  bottomArea
}) {
  const {
    name,
    isSelling,
    isDiscontinued,
    brand,
    originalPrice,
    sellingPrice,
    isSoldOut,
    type,
    reviewAvg,
    reviewCount,
    scrapCount,
    currency,
    couponBadge
  } = product;
  const isGlobal = !!currency;
  const showPrice = isGlobal || isSelling && !isDiscontinued;
  return jsxs(Container$u, {
    flex: flex,
    className: classNames('product-info', className),
    children: [jsxs(Header$5, {
      children: [brand?.name != null && jsx(Brand, {
        className: "product-brand",
        children: brand.name
      }), renderDescription != null && jsx(Box, {
        children: renderDescription()
      }), name && jsx(Name, {
        className: "product-name",
        variant: variant,
        children: name
      })]
    }), showPrice && jsx(Price, {
      type: type,
      couponBadge: couponBadge,
      originalPrice: originalPrice,
      sellingPrice: sellingPrice,
      isDiscontinued: isDiscontinued,
      isSoldOut: isSoldOut,
      variant: variant,
      currency: hidePriceCurrency ? undefined : currency,
      renderSuffix: () => jsx("span", {
        children: type === 'Deal' && ' 외'
      }),
      priceToken: localeData?.priceToken
    }), !isGlobal && jsx(Stats, {
      stats: {
        reviewAvg,
        reviewCount,
        scrapCount
      },
      isMdPick: isMdPick,
      hideReview: hideReview,
      hideStats: hideStats
    }), !hideBadge && jsx(Badges, {
      product: product,
      isMdPick: isMdPick,
      badgeMaxCount: badgeMaxCount
    }), bottomArea && bottomArea]
  });
}
function InfoPlaceholder() {
  return jsxs(Container$u, {
    children: [jsxs(Header$5, {
      children: [jsx(BrandPlaceholder, {}), jsx(NamePlaceholder, {})]
    }), jsx(StyledPricePlaceholder, {}), jsx(StyledStatsPlaceholer, {})]
  });
}
var _ref2$e = process.env.NODE_ENV === "production" ? {
  name: "v1s1f3",
  styles: "margin-left:12px"
} : {
  name: "oyt7z3-Container",
  styles: "margin-left:12px;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
};
const Container$u = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eo39oc47"
} : {
  target: "eo39oc47",
  label: "Container"
})("width:100%;", ({
  flex
}) => flex && _ref2$e, ";");
const Header$5 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eo39oc46"
} : {
  target: "eo39oc46",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : {
  name: "1r0yqr6",
  styles: "margin-top:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
});
const Brand = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eo39oc45"
} : {
  target: "eo39oc45",
  label: "Brand"
})(process.env.NODE_ENV === "production" ? {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94"
} : {
  name: "11vbb10",
  styles: "font-size:12px;line-height:16px;display:block;word-break:break-all;color:#828C94",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
});
const nameStyle = process.env.NODE_ENV === "production" ? {
  name: "wwgkbi",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word"
} : {
  name: "kdxkly-nameStyle",
  styles: "font-size:14px;line-height:18px;display:block;max-height:36px;margin-top:4px;word-break:break-all;transition:.1s opacity;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-wrap:break-word;label:nameStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
};
var _ref$A = process.env.NODE_ENV === "production" ? {
  name: "xolxwr",
  styles: "font-size:12px;line-height:16px"
} : {
  name: "1qwpow5-Name",
  styles: "font-size:12px;line-height:16px;label:Name;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
};
const Name = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "eo39oc44"
} : {
  target: "eo39oc44",
  label: "Name"
})(nameStyle, " color:#2F3438;", ({
  variant
}) => (variant === 'sm' || variant === 'md') && _ref$A, ";");
const BrandPlaceholder = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "eo39oc43"
} : {
  target: "eo39oc43",
  label: "BrandPlaceholder"
})(FONT_STYLE.caption1, " &:before{content:'\\00a0';}display:block;word-break:break-all;width:80px;");
const NamePlaceholder = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "eo39oc42"
} : {
  target: "eo39oc42",
  label: "NamePlaceholder"
})(nameStyle, " &:before{content:'\\00a0';}");
const StyledPricePlaceholder = /*#__PURE__*/_styled(PricePlaceholder, process.env.NODE_ENV === "production" ? {
  target: "eo39oc41"
} : {
  target: "eo39oc41",
  label: "StyledPricePlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px"
} : {
  name: "192rb07",
  styles: "margin-top:3px;line-height:21px;width:120px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
});
const StyledStatsPlaceholer = /*#__PURE__*/_styled(StatsPlaceholder, process.env.NODE_ENV === "production" ? {
  target: "eo39oc40"
} : {
  target: "eo39oc40",
  label: "StyledStatsPlaceholer"
})(process.env.NODE_ENV === "production" ? {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px"
} : {
  name: "13ec1gr",
  styles: "margin-top:3px;width:100px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1p
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$1o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const badgeSizeLookup = {
  extraSmall: [29, 29],
  small: [29, 26],
  large: [23, 20]
};
const BASE_BADGE_SIZE = 100;
const SEGMENTS = 3;
const calculateColumn = (elementSize, position) => {
  const base = BASE_BADGE_SIZE / SEGMENTS;
  const pos = Math.floor(position / SEGMENTS);
  return base * pos + (base - elementSize) / 2 * pos;
};
const calculateRow = (elementSize, position) => {
  const base = BASE_BADGE_SIZE / SEGMENTS;
  const pos = position % SEGMENTS;
  return base * pos + (base - elementSize) / 2 * pos;
};
function ThumbnailBadge({
  badgeList,
  size
}) {
  const badgeSize = badgeSizeLookup[size ?? 'small'];
  const filteredBadgeList = badgeList.map(badge => ({
    ...badge,
    position: Math.max(1, Math.min(badge.position, 9))
  }));
  return jsx(Container$t, {
    children: filteredBadgeList.map((badge, index) => jsx(Content$4, {
      calculateColumn: calculateColumn,
      calculateRow: calculateRow,
      size: badgeSize,
      position: badge.position - 1,
      children: jsx(Image$1, {
        src: badge.image.url
      })
    }, `thumbnail-badge-${index + 1}`))
  });
}
const Container$t = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3bgcpm2"
} : {
  target: "e3bgcpm2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none"
} : {
  name: "nm1wv3",
  styles: "position:absolute;width:100%;height:100%;box-sizing:border-box;z-index:1;pointer-events:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1o
});
const Content$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3bgcpm1"
} : {
  target: "e3bgcpm1",
  label: "Content"
})("position:absolute;", ({
  calculateColumn,
  calculateRow,
  size,
  position
}) => `
    top: ${calculateColumn(size[0], position)}%;
    left: ${calculateRow(size[0], position)}%;
    width: ${size[0]}%;
    height: ${size[0]}%;
    ${MEDIA_QUERY.min('tablet', `
      top: ${calculateColumn(size[1], position)}%;
      left: ${calculateRow(size[1], position)}%;
      width: ${size[1]}%;
      height: ${size[1]}%;
    `)}
  `, ";");
const Image$1 = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e3bgcpm0"
} : {
  target: "e3bgcpm0",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}"
} : {
  name: "1dapu1e",
  styles: "&&&{width:100%;background-color:transparent;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1o
});

function SoldOutBanner() {
  return jsx(Container$s, {
    children: "\uD488\uC808"
  });
}
const Container$s = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e152w92t0"
} : {
  target: "e152w92t0",
  label: "Container"
})(FONT_STYLE.caption1, " position:absolute;left:0;right:0;bottom:0;padding:2px 0;text-align:center;font-weight:bold;", ({
  theme
}) => /*#__PURE__*/css("color:", theme.content.white, ";background-color:", theme.content.base3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")), " border-radius:0 0 4px 4px;z-index:2;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function Thumbnail$2({
  badges,
  originalImageUrl,
  isSoldOut,
  isDiscontinued,
  flex,
  isMdPick,
  className,
  children,
  renderOverlay,
  scrap
}) {
  const isVisibleSoldoutBanner = isSoldOut && !isDiscontinued;
  return jsx(Wrapper$4, {
    flex: flex,
    className: classNames('product-thumbnail', className),
    children: jsxs(Container$r, {
      children: [renderOverlay?.(), scrap != null && jsx(ProductCardScrap, {
        scrapData: scrap.data,
        product: scrap.product,
        logData: scrap.logData,
        isOwap: scrap.isOwap
      }), jsxs(ImageWrapper, {
        children: [badges != null && badges.length > 0 && jsx(ThumbnailBadge, {
          badgeList: badges,
          size: isMdPick ? 'extraSmall' : 'small'
        }), jsx(StyledResizeImage, {
          src: originalImageUrl,
          quality: 50,
          intrinsicAspect: 1,
          className: "thumbnail-image",
          alt: "\uC0C1\uD488-\uC378\uB124\uC77C-\uC774\uBBF8\uC9C0"
        })]
      }), isVisibleSoldoutBanner && jsx(SoldOutBanner, {}), children]
    })
  });
}
function ThumbnailPlaceholder() {
  return jsx(ThumbnailPlaceholderAnimation, {});
}
const Wrapper$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc4"
} : {
  target: "e1bro5mc4",
  label: "Wrapper"
})(({
  flex
}) => flex && `
    flex: 1 0 48%;
  `, ";");
const Container$r = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc3"
} : {
  target: "e1bro5mc3",
  label: "Container"
})("position:relative;padding-bottom:100%;background-color:", ({
  theme
}) => theme.content.base5, ";border-radius:4px;&:after{content:'';position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(5, 3, 3, 0.02);border-radius:4px;}");
const ImageWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc2"
} : {
  target: "e1bro5mc2",
  label: "ImageWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden"
} : {
  name: "ypqde8",
  styles: "position:absolute;width:100%;height:100%;border-radius:4px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1n
});
const StyledResizeImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc1"
} : {
  target: "e1bro5mc1",
  label: "StyledResizeImage"
})(process.env.NODE_ENV === "production" ? {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform"
} : {
  name: "j9woce",
  styles: "position:absolute;top:50%;left:50%;width:100%;transform:translate(-50%, -50%);transition:.2s transform",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1n
});
const ThumbnailPlaceholderAnimation = /*#__PURE__*/_styled(PlaceholderAnimation, process.env.NODE_ENV === "production" ? {
  target: "e1bro5mc0"
} : {
  target: "e1bro5mc0",
  label: "ThumbnailPlaceholderAnimation"
})(process.env.NODE_ENV === "production" ? {
  name: "vs1u20",
  styles: "padding-bottom:100%;border-radius:4px"
} : {
  name: "vs1u20",
  styles: "padding-bottom:100%;border-radius:4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1n
});

function Timer({
  className,
  todayDeal
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = breakpoint === 'mobile';
  const endAt = new Date(todayDeal.endAt).getTime();
  const [remaining, setRemaining] = useState(() => endAt - Date.now());
  const hasExpired = remaining <= 0;
  const text = remaining >= 86400000 ? `${Math.floor(remaining / 86400000)}일` : `${`00${Math.floor(remaining / 1000 / 3600) % 24}`.slice(-2)}:${`00${Math.floor(remaining / 1000 / 60) % 60}`.slice(-2)}:${`00${Math.floor(remaining / 1000) % 60}`.slice(-2)}`;
  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(endAt - Date.now());
    }, 1000);
    return () => {
      window.clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(Badge, {
    size: isMobile ? 20 : 24,
    type: "fill",
    variant: "primary2",
    className: className,
    children: hasExpired ? '마감' : `${text} 남음`
  });
}
const Badge = /*#__PURE__*/_styled(SquareBadge, process.env.NODE_ENV === "production" ? {
  target: "edmzysc0"
} : {
  target: "edmzysc0",
  label: "Badge"
})("position:absolute;z-index:3;top:8px;left:8px;", MEDIA_QUERY.min('tablet', `
    top: 12px;
    left: 12px;
  `), ";");

function ProductCard({
  product,
  href,
  badgeMaxCount,
  flex,
  isMdPick,
  logData,
  scrapData,
  localeData,
  hideBadge,
  hideReview,
  hideStats,
  hidePriceCurrency,
  className,
  renderDescription,
  renderOverlay,
  onClick,
  linkComponent,
  infoBottomArea,
  infoVariant,
  isOwap = false
}) {
  const {
    detailLogData
  } = useProductCardLogData({
    product,
    badgeMaxCount
  });
  const bucketLogData = {
    ...logData,
    type: product.type?.toLowerCase() || 'production',
    id: product.id,
    data: {
      ...logData?.data,
      ...detailLogData
    }
  };
  const {
    ref
  } = de({
    logData: bucketLogData
  });
  const LinkComponent = linkComponent;
  const handleClickProductLink = event => {
    if (logData) {
      O$1({
        category: 'click',
        ...bucketLogData
      });
    }
    onClick?.(event);
  };
  return jsxs(Container$q, {
    className: className,
    ref: ref,
    flex: flex,
    children: [LinkComponent != null && jsx(LinkComponent, {
      href: href,
      onClick: handleClickProductLink
    }), jsx(Thumbnail$2, {
      badges: product.badges,
      originalImageUrl: product.originalImageUrl,
      isSoldOut: product.isSoldOut,
      isDiscontinued: product.isDiscontinued,
      flex: flex,
      isMdPick: isMdPick,
      renderOverlay: renderOverlay,
      scrap: scrapData ? {
        data: scrapData,
        product,
        logData: bucketLogData,
        isOwap
      } : undefined
    }), jsx(Info$1, {
      product: product,
      badgeMaxCount: badgeMaxCount,
      flex: flex,
      isMdPick: isMdPick,
      localeData: localeData,
      hideBadge: hideBadge,
      hideReview: hideReview,
      hideStats: hideStats,
      hidePriceCurrency: hidePriceCurrency,
      bottomArea: infoBottomArea,
      variant: infoVariant,
      renderDescription: renderDescription
    })]
  });
}
function CardPlaceholder() {
  return jsxs(Container$q, {
    children: [jsx(ThumbnailPlaceholder, {}), jsx(InfoPlaceholder, {})]
  });
}
const Container$q = /*#__PURE__*/_styled("article", process.env.NODE_ENV === "production" ? {
  target: "etj6rb20"
} : {
  target: "etj6rb20",
  label: "Container"
})("display:block;position:relative;padding:16px 0;", ({
  flex
}) => flex && `
    display: flex;
    align-items: center;
  `, ">a{position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;", HOVER`
      & ~ .product-thumbnail .thumbnail-image {
        transform: translate(-50%, -50%) scale(1.1);
      }
      & ~ .product-info .product-name {
        opacity: 0.5;
      }
    `, ";}");

const CommerceProductCard = props => {
  return jsx(ProductCard, {
    ...props
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function DeliverySummary({
  logisticsName,
  invoiceNumber,
  deliveryStatus,
  deliveryTrackingNoticeDate,
  isOverseasPurchase,
  shipmentType,
  deliveryTargetType
}) {
  const theme = useTheme();
  const {
    open
  } = useSnackbar();
  const handleClickCopy = () => {
    copyTextToClipboard(invoiceNumber);
    open({
      content: '운송장 번호를 복사했습니다.'
    });
  };
  let dateFormat = null;
  if (deliveryTrackingNoticeDate) {
    dateFormat = getDeliveryTackingNoticeFormat({
      date: deliveryTrackingNoticeDate,
      isWithinDue: isOverseasPurchase || shipmentType === SHIPMENT_TYPE.SELLER,
      deliveryStatus,
      deliveryTargetType
    });
  }
  return jsxs(Wrapper$3, {
    children: [dateFormat && jsxs(ExpectedInfo, {
      children: [jsx("span", {
        className: "due",
        children: `${dateFormat.due} `
      }), jsx("span", {
        className: classNames('status', {
          delayed: dateFormat.status === '배송지연중'
        }),
        children: dateFormat.status
      })]
    }), jsxs(LogisticInfo, {
      children: [jsxs(LogisticName, {
        children: [jsx(TruckIcon, {
          className: "icon",
          size: 24,
          "data-testid": "truck-icon"
        }), `${logisticsName} ${invoiceNumber}`]
      }), jsx(OutlineButton, {
        css: /*#__PURE__*/css("background-color:", theme.content.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:DeliverySummary;")),
        size: 32,
        variant: "base1",
        onClick: handleClickCopy,
        children: "\uBCF5\uC0AC"
      })]
    })]
  });
}
const Wrapper$3 = /*#__PURE__*/_styled("section", process.env.NODE_ENV === "production" ? {
  target: "e185skhs3"
} : {
  target: "e185skhs3",
  label: "Wrapper"
})("margin-bottom:40px;color:", ({
  theme
}) => theme.content.base1, ";");
const ExpectedInfo = /*#__PURE__*/_styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e185skhs2"
} : {
  target: "e185skhs2",
  label: "ExpectedInfo"
})(FONT_STYLE.title2, ";font-weight:700;text-align:center;margin-bottom:20px;.due{color:", ({
  theme
}) => theme.content.primary1.thick, ";}.status.delayed{color:", ({
  theme
}) => theme.content.base2, ";}");
const LogisticInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e185skhs1"
} : {
  target: "e185skhs1",
  label: "LogisticInfo"
})("display:flex;justify-content:space-between;align-items:center;padding:8px 12px;background-color:", ({
  theme
}) => theme.background.groupedBase, ";border-radius:4px;");
const LogisticName = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e185skhs0"
} : {
  target: "e185skhs0",
  label: "LogisticName"
})(process.env.NODE_ENV === "production" ? {
  name: "1ec23nz",
  styles: "display:flex;align-items:center;.icon{margin-right:12px;}"
} : {
  name: "1ec23nz",
  styles: "display:flex;align-items:center;.icon{margin-right:12px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1m
});

function DeliveryTimeLineStep({
  highLight,
  showArrow,
  fillPath,
  header,
  children,
  className
}) {
  return jsxs(Wrapper$2, {
    className: classNames(className, {
      highLight,
      fillPath
    }),
    "data-testid": "delivery-time-line-step",
    children: [showArrow && jsx(ArrowMark, {
      children: jsx(ChevronDownIcon$1, {
        size: 12,
        "data-testid": "arrow-down-icon"
      })
    }), header && jsx(Header$4, {
      children: header
    }), children]
  });
}
const Header$4 = /*#__PURE__*/_styled("h3", process.env.NODE_ENV === "production" ? {
  target: "e12hlzca2"
} : {
  target: "e12hlzca2",
  label: "Header"
})(FONT_STYLE.subTitle1, ";color:", ({
  theme
}) => theme.content.base3, ";font-weight:700;display:flex;");
const ArrowMark = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12hlzca1"
} : {
  target: "e12hlzca1",
  label: "ArrowMark"
})("display:inline-flex;align-items:center;color:", ({
  theme
}) => theme.content.primary1.basic, ";justify-content:center;position:absolute;left:-4px;top:-6px;width:36px;height:36px;border-radius:50%;background-color:", ({
  theme
}) => theme.content.white, ";border:2px solid ", ({
  theme
}) => theme.content.primary1.basic, ";box-sizing:border-box;z-index:5;");
const Wrapper$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12hlzca0"
} : {
  target: "e12hlzca0",
  label: "Wrapper"
})("padding-left:44px;position:relative;min-height:60px;padding-bottom:16px;&:last-of-type{min-height:0;}&::before{content:\"\";position:absolute;width:20px;display:inline-block;top:0;bottom:0;left:4px;background-color:", ({
  theme
}) => theme.content.base4, ";}&.fillPath::before{background-color:", ({
  theme
}) => theme.content.primary1.basic, ";}&:first-of-type::before{border-top-left-radius:20px;border-top-right-radius:20px;}&:last-of-type::before{border-bottom-left-radius:20px;border-bottom-right-radius:20px;height:20px;}&::after{content:\"\";position:absolute;background-color:white;display:inline-block;width:8px;height:8px;left:10px;top:6px;z-index:3;border-radius:50%;}&.fillPath{", Header$4, "{color:", ({
  theme
}) => theme.content.base1, ";}}&.highLight{", Header$4, "{color:", ({
  theme
}) => theme.content.primary1.thick, ";}}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$z = process.env.NODE_ENV === "production" ? {
  name: "y1f223",
  styles: "margin:auto"
} : {
  name: "i5sq5b-DeliveryWayPoint",
  styles: "margin:auto;label:DeliveryWayPoint;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1l
};
function DeliveryWayPoint({
  currentLocation,
  className,
  empName,
  datetime,
  position,
  empPhone
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = ['mobile', 'tablet'].includes(breakpoint ?? '');
  const formatDate = datetime && format(parseISO(datetime), 'M/d (EE) HH:mm', {
    locale: ko
  });
  return jsxs(Wrapper$1, {
    className: className,
    children: [jsx(Header$3, {
      className: classNames({
        highlight: currentLocation
      }),
      children: position
    }), jsxs(Info, {
      children: [`${formatDate} `, empName && jsxs(Fragment, {
        children: ["\xB7", ` ${empName} `]
      }), currentLocation && empPhone && (isMobile ? jsx(CallButton, {
        href: `tel:${empPhone}`,
        children: jsx(CallIcon, {
          size: 18,
          css: _ref$z
        })
      }) : empPhone)]
    })]
  });
}
const Wrapper$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo3"
} : {
  target: "e3nenqo3",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1u53ekv",
  styles: "padding-bottom:16px"
} : {
  name: "1u53ekv",
  styles: "padding-bottom:16px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1l
});
const Header$3 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo2"
} : {
  target: "e3nenqo2",
  label: "Header"
})(FONT_STYLE.subTitle2, ";&.highlight{font-weight:500;}");
const Info = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo1"
} : {
  target: "e3nenqo1",
  label: "Info"
})(FONT_STYLE.body2_small, ";color:", ({
  theme
}) => theme.content.base2, ";display:inline-flex;align-items:center;justify-content:center;");
const CallButton = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e3nenqo0"
} : {
  target: "e3nenqo0",
  label: "CallButton"
})("border:1px solid ", ({
  theme
}) => theme.content.base4, ";border-radius:50%;width:26px;height:26px;display:inline-flex;margin-left:4px;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$y = process.env.NODE_ENV === "production" ? {
  name: "pbbd9q",
  styles: "padding-bottom:0px"
} : {
  name: "1quos74-DeliveryTimeLine",
  styles: "padding-bottom:0px;label:DeliveryTimeLine;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1k
};
var _ref2$d = process.env.NODE_ENV === "production" ? {
  name: "18g08sj",
  styles: "padding-bottom:0"
} : {
  name: "84nixw-DeliveryTimeLine",
  styles: "padding-bottom:0;label:DeliveryTimeLine;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1k
};
function DeliveryTimeLine({
  details,
  status,
  isError,
  message,
  targetType
}) {
  const [isShowDetail, setIsShowDetail] = useState(false);
  if (isError) {
    return jsx(ErrorMessage, {
      children: breakLines(message)
    });
  }
  if (!details) {
    return null;
  }
  const detailsLength = details.length;
  const isExistWayPoint = detailsLength > 0;
  const recentWayPoint = isExistWayPoint && details[detailsLength - 1];
  const passedWayPoints = isExistWayPoint ? details.slice(0, detailsLength - 1) : undefined;
  const canShowPassedWayPoints = passedWayPoints && passedWayPoints?.length > 0;
  const targetTypeKorean = targetType === DELIVERY_TARGET_TYPE.PICKUP ? '수거' : '배송';
  return jsxs(Fragment, {
    children: [jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean} 준비중`,
      fillPath: [DELIVERY_TRACKING_STATUS.COMPLETE, DELIVERY_TRACKING_STATUS.INPROGRESS, DELIVERY_TRACKING_STATUS.SCHEDULED].includes(status),
      highLight: status === DELIVERY_TRACKING_STATUS.READY,
      showArrow: status === DELIVERY_TRACKING_STATUS.READY
    }), targetType === DELIVERY_TARGET_TYPE.PICKUP && jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean} 예정`,
      fillPath: [DELIVERY_TRACKING_STATUS.COMPLETE, DELIVERY_TRACKING_STATUS.INPROGRESS].includes(status),
      highLight: status === DELIVERY_TRACKING_STATUS.SCHEDULED,
      showArrow: status === DELIVERY_TRACKING_STATUS.SCHEDULED
    }), jsx(DeliveryTimeLineStep, {
      header: [`${targetTypeKorean}중`, canShowPassedWayPoints && jsx(ShowDetailButton, {
        isShowDetail: isShowDetail,
        onClick: () => setIsShowDetail(!isShowDetail)
      }, 1)],
      css: canShowPassedWayPoints && status === DELIVERY_TRACKING_STATUS.INPROGRESS && _ref2$d,
      highLight: status === DELIVERY_TRACKING_STATUS.INPROGRESS
      // 배송이 완료된 상태이거나 배송중이면서 하나 이상의 경유지를 방문하였을 경우
      ,
      fillPath: status === DELIVERY_TRACKING_STATUS.COMPLETE || status === DELIVERY_TRACKING_STATUS.INPROGRESS && isExistWayPoint
      // 배송중이지만 경유지 정보가 주어지지 않았을 경우
      ,
      showArrow: status === DELIVERY_TRACKING_STATUS.INPROGRESS && !isExistWayPoint,
      children: isShowDetail && jsx(PassedPointList, {
        children: passedWayPoints?.map((item, index) => jsx(DeliveryWayPoint, {
          ...item
        }, index))
      })
    }), recentWayPoint && status === DELIVERY_TRACKING_STATUS.INPROGRESS && jsx(DeliveryTimeLineStep, {
      highLight: true,
      showArrow: true,
      fillPath: false,
      children: jsx(DeliveryWayPoint, {
        ...recentWayPoint,
        currentLocation: true
      })
    }), jsx(DeliveryTimeLineStep, {
      header: `${targetTypeKorean}완료`,
      highLight: status === DELIVERY_TRACKING_STATUS.COMPLETE,
      showArrow: status === DELIVERY_TRACKING_STATUS.COMPLETE,
      fillPath: false,
      children: status === DELIVERY_TRACKING_STATUS.COMPLETE && recentWayPoint && jsx(DeliveryWayPoint, {
        css: _ref$y,
        ...recentWayPoint,
        position: "",
        currentLocation: true
      })
    })]
  });
}
function ShowDetailButton({
  isShowDetail,
  onClick
}) {
  const text = isShowDetail ? '접기' : '자세히보기';
  return jsxs(WayPointDetailButton, {
    onClick: onClick,
    children: [text, isShowDetail ? jsx(ChevronUpIcon, {
      className: "icon",
      size: 12,
      "data-testid": "chevron-up-icon"
    }) : jsx(ChevronDownIcon$1, {
      className: "icon",
      size: 12,
      "data-testid": "chevron-down-icon"
    })]
  });
}

// dot(.)을 기준으로 라인을 나누어 렌더링
function breakLines(message) {
  return message.split('.').map((line, index) => jsxs(Fragment$1, {
    children: [line, jsx("br", {})]
  }, index));
}
const WayPointDetailButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1k86jnz2"
} : {
  target: "e1k86jnz2",
  label: "WayPointDetailButton"
})(RESET_BUTTON, ";", FONT_STYLE.subTitle2, ";font-weight:400;margin-left:8px;margin-right:2px;color:", ({
  theme
}) => theme.content.base2, ";display:inline-flex;align-items:center;.icon{margin-left:2px;}");
const ErrorMessage = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1k86jnz1"
} : {
  target: "e1k86jnz1",
  label: "ErrorMessage"
})(FONT_STYLE.body2, ";color:", ({
  theme
}) => theme.content.base2, ";text-align:center;padding:24px 0;");
const PassedPointList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1k86jnz0"
} : {
  target: "e1k86jnz0",
  label: "PassedPointList"
})(process.env.NODE_ENV === "production" ? {
  name: "de9hf",
  styles: "padding-top:16px"
} : {
  name: "de9hf",
  styles: "padding-top:16px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1k
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$1j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function PhoneButton({
  phoneNumber,
  name
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = breakpoint === 'mobile' || breakpoint === 'tablet';
  const theme = useTheme();

  // FIXME 디자인시스템의 OutlineButtonWithIcon컴포넌트에서 anchoring을 정상 지원할 경우
  //  컴포넌트에서 처리
  //  관련 이슈 https://github.com/bucketplace/design-system/issues/238
  const handlePhoneCall = () => {
    const a = document.createElement('a');
    a.href = `tel:${phoneNumber}`;
    a.click();
  };
  return isMobile ? jsx(PhoneMobileButton, {
    text: name,
    icon: "call_outline",
    color: theme.content.base2,
    size: 40,
    full: true,
    variant: "base1",
    onClick: handlePhoneCall
  }) : jsxs(PhoneInfo, {
    children: [jsx("span", {
      className: "label",
      children: name
    }), jsx("span", {
      className: "phone-number",
      children: phoneNumber
    })]
  });
}
const PhoneMobileButton = /*#__PURE__*/_styled(OutlineButtonWithIcon, process.env.NODE_ENV === "production" ? {
  target: "eoi3ru91"
} : {
  target: "eoi3ru91",
  label: "PhoneMobileButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1ti5vbu",
  styles: "letter-spacing:-0.4px"
} : {
  name: "1ti5vbu",
  styles: "letter-spacing:-0.4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1j
});
const PhoneInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eoi3ru90"
} : {
  target: "eoi3ru90",
  label: "PhoneInfo"
})(FONT_STYLE.caption1, ";background-color:", ({
  theme
}) => theme.background.groupedBase, ";border-radius:4px;height:40px;display:flex;padding:0 20px;align-items:center;justify-content:center;flex:1 1 0;min-width:0;.label{color:", ({
  theme
}) => theme.content.base2, ";margin-right:4px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}.phone-number{white-space:nowrap;}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function DeliveryOrderInfo({
  productName,
  destinationAddress,
  optionName,
  receiverName,
  productImageUrl,
  sellerPhone,
  sellerName,
  quantity,
  onClickProduct,
  targetType
}) {
  const {
    breakpoint
  } = useResponsive({});
  const isMobile = ['mobile', 'tablet'].includes(breakpoint ?? '');
  const title = targetType === DELIVERY_TARGET_TYPE.PICKUP ? '수거정보' : '배송지정보';
  return jsxs(Wrapper, {
    children: [jsx(Header$2, {
      children: title
    }), jsxs(InfoRow, {
      children: [jsx(InfoLabel, {
        children: "\uC8FC\uC18C"
      }), destinationAddress]
    }), jsxs(InfoRow, {
      children: [jsx(InfoLabel, {
        children: "\uBC1B\uB294 \uC0AC\uB78C"
      }), receiverName]
    }), jsxs(Content$3, {
      onClick: onClickProduct,
      children: [jsx(ProductImage, {
        alt: `${productName}`,
        src: productImageUrl ?? ''
      }), jsxs(ProductExplanation, {
        children: [jsx(ProductName, {
          children: productName
        }), jsx(OptionName, {
          children: `${optionName} • ${quantity}개`
        })]
      })]
    }), jsxs(PhoneNumbersWrapper, {
      children: [sellerPhone && jsx(PhoneButton, {
        phoneNumber: formatPhoneNumber(sellerPhone),
        name: isMobile ? '판매자 전화문의' : sellerName ?? ''
      }), jsx(PhoneButton, {
        phoneNumber: "1670-0876",
        name: "\uC624\uB298\uC758\uC9D1 \uACE0\uAC1D\uC13C\uD130"
      })]
    })]
  });
}
const Wrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx9"
} : {
  target: "e1yc6enx9",
  label: "Wrapper"
})("color:", ({
  theme
}) => theme.content.base1, ";");
const Header$2 = /*#__PURE__*/_styled("h2", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx8"
} : {
  target: "e1yc6enx8",
  label: "Header"
})(FONT_STYLE.subTitle1, ";font-weight:bold;margin-bottom:20px;");
const InfoRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx7"
} : {
  target: "e1yc6enx7",
  label: "InfoRow"
})("display:flex;", FONT_STYLE.body1_small, ";margin-bottom:6px;&:nth-of-type(2){margin-bottom:20px;}");
const InfoLabel = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx6"
} : {
  target: "e1yc6enx6",
  label: "InfoLabel"
})("display:inherit;min-width:68px;color:", ({
  theme
}) => theme.content.base2, ";");
const ProductImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx5"
} : {
  target: "e1yc6enx5",
  label: "ProductImage"
})(process.env.NODE_ENV === "production" ? {
  name: "1vc19v7",
  styles: "flex-shrink:0;width:54px;height:54px;border-radius:4px;margin-right:10px"
} : {
  name: "1vc19v7",
  styles: "flex-shrink:0;width:54px;height:54px;border-radius:4px;margin-right:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1i
});
const PhoneNumbersWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx4"
} : {
  target: "e1yc6enx4",
  label: "PhoneNumbersWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "mapv73",
  styles: "display:flex;column-gap:12px"
} : {
  name: "mapv73",
  styles: "display:flex;column-gap:12px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1i
});
const Content$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx3"
} : {
  target: "e1yc6enx3",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "oyqoge",
  styles: "display:flex;padding-bottom:20px;cursor:pointer"
} : {
  name: "oyqoge",
  styles: "display:flex;padding-bottom:20px;cursor:pointer",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1i
});
const ProductExplanation = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx2"
} : {
  target: "e1yc6enx2",
  label: "ProductExplanation"
})(FONT_STYLE.body2, ";");
const ProductName = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx1"
} : {
  target: "e1yc6enx1",
  label: "ProductName"
})("font-weight:500;color:", ({
  theme
}) => theme.content.base1, ";");
const OptionName = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yc6enx0"
} : {
  target: "e1yc6enx0",
  label: "OptionName"
})("font-weight:400;color:", ({
  theme
}) => theme.content.base2, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DeliveryTrackingLoadFail = ({
  handleButtonClick,
  title
}) => {
  return jsxs(Fragment, {
    children: [!isInApp() && title && jsx(WebViewTitle, {
      children: title
    }), jsxs(LoadingWrapper, {
      children: [jsx(Title$b, {
        children: "\uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694."
      }), jsxs(Text, {
        children: ["\uC5F0\uB3D9 \uC815\uBCF4 \uC870\uD68C \uC911 \uC77C\uC2DC\uC801\uC778 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694.", jsx("br", {}), "\uC0C8\uB85C\uACE0\uCE68\uC744 \uD074\uB9AD\uD574\uC8FC\uC138\uC694."]
      }), jsx(RefreshButton, {
        size: 44,
        variant: "primary1",
        onClick: handleButtonClick,
        children: "\uC0C8\uB85C\uACE0\uCE68"
      })]
    })]
  });
};
const LoadingWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty4"
} : {
  target: "e1ewtnty4",
  label: "LoadingWrapper"
})("width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;height:calc(100vh - 80px);", MEDIA_QUERY.max('tablet', process.env.NODE_ENV === "production" ? {
  name: "lohfg0",
  styles: "height:calc(100vh - 50px)"
} : {
  name: "1kegrpo-LoadingWrapper",
  styles: "height:calc(100vh - 50px);label:LoadingWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1h
}), ";");
const WebViewTitle = /*#__PURE__*/_styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty3"
} : {
  target: "e1ewtnty3",
  label: "WebViewTitle"
})(FONT_STYLE.subTitle1, ";border-bottom:1px solid ", ({
  theme
}) => theme.content.base4, ";height:45px;display:flex;align-items:center;justify-content:center;font-weight:bold;");
const Title$b = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty2"
} : {
  target: "e1ewtnty2",
  label: "Title"
})(FONT_STYLE.title2, ";font-weight:600;", MEDIA_QUERY.max('tablet', process.env.NODE_ENV === "production" ? {
  name: "mmvz9h",
  styles: "font-weight:400"
} : {
  name: "7uheje-Title",
  styles: "font-weight:400;label:Title;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1h
}), ";");
const Text = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty1"
} : {
  target: "e1ewtnty1",
  label: "Text"
})(FONT_STYLE.body1_1, ";margin-top:8px;text-align:center;color:", ({
  theme
}) => theme.content.base2, ";", MEDIA_QUERY.max('tablet', /*#__PURE__*/css(FONT_STYLE.body2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Text;"))), ";");
const RefreshButton = /*#__PURE__*/_styled(Button$9, process.env.NODE_ENV === "production" ? {
  target: "e1ewtnty0"
} : {
  target: "e1ewtnty0",
  label: "RefreshButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : {
  name: "1r0yqr6",
  styles: "margin-top:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1h
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$1g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DELIVERY_TARGET_TYPE_NAME = {
  ORDER: '배송',
  PICKUP: '수거',
  REDELIVERY: '재배송'
};
function DeliveryTrackingTemplate({
  deliveryTargetType,
  summaryElement,
  timelineElement,
  orderInfoElement
}) {
  const targetTypeKorean = DELIVERY_TARGET_TYPE_NAME[deliveryTargetType];
  const title = `${targetTypeKorean}조회`;
  return jsx(BackgroundLayout, {
    children: jsxs(ContentWrapper, {
      children: [!isInApp() && jsx(Title$a, {
        children: title
      }), jsxs(Content$2, {
        children: [summaryElement, timelineElement]
      }), jsx(Divider, {
        variant: "thick"
      }), jsx(Content$2, {
        children: orderInfoElement
      })]
    })
  });
}
const BackgroundLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq3"
} : {
  target: "e1v1izdq3",
  label: "BackgroundLayout"
})("background-color:", ({
  theme
}) => theme.background.groupedBase, ";height:auto;min-height:100vh;");
const ContentWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq2"
} : {
  target: "e1v1izdq2",
  label: "ContentWrapper"
})("max-width:500px;height:auto;min-height:100vh;background-color:", ({
  theme
}) => theme.background.base, ";margin-left:auto;margin-right:auto;");
const Content$2 = /*#__PURE__*/_styled("section", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq1"
} : {
  target: "e1v1izdq1",
  label: "Content"
})("padding:24px 20px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "9zbbnr",
  styles: "padding:24px 16px"
} : {
  name: "ik3grn-Content",
  styles: "padding:24px 16px;label:Content;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1g
}), ";");
const Title$a = /*#__PURE__*/_styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e1v1izdq0"
} : {
  target: "e1v1izdq0",
  label: "Title"
})(FONT_STYLE.subTitle1, ";border-bottom:1px solid ", ({
  theme
}) => theme.content.base4, ";height:45px;display:flex;align-items:center;justify-content:center;font-weight:bold;");

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// Loads Kakao API on demand.
const KAKAO_API_SRC = '//developers.kakao.com/sdk/js/kakao.min.js';
const KAKAO_AUTH_TOKEN = '3019c756ec77dd7e0a24e56d9d784f77';
let kakaoAPILoading = null;
let initialized = false;
function getKakaoAPI() {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.Kakao;
}
function loadKakaoAPI() {
  if (window.Kakao != null) {
    if (!initialized) {
      try {
        Kakao.init(KAKAO_AUTH_TOKEN);
      } catch (e) {
        //
      }
      initialized = true;
    }
    return Promise.resolve(window.Kakao);
  } else if (kakaoAPILoading != null) {
    return kakaoAPILoading;
  } else {
    kakaoAPILoading = new Promise(resolve => {
      // Load the script from daum...
      const script = document.createElement('script');
      script.addEventListener('load', () => {
        const Kakao = window.Kakao;
        Kakao.init(KAKAO_AUTH_TOKEN);
        initialized = true;
        resolve(Kakao);
      });
      script.src = KAKAO_API_SRC;
      document.body.appendChild(script);
    });
    return kakaoAPILoading;
  }
}
function useKakaoAPI(onUpdate) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!loaded) {
      loadKakaoAPI().then(() => {
        setLoaded(true);
        if (onUpdate != null) {
          onUpdate();
        }
      });
    }
  }, []);
  return getKakaoAPI();
}

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var qrcodegen;
(qrcodegen2 => {
  const _QrCode = class {
    constructor(version, errorCorrectionLevel, dataCodewords, msk) {
      this.version = version;
      this.errorCorrectionLevel = errorCorrectionLevel;
      this.modules = [];
      this.isFunction = [];
      if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
      if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
      this.size = version * 4 + 17;
      let row = [];
      for (let i = 0; i < this.size; i++) row.push(false);
      for (let i = 0; i < this.size; i++) {
        this.modules.push(row.slice());
        this.isFunction.push(row.slice());
      }
      this.drawFunctionPatterns();
      const allCodewords = this.addEccAndInterleave(dataCodewords);
      this.drawCodewords(allCodewords);
      if (msk == -1) {
        let minPenalty = 1e9;
        for (let i = 0; i < 8; i++) {
          this.applyMask(i);
          this.drawFormatBits(i);
          const penalty = this.getPenaltyScore();
          if (penalty < minPenalty) {
            msk = i;
            minPenalty = penalty;
          }
          this.applyMask(i);
        }
      }
      assert(0 <= msk && msk <= 7);
      this.mask = msk;
      this.applyMask(msk);
      this.drawFormatBits(msk);
      this.isFunction = [];
    }
    static encodeText(text, ecl) {
      const segs = qrcodegen2.QrSegment.makeSegments(text);
      return _QrCode.encodeSegments(segs, ecl);
    }
    static encodeBinary(data, ecl) {
      const seg = qrcodegen2.QrSegment.makeBytes(data);
      return _QrCode.encodeSegments([seg], ecl);
    }
    static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
      if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
      let version;
      let dataUsedBits;
      for (version = minVersion;; version++) {
        const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
        const usedBits = QrSegment.getTotalBits(segs, version);
        if (usedBits <= dataCapacityBits2) {
          dataUsedBits = usedBits;
          break;
        }
        if (version >= maxVersion) throw new RangeError("Data too long");
      }
      for (const newEcl of [_QrCode.Ecc.MEDIUM, _QrCode.Ecc.QUARTILE, _QrCode.Ecc.HIGH]) {
        if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
      }
      let bb = [];
      for (const seg of segs) {
        appendBits(seg.mode.modeBits, 4, bb);
        appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
        for (const b of seg.getData()) bb.push(b);
      }
      assert(bb.length == dataUsedBits);
      const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
      assert(bb.length <= dataCapacityBits);
      appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
      appendBits(0, (8 - bb.length % 8) % 8, bb);
      assert(bb.length % 8 == 0);
      for (let padByte = 236; bb.length < dataCapacityBits; padByte ^= 236 ^ 17) appendBits(padByte, 8, bb);
      let dataCodewords = [];
      while (dataCodewords.length * 8 < bb.length) dataCodewords.push(0);
      bb.forEach((b, i) => dataCodewords[i >>> 3] |= b << 7 - (i & 7));
      return new _QrCode(version, ecl, dataCodewords, mask);
    }
    getModule(x, y) {
      return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
    }
    getModules() {
      return this.modules;
    }
    drawFunctionPatterns() {
      for (let i = 0; i < this.size; i++) {
        this.setFunctionModule(6, i, i % 2 == 0);
        this.setFunctionModule(i, 6, i % 2 == 0);
      }
      this.drawFinderPattern(3, 3);
      this.drawFinderPattern(this.size - 4, 3);
      this.drawFinderPattern(3, this.size - 4);
      const alignPatPos = this.getAlignmentPatternPositions();
      const numAlign = alignPatPos.length;
      for (let i = 0; i < numAlign; i++) {
        for (let j = 0; j < numAlign; j++) {
          if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
        }
      }
      this.drawFormatBits(0);
      this.drawVersion();
    }
    drawFormatBits(mask) {
      const data = this.errorCorrectionLevel.formatBits << 3 | mask;
      let rem = data;
      for (let i = 0; i < 10; i++) rem = rem << 1 ^ (rem >>> 9) * 1335;
      const bits = (data << 10 | rem) ^ 21522;
      assert(bits >>> 15 == 0);
      for (let i = 0; i <= 5; i++) this.setFunctionModule(8, i, getBit(bits, i));
      this.setFunctionModule(8, 7, getBit(bits, 6));
      this.setFunctionModule(8, 8, getBit(bits, 7));
      this.setFunctionModule(7, 8, getBit(bits, 8));
      for (let i = 9; i < 15; i++) this.setFunctionModule(14 - i, 8, getBit(bits, i));
      for (let i = 0; i < 8; i++) this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
      for (let i = 8; i < 15; i++) this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
      this.setFunctionModule(8, this.size - 8, true);
    }
    drawVersion() {
      if (this.version < 7) return;
      let rem = this.version;
      for (let i = 0; i < 12; i++) rem = rem << 1 ^ (rem >>> 11) * 7973;
      const bits = this.version << 12 | rem;
      assert(bits >>> 18 == 0);
      for (let i = 0; i < 18; i++) {
        const color = getBit(bits, i);
        const a = this.size - 11 + i % 3;
        const b = Math.floor(i / 3);
        this.setFunctionModule(a, b, color);
        this.setFunctionModule(b, a, color);
      }
    }
    drawFinderPattern(x, y) {
      for (let dy = -4; dy <= 4; dy++) {
        for (let dx = -4; dx <= 4; dx++) {
          const dist = Math.max(Math.abs(dx), Math.abs(dy));
          const xx = x + dx;
          const yy = y + dy;
          if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
        }
      }
    }
    drawAlignmentPattern(x, y) {
      for (let dy = -2; dy <= 2; dy++) {
        for (let dx = -2; dx <= 2; dx++) this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
      }
    }
    setFunctionModule(x, y, isDark) {
      this.modules[y][x] = isDark;
      this.isFunction[y][x] = true;
    }
    addEccAndInterleave(data) {
      const ver = this.version;
      const ecl = this.errorCorrectionLevel;
      if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
      const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
      const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
      const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
      const numShortBlocks = numBlocks - rawCodewords % numBlocks;
      const shortBlockLen = Math.floor(rawCodewords / numBlocks);
      let blocks = [];
      const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
      for (let i = 0, k = 0; i < numBlocks; i++) {
        let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
        k += dat.length;
        const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
        if (i < numShortBlocks) dat.push(0);
        blocks.push(dat.concat(ecc));
      }
      let result = [];
      for (let i = 0; i < blocks[0].length; i++) {
        blocks.forEach((block, j) => {
          if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
        });
      }
      assert(result.length == rawCodewords);
      return result;
    }
    drawCodewords(data) {
      if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
      let i = 0;
      for (let right = this.size - 1; right >= 1; right -= 2) {
        if (right == 6) right = 5;
        for (let vert = 0; vert < this.size; vert++) {
          for (let j = 0; j < 2; j++) {
            const x = right - j;
            const upward = (right + 1 & 2) == 0;
            const y = upward ? this.size - 1 - vert : vert;
            if (!this.isFunction[y][x] && i < data.length * 8) {
              this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
              i++;
            }
          }
        }
      }
      assert(i == data.length * 8);
    }
    applyMask(mask) {
      if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
      for (let y = 0; y < this.size; y++) {
        for (let x = 0; x < this.size; x++) {
          let invert;
          switch (mask) {
            case 0:
              invert = (x + y) % 2 == 0;
              break;
            case 1:
              invert = y % 2 == 0;
              break;
            case 2:
              invert = x % 3 == 0;
              break;
            case 3:
              invert = (x + y) % 3 == 0;
              break;
            case 4:
              invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
              break;
            case 5:
              invert = x * y % 2 + x * y % 3 == 0;
              break;
            case 6:
              invert = (x * y % 2 + x * y % 3) % 2 == 0;
              break;
            case 7:
              invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
        }
      }
    }
    getPenaltyScore() {
      let result = 0;
      for (let y = 0; y < this.size; y++) {
        let runColor = false;
        let runX = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let x = 0; x < this.size; x++) {
          if (this.modules[y][x] == runColor) {
            runX++;
            if (runX == 5) result += _QrCode.PENALTY_N1;else if (runX > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runX, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runX = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let x = 0; x < this.size; x++) {
        let runColor = false;
        let runY = 0;
        let runHistory = [0, 0, 0, 0, 0, 0, 0];
        for (let y = 0; y < this.size; y++) {
          if (this.modules[y][x] == runColor) {
            runY++;
            if (runY == 5) result += _QrCode.PENALTY_N1;else if (runY > 5) result++;
          } else {
            this.finderPenaltyAddHistory(runY, runHistory);
            if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
            runColor = this.modules[y][x];
            runY = 1;
          }
        }
        result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
      }
      for (let y = 0; y < this.size - 1; y++) {
        for (let x = 0; x < this.size - 1; x++) {
          const color = this.modules[y][x];
          if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
        }
      }
      let dark = 0;
      for (const row of this.modules) dark = row.reduce((sum, color) => sum + (color ? 1 : 0), dark);
      const total = this.size * this.size;
      const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
      assert(0 <= k && k <= 9);
      result += k * _QrCode.PENALTY_N4;
      assert(0 <= result && result <= 2568888);
      return result;
    }
    getAlignmentPatternPositions() {
      if (this.version == 1) return [];else {
        const numAlign = Math.floor(this.version / 7) + 2;
        const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
        let result = [6];
        for (let pos = this.size - 7; result.length < numAlign; pos -= step) result.splice(1, 0, pos);
        return result;
      }
    }
    static getNumRawDataModules(ver) {
      if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
      let result = (16 * ver + 128) * ver + 64;
      if (ver >= 2) {
        const numAlign = Math.floor(ver / 7) + 2;
        result -= (25 * numAlign - 10) * numAlign - 55;
        if (ver >= 7) result -= 36;
      }
      assert(208 <= result && result <= 29648);
      return result;
    }
    static getNumDataCodewords(ver, ecl) {
      return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
    }
    static reedSolomonComputeDivisor(degree) {
      if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
      let result = [];
      for (let i = 0; i < degree - 1; i++) result.push(0);
      result.push(1);
      let root = 1;
      for (let i = 0; i < degree; i++) {
        for (let j = 0; j < result.length; j++) {
          result[j] = _QrCode.reedSolomonMultiply(result[j], root);
          if (j + 1 < result.length) result[j] ^= result[j + 1];
        }
        root = _QrCode.reedSolomonMultiply(root, 2);
      }
      return result;
    }
    static reedSolomonComputeRemainder(data, divisor) {
      let result = divisor.map(_ => 0);
      for (const b of data) {
        const factor = b ^ result.shift();
        result.push(0);
        divisor.forEach((coef, i) => result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
      }
      return result;
    }
    static reedSolomonMultiply(x, y) {
      if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
      let z = 0;
      for (let i = 7; i >= 0; i--) {
        z = z << 1 ^ (z >>> 7) * 285;
        z ^= (y >>> i & 1) * x;
      }
      assert(z >>> 8 == 0);
      return z;
    }
    finderPenaltyCountPatterns(runHistory) {
      const n = runHistory[1];
      assert(n <= this.size * 3);
      const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
      return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
    }
    finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
      if (currentRunColor) {
        this.finderPenaltyAddHistory(currentRunLength, runHistory);
        currentRunLength = 0;
      }
      currentRunLength += this.size;
      this.finderPenaltyAddHistory(currentRunLength, runHistory);
      return this.finderPenaltyCountPatterns(runHistory);
    }
    finderPenaltyAddHistory(currentRunLength, runHistory) {
      if (runHistory[0] == 0) currentRunLength += this.size;
      runHistory.pop();
      runHistory.unshift(currentRunLength);
    }
  };
  let QrCode = _QrCode;
  QrCode.MIN_VERSION = 1;
  QrCode.MAX_VERSION = 40;
  QrCode.PENALTY_N1 = 3;
  QrCode.PENALTY_N2 = 3;
  QrCode.PENALTY_N3 = 40;
  QrCode.PENALTY_N4 = 10;
  QrCode.ECC_CODEWORDS_PER_BLOCK = [[-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28], [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]];
  QrCode.NUM_ERROR_CORRECTION_BLOCKS = [[-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25], [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49], [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68], [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]];
  qrcodegen2.QrCode = QrCode;
  function appendBits(val, len, bb) {
    if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
    for (let i = len - 1; i >= 0; i--) bb.push(val >>> i & 1);
  }
  function getBit(x, i) {
    return (x >>> i & 1) != 0;
  }
  function assert(cond) {
    if (!cond) throw new Error("Assertion error");
  }
  const _QrSegment = class {
    constructor(mode, numChars, bitData) {
      this.mode = mode;
      this.numChars = numChars;
      this.bitData = bitData;
      if (numChars < 0) throw new RangeError("Invalid argument");
      this.bitData = bitData.slice();
    }
    static makeBytes(data) {
      let bb = [];
      for (const b of data) appendBits(b, 8, bb);
      return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
    }
    static makeNumeric(digits) {
      if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
      let bb = [];
      for (let i = 0; i < digits.length;) {
        const n = Math.min(digits.length - i, 3);
        appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
        i += n;
      }
      return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
    }
    static makeAlphanumeric(text) {
      if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let bb = [];
      let i;
      for (i = 0; i + 2 <= text.length; i += 2) {
        let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
        temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
        appendBits(temp, 11, bb);
      }
      if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
      return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
    }
    static makeSegments(text) {
      if (text == "") return [];else if (_QrSegment.isNumeric(text)) return [_QrSegment.makeNumeric(text)];else if (_QrSegment.isAlphanumeric(text)) return [_QrSegment.makeAlphanumeric(text)];else return [_QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))];
    }
    static makeEci(assignVal) {
      let bb = [];
      if (assignVal < 0) throw new RangeError("ECI assignment value out of range");else if (assignVal < 1 << 7) appendBits(assignVal, 8, bb);else if (assignVal < 1 << 14) {
        appendBits(2, 2, bb);
        appendBits(assignVal, 14, bb);
      } else if (assignVal < 1e6) {
        appendBits(6, 3, bb);
        appendBits(assignVal, 21, bb);
      } else throw new RangeError("ECI assignment value out of range");
      return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
    }
    static isNumeric(text) {
      return _QrSegment.NUMERIC_REGEX.test(text);
    }
    static isAlphanumeric(text) {
      return _QrSegment.ALPHANUMERIC_REGEX.test(text);
    }
    getData() {
      return this.bitData.slice();
    }
    static getTotalBits(segs, version) {
      let result = 0;
      for (const seg of segs) {
        const ccbits = seg.mode.numCharCountBits(version);
        if (seg.numChars >= 1 << ccbits) return Infinity;
        result += 4 + ccbits + seg.bitData.length;
      }
      return result;
    }
    static toUtf8ByteArray(str) {
      str = encodeURI(str);
      let result = [];
      for (let i = 0; i < str.length; i++) {
        if (str.charAt(i) != "%") result.push(str.charCodeAt(i));else {
          result.push(parseInt(str.substr(i + 1, 2), 16));
          i += 2;
        }
      }
      return result;
    }
  };
  let QrSegment = _QrSegment;
  QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
  QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
  QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  qrcodegen2.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));
(qrcodegen2 => {
  (QrCode2 => {
    const _Ecc = class {
      constructor(ordinal, formatBits) {
        this.ordinal = ordinal;
        this.formatBits = formatBits;
      }
    };
    let Ecc = _Ecc;
    Ecc.LOW = new _Ecc(0, 1);
    Ecc.MEDIUM = new _Ecc(1, 0);
    Ecc.QUARTILE = new _Ecc(2, 3);
    Ecc.HIGH = new _Ecc(3, 2);
    QrCode2.Ecc = Ecc;
  })(qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
(qrcodegen2 => {
  (QrSegment2 => {
    const _Mode = class {
      constructor(modeBits, numBitsCharCount) {
        this.modeBits = modeBits;
        this.numBitsCharCount = numBitsCharCount;
      }
      numCharCountBits(ver) {
        return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
      }
    };
    let Mode = _Mode;
    Mode.NUMERIC = new _Mode(1, [10, 12, 14]);
    Mode.ALPHANUMERIC = new _Mode(2, [9, 11, 13]);
    Mode.BYTE = new _Mode(4, [8, 16, 16]);
    Mode.KANJI = new _Mode(8, [8, 10, 12]);
    Mode.ECI = new _Mode(7, [0, 0, 0]);
    QrSegment2.Mode = Mode;
  })(qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var qrcodegen_default = qrcodegen;

// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var ERROR_LEVEL_MAP = {
  L: qrcodegen_default.QrCode.Ecc.LOW,
  M: qrcodegen_default.QrCode.Ecc.MEDIUM,
  Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
  H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE$1 = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var MARGIN_SIZE = 4;
var DEFAULT_IMG_SCALE = 0.1;
function generatePath(modules, margin = 0) {
  const ops = [];
  modules.forEach(function (row, y) {
    let start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
        start = null;
        return;
      }
      if (x === row.length - 1) {
        if (!cell) {
          return;
        }
        if (start === null) {
          ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
        } else {
          ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
        }
        return;
      }
      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join("");
}
function excavateModules(modules, excavation) {
  return modules.slice().map((row, y) => {
    if (y < excavation.y || y >= excavation.y + excavation.h) {
      return row;
    }
    return row.map((cell, x) => {
      if (x < excavation.x || x >= excavation.x + excavation.w) {
        return cell;
      }
      return false;
    });
  });
}
function getImageSettings(cells, size, includeMargin, imageSettings) {
  if (imageSettings == null) {
    return null;
  }
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
  const scale = numCells / size;
  const w = (imageSettings.width || defaultSize) * scale;
  const h = (imageSettings.height || defaultSize) * scale;
  const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
  const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
  let excavation = null;
  if (imageSettings.excavate) {
    let floorX = Math.floor(x);
    let floorY = Math.floor(y);
    let ceilW = Math.ceil(w + x - floorX);
    let ceilH = Math.ceil(h + y - floorY);
    excavation = {
      x: floorX,
      y: floorY,
      w: ceilW,
      h: ceilH
    };
  }
  return {
    x,
    y,
    h,
    w,
    excavation
  };
}
var SUPPORTS_PATH2D = function () {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return false;
  }
  return true;
}();
function QRCodeCanvas(props) {
  const _a = props,
    {
      value,
      size = DEFAULT_SIZE$1,
      level = DEFAULT_LEVEL,
      bgColor = DEFAULT_BGCOLOR,
      fgColor = DEFAULT_FGCOLOR,
      includeMargin = DEFAULT_INCLUDEMARGIN,
      style,
      imageSettings
    } = _a,
    otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "style", "imageSettings"]);
  const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
  const _canvas = useRef(null);
  const _image = useRef(null);
  const [isImgLoaded, setIsImageLoaded] = useState(false);
  useEffect(() => {
    if (_canvas.current != null) {
      const canvas = _canvas.current;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return;
      }
      let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
      const margin = includeMargin ? MARGIN_SIZE : 0;
      const numCells = cells.length + margin * 2;
      const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
      const image = _image.current;
      const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
      if (haveImageToRender) {
        if (calculatedImageSettings.excavation != null) {
          cells = excavateModules(cells, calculatedImageSettings.excavation);
        }
      }
      const pixelRatio = window.devicePixelRatio || 1;
      canvas.height = canvas.width = size * pixelRatio;
      const scale = size / numCells * pixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = fgColor;
      if (SUPPORTS_PATH2D) {
        ctx.fill(new Path2D(generatePath(cells, margin)));
      } else {
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }
      if (haveImageToRender) {
        ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
      }
    }
  });
  useEffect(() => {
    setIsImageLoaded(false);
  }, [imgSrc]);
  const canvasStyle = __spreadValues({
    height: size,
    width: size
  }, style);
  let img = null;
  if (imgSrc != null) {
    img = /* @__PURE__ */React__default.createElement("img", {
      src: imgSrc,
      key: imgSrc,
      style: {
        display: "none"
      },
      onLoad: () => {
        setIsImageLoaded(true);
      },
      ref: _image
    });
  }
  return /* @__PURE__ */React__default.createElement(React__default.Fragment, null, /* @__PURE__ */React__default.createElement("canvas", __spreadValues({
    style: canvasStyle,
    height: size,
    width: size,
    ref: _canvas
  }, otherProps)), img);
}
function QRCodeSVG(props) {
  const _a = props,
    {
      value,
      size = DEFAULT_SIZE$1,
      level = DEFAULT_LEVEL,
      bgColor = DEFAULT_BGCOLOR,
      fgColor = DEFAULT_FGCOLOR,
      includeMargin = DEFAULT_INCLUDEMARGIN,
      imageSettings
    } = _a,
    otherProps = __objRest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin", "imageSettings"]);
  let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
  const margin = includeMargin ? MARGIN_SIZE : 0;
  const numCells = cells.length + margin * 2;
  const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
  let image = null;
  if (imageSettings != null && calculatedImageSettings != null) {
    if (calculatedImageSettings.excavation != null) {
      cells = excavateModules(cells, calculatedImageSettings.excavation);
    }
    image = /* @__PURE__ */React__default.createElement("image", {
      xlinkHref: imageSettings.src,
      height: calculatedImageSettings.h,
      width: calculatedImageSettings.w,
      x: calculatedImageSettings.x + margin,
      y: calculatedImageSettings.y + margin,
      preserveAspectRatio: "none"
    });
  }
  const fgPath = generatePath(cells, margin);
  return /* @__PURE__ */React__default.createElement("svg", __spreadValues({
    height: size,
    width: size,
    viewBox: `0 0 ${numCells} ${numCells}`
  }, otherProps), /* @__PURE__ */React__default.createElement("path", {
    fill: bgColor,
    d: `M0,0 h${numCells}v${numCells}H0z`,
    shapeRendering: "crispEdges"
  }), /* @__PURE__ */React__default.createElement("path", {
    fill: fgColor,
    d: fgPath,
    shapeRendering: "crispEdges"
  }), image);
}
var QRCode = props => {
  const _a = props,
    {
      renderAs
    } = _a,
    otherProps = __objRest(_a, ["renderAs"]);
  if (renderAs === "svg") {
    return /* @__PURE__ */React__default.createElement(QRCodeSVG, __spreadValues({}, otherProps));
  }
  return /* @__PURE__ */React__default.createElement(QRCodeCanvas, __spreadValues({}, otherProps));
};

const LogoIcon$1 = props => jsx("svg", {
  className: "icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  preserveAspectRatio: "xMidYMid meet",
  ...props,
  children: jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [jsx("path", {
      fill: "#35C5F0",
      d: "M16.41 0H3.59A3.59 3.59 0 0 0 0 3.59v12.82A3.59 3.59 0 0 0 3.59 20h12.82A3.59 3.59 0 0 0 20 16.41V3.59A3.59 3.59 0 0 0 16.41 0"
    }), jsx("path", {
      fill: "#FFF",
      d: "M14.75 10.34c-.74 0-1.33-.6-1.33-1.34 0-.74.6-1.34 1.33-1.34s1.32.6 1.32 1.34c0 .74-.59 1.34-1.32 1.34zm-1 3.53H6.12V8.75l3.82-2.7 2.2 1.55a3.01 3.01 0 0 0-.35 1.4 3 3 0 0 0 1.98 2.83v2.04zm1-7.87c-.34 0-.66.06-.97.17l-3.17-2.24a1.18 1.18 0 0 0-1.35 0L4.5 7.28a1.2 1.2 0 0 0-.51.98v6.54c0 .66.53 1.2 1.19 1.2h9.5a1.2 1.2 0 0 0 1.18-1.2v-3.02A3 3 0 0 0 17.7 9c0-1.65-1.32-3-2.96-3z"
    })]
  })
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$1f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const AppDownloadPopupWithQR = ({
  deeplink,
  isOpen,
  isMobileDevice,
  onClose,
  actionType,
  localeData
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleDownloadApp = () => {
    O$1({
      category: 'click',
      url: window.location.href,
      section: '앱 QR 모달',
      section_id: 'MODAL_APP_QR',
      type: 'button',
      id: 'app',
      data: {
        object_group: '팝업 액션',
        object_group_id: actionType
      }
    });
    window.location.href = deeplink;
  };
  const action = isMobileDevice ? {
    primary: {
      text: localeData.popupWebToAppBtn02,
      onClick: handleDownloadApp
    }
  } : undefined;
  const handleBlur = () => {
    O$1({
      category: 'click',
      url: window.location.href,
      section: '앱 QR 모달',
      section_id: 'MODAL_APP_QR',
      type: 'grey_zone',
      id: 'close'
    });
    onClose();
  };
  useEffect(() => {
    if (isOpen) {
      O$1({
        category: 'impression',
        url: window.location.href,
        type: '앱 QR 모달',
        id: 'MODAL_APP_QR',
        data: [{
          object_group: '팝업 액션',
          object_group_id: actionType
        }]
      });
      logAmplitude$1('Pop-up', {
        action_name: actionType
      });
    }
  }, [isOpen, actionType]);
  if (!isOpen) {
    return null;
  }
  return jsx(Modal, {
    width: 400,
    footer: {
      action
    },
    disableBackgroundScroll: isOpen,
    onBlur: handleBlur,
    role: "dialog",
    children: jsxs(Container$p, {
      children: [isMobileDevice ? jsx(Logo$2, {
        "data-testid": "logo"
      }) : jsxs(Fragment, {
        children: [jsx(Title$9, {
          children: localeData.popupWebToAppTitleScan
        }), jsx(QRCode, {
          "data-testid": "qr",
          value: deeplink,
          size: isMobile ? 64 : 80
        })]
      }), jsx(Description$2, {
        children: localeData.popupWebToAppTitle
      })]
    })
  });
};
const Container$p = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2lc0f63"
} : {
  target: "e2lc0f63",
  label: "Container"
})("padding:30px 16px 10px 16px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "1b5azyf",
  styles: "padding:20px 16px 0 16px"
} : {
  name: "168ylpe-Container",
  styles: "padding:20px 16px 0 16px;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1f
}), ";");
const Title$9 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2lc0f62"
} : {
  target: "e2lc0f62",
  label: "Title"
})(FONT_STYLE.title3, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";");
const Description$2 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e2lc0f61"
} : {
  target: "e2lc0f61",
  label: "Description"
})(FONT_STYLE.body1_small, ";font-weight:500;white-space:pre-wrap;color:", ({
  theme
}) => theme.content.base1, ";");
const Logo$2 = /*#__PURE__*/_styled(LogoIcon$1, process.env.NODE_ENV === "production" ? {
  target: "e2lc0f60"
} : {
  target: "e2lc0f60",
  label: "Logo"
})("width:64px;height:64px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "1e9n0ny",
  styles: "width:80px;height:80px"
} : {
  name: "a91dqi-Logo",
  styles: "width:80px;height:80px;label:Logo;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1f
}), ";");

function BlockedPage({
  className,
  title,
  description,
  exit
}) {
  return jsxs(Container$o, {
    className: className,
    children: [jsx(Title$8, {
      children: title
    }), jsx(Description$1, {
      children: description
    }), exit && jsx(Responsive, {
      mobile: jsx(ExitButton, {
        size: 32,
        variant: "primary1",
        onClick: exit.onClick,
        children: exit.text
      }),
      tablet: jsx(ExitButton, {
        size: 30,
        variant: "primary1",
        onClick: exit.onClick,
        children: exit.text
      })
    })]
  });
}
const Container$o = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi3"
} : {
  target: "eqn4bhi3",
  label: "Container"
})("width:100%;max-width:", pxToRem(300), ";margin:", pxToRem(140), " auto;padding:0 ", pxToRem(40), ";box-sizing:border-box;text-align:center;word-break:keep-all;word-wrap:break-word;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("max-width:", pxToRem(500), ";margin-top:", pxToRem(200), ";margin-bottom:", pxToRem(200), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"))), ";");
const Title$8 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi2"
} : {
  target: "eqn4bhi2",
  label: "Title"
})("margin-bottom:", pxToRem(8), ";", FONT_STYLE.subTitle1, ";font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.title3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Title;"))), ";");
const Description$1 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi1"
} : {
  target: "eqn4bhi1",
  label: "Description"
})("margin:", pxToRem(8), " 0 ", pxToRem(13), ";", FONT_STYLE.body2, ";color:", ({
  theme
}) => theme.content.base1, ";white-space:pre-line;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.body1_1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Description;"))), ";");
const ExitButton = /*#__PURE__*/_styled(TextButton, process.env.NODE_ENV === "production" ? {
  target: "eqn4bhi0"
} : {
  target: "eqn4bhi0",
  label: "ExitButton"
})("margin:", pxToRem(7), " 0 0;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChipListModule = ({
  chipListInfo,
  onClick,
  ...rest
}) => {
  const {
    label,
    chipList
  } = chipListInfo;
  return jsxs(Container$n, {
    ...rest,
    children: [label && jsx(Label$2, {
      children: label
    }), jsx(ChipList, {
      children: chipList.map(({
        chipId,
        chipLabel,
        selected
      }) => {
        return jsx(ChipItem, {
          children: jsx(OutlineSelectChip, {
            size: 32,
            variant: "primary1",
            checked: selected,
            onCheck: () => onClick(chipId),
            children: chipLabel
          })
        }, chipId);
      })
    })]
  });
};
const Container$n = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy3"
} : {
  target: "e1t6ufvy3",
  label: "Container"
})("margin-bottom:", pxToRem(20), ";");
const Label$2 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy2"
} : {
  target: "e1t6ufvy2",
  label: "Label"
})(FONT_STYLE.subTitle2, " font-weight:700;margin-bottom:", pxToRem(8), ";");
const ChipList = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy1"
} : {
  target: "e1t6ufvy1",
  label: "ChipList"
})(process.env.NODE_ENV === "production" ? {
  name: "1mzohwv",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;text-align:center;align-items:center"
} : {
  name: "1mzohwv",
  styles: "display:flex;flex-direction:row;flex-wrap:wrap;text-align:center;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1e
});
const ChipItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1t6ufvy0"
} : {
  target: "e1t6ufvy0",
  label: "ChipItem"
})("margin-right:", pxToRem(4), ";margin-bottom:", pxToRem(8), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemThumbnail$1 = ({
  src,
  isZoomed,
  dim,
  topLeft,
  topRight,
  bottomLeft,
  bottomRight,
  aspect = 3 / 2,
  alt = '',
  quality,
  lazy
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleCornerClick = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return jsxs(Container$m, {
    aspect: aspect,
    children: [jsx(Thumbnail$1, {
      alt: alt,
      src: src,
      intrinsicAspect: aspect,
      objectFit: "cover",
      style: isZoomed && !isMobile ? {
        transform: 'scale(1.05)'
      } : undefined,
      quality: quality,
      lazy: lazy
    }), topLeft && jsx(Corner, {
      position: "top-left",
      onClick: handleCornerClick,
      children: topLeft
    }), topRight && jsx(Corner, {
      position: "top-right",
      onClick: handleCornerClick,
      children: topRight
    }), bottomLeft && jsx(Corner, {
      position: "bottom-left",
      onClick: handleCornerClick,
      children: bottomLeft
    }), bottomRight && jsx(Corner, {
      position: "bottom-right",
      onClick: handleCornerClick,
      children: bottomRight
    }), dim && jsx(Dim, {
      children: dim
    })]
  });
};
const Container$m = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm3"
} : {
  target: "e8i2tqm3",
  label: "Container"
})("overflow:hidden;position:relative;border-radius:", pxToRem(4), ";&:before{content:\"\";display:block;", ({
  aspect
}) => /*#__PURE__*/css("padding-top:", 100 / aspect, "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")), ";}");
const Thumbnail$1 = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm2"
} : {
  target: "e8i2tqm2",
  label: "Thumbnail"
})(process.env.NODE_ENV === "production" ? {
  name: "161a5fa",
  styles: "position:absolute;top:0;left:0;transition:transform .2s"
} : {
  name: "161a5fa",
  styles: "position:absolute;top:0;left:0;transition:transform .2s",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1d
});
const Corner = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm1"
} : {
  target: "e8i2tqm1",
  label: "Corner"
})("position:absolute;padding:", pxToRem(6), ";font-size:0;z-index:1;", ({
  position
}) => {
  switch (position) {
    case 'top-left':
      return /*#__PURE__*/css("top:", pxToRem(6), ";left:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"));
    case 'top-right':
      return /*#__PURE__*/css("top:", pxToRem(6), ";right:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"));
    case 'bottom-left':
      return /*#__PURE__*/css("left:", pxToRem(6), ";bottom:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"));
    case 'bottom-right':
      return /*#__PURE__*/css("right:", pxToRem(6), ";bottom:", pxToRem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Corner;"));
    default:
      return '';
  }
}, ";");
const Dim = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e8i2tqm0"
} : {
  target: "e8i2tqm0",
  label: "Dim"
})("position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;color:", ({
  theme
}) => theme.content.base6, ";background:", ({
  theme
}) => theme.dim.basic, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const HorizontalFeedItem = ({
  className,
  thumbnail,
  title,
  writer,
  counts
}) => {
  return jsxs(Container$l, {
    "data-testid": "horizontal-feed-item",
    className: className,
    children: [jsx(FeedItemThumbnail$1, {
      aspect: 3 / 2,
      ...thumbnail
    }), title && jsx(Title$7, {
      children: title
    }), writer && jsxs(Writer, {
      onClick: e => {
        writer.onClick?.(e);
        e.preventDefault();
        e.stopPropagation();
      },
      children: [writer.avatar && jsx(Avatar, {
        children: jsx(ResizeImage, {
          src: writer.avatar,
          intrinsicInitialWidth: 18,
          intrinsicAspect: 1,
          objectFit: "cover",
          alt: writer.nickname
        })
      }), jsx(Nickname$3, {
        children: writer.nickname
      }), jsx(RightNickname, {
        children: writer.rightNickName
      })]
    }), counts && jsx(Counts$1, {
      children: counts.map((count, i) => jsx(Count$1, {
        children: `${count.label} ${count.number.toLocaleString()}`
      }, i))
    })]
  });
};
const Container$l = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u7"
} : {
  target: "e1yd5r1u7",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1azakc",
  styles: "text-align:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1c
});
const Title$7 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u6"
} : {
  target: "e1yd5r1u6",
  label: "Title"
})(FONT_STYLE.subTitle1, " overflow:hidden;display:-webkit-box;margin-top:", pxToRem(14), ";color:", ({
  theme
}) => theme.content.base1, ";font-weight:700;text-overflow:ellipsis;word-wrap:break-word;word-break:break-all;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
const Writer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u5"
} : {
  target: "e1yd5r1u5",
  label: "Writer"
})("display:flex;align-items:center;justify-content:center;margin-top:", pxToRem(8), ";", FONT_STYLE.subTitle2, " font-weight:500;");
const Avatar = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u4"
} : {
  target: "e1yd5r1u4",
  label: "Avatar"
})("overflow:hidden;position:relative;width:", pxToRem(18), ";height:", pxToRem(18), ";border-radius:100%;margin-right:", pxToRem(6), ";flex:none;");
const Nickname$3 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u3"
} : {
  target: "e1yd5r1u3",
  label: "Nickname"
})("color:", ({
  theme
}) => theme.content.base1, ";display:flex;align-items:center;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;");
const RightNickname = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u2"
} : {
  target: "e1yd5r1u2",
  label: "RightNickname"
})(process.env.NODE_ENV === "production" ? {
  name: "1iiyiwh",
  styles: "flex:none;display:flex;align-items:center"
} : {
  name: "1iiyiwh",
  styles: "flex:none;display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1c
});
const Counts$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u1"
} : {
  target: "e1yd5r1u1",
  label: "Counts"
})("display:flex;flex-wrap:wrap;align-items:center;justify-content:center;margin-top:", pxToRem(8), ";");
const Count$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yd5r1u0"
} : {
  target: "e1yd5r1u0",
  label: "Count"
})(FONT_STYLE.subTitle2, " position:relative;flex-shrink:0;margin-right:", pxToRem(8), ";color:", ({
  theme
}) => theme.content.base2, ";&:before{content:\"\";position:absolute;top:0;left:", pxToRem(-4), ";bottom:0;width:", pxToRem(2), ";height:", pxToRem(2), ";margin:auto;border-radius:100%;background:", ({
  theme
}) => theme.content.base2, ";}&:first-of-type:before{content:none;}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const VerticalFeedItem = ({
  className,
  thumbnail,
  title,
  writer,
  counts
}) => {
  return jsxs(Container$k, {
    "data-testid": "vertical-feed-item",
    className: className,
    children: [jsx(Column, {
      children: jsx(FeedItemThumbnail$1, {
        aspect: 8 / 5,
        ...thumbnail
      })
    }), jsxs(Column, {
      children: [jsx(Row, {
        children: title && jsx(Title$6, {
          children: title
        })
      }), writer && jsxs(Nickname$2, {
        onClick: writer.onClick,
        children: [writer.nickname, writer.rightNickName]
      }), counts && jsx(Counts, {
        children: counts.map((count, i) => jsx(Count, {
          children: `${count.label} ${count.number.toLocaleString()}`
        }, i))
      })]
    })]
  });
};
const Container$k = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m6"
} : {
  target: "emnxm2m6",
  label: "Container"
})("overflow:hidden;display:flex;align-items:top;width:100%;padding:0 ", pxToRem(16), ";box-sizing:border-box;");
const Column = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m5"
} : {
  target: "emnxm2m5",
  label: "Column"
})("flex:1 0 0%;margin-left:", pxToRem(12), ";&:first-of-type{margin-left:0;}");
const Row = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m4"
} : {
  target: "emnxm2m4",
  label: "Row"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1b
});
const Title$6 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m3"
} : {
  target: "emnxm2m3",
  label: "Title"
})(FONT_STYLE.subTitle1, " overflow:hidden;flex:1 0 0%;display:-webkit-box;color:", ({
  theme
}) => theme.content.base1, ";font-weight:500;text-overflow:ellipsis;word-wrap:break-word;-webkit-line-clamp:3;-webkit-box-orient:vertical;");
const Nickname$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m2"
} : {
  target: "emnxm2m2",
  label: "Nickname"
})(FONT_STYLE.body3, " display:block;margin-top:", pxToRem(8), ";color:", ({
  theme
}) => theme.content.base2, ";font-weight:500;display:flex;align-items:center;");
const Counts = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m1"
} : {
  target: "emnxm2m1",
  label: "Counts"
})("display:flex;flex-wrap:wrap;align-items:center;margin-top:", pxToRem(2), ";");
const Count = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "emnxm2m0"
} : {
  target: "emnxm2m0",
  label: "Count"
})(FONT_STYLE.body3, " flex-shrink:0;position:relative;margin:0 ", pxToRem(8), ";color:", ({
  theme
}) => theme.content.base2, ";&:before{content:\"\";position:absolute;top:0;left:", pxToRem(-4), ";bottom:0;width:", pxToRem(2), ";height:", pxToRem(2), ";margin:auto;border-radius:100%;background:", ({
  theme
}) => theme.content.base2, ";}&:first-of-type{margin-left:0;&:before{content:none;}}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItem = /*#__PURE__*/React__default.memo(({
  flow = 'horizontal',
  link,
  onClick,
  onImpression = () => {/* noop */},
  ...props
}) => {
  const [isHovered, setHovered] = useState(false);
  const intersectionObserverTarget = useIntersectionObserver({
    options: {
      triggerOnce: true
    },
    onIntersect: onImpression
  });
  const feedItem = jsxs(Container$j, {
    ref: intersectionObserverTarget,
    clickable: !!onClick,
    onClick: onClick,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    children: [flow === 'horizontal' && jsx(HorizontalFeedItem, {
      ...props,
      thumbnail: {
        ...props.thumbnail,
        isZoomed: isHovered
      }
    }), flow === 'vertical' && jsx(VerticalFeedItem, {
      ...props,
      thumbnail: {
        ...props.thumbnail,
        isZoomed: isHovered
      }
    })]
  });
  if (link) {
    const Link = link.component;
    return jsx(Link, {
      href: link.href,
      children: feedItem
    });
  } else {
    return feedItem;
  }
});
var _ref$x = process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "daeijt-Container",
  styles: "cursor:pointer;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1a
};
const Container$j = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etxueos0"
} : {
  target: "etxueos0",
  label: "Container"
})("position:relative;", ({
  clickable
}) => clickable && _ref$x, ";");

/**
 * @internal
 */
const SkeletonThemeContext = React__default.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = React__default.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (React__default.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(React__default.createElement(React__default.Fragment, { key: i },
                skeletonSpan,
                React__default.createElement("br", null)));
        }
    }
    return (React__default.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => React__default.createElement(Wrapper, { key: i }, el))
        : elements));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$19() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemPlaceholder = /*#__PURE__*/React__default.memo(({
  flow = 'horizontal'
}) => {
  if (flow === 'vertical') {
    return jsxs(VerticalContainer, {
      "data-testid": "vertical-container",
      children: [jsx(VerticalContainerColumn, {
        children: jsx(ImageSkeletonWrapper, {
          children: jsx(ImageSkeleton$3, {})
        })
      }), jsxs(VerticalContainerColumn, {
        children: [jsx(TextSkeleton$2, {}), jsx(TextSkeleton$2, {
          width: "50%",
          marginTop: 8
        })]
      })]
    });
  }
  return jsxs(HorizontalContainer, {
    "data-testid": "horizontal-container",
    children: [jsx(ImageSkeletonWrapper, {
      children: jsx(ImageSkeleton$3, {})
    }), jsx(TextSkeleton$2, {
      marginTop: 14
    }), jsx(TextSkeleton$2, {
      width: "50%",
      marginTop: 8
    })]
  });
});
const HorizontalContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh5"
} : {
  target: "e1adnbeh5",
  label: "HorizontalContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1xe63ku",
  styles: "line-height:1"
} : {
  name: "1xe63ku",
  styles: "line-height:1",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$19
});
const VerticalContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh4"
} : {
  target: "e1adnbeh4",
  label: "VerticalContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "7whenc",
  styles: "display:flex;width:100%"
} : {
  name: "7whenc",
  styles: "display:flex;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$19
});
const VerticalContainerColumn = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh3"
} : {
  target: "e1adnbeh3",
  label: "VerticalContainerColumn"
})("flex:1;margin-left:", pxToRem(12), ";&:first-of-type{margin-left:0;}");
const ImageSkeletonWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh2"
} : {
  target: "e1adnbeh2",
  label: "ImageSkeletonWrapper"
})("position:relative;&:before{content:\"\";display:block;padding-top:", 2 / 3 * 100, "%;}br{display:none;}");
const ImageSkeleton$3 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh1"
} : {
  target: "e1adnbeh1",
  label: "ImageSkeleton"
})(process.env.NODE_ENV === "production" ? {
  name: "1at77vf",
  styles: "position:absolute;top:0;left:0;min-height:100%"
} : {
  name: "1at77vf",
  styles: "position:absolute;top:0;left:0;min-height:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$19
});
const TextSkeleton$2 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1adnbeh0"
} : {
  target: "e1adnbeh0",
  label: "TextSkeleton"
})("margin-top:", ({
  marginTop
}) => marginTop ? pxToRem(marginTop) : 0, ";");

const canPlayHls = videoElem => {
  return !!videoElem.canPlayType('application/vnd.apple.mpegurl');
};
const Video = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    src,
    autoPlay,
    useHlsJs = true,
    hlsConfig,
    quality = 'auto',
    ...restProps
  } = props;
  const videoRef = useRef(null);
  const mergedRef = useMergeRef(ref ?? null, videoRef);
  useEffect(() => {
    const videoElem = videoRef.current;
    if (!videoElem || !src) {
      return;
    }
    let unmounted = false;
    let playPromise;
    import('hls.js').then(({
      default: HlsJs
    }) => {
      if (unmounted) {
        return;
      }
      if (!src) {
        return;
      }
      if (!useHlsJs) {
        videoElem.src = src;
      } else if (HlsJs.isSupported()) {
        const hls = new HlsJs(hlsConfig ?? {});
        hls.attachMedia(videoElem);
        hls.loadSource(src);
        if (quality === 'low') {
          hls.autoLevelCapping = 0;
        }
        if (quality === 'auto') {
          hls.capLevelToPlayerSize = true;
        }
      } else if (canPlayHls(videoElem)) {
        videoElem.src = src;
      }
      videoElem.load();
      // Because Safari
      if (autoPlay) {
        playPromise = videoElem.play();
      }
    });
    return () => {
      unmounted = true;
      if (playPromise !== undefined) {
        playPromise.then(() => {
          videoElem.removeAttribute('src');
          videoElem.load();
        }).catch(() => {
          /**
           * Uncaught (in promise) DOMException: The play() request was interrupted because the media was removed from the document.
           * catch above error
           * */
        });
      }
    };
  }, [src, useHlsJs, autoPlay, hlsConfig, quality]);
  return jsx("video", {
    ...restProps,
    "data-testid": "video",
    src: src,
    autoPlay: autoPlay,
    ref: mergedRef
  });
});

const FeedItemVideoThumbnail = ({
  src,
  aspect = 3 / 2,
  canPlay,
  poster
}) => {
  return jsx(VideoContainer, {
    aspect: aspect,
    children: canPlay && jsx(StyledVideoPlayer, {
      src: src,
      quality: "auto",
      loop: true,
      autoPlay: true,
      muted: true,
      playsInline: true,
      poster: poster
    })
  });
};
const StyledVideoPlayer = /*#__PURE__*/_styled(Video, process.env.NODE_ENV === "production" ? {
  target: "efg1py01"
} : {
  target: "efg1py01",
  label: "StyledVideoPlayer"
})("width:100%;height:100%;object-fit:cover;border-radius:", pxToRem(4), ";");
const VideoContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efg1py00"
} : {
  target: "efg1py00",
  label: "VideoContainer"
})("aspect-ratio:", props => props.aspect, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$18() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardFeedItem = ({
  writer,
  thumbnail,
  videoThumbnail,
  actions,
  title,
  link
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref: targetRef,
    inView
  } = useInView({
    threshold: 1,
    skip: !isMobileDevice()
  });
  const Link = link.component;
  const countFormatter = new Intl.NumberFormat('en', {
    notation: 'compact'
  });
  return jsxs("div", {
    children: [writer && jsxs(WriterContainer$1, {
      children: [jsxs(WriterMainContainer, {
        children: [jsxs(WriterLink$1, {
          as: Link,
          href: writer.href,
          onClick: writer.onClick,
          children: [jsx(WriterNickname, {
            children: writer.nickname
          }), jsx(WriterAvatar, {
            children: jsx(ResizeImage, {
              src: writer.avatarSrc,
              intrinsicInitialWidth: 72,
              intrinsicAspect: 1,
              objectFit: "cover",
              alt: writer.nickname
            })
          })]
        }), writer.action && jsxs(Fragment, {
          children: [jsx(WriterNickname, {
            children: "\xB7"
          }), jsx(WriterAction, {
            onClick: writer.action.onClick,
            children: writer.action.label
          })]
        })]
      }), writer.description && jsx(WriterDescription, {
        children: writer.description
      })]
    }), jsxs(Container$i, {
      children: [jsxs(Link, {
        href: link.href,
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        children: [jsxs(ThumbnailContainer$2, {
          children: [jsx(FeedItemThumbnail$1, {
            ...thumbnail,
            aspect: 1,
            isZoomed: isHovered
          }), videoThumbnail && jsx(VideoThumbnailContainer$1, {
            ref: targetRef,
            children: jsx(FeedItemVideoThumbnail, {
              src: videoThumbnail.src,
              aspect: 1,
              canPlay: isHovered && !isMobileDevice() || inView && isMobileDevice()
            })
          })]
        }), actions && jsx(ActionsPlaceholder, {}), jsx(Title$5, {
          isHovered: isHovered,
          children: title
        })]
      }), actions && jsx(Actions, {
        children: actions.map(action => jsxs(ActionButton, {
          type: "button",
          onClick: action.onClick,
          children: [jsx(Icon$2, {
            name: action.iconName,
            size: 24,
            fill: theme => action.iconColor?.(theme) ?? theme.content.base1
          }), jsx(ActionCount, {
            children: countFormatter.format(action.count)
          })]
        }, action.iconName))
      })]
    })]
  });
};
const WriterContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr14"
} : {
  target: "e12sucbr14",
  label: "WriterContainer"
})("display:flex;flex-direction:column;gap:", pxToRem(2), ";position:relative;min-height:", pxToRem(40), ";padding-left:", pxToRem(48), ";margin-bottom:", pxToRem(16), ";");
const WriterMainContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr13"
} : {
  target: "e12sucbr13",
  label: "WriterMainContainer"
})("margin:auto 0;display:flex;align-items:center;gap:", pxToRem(4), ";");
const WriterLink$1 = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr12"
} : {
  target: "e12sucbr12",
  label: "WriterLink"
})(process.env.NODE_ENV === "production" ? {
  name: "6isekk",
  styles: "&:hover{opacity:0.5;}"
} : {
  name: "6isekk",
  styles: "&:hover{opacity:0.5;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
});
const WriterAvatar = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr11"
} : {
  target: "e12sucbr11",
  label: "WriterAvatar"
})("position:absolute;left:0;top:0;overflow:hidden;width:", pxToRem(36), ";height:", pxToRem(36), ";border-radius:100%;");
const WriterNickname = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr10"
} : {
  target: "e12sucbr10",
  label: "WriterNickname"
})(FONT_STYLE.body1_small, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;");
const WriterAction = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr9"
} : {
  target: "e12sucbr9",
  label: "WriterAction"
})(RESET_BUTTON, " ", FONT_STYLE.body1_small, " font-weight:700;color:", ({
  theme
}) => theme.content.primary1.basic, ";white-space:nowrap;");
const WriterDescription = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr8"
} : {
  target: "e12sucbr8",
  label: "WriterDescription"
})(FONT_STYLE.caption1, " color:", ({
  theme
}) => theme.content.base2, ";font-weight:400;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;-webkit-box-orient:vertical;word-break:break-all;");
const Container$i = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr7"
} : {
  target: "e12sucbr7",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
});
const ThumbnailContainer$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr6"
} : {
  target: "e12sucbr6",
  label: "ThumbnailContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
});
const VideoThumbnailContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr5"
} : {
  target: "e12sucbr5",
  label: "VideoThumbnailContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "b98nv4",
  styles: "position:absolute;inset:0"
} : {
  name: "b98nv4",
  styles: "position:absolute;inset:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
});
const ActionsPlaceholder = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr4"
} : {
  target: "e12sucbr4",
  label: "ActionsPlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "1k18kha",
  styles: "height:40px"
} : {
  name: "1k18kha",
  styles: "height:40px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
});
const Actions = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr3"
} : {
  target: "e12sucbr3",
  label: "Actions"
})(process.env.NODE_ENV === "production" ? {
  name: "9h583h",
  styles: "position:absolute;top:0;width:100%;margin-top:100%;height:40px;display:flex;justify-content:space-between"
} : {
  name: "9h583h",
  styles: "position:absolute;top:0;width:100%;margin-top:100%;height:40px;display:flex;justify-content:space-between",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
});
const ActionButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr2"
} : {
  target: "e12sucbr2",
  label: "ActionButton"
})(RESET_BUTTON, " flex:1 0 0;padding:", pxToRem(12), " 0 ", pxToRem(4), " 0;display:flex;justify-content:center;align-items:center;&:hover{opacity:0.5;}");
const ActionCount = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr1"
} : {
  target: "e12sucbr1",
  label: "ActionCount"
})(FONT_STYLE.body3, " color:", ({
  theme
}) => theme.content.base1, ";margin-left:", pxToRem(6), ";");
var _ref$w = process.env.NODE_ENV === "production" ? {
  name: "o9ww1u",
  styles: "opacity:0.5"
} : {
  name: "tg2egp-Title",
  styles: "opacity:0.5;label:Title;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$18
};
const Title$5 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12sucbr0"
} : {
  target: "e12sucbr0",
  label: "Title"
})("margin-top:12px;", FONT_STYLE.body1_small, " color:", ({
  theme
}) => theme.content.base1, ";white-space:pre-line;display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-break:break-all;", ({
  isHovered
}) => isHovered && _ref$w, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$17() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const CardFeedItemPlaceholder = ({
  writer,
  actions
}) => {
  return jsxs("div", {
    style: {
      width: '100%'
    },
    children: [writer && jsxs(WriterContainer, {
      children: [jsx(AvatarPlaceholder, {
        height: "auto",
        borderRadius: "50%"
      }), jsx(NicknameContainer, {
        children: jsx(Skeleton, {
          height: "auto"
        })
      })]
    }), jsx(ImageSkeleton$2, {
      height: "auto"
    }), actions && jsx(ActionsContainer, {
      children: Array.from({
        length: 3
      }).map((_, index) => jsx(ActionIconContainer, {
        children: jsx(ActionIconPlaceholder, {
          height: "auto"
        })
      }, index))
    }), jsx(TitlePlaceholder, {})]
  });
};
const WriterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi7"
} : {
  target: "eknv2pi7",
  label: "WriterContainer"
})("display:flex;gap:", pxToRem(12), ";min-height:", pxToRem(40), ";margin-bottom:", pxToRem(16), ";align-items:center;");
const AvatarPlaceholder = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi6"
} : {
  target: "eknv2pi6",
  label: "AvatarPlaceholder"
})("width:", pxToRem(40), ";aspect-ratio:1;border-radius:50%;");
const NicknameContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi5"
} : {
  target: "eknv2pi5",
  label: "NicknameContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "82a6rk",
  styles: "flex:1"
} : {
  name: "82a6rk",
  styles: "flex:1",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$17
});
const ImageSkeleton$2 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi4"
} : {
  target: "eknv2pi4",
  label: "ImageSkeleton"
})("aspect-ratio:1;width:100%;height:auto;border-radius:", pxToRem(4), ";");
const ActionsContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi3"
} : {
  target: "eknv2pi3",
  label: "ActionsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "8w8w4j",
  styles: "height:40px;display:flex;justify-content:space-between"
} : {
  name: "8w8w4j",
  styles: "height:40px;display:flex;justify-content:space-between",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$17
});
const ActionIconContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eknv2pi2"
} : {
  target: "eknv2pi2",
  label: "ActionIconContainer"
})("flex:1 0 0;padding:", pxToRem(12), " 0 ", pxToRem(4), " 0;display:flex;justify-content:center;align-items:center;");
const ActionIconPlaceholder = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi1"
} : {
  target: "eknv2pi1",
  label: "ActionIconPlaceholder"
})("width:", pxToRem(24), ";aspect-ratio:1;border-radius:50%;");
const TitlePlaceholder = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "eknv2pi0"
} : {
  target: "eknv2pi0",
  label: "TitlePlaceholder"
})(process.env.NODE_ENV === "production" ? {
  name: "xda5ep",
  styles: "margin-top:12px"
} : {
  name: "xda5ep",
  styles: "margin-top:12px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$17
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$16() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FEED_ITEM_MOBILE_ASPECT_RATIO = 3 / 4;
const FEED_ITEM_DESKTOP_ASPECT_RATIO = 1;
const ContentFeedItem = ({
  href,
  onClick,
  label,
  title,
  writer,
  thumbnail,
  videoThumbnail,
  className,
  linkComponent,
  like,
  scrap,
  badge
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {
    ref: targetRef,
    inView
  } = useInView({
    threshold: 1,
    skip: !isMobileDevice()
  });
  const isMobile = useResponsive().breakpoint === 'mobile';
  const Link = linkComponent ?? 'a';
  return jsxs(Container$h, {
    ref: targetRef,
    className: className,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    children: [jsxs(Link, {
      href: href,
      onClick: onClick,
      children: [jsxs(ThumbnailContainer$1, {
        children: [jsx(FeedItemThumbnail$1, {
          ...thumbnail,
          aspect: isMobile ? FEED_ITEM_MOBILE_ASPECT_RATIO : FEED_ITEM_DESKTOP_ASPECT_RATIO
        }), videoThumbnail && jsx(VideoThumbnailContainer, {
          children: jsx(FeedItemVideoThumbnail, {
            src: videoThumbnail.src,
            canPlay: isHovered && !isMobileDevice() || inView && isMobileDevice(),
            aspect: isMobile ? FEED_ITEM_MOBILE_ASPECT_RATIO : FEED_ITEM_DESKTOP_ASPECT_RATIO
          })
        })]
      }), jsxs(Title$4, {
        children: [label && jsx(Label$1, {
          children: `${label} `
        }), title]
      })]
    }), badge && jsx(BadgeContainer, {
      children: badge
    }), scrap && jsx(ScrapButton, {
      name: "scrap",
      "aria-label": scrap.label ?? '스크랩',
      size: 24,
      active: scrap.active,
      initialActive: scrap.initialActive,
      onActive: () => scrap.onClick(true),
      onInactive: () => scrap.onClick(false)
    }), jsxs(UserContainer, {
      children: [jsxs(Link, {
        href: writer.href,
        onClick: writer.onClick,
        children: [jsx(StyledAvatar$1, {
          size: 18,
          alt: writer.nickname,
          src: getImageUrl({
            src: writer.avatar
          }),
          placeholderIcon: CircleFilledIcon,
          quality: 60
        }), jsx(Nickname$1, {
          children: writer.nickname
        })]
      }), like && jsxs(LikeButton, {
        type: "button",
        "aria-label": like.label ?? '좋아요',
        onClick: () => like.onClick(like.active),
        children: [jsx(Icon$2, {
          size: 16,
          name: like.active ? 'heart' : 'heart_outline',
          fill: theme => like.active ? theme.content.primary1.basic : theme.interactive.base1
        }), jsx(LikeCountText, {
          children: like.count > 0 && formatLargeNumber(like.count)
        })]
      })]
    })]
  });
};
const Container$h = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj11"
} : {
  target: "e1e7vpgj11",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
});
const ThumbnailContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj10"
} : {
  target: "e1e7vpgj10",
  label: "ThumbnailContainer"
})("position:relative;aspect-ratio:", FEED_ITEM_MOBILE_ASPECT_RATIO, ";margin-bottom:", pxToRem(8), ";overflow:hidden;border-radius:", pxToRem(4), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("aspect-ratio:", FEED_ITEM_DESKTOP_ASPECT_RATIO, ";margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ThumbnailContainer;"))), ";");
const VideoThumbnailContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj9"
} : {
  target: "e1e7vpgj9",
  label: "VideoThumbnailContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "b98nv4",
  styles: "position:absolute;inset:0"
} : {
  name: "b98nv4",
  styles: "position:absolute;inset:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
});
const Label$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj8"
} : {
  target: "e1e7vpgj8",
  label: "Label"
})("color:", ({
  theme
}) => theme.content.primary2.thick, ";font-weight:700;");
const Title$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj7"
} : {
  target: "e1e7vpgj7",
  label: "Title"
})(FONT_STYLE.body2_small, " color:", ({
  theme
}) => theme.content.base1, ";overflow:hidden;text-overflow:ellipsis;white-space:pre-line;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;margin-bottom:", pxToRem(6), ";&:hover{opacity:0.5;}", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.body1_1, " margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Title;"))), ";");
const ScrapButton = /*#__PURE__*/_styled(ToggleButton, process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj6"
} : {
  target: "e1e7vpgj6",
  label: "ScrapButton"
})("position:absolute;top:", pxToRem(-10), ";right:", pxToRem(8), ";margin-top:", 1 / FEED_ITEM_MOBILE_ASPECT_RATIO * 100, "%;transform:translateY(-100%);@media(hover: hover){&:hover{opacity:0.5;}}", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("margin-top:", 1 / FEED_ITEM_DESKTOP_ASPECT_RATIO * 100, "%;" + (process.env.NODE_ENV === "production" ? "" : ";label:ScrapButton;"))), ";");
const BadgeContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj5"
} : {
  target: "e1e7vpgj5",
  label: "BadgeContainer"
})("position:absolute;top:", pxToRem(8), ";right:", pxToRem(8), ";");
const UserContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj4"
} : {
  target: "e1e7vpgj4",
  label: "UserContainer"
})("display:flex;margin-top:", pxToRem(8), ";justify-content:space-between;align-items:center;& a{display:flex;gap:", pxToRem(6), ";align-items:center;width:fit-content;max-width:100%;overflow:hidden;&:hover{opacity:0.5;}}");
const Nickname$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj3"
} : {
  target: "e1e7vpgj3",
  label: "Nickname"
})(FONT_STYLE.caption1_small, " font-weight:500;color:", ({
  theme
}) => theme.content.base1, ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : {
  name: "13gc3a7-Nickname",
  styles: "font-weight:600;label:Nickname;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
}), ";");
const StyledAvatar$1 = /*#__PURE__*/_styled(Avatar$1, process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj2"
} : {
  target: "e1e7vpgj2",
  label: "StyledAvatar"
})(process.env.NODE_ENV === "production" ? {
  name: "ozd7xs",
  styles: "flex-shrink:0"
} : {
  name: "ozd7xs",
  styles: "flex-shrink:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$16
});
const LikeButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj1"
} : {
  target: "e1e7vpgj1",
  label: "LikeButton"
})("display:flex;justify-content:flex-end;align-items:center;gap:", pxToRem(4), ";margin-left:", pxToRem(4), ";text-align:center;");
const LikeCountText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1e7vpgj0"
} : {
  target: "e1e7vpgj0",
  label: "LikeCountText"
})(FONT_STYLE.body3, ";color:", ({
  theme
}) => theme.content.base1, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$15() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ContentFeedItemPlaceholder = /*#__PURE__*/React__default.memo(({
  className
}) => {
  return jsxs(Container$g, {
    className: className,
    children: [jsx(ImageSkeleton$1, {
      height: "auto",
      style: {
        display: 'block'
      }
    }), jsx(TextSkeleton$1, {}), jsx(TextSkeleton$1, {
      width: "50%"
    }), jsx(TextSkeleton$1, {
      width: "50%"
    })]
  });
});
const Container$g = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1l3as7g2"
} : {
  target: "e1l3as7g2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1amee4m",
  styles: "line-height:0"
} : {
  name: "1amee4m",
  styles: "line-height:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$15
});
const ImageSkeleton$1 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1l3as7g1"
} : {
  target: "e1l3as7g1",
  label: "ImageSkeleton"
})("aspect-ratio:", FEED_ITEM_MOBILE_ASPECT_RATIO, ";margin-bottom:", pxToRem(8), ";border-radius:", pxToRem(4), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("aspect-ratio:", FEED_ITEM_DESKTOP_ASPECT_RATIO, ";margin-bottom:", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ImageSkeleton;"))), ";");
const TextSkeleton$1 = /*#__PURE__*/_styled(Skeleton, process.env.NODE_ENV === "production" ? {
  target: "e1l3as7g0"
} : {
  target: "e1l3as7g0",
  label: "TextSkeleton"
})("margin-bottom:", pxToRem(6), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$14() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedPlaceholder = ({
  className,
  loadingText
}) => {
  return jsxs(ContentContainer, {
    className: className,
    children: [jsxs(PlaceholderContainer, {
      children: [jsxs(PlaceholderModule, {
        children: [jsx(ImageSkeleton, {}), jsx(TextSkeleton, {}), jsx(TextSkeleton, {})]
      }), jsxs(PlaceholderModule, {
        children: [jsx(ImageSkeleton, {}), jsx(TextSkeleton, {}), jsx(TextSkeleton, {})]
      })]
    }), jsx(PlaceholderText, {
      children: loadingText ?? '맞춤 피드를 불러오고 있어요'
    })]
  });
};
const ContentContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf5"
} : {
  target: "e989kf5",
  label: "ContentContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "i4idzn",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;margin:auto"
} : {
  name: "i4idzn",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;margin:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$14
});
const PlaceholderContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf4"
} : {
  target: "e989kf4",
  label: "PlaceholderContainer"
})("width:", pxToRem(95), ";display:flex;justify-content:space-around;");
const PlaceholderModule = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf3"
} : {
  target: "e989kf3",
  label: "PlaceholderModule"
})("width:", pxToRem(44), ";");
const ImageSkeleton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf2"
} : {
  target: "e989kf2",
  label: "ImageSkeleton"
})("width:100%;height:", pxToRem(58), ";margin-bottom:", pxToRem(4), ";border-radius:", pxToRem(8), ";background-color:", ({
  theme
}) => theme.content.base4, ";");
const TextSkeleton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf1"
} : {
  target: "e989kf1",
  label: "TextSkeleton"
})("height:", pxToRem(6), ";margin-bottom:", pxToRem(3), ";border-radius:", pxToRem(8), ";background-color:", ({
  theme
}) => theme.content.base4, ";");
const PlaceholderText = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e989kf0"
} : {
  target: "e989kf0",
  label: "PlaceholderText"
})("margin-top:", pxToRem(16), ";color:", ({
  theme
}) => theme.content.base2, ";", FONT_STYLE.subTitle2, ";");

const BaseFeedItemContext = /*#__PURE__*/createContext({
  hasNestedLink: false
});
const useBaseFeedItemContext = () => useContext(BaseFeedItemContext);

const FeedItemLinkWrapper = ({
  children,
  link,
  onClick
}) => {
  const context = useBaseFeedItemContext();

  /** 중첩된 Context가 생성될 시 사용할 ContextValue */
  const nestedContextValue = useMemo(() => ({
    link,
    onClick,
    hasNestedLink: true
  }), [link, onClick]);
  const finalLink = link || context.link;
  const finalOnClick = onClick || context.onClick;
  const hasNestedLink = context.hasNestedLink;
  const handleClick = useCallback(e => {
    if (e.defaultPrevented) {
      return;
    }
    finalOnClick?.();
  }, [finalOnClick]);
  if (hasNestedLink) {
    return children;
  }
  if (!finalLink?.href) {
    return /*#__PURE__*/cloneElement(children, {
      onClick: finalOnClick ? handleClick : undefined
    });
  }
  const LinkComponent = finalLink.LinkComponent ?? 'a';
  return jsx(BaseFeedItemContext.Provider, {
    value: nestedContextValue,
    children: jsx(LinkComponent, {
      href: finalLink.href,
      onClick: handleClick,
      children: children
    })
  });
};

const PRESET_POSITIONS = {
  'top-left': {
    top: 12,
    left: 12
  },
  'top-right': {
    top: 12,
    right: 12
  },
  'bottom-left': {
    bottom: 12,
    left: 12
  },
  'bottom-right': {
    bottom: 12,
    right: 12
  }
};
const FeedItemOverlay = ({
  overlay
}) => {
  const finalPosition = overlay.preset ? PRESET_POSITIONS[overlay.preset] : overlay.position;
  const finalSize = overlay.preset ? undefined : overlay.size;
  return jsx(Box, {
    position: "absolute",
    ...finalPosition,
    ...finalSize,
    children: overlay.element
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$13() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const SQUARE_RATIO = 1;
const LANDSCAPE_RATIO = 16 / 9;
const RATIO = {
  square: SQUARE_RATIO,
  landscape: LANDSCAPE_RATIO,
  none: undefined
};
var _ref2$c = process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "y9cyos-FeedItemThumbnail",
  styles: "width:100%;height:100%;label:FeedItemThumbnail;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$13
};
const FeedItemThumbnail = ({
  ratioType,
  overlays,
  isZoomedOnHover = true,
  link,
  onClick,
  ...props
}) => {
  return jsxs(Box, {
    position: "relative",
    w: "100%",
    h: "100%",
    children: [jsx(FeedItemLinkWrapper, {
      link: link,
      onClick: onClick,
      children: jsx(StyledBox, {
        overflow: "hidden",
        position: "relative",
        bdr: "8px",
        bd: "1px solid border",
        ratioType: ratioType,
        w: "100%",
        h: "100%",
        children: jsx(TransitionResizeImage, {
          ...props,
          isZoomedOnHover: isZoomedOnHover,
          intrinsicAspect: RATIO[ratioType],
          css: _ref2$c,
          objectFit: props.objectFit ?? 'cover'
        })
      })
    }), overlays?.map((overlay, index) => jsx(FeedItemOverlay, {
      overlay: overlay
    }, index))]
  });
};
const StyledBox = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "e11ekyxr1"
} : {
  target: "e11ekyxr1",
  label: "StyledBox"
})("aspect-ratio:", ({
  ratioType
}) => RATIO[ratioType], ";");
var _ref$v = process.env.NODE_ENV === "production" ? {
  name: "1np1zzr",
  styles: "&:hover{transform:scale(1.05);transition:transform 0.2s;}"
} : {
  name: "6es30r-TransitionResizeImage",
  styles: "&:hover{transform:scale(1.05);transition:transform 0.2s;};label:TransitionResizeImage;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$13
};
const TransitionResizeImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e11ekyxr0"
} : {
  target: "e11ekyxr0",
  label: "TransitionResizeImage"
})(({
  isZoomedOnHover
}) => isZoomedOnHover && _ref$v, ";");

const FeedItemWriter = ({
  profileImageUrl,
  nickname,
  link,
  onClick
}) => {
  const theme = useTheme();
  const buttonStyle = useMemo(() => ({
    color: theme.colors.foreground
  }), [theme.colors.foreground]);
  return jsx(FeedItemLinkWrapper, {
    link: link,
    onClick: onClick,
    children: jsx(StyledButton$1, {
      type: "button",
      style: buttonStyle,
      children: jsxs(Flex, {
        direction: "row",
        align: "center",
        gap: 8,
        p: "0 4px",
        children: [jsx(Flex, {
          shrink: 0,
          children: jsx(Avatar$1, {
            size: 30,
            src: profileImageUrl,
            placeholderIcon: CircleFilledIcon
          })
        }), jsx(Text$3, {
          variant: "body14L18",
          weight: 600,
          truncate: true,
          children: nickname
        })]
      })
    })
  });
};
const StyledButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e7xrrji0"
} : {
  target: "e7xrrji0",
  label: "StyledButton"
})("color:", ({
  theme
}) => theme.colors.foreground, ";");

const FeedItemDescription = ({
  children,
  link,
  onClick,
  truncate = {
    rows: 2
  }
}) => {
  return jsx(FeedItemLinkWrapper, {
    link: link,
    onClick: onClick,
    children: jsx(Box, {
      w: "100%",
      h: "100%",
      children: jsx(Text$3, {
        truncate: truncate,
        variant: "body15L24",
        weight: 400,
        color: "foreground",
        children: children
      })
    })
  });
};

const FeedItemGoods = ({
  item,
  link,
  onClick
}) => {
  return jsx(FeedItemLinkWrapper, {
    link: link,
    onClick: onClick,
    children: jsxs(Flex, {
      direction: "row",
      children: [jsx(Flex, {
        w: 62,
        h: 62,
        shrink: 0,
        mr: 8,
        children: jsx(FeedItemThumbnail, {
          ratioType: "square",
          src: item.imageUrl,
          alt: `Thumbnail image of ${item.productName}`
        })
      }), jsxs(Box, {
        children: [jsx(Text$3, {
          color: "foregroundWeak",
          variant: "detail12L16",
          children: item.brandName
        }), jsx(Box, {
          mt: 4,
          mb: 2,
          children: jsx(Text$3, {
            color: "foreground",
            variant: "body14L18",
            truncate: {
              rows: 1,
              overflow: 'ellipsis'
            },
            children: item.productName
          })
        }), !!item.price && jsxs(Flex, {
          gap: 2,
          direction: "row",
          align: "center",
          children: [item.price.salePercent > 0 && jsx(Text$3, {
            color: "foregroundEmphasis",
            variant: "body14L18",
            children: `-${item.price.salePercent}%`
          }), jsx(Text$3, {
            weight: 600,
            color: "foreground",
            variant: "body14L18",
            children: formatPriceByCurrency(item.price.sellingPrice, item.price.currency)
          })]
        })]
      })]
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$12() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemScrapButton = ({
  active,
  scrap,
  unscrap
}) => {
  const theme = useTheme();
  return active ? jsx(ScrapWrapperButton, {
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      unscrap();
    },
    "aria-label": "unscrap",
    children: jsx(ScrapFilledIcon, {
      size: 24,
      color: theme.colors.foregroundBrand
    })
  }) : jsxs(ScrapWrapperButton, {
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      scrap();
    },
    "aria-label": "scrap",
    children: [jsx(ScrapIcon, {
      size: 24,
      color: theme.colors.foregroundInverse
    }), jsx(ScrapFilledIcon, {
      size: 24,
      color: "rgba(255, 255, 255, 0.7)"
    })]
  });
};
const ScrapWrapperButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1g44pot0"
} : {
  target: "e1g44pot0",
  label: "ScrapWrapperButton"
})(process.env.NODE_ENV === "production" ? {
  name: "l5frqf",
  styles: "width:24px;height:24px;position:relative;&:hover svg{opacity:0.5;}&>svg{position:absolute;bottom:0;right:0;filter:drop-shadow(0px 2px 5px rgba(63, 71, 77, 0.25));}"
} : {
  name: "l5frqf",
  styles: "width:24px;height:24px;position:relative;&:hover svg{opacity:0.5;}&>svg{position:absolute;bottom:0;right:0;filter:drop-shadow(0px 2px 5px rgba(63, 71, 77, 0.25));}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$12
});

/** 기존 국내향에서 사용하던 레거시 버전의 뱃지입니다.
 * 요청에 의해 BDS PillBadge를 사용하지 않고, 추후 ODS 변경 시 새로 정의한 스팩의 뱃지나 레이아웃으로 변경합니다.
*/
const LegacyFeedBadge = ({
  children
}) => {
  return jsx(LegacyBadge, {
    children: children
  });
};
const LegacyBadge = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1le5rvx0"
} : {
  target: "e1le5rvx0",
  label: "LegacyBadge"
})(FONT_STYLE.caption1_small, ";display:flex;justify-content:center;align-items:center;background-color:", ({
  theme
}) => theme.dim.basic, ";border-radius:10px;padding:3px 8px;color:", ({
  theme
}) => theme.content.base6, ";font-weight:500;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$11() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FeedItemStackCountIcon = ({
  count
}) => {
  return jsx(LegacyFeedBadge, {
    children: jsxs(BadgeInnerWrapper, {
      children: [jsx(StyledStackedImagesIcon, {
        size: 12
      }), count]
    })
  });
};
const BadgeInnerWrapper = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e789qhx1"
} : {
  target: "e789qhx1",
  label: "BadgeInnerWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$11
});
const StyledStackedImagesIcon = /*#__PURE__*/_styled(StackedImagesIcon, process.env.NODE_ENV === "production" ? {
  target: "e789qhx0"
} : {
  target: "e789qhx0",
  label: "StyledStackedImagesIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "2bhlo8",
  styles: "margin-right:2px"
} : {
  name: "2bhlo8",
  styles: "margin-right:2px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$11
});

const FeedItemStackedImagesIcon = () => {
  return jsx(StackedImagesFilledIcon, {
    size: 18,
    fill: theme => theme.base.neutral0
  });
};

const FeedItemVideoDurationBadge = ({
  duration
}) => {
  return jsx(LegacyFeedBadge, {
    children: formatTimeStringFromTotalSeconds(duration ?? 0)
  });
};

const FeedItemOverlayElement = props => {
  const {
    type,
    data
  } = props;
  switch (type) {
    case 'STACKED_IMAGES':
      return jsx(FeedItemStackedImagesIcon, {});
    case 'STACK_COUNT':
      return jsx(FeedItemStackCountIcon, {
        ...data
      });
    case 'VIDEO_DURATION':
      return jsx(FeedItemVideoDurationBadge, {
        ...data
      });
    case 'SCRAP':
      return jsx(FeedItemScrapButton, {
        ...data
      });
    default:
      return null;
  }
};

const BaseFeedItem = ({
  children,
  link,
  onClick
}) => {
  const contextValue = useMemo(() => ({
    link,
    onClick,
    hasNestedLink: false
  }), [link, onClick]);
  return jsx(BaseFeedItemContext.Provider, {
    value: contextValue,
    children: jsx(FeedContainer, {
      children: children
    })
  });
};
BaseFeedItem.Thumbnail = FeedItemThumbnail;
BaseFeedItem.Writer = FeedItemWriter;
BaseFeedItem.Description = FeedItemDescription;
BaseFeedItem.Goods = FeedItemGoods;
const FeedContainer = ({
  children
}) => {
  return jsx(Flex, {
    direction: "column",
    overflow: "hidden",
    w: "100%",
    rowGap: {
      mobile: '8px',
      tablet: '16px'
    },
    children: children
  });
};

const LinkContext = /*#__PURE__*/createContext('a');
const useLinkContext = () => useContext(LinkContext);
function LinkProvider({
  children,
  linkComponent
}) {
  return jsx(LinkContext.Provider, {
    value: linkComponent,
    children: children
  });
}

const LogContext = /*#__PURE__*/createContext(() => {/* noop */});
const useLogContext = () => useContext(LogContext);
function LogProvider({
  children,
  onLog
}) {
  return jsx(LogContext.Provider, {
    value: onLog,
    children: children
  });
}

const GNBDataContext = /*#__PURE__*/createContext(null);
function GNBDataProvider({
  children,
  value
}) {
  return jsx(GNBDataContext.Provider, {
    value: value,
    children: children
  });
}
function useGNBData() {
  const value = useContext(GNBDataContext);
  if (value === null) {
    throw new Error('The useGNBData must be used within a GNBDataContext');
  }
  return value;
}

function GlobalDrawerHeader({
  onClose,
  action,
  mb
}) {
  return jsxs(Flex, {
    direction: "row",
    justify: "space-between",
    mb: mb,
    children: [jsx(IconButton, {
      type: "button",
      onClick: onClose,
      children: jsx(ArrowLeftIcon, {
        size: 24,
        fill: theme => theme.base.neutral600
      })
    }), action]
  });
}
const IconButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1m2ewvr0"
} : {
  target: "e1m2ewvr0",
  label: "IconButton"
})(RESET_BUTTON, " height:40px;padding:8px;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$10() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BaseDrawerMenu = ({
  children,
  gap,
  ...props
}) => {
  return jsx(List$1, {
    gap: gap,
    ...props,
    children: children
  });
};
const List$1 = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e19v6ygh1"
} : {
  target: "e19v6ygh1",
  label: "List"
})("padding:0;", ({
  gap
}) => gap && `
    display: flex;
    flex-direction: column;
    gap: ${gap}px;
  `, ";");
const BaseDrawerMenuItem = ({
  children,
  ...props
}) => {
  return jsx(ListItem, {
    ...props,
    children: children
  });
};
const ListItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e19v6ygh0"
} : {
  target: "e19v6ygh0",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1772xtw",
  styles: "padding:0;margin:0"
} : {
  name: "1772xtw",
  styles: "padding:0;margin:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$10
});
const BaseDrawerMenuAction = ({
  href,
  onClick,
  children,
  logData,
  ...props
}) => {
  const Link = useLinkContext();
  const Component = href ? Link : 'button';
  const log = useLogContext();
  const handleClick = () => {
    if (logData) {
      log({
        category: 'click',
        ...logData
      });
    }
    onClick?.();
  };
  return jsx(Component, {
    css: /*#__PURE__*/css(RESET_BUTTON, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:BaseDrawerMenuAction;")),
    href: href,
    onClick: handleClick,
    ...props,
    children: children
  });
};

function BaseDrawer({
  width = 270,
  open,
  onClose,
  children,
  ...rest
}) {
  return jsx(Drawer, {
    open: open,
    width: width,
    onClose: onClose,
    ...rest,
    children: children
  });
}
const BaseDrawerDivider = ({
  my
}) => {
  return jsx(Box, {
    my: my,
    children: jsx(Divider, {
      variant: "thin"
    })
  });
};
BaseDrawer.Divider = BaseDrawerDivider;
BaseDrawer.Menu = BaseDrawerMenu;
BaseDrawer.MenuItem = BaseDrawerMenuItem;
BaseDrawer.MenuAction = BaseDrawerMenuAction;

function _EMOTION_STRINGIFIED_CSS_ERROR__$$() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function GlobalDrawerFooterMenu({
  items,
  onClose
}) {
  return jsx(GlobalDrawerMenu, {
    gap: 8,
    children: items.map((item, index) => jsxs(Fragment$1, {
      children: [index > 0 && jsx(Ellipse$1, {
        w: 4,
        h: 4,
        bgc: "foregroundDisabled"
      }), jsx(BaseDrawer.MenuItem, {
        children: jsx(BaseDrawer.MenuAction, {
          ...(item.href ? {
            href: item.href,
            target: '_blank',
            rel: 'noreferrer'
          } : {}),
          onClick: () => {
            item.onClick?.();
            onClose?.();
          },
          children: jsx(Text$3, {
            variant: "body14L18",
            color: "foregroundWeak",
            children: item.title
          })
        })
      })]
    }, index))
  });
}
const GlobalDrawerMenu = /*#__PURE__*/_styled(BaseDrawer.Menu, process.env.NODE_ENV === "production" ? {
  target: "e1yfo9fy1"
} : {
  target: "e1yfo9fy1",
  label: "GlobalDrawerMenu"
})(process.env.NODE_ENV === "production" ? {
  name: "1u9unfx",
  styles: "flex-direction:row;align-items:center;flex-wrap:wrap"
} : {
  name: "1u9unfx",
  styles: "flex-direction:row;align-items:center;flex-wrap:wrap",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
});
const Ellipse$1 = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "e1yfo9fy0"
} : {
  target: "e1yfo9fy0",
  label: "Ellipse"
})(process.env.NODE_ENV === "production" ? {
  name: "18wgrk7",
  styles: "border-radius:50%"
} : {
  name: "18wgrk7",
  styles: "border-radius:50%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$$
});

const GlobalDrawerMenuItemText = ({
  children,
  active = false
}) => jsx(Box, {
  as: "span",
  display: "inline-block",
  px: 4,
  py: 6,
  children: jsx(Title$3, {
    variant: "heading20",
    weight: 600,
    active: active,
    children: children
  })
});
const Title$3 = /*#__PURE__*/_styled(Text$3, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: props => props !== 'active',
  target: "efsedsx0"
} : {
  shouldForwardProp: props => props !== 'active',
  target: "efsedsx0",
  label: "Title"
})("color:", ({
  active
}) => active ? 'rgba(37, 37, 37, 1)' : 'rgba(140, 140, 140, 1)', ";");

function GlobalNavigationDrawer({
  open,
  menuSchema,
  supplementary,
  onClose,
  onAppDownload,
  ...rest
}) {
  const {
    userMenu,
    showAppDownloadButton = true
  } = supplementary;
  const log = useLogContext();
  const {
    localeData
  } = useGNBData();
  const drawerUserMenu = userMenu.filter(menu => menu.showOn?.includes('drawer') && menu.type !== 'bottom');
  const drawerFooterMenu = userMenu.filter(menu => menu.showOn?.includes('drawer') && menu.type === 'bottom');
  return jsxs(BaseDrawer, {
    open: open,
    width: 292,
    onClose: onClose,
    ...rest,
    children: [jsx(GlobalDrawerHeader, {
      onClose: onClose,
      action: showAppDownloadButton && jsx(TextButton$1, {
        variant: "neutral-600",
        size: 16,
        rightIcon: LaunchIcon,
        onClick: () => {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload?.();
        },
        children: localeData?.appDownload ?? '앱다운로드'
      }),
      mb: 40
    }), jsx(BaseDrawer.Menu, {
      gap: 5,
      children: menuSchema.map((menu, index) => jsx(BaseDrawer.MenuItem, {
        children: jsx(BaseDrawer.MenuAction, {
          href: menu.href,
          onClick: onClose,
          logData: {
            key: 'drawer.main.item',
            params: {
              id: menu.logId,
              // HOME | LOGO | SHOPPING
              section_id: 'GNB',
              index
            }
          },
          children: jsx(GlobalDrawerMenuItemText, {
            active: menu.active,
            children: menu.title
          })
        })
      }, index))
    }), drawerUserMenu.length > 0 && jsx(BaseDrawer.Divider, {
      my: 36
    }), jsx(BaseDrawer.Menu, {
      gap: 5,
      children: drawerUserMenu.map((menu, index) => jsx(BaseDrawer.MenuItem, {
        children: jsx(BaseDrawer.MenuAction, {
          href: menu.href,
          onClick: () => {
            menu.onClick?.();
            onClose();
          },
          logData: {
            key: 'drawer.user.item',
            params: {
              index
            }
          },
          children: jsx(GlobalDrawerMenuItemText, {
            children: menu.title
          })
        })
      }, index))
    }), jsx(BaseDrawer.Divider, {
      my: 36
    }), jsx(GlobalDrawerFooterMenu, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  });
}

var _path$5, _path2$3;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgIcNew18 = function SvgIcNew18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F77",
    fillRule: "evenodd",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m-1.7-5.25H5.26v-7.5h2.61l2.8 4.2h.03v-4.2h2.06v7.5h-2.3l-3.1-4.68h-.05v4.68z",
    clipRule: "evenodd"
  })));
};
var NewIcon$1 = SvgIcNew18;

function _EMOTION_STRINGIFIED_CSS_ERROR__$_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$u = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "l717kj-NavigationDrawerMenuAccordion",
  styles: "overflow:hidden;label:NavigationDrawerMenuAccordion;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$_
};
function NavigationDrawerMenuAccordion({
  children,
  isExpanded,
  onTransitionStart,
  onTransitionEnd
}) {
  const container = useRef(null);
  const content = useRef(null);
  const isExpanding = useRef(false);
  const isCollapsing = useRef(false);
  const expand = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      return;
    }
    if (isCollapsing.current) {
      return;
    }
    isExpanding.current = true;
    container.current.style.display = 'block';
    container.current.style.height = `${content.current.clientHeight}px`;
    onTransitionStart();
  }, [onTransitionStart]);
  const collapse = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      return;
    }
    if (isCollapsing.current) {
      return;
    }
    isCollapsing.current = true;
    container.current.style.height = `${content.current.clientHeight}px`;
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.style.height = '0px';
      onTransitionStart();
    }, 50);
  }, [onTransitionStart]);
  const handleTransitionEnd = useCallback(() => {
    if (!container.current || !content.current) {
      return;
    }
    if (isExpanding.current) {
      container.current.style.height = 'auto';
      isExpanding.current = false;
    } else if (isCollapsing.current) {
      container.current.style.display = 'none';
      isCollapsing.current = false;
    }
    onTransitionEnd();
  }, [onTransitionEnd]);
  useEffect(() => {
    if (!container.current) {
      return;
    }
    if (!container.current.style.transition) {
      return;
    }
    (isExpanded ? expand : collapse)();
  }, [isExpanded, expand, collapse]);
  useEffect(() => {
    if (!container.current) {
      return;
    }
    container.current.style.height = isExpanded ? 'auto' : '0px';
    container.current.style.display = isExpanded ? 'block' : 'none';
    setTimeout(() => {
      if (!container.current) {
        return;
      }
      container.current.style.transition = 'height .3s';
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx("div", {
    ref: container,
    css: _ref$u,
    onTransitionEnd: handleTransitionEnd,
    children: jsx("div", {
      ref: content,
      children: children
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$Z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref4$4 = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "ighj9o-NavigationDrawerMenu",
  styles: "padding:0;label:NavigationDrawerMenu;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Z
};
function NavigationDrawerMenu({
  items,
  indents,
  fontStyles,
  onClose
}) {
  const [expandedIndex, setExpandedIndex] = useState(() => items.findIndex(item => item.active));
  return jsx("ul", {
    css: _ref4$4,
    children: items.map((item, index) => jsx(NavigationDrawerMenuItem, {
      title: item.title,
      icon: item.icon,
      bullet: item.bullet,
      href: item.href,
      isActive: item.active,
      items: item.entries,
      renderChild: item.renderDrawerChild,
      indents: indents,
      fontStyles: fontStyles,
      isExpanded: index === expandedIndex,
      onExpand: () => setExpandedIndex(index),
      onCollapse: () => setExpandedIndex(-1),
      onClick: () => {
        item.onClick?.({
          item,
          index
        });
        if (!item.entries) {
          onClose?.();
        }
      },
      onClose: onClose
    }, index))
  });
}
var _ref$t = process.env.NODE_ENV === "production" ? {
  name: "1keejwa",
  styles: "margin:0 0 14px 2px"
} : {
  name: "c3zf6m-renderTitle",
  styles: "margin:0 0 14px 2px;label:renderTitle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Z
};
var _ref2$b = process.env.NODE_ENV === "production" ? {
  name: "1r7xtnv",
  styles: "margin-left:1.5px"
} : {
  name: "z60fnh-renderTitle",
  styles: "margin-left:1.5px;label:renderTitle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Z
};
var _ref3$8 = process.env.NODE_ENV === "production" ? {
  name: "6103ef",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1"
} : {
  name: "1bx3wbx-renderTitle",
  styles: "display:flex;flex-wrap:wrap;align-items:center;width:100%;height:100%;line-height:1;label:renderTitle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Z
};
function NavigationDrawerMenuItem({
  title,
  icon,
  href,
  bullet,
  items,
  indents = [],
  fontStyles = [],
  isActive,
  isExpanded,
  onExpand,
  onCollapse,
  renderChild,
  onClick,
  onClose
}) {
  const theme = useTheme();
  const Link = useLinkContext();
  const Component = isNil$2(href) ? 'button' : Link;
  const isAccordionTransitioning = useRef(false);
  const handleAccordionTransitionStart = useCallback(() => {
    isAccordionTransitioning.current = true;
  }, []);
  const handleAccordionTransitionEnd = useCallback(() => {
    isAccordionTransitioning.current = false;
  }, []);
  const handleAccordionToggle = useCallback(() => {
    if (isAccordionTransitioning.current) {
      return;
    }
    (isExpanded ? onCollapse : onExpand)();
  }, [isExpanded, onCollapse, onExpand]);
  const renderTitle = () => {
    return jsxs("div", {
      css: _ref3$8,
      children: [icon && jsx("span", {
        css: /*#__PURE__*/css("display:inline-block;margin-right:", pxToRem(8), ";border-radius:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:renderTitle;")),
        children: icon
      }), title, bullet === 'new' && jsx(NewIcon$1, {
        css: _ref2$b
      }), bullet === 'dot' && jsx(DotBadge, {
        css: _ref$t
      })]
    });
  };
  const [indent] = indents;
  const [fontStyle = {}] = fontStyles;
  return jsx("li", {
    css: /*#__PURE__*/css("margin:", pxToRem(4), " 0 0;padding:0;font-size:", pxToRem(fontStyle.size || 14), ";font-weight:", isActive ? 'bold' : fontStyle.weight || 'normal', ";color:", fontStyle.color || theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;")),
    children: items && items.length || renderChild ? jsxs(Fragment, {
      children: [jsxs("button", {
        type: "button",
        onClick: () => {
          handleAccordionToggle();
          onClick?.();
        },
        css: /*#__PURE__*/css(RESET_BUTTON, " overflow:hidden;position:relative;display:block;width:100%;height:", pxToRem(40), ";margin:0;padding:0 ", pxToRem(40), " 0 ", pxToRem(indent || 14), ";color:inherit;text-align:left;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/css("background-color:", theme.interactive.transparent, ";", HOVER$1`
                      background-color: ${theme.content.base5};
                    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;")) : HOVER$1`
                    background-color: ${theme.content.base5};
                  `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;")),
        children: [renderTitle(), jsx(Icon$2, {
          size: 12,
          name: isExpanded ? 'chevron_thick_up' : 'chevron_thick_down',
          css: /*#__PURE__*/css("position:absolute;top:", pxToRem(14), ";right:", pxToRem(14), ";color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;"))
        })]
      }), jsx(NavigationDrawerMenuAccordion, {
        isExpanded: isExpanded,
        onTransitionStart: handleAccordionTransitionStart,
        onTransitionEnd: handleAccordionTransitionEnd,
        children: items && jsx(NavigationDrawerMenu, {
          items: items,
          fontStyles: fontStyles.slice(1),
          indents: indents.length > 1 ? indents.slice(1) : indents.slice(-1),
          onClose: onClose
        }) || renderChild && renderChild()
      })]
    }) : jsx(Component, {
      href: href,
      onClick: onClick,
      css: /*#__PURE__*/css(RESET_BUTTON, " overflow:hidden;display:block;width:100%;height:", pxToRem(40), ";padding:0 ", pxToRem(14), " 0 ", pxToRem(indent || 14), ";color:inherit;text-overflow:ellipsis;white-space:nowrap;box-sizing:border-box;outline:none;border-radius:4px;", isActive ? /*#__PURE__*/css("background-color:", theme.interactive.transparent, ";", HOVER$1`
                  background-color: ${theme.content.base5};
                `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;")) : HOVER$1`
                background-color: ${theme.content.base5};
              `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerMenuItem;")),
      children: renderTitle()
    })
  });
}

var _path$4, _path2$2, _path3, _path4, _path5;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 28,
    fill: "none"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M19.711 7.307h10.226c.759 0 1.374-.606 1.374-1.355s-.615-1.356-1.374-1.356h-8.852v-3.24C21.085.607 20.47 0 19.71 0c-.759 0-1.374.607-1.374 1.356v4.596c0 .749.615 1.355 1.374 1.355Z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.804 8.877c0 4.711-2.261 7.638-5.9 7.638s-5.901-2.927-5.901-7.638V8.54c0-4.711 2.26-7.638 5.9-7.638s5.9 2.927 5.9 7.638zm-5.9-5.264c-1.178 0-3.153.64-3.153 4.927v.337c0 4.287 1.975 4.927 3.152 4.927s3.153-.64 3.153-4.927V8.54c0-4.287-1.975-4.927-3.153-4.927Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.278 23.496h4.655c.76 0 1.374.607 1.374 1.356 0 .748-.615 1.355-1.374 1.355H1.873A1.365 1.365 0 0 1 .5 24.852c0-.75.615-1.356 1.374-1.356H6.53v-4.173c0-.748.615-1.355 1.374-1.355.758 0 1.374.607 1.374 1.355zm22.79-13.84H17.343c-.759 0-1.373.607-1.373 1.355 0 .75.614 1.356 1.373 1.356h14.725c.76 0 1.374-.607 1.374-1.356 0-.748-.615-1.355-1.374-1.355M21.009 24.362c.654.499 2.897 1.475 9.59-.24a1.376 1.376 0 0 1 1.675.97 1.354 1.354 0 0 1-.984 1.653c-2.745.704-5.095 1.055-7.035 1.056-2.15 0-3.797-.432-4.927-1.294-1.103-.843-1.686-2.063-1.686-3.532v-2.163c0-.748.614-1.356 1.373-1.356h9.703v-2.03h-9.703a1.365 1.365 0 0 1-1.373-1.355c0-.749.614-1.356 1.373-1.356h11.077c.759 0 1.373.607 1.373 1.356v4.741c0 .749-.614 1.356-1.373 1.356h-9.703v.807c0 .632.191 1.06.62 1.387M68.135 0a1.41 1.41 0 0 0-1.419 1.4v11.2c0 .773.636 1.4 1.42 1.4a1.41 1.41 0 0 0 1.418-1.4V1.4c0-.773-.635-1.4-1.419-1.4m-6.624 12.39a1.374 1.374 0 0 0 1.759.808 1.35 1.35 0 0 0 .823-1.737c-.045-.12-.944-2.5-3.191-4.195l3.49-3.83c.362-.398.454-.97.233-1.458a1.38 1.38 0 0 0-1.255-.804h-8.56c-.759 0-1.374.607-1.374 1.356 0 .748.615 1.355 1.374 1.355h5.477l-6.499 7.132a1.34 1.34 0 0 0 .103 1.914c.263.233.591.348.919.348.376 0 .75-.152 1.022-.45l3.224-3.538c1.706 1.19 2.437 3.054 2.454 3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M67.072 17.362c0-.749.615-1.356 1.374-1.356s1.374.607 1.374 1.356v6.627c0 1.914-1.579 3.471-3.519 3.471h-6.634c-1.94 0-3.519-1.557-3.519-3.471v-6.627c0-.749.615-1.356 1.374-1.356s1.374.607 1.374 1.356v2.095h8.176zm-7.405 7.387h6.634c.425 0 .771-.34.771-.76v-1.821h-8.176v1.82c0 .42.346.761.771.761m-18.999-8.935c1.664 0 3.052-.87 3.91-2.452.678-1.252 1.037-2.982 1.037-5.004s-.359-3.752-1.038-5.004C43.72 1.772 42.332.902 40.668.902s-3.052.87-3.91 2.452c-.678 1.252-1.037 2.982-1.037 5.004s.359 3.752 1.038 5.004c.857 1.581 2.245 2.452 3.909 2.452m0-12.201c2.093 0 2.2 3.952 2.2 4.745 0 .792-.107 4.745-2.2 4.745s-2.2-3.953-2.2-4.745.106-4.745 2.2-4.745",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M47.746 1.81c0-.748.615-1.355 1.374-1.355s1.374.607 1.374 1.356V25.73c0 .749-.615 1.355-1.374 1.355a1.365 1.365 0 0 1-1.374-1.355v-4.514c-2.992.733-7.314.95-9.812.95h-2.091a1.365 1.365 0 0 1-1.374-1.355c0-.749.615-1.356 1.374-1.356h2.091c4.378 0 7.991-.493 9.812-1.052z"
  })));
};
var LogoIcon = SvgLogo;

function _EMOTION_STRINGIFIED_CSS_ERROR__$Y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$s = process.env.NODE_ENV === "production" ? {
  name: "40f4ru",
  styles: "vertical-align:top"
} : {
  name: "1w6io5f-Logo",
  styles: "vertical-align:top;label:Logo;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Y
};
function Logo$1({
  logo,
  children,
  ...rest
}) {
  const theme = useTheme();
  const Link = useLinkContext();
  return jsx(Link, {
    ...rest,
    href: logo?.href || 'https://ohou.se',
    "aria-label": "\uC624\uB298\uC758\uC9D1 \uB85C\uACE0",
    css: [/*#__PURE__*/css(RESET_BUTTON, " display:inline-flex;align-items:center;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";font-size:0;line-height:0;color:", theme.interactive.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:Logo;")), FOCUS`
          box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
          border-radius: ${pxToRem(3)};
        `, process.env.NODE_ENV === "production" ? "" : ";label:Logo;"],
    children: children || logo?.item || jsx(LogoIcon, {
      css: _ref$s
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$X() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$r = process.env.NODE_ENV === "production" ? {
  name: "1200b05",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none"
} : {
  name: "10rqdyz-NavigationDrawerHeader",
  styles: "position:absolute;top:0;right:0;display:flex;align-items:center;outline:none;label:NavigationDrawerHeader;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$X
};
function NavigationDrawerHeader({
  logo,
  action,
  supplementary
}) {
  const log = useLogContext();
  const {
    userProfile,
    signup,
    signin
  } = supplementary;
  return jsxs(Fragment, {
    children: [jsxs("div", {
      css: /*#__PURE__*/css("position:relative;font-size:", pxToRem(14), ";line-height:", pxToRem(18), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;")),
      children: [jsx(Logo$1, {
        ...logo,
        onClick: () => log({
          key: 'drawer.logo',
          category: 'click'
        })
      }), action && (({
        text,
        ...rest
      }) => jsxs(TextButton, {
        ...rest,
        size: 32,
        variant: "primary1",
        css: _ref$r,
        children: [text, jsx(Icon$2, {
          name: "chevron_right",
          size: 12,
          fill: theme => theme.content.primary1.basic,
          css: /*#__PURE__*/css("margin-left:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;"))
        })]
      }))(action)]
    }), userProfile == null ? jsxs("div", {
      css: /*#__PURE__*/css("display:flex;justify-content:space-between;width:100%;margin:", pxToRem(20), " 0 ", pxToRem(10), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;")),
      children: [signin && jsx(OutlineAnchorButton, {
        href: signin.href,
        size: 44,
        variant: "primary1",
        onClick: () => {
          // to signIn page
        },
        css: /*#__PURE__*/css("font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;height:", pxToRem(42), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;")),
        children: signin.title
      }), signup && jsx(AnchorButton, {
        href: signup.href,
        size: 44,
        variant: "primary1",
        onClick: () => {
          // to signUp page
        },
        css: /*#__PURE__*/css("margin-left:", pxToRem(8), ";font-weight:bold;outline:none;display:flex;flex:1;justify-content:center;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;")),
        children: signup.title
      })]
    }) : jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;margin:", pxToRem(24), " 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;")),
      children: [jsx(Avatar$2, {
        "aria-label": "drawer \uC720\uC800 \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0",
        size: 20,
        src: userProfile.imageUrl
      }), jsx("p", {
        css: /*#__PURE__*/css("font-size:", pxToRem(14), ";line-height:", pxToRem(20), ";margin-left:", pxToRem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerHeader;")),
        children: userProfile.nickname
      })]
    })]
  });
}

function NavigationDrawerFooterListItem({
  title,
  href,
  onClick,
  onClose
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  return jsx("li", {
    css: [/*#__PURE__*/css("display:inline-block;padding:", pxToRem(6), ";border-radius:", pxToRem(4), ";margin:0 0 0 ", pxToRem(7), ";line-height:", pxToRem(18), ";&:first-of-type{margin:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;")), HOVER$1`
        background-color: ${theme.background.groupedBase};
      `, process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;"],
    children: href != null ? jsx(LinkComponent, {
      href: href,
      css: /*#__PURE__*/css(FONT_STYLE.subTitle2, " outline:none;vertical-align:middle;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;")),
      onClick: onClose,
      children: title
    }) : jsx("button", {
      css: /*#__PURE__*/css(RESET_BUTTON, " ", FONT_STYLE.subTitle2, " color:", theme.content.base1, ";outline:none;cursor:pointer;vertical-align:middle;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooterListItem;")),
      onClick: onClick,
      type: "button",
      children: title
    })
  });
}
function NavigationDrawerFooter({
  items,
  onClose
}) {
  return jsx("ul", {
    css: /*#__PURE__*/css("padding:0;margin-top:", pxToRem(14), ";display:flex;align-items:center;>button{font-size:", pxToRem(14), ";font-weight:normal;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationDrawerFooter;")),
    children: items.map((item, index) => jsx(NavigationDrawerFooterListItem, {
      onClose: onClose,
      ...item
    }, index))
  });
}

function LocalNavigationDrawer({
  open,
  logo,
  menuSchema,
  supplementary,
  onClose,
  onAppDownload,
  ...rest
}) {
  const {
    userMenu,
    showAppDownloadButton = true
  } = supplementary;
  const log = useLogContext();
  const {
    localeData
  } = useGNBData();
  const drawerMenu = useMemo(() => menuSchema.map(mainMenu => ({
    ...mainMenu,
    onClick: ({
      index
    }) => {
      log({
        key: 'drawer.main.item',
        category: 'click',
        params: {
          index
        }
      });
    },
    entries: mainMenu.entries?.map(subMenu => ({
      ...subMenu,
      onClick: ({
        item: {
          href
        },
        index
      }) => {
        log({
          key: 'drawer.sub.item',
          category: 'click',
          params: {
            index,
            href
          }
        });
      }
    }))
  })), [menuSchema, log]);
  const drawerUserMenu = useMemo(() => userMenu.filter(menu => menu.showOn?.includes('drawer')).map(({
    logId,
    title,
    href,
    bullet,
    onClick
  }) => ({
    title,
    href,
    bullet,
    onClick: ({
      index
    }) => {
      log({
        key: 'drawer.user.item',
        category: 'click',
        params: {
          index,
          ...(logId === 'user.remodeling.history' && {
            section_id: 'O2O_HISTORY'
          })
        }
      });
      onClick?.();
    }
  })), [userMenu, log]);
  const drawerFooterMenu = useMemo(() => userMenu.filter(menu => menu.type === 'bottom'), [userMenu]);
  return jsxs(Drawer, {
    open: open,
    width: 270,
    onClose: onClose,
    ...rest,
    children: [jsx(NavigationDrawerHeader, {
      logo: {
        logo,
        onClick: () => window.open(logo?.href || 'https://ohou.se')
      },
      action: showAppDownloadButton ? {
        text: localeData?.appDownload ?? '앱다운로드',
        onClick: () => {
          log({
            key: 'drawer.user.profile',
            category: 'click'
          });
          onAppDownload?.();
        }
      } : undefined,
      supplementary: supplementary
    }), jsx(NavigationDrawerDivider, {
      variant: "thin"
    }), jsx(NavigationDrawerMenu, {
      items: drawerMenu,
      fontStyles: [{
        size: 16,
        weight: 'bold'
      }],
      indents: [14, 42, 50],
      onClose: onClose
    }), drawerUserMenu.length > 0 && jsx(NavigationDrawerDivider, {
      variant: "thin"
    }), jsx(NavigationDrawerMenu, {
      items: drawerUserMenu,
      onClose: onClose
    }), jsx(NavigationDrawerDivider, {
      variant: "thin"
    }), jsx(NavigationDrawerFooter, {
      items: drawerFooterMenu,
      onClose: onClose
    })]
  });
}
const NavigationDrawerDivider = /*#__PURE__*/_styled(Divider, process.env.NODE_ENV === "production" ? {
  target: "eyo3jx70"
} : {
  target: "eyo3jx70",
  label: "NavigationDrawerDivider"
})("margin:", pxToRem(20), " 0;");

/**
 * 50ms의 타임아웃을 두고 마우스 호버 이벤트를 감지하는 커스텀
 *
 * @param {Function} onHover - 호버가 감지되었을 때 실행할 콜백 함수
 * @returns {[Function, Function]}
 *   1. `handleMouseEnter`: 요소에 마우스가 들어갈 때 호출해야 하는 함수
 *   2. `handleMouseLeave`: 요소에서 마우스가 나갈 때 호출해야 하는 함수
 */
function useHover(onHover) {
  const onHoverRef = useRef(onHover);
  onHoverRef.current = onHover;
  const timeoutRef = useRef(null);
  const handleMouseTimeout = useCallback(() => {
    onHoverRef.current();
    timeoutRef.current = null;
  }, []);
  const handleMouseMove = useCallback(() => {
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout]);
  const handleMouseEnter = useCallback(() => {
    window.addEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(handleMouseTimeout, 50);
  }, [handleMouseTimeout, handleMouseMove]);
  const handleMouseLeave = useCallback(() => {
    window.removeEventListener('mousemove', handleMouseMove);
    if (timeoutRef.current != null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [handleMouseMove]);
  useEffect(() => {
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      if (timeoutRef.current != null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [handleMouseMove]);
  return [handleMouseEnter, handleMouseLeave];
}

function NavigationBarPrimaryTabItem(props) {
  const {
    component = 'button',
    index,
    isActive,
    isOpen,
    children,
    onSelect,
    forwardedRef,
    onClick,
    ...rest
  } = props;
  const theme = useTheme();
  const log = useLogContext();
  const handleClick = useCallback(e => {
    if (onClick) {
      onClick(e);
    }
    log({
      key: 'primary.item',
      category: 'click',
      params: {
        index
      }
    });
  }, [log, onClick, index]);
  const [handleMouseEnter, handleMouseLeave] = useHover(onSelect);
  const Component = component;
  return jsx(Component, {
    "data-testid": "navigation-primary-tab-item",
    css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;display:inline-block;margin:0 ", pxToRem(10), ";padding:", pxToRem(21), " ", pxToRem(5), " ", pxToRem(15), ";font-size:", pxToRem(18), ";line-height:1;font-weight:bold;color:", theme.content.base1, ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;")), isActive && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;")), isOpen && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;")), HOVER$1`
          color: ${theme.content.primary1.basic};
        `, FOCUS`
          color: ${theme.content.primary1.basic};
          & > span {
            box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
          }
        `, process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;"],
    ref: forwardedRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ...rest,
    children: jsx("span", {
      css: /*#__PURE__*/css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(3), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarPrimaryTabItem;")),
      children: children
    })
  });
}

function BasePrimaryBarItem({
  children,
  component,
  onHover,
  forwardedRef,
  logData,
  ...rest
}) {
  const log = useLogContext();
  const [handleMouseEnter, handleMouseLeave] = useHover(onHover);
  const Component = component ?? 'button';
  return jsx(Component, {
    ref: forwardedRef,
    "data-testid": "navigation-primary-tab-item",
    onClick: () => {
      log({
        key: 'primary.item',
        category: 'click',
        params: logData?.params
      });
    },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ...rest,
    children: children
  });
}

function BasePrimaryBar({
  initialHeight,
  onHoverIn,
  onHoverOut,
  children,
  ...props
}) {
  const childRef = useRef(null);
  const isPc = useMedia(`(min-width: ${BREAK_POINT.tablet}px)`, true);
  const nodeHeight = useNodeHeight(childRef, initialHeight);
  const scrollDir = useScrollDirection();
  return jsx(StyledSticky$1, {
    direction: "top",
    offset: !isPc && scrollDir === 'down' ? -nodeHeight : 0,
    offsetRange: isPc ? [0, 0] : [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    zIndex: ZINDEX$1.appBar + 2,
    transition: 0.1,
    onMouseEnter: onHoverIn,
    onMouseLeave: onHoverOut,
    forwardRef: childRef,
    ...props,
    children: children
  });
}
BasePrimaryBar.TabItem = BasePrimaryBarItem;
const StyledSticky$1 = /*#__PURE__*/_styled(Sticky, process.env.NODE_ENV === "production" ? {
  target: "eojx8xr0"
} : {
  target: "eojx8xr0",
  label: "StyledSticky"
})("background-color:", ({
  theme
}) => theme.background.base, ";");

function BaseSecondaryBar({
  hasItems,
  isForceOpened,
  children,
  initialHeight,
  onHoverIn,
  onHoverOut,
  className
}) {
  const childRef = useRef(null);
  const nodeHeight = useNodeHeight$1(childRef, initialHeight);
  const scrollDir = useScrollDirection$1();
  const isOpen = hasItems && scrollDir !== 'down' || isForceOpened;
  return jsx(StyledSticky, {
    className: ['layout-navigation-secondary', ...(className ? [className] : [])].join(' '),
    containerStyle: !hasItems ? {
      position: 'relative',
      top: isForceOpened ? '0' : pxToRem(-nodeHeight),
      height: '0px',
      transition: '.1s top'
    } : undefined,
    direction: "top",
    offset: isOpen ? 0 : -nodeHeight,
    offsetRange: [-nodeHeight, 0],
    type: "navigation",
    disableNativeSticky: true,
    disableBottom: true,
    disableHeight: !hasItems,
    forwardRef: childRef,
    zIndex: ZINDEX$1.appBar + 1,
    transition: 0.1,
    initialState: !hasItems ? {
      ...DEFAULT_STICKY_STATE,
      disabled: false,
      emulatedDisabled: false,
      offset: -nodeHeight,
      emulatedOffset: -nodeHeight
    } : undefined,
    onMouseEnter: onHoverIn,
    onMouseLeave: onHoverOut,
    children: children
  });
}
const StyledSticky = /*#__PURE__*/_styled(Sticky$1, process.env.NODE_ENV === "production" ? {
  target: "e5aip0g0"
} : {
  target: "e5aip0g0",
  label: "StyledSticky"
})("background:", ({
  theme
}) => theme.background.base, ";border-bottom:", pxToRem(1), " solid ", ({
  theme
}) => theme.divider, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$W() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_NODE_HEIGHT$1 = 81;
function NavigationBarPrimary(props) {
  const {
    leftmost,
    left,
    right,
    menuEntries,
    activeId,
    selectedId,
    onMouseEnter,
    onMouseLeave,
    onSelect
  } = props;
  const LinkComponent = useLinkContext();
  return jsx(LocalPrimaryBar, {
    initialHeight: INITIAL_NODE_HEIGHT$1,
    onHoverIn: onMouseEnter,
    onHoverOut: onMouseLeave,
    children: jsxs(StyledContainer$1, {
      children: [jsx(LeftMost, {
        children: leftmost
      }), jsx(Left, {
        children: left
      }), jsx(NavigationBarPrimaryTabList, {
        children: menuEntries.map((item, index) => jsx(NavigationBarPrimaryTabItem, {
          index: index,
          component: LinkComponent,
          href: item.href,
          isActive: activeId === index,
          isOpen: selectedId === index,
          onSelect: () => onSelect(item, index),
          children: item.title
        }, index))
      }), jsx(Right$2, {
        children: right
      })]
    })
  });
}
const LocalPrimaryBar = /*#__PURE__*/_styled(BasePrimaryBar, process.env.NODE_ENV === "production" ? {
  target: "e1988c065"
} : {
  target: "e1988c065",
  label: "LocalPrimaryBar"
})("background:", ({
  theme
}) => theme.background.base, ";border-bottom:1px solid ", ({
  theme
}) => theme.divider, ";");
const StyledContainer$1 = /*#__PURE__*/_styled(Container$G, process.env.NODE_ENV === "production" ? {
  target: "e1988c064"
} : {
  target: "e1988c064",
  label: "StyledContainer"
})("position:relative;display:flex;align-items:center;justify-content:space-between;height:50px;box-sizing:border-box;line-height:0;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "oh5yf0",
  styles: "height:80px;padding-top:10px;padding-bottom:10px"
} : {
  name: "scmr9i-StyledContainer",
  styles: "height:80px;padding-top:10px;padding-bottom:10px;label:StyledContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), ";");
const LeftMost = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1988c063"
} : {
  target: "e1988c063",
  label: "LeftMost"
})("flex:0 0 auto;display:block;margin-left:-7px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "jk5cn7-LeftMost",
  styles: "display:none;label:LeftMost;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), ";");
const Left = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1988c062"
} : {
  target: "e1988c062",
  label: "Left"
})("position:absolute;flex:0 0 auto;left:50%;top:50%;color:", ({
  theme
}) => theme.interactive.base1, ";transform:translate(-50%, -50%);", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "xlj1a2",
  styles: "position:static;margin-right:20px;left:none;top:none;transform:none"
} : {
  name: "5ukjfd-Left",
  styles: "position:static;margin-right:20px;left:none;top:none;transform:none;label:Left;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), " ", MEDIA_QUERY.min('laptop', process.env.NODE_ENV === "production" ? {
  name: "1xlf9iz",
  styles: "margin-right:35px"
} : {
  name: "1lcdngo-Left",
  styles: "margin-right:35px;label:Left;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), ";");
const NavigationBarPrimaryTabList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1988c061"
} : {
  target: "e1988c061",
  label: "NavigationBarPrimaryTabList"
})("flex:1 1 0px;display:none;white-space:nowrap;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "17kma8h-NavigationBarPrimaryTabList",
  styles: "display:block;label:NavigationBarPrimaryTabList;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), ";");
const Right$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1988c060"
} : {
  target: "e1988c060",
  label: "Right"
})("flex:0 0 auto;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "zd8pen",
  styles: "flex:0 1 476px"
} : {
  name: "1bjpz0a-Right",
  styles: "flex:0 1 476px;label:Right;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), " ", MEDIA_QUERY.min('desktop', process.env.NODE_ENV === "production" ? {
  name: "4ji33p",
  styles: "flex:0 1 650px"
} : {
  name: "1r98yfw-Right",
  styles: "flex:0 1 650px;label:Right;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), " ", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "gbs8ku",
  styles: "margin-right:-7px"
} : {
  name: "1e0qy0c-Right",
  styles: "margin-right:-7px;label:Right;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$W
}), ";");

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

/* eslint-disable camelcase */

/** 글로벌에서만 찍는 로그를 한시적으로 적용합니다. 추후 국내와 국외 로그 스펙이 같거나 비슷해져서 통합 가능해졌을 때 Context형태로 통합하는 것을 권장합니다. */

const globalLog = {
  logClickTab: ({
    section_id,
    section_idx
  }) => {
    O$1({
      category: 'click',
      section_id,
      section_idx,
      type: 'TAB'
    });
  },
  logClickAutocompleteKeyword: ({
    id,
    index
  }) => {
    O$1({
      category: 'click',
      section_id: 'AUTOCOMPLETE',
      type: 'KEYWORD',
      id,
      index
    });
  },
  logClickSearchInput: () => {
    O$1({
      category: 'click',
      section_id: 'TOPBAR',
      type: 'INPUT',
      id: 'SEARCH'
    });
  },
  logClickChangeLocaleButton: () => {
    O$1({
      category: 'click',
      section_id: 'COUNTRY'
    });
  },
  logClickChangeLocaleSubmitButton: ({
    language,
    country
  }) => {
    O$1({
      category: 'click',
      section_id: 'COUNTRY',
      type: 'BUTTON',
      id: 'CONFIRM',
      data: {
        language,
        country
      }
    });
  }
};

function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function (a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function (a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function (a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function (a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function (a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function (a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function (a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function (a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function (a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function (a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function (a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function () {

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}

var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === 'production') {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }

      // Detect buggy property enumeration order in older V8 versions.

      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }

      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
        return false;
      }
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has = requireHas();
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {/**/}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function () {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function () {};
  if (process.env.NODE_ENV !== 'production') {
    printWarning = function (text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bigint: createPrimitiveTypeChecker('bigint'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === 'object' ? data : {};
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (!manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
            expectedType: expectedType
          });
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
          } else {
            printWarning('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from props.
        var allKeys = assign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has(shapeTypes, key) && typeof checker !== 'function') {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = /*#__PURE__*/React__default.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);
  function Transition(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;
  var _proto = Transition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }
    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default.findDOMNode(this), appearing],
      maybeNode = _ref2[0],
      maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function () {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
        maybeNode = _ref3[0],
        maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props,
      children = _this$props.children;
      _this$props.in;
      _this$props.mountOnEnter;
      _this$props.unmountOnExit;
      _this$props.appear;
      _this$props.enter;
      _this$props.exit;
      _this$props.timeout;
      _this$props.addEndListener;
      _this$props.onEnter;
      _this$props.onEntering;
      _this$props.onEntered;
      _this$props.onExit;
      _this$props.onExiting;
      _this$props.onExited;
      _this$props.nodeRef;
      var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /*#__PURE__*/(
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : /*#__PURE__*/React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$1() {}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */

var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);
  function CSSTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };
    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument[0],
        appearing = _this$resolveArgument[1];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };
    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument2[0],
        appearing = _this$resolveArgument2[1];
      var type = appearing ? 'appear' : 'enter';
      _this.addClass(node, type, 'active');
      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };
    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
        node = _this$resolveArgument3[0],
        appearing = _this$resolveArgument3[1];
      var type = appearing ? 'appear' : 'enter';
      _this.removeClasses(node, type);
      _this.addClass(node, type, 'done');
      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };
    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument4[0];
      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      _this.addClass(node, 'exit', 'base');
      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };
    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument5[0];
      _this.addClass(node, 'exit', 'active');
      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };
    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
        node = _this$resolveArgument6[0];
      _this.removeClasses(node, 'exit');
      _this.addClass(node, 'exit', 'done');
      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };
    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };
    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };
    return _this;
  }
  var _proto = CSSTransition.prototype;
  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];
    var _this$getClassNames = this.getClassNames('enter'),
      doneClassName = _this$getClassNames.doneClassName;
    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.

    if (phase === 'active') {
      if (node) forceReflow(node);
    }
    if (className) {
      this.appliedClasses[type][phase] = className;
      _addClass(node, className);
    }
  };
  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
      baseClassName = _this$appliedClasses$.base,
      activeClassName = _this$appliedClasses$.active,
      doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};
    if (baseClassName) {
      removeClass(node, baseClassName);
    }
    if (activeClassName) {
      removeClass(node, activeClassName);
    }
    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };
  _proto.render = function render() {
    var _this$props = this.props;
      _this$props.classNames;
      var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
    return /*#__PURE__*/React__default.createElement(Transition$1, _extends$5({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };
  return CSSTransition;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$5({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && /*#__PURE__*/isValidElement(child) ? mapFn(child) : child;
  };
  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list

  var nextKeysPending = Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`

  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return /*#__PURE__*/cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (! /*#__PURE__*/isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = /*#__PURE__*/isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = /*#__PURE__*/cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = /*#__PURE__*/cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && /*#__PURE__*/isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = /*#__PURE__*/cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);
  function TransitionGroup(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear

    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
      handleExited = _ref.handleExited,
      firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$5({}, state.children);
        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      Component = _this$props.component,
      childFactory = _this$props.childFactory,
      props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };
  return TransitionGroup;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;
  if (/*#__PURE__*/React__default.isValidElement(oldChildren) && /*#__PURE__*/React__default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }
  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */

var modes = {
  out: 'out-in',
  in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;
    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
    changeState = _ref.changeState;
  return /*#__PURE__*/React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
    changeState = _ref2.changeState,
    children = _ref2.children;
  return [current, /*#__PURE__*/React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
    changeState = _ref3.changeState;
  return /*#__PURE__*/React__default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(ENTERED, /*#__PURE__*/React__default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
    children = _ref4.children,
    changeState = _ref4.changeState;
  return [/*#__PURE__*/React__default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(ENTERED, /*#__PURE__*/React__default.cloneElement(children, {
        in: true
      }));
    })
  }), /*#__PURE__*/React__default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);
  function SwitchTransition() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: ENTERED,
      current: null
    };
    _this.appeared = false;
    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }
      _this.setState({
        status: status,
        current: current
      });
    };
    return _this;
  }
  var _proto = SwitchTransition.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };
  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }
    if (state.status === ENTERING && props.mode === modes.in) {
      return {
        status: ENTERING
      };
    }
    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: EXITING
      };
    }
    return {
      current: /*#__PURE__*/React__default.cloneElement(props.children, {
        in: true
      })
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      mode = _this$props.mode,
      _this$state = this.state,
      status = _this$state.status,
      current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;
    switch (status) {
      case ENTERING:
        component = enterRenders[mode](data);
        break;
      case EXITING:
        component = leaveRenders[mode](data);
        break;
      case ENTERED:
        component = current;
    }
    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };
  return SwitchTransition;
}(React__default.Component);
SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),
  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
var SwitchTransition$1 = SwitchTransition;

const useNavigationLog = () => {
  const log = useLogContext();
  const logTabImpression = useCallback((menu, index) => {
    log({
      key: 'secondary.item',
      category: 'impression',
      params: {
        index,
        id: menu.logId,
        type: 'topic',
        section: '서브 메뉴',
        section_id: 'LNB'
      }
    });
  }, [log]);
  const logTabClick = useCallback((menu, index, isHncTopicTab) => {
    const defaultParams = {
      index,
      section: '서브 메뉴',
      type: 'tab',
      id: menu.logId ?? menu.title
    };
    const params = isHncTopicTab ? {
      ...defaultParams,
      type: 'topic',
      section_id: 'LNB'
    } : defaultParams;
    log({
      key: 'secondary.item',
      category: 'click',
      params
    });
  }, [log]);
  const logMoreButtonClick = useCallback(() => {
    log({
      key: 'secondary.more.button',
      category: 'click'
    });
  }, [log]);
  return {
    logTabClick,
    logTabImpression,
    logMoreButtonClick
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$V() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BUTTON_WIDTH = 100;
/**
 * scraollableEntries가 false일 경우
 * 메뉴 entries UI를 다른 UI로 보여주는 로직들을 포함합니다.
 */
const useMoreMenus = ({
  menus,
  scrollableEntries,
  activeId,
  primaryId
}) => {
  const menusWithIndex = useMemo(() => menus.map((menu, index) => ({
    ...menu,
    index
  })), [menus]);
  const [moreMenus, setMoreMenus] = useState(menusWithIndex);
  /** moreButton + popper의 visible 여부 */
  const [isVisible, setIsVisible] = useState(false);
  const [isGradientVisible, setIsGradientVisible] = useState(true);
  /** popper를 강제로 닫을지 여부 */
  const [isForcePopperClosed, setIsForcePopperClosed] = useState(false);
  /** popper의 open 여부 */
  const [isPopperOpened, setIsPopperOpened] = useState(false);

  // TODO: bottomSheet 관련 공통 인터랙션 공통화
  const [bottomSheetHeight, setBottomSheetHeight] = useState('auto');
  const [hasClosingInteraction, setHasClosingInteraction] = useState(false);
  const containerRef = useRef(null);
  const currentClientY = useRef(0);
  const isMobile = useResponsive().breakpoint === 'mobile';
  const theme = useTheme();
  const Link = useLinkContext();
  const {
    logTabClick,
    logTabImpression,
    logMoreButtonClick
  } = useNavigationLog();
  const isHncSecondaryTabItem = primaryId === 0;
  const handleIntersect = useCallback((menu, index) => {
    if (!isHncSecondaryTabItem || !menu.logId) {
      return;
    }
    logTabImpression(menu, index);
  }, [logTabImpression, isHncSecondaryTabItem]);
  const handleClick = useCallback((menu, index) => {
    logTabClick(menu, index, !!(isHncSecondaryTabItem && menu.logId));
  }, [logTabClick, isHncSecondaryTabItem]);
  const activeIdInMoreMenus = useMemo(() => {
    if (activeId == null) {
      return null;
    }
    return activeId - (menus.length - moreMenus.length);
  }, [activeId, menus.length, moreMenus.length]);
  const handleOpenBottomSheet = () => {
    setHasClosingInteraction(false);
    setBottomSheetHeight('auto');
    setIsForcePopperClosed(false);
  };
  const handleCloseBottomSheet = () => {
    setHasClosingInteraction(true);
    setBottomSheetHeight('0%');
  };
  const handleTouchMove = useCallback(event => {
    if (event.changedTouches[0]?.clientY) {
      const scrollDown = currentClientY.current < event.changedTouches[0].clientY;
      if (scrollDown) {
        handleCloseBottomSheet();
      }
    }
  }, []);
  const handleChangeVisibleMenu = useCallback((changedMenu, changedMenuIndex, visibleRatio) => {
    if (isMobile) {
      setMoreMenus(menusWithIndex);
      return;
    }
    if (visibleRatio == null) {
      return;
    }
    if (visibleRatio < 1) {
      setMoreMenus(menus => menus.map(menu => menu.index).includes(changedMenuIndex) ? menus : [...menus, {
        ...changedMenu,
        index: changedMenuIndex
      }].sort((a, b) => a.index - b.index));
    } else {
      setMoreMenus(menus => menus.filter(menu => changedMenuIndex !== menu.index));
    }
  }, [isMobile, menusWithIndex]);
  const handleChangeVisibleGradient = node => {
    const scrollRight = node.scrollWidth - Math.ceil(node.scrollLeft) - node?.getBoundingClientRect().width;
    setIsGradientVisible(scrollRight > 5);
  };
  const handleResize = () => {
    if (!containerRef.current) {
      return;
    }
    const scrollWidth = containerRef.current.scrollWidth;
    const elementWidth = Math.ceil(containerRef.current.getBoundingClientRect().width);
    const overflowWidth = Math.max(scrollWidth - elementWidth, 0);
    setIsVisible(overflowWidth > 0);
  };
  useResize(containerRef, handleResize);
  useEffect(() => {
    setMoreMenus([]);
  }, [scrollableEntries]);
  useEffect(() => {
    if (isMobile) {
      return;
    }
    const handleScroll = () => {
      const isScrollDown = currentClientY.current < window.scrollY;
      setIsForcePopperClosed(isScrollDown);
      currentClientY.current = window.scrollY;
    };
    const throttleScroll = throttle$1(handleScroll, 1000);
    window.addEventListener('scroll', throttleScroll);
    return () => {
      window.removeEventListener('scroll', throttleScroll);
    };
  }, [isMobile]);
  const MoreMenus = useMemo(() => {
    return jsx(MoreMenusContainer, {
      children: moreMenus.map((menu, index) => jsx(StyledIntersectionObserver, {
        onIntersect: () => handleIntersect(menu, menu.index),
        children: jsx(Link, {
          href: menu.href,
          onClick: () => {
            handleClick(menu, menu.index);
            setIsForcePopperClosed(true);
          },
          css: [cssLink, /*#__PURE__*/css("@media(hover: hover){&:hover{color:", theme.content.primary1.basic, ";}}", activeIdInMoreMenus === index && /*#__PURE__*/css("color:", theme.content.primary1.basic, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenus;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenus;")), FOCUS`
                  color: ${theme.content.primary1.basic};
                `, process.env.NODE_ENV === "production" ? "" : ";label:MoreMenus;"],
          children: menu.title
        })
      }, menu.title))
    });
  }, [theme, moreMenus, Link, activeIdInMoreMenus, handleIntersect, handleClick]);
  return {
    onChangeVisibleMenu: handleChangeVisibleMenu,
    onChangeVisibleGradient: handleChangeVisibleGradient,
    containerRef,
    isPopperOpened,
    moreMenusComponent: isVisible ? jsx(Popper$1, {
      isForceClosed: isForcePopperClosed,
      usePortal: false,
      style: isMobile ? {
        visibility: 'hidden'
      } : undefined,
      onChange: setIsPopperOpened,
      renderButton: ({
        onClick,
        isOpen
      }) => jsxs(Fragment, {
        children: [jsx(MoreButton, {
          isGradientVisible: isGradientVisible,
          type: "button",
          onClick: () => {
            handleOpenBottomSheet();
            onClick();
            logMoreButtonClick();
          },
          children: jsx(ChevronDownIcon, {
            size: 12,
            name: "chevron_down",
            fill: theme => theme.content.base1
          })
        }), isMobile && isOpen && jsx(StyledModal$1, {
          width: 400,
          hasInteraction: true,
          hasGrabber: true,
          height: bottomSheetHeight,
          hasClosingInteraction: hasClosingInteraction,
          onBlur: handleCloseBottomSheet,
          onTouchStart: event => {
            if (event.changedTouches[0]?.clientY) {
              currentClientY.current = event.changedTouches[0]?.clientY;
            }
          },
          onTouchMove: handleTouchMove,
          disableBackgroundScroll: true,
          header: {
            title: '탭 선택하기',
            onClose: handleCloseBottomSheet
          },
          onTransitionEnd: () => {
            if (hasClosingInteraction) {
              onClick();
            }
          },
          children: jsx(SwitchTransition$1, {
            children: jsx(Transition$1, {
              timeout: 200,
              children: MoreMenus
            })
          })
        })]
      }),
      children: !isMobile && MoreMenus
    }) : null
  };
};
const cssLink = /*#__PURE__*/css(FONT_STYLE.body1_small, " display:block;padding:", pxToRem(10), " 0 ", pxToRem(10), " ", pxToRem(26), ";text-align:start;font-weight:700;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css(FONT_STYLE.subTitle1, ";padding:0 0 ", pxToRem(20), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;"))), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssLink;"));
const MoreButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "eepz8hq4"
} : {
  target: "eepz8hq4",
  label: "MoreButton"
})(RESET_BUTTON, " padding:0 ", pxToRem(6), ";height:100%;display:flex;align-items:center;position:absolute;transform:translateX(-100%);", ({
  isGradientVisible,
  theme
}) => isGradientVisible && /*#__PURE__*/css("&:after{content:'';position:absolute;right:0;width:", pxToRem(BUTTON_WIDTH), ";height:100%;background:linear-gradient(90deg, ", hexToRgba(theme.background.base, 0), " 0%, ", theme.background.base, " 50%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreButton;")), ";");
const MoreMenusContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eepz8hq3"
} : {
  target: "eepz8hq3",
  label: "MoreMenusContainer"
})("display:flex;flex-wrap:wrap;padding-top:", pxToRem(30), ";", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("display:block;min-width:", pxToRem(250), ";padding:", pxToRem(20), " ", pxToRem(22), " 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:MoreMenusContainer;"))), ";");
const ChevronDownIcon = /*#__PURE__*/_styled(Icon$2, process.env.NODE_ENV === "production" ? {
  target: "eepz8hq2"
} : {
  target: "eepz8hq2",
  label: "ChevronDownIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "1dk0v5d",
  styles: "z-index:2"
} : {
  name: "1dk0v5d",
  styles: "z-index:2",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$V
});
var _ref$q = process.env.NODE_ENV === "production" ? {
  name: "1yoibbp",
  styles: "opacity:0;transition:opacity 0.3s ease-in"
} : {
  name: "1pkytaj-StyledModal",
  styles: "opacity:0;transition:opacity 0.3s ease-in;label:StyledModal;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$V
};
const StyledModal$1 = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "eepz8hq1"
} : {
  target: "eepz8hq1",
  label: "StyledModal"
})(({
  hasClosingInteraction
}) => hasClosingInteraction && _ref$q, ";");
const StyledIntersectionObserver = /*#__PURE__*/_styled(IntersectionObserver$1, process.env.NODE_ENV === "production" ? {
  target: "eepz8hq0"
} : {
  target: "eepz8hq0",
  label: "StyledIntersectionObserver"
})(process.env.NODE_ENV === "production" ? {
  name: "1dlyed8",
  styles: "flex-basis:50%"
} : {
  name: "1dlyed8",
  styles: "flex-basis:50%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$V
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$U() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$p = process.env.NODE_ENV === "production" ? {
  name: "gth0vq",
  styles: "height:inherit"
} : {
  name: "1p5tzyk-NavigationBarSecondaryTabItem",
  styles: "height:inherit;label:NavigationBarSecondaryTabItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$U
};
function NavigationBarSecondaryTabItem(props) {
  const {
    onSelect,
    index,
    item,
    onChangeVisibleMenu,
    containerRef,
    primaryId,
    ...rest
  } = props;
  const {
    isGlobal
  } = useGNBData();
  const LinkComponent = useLinkContext();
  const [handleMouseEnter, handleMouseLeave] = useHover(onSelect);
  const {
    ref,
    entry
  } = useInView({
    root: containerRef.current,
    rootMargin: `0px -${BUTTON_WIDTH}px 0px 0px`,
    initialInView: true,
    threshold: [0, 1]
  });
  const {
    logTabClick,
    logTabImpression
  } = useNavigationLog();
  const isHncSecondaryTabItem = primaryId === 0;
  const handleIntersect = useCallback(() => {
    if (!isHncSecondaryTabItem || !item.logId) {
      return;
    }
    logTabImpression?.(item, index);
  }, [logTabImpression, item, index, isHncSecondaryTabItem]);
  const handleTabClick = useCallback(() => {
    // TODO: 글로벌 분기 제거
    if (isGlobal) {
      globalLog.logClickTab({
        section_idx: index,
        section_id: item.logId
      });
    } else {
      logTabClick?.(item, index, !!(isHncSecondaryTabItem && item.logId));
    }
  }, [index, isGlobal, isHncSecondaryTabItem, item, logTabClick]);
  useEffect(() => {
    onChangeVisibleMenu(item, index, entry?.intersectionRatio);
  }, [entry, item, index, onChangeVisibleMenu]);
  return jsx(IntersectionObserver$1, {
    onIntersect: handleIntersect,
    children: jsx("div", {
      ref: ref,
      css: _ref$p,
      children: jsx(StyledTabItem, {
        ...rest,
        component: LinkComponent,
        onClick: handleTabClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      })
    })
  });
}
const StyledTabItem = /*#__PURE__*/_styled(TabItem, process.env.NODE_ENV === "production" ? {
  target: "ev1ao2b0"
} : {
  target: "ev1ao2b0",
  label: "StyledTabItem"
})("height:inherit;outline:none;&>div>p{font-weight:700;}", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("padding:", pxToRem(11), " ", pxToRem(5), ";>div>p{", FONT_STYLE.subTitle2, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;"))), " ", ({
  theme
}) => /*#__PURE__*/css(HOVER$1`
      color: ${theme.content.primary1.basic};
    `, " ", FOCUS`
      * {
        color: ${theme.content.primary1.basic};
      }
      & > div {
        box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
        border-radius: ${pxToRem(3)};
      }
    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTabItem;")), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$T() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_NODE_HEIGHT = 51;
function NavigationBarSecondary(props) {
  const {
    hasItems,
    isForceOpened,
    isFallback,
    right,
    menuEntries,
    activeId,
    onHoverIn,
    onHoverOut,
    onSelect,
    primaryId,
    scrollableEntries = true
  } = props;
  const theme = useTheme();
  const isMobile = useResponsive().breakpoint === 'mobile';
  const {
    onChangeVisibleMenu,
    onChangeVisibleGradient,
    containerRef,
    moreMenusComponent,
    isPopperOpened
  } = useMoreMenus({
    menus: menuEntries,
    scrollableEntries,
    activeId,
    primaryId
  });

  /** Hover된 Secondary 메뉴 내 Popper가 닫히면, Secondary의 Hover상태도 없애기 위해 실행합니다. */
  useEffect(() => {
    if (isPopperOpened) {
      return;
    }
    onHoverOut?.();
  }, [isPopperOpened, onHoverOut]);
  if (menuEntries.length === 0) {
    return null;
  }
  return jsx(BaseSecondaryBar, {
    css: /*#__PURE__*/css(isFallback && /*#__PURE__*/css("background:", theme.background.groupedBase, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarSecondary;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarSecondary;")),
    hasItems: hasItems,
    isForceOpened: isForceOpened,
    initialHeight: INITIAL_NODE_HEIGHT,
    onHoverIn: onHoverIn,
    onHoverOut: () => {
      if (isPopperOpened) {
        return;
      }
      onHoverOut?.();
    },
    children: jsxs(StyledContainer, {
      scrollable: scrollableEntries,
      children: [jsxs(TabContainer$1, {
        ref: containerRef,
        scrollable: scrollableEntries,
        children: [jsx(StyledTab, {
          ref: node => {
            if (!node) {
              return;
            }
            const throttleScroll = throttle$1(() => onChangeVisibleGradient(node), 100);
            node.addEventListener('scroll', throttleScroll);
          },
          scrollable: scrollableEntries,
          isMobile: isMobile,
          children: menuEntries.map((item, index) => jsx(NavigationBarSecondaryTabItem, {
            containerRef: containerRef,
            index: index,
            onChangeVisibleMenu: onChangeVisibleMenu,
            item: item,
            href: item.href,
            bullet: item.bullet,
            badge: item.badge,
            isActive: activeId === index,
            onSelect: () => onSelect(item, index),
            primaryId: primaryId,
            children: item.title
          }, item.title))
        }), !scrollableEntries && moreMenusComponent]
      }), right && jsx(Right$1, {
        children: right
      })]
    })
  });
}
var _ref3$7 = process.env.NODE_ENV === "production" ? {
  name: "1ahtu5h",
  styles: "overflow:initial;padding-left:0"
} : {
  name: "167amg9-StyledContainer",
  styles: "overflow:initial;padding-left:0;label:StyledContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
};
const StyledContainer = /*#__PURE__*/_styled(Container$G, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => isPropValid(prop),
  target: "ehuls653"
} : {
  shouldForwardProp: prop => isPropValid(prop),
  target: "ehuls653",
  label: "StyledContainer"
})("position:relative;display:flex;align-items:center;justify-content:space-between;box-sizing:border-box;overflow:auto;", ({
  scrollable
}) => !scrollable && _ref3$7, ";");
var _ref2$a = process.env.NODE_ENV === "production" ? {
  name: "d3v9zr",
  styles: "overflow:hidden"
} : {
  name: "xx69bi-StyledTab",
  styles: "overflow:hidden;label:StyledTab;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
};
const StyledTab = /*#__PURE__*/_styled(Tab, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => isPropValid(prop),
  target: "ehuls652"
} : {
  shouldForwardProp: prop => isPropValid(prop),
  target: "ehuls652",
  label: "StyledTab"
})("height:", pxToRem(51), ";", MEDIA_QUERY.max('mobile', /*#__PURE__*/css("height:", pxToRem(40), ";justify-content:center;margin:0 ", pxToRem(-2), ";&&>*{margin:0 ", pxToRem(2), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;"))), " ", ({
  scrollable,
  isMobile
}) => !scrollable && /*#__PURE__*/css("&{", isMobile ? /*#__PURE__*/css("padding:0 ", pxToRem(32), " 0 ", pxToRem(16), ";justify-content:start;" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")) : _ref2$a, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledTab;")), ";");
const Right$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehuls651"
} : {
  target: "ehuls651",
  label: "Right"
})("flex:0 0 auto;display:none;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "17kpjmp",
  styles: "display:block;margin-left:10px"
} : {
  name: "a5adt4-Right",
  styles: "display:block;margin-left:10px;label:Right;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
}), ";");
var _ref$o = process.env.NODE_ENV === "production" ? {
  name: "t1y265",
  styles: "display:flex;justify-content:space-between;overflow:hidden"
} : {
  name: "1sit2m7-TabContainer",
  styles: "display:flex;justify-content:space-between;overflow:hidden;label:TabContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$T
};
const TabContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehuls650"
} : {
  target: "ehuls650",
  label: "TabContainer"
})("flex:1 0 0;", ({
  scrollable
}) => !scrollable && _ref$o, ";");

function NavigationBarTertiary({
  item,
  isOpen,
  onMouseEnter,
  onMouseLeave
}) {
  const itemRef = useRef(item);
  if (item != null) {
    itemRef.current = item;
  }
  const currentItem = itemRef.current;
  const nodeRef = useRef(null);
  const [top, setTop] = useState(null);
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    if (nodeRef.current == null) {
      nodeRef.current = document.querySelector('.layout-navigation-secondary');
    }
    if (nodeRef.current) {
      setTop(nodeRef.current.getBoundingClientRect().bottom);
    }
    let timer = null;
    function handleScroll() {
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
      timer = requestAnimationFrame(() => {
        timer = null;
        if (nodeRef.current) {
          setTop(nodeRef.current.getBoundingClientRect().bottom);
        }
      });
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timer != null) {
        cancelAnimationFrame(timer);
      }
    };
  }, [isOpen]);
  const show = useMemo(() => Boolean(isOpen && item?.renderBarChild), [isOpen, item]);
  if (top == null) {
    return null;
  }
  return jsx(CSSTransition$1, {
    timeout: 200,
    in: show,
    appear: show,
    unmountOnExit: true,
    classNames: {
      enterActive: 'open opening',
      enterDone: 'open open-active',
      appearActive: 'open opening',
      appearDone: 'open open-active',
      exit: 'exiting'
    },
    children: jsx("div", {
      css: /*#__PURE__*/css("position:fixed;top:", top, "px;left:0;right:0;background-color:#ffffff;border-bottom:1px solid #ededed;z-index:500;opacity:0;transform:translateY(-100%);&.opening{transition:.2s opacity,.2s transform;}&.exiting{transition:.2s opacity,.2s transform;}&.open{opacity:1;transform:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationBarTertiary;")),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: currentItem?.renderBarChild?.()
    })
  });
}

const HistoryStorageContext = /*#__PURE__*/createContext({});
const useHistoryStorage = () => useContext(HistoryStorageContext);
function HistoryStorageProvider({
  children,
  ...props
}) {
  return jsx(HistoryStorageContext.Provider, {
    value: props,
    children: children
  });
}

function getSearchPlaceholder(searchType) {
  return searchType === 'store' && '쇼핑 검색' || searchType === 'expert_user' && '시공업체 검색' || '통합검색';
}

/**
 * Escape special regex characters in a string.
 *
 * @example '*' => '\\*'
 *
 * @param input - The string to escape.
 * @returns The escaped string.
 */
function escapeRegex(input) {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$S() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HighlightedText$1({
  item,
  query
}) {
  const {
    highlightedDisplay
  } = item.value;
  if (!query) {
    return jsx(Fragment, {
      children: item.query
    });
  }
  const parts = highlightedDisplay ? highlightedDisplay.split(/<strong>|<\/strong>/gi) : item.query.split(new RegExp(`(${escapeRegex(query)})`, 'gi'));
  return jsx(Fragment, {
    children: parts.map((part, index) => jsx(Fragment$1, {
      children: index % 2 === 1 ? jsx("strong", {
        children: part
      }) : part
    }, index))
  });
}
var _ref$n = process.env.NODE_ENV === "production" ? {
  name: "1uhrb8q",
  styles: "flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:8px"
} : {
  name: "8ztv3b-KeywordItem",
  styles: "flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:8px;label:KeywordItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
var _ref2$9 = process.env.NODE_ENV === "production" ? {
  name: "1953rds",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center"
} : {
  name: "cmch2u-KeywordItem",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center;label:KeywordItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
var _ref3$6 = process.env.NODE_ENV === "production" ? {
  name: "17uk3v8",
  styles: "display:flex;align-items:center;white-space:nowrap"
} : {
  name: "1tzo240-KeywordItem",
  styles: "display:flex;align-items:center;white-space:nowrap;label:KeywordItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$S
};
function KeywordItem(props) {
  return jsxs("div", {
    css: _ref3$6,
    children: [jsx("div", {
      css: _ref2$9,
      children: jsx(SearchIcon, {
        size: 18,
        fill: theme => theme.colors.foregroundWeak
      })
    }), jsx("div", {
      css: _ref$n,
      children: jsx(HighlightedText$1, {
        ...props
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$R() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$m = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "wch7zr-CategoryItem",
  styles: "display:flex;align-items:center;label:CategoryItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
var _ref2$8 = process.env.NODE_ENV === "production" ? {
  name: "fqhs2q",
  styles: "text-overflow:ellipsis;overflow:hidden;margin-left:8px"
} : {
  name: "3lvt1k-CategoryItem",
  styles: "text-overflow:ellipsis;overflow:hidden;margin-left:8px;label:CategoryItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
var _ref3$5 = process.env.NODE_ENV === "production" ? {
  name: "fob7he",
  styles: "width:32px;height:32px;min-width:32px;display:flex;align-items:center;justify-content:center"
} : {
  name: "10210fo-CategoryItem",
  styles: "width:32px;height:32px;min-width:32px;display:flex;align-items:center;justify-content:center;label:CategoryItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
var _ref4$3 = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "ick9f2-CategoryItem",
  styles: "display:flex;align-items:center;overflow:hidden;label:CategoryItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
var _ref5$3 = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "1msaz0g-CategoryItem",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:CategoryItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$R
};
function CategoryItem(props) {
  const theme = useTheme();
  return jsxs("div", {
    css: _ref5$3,
    children: [jsxs("div", {
      css: _ref4$3,
      children: [jsx("div", {
        css: _ref3$5,
        children: jsx(StoreIcon, {
          size: 18,
          fill: theme => theme.colors.foregroundWeak
        })
      }), jsx("div", {
        css: _ref2$8,
        children: jsx(HighlightedText$1, {
          ...props
        })
      })]
    }), jsxs("div", {
      css: _ref$m,
      children: [jsx("span", {
        css: /*#__PURE__*/css(FONT_STYLE.subTitle2, " margin-right:4px;color:", theme.colors.foregroundEmphasis, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryItem;")),
        children: "\uCE74\uD14C\uACE0\uB9AC"
      }), jsx(ChevronRightIcon, {
        size: 12,
        css: /*#__PURE__*/css("color:", theme.colors.foregroundEmphasis, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:CategoryItem;"))
      })]
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$Q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$l = process.env.NODE_ENV === "production" ? {
  name: "1ar58c9",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%;box-sizing:border-box"
} : {
  name: "17kwaj7-HistoryItem",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%;box-sizing:border-box;label:HistoryItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Q
};
var _ref2$7 = process.env.NODE_ENV === "production" ? {
  name: "1953rds",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center"
} : {
  name: "oxo6mz-renderItem",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center;label:renderItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Q
};
var _ref3$4 = process.env.NODE_ENV === "production" ? {
  name: "i201p",
  styles: "display:flex;align-items:center;white-space:nowrap;overflow:hidden"
} : {
  name: "18f4vva-renderItem",
  styles: "display:flex;align-items:center;white-space:nowrap;overflow:hidden;label:renderItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$Q
};
function HistoryItem({
  item,
  hovered
}) {
  const theme = useTheme();
  const {
    query,
    value
  } = item;
  const historyStorage = useHistoryStorage();
  const handleDeleteClick = e => {
    e.stopPropagation();
    historyStorage.remove(value);
  };
  const renderItem = () => {
    return jsxs("div", {
      css: _ref3$4,
      children: [jsx("div", {
        css: _ref2$7,
        children: jsx(ClockIcon, {
          size: 18,
          fill: theme => theme.colors.foregroundWeak
        })
      }), jsx("div", {
        css: /*#__PURE__*/css("flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:8px;color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:renderItem;")),
        children: query
      })]
    });
  };
  return jsxs("div", {
    css: _ref$l,
    children: [renderItem(), jsx("button", {
      type: "button",
      onClick: handleDeleteClick,
      css: [/*#__PURE__*/css(RESET_BUTTON, " margin-right:-6px;padding:6px;transition:.1s opacity;font-size:0;line-height:0;border-radius:2px;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryItem;")), HOVER$1`
            opacity: .4;
          `, FOCUS`
            box-shadow: 0 0 0 3px ${theme.interactive.primary1.thin};
          `, process.env.NODE_ENV === "production" ? "" : ";label:HistoryItem;"],
      children: jsx(Icon$2, {
        name: "dismiss",
        size: 12,
        fill: theme => hovered ? theme.content.base2 : theme.content.base3
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$P() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$k = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "iqztu2-ConsultingItem",
  styles: "display:flex;align-items:center;label:ConsultingItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var _ref2$6 = process.env.NODE_ENV === "production" ? {
  name: "fqhs2q",
  styles: "text-overflow:ellipsis;overflow:hidden;margin-left:8px"
} : {
  name: "cfm4v-ConsultingItem",
  styles: "text-overflow:ellipsis;overflow:hidden;margin-left:8px;label:ConsultingItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var _ref3$3 = process.env.NODE_ENV === "production" ? {
  name: "1953rds",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center"
} : {
  name: "zmi6i1-ConsultingItem",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center;label:ConsultingItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var _ref4$2 = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "wghtr2-ConsultingItem",
  styles: "display:flex;align-items:center;overflow:hidden;label:ConsultingItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
var _ref5$2 = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "dgqyf2-ConsultingItem",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:ConsultingItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$P
};
function ConsultingItem(props) {
  const {
    item: {
      value
    }
  } = props;
  const theme = useTheme();
  const cta = ` ${value.info.cta}`;
  return jsxs("div", {
    css: _ref5$2,
    children: [jsxs("div", {
      css: _ref4$2,
      children: [jsx("div", {
        css: _ref3$3,
        children: value.info.iconFileUrl ? jsx(CircleImage, {
          src: value.info.iconFileUrl,
          css: /*#__PURE__*/css("width:32px;border:0.5px solid ", theme.outline, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ConsultingItem;"))
        }) : jsx(SearchIcon, {
          size: 18,
          fill: theme => theme.colors.foregroundWeak
        })
      }), jsx("div", {
        css: _ref2$6,
        children: jsx(HighlightedText$1, {
          ...props
        })
      })]
    }), jsxs("div", {
      css: _ref$k,
      children: [jsx("span", {
        css: /*#__PURE__*/css(FONT_STYLE.subTitle2, " margin-right:4px;color:", theme.colors.foregroundEmphasis, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ConsultingItem;")),
        children: cta
      }), jsx(ChevronRightIcon, {
        size: 12,
        css: /*#__PURE__*/css("color:", theme.colors.foregroundEmphasis, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ConsultingItem;"))
      })]
    })]
  });
}

// FIXME: Use exports from @bucketplace/bucket-log instead;
// Leaving this as there's unresolved module resolution issue with bucket-log.
function sendImpressionLog(logData) {
  O$1({
    category: 'impression',
    data: [{
      ...L(logData),
      time: Date.now()
    }]
  });
}
function sendViewableImpressionLog(logData) {
  O$1({
    category: 'viewable_impression',
    data: [{
      ...L(logData),
      time: Date.now()
    }]
  });
}
function removeViewableImpressionLog(logData) {
  O$1({
    category: 'viewable_impression_remove',
    data: [{
      ...L(logData),
      time: Date.now()
    }]
  });
}
function serializePathToString(path) {
  if (typeof path === 'string') {
    return path;
  }
  return `${path.pathname ?? ''}${path.search ?? ''}${path.hash ?? ''}`;
}

/**
 * 연결된 `ref` 요소가 화면에 보이기 시작하면 `logData`를 가지고 impression 로그를 전송합니다.
 */
function useImpressionLog({
  logData,
  threshold,
  disable
}) {
  const {
    ref,
    inView
  } = useInView({
    threshold,
    skip: disable,
    triggerOnce: true
  });
  useEffect(() => {
    if (inView && !disable && !!logData) {
      sendImpressionLog(logData);
    }
  }, [inView, disable, logData]);
  return {
    ref,
    inView
  };
}

const CONFIG = {
  THRESHOLD: 0.5
};

/**
 * 연결된 `ref` 요소가 화면에 50% 이상 노출되면 viewable_impression 로그를 전송합니다.
 * 이후 화면에서 사라지면 viewable_impression_remove 로그를 전송합니다.
 */
function useViewableImpressionLog({
  logData,
  disable,
  onViewableImpression
}) {
  const hasSentViewableLog = useRef(false);
  const onViewableImpressionRef = useRef(onViewableImpression);
  useEffect(() => {
    onViewableImpressionRef.current = onViewableImpression;
  }, [onViewableImpression]);
  const {
    ref,
    inView
  } = useInView({
    threshold: CONFIG.THRESHOLD,
    skip: disable,
    triggerOnce: false
  });
  useEffect(() => {
    if (disable || !logData) {
      return;
    }
    const handleViewableImpression = () => {
      sendViewableImpressionLog(logData);
      hasSentViewableLog.current = true;
    };
    const handleViewableImpressionRemove = () => {
      if (hasSentViewableLog.current) {
        removeViewableImpressionLog(logData);
        hasSentViewableLog.current = false;
      }
    };
    if (inView) {
      handleViewableImpression();
    } else {
      handleViewableImpressionRemove();
    }
  }, [disable, inView, logData, ref]);
  useEffect(() => {
    if (!onViewableImpressionRef.current) {
      return;
    }
    const handleViewableImpression = data => {
      if (logData && N(L(logData)) === N(data)) {
        onViewableImpressionRef.current?.(data);
      }
    };
    Y$1('viewable_impression', handleViewableImpression);
    return () => {
      ee$1('viewable_impression', handleViewableImpression);
    };
  }, [logData]);
  return {
    ref,
    inView
  };
}

/**
 * 감싸진 `children`이 화면에 보이기 시작하면 `logData`를 가지고 impression
 * 로그를 전송합니다.
 *
 * `children`이 html element(styled components)이거나, forwardRef로 감싸진
 * 컴포넌트인 경우에만 사용 가능합니다.
 *
 * 더 많은 컨트롤이 필요하다면 useImpressionLog() hook을 사용하세요.
 */
function ImpressionTracker(props) {
  const {
    threshold = 0.5,
    logData,
    disable,
    onLog,
    children
  } = props;
  const handleChange = useCallback(inView => {
    if (inView && !disable && logData != null) {
      if (onLog != null) {
        onLog();
        return;
      }
      O$1({
        category: 'impression',
        data: [{
          ...L(logData),
          time: Date.now()
        }]
      });
    }
  }, [disable, logData, onLog]);
  if (logData == null) {
    return children;
  }
  return jsx(InView, {
    threshold: threshold,
    skip: disable,
    onChange: handleChange,
    triggerOnce: true,
    children: ({
      ref: inViewRef
    }) => React__default.Children.map(children, child => {
      const ref = node => {
        if (child.props.ref != null) {
          if (typeof child.props.ref === 'function') {
            child.props.ref(node);
          } else {
            child.props.ref.current = node;
          }
        }
        if (inViewRef != null) {
          if (typeof inViewRef === 'function') {
            inViewRef(node);
          } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            inViewRef.current = node;
          }
        }
      };
      return /*#__PURE__*/React__default.cloneElement(child, {
        ref
      });
    })
  });
}

/**
 * Checks whether we're in a browser environment
 *
 * @returns Answer to given question
 */
function isBrowserEnv() {
  return typeof window === 'object' && (window === null || window === void 0 ? void 0 : window.document) !== undefined;
}
/**
 * Fixes browser edge case where Prototype.js injects Array.prototype.toJSON and breaks the built-in JSON.stringify()
 *
 * @returns true if Array.prototype.toJSON was deleted, false if not
 */
var prototypeJsFix = function () {
  var _a;
  if (isBrowserEnv()) {
    var augmentedWindow = window;
    var augmentedArray = Array;
    if (augmentedWindow.Prototype !== undefined && ((_a = augmentedArray.prototype) === null || _a === void 0 ? void 0 : _a.toJSON) !== undefined) {
      delete augmentedArray.prototype.toJSON;
      return true;
    }
  }
  return false;
};

var md5$1 = {exports: {}};

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
(function (module) {
  (function ($) {

    /**
     * Add integers, wrapping at 2^32.
     * This uses 16-bit operations internally to work around bugs in interpreters.
     *
     * @param {number} x First integer
     * @param {number} y Second integer
     * @returns {number} Sum
     */
    function safeAdd(x, y) {
      var lsw = (x & 0xffff) + (y & 0xffff);
      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
      return msw << 16 | lsw & 0xffff;
    }

    /**
     * Bitwise rotate a 32-bit number to the left.
     *
     * @param {number} num 32-bit number
     * @param {number} cnt Rotation count
     * @returns {number} Rotated number
     */
    function bitRotateLeft(num, cnt) {
      return num << cnt | num >>> 32 - cnt;
    }

    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} q q
     * @param {number} a a
     * @param {number} b b
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5cmn(q, a, b, x, s, t) {
      return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5ff(a, b, c, d, x, s, t) {
      return md5cmn(b & c | ~b & d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5gg(a, b, c, d, x, s, t) {
      return md5cmn(b & d | c & ~d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5hh(a, b, c, d, x, s, t) {
      return md5cmn(b ^ c ^ d, a, b, x, s, t);
    }
    /**
     * Basic operation the algorithm uses.
     *
     * @param {number} a a
     * @param {number} b b
     * @param {number} c c
     * @param {number} d d
     * @param {number} x x
     * @param {number} s s
     * @param {number} t t
     * @returns {number} Result
     */
    function md5ii(a, b, c, d, x, s, t) {
      return md5cmn(c ^ (b | ~d), a, b, x, s, t);
    }

    /**
     * Calculate the MD5 of an array of little-endian words, and a bit length.
     *
     * @param {Array} x Array of little-endian words
     * @param {number} len Bit length
     * @returns {Array<number>} MD5 Array
     */
    function binlMD5(x, len) {
      /* append padding */
      x[len >> 5] |= 0x80 << len % 32;
      x[(len + 64 >>> 9 << 4) + 14] = len;
      var i;
      var olda;
      var oldb;
      var oldc;
      var oldd;
      var a = 1732584193;
      var b = -271733879;
      var c = -1732584194;
      var d = 271733878;
      for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
      }
      return [a, b, c, d];
    }

    /**
     * Convert an array of little-endian words to a string
     *
     * @param {Array<number>} input MD5 Array
     * @returns {string} MD5 string
     */
    function binl2rstr(input) {
      var i;
      var output = '';
      var length32 = input.length * 32;
      for (i = 0; i < length32; i += 8) {
        output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
      }
      return output;
    }

    /**
     * Convert a raw string to an array of little-endian words
     * Characters >255 have their high-byte silently ignored.
     *
     * @param {string} input Raw input string
     * @returns {Array<number>} Array of little-endian words
     */
    function rstr2binl(input) {
      var i;
      var output = [];
      output[(input.length >> 2) - 1] = undefined;
      for (i = 0; i < output.length; i += 1) {
        output[i] = 0;
      }
      var length8 = input.length * 8;
      for (i = 0; i < length8; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
      }
      return output;
    }

    /**
     * Calculate the MD5 of a raw string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */
    function rstrMD5(s) {
      return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
    }

    /**
     * Calculates the HMAC-MD5 of a key and some data (raw strings)
     *
     * @param {string} key HMAC key
     * @param {string} data Raw input string
     * @returns {string} Raw MD5 string
     */
    function rstrHMACMD5(key, data) {
      var i;
      var bkey = rstr2binl(key);
      var ipad = [];
      var opad = [];
      var hash;
      ipad[15] = opad[15] = undefined;
      if (bkey.length > 16) {
        bkey = binlMD5(bkey, key.length * 8);
      }
      for (i = 0; i < 16; i += 1) {
        ipad[i] = bkey[i] ^ 0x36363636;
        opad[i] = bkey[i] ^ 0x5c5c5c5c;
      }
      hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
      return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
    }

    /**
     * Convert a raw string to a hex string
     *
     * @param {string} input Raw input string
     * @returns {string} Hex encoded string
     */
    function rstr2hex(input) {
      var hexTab = '0123456789abcdef';
      var output = '';
      var x;
      var i;
      for (i = 0; i < input.length; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
      }
      return output;
    }

    /**
     * Encode a string as UTF-8
     *
     * @param {string} input Input string
     * @returns {string} UTF8 string
     */
    function str2rstrUTF8(input) {
      return unescape(encodeURIComponent(input));
    }

    /**
     * Encodes input string as raw MD5 string
     *
     * @param {string} s Input string
     * @returns {string} Raw MD5 string
     */
    function rawMD5(s) {
      return rstrMD5(str2rstrUTF8(s));
    }
    /**
     * Encodes input string as Hex encoded string
     *
     * @param {string} s Input string
     * @returns {string} Hex encoded string
     */
    function hexMD5(s) {
      return rstr2hex(rawMD5(s));
    }
    /**
     * Calculates the raw HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */
    function rawHMACMD5(k, d) {
      return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
    }
    /**
     * Calculates the Hex encoded HMAC-MD5 for the given key and data
     *
     * @param {string} k HMAC key
     * @param {string} d Input string
     * @returns {string} Raw MD5 string
     */
    function hexHMACMD5(k, d) {
      return rstr2hex(rawHMACMD5(k, d));
    }

    /**
     * Calculates MD5 value for a given string.
     * If a key is provided, calculates the HMAC-MD5 value.
     * Returns a Hex encoded string unless the raw argument is given.
     *
     * @param {string} string Input string
     * @param {string} [key] HMAC key
     * @param {boolean} [raw] Raw output switch
     * @returns {string} MD5 output
     */
    function md5(string, key, raw) {
      if (!key) {
        if (!raw) {
          return hexMD5(string);
        }
        return rawMD5(string);
      }
      if (!raw) {
        return hexHMACMD5(key, string);
      }
      return rawHMACMD5(key, string);
    }
    if (module.exports) {
      module.exports = md5;
    } else {
      $.md5 = md5;
    }
  })(commonjsGlobal);
})(md5$1);
var md5Exports = md5$1.exports;
var md5 = /*@__PURE__*/getDefaultExportFromCjs(md5Exports);

const token$1 = '%[a-f0-9]{2}';
const singleMatcher$1 = new RegExp('(' + token$1 + ')|([^%]+?)', 'gi');
const multiMatcher$1 = new RegExp('(' + token$1 + ')+', 'gi');
function decodeComponents$1(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  const left = components.slice(0, split);
  const right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents$1(left), decodeComponents$1(right));
}
function decode$2(input) {
  try {
    return decodeURIComponent(input);
  } catch {
    let tokens = input.match(singleMatcher$1) || [];
    for (let i = 1; i < tokens.length; i++) {
      input = decodeComponents$1(tokens, i).join('');
      tokens = input.match(singleMatcher$1) || [];
    }
    return input;
  }
}
function customDecodeURIComponent$1(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  const replaceMap = {
    '%FE%FF': '\uFFFD\uFFFD',
    '%FF%FE': '\uFFFD\uFFFD'
  };
  let match = multiMatcher$1.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch {
      const result = decode$2(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher$1.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = '\uFFFD';
  const entries = Object.keys(replaceMap);
  for (const key of entries) {
    // Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
function decodeUriComponent$1(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }
  try {
    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent$1(encodedURI);
  }
}

function splitOnFirst$1(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (string === '' || separator === '') {
    return [];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
}

function includeKeys(object, predicate) {
  const result = {};
  if (Array.isArray(predicate)) {
    for (const key of predicate) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor?.enumerable) {
        Object.defineProperty(result, key, descriptor);
      }
    }
  } else {
    // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)) {
      const descriptor = Object.getOwnPropertyDescriptor(object, key);
      if (descriptor.enumerable) {
        const value = object[key];
        if (predicate(key, value, object)) {
          Object.defineProperty(result, key, descriptor);
        }
      }
    }
  }
  return result;
}

const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode$1 = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function encoderForArrayFormat(options) {
  switch (options.arrayFormat) {
    case 'index':
      {
        return key => (result, value) => {
          const index = result.length;
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[', index, ']'].join('')];
          }
          return [...result, [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')];
        };
      }
    case 'bracket':
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[]'].join('')];
          }
          return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
        };
      }
    case 'colon-list-separator':
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), ':list='].join('')];
          }
          return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
        };
      }
    case 'comma':
    case 'separator':
    case 'bracket-separator':
      {
        const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }

          // Translate null to an empty string so that it doesn't serialize as 'null'
          value = value === null ? '' : value;
          if (result.length === 0) {
            return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
          }
          return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
        };
      }
    default:
      {
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, encode(key, options)];
          }
          return [...result, [encode(key, options), '=', encode(value, options)].join('')];
        };
      }
  }
}
function parserForArrayFormat(options) {
  let result;
  switch (options.arrayFormat) {
    case 'index':
      {
        return (key, value, accumulator) => {
          result = /\[(\d*)]$/.exec(key);
          key = key.replace(/\[\d*]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      }
    case 'bracket':
      {
        return (key, value, accumulator) => {
          result = /(\[])$/.exec(key);
          key = key.replace(/\[]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [...accumulator[key], value];
        };
      }
    case 'colon-list-separator':
      {
        return (key, value, accumulator) => {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [...accumulator[key], value];
        };
      }
    case 'comma':
    case 'separator':
      {
        return (key, value, accumulator) => {
          const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          const isEncodedArray = typeof value === 'string' && !isArray && decode$1(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode$1(value, options) : value;
          const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode$1(item, options)) : value === null ? value : decode$1(value, options);
          accumulator[key] = newValue;
        };
      }
    case 'bracket-separator':
      {
        return (key, value, accumulator) => {
          const isArray = /(\[])$/.test(key);
          key = key.replace(/\[]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode$1(value, options) : value;
            return;
          }
          const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(item => decode$1(item, options));
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [...accumulator[key], ...arrayValue];
        };
      }
    default:
      {
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [...[accumulator[key]].flat(), value];
        };
      }
  }
}
function validateArrayFormatSeparator(value) {
  if (typeof value !== 'string' || value.length !== 1) {
    throw new TypeError('arrayFormatSeparator must be single character string');
  }
}
function encode(value, options) {
  if (options.encode) {
    return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
  }
  return value;
}
function decode$1(value, options) {
  if (options.decode) {
    return decodeUriComponent$1(value);
  }
  return value;
}
function keysSorter(input) {
  if (Array.isArray(input)) {
    return input.sort();
  }
  if (typeof input === 'object') {
    return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map(key => input[key]);
  }
  return input;
}
function removeHash(input) {
  const hashStart = input.indexOf('#');
  if (hashStart !== -1) {
    input = input.slice(0, hashStart);
  }
  return input;
}
function getHash(url) {
  let hash = '';
  const hashStart = url.indexOf('#');
  if (hashStart !== -1) {
    hash = url.slice(hashStart);
  }
  return hash;
}
function parseValue(value, options) {
  if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
    value = Number(value);
  } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
    value = value.toLowerCase() === 'true';
  }
  return value;
}
function extract(input) {
  input = removeHash(input);
  const queryStart = input.indexOf('?');
  if (queryStart === -1) {
    return '';
  }
  return input.slice(queryStart + 1);
}
function parse(query, options) {
  options = {
    decode: true,
    sort: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ',',
    parseNumbers: false,
    parseBooleans: false,
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const formatter = parserForArrayFormat(options);

  // Create an object with no prototype
  const returnValue = Object.create(null);
  if (typeof query !== 'string') {
    return returnValue;
  }
  query = query.trim().replace(/^[?#&]/, '');
  if (!query) {
    return returnValue;
  }
  for (const parameter of query.split('&')) {
    if (parameter === '') {
      continue;
    }
    const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;
    let [key, value] = splitOnFirst$1(parameter_, '=');
    if (key === undefined) {
      key = parameter_;
    }

    // Missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
    value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode$1(value, options);
    formatter(decode$1(key, options), value, returnValue);
  }
  for (const [key, value] of Object.entries(returnValue)) {
    if (typeof value === 'object' && value !== null) {
      for (const [key2, value2] of Object.entries(value)) {
        value[key2] = parseValue(value2, options);
      }
    } else {
      returnValue[key] = parseValue(value, options);
    }
  }
  if (options.sort === false) {
    return returnValue;
  }

  // TODO: Remove the use of `reduce`.
  // eslint-disable-next-line unicorn/no-array-reduce
  return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
    const value = returnValue[key];
    if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
      // Sort object keys, not values
      result[key] = keysSorter(value);
    } else {
      result[key] = value;
    }
    return result;
  }, Object.create(null));
}
function stringify(object, options) {
  if (!object) {
    return '';
  }
  options = {
    encode: true,
    strict: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ',',
    ...options
  };
  validateArrayFormatSeparator(options.arrayFormatSeparator);
  const shouldFilter = key => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
  const formatter = encoderForArrayFormat(options);
  const objectCopy = {};
  for (const [key, value] of Object.entries(object)) {
    if (!shouldFilter(key)) {
      objectCopy[key] = value;
    }
  }
  const keys = Object.keys(objectCopy);
  if (options.sort !== false) {
    keys.sort(options.sort);
  }
  return keys.map(key => {
    const value = object[key];
    if (value === undefined) {
      return '';
    }
    if (value === null) {
      return encode(key, options);
    }
    if (Array.isArray(value)) {
      if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
        return encode(key, options) + '[]';
      }
      return value.reduce(formatter(key), []).join('&');
    }
    return encode(key, options) + '=' + encode(value, options);
  }).filter(x => x.length > 0).join('&');
}
function parseUrl(url, options) {
  options = {
    decode: true,
    ...options
  };
  let [url_, hash] = splitOnFirst$1(url, '#');
  if (url_ === undefined) {
    url_ = url;
  }
  return {
    url: url_?.split('?')?.[0] ?? '',
    query: parse(extract(url), options),
    ...(options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode$1(hash, options)
    } : {})
  };
}
function stringifyUrl(object, options) {
  options = {
    encode: true,
    strict: true,
    [encodeFragmentIdentifier]: true,
    ...options
  };
  const url = removeHash(object.url).split('?')[0] || '';
  const queryFromUrl = extract(object.url);
  const query = {
    ...parse(queryFromUrl, {
      sort: false
    }),
    ...object.query
  };
  let queryString = stringify(query, options);
  if (queryString) {
    queryString = `?${queryString}`;
  }
  let hash = getHash(object.url);
  if (object.fragmentIdentifier) {
    const urlObjectForFragmentEncode = new URL(url);
    urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
    hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
  }
  return `${url}${queryString}${hash}`;
}
function pick(input, filter, options) {
  options = {
    parseFragmentIdentifier: true,
    [encodeFragmentIdentifier]: false,
    ...options
  };
  const {
    url,
    query,
    fragmentIdentifier
  } = parseUrl(input, options);
  return stringifyUrl({
    url,
    query: includeKeys(query, filter),
    fragmentIdentifier
  }, options);
}
function exclude(input, filter, options) {
  const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);
  return pick(input, exclusionFilter, options);
}

var queryString$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  exclude: exclude,
  extract: extract,
  parse: parse,
  parseUrl: parseUrl,
  pick: pick,
  stringify: stringify,
  stringifyUrl: stringifyUrl
});

var uaParser = {exports: {}};

(function (module, exports) {
  /////////////////////////////////////////////////////////////////////////////////
  /* UAParser.js v0.7.33
     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
     MIT License */ /*
                    Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
                    Supports browser & node.js environment.
                    Demo   : https://faisalman.github.io/ua-parser-js
                    Source : https://github.com/faisalman/ua-parser-js */
  /////////////////////////////////////////////////////////////////////////////////

  (function (window, undefined$1) {

    //////////////
    // Constants
    /////////////
    var LIBVERSION = "0.7.33",
      EMPTY = "",
      UNKNOWN = "?",
      FUNC_TYPE = "function",
      UNDEF_TYPE = "undefined",
      OBJ_TYPE = "object",
      STR_TYPE = "string",
      MAJOR = "major",
      MODEL = "model",
      NAME = "name",
      TYPE = "type",
      VENDOR = "vendor",
      VERSION = "version",
      ARCHITECTURE = "architecture",
      CONSOLE = "console",
      MOBILE = "mobile",
      TABLET = "tablet",
      SMARTTV = "smarttv",
      WEARABLE = "wearable",
      EMBEDDED = "embedded",
      UA_MAX_LENGTH = 350;
    var AMAZON = "Amazon",
      APPLE = "Apple",
      ASUS = "ASUS",
      BLACKBERRY = "BlackBerry",
      BROWSER = "Browser",
      CHROME = "Chrome",
      EDGE = "Edge",
      FIREFOX = "Firefox",
      GOOGLE = "Google",
      HUAWEI = "Huawei",
      LG = "LG",
      MICROSOFT = "Microsoft",
      MOTOROLA = "Motorola",
      OPERA = "Opera",
      SAMSUNG = "Samsung",
      SHARP = "Sharp",
      SONY = "Sony",
      XIAOMI = "Xiaomi",
      ZEBRA = "Zebra",
      FACEBOOK = "Facebook";

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
        var mergedRegexes = {};
        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }
        return mergedRegexes;
      },
      enumerize = function (arr) {
        var enums = {};
        for (var i = 0; i < arr.length; i++) {
          enums[arr[i].toUpperCase()] = arr[i];
        }
        return enums;
      },
      has = function (str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
      },
      lowerize = function (str) {
        return str.toLowerCase();
      },
      majorize = function (version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
      },
      trim = function (str, len) {
        if (typeof str === STR_TYPE) {
          str = str.replace(/^\s\s*/, EMPTY);
          return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
      };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {
        var i = 0,
          j,
          k,
          p,
          q,
          matches,
          match;

        // loop through all regexes maps
        while (i < arrays.length && !matches) {
          var regex = arrays[i],
            // even sequence (0,2,4,..)
            props = arrays[i + 1]; // odd sequence (1,3,5,..)
          j = k = 0;

          // try matching uastring with regexes
          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);
            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];
                // check if given property is actually array
                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length === 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      // assign modified match
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      // assign given value, ignore regex match
                      this[q[0]] = q[1];
                    }
                  } else if (q.length === 3) {
                    // check whether function or regex
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      // call function (usually string mapper)
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                    } else {
                      // sanitize match using given regex
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                    }
                  } else if (q.length === 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                  }
                } else {
                  this[q] = match ? match : undefined$1;
                }
              }
            }
          }
          i += 2;
        }
      },
      strMapper = function (str, map) {
        for (var i in map) {
          // check if current value is array
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (has(map[i][j], str)) {
                return i === UNKNOWN ? undefined$1 : i;
              }
            }
          } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined$1 : i;
          }
        }
        return str;
      };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
      },
      windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2000: "NT 5.0",
        XP: ["NT 5.1", "NT 5.2"],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: ["NT 6.4", "NT 10.0"],
        RT: "ARM"
      };

    //////////////
    // Regex map
    /////////////

    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ], [VERSION, [NAME, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ], [VERSION, [NAME, "Edge"]], [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
      ], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ], [VERSION, [NAME, OPERA + " Mini"]], [/\bopr\/([\w\.]+)/i // Opera Webkit
      ], [VERSION, [NAME, OPERA]], [
      // Mixed
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
      // Trident based
      /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
      // Avant/IEMobile/SlimBrowser
      /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
      // Baidu Browser
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer

      // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
      /(weibo)__([\d\.]+)/i // Weibo
      ], [NAME, VERSION], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
      ], [VERSION, [NAME, "UC" + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i], [VERSION, [NAME, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i // WeChat
      ], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i // Konqueror
      ], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
      ], [VERSION, [NAME, "IE"]], [/yabrowser\/([\w\.]+)/i // Yandex
      ], [VERSION, [NAME, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ], [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i // Firefox Focus
      ], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i // Opera Touch
      ], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
      ], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i // Dolphin
      ], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i // Opera Coast
      ], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i // MIUI Browser
      ], [VERSION, [NAME, "MIUI " + BROWSER]], [/fxios\/([-\w\.]+)/i // Firefox for iOS
      ], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i // 360
      ], [[NAME, "360 " + BROWSER]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 " + BROWSER], VERSION], [
      // Oculus/Samsung/Sailfish/Huawei Browser
      /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ], [[NAME, /_/g, " "], VERSION], [/(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ], [NAME, VERSION], [/(metasr)[\/ ]?([\w\.]+)/i,
      // SouGouBrowser
      /(lbbrowser)/i,
      // LieBao Browser
      /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
      ], [NAME], [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
      ], [[NAME, FACEBOOK], VERSION], [/safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
      ], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
      ], [VERSION, [NAME, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
      ], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
      ], [VERSION, [NAME, "Android " + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
      ], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
      ], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [
      // Gecko based
      /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
      ], [[NAME, "Netscape"], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
      ], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla

      // Other
      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
      /(links) \(([\w\.]+)/i // Links
      ], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i // Cobalt
      ], [NAME, [VERSION, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i // IA32 (quicktime)
      ], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
      ], [[ARCHITECTURE, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ], [[ARCHITECTURE, "armhf"]], [
      // PocketPC mistakenly identified as PowerPC
      /windows (ce|mobile); ppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
      ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i // SPARC
      ], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ], [[ARCHITECTURE, lowerize]]],
      device: [[
      //////////////////////////
      // MOBILES & TABLETS
      // Ordered by popularity
      /////////////////////////

      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
      // Apple
      /((ipod|iphone)\d+,\d+)/i // iPod/iPhone model
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/(ipad\d+,\d+)/i // iPad model
      ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
      ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [
      // Huawei
      /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
      // Xiaomi
      /\b(poco[\w ]+)(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
      ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
      ], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [
      // OPPO
      /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]], [
      // Vivo
      /vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [
      // Realme
      /\b(rmx[12]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
      // Lenovo
      /(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [
      // Nokia
      /(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]], [
      // Google
      /(pixel c)\b/i // Google Pixel C
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
      // Sony
      /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [
      // OnePlus
      / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [
      // Amazon
      /(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i,
      // Kindle Fire without Silk
      /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
      ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
      ], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
      ], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i // BlackBerry 10
      ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
      // HTC
      /(nexus 9)/i // HTC Nexus 9
      ], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC

      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [
      // Meizu
      /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [
      // MIXED
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(asus)-?(\w+)/i,
      // Asus
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(lenovo)[-_ ]?([-\w]+)/i,
      // Lenovo
      /(jolla)/i,
      // Jolla
      /(oppo) ?([\w ]+) bui/i // OPPO
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(archos) (gamepad2?)/i,
      // Archos
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(nook)[\w ]+build\/(\w+)/i,
      // Nook
      /(dell) (strea[kpr\d ]*[\dko])/i,
      // Dell Streak
      /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
      // Le Pan Tablets
      /(trinity)[- ]*(t\d{3}) bui/i,
      // Trinity Tablets
      /(gigaset)[- ]+(q\w{1,9}) bui/i,
      // Gigaset Tablets
      /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
      ], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i // Surface Duo
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
      ], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(u304aa)/i // AT&T
      ], [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]], [/\bsie-(\w*)/i // Siemens
      ], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/\b(rct\w+) b/i // RCA Tablets
      ], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
      ], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
      ], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
      ], [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/\b(k88) b/i // ZTE K Series Tablet
      ], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i // ZTE Nubia
      ], [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
      ], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i // Swiss ZUR Tablet
      ], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i // Zeki Tablets
      ], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
      ], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i // Insignia Tablets
      ], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
      ], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
      ], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
      ], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i // Essential PH-1
      ], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
      ], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
      ], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/\btu_(1491) b/i // Rotor Tablets
      ], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/(shield[\w ]+) b/i // Nvidia Shield Tablets
      ], [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]], [/(sprint) (\w+)/i // Sprint Phones
      ], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i // Microsoft Kin
      ], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
      ///////////////////
      // CONSOLES
      ///////////////////

      /(ouya)/i,
      // Ouya
      /(nintendo) ([wids3utch]+)/i // Nintendo
      ], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i // Nvidia
      ], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i // Playstation
      ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
      ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
      ///////////////////
      // SMARTTVS
      ///////////////////

      /smart-tv.+(samsung)/i // Samsung
      ], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
      ], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i // Apple TV
      ], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i // Google Chromecast
      ], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w)( bui|\))/i // Fire TV
      ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i // Sharp
      ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i // Sony
      ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i // Xiaomi
      ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
      ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
      ], [[TYPE, SMARTTV]], [
      ///////////////////
      // WEARABLES
      ///////////////////

      /((pebble))app/i // Pebble
      ], [VENDOR, MODEL, [TYPE, WEARABLE]], [/droid.+; (glass) \d/i // Google Glass
      ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( 2)?)/i // Oculus Quest
      ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
      ///////////////////
      // EMBEDDED
      ///////////////////

      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
      ], [VENDOR, [TYPE, EMBEDDED]], [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////

      /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
      ], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
      ], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
      ], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
      ], [MODEL, [VENDOR, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i // EdgeHTML
      ], [VERSION, [NAME, EDGE + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
      ], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ], [VERSION, NAME]],
      os: [[
      // Windows
      /microsoft (windows) (vista|xp)/i // Windows (iTunes)
      ], [NAME, VERSION], [/(windows) nt 6\.2; (arm)/i,
      // Windows RT
      /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
      // Windows Phone
      /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, strMapper, windowsVersionMap]], [
      // iOS/macOS
      /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
      ], [[NAME, "Mac OS"], [VERSION, /_/g, "."]], [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
      ], [VERSION, NAME], [
      // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
      /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i,
      // Blackberry
      /(tizen|kaios)[\/ ]([\w\.]+)/i,
      // Tizen/KaiOS
      /\((series40);/i // Series 40
      ], [NAME, VERSION], [/\(bb(10);/i // BlackBerry 10
      ], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
      ], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
      ], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ], [VERSION, [NAME, "webOS"]], [
      // Google Chromecast
      /crkey\/([\d\.]+)/i // Google Chromecast
      ], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
      ], [[NAME, "Chromium OS"], VERSION], [
      // Console
      /(nintendo|playstation) ([wids345portablevuch]+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)

      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /(mint)[\/\(\) ]?(\w*)/i,
      // Mint
      /(mageia|vectorlinux)[; ]/i,
      // Mageia/VectorLinux
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
      /(hurd|linux) ?([\w\.]*)/i,
      // Hurd/Linux
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) (\w+)/i // Haiku
      ], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i // Solaris
      ], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
      // AIX
      /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
      // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
      /(unix) ?([\w\.]*)/i // UNIX
      ], [NAME, VERSION]]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }
      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }
      var _ua = ua || (typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
      this.getBrowser = function () {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser.major = majorize(_browser.version);
        return _browser;
      };
      this.getCPU = function () {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function () {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        return _device;
      };
      this.getEngine = function () {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function () {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        return _os;
      };
      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function () {
        return _ua;
      };
      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
      // nodejs env
      if (module.exports) {
        exports = module.exports = UAParser;
      }
      exports.UAParser = UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA();
      };
      $.ua.set = function (ua) {
        parser.setUA(ua);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var uaParserExports = uaParser.exports;
var UAParser = /*@__PURE__*/getDefaultExportFromCjs(uaParserExports);

var ApplicationContextProviderImpl = /** @class */function () {
  function ApplicationContextProviderImpl() {}
  ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
    return {
      versionName: this.versionName,
      language: getLanguage$1(),
      platform: 'Web',
      os: undefined,
      deviceModel: undefined
    };
  };
  return ApplicationContextProviderImpl;
}();
var getLanguage$1 = function () {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */function () {
  function EventBridgeImpl() {
    this.queue = [];
  }
  EventBridgeImpl.prototype.logEvent = function (event) {
    if (!this.receiver) {
      if (this.queue.length < 512) {
        this.queue.push(event);
      }
    } else {
      this.receiver(event);
    }
  };
  EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
    this.receiver = receiver;
    if (this.queue.length > 0) {
      this.queue.forEach(function (event) {
        receiver(event);
      });
      this.queue = [];
    }
  };
  return EventBridgeImpl;
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual$1 = function (obj1, obj2) {
  var primitive = ['string', 'number', 'boolean', 'undefined'];
  var typeA = typeof obj1;
  var typeB = typeof obj2;
  if (typeA !== typeB) {
    return false;
  }
  for (var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++) {
    var p = primitive_1[_i];
    if (p === typeA) {
      return obj1 === obj2;
    }
  }
  // check null
  if (obj1 == null && obj2 == null) {
    return true;
  } else if (obj1 == null || obj2 == null) {
    return false;
  }
  // if got here - objects
  if (obj1.length !== obj2.length) {
    return false;
  }
  //check if arrays
  var isArrayA = Array.isArray(obj1);
  var isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA && isArrayB) {
    //arrays
    for (var i = 0; i < obj1.length; i++) {
      if (!isEqual$1(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    //objects
    var sorted1 = Object.keys(obj1).sort();
    var sorted2 = Object.keys(obj2).sort();
    if (!isEqual$1(sorted1, sorted2)) {
      return false;
    }
    //compare object values
    var result_1 = true;
    Object.keys(obj1).forEach(function (key) {
      if (!isEqual$1(obj1[key], obj2[key])) {
        result_1 = false;
      }
    });
    return result_1;
  }
  return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}
var IdentityStoreImpl = /** @class */function () {
  function IdentityStoreImpl() {
    this.identity = {
      userProperties: {}
    };
    this.listeners = new Set();
  }
  IdentityStoreImpl.prototype.editIdentity = function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var self = this;
    var actingUserProperties = __assign({}, this.identity.userProperties);
    var actingIdentity = __assign(__assign({}, this.identity), {
      userProperties: actingUserProperties
    });
    return {
      setUserId: function (userId) {
        actingIdentity.userId = userId;
        return this;
      },
      setDeviceId: function (deviceId) {
        actingIdentity.deviceId = deviceId;
        return this;
      },
      setUserProperties: function (userProperties) {
        actingIdentity.userProperties = userProperties;
        return this;
      },
      setOptOut: function (optOut) {
        actingIdentity.optOut = optOut;
        return this;
      },
      updateUserProperties: function (actions) {
        var actingProperties = actingIdentity.userProperties || {};
        for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
          var _b = _a[_i],
            action = _b[0],
            properties = _b[1];
          switch (action) {
            case ID_OP_SET:
              for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
                var _e = _d[_c],
                  key = _e[0],
                  value = _e[1];
                actingProperties[key] = value;
              }
              break;
            case ID_OP_UNSET:
              for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
                var key = _g[_f];
                delete actingProperties[key];
              }
              break;
            case ID_OP_CLEAR_ALL:
              actingProperties = {};
              break;
          }
        }
        actingIdentity.userProperties = actingProperties;
        return this;
      },
      commit: function () {
        self.setIdentity(actingIdentity);
        return this;
      }
    };
  };
  IdentityStoreImpl.prototype.getIdentity = function () {
    return __assign({}, this.identity);
  };
  IdentityStoreImpl.prototype.setIdentity = function (identity) {
    var originalIdentity = __assign({}, this.identity);
    this.identity = __assign({}, identity);
    if (!isEqual$1(originalIdentity, this.identity)) {
      this.listeners.forEach(function (listener) {
        listener(identity);
      });
    }
  };
  IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
    this.listeners.add(listener);
  };
  IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
    this.listeners.delete(listener);
  };
  return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
var AnalyticsConnector = /** @class */function () {
  function AnalyticsConnector() {
    this.identityStore = new IdentityStoreImpl();
    this.eventBridge = new EventBridgeImpl();
    this.applicationContextProvider = new ApplicationContextProviderImpl();
  }
  AnalyticsConnector.getInstance = function (instanceName) {
    if (!safeGlobal['analyticsConnectorInstances']) {
      safeGlobal['analyticsConnectorInstances'] = {};
    }
    if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
      safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
    }
    return safeGlobal['analyticsConnectorInstances'][instanceName];
  };
  return AnalyticsConnector;
}();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var Constants = {
  DEFAULT_INSTANCE: '$default_instance',
  API_VERSION: 2,
  MAX_STRING_LENGTH: 4096,
  MAX_PROPERTY_KEYS: 1000,
  IDENTIFY_EVENT: '$identify',
  GROUP_IDENTIFY_EVENT: '$groupidentify',
  EVENT_LOG_URL: 'api.amplitude.com',
  EVENT_LOG_EU_URL: 'api.eu.amplitude.com',
  DYNAMIC_CONFIG_URL: 'regionconfig.amplitude.com',
  DYNAMIC_CONFIG_EU_URL: 'regionconfig.eu.amplitude.com',
  // localStorageKeys
  LAST_EVENT_ID: 'amplitude_lastEventId',
  LAST_EVENT_TIME: 'amplitude_lastEventTime',
  LAST_IDENTIFY_ID: 'amplitude_lastIdentifyId',
  LAST_SEQUENCE_NUMBER: 'amplitude_lastSequenceNumber',
  SESSION_ID: 'amplitude_sessionId',
  // Used in cookie as well
  DEVICE_ID: 'amplitude_deviceId',
  OPT_OUT: 'amplitude_optOut',
  USER_ID: 'amplitude_userId',
  // indexes of properties in cookie v2 storage format
  DEVICE_ID_INDEX: 0,
  USER_ID_INDEX: 1,
  OPT_OUT_INDEX: 2,
  SESSION_ID_INDEX: 3,
  LAST_EVENT_TIME_INDEX: 4,
  EVENT_ID_INDEX: 5,
  IDENTIFY_ID_INDEX: 6,
  SEQUENCE_NUMBER_INDEX: 7,
  COOKIE_TEST_PREFIX: 'amp_cookie_test',
  COOKIE_PREFIX: 'amp',
  // Storage options
  STORAGE_DEFAULT: '',
  STORAGE_COOKIES: 'cookies',
  STORAGE_NONE: 'none',
  STORAGE_LOCAL: 'localStorage',
  STORAGE_SESSION: 'sessionStorage',
  // revenue keys
  REVENUE_EVENT: 'revenue_amount',
  REVENUE_PRODUCT_ID: '$productId',
  REVENUE_QUANTITY: '$quantity',
  REVENUE_PRICE: '$price',
  REVENUE_REVENUE_TYPE: '$revenueType',
  AMP_DEVICE_ID_PARAM: 'amp_device_id',
  // url param
  AMP_REFERRER_PARAM: 'amp_referrer',
  // url param for overwriting the document.refer

  REFERRER: 'referrer',
  REFERRING_DOMAIN: 'referring_domain',
  // UTM Params
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
  UTM_TERM: 'utm_term',
  UTM_CONTENT: 'utm_content',
  ATTRIBUTION_EVENT: '[Amplitude] Attribution Captured',
  TRANSPORT_HTTP: 'http',
  TRANSPORT_BEACON: 'beacon'
};

/*
 * UTF-8 encoder/decoder
 * http://www.webtoolkit.info/
 */
var UTF8 = {
  encode: function encode(s) {
    var utftext = '';
    for (var n = 0; n < s.length; n++) {
      var c = s.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }
    return utftext;
  },
  decode: function decode(utftext) {
    var s = '';
    var i = 0;
    var c = 0,
      c1 = 0,
      c2 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        s += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c1 = utftext.charCodeAt(i + 1);
        s += String.fromCharCode((c & 31) << 6 | c1 & 63);
        i += 2;
      } else {
        c1 = utftext.charCodeAt(i + 1);
        c2 = utftext.charCodeAt(i + 2);
        s += String.fromCharCode((c & 15) << 12 | (c1 & 63) << 6 | c2 & 63);
        i += 3;
      }
    }
    return s;
  }
};

/* global globalThis */
var GlobalScope = function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
}();

/*
 * Base64 encoder/decoder
 * http://www.webtoolkit.info/
 */
var Base64 = {
  _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  encode: function encode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return GlobalScope.btoa(unescape(encodeURIComponent(input)));
      }
    } catch (e) {
      //log(e);
    }
    return Base64._encode(input);
  },
  _encode: function _encode(input) {
    var output = '';
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = UTF8.encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output + Base64._keyStr.charAt(enc1) + Base64._keyStr.charAt(enc2) + Base64._keyStr.charAt(enc3) + Base64._keyStr.charAt(enc4);
    }
    return output;
  },
  decode: function decode(input) {
    try {
      if (GlobalScope.btoa && GlobalScope.atob) {
        return decodeURIComponent(escape(GlobalScope.atob(input)));
      }
    } catch (e) {
      //log(e);
    }
    return Base64._decode(input);
  },
  _decode: function _decode(input) {
    var output = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');
    while (i < input.length) {
      enc1 = Base64._keyStr.indexOf(input.charAt(i++));
      enc2 = Base64._keyStr.indexOf(input.charAt(i++));
      enc3 = Base64._keyStr.indexOf(input.charAt(i++));
      enc4 = Base64._keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = UTF8.decode(output);
    return output;
  }
};

/**
 * toString ref.
 * @private
 */

var toString = Object.prototype.toString;

/**
 * Return the type of `val`.
 * @private
 * @param {Mixed} val
 * @return {String}
 * @api public
 */

function type(val) {
  switch (toString.call(val)) {
    case '[object Date]':
      return 'date';
    case '[object RegExp]':
      return 'regexp';
    case '[object Arguments]':
      return 'arguments';
    case '[object Array]':
      return 'array';
    case '[object Error]':
      return 'error';
  }
  if (val === null) {
    return 'null';
  }
  if (val === undefined) {
    return 'undefined';
  }
  if (val !== val) {
    return 'nan';
  }
  if (val && val.nodeType === 1) {
    return 'element';
  }
  if (typeof Buffer !== 'undefined' && typeof Buffer.isBuffer === 'function' && Buffer.isBuffer(val)) {
    return 'buffer';
  }
  val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
  return _typeof(val);
}
var logLevels = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3
};
var logLevel = logLevels.WARN;
var setLogLevel = function setLogLevel(logLevelName) {
  if (Object.prototype.hasOwnProperty.call(logLevels, logLevelName)) {
    logLevel = logLevels[logLevelName];
  }
};
var getLogLevel = function getLogLevel() {
  return logLevel;
};
var log = {
  error: function error(s) {
    if (logLevel >= logLevels.ERROR) {
      _log(s);
    }
  },
  warn: function warn(s) {
    if (logLevel >= logLevels.WARN) {
      _log(s);
    }
  },
  info: function info(s) {
    if (logLevel >= logLevels.INFO) {
      _log(s);
    }
  }
};
var _log = function _log(s) {
  try {
    console.log('[Amplitude] ' + s);
  } catch (e) {
    // console logging not available
  }
};
var isEmptyString = function isEmptyString(str) {
  return !str || str.length === 0;
};
var sessionStorageEnabled = function sessionStorageEnabled() {
  try {
    if (GlobalScope.sessionStorage) {
      return true;
    }
  } catch (e) {
    // sessionStorage disabled
  }
  return false;
};

// truncate string values in event and user properties so that request size does not get too large
var truncate$1 = function truncate(value) {
  if (type(value) === 'array') {
    for (var i = 0; i < value.length; i++) {
      value[i] = truncate(value[i]);
    }
  } else if (type(value) === 'object') {
    for (var key in value) {
      if (key in value) {
        value[key] = truncate(value[key]);
      }
    }
  } else {
    value = _truncateValue(value);
  }
  return value;
};
var _truncateValue = function _truncateValue(value) {
  if (type(value) === 'string') {
    return value.length > Constants.MAX_STRING_LENGTH ? value.substring(0, Constants.MAX_STRING_LENGTH) : value;
  }
  return value;
};
var validateInput = function validateInput(input, name, expectedType) {
  if (type(input) !== expectedType) {
    log.error('Invalid ' + name + ' input type. Expected ' + expectedType + ' but received ' + type(input));
    return false;
  }
  return true;
};
var validateDeviceId = function validateDeviceId(deviceId) {
  if (!validateInput(deviceId, 'deviceId', 'string')) {
    return false;
  }
  if (deviceId.indexOf('.') >= 0) {
    log.error("Device IDs may not contain '.' characters. Value will be ignored: \"".concat(deviceId, "\""));
    return false;
  }
  return true;
};
var validateTransport = function validateTransport(transport) {
  if (!validateInput(transport, 'transport', 'string')) {
    return false;
  }
  if (transport !== Constants.TRANSPORT_HTTP && transport !== Constants.TRANSPORT_BEACON) {
    log.error("transport value must be one of '".concat(Constants.TRANSPORT_BEACON, "' or '").concat(Constants.TRANSPORT_HTTP, "'"));
    return false;
  }
  if (transport !== Constants.TRANSPORT_HTTP && typeof navigator !== 'undefined' && !navigator.sendBeacon) {
    log.error("browser does not support sendBeacon, so transport must be HTTP");
    return false;
  }
  return true;
};

// do some basic sanitization and type checking, also catch property dicts with more than 1000 key/value pairs
var validateProperties = function validateProperties(properties) {
  var propsType = type(properties);
  if (propsType !== 'object') {
    log.error('Error: invalid properties format. Expecting Javascript object, received ' + propsType + ', ignoring');
    return {};
  }
  if (Object.keys(properties).length > Constants.MAX_PROPERTY_KEYS) {
    log.error('Error: too many properties (more than 1000), ignoring');
    return {};
  }
  var copy = {}; // create a copy with all of the valid properties
  for (var property in properties) {
    if (!Object.prototype.hasOwnProperty.call(properties, property)) {
      continue;
    }

    // validate key
    var key = property;
    var keyType = type(key);
    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string property key, received type ' + keyType + ', coercing to string "' + key + '"');
    }

    // validate value
    var value = validatePropertyValue(key, properties[property]);
    if (value === null) {
      continue;
    }
    copy[key] = value;
  }
  return copy;
};
var invalidValueTypes = ['nan', 'function', 'arguments', 'regexp', 'element'];
var validatePropertyValue = function validatePropertyValue(key, value) {
  var valueType = type(value);
  if (invalidValueTypes.indexOf(valueType) !== -1) {
    log.warn('WARNING: Property key "' + key + '" with invalid value type ' + valueType + ', ignoring');
    value = null;
  } else if (valueType === 'undefined') {
    value = null;
  } else if (valueType === 'error') {
    value = String(value);
    log.warn('WARNING: Property key "' + key + '" with value type error, coercing to ' + value);
  } else if (valueType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];
    for (var i = 0; i < value.length; i++) {
      var element = value[i];
      var elemType = type(element);
      if (elemType === 'array') {
        log.warn('WARNING: Cannot have ' + elemType + ' nested in an array property value, skipping');
        continue;
      } else if (elemType === 'object') {
        arrayCopy.push(validateProperties(element));
      } else {
        arrayCopy.push(validatePropertyValue(key, element));
      }
    }
    value = arrayCopy;
  } else if (valueType === 'object') {
    value = validateProperties(value);
  }
  return value;
};
var validateGroups = function validateGroups(groups) {
  var groupsType = type(groups);
  if (groupsType !== 'object') {
    log.error('Error: invalid groups format. Expecting Javascript object, received ' + groupsType + ', ignoring');
    return {};
  }
  var copy = {}; // create a copy with all of the valid properties
  for (var group in groups) {
    if (!Object.prototype.hasOwnProperty.call(groups, group)) {
      continue;
    }

    // validate key
    var key = group;
    var keyType = type(key);
    if (keyType !== 'string') {
      key = String(key);
      log.warn('WARNING: Non-string groupType, received type ' + keyType + ', coercing to string "' + key + '"');
    }

    // validate value
    var value = validateGroupName(key, groups[group]);
    if (value === null) {
      continue;
    }
    copy[key] = value;
  }
  return copy;
};
var validateGroupName = function validateGroupName(key, groupName) {
  var groupNameType = type(groupName);
  if (groupNameType === 'string') {
    return groupName;
  }
  if (groupNameType === 'date' || groupNameType === 'number' || groupNameType === 'boolean') {
    groupName = String(groupName);
    log.warn('WARNING: Non-string groupName, received type ' + groupNameType + ', coercing to string "' + groupName + '"');
    return groupName;
  }
  if (groupNameType === 'array') {
    // check for nested arrays or objects
    var arrayCopy = [];
    for (var i = 0; i < groupName.length; i++) {
      var element = groupName[i];
      var elemType = type(element);
      if (elemType === 'array' || elemType === 'object') {
        log.warn('WARNING: Skipping nested ' + elemType + ' in array groupName');
        continue;
      } else if (elemType === 'string') {
        arrayCopy.push(element);
      } else if (elemType === 'date' || elemType === 'number' || elemType === 'boolean') {
        element = String(element);
        log.warn('WARNING: Non-string groupName, received type ' + elemType + ', coercing to string "' + element + '"');
        arrayCopy.push(element);
      }
    }
    return arrayCopy;
  }
  log.warn('WARNING: Non-string groupName, received type ' + groupNameType + '. Please use strings or array of strings for groupName');
};

// parses the value of a url param (for example ?gclid=1234&...)
var getQueryParam = function getQueryParam(name, query) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(query);
  return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
var isWebWorkerEnvironment = function isWebWorkerEnvironment() {
  return typeof WorkerGlobalScope !== 'undefined';
};
var validateSessionId = function validateSessionId(sessionId) {
  if (validateInput(sessionId, 'sessionId', 'number') && new Date(sessionId).getTime() > 0) {
    return true;
  }
  log.error("sessionId value must in milliseconds since epoch (Unix Timestamp)");
  return false;
};
var getLocation = function getLocation() {
  return GlobalScope.location;
};
var getHost = function getHost(url) {
  var defaultHostname = GlobalScope.location ? GlobalScope.location.hostname : '';
  if (url) {
    if (typeof document !== 'undefined') {
      var a = document.createElement('a');
      a.href = url;
      return a.hostname || defaultHostname;
    }
    if (typeof URL === 'function') {
      var u = new URL(url);
      return u.hostname || defaultHostname;
    }
  }
  return defaultHostname;
};
var utils = {
  setLogLevel: setLogLevel,
  getLogLevel: getLogLevel,
  logLevels: logLevels,
  log: log,
  isEmptyString: isEmptyString,
  isWebWorkerEnvironment: isWebWorkerEnvironment,
  getQueryParam: getQueryParam,
  sessionStorageEnabled: sessionStorageEnabled,
  truncate: truncate$1,
  validateGroups: validateGroups,
  validateInput: validateInput,
  validateProperties: validateProperties,
  validateDeviceId: validateDeviceId,
  validateTransport: validateTransport,
  validateSessionId: validateSessionId,
  getLocation: getLocation,
  getHost: getHost
};
var get$1 = function get(name) {
  try {
    var ca = document.cookie.split(';');
    var value = null;
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(name) === 0) {
        value = c.substring(name.length, c.length);
        break;
      }
    }
    return value;
  } catch (e) {
    return null;
  }
};
var getAll = function getAll(name) {
  try {
    var cookieArray = document.cookie.split(';').map(function (c) {
      return c.trimStart();
    });
    var values = [];
    var _iterator = _createForOfIteratorHelper(cookieArray),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cookie = _step.value;
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
          values.push(cookie.substring(name.length));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return values;
  } catch (e) {
    return [];
  }
};
var set$1 = function set(name, value, opts) {
  var expires = value !== null ? opts.expirationDays : -1;
  if (expires) {
    var date = new Date();
    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
    expires = date;
  }
  var str = name + '=' + value;
  if (expires) {
    str += '; expires=' + expires.toUTCString();
  }
  str += '; path=/';
  if (opts.domain) {
    str += '; domain=' + opts.domain;
  }
  if (opts.secure) {
    str += '; Secure';
  }
  if (opts.sameSite) {
    str += '; SameSite=' + opts.sameSite;
  }
  document.cookie = str;
};
var getLastEventTime = function getLastEventTime() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var strValue = cookie.split('.')[Constants.LAST_EVENT_TIME_INDEX];
  var parsedValue;
  if (strValue) {
    parsedValue = parseInt(strValue, 32);
  }
  if (parsedValue) {
    return parsedValue;
  } else {
    utils.log.warn("unable to parse malformed cookie: ".concat(cookie));
    return 0;
  }
};
var sortByEventTime = function sortByEventTime(cookies) {
  return _toConsumableArray(cookies).sort(function (c1, c2) {
    var t1 = getLastEventTime(c1);
    var t2 = getLastEventTime(c2);
    // sort c1 first if its last event time is more recent
    // i.e its event time integer is larger that c2's
    return t2 - t1;
  });
};

// test that cookies are enabled - navigator.cookiesEnabled yields false positives in IE, need to test directly
var areCookiesEnabled = function areCookiesEnabled() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var cookieName = Constants.COOKIE_TEST_PREFIX;
  if (typeof document === 'undefined') {
    return false;
  }
  var _areCookiesEnabled = false;
  try {
    var uid = String(Date.now());
    set$1(cookieName, uid, opts);
    utils.log.info("Testing if cookies available");
    _areCookiesEnabled = get$1(cookieName + '=') === uid;
  } catch (e) {
    utils.log.warn("Error thrown when checking for cookies. Reason: \"".concat(e, "\""));
  } finally {
    utils.log.info("Cleaning up cookies availability test");
    set$1(cookieName, null, opts);
  }
  return _areCookiesEnabled;
};
var baseCookie = {
  set: set$1,
  get: get$1,
  getAll: getAll,
  getLastEventTime: getLastEventTime,
  sortByEventTime: sortByEventTime,
  areCookiesEnabled: areCookiesEnabled
};

// A URL safe variation on the the list of Base64 characters
var base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
var base64Id = function base64Id() {
  var str = '';
  for (var i = 0; i < 22; ++i) {
    str += base64Chars.charAt(Math.floor(Math.random() * 64));
  }
  return str;
};

// Utility that finds top level domain to write to
var topDomain = function topDomain(url) {
  var host = utils.getHost(url);
  var parts = host.split('.');
  var levels = [];
  var cname = '_tldtest_' + base64Id();
  if (utils.isWebWorkerEnvironment()) return '';
  for (var i = parts.length - 2; i >= 0; --i) {
    levels.push(parts.slice(i).join('.'));
  }
  for (var _i = 0; _i < levels.length; ++_i) {
    var domain = levels[_i];
    var opts = {
      domain: '.' + domain
    };
    baseCookie.set(cname, 1, opts);
    if (baseCookie.get(cname)) {
      baseCookie.set(cname, null, opts);
      return domain;
    }
  }
  return '';
};

/*
 * Cookie data
 */
var _options = {
  expirationDays: undefined,
  domain: undefined
};
var reset = function reset() {
  _options = {
    expirationDays: undefined,
    domain: undefined
  };
};
var options = function options(opts) {
  if (arguments.length === 0) {
    return _options;
  }
  opts = opts || {};
  _options.expirationDays = opts.expirationDays;
  _options.secure = opts.secure;
  _options.sameSite = opts.sameSite;
  var domain = !utils.isEmptyString(opts.domain) ? opts.domain : '.' + topDomain(utils.getLocation().href);
  var token = Math.random();
  _options.domain = domain;
  set$2('amplitude_test', token);
  var stored = get$2('amplitude_test');
  if (!stored || stored !== token) {
    domain = null;
  }
  remove('amplitude_test');
  _options.domain = domain;
  return _options;
};
var _domainSpecific = function _domainSpecific(name) {
  // differentiate between cookies on different domains
  var suffix = '';
  if (_options.domain) {
    suffix = _options.domain.charAt(0) === '.' ? _options.domain.substring(1) : _options.domain;
  }
  return name + suffix;
};
var get$2 = function get(name) {
  var nameEq = _domainSpecific(name) + '=';
  var value = baseCookie.get(nameEq);
  try {
    if (value) {
      return JSON.parse(Base64.decode(value));
    }
  } catch (e) {
    return null;
  }
  return null;
};
var set$2 = function set(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), Base64.encode(JSON.stringify(value)), _options);
    return true;
  } catch (e) {
    return false;
  }
};
var setRaw = function setRaw(name, value) {
  try {
    baseCookie.set(_domainSpecific(name), value, _options);
    return true;
  } catch (e) {
    return false;
  }
};
var getRaw = function getRaw(name) {
  var nameEq = _domainSpecific(name) + '=';
  return baseCookie.get(nameEq);
};
var remove = function remove(name) {
  try {
    baseCookie.set(_domainSpecific(name), null, _options);
    return true;
  } catch (e) {
    return false;
  }
};
var Cookie = {
  reset: reset,
  options: options,
  get: get$2,
  set: set$2,
  remove: remove,
  setRaw: setRaw,
  getRaw: getRaw
};
var WorkerStorage = /*#__PURE__*/function () {
  function WorkerStorage() {
    _classCallCheck(this, WorkerStorage);
    this.map = new Map();
    this.length = 0;
  }
  _createClass(WorkerStorage, [{
    key: "key",
    value: function key(index) {
      var keys = Array.from(this.map.keys());
      var key = keys[index];
      return this.map.get(key);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      if (!this.map.has(key)) {
        this.length += 1;
      }
      this.map.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this.map.has(key)) {
        this.length -= 1;
        this.map["delete"](key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
      this.length = 0;
    }
  }]);
  return WorkerStorage;
}();

/*
 * Implement localStorage to support Firefox 2-3 and IE 5-7
 */
var localStorage$1;
{
  // test that Window.localStorage is available and works
  var windowLocalStorageAvailable = function windowLocalStorageAvailable() {
    var uid = new Date();
    var result;
    try {
      GlobalScope.localStorage.setItem(uid, uid);
      result = GlobalScope.localStorage.getItem(uid) === String(uid);
      GlobalScope.localStorage.removeItem(uid);
      return result;
    } catch (e) {
      // localStorage not available
    }
    return false;
  };
  if (windowLocalStorageAvailable()) {
    localStorage$1 = GlobalScope.localStorage;
  } else if (typeof GlobalScope !== 'undefined' && GlobalScope.globalStorage) {
    // Firefox 2-3 use globalStorage
    // See https://developer.mozilla.org/en/dom/storage#globalStorage
    try {
      localStorage$1 = GlobalScope.globalStorage[GlobalScope.location.hostname];
    } catch (e) {
      // Something bad happened...
    }
  } else if (typeof document !== 'undefined') {
    // IE 5-7 use userData
    // See http://msdn.microsoft.com/en-us/library/ms531424(v=vs.85).aspx
    var div = document.createElement('div'),
      attrKey = 'localStorage';
    div.style.display = 'none';
    document.getElementsByTagName('head')[0].appendChild(div);
    if (div.addBehavior) {
      div.addBehavior('#default#userdata');
      localStorage$1 = {
        length: 0,
        setItem: function setItem(k, v) {
          div.load(attrKey);
          if (!div.getAttribute(k)) {
            this.length++;
          }
          div.setAttribute(k, v);
          div.save(attrKey);
        },
        getItem: function getItem(k) {
          div.load(attrKey);
          return div.getAttribute(k);
        },
        removeItem: function removeItem(k) {
          div.load(attrKey);
          if (div.getAttribute(k)) {
            this.length--;
          }
          div.removeAttribute(k);
          div.save(attrKey);
        },
        clear: function clear() {
          div.load(attrKey);
          var i = 0;
          var attr;
          while (attr = div.XMLDocument.documentElement.attributes[i++]) {
            div.removeAttribute(attr.name);
          }
          div.save(attrKey);
          this.length = 0;
        },
        key: function key(k) {
          div.load(attrKey);
          return div.XMLDocument.documentElement.attributes[k];
        }
      };
      div.load(attrKey);
      localStorage$1.length = div.XMLDocument.documentElement.attributes.length;
    }
  } else if (utils.isWebWorkerEnvironment()) {
    // Web worker
    localStorage$1 = new WorkerStorage();
  }
  if (!localStorage$1) {
    /* eslint-disable no-unused-vars */
    localStorage$1 = {
      length: 0,
      setItem: function setItem(k, v) {},
      getItem: function getItem(k) {},
      removeItem: function removeItem(k) {},
      clear: function clear() {},
      key: function key(k) {}
    };
    /* eslint-enable no-unused-vars */
  }
}
var localStorage$1$1 = localStorage$1;

/*
 * Abstraction layer for cookie storage.
 * Uses cookie if available, otherwise fallback to localstorage.
 */
var cookieStorage = function cookieStorage() {
  this.storage = null;
};
cookieStorage.prototype.getStorage = function (disableCookies) {
  if (this.storage !== null) {
    return this.storage;
  }
  if (!disableCookies && baseCookie.areCookiesEnabled()) {
    this.storage = Cookie;
  } else {
    // if cookies disabled, fallback to localstorage
    // note: localstorage does not persist across subdomains
    var keyPrefix = 'amp_cookiestore_';
    this.storage = {
      _options: {
        expirationDays: undefined,
        domain: undefined,
        secure: false
      },
      reset: function reset() {
        this._options = {
          expirationDays: undefined,
          domain: undefined,
          secure: false
        };
      },
      options: function options(opts) {
        if (arguments.length === 0) {
          return this._options;
        }
        opts = opts || {};
        this._options.expirationDays = opts.expirationDays || this._options.expirationDays;
        // localStorage is specific to subdomains
        this._options.domain = opts.domain || this._options.domain || GlobalScope && GlobalScope.location && GlobalScope.location.hostname;
        return this._options.secure = opts.secure || false;
      },
      get: function get(name) {
        try {
          return JSON.parse(localStorage$1$1.getItem(keyPrefix + name));
        } catch (e) {} /* eslint-disable-line no-empty */
        return null;
      },
      set: function set(name, value) {
        try {
          localStorage$1$1.setItem(keyPrefix + name, JSON.stringify(value));
          return true;
        } catch (e) {} /* eslint-disable-line no-empty */
        return false;
      },
      remove: function remove(name) {
        try {
          localStorage$1$1.removeItem(keyPrefix + name);
        } catch (e) {
          return false;
        }
      }
    };
  }
  return this.storage;
};
var _storageOptionExists;
var storageOptionExists = (_storageOptionExists = {}, _defineProperty(_storageOptionExists, Constants.STORAGE_COOKIES, true), _defineProperty(_storageOptionExists, Constants.STORAGE_NONE, true), _defineProperty(_storageOptionExists, Constants.STORAGE_LOCAL, true), _defineProperty(_storageOptionExists, Constants.STORAGE_SESSION, true), _storageOptionExists);

/**
 * MetadataStorage involves SDK data persistance
 * storage priority: cookies -> localStorage -> in memory
 * This priority can be overriden by setting the storage options.
 * if in localStorage, unable track users between subdomains
 * if in memory, then memory can't be shared between different tabs
 */
var MetadataStorage = /*#__PURE__*/function () {
  function MetadataStorage(_ref) {
    var storageKey = _ref.storageKey,
      disableCookies = _ref.disableCookies,
      domain = _ref.domain,
      secure = _ref.secure,
      sameSite = _ref.sameSite,
      expirationDays = _ref.expirationDays,
      storage = _ref.storage;
    _classCallCheck(this, MetadataStorage);
    this.storageKey = storageKey;
    this.domain = domain;
    this.secure = secure;
    this.sameSite = sameSite;
    this.expirationDays = expirationDays;
    this.cookieDomain = '';
    var loc = utils.getLocation() ? utils.getLocation().href : undefined;
    var writableTopDomain = !disableCookies ? topDomain(loc) : '';
    this.cookieDomain = domain || (writableTopDomain ? '.' + writableTopDomain : null);
    if (storageOptionExists[storage]) {
      this.storage = storage;
    } else {
      var disableCookieStorage = disableCookies || !baseCookie.areCookiesEnabled({
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
      if (disableCookieStorage) {
        this.storage = Constants.STORAGE_LOCAL;
      } else {
        this.storage = Constants.STORAGE_COOKIES;
      }
    }
  }
  _createClass(MetadataStorage, [{
    key: "getCookieStorageKey",
    value: function getCookieStorageKey() {
      if (!this.domain) {
        return this.storageKey;
      }
      var suffix = this.domain.charAt(0) === '.' ? this.domain.substring(1) : this.domain;
      return "".concat(this.storageKey).concat(suffix ? "_".concat(suffix) : '');
    }

    /*
     * Data is saved as delimited values rather than JSO to minimize cookie space
     * Should not change order of the items
     */
  }, {
    key: "save",
    value: function save(_ref2) {
      var deviceId = _ref2.deviceId,
        userId = _ref2.userId,
        optOut = _ref2.optOut,
        sessionId = _ref2.sessionId,
        lastEventTime = _ref2.lastEventTime,
        eventId = _ref2.eventId,
        identifyId = _ref2.identifyId,
        sequenceNumber = _ref2.sequenceNumber;
      if (this.storage === Constants.STORAGE_NONE) {
        return;
      }
      var value = [deviceId, Base64.encode(userId || ''),
      // used to convert not unicode to alphanumeric since cookies only use alphanumeric
      optOut ? '1' : '', sessionId ? sessionId.toString(32) : '0',
      // generated when instantiated, timestamp (but re-uses session id in cookie if not expired) @TODO clients may want custom session id
      lastEventTime ? lastEventTime.toString(32) : '0',
      // last time an event was set
      eventId ? eventId.toString(32) : '0', identifyId ? identifyId.toString(32) : '0', sequenceNumber ? sequenceNumber.toString(32) : '0'].join('.');
      switch (this.storage) {
        case Constants.STORAGE_SESSION:
          if (GlobalScope.sessionStorage) {
            GlobalScope.sessionStorage.setItem(this.storageKey, value);
          }
          break;
        case Constants.STORAGE_LOCAL:
          localStorage$1$1.setItem(this.storageKey, value);
          break;
        case Constants.STORAGE_COOKIES:
          this.saveCookie(value);
          break;
      }
    }
  }, {
    key: "saveCookie",
    value: function saveCookie(value) {
      baseCookie.set(this.getCookieStorageKey(), value, {
        domain: this.cookieDomain,
        secure: this.secure,
        sameSite: this.sameSite,
        expirationDays: this.expirationDays
      });
    }
  }, {
    key: "load",
    value: function load() {
      var _this = this;
      var str;
      if (this.storage === Constants.STORAGE_COOKIES) {
        var cookieKey = this.getCookieStorageKey() + '=';
        var allCookies = baseCookie.getAll(cookieKey);
        if (allCookies.length === 0 || allCookies.length === 1) {
          str = allCookies[0];
        } else {
          // dedup cookies by deleting them all and restoring
          // the one with the most recent event time
          var latestCookie = baseCookie.sortByEventTime(allCookies)[0];
          allCookies.forEach(function () {
            return baseCookie.set(_this.getCookieStorageKey(), null, {});
          });
          this.saveCookie(latestCookie);
          str = baseCookie.get(cookieKey);
        }
      }
      if (!str) {
        str = localStorage$1$1.getItem(this.storageKey);
      }
      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }
      if (!str) {
        return null;
      }
      var values = str.split('.');
      var userId = null;
      if (values[Constants.USER_ID_INDEX]) {
        try {
          userId = Base64.decode(values[Constants.USER_ID_INDEX]);
        } catch (e) {
          userId = null;
        }
      }
      return {
        deviceId: values[Constants.DEVICE_ID_INDEX],
        userId: userId,
        optOut: values[Constants.OPT_OUT_INDEX] === '1',
        sessionId: parseInt(values[Constants.SESSION_ID_INDEX], 32),
        lastEventTime: parseInt(values[Constants.LAST_EVENT_TIME_INDEX], 32),
        eventId: parseInt(values[Constants.EVENT_ID_INDEX], 32),
        identifyId: parseInt(values[Constants.IDENTIFY_ID_INDEX], 32),
        sequenceNumber: parseInt(values[Constants.SEQUENCE_NUMBER_INDEX], 32)
      };
    }

    /**
     * Clears any saved metadata storage
     * @constructor AmplitudeClient
     * @public
     * @return {boolean} True if metadata was cleared, false if none existed
     */
  }, {
    key: "clear",
    value: function clear() {
      var str;
      if (this.storage === Constants.STORAGE_COOKIES) {
        str = baseCookie.get(this.getCookieStorageKey() + '=');
        baseCookie.set(this.getCookieStorageKey(), null, {
          domain: this.cookieDomain,
          secure: this.secure,
          sameSite: this.sameSite,
          expirationDays: 0
        });
      }
      if (!str) {
        str = localStorage$1$1.getItem(this.storageKey);
        localStorage$1$1.clear();
      }
      if (!str) {
        try {
          str = GlobalScope.sessionStorage && GlobalScope.sessionStorage.getItem(this.storageKey);
          GlobalScope.sessionStorage.clear();
        } catch (e) {
          utils.log.info("window.sessionStorage unavailable. Reason: \"".concat(e, "\""));
        }
      }
      return !!str;
    }
  }]);
  return MetadataStorage;
}();
var getUtmData$1 = function getUtmData(rawCookie, query) {
  // Translate the utmz cookie format into url query string format.
  var cookie = rawCookie ? '?' + rawCookie.split('.').slice(-1)[0].replace(/\|/g, '&') : '';
  var fetchParam = function fetchParam(queryName, query, cookieName, cookie) {
    return utils.getQueryParam(queryName, query) || utils.getQueryParam(cookieName, cookie);
  };
  var utmSource = fetchParam(Constants.UTM_SOURCE, query, 'utmcsr', cookie);
  var utmMedium = fetchParam(Constants.UTM_MEDIUM, query, 'utmcmd', cookie);
  var utmCampaign = fetchParam(Constants.UTM_CAMPAIGN, query, 'utmccn', cookie);
  var utmTerm = fetchParam(Constants.UTM_TERM, query, 'utmctr', cookie);
  var utmContent = fetchParam(Constants.UTM_CONTENT, query, 'utmcct', cookie);
  var utmData = {};
  var addIfNotNull = function addIfNotNull(key, value) {
    if (!utils.isEmptyString(value)) {
      utmData[key] = value;
    }
  };
  addIfNotNull(Constants.UTM_SOURCE, utmSource);
  addIfNotNull(Constants.UTM_MEDIUM, utmMedium);
  addIfNotNull(Constants.UTM_CAMPAIGN, utmCampaign);
  addIfNotNull(Constants.UTM_TERM, utmTerm);
  addIfNotNull(Constants.UTM_CONTENT, utmContent);
  return utmData;
};

/*
 * Wrapper for a user properties JSON object that supports operations.
 * Note: if a user property is used in multiple operations on the same Identify object,
 * only the first operation will be saved, and the rest will be ignored.
 */

var AMP_OP_ADD = '$add';
var AMP_OP_APPEND = '$append';
var AMP_OP_CLEAR_ALL = '$clearAll';
var AMP_OP_PREPEND = '$prepend';
var AMP_OP_SET = '$set';
var AMP_OP_SET_ONCE = '$setOnce';
var AMP_OP_UNSET = '$unset';
var AMP_OP_PREINSERT = '$preInsert';
var AMP_OP_POSTINSERT = '$postInsert';
var AMP_OP_REMOVE = '$remove';

/**
 * Identify API - instance constructor. Identify objects are a wrapper for user property operations.
 * Each method adds a user property operation to the Identify object, and returns the same Identify object,
 * allowing you to chain multiple method calls together.
 * Note: if the same user property is used in multiple operations on a single Identify object,
 * only the first operation on that property will be saved, and the rest will be ignored.
 * @constructor Identify
 * @public
 * @example var identify = new amplitude.Identify();
 */
var Identify = function Identify() {
  this.userPropertiesOperations = {};
  this.properties = []; // keep track of keys that have been added
};

/**
 * Increment a user property by a given value (can also be negative to decrement).
 * If the user property does not have a value set yet, it will be initialized to 0 before being incremented.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string} value - The amount by which to increment the user property. Allows numbers as strings (ex: '123').
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().add('karma', 1).add('friends', 1);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.add = function (property, value) {
  if (type(value) === 'number' || type(value) === 'string') {
    this._addOperation(AMP_OP_ADD, property, value);
  } else {
    utils.log.error('Unsupported type for value: ' + type(value) + ', expecting number or string');
  }
  return this;
};

/**
 * Append a value or values to a user property.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are appended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values appended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to append.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().append('ab-tests', 'new-user-tests');
 * identify.append('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.append = function (property, value) {
  this._addOperation(AMP_OP_APPEND, property, value);
  return this;
};

/**
 * Clear all user properties for the current user.
 * SDK user should instead call amplitude.clearUserProperties() instead of using this.
 * $clearAll needs to be sent on its own Identify object. If there are already other operations, then don't add $clearAll.
 * If $clearAll already in an Identify object, don't allow other operations to be added.
 * @private
 */
Identify.prototype.clearAll = function () {
  if (Object.keys(this.userPropertiesOperations).length > 0) {
    if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
      utils.log.error('Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll');
    }
    return this;
  }
  this.userPropertiesOperations[AMP_OP_CLEAR_ALL] = '-';
  return this;
};

/**
 * Prepend a value or values to a user property.
 * Prepend means inserting the value or values at the front of a list.
 * If the user property does not have a value set yet,
 * it will be initialized to an empty list before the new values are prepended.
 * If the user property has an existing value and it is not a list,
 * the existing value will be converted into a list with the new values prepended.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to prepend.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().prepend('ab-tests', 'new-user-tests');
 * identify.prepend('some_list', [1, 2, 3, 4, 'values']);
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.prepend = function (property, value) {
  this._addOperation(AMP_OP_PREPEND, property, value);
  return this;
};

/**
 * Sets the value of a given user property. If a value already exists, it will be overwriten with the new value.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().set('user_type', 'beta');
 * identify.set('name', {'first': 'John', 'last': 'Doe'}); // dict is flattened and becomes name.first: John, name.last: Doe
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.set = function (property, value) {
  this._addOperation(AMP_OP_SET, property, value);
  return this;
};

/**
 * Sets the value of a given user property only once. Subsequent setOnce operations on that user property will be ignored;
 * however, that user property can still be modified through any of the other operations.
 * Useful for capturing properties such as 'initial_signup_date', 'initial_referrer', etc.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|boolean|object} value - A value or values to set once.
 * Values can be numbers, strings, lists, or object (key:value dict will be flattened).
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().setOnce('sign_up_date', '2016-04-01');
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.setOnce = function (property, value) {
  this._addOperation(AMP_OP_SET_ONCE, property, value);
  return this;
};

/**
 * Unset and remove a user property. This user property will no longer show up in a user's profile.
 * @public
 * @param {string} property - The user property key.
 * @return {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 * @example var identify = new amplitude.Identify().unset('user_type').unset('age');
 * amplitude.identify(identify); // send the Identify call
 */
Identify.prototype.unset = function (property) {
  this._addOperation(AMP_OP_UNSET, property, '-');
  return this;
};

/**
 * Preinsert a value or values to a user property, if it does not exist in the user property already.
 * Preinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @public
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.preInsert = function (property, value) {
  this._addOperation(AMP_OP_PREINSERT, property, value);
  return this;
};

/**
 * Postinsert a value or values to a user property, if it does not exist in the user property already.
 * Postinsert means inserting the value or values to the beginning of the specified user property.
 * If the item already exists in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to insert.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.postInsert = function (property, value) {
  this._addOperation(AMP_OP_POSTINSERT, property, value);
  return this;
};

/**
 * Remove a value or values to a user property, if it does exist in the user property.
 * If the item does not exist in the user property, it will be a no-op.
 * @param {string} property - The user property key.
 * @param {number|string|list|object} value - A value or values to remove.
 * @returns {Identify} Returns the same Identify object, allowing you to chain multiple method calls together.
 */
Identify.prototype.remove = function (property, value) {
  this._addOperation(AMP_OP_REMOVE, property, value);
  return this;
};

/**
 * Helper function that adds operation to the Identify's object
 * Handle's filtering of duplicate user property keys, and filtering for clearAll.
 * @private
 */
Identify.prototype._addOperation = function (operation, property, value) {
  // check that the identify doesn't already contain a clearAll
  if (Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, AMP_OP_CLEAR_ALL)) {
    utils.log.error('This identify already contains a $clearAll operation, skipping operation ' + operation);
    return;
  }

  // check that property wasn't already used in this Identify
  if (this.properties.indexOf(property) !== -1) {
    utils.log.error('User property "' + property + '" already used in this identify, skipping operation ' + operation);
    return;
  }
  if (!Object.prototype.hasOwnProperty.call(this.userPropertiesOperations, operation)) {
    this.userPropertiesOperations[operation] = {};
  }
  this.userPropertiesOperations[operation][property] = value;
  this.properties.push(property);
};

/*
 * Simple AJAX request object
 */
var Request$1 = function Request(url, data, headers) {
  this.url = url;
  this.data = data || {};
  this.headers = headers;
};
var CORS_HEADER = 'Cross-Origin-Resource-Policy';
function setHeaders(xhr, headers) {
  for (var header in headers) {
    if (header === CORS_HEADER && !headers[header]) {
      continue;
    }
    xhr.setRequestHeader(header, headers[header]);
  }
}
Request$1.prototype.send = function (callback) {
  var isIE = GlobalScope.XDomainRequest ? true : false;
  if (isIE) {
    var xdr = new GlobalScope.XDomainRequest();
    xdr.open('POST', this.url, true);
    xdr.onload = function () {
      callback(200, xdr.responseText);
    };
    xdr.onerror = function () {
      // status code not available from xdr, try string matching on responseText
      if (xdr.responseText === 'Request Entity Too Large') {
        callback(413, xdr.responseText);
      } else {
        callback(500, xdr.responseText);
      }
    };
    xdr.ontimeout = function () {};
    xdr.onprogress = function () {};
    xdr.send(queryString$1.stringify(this.data));
  } else if (typeof XMLHttpRequest !== 'undefined') {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', this.url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        callback(xhr.status, xhr.responseText);
      }
    };
    setHeaders(xhr, this.headers);
    xhr.send(queryString$1.stringify(this.data));
  } else {
    var responseStatus = undefined;
    fetch(this.url, {
      method: 'POST',
      headers: this.headers,
      body: queryString$1.stringify(this.data)
    }).then(function (response) {
      responseStatus = response.status;
      return response.text();
    }).then(function (responseText) {
      callback(responseStatus, responseText);
    });
  }
  //log('sent request to ' + this.url + ' with data ' + decodeURIComponent(queryString(this.data)));
};

/**
 * Revenue API - instance constructor. Wrapper for logging Revenue data. Revenue objects get passed to amplitude.logRevenueV2 to send to Amplitude servers.
 * Each method updates a revenue property in the Revenue object, and returns the same Revenue object,
 * allowing you to chain multiple method calls together.
 *
 * Note: price is a required field to log revenue events.
 * If quantity is not specified then defaults to 1.
 * @constructor Revenue
 * @public
 * @example var revenue = new amplitude.Revenue();
 */
var Revenue = function Revenue() {
  // required fields
  this._price = null;

  // optional fields
  this._productId = null;
  this._quantity = 1;
  this._revenueType = null;
  this._properties = null;
};

/**
 * Set a value for the product identifer.
 * @public
 * @param {string} productId - The value for the product identifier. Empty and invalid strings are ignored.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setProductId = function setProductId(productId) {
  if (type(productId) !== 'string') {
    utils.log.error('Unsupported type for productId: ' + type(productId) + ', expecting string');
  } else if (utils.isEmptyString(productId)) {
    utils.log.error('Invalid empty productId');
  } else {
    this._productId = productId;
  }
  return this;
};

/**
 * Set a value for the quantity. Note revenue amount is calculated as price * quantity.
 * @public
 * @param {number} quantity - Integer value for the quantity. If not set, quantity defaults to 1.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setQuantity(5);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setQuantity = function setQuantity(quantity) {
  if (type(quantity) !== 'number') {
    utils.log.error('Unsupported type for quantity: ' + type(quantity) + ', expecting number');
  } else {
    this._quantity = parseInt(quantity);
  }
  return this;
};

/**
 * Set a value for the price. This field is required for all revenue being logged.
 *
 * Note: revenue amount is calculated as price * quantity.
 * @public
 * @param {number} price - Double value for the quantity.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setPrice = function setPrice(price) {
  if (type(price) !== 'number') {
    utils.log.error('Unsupported type for price: ' + type(price) + ', expecting number');
  } else {
    this._price = price;
  }
  return this;
};

/**
 * Set a value for the revenueType (for example purchase, cost, tax, refund, etc).
 * @public
 * @param {string} revenueType - RevenueType to designate.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setRevenueType('purchase');
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setRevenueType = function setRevenueType(revenueType) {
  if (type(revenueType) !== 'string') {
    utils.log.error('Unsupported type for revenueType: ' + type(revenueType) + ', expecting string');
  } else {
    this._revenueType = revenueType;
  }
  return this;
};

/**
 * Set event properties for the revenue event.
 * @public
 * @param {object} eventProperties - Revenue event properties to set.
 * @return {Revenue} Returns the same Revenue object, allowing you to chain multiple method calls together.
 * @example var event_properties = {'city': 'San Francisco'};
 * var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99).setEventProperties(event_properties);
 * amplitude.logRevenueV2(revenue);
 */
Revenue.prototype.setEventProperties = function setEventProperties(eventProperties) {
  if (type(eventProperties) !== 'object') {
    utils.log.error('Unsupported type for eventProperties: ' + type(eventProperties) + ', expecting object');
  } else {
    this._properties = utils.validateProperties(eventProperties);
  }
  return this;
};

/**
 * @private
 */
Revenue.prototype._isValidRevenue = function _isValidRevenue() {
  if (type(this._price) !== 'number') {
    utils.log.error('Invalid revenue, need to set price field');
    return false;
  }
  return true;
};

/**
 * @private
 */
Revenue.prototype._toJSONObject = function _toJSONObject() {
  var obj = type(this._properties) === 'object' ? this._properties : {};
  if (this._productId !== null) {
    obj[Constants.REVENUE_PRODUCT_ID] = this._productId;
  }
  if (this._quantity !== null) {
    obj[Constants.REVENUE_QUANTITY] = this._quantity;
  }
  if (this._price !== null) {
    obj[Constants.REVENUE_PRICE] = this._price;
  }
  if (this._revenueType !== null) {
    obj[Constants.REVENUE_REVENUE_TYPE] = this._revenueType;
  }
  return obj;
};

/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */
var uuid = function uuid(a) {
  return a // if the placeholder was passed, return
  ?
  // a random number from 0 to 15
  (a ^
  // unless b is 8,
  Math.random() *
  // in which case
  16 >>
  // a random number from
  a / 4
  // 8 to 11
  ).toString(16) // in hexadecimal
  :
  // or otherwise a concatenated string:
  ([1e7] +
  // 10000000 +
  -1e3 +
  // -1000 +
  -4e3 +
  // -4000 +
  -8e3 +
  // -80000000 +
  -1e11
  // -100000000000,
  ).replace(
  // replacing
  /[018]/g,
  // zeroes, ones, and eights with
  uuid // random hex digits
  );
};
var getLanguage = function getLanguage() {
  return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage) || '';
};
var language = {
  getLanguage: getLanguage
};

/**
 * AmplitudeServerZone is for Data Residency and handling server zone related properties.
 * The server zones now are US and EU.
 *
 * For usage like sending data to Amplitude's EU servers, you need to configure the serverZone during nitializing.
 */
var AmplitudeServerZone = {
  US: 'US',
  EU: 'EU'
};
var getEventLogApi = function getEventLogApi(serverZone) {
  var eventLogUrl = Constants.EVENT_LOG_URL;
  switch (serverZone) {
    case AmplitudeServerZone.EU:
      eventLogUrl = Constants.EVENT_LOG_EU_URL;
      break;
    case AmplitudeServerZone.US:
      eventLogUrl = Constants.EVENT_LOG_URL;
      break;
  }
  return eventLogUrl;
};
var getDynamicConfigApi = function getDynamicConfigApi(serverZone) {
  var dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
  switch (serverZone) {
    case AmplitudeServerZone.EU:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_EU_URL;
      break;
    case AmplitudeServerZone.US:
      dynamicConfigUrl = Constants.DYNAMIC_CONFIG_URL;
      break;
  }
  return dynamicConfigUrl;
};
var version = "8.21.9";

/**
 * Options used when initializing Amplitude
 * @typedef {Object} Options
 * @property {string} [apiEndpoint=`api.amplitude.com`] - Endpoint to send amplitude event requests to.
 * @property {boolean} [batchEvents=`false`] -  If `true`, then events are batched together and uploaded only when the number of unsent events is greater than or equal to eventUploadThreshold or after eventUploadPeriodMillis milliseconds have passed since the first unsent event was logged.
 * @property {number} [cookieExpiration=`365`] - The number of days after which the Amplitude cookie will expire. 12 months is for GDPR compliance.
 * @property {string} [cookieName=`amplitude_id`] - *DEPRECATED*
 * @property {string} [sameSiteCookie='None'] -  Sets the SameSite flag on the amplitude cookie. Decides cookie privacy policy.
 * @property {boolean} [cookieForceUpgrade=`false`] - Forces pre-v6.0.0 instances to adopt post-v6.0.0 compat cookie formats.
 * @property {boolean} [deferInitialization=`null`] -  If `true`, disables the core functionality of the sdk, including saving a cookie and all logging, until explicitly enabled. To enable tracking, please call `amplitude.getInstance().enableTracking()` *Note: This will not affect users who already have an amplitude cookie. The decision to track events is determined by whether or not a user has an amplitude analytics cookie. If the `cookieExpiration</code> is manually defined to be a short lifespan, you may need to run `amplitude.getInstance().enableTracking()` upon the cookie expiring or upon logging in.*
 * @property {boolean} [disableCookies=`false`] -  Disable Ampllitude cookies altogether.
 * @property {string} [deviceId=A randomly generated UUID.] -  The custom Device ID to set. *Note: This is not recommended unless you know what you are doing (e.g. you have your own system for tracking user devices).*
 * @property {boolean} [deviceIdFromUrlParam=`false`] -  If `true`, then the SDK will parse Device ID values from the URL parameter amp_device_id if available. Device IDs defined in the configuration options during init will take priority over Device IDs from URL parameters.
 * @property {string} [domain=The top domain of the current page's URL. ('https://amplitude.com')] -  Set a custom domain for the Amplitude cookie. To include subdomains, add a preceding period, eg: `.amplitude.com`.
 * @property {number} [eventUploadPeriodMillis=`30000` (30 sec)] -  Amount of time in milliseconds that the SDK waits before uploading events if batchEvents is true.
 * @property {number} [eventUploadThreshold=`30`] -  Minimum number of events to batch together per request if batchEvents is true.
 * @property {boolean} [forceHttps=`true`] -  If `true`, the events will always be uploaded to HTTPS endpoint. Otherwise, it will use the embedding site's protocol.
 * @property {boolean} [includeFbclid=`false`] -  If `true`, captures the fbclid URL parameter as well as the user's initial_fbclid via a setOnce operation.
 * @property {boolean} [includeGclid=`false`] -  If `true`, captures the gclid URL parameter as well as the user's initial_gclid via a setOnce operation.
 * @property {boolean} [includeReferrer=`false`] -  If `true`, captures the referrer and referring_domain for each session, as well as the user's initial_referrer and initial_referring_domain via a setOnce operation.
 * @property {boolean} [includeUtm=`false`] -  If `true`, finds UTM parameters in the query string or the _utmz cookie, parses, and includes them as user properties on all events uploaded. This also captures initial UTM parameters for each session via a setOnce operation.
 * @property {Object} [ingestionMetadata] Ingestion metadata
 * @property {string} [ingestionMetadata.sourceName] source name in ingestion metadata, e.g. "ampli"
 * @property {string} [ingestionMetadata.sourceVersion] source version in ingestion metadata, e.g. "1.0.0"
 * @property {string} [language=The language determined by the browser] -  Custom language to set.
 * @property {Object} [library=`{ name: 'amplitude-js', version: packageJsonVersion }`] -  Values for the library version
 * @property {string} [logLevel=`WARN`] -  Level of logs to be printed in the developer console. Valid values are 'DISABLE', 'ERROR', 'WARN', 'INFO'. To learn more about the different options, see below.
 * @property {boolean} [logAttributionCapturedEvent=`false`] - If `true`, the SDK will log an Amplitude event anytime new attribution values are captured from the user. **Note: These events count towards your event volume.** Event name being logged: [Amplitude] Attribution Captured. Event Properties that can be logged: `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, `utm_content`, `referrer`, `referring_domain`, `gclid`, `fbclid`. For UTM properties to be logged, `includeUtm` must be set to `true`. For the `referrer` and `referring_domain` properties to be logged, `includeReferrer` must be set to `true`. For the `gclid` property to be logged, `includeGclid` must be set to `true`. For the `fbclid` property to be logged, `includeFbclid` must be set to `true`.
 * @property {boolean} [optOut=`false`] -  Whether or not to disable tracking for the current user.
 * @property {function} [onError=`() => {}`] - Function to call on error.
 * @property {function} [onExitPage=`() => {}`] - Function called when the user exits the browser. Useful logging on page exit.
 * @property {Object} [plan] Tracking plan properties
 * @property {string} [plan.branch] The tracking plan branch name e.g. "main"
 * @property {string} [plan.source] The tracking plan source e.g. "web"
 * @property {string} [plan.version] The tracking plan version e.g. "1", "15"
 * @property {string} [plan.versionId] The tracking plan version Id e.g. "9ec23ba0-275f-468f-80d1-66b88bff9529"
 * @property {string} [platform=`Web`] -  Platform device is running on. Defaults to `Web` (browser, including mobile browsers).
 * @property {number} [savedMaxCount=`1000`] -  Maximum number of events to save in localStorage. If more events are logged while offline, then old events are removed.
 * @property {boolean} [saveEvents=`true`] -  If `true`, saves events to localStorage and removes them upon successful upload. *Note: Without saving events, events may be lost if the user navigates to another page before the events are uploaded.*
 * @property {boolean} [saveParamsReferrerOncePerSession=`true`] -  If `true`, then includeGclid, includeFbclid, includeReferrer, and includeUtm will only track their respective properties once per session. New values that come in during the middle of the user's session will be ignored. Set to false to always capture new values.
 * @property {boolean} [secureCookie=`false`] -  If `true`, the amplitude cookie will be set with the Secure flag.
 * @property {number} [sessionTimeout=`30*60*1000` (30 min)] -  The time between logged events before a new session starts in milliseconds.
 * @property {string[]} [storage=`''`] - Sets storage strategy.  Options are 'cookies', 'localStorage', 'sessionStorage', or `none`. Will override `disableCookies` option
 * @property {Object} [trackingOptions=`{ city: true, country: true, carrier: true, device_manufacturer: true, device_model: true, dma: true, ip_address: true, language: true, os_name: true, os_version: true, platform: true, region: true, version_name: true}`] - Type of data associated with a user.
 * @property {string} [transport=`http`] - Network transport mechanism used to send events. Options are 'http' and 'beacon'.
 * @property {boolean} [unsetParamsReferrerOnNewSession=`false`] -  If `false`, the existing `referrer` and `utm_parameter` values will be carried through each new session. If set to `true`, the `referrer` and `utm_parameter` user properties, which include `referrer`, `utm_source`, `utm_medium`, `utm_campaign`, `utm_term`, and `utm_content`, will be set to `null` upon instantiating a new session. Note: This only works if `includeReferrer` or `includeUtm` is set to `true`.
 * @property {string} [unsentKey=`amplitude_unsent`] - localStorage key that stores unsent events.
 * @property {string} [unsentIdentifyKey=`amplitude_unsent_identify`] - localStorage key that stores unsent identifies.
 * @property {number} [uploadBatchSize=`100`] -  The maximum number of events to send to the server per request.
 * @property {Object} [headers=`{ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }`] - Headers attached to an event(s) upload network request. Custom header properties are merged with this object.
 * @property {string} [serverZone] - For server zone related configuration, used for server api endpoint and dynamic configuration.
 * @property {boolean} [useDynamicConfig] - Enable dynamic configuration to find best server url for user.
 * @property {boolean} [serverZoneBasedApi] - To update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @property {number} [sessionId=`null`] - The custom Session ID for the current session. *Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * @property {string} [partnerId=`null`] - The partner id value
 */
var DEFAULT_OPTIONS$1 = {
  apiEndpoint: Constants.EVENT_LOG_URL,
  batchEvents: false,
  cookieExpiration: 365,
  // 12 months is for GDPR compliance
  cookieName: 'amplitude_id',
  // this is a deprecated option
  sameSiteCookie: 'Lax',
  // cookie privacy policy
  cookieForceUpgrade: false,
  deferInitialization: false,
  disableCookies: false,
  // this is a deprecated option
  deviceIdFromUrlParam: false,
  domain: '',
  eventUploadPeriodMillis: 30 * 1000,
  // 30s
  eventUploadThreshold: 30,
  forceHttps: true,
  includeFbclid: false,
  includeGclid: false,
  includeReferrer: false,
  includeUtm: false,
  ingestionMetadata: {
    sourceName: '',
    sourceVersion: ''
  },
  language: language.getLanguage(),
  library: {
    name: 'amplitude-js',
    version: version
  },
  logLevel: 'WARN',
  logAttributionCapturedEvent: false,
  optOut: false,
  onError: function onError() {},
  onExitPage: function onExitPage() {},
  onNewSessionStart: function onNewSessionStart() {},
  plan: {
    branch: '',
    source: '',
    version: '',
    versionId: ''
  },
  platform: 'Web',
  savedMaxCount: 1000,
  saveEvents: true,
  saveParamsReferrerOncePerSession: true,
  secureCookie: false,
  sessionTimeout: 30 * 60 * 1000,
  storage: Constants.STORAGE_DEFAULT,
  trackingOptions: {
    city: true,
    country: true,
    carrier: true,
    device_manufacturer: true,
    device_model: true,
    dma: true,
    ip_address: true,
    language: true,
    os_name: true,
    os_version: true,
    platform: true,
    region: true,
    version_name: true
  },
  transport: Constants.TRANSPORT_HTTP,
  unsetParamsReferrerOnNewSession: false,
  unsentKey: 'amplitude_unsent',
  unsentIdentifyKey: 'amplitude_unsent_identify',
  uploadBatchSize: 100,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Cross-Origin-Resource-Policy': 'cross-origin'
  },
  serverZone: AmplitudeServerZone.US,
  useDynamicConfig: false,
  serverZoneBasedApi: false,
  sessionId: null,
  partnerId: ''
};

/**
 * Dynamic Configuration
 * Find the best server url automatically based on app users' geo location.
 */
var ConfigManager = /*#__PURE__*/function () {
  function ConfigManager() {
    _classCallCheck(this, ConfigManager);
    if (!ConfigManager.instance) {
      this.ingestionEndpoint = Constants.EVENT_LOG_URL;
      ConfigManager.instance = this;
    }
    return ConfigManager.instance;
  }
  _createClass(ConfigManager, [{
    key: "refresh",
    value: function refresh(serverZone, forceHttps, callback) {
      var protocol = 'https';
      if (!forceHttps && 'https:' !== GlobalScope.location.protocol) {
        protocol = 'http';
      }
      var dynamicConfigUrl = protocol + '://' + getDynamicConfigApi(serverZone);
      var self = this;
      var isIE = GlobalScope.XDomainRequest ? true : false;
      if (isIE) {
        var xdr = new GlobalScope.XDomainRequest();
        xdr.open('GET', dynamicConfigUrl, true);
        xdr.onload = function () {
          var response = JSON.parse(xdr.responseText);
          self.ingestionEndpoint = response['ingestionEndpoint'];
          if (callback) {
            callback();
          }
        };
        xdr.onerror = function () {};
        xdr.ontimeout = function () {};
        xdr.onprogress = function () {};
        xdr.send();
      } else {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', dynamicConfigUrl, true);
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            self.ingestionEndpoint = response['ingestionEndpoint'];
            if (callback) {
              callback();
            }
          }
        };
        xhr.send();
      }
    }
  }]);
  return ConfigManager;
}();
var instance$1 = new ConfigManager();

/**
 * AmplitudeClient SDK API - instance constructor.
 * The Amplitude class handles creation of client instances, all you need to do is call amplitude.getInstance()
 * @constructor AmplitudeClient
 * @public
 * @example var amplitudeClient = new AmplitudeClient();
 */
var AmplitudeClient = function AmplitudeClient(instanceName) {
  if (!isBrowserEnv() && !utils.isWebWorkerEnvironment()) {
    utils.log.warn('amplitude-js will not work in a non-browser environment. If you are planning to add Amplitude to a node environment, please use @amplitude/node');
  }
  this._instanceName = utils.isEmptyString(instanceName) ? Constants.DEFAULT_INSTANCE : instanceName.toLowerCase();
  this._unsentEvents = [];
  this._unsentIdentifys = [];
  this.options = _objectSpread2(_objectSpread2({}, DEFAULT_OPTIONS$1), {}, {
    headers: _objectSpread2({}, DEFAULT_OPTIONS$1.headers),
    ingestionMetadata: _objectSpread2({}, DEFAULT_OPTIONS$1.ingestionMetadata),
    library: _objectSpread2({}, DEFAULT_OPTIONS$1.library),
    plan: _objectSpread2({}, DEFAULT_OPTIONS$1.plan),
    trackingOptions: _objectSpread2({}, DEFAULT_OPTIONS$1.trackingOptions)
  });
  this._q = []; // queue for proxied functions before script load
  this._sending = false;
  this._updateScheduled = false;
  this._onInitCallbacks = [];
  this._onNewSessionStartCallbacks = [];

  // event meta data
  this._eventId = 0;
  this._identifyId = 0;
  this._lastEventTime = null;
  this._newSession = false;
  // sequence used for by frontend for prioritizing event send retries
  this._sequenceNumber = 0;
  this._sessionId = null;
  this._isInitialized = false;

  // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
  this._connector = null;
  this._userAgent = typeof navigator !== 'undefined' && navigator && navigator.userAgent || null;
  this._ua = new UAParser(this._userAgent).getResult();
};
AmplitudeClient.prototype.Identify = Identify;
AmplitudeClient.prototype.Revenue = Revenue;

/**
 * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
 * This is required before any other methods can be called.
 * @public
 * @param {string} apiKey - The API key for your app.
 * @param {string} opt_userId - (optional) An identifier for this user.
 * @param {object} opt_config - (optional) Configuration options.
 * See [options.js](https://amplitude.github.io/Amplitude-JavaScript/Options) for a list of options and default values.
 * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
 * @example amplitudeClient.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
 */
AmplitudeClient.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
  var _this = this;
  if (type(apiKey) !== 'string' || utils.isEmptyString(apiKey)) {
    utils.log.error('Invalid apiKey. Please re-initialize with a valid apiKey');
    return;
  }
  try {
    // used to integrate with experiment SDK (client-side exposure tracking & real-time user properties)
    this._connector = AnalyticsConnector.getInstance(this._instanceName);
    _parseConfig(this.options, opt_config);
    if ((isBrowserEnv() || utils.isWebWorkerEnvironment()) && GlobalScope.Prototype !== undefined && Array.prototype.toJSON) {
      prototypeJsFix();
      utils.log.warn('Prototype.js injected Array.prototype.toJSON. Deleting Array.prototype.toJSON to prevent double-stringify');
    }
    if (this.options.cookieName !== DEFAULT_OPTIONS$1.cookieName) {
      utils.log.warn('The cookieName option is deprecated. We will be ignoring it for newer cookies');
    }
    if (this.options.serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
    this._refreshDynamicConfig();
    this.options.apiKey = apiKey;
    this._storageSuffix = '_' + apiKey + (this._instanceName === Constants.DEFAULT_INSTANCE ? '' : '_' + this._instanceName);
    this._storageSuffixV5 = apiKey.slice(0, 6);
    this._oldCookiename = this.options.cookieName + this._storageSuffix;
    this._unsentKey = this.options.unsentKey + this._storageSuffix;
    this._unsentIdentifyKey = this.options.unsentIdentifyKey + this._storageSuffix;
    this._cookieName = Constants.COOKIE_PREFIX + '_' + this._storageSuffixV5;
    this.cookieStorage = new cookieStorage().getStorage(this.options.disableCookies);
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie
    });
    this._metadataStorage = new MetadataStorage({
      storageKey: this._cookieName,
      disableCookies: this.options.disableCookies,
      expirationDays: this.options.cookieExpiration,
      domain: this.options.domain,
      secure: this.options.secureCookie,
      sameSite: this.options.sameSiteCookie,
      storage: this.options.storage
    });
    var hasOldCookie = !!this.cookieStorage.get(this._oldCookiename);
    var hasNewCookie = !!this._metadataStorage.load();
    this._useOldCookie = !hasNewCookie && hasOldCookie && !this.options.cookieForceUpgrade;
    var hasCookie = hasNewCookie || hasOldCookie;
    if (this.options.deferInitialization && !hasCookie) {
      this._deferInitialization(apiKey, opt_userId, opt_config, opt_callback);
      return;
    }
    this.options.domain = this.cookieStorage.options().domain;
    if (type(this.options.logLevel) === 'string') {
      utils.setLogLevel(this.options.logLevel);
    }
    var trackingOptions = _generateApiPropertiesTrackingConfig(this);
    this._apiPropertiesTrackingOptions = Object.keys(trackingOptions).length > 0 ? {
      tracking_options: trackingOptions
    } : {};
    if (this.options.cookieForceUpgrade && hasOldCookie) {
      if (!hasNewCookie) {
        _upgradeCookieData(this);
      }
      this.cookieStorage.remove(this._oldCookiename);
    }
    _loadCookieData(this);
    this._pendingReadStorage = true;
    var initFromStorage = function initFromStorage(storedDeviceId) {
      if (opt_config && opt_config.deviceId && !utils.validateDeviceId(opt_config.deviceId)) {
        utils.log.error("Invalid device ID rejected. Randomly generated UUID will be used instead of \"".concat(opt_config.deviceId, "\""));
        delete opt_config.deviceId;
      }
      _this.options.deviceId = _this._getInitialDeviceId(opt_config && opt_config.deviceId, storedDeviceId);
      _this.options.userId = type(opt_userId) === 'string' && !utils.isEmptyString(opt_userId) && opt_userId || type(opt_userId) === 'number' && opt_userId.toString() || _this.options.userId || null;
      var now = new Date().getTime();
      var startNewSession = !_this._sessionId || !_this._lastEventTime || now - _this._lastEventTime > _this.options.sessionTimeout || _this.options.sessionId;
      if (startNewSession) {
        if (_this.options.unsetParamsReferrerOnNewSession) {
          _this._unsetUTMParams();
        }
        _this._newSession = true;
        _this._sessionId = _this.options.sessionId || now;
        // reset this.options.sessionId to avoid re-usage
        // use instance.getSessionId() to get session id
        _this.options.sessionId = undefined;

        // only capture UTM params and referrer if new session
        if (_this.options.saveParamsReferrerOncePerSession) {
          _this._trackParamsAndReferrer();
        }
      }
      if (!_this.options.saveParamsReferrerOncePerSession) {
        _this._trackParamsAndReferrer();
      }

      // load unsent events and identifies before any attempt to log new ones
      if (_this.options.saveEvents) {
        _validateUnsentEventQueue(_this._unsentEvents);
        _validateUnsentEventQueue(_this._unsentIdentifys);
      }
      _this._lastEventTime = now;
      _saveCookieData(_this);
      _this._pendingReadStorage = false;
      _this._sendEventsIfReady(); // try sending unsent events

      for (var i = 0; i < _this._onInitCallbacks.length; i++) {
        _this._onInitCallbacks[i](_this);
      }
      _this._onInitCallbacks = [];
      _this._isInitialized = true;
      if (startNewSession) {
        _this._runNewSessionStartCallbacks();
      }
    };
    if (this.options.saveEvents) {
      this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentEvents);
      this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).map(function (event) {
        return {
          event: event
        };
      }).concat(this._unsentIdentifys);
    }
    if (opt_config && opt_config.onNewSessionStart) {
      this.onNewSessionStart(this.options.onNewSessionStart);
    }
    initFromStorage();
    this.runQueuedFunctions();
    if (type(opt_callback) === 'function') {
      opt_callback(this);
    }
    var onExitPage = this.options.onExitPage;
    if (type(onExitPage) === 'function' && GlobalScope.addEventListener) {
      if (!this.pageHandlersAdded) {
        this.pageHandlersAdded = true;
        var handleVisibilityChange = function handleVisibilityChange() {
          var prevTransport = _this.options.transport;
          _this.setTransport(Constants.TRANSPORT_BEACON);
          onExitPage();
          _this.setTransport(prevTransport);
        };

        // Monitoring just page exits because that is the most requested feature for now
        // "If you're specifically trying to detect page unload events, the pagehide event is the best option."
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
        GlobalScope.addEventListener('pagehide', function () {
          handleVisibilityChange();
        }, false);
      }
    }

    // Sets an event receiver to receive and forward exposure events from the experiment SDK.
    this._connector.eventBridge.setEventReceiver(function (event) {
      _this._logEvent(event.eventType, event.eventProperties, event.userProperties);
    });

    // Set the user ID and device ID in the core identity store to enable fetching variants.
    var editor = this._connector.identityStore.editIdentity();
    if (this.options.deviceId) {
      editor.setDeviceId(this.options.deviceId);
    }
    if (this.options.userId) {
      editor.setUserId(this.options.userId);
    }
    editor.commit();
  } catch (err) {
    utils.log.error(err);
    if (opt_config && type(opt_config.onError) === 'function') {
      opt_config.onError(err);
    }
  }
};
AmplitudeClient.prototype._runNewSessionStartCallbacks = function () {
  for (var i = 0; i < this._onNewSessionStartCallbacks.length; i++) {
    this._onNewSessionStartCallbacks[i](this);
  }
};
AmplitudeClient.prototype.deleteLowerLevelDomainCookies = function () {
  var host = utils.getHost();
  var cookieHost = this.options.domain && this.options.domain[0] === '.' ? this.options.domain.slice(1) : this.options.domain;
  if (!cookieHost || !utils.isWebWorkerEnvironment()) {
    return;
  }
  if (host !== cookieHost) {
    if (new RegExp(cookieHost + '$').test(host)) {
      var hostParts = host.split('.');
      var cookieHostParts = cookieHost.split('.');
      for (var i = hostParts.length; i > cookieHostParts.length; --i) {
        var deleteDomain = hostParts.slice(hostParts.length - i).join('.');
        baseCookie.set(this._cookieName, null, {
          domain: '.' + deleteDomain
        });
      }
      baseCookie.set(this._cookieName, null, {});
    }
  }
};
AmplitudeClient.prototype._getInitialDeviceId = function (configDeviceId, storedDeviceId) {
  if (configDeviceId) {
    return configDeviceId;
  }
  if (this.options.deviceIdFromUrlParam) {
    var deviceIdFromUrlParam = this._getDeviceIdFromUrlParam(this._getUrlParams());
    if (deviceIdFromUrlParam) {
      return deviceIdFromUrlParam;
    }
  }
  if (this.options.deviceId) {
    return this.options.deviceId;
  }
  if (storedDeviceId) {
    return storedDeviceId;
  }
  return base64Id();
};

// validate properties for unsent events
var _validateUnsentEventQueue = function _validateUnsentEventQueue(queue) {
  for (var i = 0; i < queue.length; i++) {
    var userProperties = queue[i].event.user_properties;
    var eventProperties = queue[i].event.event_properties;
    var groups = queue[i].event.groups;
    queue[i].event.user_properties = utils.validateProperties(userProperties);
    queue[i].event.event_properties = utils.validateProperties(eventProperties);
    queue[i].event.groups = utils.validateGroups(groups);
  }
};

/**
 * @private
 */
AmplitudeClient.prototype._trackParamsAndReferrer = function _trackParamsAndReferrer() {
  var utmProperties;
  var referrerProperties;
  var gclidProperties;
  var fbclidProperties;
  if (this.options.includeUtm) {
    utmProperties = this._initUtmData();
  }
  if (this.options.includeReferrer) {
    referrerProperties = this._saveReferrer(this._getReferrer());
  }
  if (this.options.includeGclid) {
    gclidProperties = this._saveGclid(this._getUrlParams());
  }
  if (this.options.includeFbclid) {
    fbclidProperties = this._saveFbclid(this._getUrlParams());
  }
  if (this.options.logAttributionCapturedEvent) {
    var attributionProperties = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, utmProperties), referrerProperties), gclidProperties), fbclidProperties);
    if (Object.keys(attributionProperties).length > 0) {
      this.logEvent(Constants.ATTRIBUTION_EVENT, attributionProperties);
    }
  }
};

/**
 * Parse and validate user specified config values and overwrite existing option value
 * DEFAULT_OPTIONS provides list of all config keys that are modifiable, as well as expected types for values
 * @private
 */
var _parseConfig = function _parseConfig(options, config) {
  if (type(config) !== 'object') {
    return;
  }

  // Add exception in headers
  var freeFormObjectKeys = new Set(['headers']);
  var zeroAllowedKeys = new Set(['eventUploadPeriodMillis']);

  // validates config value is defined, is the correct type, and some additional value sanity checks
  var parseValidateAndLoad = function parseValidateAndLoad(key) {
    if (!Object.prototype.hasOwnProperty.call(options, key)) {
      return; // skip bogus config values
    }
    var inputValue = config[key];
    var expectedType = type(options[key]);
    if (key === 'transport' && !utils.validateTransport(inputValue)) {
      return;
    } else if (key === 'sessionId' && inputValue !== null) {
      options[key] = utils.validateSessionId(inputValue) ? inputValue : null;
      return;
    } else if (!utils.validateInput(inputValue, key + ' option', expectedType)) {
      return;
    }
    if (expectedType === 'boolean') {
      options[key] = !!inputValue;
    } else if (expectedType === 'string' && !utils.isEmptyString(inputValue) || expectedType === 'number' && (inputValue > 0 || inputValue === 0 && zeroAllowedKeys.has(key)) || expectedType === 'function') {
      options[key] = inputValue;
    } else if (expectedType === 'object') {
      _parseConfig(options[key], inputValue);
    }
  };
  for (var key in config) {
    if (freeFormObjectKeys.has(key)) {
      options[key] = _objectSpread2(_objectSpread2({}, options[key]), config[key]);
    } else if (Object.prototype.hasOwnProperty.call(config, key)) {
      parseValidateAndLoad(key);
    }
  }
};

/**
 * Run functions queued up by proxy loading snippet
 * @private
 */
AmplitudeClient.prototype.runQueuedFunctions = function () {
  var queue = this._q;
  this._q = [];
  for (var i = 0; i < queue.length; i++) {
    var fn = this[queue[i][0]];
    if (type(fn) === 'function') {
      fn.apply(this, queue[i].slice(1));
    }
  }
};

/**
 * Check that the apiKey is set before calling a function. Logs a warning message if not set.
 * @private
 */
AmplitudeClient.prototype._apiKeySet = function _apiKeySet(methodName) {
  if (utils.isEmptyString(this.options.apiKey)) {
    utils.log.error('Invalid apiKey. Please set a valid apiKey with init() before calling ' + methodName);
    return false;
  }
  return true;
};

/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */
AmplitudeClient.prototype._loadSavedUnsentEvents = function _loadSavedUnsentEvents(unsentKey) {
  var savedUnsentEventsString = this._getFromStorage(localStorage$1$1, unsentKey);
  var unsentEvents = this._parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey);
  this._setInStorage(localStorage$1$1, unsentKey, JSON.stringify(unsentEvents));
  return unsentEvents;
};

/**
 * Load saved events from localStorage. JSON deserializes event array. Handles case where string is corrupted.
 * @private
 */
AmplitudeClient.prototype._parseSavedUnsentEventsString = function _parseSavedUnsentEventsString(savedUnsentEventsString, unsentKey) {
  if (utils.isEmptyString(savedUnsentEventsString)) {
    return []; // new app, does not have any saved events
  }
  if (type(savedUnsentEventsString) === 'string') {
    try {
      var events = JSON.parse(savedUnsentEventsString);
      if (type(events) === 'array') {
        // handle case where JSON dumping of unsent events is corrupted
        return events;
      }
    } catch (e) {} /* eslint-disable-line no-empty */
  }
  utils.log.error('Unable to load ' + unsentKey + ' events. Restart with a new empty queue.');
  return [];
};

/**
 * Returns true if a new session was created during initialization, otherwise false.
 * @public
 * @return {boolean} Whether a new session was created during initialization.
 */
AmplitudeClient.prototype.isNewSession = function isNewSession() {
  return this._newSession;
};

/**
 * Add callbacks to call after init. Useful for users who load Amplitude through a snippet.
 * @public
 */
AmplitudeClient.prototype.onInit = function onInit(callback) {
  if (this._isInitialized) {
    callback(this);
  } else {
    this._onInitCallbacks.push(callback);
  }
};

/**
 * Add callbacks to call after new session start.
 * @public
 */
AmplitudeClient.prototype.onNewSessionStart = function onNewSessionStart(callback) {
  this._onNewSessionStartCallbacks.push(callback);
};

/**
 * Returns the id of the current session.
 * @public
 * @return {number} Id of the current session.
 */
AmplitudeClient.prototype.getSessionId = function getSessionId() {
  return this._sessionId;
};

/**
 * Increments the eventId and returns it.
 * @private
 */
AmplitudeClient.prototype.nextEventId = function nextEventId() {
  this._eventId++;
  return this._eventId;
};

/**
 * Increments the identifyId and returns it.
 * @private
 */
AmplitudeClient.prototype.nextIdentifyId = function nextIdentifyId() {
  this._identifyId++;
  return this._identifyId;
};

/**
 * Increments the sequenceNumber and returns it.
 * @private
 */
AmplitudeClient.prototype.nextSequenceNumber = function nextSequenceNumber() {
  this._sequenceNumber++;
  return this._sequenceNumber;
};

/**
 * Returns the total count of unsent events and identifys
 * @private
 */
AmplitudeClient.prototype._unsentCount = function _unsentCount() {
  return this._unsentEvents.length + this._unsentIdentifys.length;
};

/**
 * Send events if ready. Returns true if events are sent.
 * @private
 */
AmplitudeClient.prototype._sendEventsIfReady = function _sendEventsIfReady() {
  if (this._unsentCount() === 0) {
    return false;
  }

  // if batching disabled, send any unsent events immediately
  if (!this.options.batchEvents) {
    this.sendEvents();
    return true;
  }

  // if batching enabled, check if min threshold met for batch size
  if (this._unsentCount() >= this.options.eventUploadThreshold) {
    this.sendEvents();
    return true;
  }

  // if beacon transport is activated, send events immediately
  // because there is no way to retry them later
  if (this.options.transport === Constants.TRANSPORT_BEACON) {
    this.sendEvents();
    return true;
  }

  // otherwise schedule an upload after 30s
  if (!this._updateScheduled) {
    // make sure we only schedule 1 upload
    this._updateScheduled = true;
    setTimeout(function () {
      this._updateScheduled = false;
      this.sendEvents();
    }.bind(this), this.options.eventUploadPeriodMillis);
  }
  return false; // an upload was scheduled, no events were uploaded
};

/**
 * Clears any stored events and metadata. Storage is then re-created on next event sending.
 * @public
 * @return {boolean} True if metadata was cleared, false if none existed
 */
AmplitudeClient.prototype.clearStorage = function clearStorage() {
  return this._metadataStorage.clear();
};

/**
 * Helper function to fetch values from storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */
AmplitudeClient.prototype._getFromStorage = function _getFromStorage(storage, key) {
  return storage.getItem(key + this._storageSuffix);
};

/**
 * Helper function to set values in storage
 * Storage argument allows for localStoraoge and sessionStoraoge
 * @private
 */
AmplitudeClient.prototype._setInStorage = function _setInStorage(storage, key, value) {
  storage.setItem(key + this._storageSuffix, value);
};

/**
 * Fetches deviceId, userId, event meta data from amplitude cookie
 * @private
 */
var _loadCookieData = function _loadCookieData(scope) {
  if (!scope._useOldCookie) {
    var props = scope._metadataStorage.load();
    if (type(props) === 'object') {
      _loadCookieDataProps(scope, props);
    }
    return;
  }
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);
  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);
    return;
  }
};
var _upgradeCookieData = function _upgradeCookieData(scope) {
  var cookieData = scope.cookieStorage.get(scope._oldCookiename);
  if (type(cookieData) === 'object') {
    _loadCookieDataProps(scope, cookieData);
    _saveCookieData(scope);
  }
};
var _loadCookieDataProps = function _loadCookieDataProps(scope, cookieData) {
  if (cookieData.deviceId) {
    scope.options.deviceId = cookieData.deviceId;
  }
  if (cookieData.userId) {
    scope.options.userId = cookieData.userId;
  }
  if (cookieData.optOut !== null && cookieData.optOut !== undefined) {
    // Do not clobber config opt out value if cookieData has optOut as false
    if (cookieData.optOut !== false) {
      scope.options.optOut = cookieData.optOut;
    }
  }
  if (cookieData.sessionId) {
    scope._sessionId = parseInt(cookieData.sessionId, 10);
  }
  if (cookieData.lastEventTime) {
    scope._lastEventTime = parseInt(cookieData.lastEventTime, 10);
  }
  if (cookieData.eventId) {
    scope._eventId = parseInt(cookieData.eventId, 10);
  }
  if (cookieData.identifyId) {
    scope._identifyId = parseInt(cookieData.identifyId, 10);
  }
  if (cookieData.sequenceNumber) {
    scope._sequenceNumber = parseInt(cookieData.sequenceNumber, 10);
  }
};

/**
 * Saves deviceId, userId, event meta data to amplitude cookie
 * @private
 */
var _saveCookieData = function _saveCookieData(scope) {
  var cookieData = {
    deviceId: scope.options.deviceId,
    userId: scope.options.userId,
    optOut: scope.options.optOut,
    sessionId: scope._sessionId,
    lastEventTime: scope._lastEventTime,
    eventId: scope._eventId,
    identifyId: scope._identifyId,
    sequenceNumber: scope._sequenceNumber
  };
  if (scope._useOldCookie) {
    scope.cookieStorage.set(scope.options.cookieName + scope._storageSuffix, cookieData);
  } else {
    scope._metadataStorage.save(cookieData);
  }
};

/**
 * Parse the utm properties out of cookies and query for adding to user properties.
 * @private
 */
AmplitudeClient.prototype._initUtmData = function _initUtmData(queryParams, cookieParams) {
  queryParams = queryParams || this._getUrlParams();
  cookieParams = cookieParams || this.cookieStorage.get('__utmz');
  var utmProperties = getUtmData$1(cookieParams, queryParams);
  _sendParamsReferrerUserProperties(this, utmProperties);
  return utmProperties;
};

/**
 * Unset the utm params from the Amplitude instance and update the identify.
 * @private
 */
AmplitudeClient.prototype._unsetUTMParams = function _unsetUTMParams() {
  var identify = new Identify();
  identify.unset(Constants.REFERRER);
  identify.unset(Constants.REFERRING_DOMAIN);
  identify.unset(Constants.UTM_SOURCE);
  identify.unset(Constants.UTM_MEDIUM);
  identify.unset(Constants.UTM_CAMPAIGN);
  identify.unset(Constants.UTM_TERM);
  identify.unset(Constants.UTM_CONTENT);
  this.identify(identify);
};

/**
 * The calling function should determine when it is appropriate to send these user properties. This function
 * will no longer contain any session storage checking logic.
 * @private
 */
var _sendParamsReferrerUserProperties = function _sendParamsReferrerUserProperties(scope, userProperties) {
  if (type(userProperties) !== 'object' || Object.keys(userProperties).length === 0) {
    return;
  }

  // setOnce the initial user properties
  var identify = new Identify();
  for (var key in userProperties) {
    if (Object.prototype.hasOwnProperty.call(userProperties, key)) {
      identify.setOnce('initial_' + key, userProperties[key]);
      identify.set(key, userProperties[key]);
    }
  }
  scope.identify(identify);
};

/**
 * @private
 */
AmplitudeClient.prototype._getReferrer = function _getReferrer() {
  var urlRefer = this._getReferrerFromUrlParam(this._getUrlParams());
  if (urlRefer) return urlRefer;else return typeof document !== 'undefined' ? document.referrer : '';
};

/**
 * @private
 */
AmplitudeClient.prototype._getUrlParams = function _getUrlParams() {
  return GlobalScope.location.search;
};

/**
 * Try to fetch Google Gclid from url params.
 * @private
 */
AmplitudeClient.prototype._saveGclid = function _saveGclid(urlParams) {
  var gclid = utils.getQueryParam('gclid', urlParams);
  if (utils.isEmptyString(gclid)) {
    return;
  }
  var gclidProperties = {
    gclid: gclid
  };
  _sendParamsReferrerUserProperties(this, gclidProperties);
  return gclidProperties;
};

/**
 * Try to fetch Facebook Fbclid from url params.
 * @private
 */
AmplitudeClient.prototype._saveFbclid = function _saveFbclid(urlParams) {
  var fbclid = utils.getQueryParam('fbclid', urlParams);
  if (utils.isEmptyString(fbclid)) {
    return;
  }
  var fbclidProperties = {
    fbclid: fbclid
  };
  _sendParamsReferrerUserProperties(this, fbclidProperties);
  return fbclidProperties;
};

/**
 * Try to fetch Amplitude device id from url params.
 * @private
 */
AmplitudeClient.prototype._getDeviceIdFromUrlParam = function _getDeviceIdFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_DEVICE_ID_PARAM, urlParams);
};

/**
 * Try to fetch referrer from url params.
 * @private
 */
AmplitudeClient.prototype._getReferrerFromUrlParam = function _getReferrerFromUrlParam(urlParams) {
  return utils.getQueryParam(Constants.AMP_REFERRER_PARAM, urlParams);
};

/**
 * Parse the domain from referrer info
 * @private
 */
AmplitudeClient.prototype._getReferringDomain = function _getReferringDomain(referrer) {
  if (utils.isEmptyString(referrer)) {
    return null;
  }
  var parts = referrer.split('/');
  if (parts.length >= 3) {
    return parts[2];
  }
  return null;
};

/**
 * Fetch the referrer information, parse the domain and send.
 * Since user properties are propagated on the server, only send once per session, don't need to send with every event
 * @private
 */
AmplitudeClient.prototype._saveReferrer = function _saveReferrer(referrer) {
  if (utils.isEmptyString(referrer)) {
    return;
  }
  var referrerInfo = {
    referrer: referrer,
    referring_domain: this._getReferringDomain(referrer)
  };
  _sendParamsReferrerUserProperties(this, referrerInfo);
  return referrerInfo;
};

/**
 * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
 * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
 * @private
 */
AmplitudeClient.prototype.saveEvents = function saveEvents() {
  try {
    var serializedUnsentEvents = JSON.stringify(this._unsentEvents.map(function (_ref) {
      var event = _ref.event;
      return event;
    }));
    this._setInStorage(localStorage$1$1, this.options.unsentKey, serializedUnsentEvents);
  } catch (e) {} /* eslint-disable-line no-empty */

  try {
    var serializedIdentifys = JSON.stringify(this._unsentIdentifys.map(function (unsentIdentify) {
      return unsentIdentify.event;
    }));
    this._setInStorage(localStorage$1$1, this.options.unsentIdentifyKey, serializedIdentifys);
  } catch (e) {} /* eslint-disable-line no-empty */
};

/**
 * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
 * @public
 * @param {string} domain to set.
 * @example amplitudeClient.setDomain('.amplitude.com');
 */
AmplitudeClient.prototype.setDomain = function setDomain(domain) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDomain'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(domain, 'domain', 'string')) {
    return;
  }
  try {
    this.cookieStorage.options({
      expirationDays: this.options.cookieExpiration,
      secure: this.options.secureCookie,
      domain: domain,
      sameSite: this.options.sameSiteCookie
    });
    this.options.domain = this.cookieStorage.options().domain;
    _loadCookieData(this);
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets an identifier for the current user.
 * @public
 * @param {string} userId - identifier to set. Can be null.
 * @param {boolean} startNewSession - (optional) if start a new session or not
 * @example amplitudeClient.setUserId('joe@gmail.com');
 */
AmplitudeClient.prototype.setUserId = function setUserId(userId) {
  var startNewSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!utils.validateInput(startNewSession, 'startNewSession', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.userId = userId !== undefined && userId !== null && '' + userId || null;
    if (startNewSession) {
      if (this.options.unsetParamsReferrerOnNewSession) {
        this._unsetUTMParams();
      }
      this._newSession = true;
      this._sessionId = new Date().getTime();
      this._runNewSessionStartCallbacks();

      // only capture UTM params and referrer if new session
      if (this.options.saveParamsReferrerOncePerSession) {
        this._trackParamsAndReferrer();
      }
    }
    _saveCookieData(this);

    // Update core identity store to propagate new user info
    // to experiment SDK and trigger a fetch if the ID has changed.
    if (this._connector) {
      this._connector.identityStore.editIdentity().setUserId(this.options.userId).commit();
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Add user to a group or groups. You need to specify a groupType and groupName(s).
 *
 * For example you can group people by their organization.
 * In that case, groupType is "orgId" and groupName would be the actual ID(s).
 * groupName can be a string or an array of strings to indicate a user in multiple gruups.
 * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
 *
 * Note: this will also set groupType: groupName as a user property.
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
 * @public
 * @param {string} groupType - the group type (ex: orgId)
 * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
 * @example amplitudeClient.setGroup('orgId', 15); // this adds the current user to orgId 15.
 */
AmplitudeClient.prototype.setGroup = function (groupType, groupName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setGroup'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('setGroup()') || !utils.validateInput(groupType, 'groupType', 'string') || utils.isEmptyString(groupType)) {
    return;
  }
  var groups = {};
  groups[groupType] = groupName;
  var identify = new Identify().set(groupType, groupName);
  this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify.userPropertiesOperations, groups, null, null, null);
};

/**
 * Sets whether to opt current user out of tracking.
 * @public
 * @param {boolean} enable - if true then no events will be logged or sent.
 * @example: amplitude.setOptOut(true);
 */
AmplitudeClient.prototype.setOptOut = function setOptOut(enable) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setOptOut'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(enable, 'enable', 'boolean')) {
    return;
  }
  try {
    this.options.optOut = enable;
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Set a custom Session ID for the current session.
 * Note: This is not recommended unless you know what you are doing because the Session ID of a session is utilized for all session metrics in Amplitude.
 * The Session ID to set for the current session must be in milliseconds since epoch (Unix Timestamp).
 * @public
 * @param {int} sessionId to set.
 * @example amplitudeClient.setSessionId(1622158968000);
 */
AmplitudeClient.prototype.setSessionId = function setSessionId(sessionId) {
  if (!utils.validateInput(sessionId, 'sessionId', 'number')) {
    return;
  }
  try {
    this._sessionId = sessionId;
    _saveCookieData(this);
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the current Unix timestamp as the new Session ID for the instance.
 * @public
 * @example amplitudeClient.resetSessionId();
 */
AmplitudeClient.prototype.resetSessionId = function resetSessionId() {
  this.setSessionId(new Date().getTime());
};

/**
 * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
 * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
 * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
 * This uses src/uuid.js to regenerate the deviceId.
 * @public
 */
AmplitudeClient.prototype.regenerateDeviceId = function regenerateDeviceId() {
  if (this._shouldDeferCall()) {
    return this._q.push(['regenerateDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  this.setDeviceId(base64Id());
};

/**
 * Sets a custom deviceId for current user. **Values may not have `.` inside them**
 * Note: this is not recommended unless you know what you are doing (like if you have your own system for managing deviceIds).
 * Make sure the deviceId you set is sufficiently unique
 * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
 * @public
 * @param {string} deviceId - custom deviceId for current user.
 * @example amplitudeClient.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
 */
AmplitudeClient.prototype.setDeviceId = function setDeviceId(deviceId) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateDeviceId(deviceId)) {
    return;
  }
  try {
    if (!utils.isEmptyString(deviceId)) {
      this.options.deviceId = '' + deviceId;
      _saveCookieData(this);

      // Update core identity store to propagate new user info
      // to experiment SDK and trigger a fetch if the ID has changed.
      if (this._connector) {
        this._connector.identityStore.editIdentity().setDeviceId(this.options.deviceId).commit();
      }
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the network transport type for events. Typically used to set to 'beacon'
 * on an end-of-lifecycle event handler such as `onpagehide` or `onvisibilitychange`
 * @public
 * @param {string} transport - transport mechanism to use for events. Must be one of `http` or `beacon`.
 * @example amplitudeClient.setTransport('beacon');
 */
AmplitudeClient.prototype.setTransport = function setTransport(transport) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setTransport'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateTransport(transport)) {
    return;
  }
  this.options.transport = transport;
};

/**
 * Sets user properties for the current user.
 * @public
 * @param {object} - object with string keys and values for the user properties to set.
 * @param {boolean} - DEPRECATED opt_replace: in earlier versions of the JS SDK the user properties object was kept in
 * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
 * @example amplitudeClient.setUserProperties({'gender': 'female', 'sign_up_complete': true})
 */
AmplitudeClient.prototype.setUserProperties = function setUserProperties(userProperties) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('setUserProperties()') || !utils.validateInput(userProperties, 'userProperties', 'object')) {
    return;
  }
  // sanitize the userProperties dict before converting into identify
  var sanitized = utils.truncate(utils.validateProperties(userProperties));
  if (Object.keys(sanitized).length === 0) {
    return;
  }

  // convert userProperties into an identify call
  var identify = new Identify();
  for (var property in sanitized) {
    if (Object.prototype.hasOwnProperty.call(sanitized, property)) {
      identify.set(property, sanitized[property]);
    }
  }
  this.identify(identify);
};

/**
 * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
 * @public
 * @example amplitudeClient.clearUserProperties();
 */
AmplitudeClient.prototype.clearUserProperties = function clearUserProperties() {
  if (this._shouldDeferCall()) {
    return this._q.push(['clearUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('clearUserProperties()')) {
    return;
  }
  var identify = new Identify();
  identify.clearAll();
  this.identify(identify);
};

/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 * @private
 */
var _convertProxyObjectToRealObject = function _convertProxyObjectToRealObject(instance, proxy) {
  for (var i = 0; i < proxy._q.length; i++) {
    var fn = instance[proxy._q[i][0]];
    if (type(fn) === 'function') {
      fn.apply(instance, proxy._q[i].slice(1));
    }
  }
  return instance;
};

/**
 * Send an identify call containing user property operations to Amplitude servers.
 * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
 * reference page for more information on the Identify API and user property operations.
 * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
 * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
 * Note: the server response code and response body from the identify event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example
 * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
 * amplitude.identify(identify);
 */
AmplitudeClient.prototype.identify = function (identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['identify'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('identify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });
    return;
  }

  // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }
  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.IDENTIFY_EVENT, null, null, identify_obj.userPropertiesOperations, null, null, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No user property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};
AmplitudeClient.prototype.groupIdentify = function (group_type, group_name, identify_obj, opt_callback, opt_error_callback, outOfSession) {
  if (this._shouldDeferCall()) {
    return this._q.push(['groupIdentify'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('groupIdentify()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key is not set'
    });
    return;
  }
  if (!utils.validateInput(group_type, 'group_type', 'string') || utils.isEmptyString(group_type)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group type'
    });
    return;
  }
  if (group_name === null || group_name === undefined) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid group name'
    });
    return;
  }

  // if identify input is a proxied object created by the async loading snippet, convert it into an identify object
  if (type(identify_obj) === 'object' && Object.prototype.hasOwnProperty.call(identify_obj, '_q')) {
    identify_obj = _convertProxyObjectToRealObject(new Identify(), identify_obj);
  }
  if (identify_obj instanceof Identify) {
    // only send if there are operations
    if (Object.keys(identify_obj.userPropertiesOperations).length > 0) {
      return this._logEvent(Constants.GROUP_IDENTIFY_EVENT, null, null, null, _defineProperty({}, group_type, group_name), identify_obj.userPropertiesOperations, null, opt_callback, opt_error_callback, outOfSession);
    } else {
      _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
        reason: 'No group property operations'
      });
    }
  } else {
    utils.log.error('Invalid identify input type. Expected Identify object but saw ' + type(identify_obj));
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid identify input type'
    });
  }
};

/**
 * Set a versionName for your application.
 * @public
 * @param {string} versionName - The version to set for your application.
 * @example amplitudeClient.setVersionName('1.12.3');
 */
AmplitudeClient.prototype.setVersionName = function setVersionName(versionName) {
  if (this._shouldDeferCall()) {
    return this._q.push(['setVersionName'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!utils.validateInput(versionName, 'versionName', 'string')) {
    return;
  }
  this.options.versionName = versionName;
};

/**
 * Private logEvent method. Keeps apiProperties from being publicly exposed.
 * @private
 */
AmplitudeClient.prototype._logEvent = function _logEvent(eventType, eventProperties, apiProperties, userProperties, groups, groupProperties, timestamp, callback, errorCallback, outOfSession) {
  _loadCookieData(this); // reload cookie before each log event to sync event meta-data between windows and tabs

  if (!eventType) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });
    return;
  }
  if (this.options.optOut) {
    _logErrorsWithCallbacks(callback, errorCallback, 0, 'No request sent', {
      reason: 'optOut is set to true'
    });
    return;
  }
  try {
    var eventId;
    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      eventId = this.nextIdentifyId();
    } else {
      eventId = this.nextEventId();
    }
    var sequenceNumber = this.nextSequenceNumber();
    var eventTime = type(timestamp) === 'number' ? timestamp : new Date().getTime();
    if (outOfSession) {
      this._sessionId = -1;
    } else if (!this._sessionId || !this._lastEventTime || eventTime - this._lastEventTime > this.options.sessionTimeout) {
      this._sessionId = eventTime;
      this._runNewSessionStartCallbacks();
    }
    this._lastEventTime = eventTime;
    _saveCookieData(this);
    var osName = this._ua.browser.name;
    var osVersion = this._ua.browser.major;
    var deviceModel = this._ua.device.model || this._ua.os.name;
    var deviceVendor = this._ua.device.vendor;
    userProperties = userProperties || {};
    var trackingOptions = _objectSpread2({}, this._apiPropertiesTrackingOptions);
    apiProperties = _objectSpread2(_objectSpread2({}, apiProperties || {}), trackingOptions);
    eventProperties = eventProperties || {};
    groups = groups || {};
    groupProperties = groupProperties || {};
    var event = {
      device_id: this.options.deviceId,
      user_id: this.options.userId,
      timestamp: eventTime,
      event_id: eventId,
      session_id: this._sessionId || -1,
      event_type: eventType,
      version_name: this.options.versionName || null,
      platform: _shouldTrackField(this, 'platform') ? this.options.platform : null,
      os_name: _shouldTrackField(this, 'os_name') ? osName || null : null,
      os_version: _shouldTrackField(this, 'os_version') ? osVersion || null : null,
      device_model: _shouldTrackField(this, 'device_model') ? deviceModel || null : null,
      device_manufacturer: _shouldTrackField(this, 'device_manufacturer') ? deviceVendor || null : null,
      language: _shouldTrackField(this, 'language') ? this.options.language : null,
      api_properties: apiProperties,
      event_properties: utils.truncate(utils.validateProperties(eventProperties)),
      user_properties: utils.truncate(utils.validateProperties(userProperties)),
      uuid: uuid(),
      library: this.options.library,
      sequence_number: sequenceNumber,
      // for ordering events and identifys
      groups: utils.truncate(utils.validateGroups(groups)),
      group_properties: utils.truncate(utils.validateProperties(groupProperties)),
      user_agent: this._userAgent,
      partner_id: this.options.partnerId || null
    };
    if (_isObservePlanSet(this)) {
      event.plan = {
        branch: this.options.plan.branch || undefined,
        source: this.options.plan.source || undefined,
        version: this.options.plan.version || undefined,
        versionId: this.options.plan.versionId || undefined
      };
    }
    if (_isIngestionMetadataSet(this)) {
      event.ingestion_metadata = {
        source_name: this.options.ingestionMetadata.sourceName || undefined,
        source_version: this.options.ingestionMetadata.sourceVersion || undefined
      };
    }
    if (eventType === Constants.IDENTIFY_EVENT || eventType === Constants.GROUP_IDENTIFY_EVENT) {
      this._unsentIdentifys.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });
      this._limitEventsQueued(this._unsentIdentifys);
    } else {
      this._unsentEvents.push({
        event: event,
        callback: callback,
        errorCallback: errorCallback
      });
      this._limitEventsQueued(this._unsentEvents);
    }
    if (this.options.saveEvents) {
      this.saveEvents();
    }
    this._sendEventsIfReady();

    // In the case of an identify event, update the core user store so the experiment SDK can fetch new variants and
    // utilize user properties in real time.
    if (eventType === Constants.IDENTIFY_EVENT && this._connector) {
      this._connector.identityStore.editIdentity().updateUserProperties(utils.truncate(utils.validateProperties(userProperties))).commit();
    }
    return eventId;
  } catch (e) {
    utils.log.error(e);
  }
};
var _isObservePlanSet = function _isObservePlanSet(scope) {
  return scope.options.plan && (scope.options.plan.source || scope.options.plan.branch || scope.options.plan.version || scope.options.plan.versionId);
};
var _isIngestionMetadataSet = function _isIngestionMetadataSet(scope) {
  return scope.options.ingestionMetadata && (scope.options.ingestionMetadata.sourceName || scope.options.ingestionMetadata.sourceVersion);
};
var _shouldTrackField = function _shouldTrackField(scope, field) {
  return !!scope.options.trackingOptions[field];
};
var _generateApiPropertiesTrackingConfig = function _generateApiPropertiesTrackingConfig(scope) {
  // to limit size of config payload, only send fields that have been disabled
  var fields = ['city', 'country', 'dma', 'ip_address', 'region'];
  var config = {};
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    if (!_shouldTrackField(scope, field)) {
      config[field] = false;
    }
  }
  return config;
};

/**
 * Remove old events from the beginning of the array if too many have accumulated. Default limit is 1000 events.
 * @private
 */
AmplitudeClient.prototype._limitEventsQueued = function _limitEventsQueued(queue) {
  if (queue.length > this.options.savedMaxCount) {
    var deletedEvents = queue.splice(0, queue.length - this.options.savedMaxCount);
    deletedEvents.forEach(function (event) {
      _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
        reason: 'Event dropped because options.savedMaxCount exceeded. User may be offline or have a content blocker'
      });
    });
  }
};

/**
 * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
 * and the server response code and response body from the upload request are passed to the callback function.
 * @callback Amplitude~eventCallback
 * @param {number} responseCode - Server response code for the event / identify upload request.
 * @param {string} responseBody - Server response body for the event / identify upload request.
 * @param {object} details - (optional) Additional information associated with sending event.
 */

/**
 * Log an event with eventType and eventProperties
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if this event is out of session or not
 * @example amplitudeClient.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
 */
AmplitudeClient.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEvent'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  return this.logEventWithTimestamp(eventType, eventProperties, null, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Log an event with eventType and eventProperties and a custom timestamp
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {number} timestamp - (optional) the custom timestamp as milliseconds since epoch.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {boolean} outOfSession - (optional) if out of the sessioin or not
 * @example amplitudeClient.logEventWithTimestamp('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15}, Date.now());
 */
AmplitudeClient.prototype.logEventWithTimestamp = function logEvent(eventType, eventProperties, timestamp, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithTimestamp'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logEvent()')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return -1;
  }
  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });
    return -1;
  }
  if (utils.isEmptyString(eventType)) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Missing eventType'
    });
    return -1;
  }
  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(opt_callback, opt_error_callback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }
  return this._logEvent(eventType, eventProperties, null, null, null, null, timestamp, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
 * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
 * (unless you explicitly set it with setGroup).
 *
 * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
 * about groups and Count by Distinct on the Amplitude platform.
 * @public
 * @param {string} eventType - name of event
 * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
 * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
 * groupName can be a string or an array of strings.
 * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @param {Amplitude~eventCallback} opt_error_callback - (optional) a callback function to run after the event logging
 * fails. The failure can be from the request being malformed or from a network failure
 * Note: the server response code and response body from the event upload are passed to the callback function.
 * @example amplitudeClient.logEventWithGroups('Clicked Button', null, {'orgId': 24});
 */
AmplitudeClient.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback, opt_error_callback) {
  var outOfSession = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (this._shouldDeferCall()) {
    return this._q.push(['logEventWithGroups'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logEventWithGroups()')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return -1;
  }
  if (!utils.validateInput(eventType, 'eventType', 'string')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid type for eventType'
    });
    return -1;
  }
  if (!utils.validateInput(outOfSession, 'outOfSession', 'boolean')) {
    _logErrorsWithCallbacks(event.callback, event.errorCallback, 0, 'No request sent', {
      reason: 'Invalid outOfSession value'
    });
  }
  return this._logEvent(eventType, eventProperties, null, null, groups, null, null, opt_callback, opt_error_callback, outOfSession);
};

/**
 * Test that n is a number or a numeric value.
 * @private
 */
var _isNumber = function _isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/**
 * Handles errors that are sent to both callbacks
 * @private
 */
var _logErrorsWithCallbacks = function _logErrorsWithCallbacks(opt_callback, opt_error_callback, status, response, details) {
  if (type(opt_callback) === 'function') {
    opt_callback(status, response, details);
  }
  if (type(opt_error_callback) === 'function') {
    opt_error_callback(status, response, details);
  }
};

/**
 * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
 * revenueType and event properties.
 *
 * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
 * reference page for more information on the Revenue interface and logging revenue.
 * @public
 * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
 * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
 * amplitude.logRevenueV2(revenue);
 */
AmplitudeClient.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
  if (this._shouldDeferCall()) {
    return this._q.push(['logRevenueV2'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  if (!this._apiKeySet('logRevenueV2()')) {
    return;
  }

  // if revenue input is a proxied object created by the async loading snippet, convert it into an revenue object
  if (type(revenue_obj) === 'object' && Object.prototype.hasOwnProperty.call(revenue_obj, '_q')) {
    revenue_obj = _convertProxyObjectToRealObject(new Revenue(), revenue_obj);
  }
  if (revenue_obj instanceof Revenue) {
    // only send if revenue is valid
    if (revenue_obj && revenue_obj._isValidRevenue()) {
      return this.logEvent(Constants.REVENUE_EVENT, revenue_obj._toJSONObject());
    }
  } else {
    utils.log.error('Invalid revenue input type. Expected Revenue object but saw ' + type(revenue_obj));
  }
};
{
  /**
   * Log revenue event with a price, quantity, and product identifier. DEPRECATED - use logRevenueV2
   * @public
   * @deprecated
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @example amplitudeClient.logRevenue(3.99, 1, 'product_1234');
   */
  AmplitudeClient.prototype.logRevenue = function logRevenue(price, quantity, product) {
    if (this._shouldDeferCall()) {
      return this._q.push(['logRevenue'].concat(Array.prototype.slice.call(arguments, 0)));
    }

    // Test that the parameters are of the right type.
    if (!this._apiKeySet('logRevenue()') || !_isNumber(price) || quantity !== undefined && !_isNumber(quantity)) {
      // utils.log('Price and quantity arguments to logRevenue must be numbers');
      return -1;
    }
    return this._logEvent(Constants.REVENUE_EVENT, {}, {
      productId: product,
      special: 'revenue_amount',
      quantity: quantity || 1,
      price: price
    }, null, null, null, null, null);
  };
}

/**
 * Calls error callback on unsent events
 * @private
 */
AmplitudeClient.prototype._logErrorsOnEvents = function _logErrorsOnEvents(maxEventId, maxIdentifyId, status, response) {
  var queues = ['_unsentEvents', '_unsentIdentifys'];
  for (var j = 0; j < queues.length; j++) {
    var queue = queues[j];
    var maxId = queue === '_unsentEvents' ? maxEventId : maxIdentifyId;
    for (var i = 0; i < this[queue].length || 0; i++) {
      var unsentEvent = this[queue][i];
      if (unsentEvent.event.event_id <= maxId) {
        if (unsentEvent.errorCallback) {
          unsentEvent.errorCallback(status, response);
        }
      }
    }
  }
};

/**
 * Remove events in storage with event ids up to and including maxEventId.
 * @private
 */
AmplitudeClient.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId, status, response) {
  _removeEvents(this, '_unsentEvents', maxEventId, status, response);
  _removeEvents(this, '_unsentIdentifys', maxIdentifyId, status, response);
};

/**
 * Helper function to remove events up to maxId from a single queue.
 * Does a true filter in case events get out of order or old events are removed.
 * @private
 */
var _removeEvents = function _removeEvents(scope, eventQueue, maxId, status, response) {
  if (maxId < 0) {
    return;
  }
  var filteredEvents = [];
  for (var i = 0; i < scope[eventQueue].length || 0; i++) {
    var unsentEvent = scope[eventQueue][i];
    if (unsentEvent.event.event_id > maxId) {
      filteredEvents.push(unsentEvent);
    } else {
      if (unsentEvent.callback) {
        unsentEvent.callback(status, response);
      }
    }
  }
  scope[eventQueue] = filteredEvents;
};

/**
 * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
 * If batchEvents is true, then events are only sent when batch criterias are met.
 * @private
 */
AmplitudeClient.prototype.sendEvents = function sendEvents() {
  if (!this._apiKeySet('sendEvents()')) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'API key not set'
    });
    return;
  }
  if (this.options.optOut) {
    this.removeEvents(Infinity, Infinity, 0, 'No request sent', {
      reason: 'Opt out is set to true'
    });
    return;
  }

  // How is it possible to get into this state?
  if (this._unsentCount() === 0) {
    return;
  }

  // We only make one request at a time. sendEvents will be invoked again once
  // the last request completes.
  // beacon data is sent synchronously, so don't pause for it
  if (this.options.transport !== Constants.TRANSPORT_BEACON) {
    if (this._sending) {
      return;
    }
    this._sending = true;
  }
  var protocol = this.options.forceHttps ? 'https' : 'https:' === GlobalScope.location.protocol ? 'https' : 'http';
  var url = protocol + '://' + this.options.apiEndpoint;

  // fetch events to send
  var numEvents = Math.min(this._unsentCount(), this.options.uploadBatchSize);
  var mergedEvents = this._mergeEventsAndIdentifys(numEvents);
  var maxEventId = mergedEvents.maxEventId;
  var maxIdentifyId = mergedEvents.maxIdentifyId;
  var events = JSON.stringify(mergedEvents.eventsToSend.map(function (_ref2) {
    var event = _ref2.event;
    return event;
  }));
  var uploadTime = new Date().getTime();
  var data = {
    client: this.options.apiKey,
    e: events,
    v: Constants.API_VERSION,
    upload_time: uploadTime,
    checksum: md5(Constants.API_VERSION + this.options.apiKey + events + uploadTime)
  };
  if (this.options.transport === Constants.TRANSPORT_BEACON && typeof navigator !== 'undefined') {
    var success = navigator.sendBeacon(url, new URLSearchParams(data));
    if (success) {
      this.removeEvents(maxEventId, maxIdentifyId, 200, 'success');
      if (this.options.saveEvents) {
        this.saveEvents();
      }
    } else {
      this._logErrorsOnEvents(maxEventId, maxIdentifyId, 0, '');
    }
    return;
  }
  var scope = this;
  try {
    new Request$1(url, data, this.options.headers).send(function (status, response) {
      scope._sending = false;
      try {
        if (status === 200) {
          scope.removeEvents(maxEventId, maxIdentifyId, status, response);

          // Update the event cache after the removal of sent events.
          if (scope.options.saveEvents) {
            scope.saveEvents();
          }

          // Send more events if any queued during previous send.
          scope._sendEventsIfReady();

          // handle payload too large
        } else {
          scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
          if (status === 413) {
            // utils.log('request too large');
            // Can't even get this one massive event through. Drop it, even if it is an identify.
            if (scope.options.uploadBatchSize === 1) {
              scope.removeEvents(maxEventId, maxIdentifyId, status, response);
            }

            // The server complained about the length of the request. Backoff and try again.
            scope.options.uploadBatchSize = Math.ceil(numEvents / 2);
            scope.sendEvents();
          }
        }
        // else {
        //  all the events are still queued, and will be retried when the next
        //  event is sent In the interest of debugging, it would be nice to have
        //  something like an event emitter for a better debugging experince
        //  here.
        // }
      } catch (e) {
        // utils.log.error('failed upload');
      }
    });
  } catch (e) {
    var status = 0,
      response = 'Request failed to send';
    utils.log.error(response);
    scope._logErrorsOnEvents(maxEventId, maxIdentifyId, status, response);
    scope.removeEvents(maxEventId, maxIdentifyId, status, response, {
      reason: e.message
    });
  }
};

/**
 * Merge unsent events and identifys together in sequential order based on their sequence number, for uploading.
 * Identifys given higher priority than Events. Also earlier sequence given priority
 * @private
 */
AmplitudeClient.prototype._mergeEventsAndIdentifys = function _mergeEventsAndIdentifys(numEvents) {
  // coalesce events from both queues
  var eventsToSend = [];
  var eventIndex = 0;
  var maxEventId = -1;
  var identifyIndex = 0;
  var maxIdentifyId = -1;
  while (eventsToSend.length < numEvents) {
    var unsentEvent = void 0;
    var noIdentifys = identifyIndex >= this._unsentIdentifys.length;
    var noEvents = eventIndex >= this._unsentEvents.length;

    // case 0: no events or identifys left
    // note this should not happen, this means we have less events and identifys than expected
    if (noEvents && noIdentifys) {
      utils.log.error('Merging Events and Identifys, less events and identifys than expected');
      break;
    }

    // case 1: no identifys - grab from events
    else if (noIdentifys) {
      unsentEvent = this._unsentEvents[eventIndex++];
      maxEventId = unsentEvent.event.event_id;

      // case 2: no events - grab from identifys
    } else if (noEvents) {
      unsentEvent = this._unsentIdentifys[identifyIndex++];
      maxIdentifyId = unsentEvent.event.event_id;

      // case 3: need to compare sequence numbers
    } else {
      // events logged before v2.5.0 won't have a sequence number, put those first
      if (!('sequence_number' in this._unsentEvents[eventIndex].event) || this._unsentEvents[eventIndex].event.sequence_number < this._unsentIdentifys[identifyIndex].event.sequence_number) {
        unsentEvent = this._unsentEvents[eventIndex++];
        maxEventId = unsentEvent.event.event_id;
      } else {
        unsentEvent = this._unsentIdentifys[identifyIndex++];
        maxIdentifyId = unsentEvent.event.event_id;
      }
    }
    eventsToSend.push(unsentEvent);
  }
  return {
    eventsToSend: eventsToSend,
    maxEventId: maxEventId,
    maxIdentifyId: maxIdentifyId
  };
};
{
  /**
   * Set global user properties. Note this is deprecated, and we recommend using setUserProperties
   * @public
   * @deprecated
   */
  AmplitudeClient.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.setUserProperties(userProperties);
  };
}

/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */
AmplitudeClient.prototype.__VERSION__ = function getVersion() {
  return this.options.library.version;
};

/**
 * Sets the library name and version. Default is `amplitude-js` and the version defined in package.json. Used if you're building another library on top of amplitude-js and want a custom data source value
 * @public
 * @param {string} name - Custom library name
 * @param {string} version - Custom library version
 */
AmplitudeClient.prototype.setLibrary = function setLibrary(name, version) {
  if (name !== null && typeof name !== 'undefined') {
    this.options.library.name = name;
  }
  if (version !== null && typeof version !== 'undefined') {
    this.options.library.version = version;
  }
};

/**
 * Determines whether or not to push call to this._q or invoke it
 * @private
 */
AmplitudeClient.prototype._shouldDeferCall = function _shouldDeferCall() {
  return this._pendingReadStorage || this._initializationDeferred;
};

/**
 * Defers Initialization by putting all functions into storage until users
 * have accepted terms for tracking
 * @private
 */
AmplitudeClient.prototype._deferInitialization = function _deferInitialization() {
  this._initializationDeferred = true;
  this._q.push(['init'].concat(Array.prototype.slice.call(arguments, 0)));
};

/**
 * Enable tracking via logging events and dropping a cookie
 * Intended to be used with the deferInitialization configuration flag
 * This will drop a cookie and reset initialization deferred
 * @public
 */
AmplitudeClient.prototype.enableTracking = function enableTracking() {
  // This will call init (which drops the cookie) and will run any pending tasks
  this._initializationDeferred = false;
  _saveCookieData(this);
  this.runQueuedFunctions();
};

/**
 * Find best server url if choose to enable dynamic configuration.
 */
AmplitudeClient.prototype._refreshDynamicConfig = function _refreshDynamicConfig() {
  if (this.options.useDynamicConfig) {
    instance$1.refresh(this.options.serverZone, this.options.forceHttps, function () {
      this.options.apiEndpoint = instance$1.ingestionEndpoint;
    }.bind(this));
  }
};

/**
 * Returns the deviceId value.
 * @public
 * @return {string} Id of current device.
 */
AmplitudeClient.prototype.getDeviceId = function getDeviceId() {
  return this.options.deviceId;
};

/**
 * Returns the userId.
 * @public
 * @return {string} Id of current user.
 */
AmplitudeClient.prototype.getUserId = function getUserId() {
  return this.options.userId;
};

/**
 * Set a custom session expiration time.
 * @public
 * @param {number} timeInMillis - session expireation time in milliseconds.
 */
AmplitudeClient.prototype.setMinTimeBetweenSessionsMillis = function setMinTimeBetweenSessionsMillis(timeInMillis) {
  if (!utils.validateInput(timeInMillis, 'timeInMillis', 'number')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setMinTimeBetweenSessionsMillis'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.sessionTimeout = timeInMillis;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets minimum number of events to batch together per request if batchEvents is true.
 * @public
 * @param {number} eventUploadThreshold - The number of the event upload threshold. Default value is 30.
 * @example amplitudeClient.setEventUploadThreshold(10);
 */
AmplitudeClient.prototype.setEventUploadThreshold = function setEventUploadThreshold(eventUploadThreshold) {
  if (!utils.validateInput(eventUploadThreshold, 'eventUploadThreshold', 'number')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setEventUploadThreshold'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.eventUploadThreshold = eventUploadThreshold;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Dynamically adjust server URL
 * @public
 * @param {bool} useDynamicConfig - if enable dynamic config or not.
 * @example amplitudeClient.setUseDynamicConfig(true);
 */
AmplitudeClient.prototype.setUseDynamicConfig = function setUseDynamicConfig(useDynamicConfig) {
  if (!utils.validateInput(useDynamicConfig, 'useDynamicConfig', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setUseDynamicConfig'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.useDynamicConfig = useDynamicConfig;
    this._refreshDynamicConfig();
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the server zone, used for server api endpoint and dynamic configuration.
 * @public
 * @param {string} serverZone - the server zone value. AmplitudeServerZone.US or AmplitudeServerZone.EU.
 * @param {bool} serverZoneBasedApi - (optional) update api endpoint with serverZone change or not. For data residency, recommend to enable it unless using own proxy server.
 * @example amplitudeClient.setServerZone(AmplitudeServerZone.EU, true);
 */
AmplitudeClient.prototype.setServerZone = function setServerZone(serverZone) {
  var serverZoneBasedApi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (serverZone !== AmplitudeServerZone.EU && serverZone !== AmplitudeServerZone.US || !utils.validateInput(serverZoneBasedApi, 'serverZoneBasedApi', 'boolean')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setServerZone'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.serverZone = serverZone;
    this.options.serverZoneBasedApi = serverZoneBasedApi;
    if (serverZoneBasedApi) {
      this.options.apiEndpoint = getEventLogApi(this.options.serverZone);
    }
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Sets the server URL for the request.
 * @public
 * @param {string} serverUrl - The value of the server URL.
 * @example amplitudeClient.setServerUrl('api.amplitude.com');
 */
AmplitudeClient.prototype.setServerUrl = function setServerUrl(serverUrl) {
  if (!utils.validateInput(serverUrl, 'serverUrl', 'string')) {
    return;
  }
  if (this._shouldDeferCall()) {
    return this._q.push(['setServerUrl'].concat(Array.prototype.slice.call(arguments, 0)));
  }
  try {
    this.options.apiEndpoint = serverUrl;
  } catch (e) {
    utils.log.error(e);
  }
};

/**
 * Deprecated legacy API of the Amplitude JS SDK - instance manager.
 *
 * Wraps around the current [AmplitudeClient](https://amplitude.github.io/Amplitude-JavaScript/) which provides more features
 * Function calls directly on amplitude have been deprecated. Please call methods on the default shared instance: amplitude.getInstance() instead.
 *
 * See the [3.0.0 changelog](https://github.com/amplitude/Amplitude-JavaScript/blob/ed405afb5f06d5cf5b72539a5d09179abcf7e1fe/README.md#300-update-and-logging-events-to-multiple-amplitude-apps) for more information about this change.
 * @constructor Amplitude
 * @public
 * @deprecated
 * @example var amplitude = new Amplitude();
 */
var Amplitude = function Amplitude() {
  this.options = _objectSpread2({}, DEFAULT_OPTIONS$1);
  this._q = [];
  this._instances = {}; // mapping of instance names to instances
};
Amplitude.prototype.Identify = Identify;
Amplitude.prototype.Revenue = Revenue;
Amplitude.prototype.getInstance = function getInstance(instance) {
  instance = utils.isEmptyString(instance) ? Constants.DEFAULT_INSTANCE : instance.toLowerCase();
  var client = this._instances[instance];
  if (client === undefined) {
    client = new AmplitudeClient(instance);
    this._instances[instance] = client;
  }
  return client;
};
{
  /**
   * Initializes the Amplitude Javascript SDK with your apiKey and any optional configurations.
   * This is required before any other methods can be called.
   * @public
   * @param {string} apiKey - The API key for your app.
   * @param {string} opt_userId - (optional) An identifier for this user.
   * @param {object} opt_config - (optional) Configuration options.
   * See [options.js](https://github.com/amplitude/Amplitude-JavaScript/blob/master/src/options.js#L14) for list of options and default values.
   * @param {function} opt_callback - (optional) Provide a callback function to run after initialization is complete.
   * @deprecated Please use amplitude.getInstance().init(apiKey, opt_userId, opt_config, opt_callback);
   * @example amplitude.init('API_KEY', 'USER_ID', {includeReferrer: true, includeUtm: true}, function() { alert('init complete'); });
   */
  Amplitude.prototype.init = function init(apiKey, opt_userId, opt_config, opt_callback) {
    this.getInstance().init(apiKey, opt_userId, opt_config, function (instance) {
      // make options such as deviceId available for callback functions
      this.options = instance.options;
      if (type(opt_callback) === 'function') {
        opt_callback(instance);
      }
    }.bind(this));
  };

  /**
   * Returns true if a new session was created during initialization, otherwise false.
   * @public
   * @return {boolean} Whether a new session was created during initialization.
   * @deprecated Please use amplitude.getInstance().isNewSession();
   */
  Amplitude.prototype.isNewSession = function isNewSession() {
    return this.getInstance().isNewSession();
  };

  /**
   * Returns the id of the current session.
   * @public
   * @return {number} Id of the current session.
   * @deprecated Please use amplitude.getInstance().getSessionId();
   */
  Amplitude.prototype.getSessionId = function getSessionId() {
    return this.getInstance().getSessionId();
  };

  /**
   * Increments the eventId and returns it.
   * @private
   */
  Amplitude.prototype.nextEventId = function nextEventId() {
    return this.getInstance().nextEventId();
  };

  /**
   * Increments the identifyId and returns it.
   * @private
   */
  Amplitude.prototype.nextIdentifyId = function nextIdentifyId() {
    return this.getInstance().nextIdentifyId();
  };

  /**
   * Increments the sequenceNumber and returns it.
   * @private
   */
  Amplitude.prototype.nextSequenceNumber = function nextSequenceNumber() {
    return this.getInstance().nextSequenceNumber();
  };

  /**
   * Saves unsent events and identifies to localStorage. JSON stringifies event queues before saving.
   * Note: this is called automatically every time events are logged, unless you explicitly set option saveEvents to false.
   * @private
   */
  Amplitude.prototype.saveEvents = function saveEvents() {
    this.getInstance().saveEvents();
  };

  /**
   * Sets a customer domain for the amplitude cookie. Useful if you want to support cross-subdomain tracking.
   * @public
   * @param {string} domain to set.
   * @deprecated Please use amplitude.getInstance().setDomain(domain);
   * @example amplitude.setDomain('.amplitude.com');
   */
  Amplitude.prototype.setDomain = function setDomain(domain) {
    this.getInstance().setDomain(domain);
  };

  /**
   * Sets an identifier for the current user.
   * @public
   * @param {string} userId - identifier to set. Can be null.
   * @deprecated Please use amplitude.getInstance().setUserId(userId);
   * @example amplitude.setUserId('joe@gmail.com');
   */
  Amplitude.prototype.setUserId = function setUserId(userId) {
    this.getInstance().setUserId(userId);
  };

  /**
   * Add user to a group or groups. You need to specify a groupType and groupName(s).
   * For example you can group people by their organization.
   * In that case groupType is "orgId" and groupName would be the actual ID(s).
   * groupName can be a string or an array of strings to indicate a user in multiple gruups.
   * You can also call setGroup multiple times with different groupTypes to track multiple types of groups (up to 5 per app).
   * Note: this will also set groupType: groupName as a user property.
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information.
   * @public
   * @param {string} groupType - the group type (ex: orgId)
   * @param {string|list} groupName - the name of the group (ex: 15), or a list of names of the groups
   * @deprecated Please use amplitude.getInstance().setGroup(groupType, groupName);
   * @example amplitude.setGroup('orgId', 15); // this adds the current user to orgId 15.
   */
  Amplitude.prototype.setGroup = function (groupType, groupName) {
    this.getInstance().setGroup(groupType, groupName);
  };

  /**
   * Sets whether to opt current user out of tracking.
   * @public
   * @param {boolean} enable - if true then no events will be logged or sent.
   * @deprecated Please use amplitude.getInstance().setOptOut(enable);
   * @example: amplitude.setOptOut(true);
   */
  Amplitude.prototype.setOptOut = function setOptOut(enable) {
    this.getInstance().setOptOut(enable);
  };

  /**
   * Regenerates a new random deviceId for current user. Note: this is not recommended unless you know what you
   * are doing. This can be used in conjunction with `setUserId(null)` to anonymize users after they log out.
   * With a null userId and a completely new deviceId, the current user would appear as a brand new user in dashboard.
   * This uses src/uuid.js to regenerate the deviceId.
   * @public
   * @deprecated Please use amplitude.getInstance().regenerateDeviceId();
   */
  Amplitude.prototype.regenerateDeviceId = function regenerateDeviceId() {
    this.getInstance().regenerateDeviceId();
  };

  /**
   * Sets a custom deviceId for current user. Note: this is not recommended unless you know what you are doing
   * (like if you have your own system for managing deviceIds).
   *
   * Make sure the deviceId you set is sufficiently unique
   * (we recommend something like a UUID - see src/uuid.js for an example of how to generate) to prevent conflicts with other devices in our system.
   * @public
   * @param {string} deviceId - custom deviceId for current user.
   * @deprecated Please use amplitude.getInstance().setDeviceId(deviceId);
   * @example amplitude.setDeviceId('45f0954f-eb79-4463-ac8a-233a6f45a8f0');
   */
  Amplitude.prototype.setDeviceId = function setDeviceId(deviceId) {
    this.getInstance().setDeviceId(deviceId);
  };

  /**
   * Sets user properties for the current user.
   * @public
   * @param {object} userProperties - object with string keys and values for the user properties to set.
   * @param {boolean} opt_replace - Deprecated. In earlier versions of the JS SDK the user properties object was kept in
   * memory and replace = true would replace the object in memory. Now the properties are no longer stored in memory, so replace is deprecated.
   * @deprecated Please use amplitude.getInstance().setUserProperties(userProperties);
   * @example amplitude.setUserProperties({'gender': 'female', 'sign_up_complete': true})
   */
  Amplitude.prototype.setUserProperties = function setUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };

  /**
   * Clear all of the user properties for the current user. Note: clearing user properties is irreversible!
   * @public
   * @deprecated Please use amplitude.getInstance().clearUserProperties();
   * @example amplitude.clearUserProperties();
   */
  Amplitude.prototype.clearUserProperties = function clearUserProperties() {
    this.getInstance().clearUserProperties();
  };

  /**
   * Send an identify call containing user property operations to Amplitude servers.
   * See the [Identify](https://amplitude.github.io/Amplitude-JavaScript/Identify/)
   * reference page for more information on the Identify API and user property operations.
   * @param {Identify} identify_obj - the Identify object containing the user property operations to send.
   * @param {Amplitude~eventCallback} opt_callback - (optional) callback function to run when the identify event has been sent.
   * Note: the server response code and response body from the identify event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().identify(identify);
   * @example
   * var identify = new amplitude.Identify().set('colors', ['rose', 'gold']).add('karma', 1).setOnce('sign_up_date', '2016-03-31');
   * amplitude.identify(identify);
   */
  Amplitude.prototype.identify = function (identify_obj, opt_callback) {
    this.getInstance().identify(identify_obj, opt_callback);
  };

  /**
   * Set a versionName for your application.
   * @public
   * @param {string} versionName - The version to set for your application.
   * @deprecated Please use amplitude.getInstance().setVersionName(versionName);
   * @example amplitude.setVersionName('1.12.3');
   */
  Amplitude.prototype.setVersionName = function setVersionName(versionName) {
    this.getInstance().setVersionName(versionName);
  };

  /**
   * This is the callback for logEvent and identify calls. It gets called after the event/identify is uploaded,
   * and the server response code and response body from the upload request are passed to the callback function.
   * @callback Amplitude~eventCallback
   * @param {number} responseCode - Server response code for the event / identify upload request.
   * @param {string} responseBody - Server response body for the event / identify upload request.
   */

  /**
   * Log an event with eventType and eventProperties
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEvent(eventType, eventProperties, opt_callback);
   * @example amplitude.logEvent('Clicked Homepage Button', {'finished_flow': false, 'clicks': 15});
   */
  Amplitude.prototype.logEvent = function logEvent(eventType, eventProperties, opt_callback) {
    return this.getInstance().logEvent(eventType, eventProperties, opt_callback);
  };

  /**
   * Log an event with eventType, eventProperties, and groups. Use this to set event-level groups.
   *
   * Note: the group(s) set only apply for the specific event type being logged and does not persist on the user
   * (unless you explicitly set it with setGroup).
   *
   * See the [advanced topics article](https://developers.amplitude.com/docs/javascript#user-groups) for more information
   * about groups and Count by Distinct on the Amplitude platform.
   * @public
   * @param {string} eventType - name of event
   * @param {object} eventProperties - (optional) an object with string keys and values for the event properties.
   * @param {object} groups - (optional) an object with string groupType: groupName values for the event being logged.
   * groupName can be a string or an array of strings.
   * @param {Amplitude~eventCallback} opt_callback - (optional) a callback function to run after the event is logged.
   * Note: the server response code and response body from the event upload are passed to the callback function.
   * @deprecated Please use amplitude.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
   * @example amplitude.logEventWithGroups('Clicked Button', null, {'orgId': 24});
   */
  Amplitude.prototype.logEventWithGroups = function (eventType, eventProperties, groups, opt_callback) {
    return this.getInstance().logEventWithGroups(eventType, eventProperties, groups, opt_callback);
  };

  /**
   * Log revenue with Revenue interface. The new revenue interface allows for more revenue fields like
   * revenueType and event properties.
   *
   * See the [Revenue](https://amplitude.github.io/Amplitude-JavaScript/Revenue/)
   * reference page for more information on the Revenue interface and logging revenue.
   * @public
   * @param {Revenue} revenue_obj - the revenue object containing the revenue data being logged.
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example var revenue = new amplitude.Revenue().setProductId('productIdentifier').setPrice(10.99);
   * amplitude.logRevenueV2(revenue);
   */
  Amplitude.prototype.logRevenueV2 = function logRevenueV2(revenue_obj) {
    return this.getInstance().logRevenueV2(revenue_obj);
  };

  /**
   * Log revenue event with a price, quantity, and product identifier.
   * @public
   * @param {number} price - price of revenue event
   * @param {number} quantity - (optional) quantity of products in revenue event. If no quantity specified default to 1.
   * @param {string} product - (optional) product identifier
   * @deprecated Please use amplitude.getInstance().logRevenueV2(revenue_obj);
   * @example amplitude.logRevenue(3.99, 1, 'product_1234');
   */
  Amplitude.prototype.logRevenue = function logRevenue(price, quantity, product) {
    return this.getInstance().logRevenue(price, quantity, product);
  };

  /**
   * Remove events in storage with event ids up to and including maxEventId.
   * @private
   */
  Amplitude.prototype.removeEvents = function removeEvents(maxEventId, maxIdentifyId) {
    this.getInstance().removeEvents(maxEventId, maxIdentifyId);
  };

  /**
   * Send unsent events. Note: this is called automatically after events are logged if option batchEvents is false.
   * If batchEvents is true, then events are only sent when batch criterias are met.
   * @private
   * @param {Amplitude~eventCallback} callback - (optional) callback to run after events are sent.
   * Note the server response code and response body are passed to the callback as input arguments.
   */
  Amplitude.prototype.sendEvents = function sendEvents(callback) {
    this.getInstance().sendEvents(callback);
  };

  /**
   * Set global user properties.
   * @public
   * @deprecated Please use amplitudeClient.setUserProperties
   */
  Amplitude.prototype.setGlobalUserProperties = function setGlobalUserProperties(userProperties) {
    this.getInstance().setUserProperties(userProperties);
  };
}

/**
 * Get the current version of Amplitude's Javascript SDK.
 * @public
 * @returns {number} version number
 * @example var amplitudeVersion = amplitude.__VERSION__;
 */
Amplitude.prototype.__VERSION__ = version;

// Entry point
var old = typeof GlobalScope !== 'undefined' && GlobalScope.amplitude || {};
var newInstance = new Amplitude();
newInstance._q = old._q || [];

/**
 * Instantiates Amplitude object and runs all queued function logged by stubbed methods provided by snippets
 * Event queue allows async loading of SDK to not blocking client's app
 */
for (var instance in old._iq) {
  // migrate each instance's queue
  if (Object.prototype.hasOwnProperty.call(old._iq, instance)) {
    newInstance.getInstance(instance)._q = old._iq[instance]._q || [];
  }
}

/**
 * Amplitude 로그를 남깁니다.
 *
 * @param type 이벤트 타입
 * @param data 이벤트 데이터
 */
function logAmplitude(type, data) {
  newInstance.getInstance().logEvent(type, data);
}

function _LogLink(props, ref) {
  const {
    logData,
    amplitudeType,
    amplitudeData = {},
    href,
    to,
    as: LinkComponent = 'a',
    onClick,
    ...linkProps
  } = props;
  const interopHref = href ?? to; // Supports both Next.js and React Router.
  const normalizedHref = interopHref != null ? serializePathToString(interopHref) : interopHref;
  return jsx(LinkComponent, {
    ref: ref,
    onClick: e => {
      if (logData != null) {
        O$1({
          category: 'click',
          ...logData
        });
      }
      if (amplitudeType != null) {
        logAmplitude(amplitudeType, amplitudeData);
      }
      onClick?.(e);
    },
    href: normalizedHref,
    to: normalizedHref,
    ...linkProps
  });
}

/**
 * A generic logging link component that supports any routing library.
 */
const LogLink = /*#__PURE__*/React.forwardRef(_LogLink);

function _EMOTION_STRINGIFIED_CSS_ERROR__$O() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$j = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "13v0n73-NavigationItem",
  styles: "display:flex;align-items:center;label:NavigationItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
var _ref2$5 = process.env.NODE_ENV === "production" ? {
  name: "fqhs2q",
  styles: "text-overflow:ellipsis;overflow:hidden;margin-left:8px"
} : {
  name: "t41ge4-NavigationItem",
  styles: "text-overflow:ellipsis;overflow:hidden;margin-left:8px;label:NavigationItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
var _ref3$2 = process.env.NODE_ENV === "production" ? {
  name: "1p2i2oq",
  styles: "width:32px"
} : {
  name: "x7la5y-NavigationItem",
  styles: "width:32px;label:NavigationItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
var _ref4$1 = process.env.NODE_ENV === "production" ? {
  name: "1953rds",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center"
} : {
  name: "vngum5-NavigationItem",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center;label:NavigationItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
var _ref5$1 = process.env.NODE_ENV === "production" ? {
  name: "1kghokd",
  styles: "display:flex;align-items:center;overflow:hidden"
} : {
  name: "kfcqn3-NavigationItem",
  styles: "display:flex;align-items:center;overflow:hidden;label:NavigationItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
var _ref6$1 = process.env.NODE_ENV === "production" ? {
  name: "7gjpkq",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap"
} : {
  name: "11fxc8c-NavigationItem",
  styles: "display:flex;align-items:center;justify-content:space-between;white-space:nowrap;label:NavigationItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$O
};
function NavigationItem(props) {
  const {
    item: {
      value
    }
  } = props;
  const {
    isGlobal
  } = useGNBData();
  const theme = useTheme();
  const {
    ref
  } = useImpressionLog({
    disable: !isGlobal,
    logData: {
      id: value.info.searchKeyword,
      index: value.log?.objectIdx,
      type: value.log?.objectType,
      section: value.log?.objectSection
    }
  });
  return jsxs("div", {
    css: _ref6$1,
    ref: ref,
    children: [jsxs("div", {
      css: _ref5$1,
      children: [jsx("div", {
        css: _ref4$1,
        children: value.info.iconUrl ? jsx(CircleImage, {
          src: value.info.iconUrl,
          css: _ref3$2
        }) : jsx(SearchIcon, {
          size: 18,
          fill: theme => theme.colors.foregroundWeak
        })
      }), jsx("div", {
        css: _ref2$5,
        children: jsx(HighlightedText$1, {
          ...props
        })
      })]
    }), jsxs("div", {
      css: _ref$j,
      children: [jsx("span", {
        css: /*#__PURE__*/css(FONT_STYLE.subTitle2, " margin-right:4px;color:", theme.colors.foregroundEmphasis, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationItem;")),
        children: value.info.guideDescription
      }), jsx(ChevronRightIcon, {
        size: 12,
        css: /*#__PURE__*/css("color:", theme.colors.foregroundEmphasis, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavigationItem;"))
      })]
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$N() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function HighlightedText({
  item,
  query
}) {
  const parts = item.query.split(new RegExp(`(${escapeRegex(query || '')})`, 'gi'));
  return jsx(Fragment, {
    children: parts.map((part, index) => jsx(Fragment$1, {
      children: index % 2 === 1 || parts.length === 1 ? part : jsx("strong", {
        children: part
      })
    }, index))
  });
}
var _ref$i = process.env.NODE_ENV === "production" ? {
  name: "1uhrb8q",
  styles: "flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:8px"
} : {
  name: "vjqzbn-HistoryKeywordItem",
  styles: "flex:1;text-overflow:ellipsis;overflow:hidden;margin-left:8px;label:HistoryKeywordItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
};
var _ref2$4 = process.env.NODE_ENV === "production" ? {
  name: "1953rds",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center"
} : {
  name: "1co05n4-HistoryKeywordItem",
  styles: "width:32px;height:32px;display:flex;align-items:center;justify-content:center;label:HistoryKeywordItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
};
var _ref3$1 = process.env.NODE_ENV === "production" ? {
  name: "17uk3v8",
  styles: "display:flex;align-items:center;white-space:nowrap"
} : {
  name: "8l42v4-HistoryKeywordItem",
  styles: "display:flex;align-items:center;white-space:nowrap;label:HistoryKeywordItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$N
};
function HistoryKeywordItem(props) {
  const log = useLogContext();
  return jsx(ImpressionTracker, {
    onLog: () => log({
      key: 'primary.right.search.autocomplete.history',
      category: 'impression'
    }),
    children: jsxs("div", {
      css: _ref3$1,
      children: [jsx("div", {
        css: _ref2$4,
        children: jsx(ClockIcon, {
          size: 18,
          fill: theme => theme.colors.foregroundWeak
        })
      }), jsx("div", {
        css: _ref$i,
        children: jsx(HighlightedText, {
          ...props
        })
      })]
    })
  });
}

function ListBoxItem({
  item,
  hovered,
  query,
  showDivider = false,
  onHover,
  isHistoryList,
  ...props
}) {
  const theme = useTheme();
  const ref = useRef(null);
  const renderItem = () => {
    switch (item.type) {
      case 'query':
        return jsx(KeywordItem, {
          item: item,
          query: query
        });
      case 'category':
        return jsx(CategoryItem, {
          item: item,
          query: query
        });
      case 'consulting':
        return jsx(ConsultingItem, {
          item: item,
          query: query
        });
      case 'history':
        if (isHistoryList) {
          return jsx(HistoryKeywordItem, {
            item: item,
            query: query
          });
        }
        return jsx(HistoryItem, {
          item: item,
          hovered: hovered
        });
      case 'navigation':
        return jsx(NavigationItem, {
          item: item,
          query: query
        });
      default:
        return null;
    }
  };
  useEffect(() => {
    if (!hovered || !ref.current) {
      return;
    }
    onHover(ref.current);
  }, [hovered, onHover]);
  return jsxs(Fragment, {
    children: [jsx("li", {
      ref: ref,
      role: "option",
      "aria-selected": undefined,
      css: [/*#__PURE__*/css(FONT_STYLE.subTitle1, " position:relative;margin:0;padding:4px 12px 4px 8px;color:#6C747A;line-height:21px;cursor:pointer;border-radius:2px;outline:none;strong{color:", theme.colors.foreground, ";font-weight:600;}", hovered && `background: ${theme.background.groupedBase};`, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBoxItem;")), FOCUS`
          background: ${theme.background.groupedBase};
        `, process.env.NODE_ENV === "production" ? "" : ";label:ListBoxItem;"],
      tabIndex: 0,
      ...props,
      children: renderItem()
    }), showDivider && jsx(Divider, {
      variant: "thin"
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$M() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function filterOnlyHistoryKeyword(items) {
  return items.filter(item => item.type === 'history' && typeof item.value !== 'string' && item.value.type === 'query');
}
var _ref2$3 = process.env.NODE_ENV === "production" ? {
  name: "1xclg2i",
  styles: "margin:0;padding:0"
} : {
  name: "6ca3jb-ListBox",
  styles: "margin:0;padding:0;label:ListBox;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
function ListBox({
  items,
  query,
  hoveredIndex,
  isHistoryList,
  onItemClick,
  onItemMouseEnter,
  className
}) {
  const theme = useTheme();
  const container = useRef(null);
  const {
    localeData
  } = useGNBData();
  const log = useLogContext();
  const handleIntersect = useCallback(() => {
    if (filterOnlyHistoryKeyword(items).length > 0) {
      log({
        key: 'primary.right.search.history',
        category: 'impression',
        params: {
          type: 'keyword'
        }
      });
    }
  }, [items, log]);
  const isShowDivider = useCallback((item, index) => {
    return index < items.length - 1 && items[index + 1]?.type !== item.type && item.type === 'history';
  }, [items]);
  const handleItemHover = useCallback(item => {
    if (!container.current) {
      return;
    }
    container.current.scrollTop = item.offsetTop - (container.current.offsetHeight - item.offsetHeight) / 2;
  }, []);
  const handleItemClick = useCallback((item, index) => () => onItemClick(item, index), [onItemClick]);
  const handleItemMouseEnter = useCallback((item, index) => () => onItemMouseEnter(item, index), [onItemMouseEnter]);
  return jsx(IntersectionObserver$1, {
    onIntersect: handleIntersect,
    children: jsxs("div", {
      ref: container,
      css: /*#__PURE__*/css("overflow-y:auto;position:relative;width:100%;padding:", pxToRem(10), " 0;border:", pxToRem(1), " solid ", theme.divider, ";border-radius:", pxToRem(4), ";background:", theme.background.base, ";box-shadow:0 ", pxToRem(4), " ", pxToRem(6), " 0 ", theme.shadow.basic, ";box-sizing:border-box;", MEDIA_QUERY.min('laptop', `
          position: absolute;
          top: calc(100% + ${pxToRem(4)});
          left: 0;
          max-height: ${pxToRem(400)};
        `), " ", MEDIA_QUERY.only('tablet', `
          top: ${pxToRem(4)};
          height: 100%;
        `), " ", MEDIA_QUERY.only('mobile', `
          height: 100%;
          padding: ${pxToRem(8)} 0;
          border: 0;
          box-shadow: none;
        `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBox;")),
      className: className,
      children: [!isHistoryList && jsx(HistoryListBoxHeader, {
        hasDeleteButton: items.length > 0,
        localeData: localeData
      }), items.length > 0 ? jsx("ul", {
        css: _ref2$3,
        children: items.map((item, index) => jsx(ListBoxItem, {
          item: item,
          query: query,
          hovered: hoveredIndex === index,
          showDivider: isShowDivider(item, index),
          onHover: handleItemHover,
          onClick: handleItemClick(item, index),
          onMouseEnter: handleItemMouseEnter(item, index),
          isHistoryList: isHistoryList
        }, `${item.query}${index}`))
      }) : jsx("p", {
        css: /*#__PURE__*/css("margin:0;padding:", pxToRem(10), " ", pxToRem(16), ";color:", theme.content.base3, ";font-size:", pxToRem(15), ";line-height:1.4;" + (process.env.NODE_ENV === "production" ? "" : ";label:ListBox;")),
        children: localeData?.search?.historyEmpty ?? '최근 검색한 내역이 없습니다.'
      })]
    })
  });
}
var _ref$h = process.env.NODE_ENV === "production" ? {
  name: "1mr6o44",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:10px 16px"
} : {
  name: "o40v6b-HistoryListBoxHeader",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:10px 16px;label:HistoryListBoxHeader;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$M
};
function HistoryListBoxHeader({
  hasDeleteButton,
  localeData
}) {
  const theme = useTheme();
  const historyStorage = useHistoryStorage();
  return jsxs("div", {
    css: _ref$h,
    children: [jsx("span", {
      css: /*#__PURE__*/css(FONT_STYLE.body2, " color:", theme.colors.foreground, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;")),
      children: localeData?.search?.historyLabel ?? '최근 검색어'
    }), hasDeleteButton && jsx("button", {
      type: "button",
      onClick: historyStorage.removeAll,
      css: [/*#__PURE__*/css(RESET_BUTTON, " ", FONT_STYLE.subTitle2, " color:", theme.colors.foregroundWeak, ";margin:-2px;padding:2px;border-radius:2px;outline:none;transition:.1s opacity;" + (process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;")), HOVER$1`
              opacity: .4;
            `, FOCUS`
              box-shadow: 0 0 0 3px ${theme.interactive.primary1.thin};
            `, process.env.NODE_ENV === "production" ? "" : ";label:HistoryListBoxHeader;"],
      children: localeData?.search?.deleteHistory ?? '전체 삭제'
    })]
  });
}

function NavigationSearch({
  searchType,
  initialQuery,
  onFetch,
  onSubmit,
  onSubmitItem,
  onInputFocus,
  historyStorage,
  placeholder,
  ...props
}) {
  const [pageKey, setPageKey] = useState(null);
  const [isHistoryList, setIsHistoryList] = useState(false);
  const [manuallyTypedInputValue, setManuallyTypedInputValue] = useState(initialQuery);
  const {
    isGlobal
  } = useGNBData();
  const fetchListFromSearchHistory = useCallback(() => {
    const history = historyStorage.get();
    return history.map(value => ({
      type: 'history',
      value,
      query: typeof value === 'string' ? value : value.query
    }));
  }, [historyStorage]);
  const fetchList = useCallback(async query => {
    if (!manuallyTypedInputValue || query === '') {
      setIsHistoryList(false);
      return fetchListFromSearchHistory();
    }
    const matchHistory = fetchListFromSearchHistory().filter(historyValue => historyValue.query.includes(query));
    const fetchQueries = (await onFetch(query)) ?? [];
    setIsHistoryList(true);
    if (matchHistory.length > 0) {
      return [matchHistory[0], ...fetchQueries];
    }
    return fetchQueries;
  }, [manuallyTypedInputValue, fetchListFromSearchHistory, onFetch]);
  const handleHistoryUpdate = useCallback(() => {
    setPageKey({
      ...window.location,
      timestamp: new Date().getTime()
    });
  }, []);
  const handleSubmit = useCallback(value => {
    historyStorage.append(value);
    if (onSubmit) {
      onSubmit(value);
    }
  }, [historyStorage, onSubmit]);
  const log = useLogContext();
  const logAutocompleteKeyword = useCallback((item, index) => {
    const params = {
      type: item.type,
      index,
      id: item.query
    };
    if (isGlobal) {
      if (item.type === 'navigation' && item.value.log) {
        log({
          key: 'primary.right.search.autocomplete.navigation.global',
          category: 'click',
          params: {
            id: item.value.info.searchKeyword,
            index: item.value.log.objectIdx,
            type: item.value.log.objectType,
            section: item.value.log.objectSection
          }
        });
      }
      globalLog.logClickAutocompleteKeyword({
        id: item.query,
        index
      });
      return;
    }
    if (item.type === 'history' && Boolean(manuallyTypedInputValue)) {
      log({
        key: 'primary.right.search.autocomplete.history',
        category: 'click',
        params: {
          id: item.query,
          index
        }
      });
    }
    if (item.type === 'history' && typeof item.value !== 'string' && Boolean(manuallyTypedInputValue) === false) {
      log({
        key: 'primary.right.search.history',
        category: 'click',
        params: {
          ...params,
          type: item.value.type
        }
      });
    }
    if (item.type === 'category' || item.type === 'query' || item.type === 'navigation') {
      log({
        key: `primary.right.search.autocomplete.${item.type}`,
        category: 'click',
        params
      });
    }
  }, [log, isGlobal, manuallyTypedInputValue]);
  const shouldHistoryAppend = useCallback(searchItem => {
    // OG: SDUI 형태로 노출되는 카테고리 검색 결과는 히스토리에 저장하지 않음
    if (isGlobal && searchItem.type === 'navigation' && searchItem.value.log?.objectType === 'category') {
      return false;
    }
    return true;
  }, [isGlobal]);
  const handleSubmitItem = useCallback((item, index) => {
    const value = item.type === 'history' ? item.value : item;
    if (shouldHistoryAppend(item)) {
      historyStorage.append(value);
    }
    if (onSubmitItem) {
      onSubmitItem(item, !!manuallyTypedInputValue);
    }
    logAutocompleteKeyword(item, index);
  }, [shouldHistoryAppend, onSubmitItem, logAutocompleteKeyword, historyStorage, manuallyTypedInputValue]);
  const handleInputFocus = useCallback(e => {
    if (onInputFocus) {
      onInputFocus(e);
    }
    if (isGlobal) {
      globalLog.logClickSearchInput();
    } else {
      log({
        key: 'primary.right.search.input',
        category: 'click',
        params: {
          search_type: searchType
        }
      });
    }
  }, [onInputFocus, log, searchType, isGlobal]);
  return jsx(HistoryStorageProvider, {
    get: historyStorage.get,
    set: histories => {
      historyStorage.set(histories);
      handleHistoryUpdate();
    },
    append: history => {
      historyStorage.append(history);
      handleHistoryUpdate();
    },
    remove: history => {
      historyStorage.remove(history);
      handleHistoryUpdate();
    },
    removeAll: () => {
      historyStorage.removeAll();
      handleHistoryUpdate();
    },
    children: isGlobal ? jsx(GlobalSearch$1, {
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder ?? getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: item => item.query,
      renderListBox: props => jsx(GlobalListBox, {
        ...props,
        isHistoryList: isHistoryList
      }),
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue,
      ...props
    }) : jsx(Search$1, {
      id: "global-search",
      pageKey: pageKey,
      initialQuery: initialQuery,
      placeholder: placeholder ?? getSearchPlaceholder(searchType),
      fetchList: fetchList,
      getItemQuery: item => item.query,
      renderListBox: props => jsx(ListBox, {
        ...props,
        isHistoryList: isHistoryList
      }),
      onSubmit: handleSubmit,
      onSubmitItem: handleSubmitItem,
      onInputFocus: handleInputFocus,
      onInputChange: setManuallyTypedInputValue,
      ...props
    })
  });
}
const GlobalSearch$1 = /*#__PURE__*/_styled(Search$1, process.env.NODE_ENV === "production" ? {
  target: "ep26fdr1"
} : {
  target: "ep26fdr1",
  label: "GlobalSearch"
})("&>div>div{background-color:", ({
  theme
}) => theme.colors.backgroundWeak, ";border-radius:12px;border:1px solid ", ({
  theme
}) => theme.colors.border, ";padding:0 12px;}&>div>div>span{font-size:18px;}&>div>div>div>button>span{font-size:16px;}input{", FONT_STYLE.body15L24, ";}input::placeholder{color:", ({
  theme
}) => theme.colors.foregroundWeak, ";}");
const GlobalListBox = /*#__PURE__*/_styled(ListBox, process.env.NODE_ENV === "production" ? {
  target: "ep26fdr0"
} : {
  target: "ep26fdr0",
  label: "GlobalListBox"
})("border-radius:12px;", MEDIA_QUERY.only('tablet', `
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    max-height: 400px;
    height: auto;
  `), ";");

const slideIn$1 = keyframes`
  from {
    transform: translateX(50px);
  }
  to {
    transform: translateX(0);
  }
`;
function SearchDrawer({
  className,
  onSubmit,
  onSubmitItem,
  ...searchProps
}) {
  const theme = useTheme();
  const {
    localeData
  } = useGNBData();
  const [open, setOpen] = useState(false);
  const drawerAnimation = {
    drawer: slideIn$1
  };
  const handleDrawerOpen = useCallback(() => {
    setOpen(true);
  }, []);
  const handleDrawerClose = useCallback(() => {
    setOpen(false);
  }, []);
  const handleSubmit = useCallback(value => {
    setOpen(false);
    onSubmit?.(value);
  }, [onSubmit]);
  const handleSubmitItem = useCallback((item, isAutoComplete) => {
    setOpen(false);
    onSubmitItem?.(item, isAutoComplete);
  }, [onSubmitItem]);
  return jsxs("div", {
    css: className,
    children: [jsx("button", {
      type: "button",
      css: [/*#__PURE__*/css(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", theme.content.base1, ";line-height:0;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;")), HOVER$1`
            color: ${theme.content.primary1.basic};
          `, FOCUS`
            color: ${theme.content.primary1.basic};
          `, process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;"],
      onClick: handleDrawerOpen,
      children: jsx(Icon$2, {
        name: "search",
        size: 24
      })
    }), jsx(Drawer, {
      open: open,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/css(safeAreaInset('bottom', 'padding-bottom'), " ", MEDIA_QUERY.min('tablet', `
            min-width: ${pxToRem(256)};
            max-width: ${pxToRem(326)};
            padding: ${pxToRem(30)};
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;")),
      children: jsx(NavigationSearch, {
        ...searchProps,
        onSubmit: handleSubmit,
        onSubmitItem: handleSubmitItem,
        isInputAutoFocused: true,
        renderInputRight: () => jsx("button", {
          type: "button",
          onClick: handleDrawerClose,
          css: [/*#__PURE__*/css(RESET_BUTTON, " flex-shrink:0;margin-left:", pxToRem(15), ";padding:", pxToRem(9), " ", pxToRem(5), " ", pxToRem(10), ";color:", theme.content.base1, ";font-size:", pxToRem(15), ";line-height:1;font-weight:700;outline:none;", MEDIA_QUERY.min('tablet', `
                    display: none;
                  `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;")), FOCUS`
                  & > span {
                    box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
                  }
                `, process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;"],
          children: jsx("span", {
            css: /*#__PURE__*/css("display:inline-block;margin:", pxToRem(-4), ";padding:", pxToRem(4), ";border-radius:", pxToRem(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SearchDrawer;")),
            children: localeData?.search?.closeDrawer ?? '취소'
          })
        })
      })
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$g = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "1a8gq24-UploadDropdownContentItem",
  styles: "position:relative;label:UploadDropdownContentItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
};
function UploadDropdownContentItem({
  href,
  icon,
  title,
  subtitle,
  logId
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  return jsxs(LinkComponent, {
    role: "link",
    href: href,
    css: [/*#__PURE__*/css("display:flex;align-items:center;padding:", pxToRem(15), ";background-color:", theme.background.base, ";border-radius:", pxToRem(2), ";transition:.1s background-color;word-break:keep-all;white-space:nowrap;font-size:30px;line-height:0;outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;")), HOVER$1`
          background-color: ${theme.colors.backgroundWeak};
        `, FOCUS`
          background-color: ${theme.colors.backgroundWeak};
        `, process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;"],
    onClick: () => {
      if (logId) {
        log({
          key: logId,
          category: 'click'
        });
      }
    },
    children: [jsx("div", {
      css: _ref$g,
      children: icon
    }), jsxs("div", {
      css: /*#__PURE__*/css("margin-left:", pxToRem(12), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;")),
      children: [jsx("div", {
        css: /*#__PURE__*/css("font-size:", pxToRem(16), ";font-weight:bold;line-height:", pxToRem(24), ";color:", theme.colors.foreground, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;")),
        children: title
      }), jsx("div", {
        css: /*#__PURE__*/css("font-size:", pxToRem(14), ";line-height:", pxToRem(20), ";color:", theme.colors.foregroundWeak, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentItem;")),
        children: subtitle
      })]
    })]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BUTTON_SIZE = 40;
var _ref$f = process.env.NODE_ENV === "production" ? {
  name: "12whrtl",
  styles: "outline:none;overflow:hidden"
} : {
  name: "pun5pg-UploadDropdownContentButton",
  styles: "outline:none;overflow:hidden;label:UploadDropdownContentButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
};
function UploadDropdownContentButton({
  uploadMenuLinks
}) {
  const theme = useTheme();
  const log = useLogContext();
  const {
    gap,
    iconSize
  } = getWithIconOptions(BUTTON_SIZE);
  return jsx(Popper$1, {
    usePortal: false,
    renderButton: ({
      onClick
    }) => jsxs(Button$9, {
      role: "button",
      variant: "primary1",
      size: BUTTON_SIZE,
      type: "button",
      css: [_ref$f, FOCUS`
              box-shadow: 0 0 0 ${pxToRem(3)} ${theme.interactive.primary1.thin};
            `, process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentButton;"],
      onClick: () => {
        onClick();
        log({
          key: 'primary.right.upload',
          category: 'click'
        });
      },
      children: [jsx("span", {
        css: /*#__PURE__*/css("vertical-align:middle;white-space:nowrap;", MEDIA_QUERY.min('laptop', `
                margin-right: ${pxToRem(gap)};
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentButton;")),
        children: "\uAE00\uC4F0\uAE30"
      }), jsx(Icon$2, {
        css: /*#__PURE__*/css("vertical-align:middle;display:none;", MEDIA_QUERY.min('laptop', `
                display: inline-block;
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UploadDropdownContentButton;")),
        name: "chevron_down",
        size: iconSize
      })]
    }),
    children: uploadMenuLinks && uploadMenuLinks.map(item => jsx(UploadDropdownContentItem, {
      ...item
    }, item.title))
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$e = process.env.NODE_ENV === "production" ? {
  name: "12w7g96",
  styles: "vertical-align:top;margin:1px 0 0 2px"
} : {
  name: "914fbo-UserDropdownContentItem",
  styles: "vertical-align:top;margin:1px 0 0 2px;label:UserDropdownContentItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
};
var _ref2$2 = process.env.NODE_ENV === "production" ? {
  name: "1dnrp50",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0"
} : {
  name: "1nd5n5m-UserDropdownContentItem",
  styles: "vertical-align:middle;margin:0 1.5px 1.5px 0;label:UserDropdownContentItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
};
function UserDropdownContentItem({
  bullet,
  title,
  href,
  index,
  onClick,
  logId
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const Component = href ? LinkComponent : 'button';
  return jsxs(Component, {
    ...(Component === LinkComponent ? {
      href
    } : {
      type: 'button'
    }),
    css: [/*#__PURE__*/css("display:block;position:relative;width:100%;margin:0;padding:", pxToRem(10), " ", pxToRem(14), " ", pxToRem(11), ";box-sizing:border-box;border:none;background:", theme.background.base, ";color:", theme.content.base1, ";font-family:inherit;font-weight:normal;font-size:", pxToRem(15), ";line-height:", pxToRem(21), ";text-decoration:none;text-align:left;cursor:pointer;border-radius:", pxToRem(2), ";outline:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentItem;")), HOVER$1`
          background: ${theme.background.groupedBase};
        `, FOCUS`
          background: ${theme.background.groupedBase};
        `, process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentItem;"],
    onClick: () => {
      if (logId) {
        log({
          key: 'primary.right.user.dropdown',
          category: 'click',
          params: {
            index,
            ...(logId === 'user.remodeling.history' && {
              section_id: 'O2O_HISTORY'
            })
          }
        });
      }
      if (onClick) {
        onClick();
      }
    },
    children: [title, bullet === 'new' && jsx(NewIcon$1, {
      "data-testid": "new-icon",
      css: _ref2$2
    }), bullet === 'dot' && jsx(DotBadge, {
      css: _ref$e
    })]
  });
}

function UserDropdownContentButton({
  userMenu,
  renderButton
}) {
  const items = useMemo(() => userMenu.filter(menu => menu.showOn?.includes('bar')), [userMenu]);
  return jsx(Popper$1, {
    usePortal: false,
    renderButton: renderButton,
    children: jsx("div", {
      css: /*#__PURE__*/css("width:", pxToRem(184), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:UserDropdownContentButton;")),
      children: items.map((item, index) => jsx(UserDropdownContentItem, {
        index: index,
        ...item
      }, index))
    })
  });
}

function NoLoginMenuItem({
  component = 'a',
  label,
  href,
  logKey,
  onClick,
  ...rest
}) {
  const theme = useTheme();
  const Component = component;
  const log = useLogContext();
  return jsx(Component, {
    ...rest,
    href: href,
    css: /*#__PURE__*/css(FONT_STYLE.subTitle2, ";color:", theme.content.base1, ";padding:0 10px;border-left:1px solid ", theme.content.base4, ";&:first-of-type{border-left:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:NoLoginMenuItem;")),
    onClick: () => {
      log({
        key: logKey,
        category: 'click'
      });
      onClick?.();
    },
    children: label
  });
}

const SELLER_USERABLE_TYPE = 'SalesUser';
var SellerButton = /*#__PURE__*/memo(({
  userableType,
  ...rest
}) => {
  if (userableType !== SELLER_USERABLE_TYPE) {
    return null;
  }
  return jsx(OutlineAnchorButton, {
    css: /*#__PURE__*/css("display:none;margin-left:8px;", MEDIA_QUERY.min('laptop', `
          display: flex;
          align-items: center;
        `), ";"),
    variant: "base1",
    size: 40,
    ...rest,
    children: "\uD310\uB9E4\uC790 \uC804\uC6A9\uC11C\uBE44\uC2A4"
  });
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_PROFILE_URL$1 = 'https://image.ohousecdn.com/i/bucketplace-v2-development/uploads/users/profile_images1542987307_LkcmI.jpeg';
var _ref$d = process.env.NODE_ENV === "production" ? {
  name: "xnm8en",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover"
} : {
  name: "v9c5p3-UserProfileButton",
  styles: "vertical-align:middle;width:100%;height:100%;object-fit:cover;label:UserProfileButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$I
};
function UserProfileButton({
  profileUrl,
  profileSize = 40,
  hasBorderOnHover = true,
  onClick,
  ...props
}) {
  const theme = useTheme();
  return jsx("button", {
    css: [/*#__PURE__*/css(RESET_BUTTON, " position:relative;overflow:hidden;width:", profileSize, "px;height:", profileSize, "px;border-radius:100%;outline:none;&:after{content:'';display:none;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:100%;border:2px solid ", hasBorderOnHover ? theme.content.primary1.basic : 'transparent', ";box-sizing:border-box;}" + (process.env.NODE_ENV === "production" ? "" : ";label:UserProfileButton;")), HOVER$1`
          &:after {
            display: block;
          }
        `, FOCUS`
          &:after {
            display: block;
          }
        `, process.env.NODE_ENV === "production" ? "" : ";label:UserProfileButton;"],
    type: "button",
    onClick: onClick,
    "aria-label": "\uD504\uB85C\uD544 \uBA54\uB274",
    ...props,
    children: jsx(ResizeImage$1, {
      width: 40,
      aspect: 1,
      src: profileUrl || DEFAULT_PROFILE_URL$1,
      alt: "\uD504\uB85C\uD544 \uC0AC\uC9C4",
      css: _ref$d
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$c = process.env.NODE_ENV === "production" ? {
  name: "1kpxvh4",
  styles: "display:flex;margin:0 10px 0 8px"
} : {
  name: "jq04iw-PrimaryRight",
  styles: "display:flex;margin:0 10px 0 8px;label:PrimaryRight;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
};
var _ref2$1 = process.env.NODE_ENV === "production" ? {
  name: "10vibjk",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0"
} : {
  name: "1c3mnkg-PrimaryRight",
  styles: "display:flex;align-items:center;justify-content:flex-end;line-height:0;label:PrimaryRight;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
};
function PrimaryRight({
  searchProps,
  userProfile,
  userMenu,
  scrap,
  cart,
  notification,
  signin,
  signup,
  cs,
  contact,
  seller,
  uploadMenuLinks,
  showChangeLocaleButton = false
}) {
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const {
    location
  } = useGNBData();
  const {
    userId,
    imageUrl
  } = userProfile || {};
  const loggedIn = userId != null;
  return jsxs("div", {
    css: _ref2$1,
    children: [searchProps && jsxs(Fragment, {
      children: [jsx(NavigationSearch, {
        css: /*#__PURE__*/css("flex:1 1 0px;min-width:0;margin-right:", pxToRem(9), ";", MEDIA_QUERY.min('desktop', `
                margin-right: ${pxToRem(14)};
              `), " ", MEDIA_QUERY.max('tablet', `
                display: none;
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;")),
        ...searchProps
      }), jsx(SearchDrawer, {
        css: /*#__PURE__*/css(MEDIA_QUERY.min('laptop', `
                display: none;
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;")),
        ...searchProps
      })]
    }), showChangeLocaleButton && jsx(ChangeLocaleSection, {
      initialLocale: location?.locale ?? GLOBAL_DEFAULT_LOCALE
    }), scrap && jsx("div", {
      css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', `
            display: none;
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;")),
      children: jsx(IconNotification, {
        iconName: "scrap_outline",
        type: NotificationType.None,
        component: LinkComponent,
        "aria-label": "\uC2A4\uD06C\uB7A9\uBD81 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        href: scrap.href,
        onClick: () => log({
          key: 'primary.right.scrap',
          category: 'click'
        })
      })
    }), notification && jsx("div", {
      css: /*#__PURE__*/css(MEDIA_QUERY.max('mobile', `
              display: none;
            `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;")),
      children: jsx(IconNotification, {
        iconName: "notification_outline",
        type: NotificationType.Number,
        count: notification.count,
        component: LinkComponent,
        href: notification.href,
        "aria-label": "\uB0B4\uC18C\uC2DD \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
        onClick: () => log({
          key: 'primary.right.notification',
          category: 'click'
        })
      })
    }), cart && jsx(IconNotification, {
      iconName: "cart",
      type: NotificationType.Number,
      count: cart.count,
      component: LinkComponent,
      href: cart.href,
      "aria-label": "\uC7A5\uBC14\uAD6C\uB2C8 \uD398\uC774\uC9C0 \uB9C1\uD06C \uBC84\uD2BC",
      onClick: () => log({
        key: 'primary.right.cart',
        category: 'click'
      })
    }), jsxs("div", {
      css: /*#__PURE__*/css("display:flex;align-items:center;", MEDIA_QUERY.max('mobile', `
            display: none;
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;")),
      children: [loggedIn && jsx("div", {
        css: /*#__PURE__*/css("margin:0 ", pxToRem(12), " 0 ", pxToRem(5), ";", MEDIA_QUERY.min('laptop', `
                margin: 0 ${pxToRem(16)} 0 ${pxToRem(9)};
              `), " ", MEDIA_QUERY.min('desktop', `
                margin: 0 ${pxToRem(20)} 0 ${pxToRem(13)};
              `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;")),
        children: jsx(UserDropdownContentButton, {
          renderButton: ({
            onClick
          }) => jsx(UserProfileButton, {
            profileUrl: imageUrl,
            onClick: onClick
          }),
          userMenu: userMenu
        })
      }), jsxs("div", {
        css: _ref$c,
        children: [signin && jsx(NoLoginMenuItem, {
          label: signin.title,
          href: signin.href,
          component: LinkComponent,
          logKey: "primary.right.login"
        }), signup && jsx(NoLoginMenuItem, {
          label: signup.title,
          href: signup.href,
          component: LinkComponent,
          logKey: "primary.right.signup"
        }), cs && jsx(NoLoginMenuItem, {
          label: cs.title,
          href: cs.href,
          component: LinkComponent,
          logKey: "primary.right.cs",
          css: /*#__PURE__*/css(MEDIA_QUERY.max('laptop', `
                  display: none;
                `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"))
        }), contact && jsx(NoLoginMenuItem, {
          label: contact.title,
          href: contact.href,
          component: "button",
          logKey: "primary.right.cs",
          onClick: contact.onClick,
          css: /*#__PURE__*/css(MEDIA_QUERY.max('laptop', `
                  display: none;
                `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PrimaryRight;"))
        })]
      }), uploadMenuLinks && uploadMenuLinks.length > 0 && jsx(UploadDropdownContentButton, {
        uploadMenuLinks: uploadMenuLinks
      }), seller && jsx(SellerButton, {
        href: seller.href
      })]
    })]
  });
}

function getActiveIds(menuSchema, fallbackMenuSchema) {
  // Check for fallback menu schema first
  if (fallbackMenuSchema != null) {
    const index = fallbackMenuSchema.findIndex(item => item.active);
    if (index !== -1) {
      return [null, index];
    }
  }
  // Try to descend down to the matching entry
  for (let i = 0; i < menuSchema.length; i += 1) {
    const child = menuSchema[i];
    const childActiveIds = getActiveIdsEntry(child);
    // If the child has 'active' entry, merge all indices
    if (childActiveIds != null) {
      return [i, ...childActiveIds];
    }
  }
  // Nothing matched
  return [null];
}
function getActiveIdsEntry(entry) {
  if (entry.entries != null) {
    for (let i = 0; i < entry.entries.length; i += 1) {
      const child = entry.entries[i];
      const childActiveIds = getActiveIdsEntry(child);
      // If the child has 'active' entry, merge all indices
      if (childActiveIds != null) {
        return [i, ...childActiveIds];
      }
    }
  }
  if (entry.active) {
    // If the entry itself is active, return itself
    return [];
  }
  // Otherwise, it didn't match
  return null;
}

/**
 * 요소의 포커스 상태를 감지하는 커스텀 훅
 *
 * @param {Function} onChange - 포커스 상태가 변경될 때 실행할 콜백 함수
 * @returns {[Function, Function]}
 *   1. `handleFocusIn`: 요소가 포커스를 받을 때 호출해야 하는 함수
 *   2. `handleFocusOut`: 요소의 포커스가 해제될 때 호출해야 하는 함수
 */
function useFocusedLatch(onChange) {
  const focusRef = useRef(null);
  const handleFocusIn = useCallback(() => {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    onChange(true);
  }, [onChange]);
  const handleFocusOut = useCallback(() => {
    if (focusRef.current != null) {
      cancelAnimationFrame(focusRef.current);
    }
    focusRef.current = requestAnimationFrame(() => onChange(false));
  }, [onChange]);
  return [handleFocusIn, handleFocusOut];
}

/** Secondary 메뉴 스키마를 리턴합니다 */
function getSecondaryEntries({
  primary,
  activeIds,
  fallbackMenuSchema
}) {
  if (primary != null) {
    return primary.entries ?? [];
  }
  if (activeIds[1] != null) {
    return fallbackMenuSchema ?? [];
  }
  return [];
}
/**
 * 바 메뉴의 상태를 관리합니다. 메뉴의 hover 여부와 선택된 메뉴 아이템들을 관리합니다.
 *
 * @returns {UseMenuStateReturn} - 메인 메뉴의 상태와 핸들러 함수를 포함한 반환 객체
 */
const useBarMenuState = ({
  menuSchema,
  fallbackMenuSchema
}) => {
  // 바 전체의 hover 여부와 선택(hover)된 메뉴 상태 관리
  const [{
    isHovered,
    selectedIds
  }, setState] = useState({
    isHovered: false,
    selectedIds: null
  });
  const setHovered = useCallback(value => {
    setState(prevState => ({
      ...prevState,
      isHovered: value,
      selectedIds: !value ? null : prevState.selectedIds
    }));
  }, []);
  const [onHoverIn, onHoverOut] = useFocusedLatch(setHovered);
  const activeIds = useMemo(() => getActiveIds(menuSchema, fallbackMenuSchema), [menuSchema, fallbackMenuSchema]);
  const currentSelectedIds = selectedIds == null ? activeIds : selectedIds;
  const primaryEntries = menuSchema;
  const primaryItem = currentSelectedIds[0] != null ? primaryEntries[currentSelectedIds[0]] : null;
  const secondaryEntries = getSecondaryEntries({
    primary: primaryItem ?? null,
    activeIds,
    fallbackMenuSchema
  });
  const secondaryItem = currentSelectedIds[1] != null ? secondaryEntries[currentSelectedIds[1]] : null;
  const handlePrimaryHover = useCallback((_, index) => {
    setState(prevState => ({
      ...prevState,
      selectedIds: [index]
    }));
  }, []);
  const handleSecondaryHover = useCallback((_, index) => {
    setState(prevState => ({
      ...prevState,
      selectedIds: [currentSelectedIds[0] ?? null, index]
    }));
  }, [currentSelectedIds]);
  const showTertiary = selectedIds?.[1] != null && secondaryItem?.renderBarChild != null;
  const activePrimaryItem = activeIds[0] != null ? primaryEntries[activeIds[0]] : null;
  const hasItemInActivePrimaryItem = activePrimaryItem?.entries != null ? activePrimaryItem.entries.length > 0 : false;
  const hasItemInHoveredPrimaryItem = primaryItem?.entries != null ? primaryItem.entries.length > 0 : false;
  return {
    isHovered,
    onHoverIn,
    onHoverOut,
    activeIds,
    currentSelectedIds,
    primaryEntries,
    primaryItem: primaryItem ?? null,
    secondaryEntries,
    secondaryItem: secondaryItem ?? null,
    handlePrimaryHover,
    handleSecondaryHover,
    showTertiary,
    hasItemInActivePrimaryItem,
    hasItemInHoveredPrimaryItem
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function LocalNavigationBar(props) {
  const log = useLogContext();
  const {
    logo,
    primaryLeftmost,
    menuSchema,
    fallbackMenuSchema,
    searchOptions,
    supplementary
  } = props;
  const {
    isHovered,
    onHoverIn,
    onHoverOut,
    activeIds,
    currentSelectedIds,
    primaryEntries,
    primaryItem,
    secondaryEntries,
    secondaryItem,
    handlePrimaryHover,
    handleSecondaryHover,
    showTertiary,
    hasItemInActivePrimaryItem,
    hasItemInHoveredPrimaryItem
  } = useBarMenuState({
    menuSchema,
    fallbackMenuSchema
  });
  const hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  const CustomPrimaryRight = supplementary.primaryRight ?? null;
  const secondaryRightElement = supplementary.secondaryRight != null ? /*#__PURE__*/React__default.createElement(supplementary.secondaryRight) : null;
  return jsxs("header", {
    children: [jsx(NavigationBarPrimary, {
      leftmost: primaryLeftmost,
      left: jsx(StyledLogo, {
        logo: logo,
        onClick: () => {
          log({
            key: 'logo',
            category: 'click'
          });
        }
      }),
      right: CustomPrimaryRight ? jsx(CustomPrimaryRightContainer, {
        children: jsx(CustomPrimaryRight, {})
      }) : jsx(PrimaryRight, {
        searchProps: searchOptions,
        ...supplementary
      }),
      menuEntries: primaryEntries,
      activeId: activeIds[0] ?? null,
      selectedId: currentSelectedIds[0] ?? null,
      onMouseEnter: onHoverIn,
      onMouseLeave: onHoverOut,
      onSelect: handlePrimaryHover
    }), jsx(NavigationBarSecondary, {
      right: secondaryRightElement,
      menuEntries: secondaryEntries,
      hasItems: hasItemInActivePrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      activeId: currentSelectedIds[0] === activeIds[0] || activeIds[1] ? activeIds[1] ?? null : null,
      primaryId: currentSelectedIds[0] ?? null,
      isForceOpened: isHovered && secondaryEntries.length > 0,
      isFallback: currentSelectedIds[0] == null && hasFallbackMenuSchema,
      onHoverIn: onHoverIn,
      onHoverOut: onHoverOut,
      onSelect: handleSecondaryHover,
      scrollableEntries: primaryItem?.scrollableEntries
    }), showTertiary && jsx(NavigationBarTertiary, {
      item: showTertiary ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onHoverIn,
      onMouseLeave: onHoverOut
    })]
  });
}
const StyledLogo = /*#__PURE__*/_styled(Logo$1, process.env.NODE_ENV === "production" ? {
  target: "eql07z71"
} : {
  target: "eql07z71",
  label: "StyledLogo"
})("height:26px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "zdz8xi",
  styles: "height:30px"
} : {
  name: "a7rwf-StyledLogo",
  styles: "height:30px;label:StyledLogo;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
}), ";");
const CustomPrimaryRightContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eql07z70"
} : {
  target: "eql07z70",
  label: "CustomPrimaryRightContainer"
})(MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "ffpekn-CustomPrimaryRightContainer",
  styles: "display:none;label:CustomPrimaryRightContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
}), ";");

var _path$3;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgGlobalLogo = function SvgGlobalLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 20,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M92.381 15.615c-1.164.96-2.603 1.64-4.17 1.64-2.097 0-3.285-1.133-3.766-2.75 3.766.557 9.226-.352 9.226-4.64 0-2.698-2.35-4.566-5.46-4.566-3.969 0-7.178 2.573-7.178 7.314 0 4.742 3.058 7.314 7.002 7.314 2.578 0 4.6-.907 5.965-2.169l-1.617-2.145zm-4.172-7.667c1.364 0 2.427.731 2.427 1.917 0 2.32-3.791 2.548-6.396 2.118.228-2.372 1.644-4.035 3.97-4.035M67.89 17.81c1.364 1.287 3.362 2.117 6.066 2.117 3.082 0 5.94-1.539 5.94-4.514 0-2.572-1.971-3.86-5.359-4.238l-.656-.076c-2.199-.252-2.654-.857-2.654-1.69 0-.732.733-1.513 2.401-1.513 1.67 0 3.286.732 4.475 1.69l1.567-2.32C78.28 6.106 76.18 5.3 73.755 5.3c-3.563 0-5.51 2.019-5.51 4.186 0 2.624 1.77 3.961 5.183 4.364l.656.076c2.224.252 2.805.833 2.805 1.767 0 1.035-1.163 1.613-3.008 1.613s-3.16-.706-4.296-1.766l-1.694 2.27zM53.281 14.427c0 3.583 2.325 5.498 4.878 5.498s3.816-1.438 4.575-2.75v2.422h3.185V5.625h-3.185v6.608c0 2.597-1.743 4.818-3.917 4.818-1.34 0-2.35-1.008-2.35-2.824V5.625h-3.184v8.804zM43.978 5.3c-4.523 0-7.406 3.177-7.406 7.313 0 4.137 2.883 7.314 7.406 7.314 4.524 0 7.406-3.177 7.406-7.314 0-4.136-2.882-7.314-7.406-7.314m0 11.778c-2.376 0-4.12-1.816-4.12-4.465s1.744-4.465 4.12-4.465 4.12 1.817 4.12 4.465c0 2.65-1.743 4.465-4.12 4.465M21.838 19.595h3.185v-6.607c0-2.597 1.82-4.819 4.018-4.819 1.39 0 2.452 1.009 2.452 2.825v8.601h3.184v-8.804c0-3.582-2.377-5.498-4.98-5.498-2.602 0-3.917 1.438-4.674 2.75V.401h-3.185zM9.934 0C4.246 0 0 4.314 0 9.988S4.246 20 9.934 20s9.933-4.287 9.933-10.012S15.621 0 9.934 0m0 16.95c-3.69 0-6.47-2.648-6.47-6.96s2.78-6.936 6.47-6.936 6.47 2.648 6.47 6.936c0 4.287-2.78 6.96-6.47 6.96"
  })));
};
var Logo = SvgGlobalLogo;

const GlobalPrimaryBarTab = ({
  children
}) => {
  return jsx(Flex, {
    direction: "row",
    display: {
      mobile: 'none',
      tablet: 'flex'
    },
    gap: 12,
    mr: 16,
    children: children
  });
};
function GlobalPrimaryBarTabItem({
  active,
  onHover,
  children,
  logData,
  ...rest
}) {
  const theme = useTheme();
  const LinkComponent = useLinkContext();
  return jsx(BasePrimaryBar.TabItem, {
    css: [/*#__PURE__*/css("color:", theme.colors.foregroundWeak, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:GlobalPrimaryBarTabItem;")), active && /*#__PURE__*/css("color:", theme.colors.foreground, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:GlobalPrimaryBarTabItem;")), HOVER$1`
          color: ${theme.colors.foreground};
        `, FOCUS`
          color: ${theme.colors.foreground};
        `, process.env.NODE_ENV === "production" ? "" : ";label:GlobalPrimaryBarTabItem;"],
    onHover: onHover,
    logData: {
      params: {
        ...logData.params,
        section_id: 'GNB',
        type: 'MENU'
      }
    },
    component: LinkComponent,
    ...rest,
    children: jsx(Box, {
      as: "span",
      py: 6,
      px: 4,
      children: jsx(Text$3, {
        variant: "heading20",
        weight: 600,
        whiteSpace: "nowrap",
        children: children
      })
    })
  });
}

const GlobalPrimaryBarSubMenu = ({
  children
}) => {
  return jsx(Flex, {
    direction: "row",
    gap: {
      mobile: 0,
      tablet: 12
    },
    py: 7,
    pl: {
      mobile: 0,
      tablet: 16
    },
    ml: "auto",
    children: children
  });
};
const GlobalPrimaryBarSubMenuItem = ({
  children,
  display = 'flex',
  order
}) => {
  return jsx(Flex, {
    display: display,
    align: "center",
    justify: "center",
    w: {
      mobile: 40,
      tablet: 'auto'
    },
    h: {
      mobile: 40,
      tablet: 'auto'
    },
    order: order,
    children: children
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const INITIAL_HEIGHT = 72;
function GlobalPrimaryBar({
  logo,
  mobileMenuButton,
  onHoverIn,
  onHoverOut,
  children
}) {
  const log = useLogContext();
  const LinkComponent = useLinkContext();
  return jsx(BasePrimaryBar, {
    initialHeight: INITIAL_HEIGHT,
    onHoverIn: onHoverIn,
    onHoverOut: onHoverOut,
    children: jsxs(Content$1, {
      children: [jsx(Flex, {
        display: {
          mobile: 'flex',
          tablet: 'none'
        },
        flex: "0 0 auto",
        mr: 4,
        children: mobileMenuButton
      }), jsx(LinkComponent, {
        href: logo.href,
        onClick: () => {
          log({
            key: 'primary.item',
            category: 'click',
            params: {
              index: 0,
              id: 'LOGO',
              section_id: 'GNB',
              type: 'MENU'
            }
          });
        },
        children: logo.item
      }), children]
    })
  });
}
GlobalPrimaryBar.Tab = GlobalPrimaryBarTab;
GlobalPrimaryBar.TabItem = GlobalPrimaryBarTabItem;
GlobalPrimaryBar.SubMenu = GlobalPrimaryBarSubMenu;
GlobalPrimaryBar.SubMenuItem = GlobalPrimaryBarSubMenuItem;
const Content$1 = /*#__PURE__*/_styled(Container$G, process.env.NODE_ENV === "production" ? {
  target: "e1lie0nj0"
} : {
  target: "e1lie0nj0",
  label: "Content"
})("display:flex;align-items:center;box-sizing:border-box;height:60px;padding-top:8px;padding-bottom:12px;line-height:0;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "11xp8ce",
  styles: "height:72px;padding-top:20px;padding-bottom:12px"
} : {
  name: "1e9jqcl-Content",
  styles: "height:72px;padding-top:20px;padding-bottom:12px;label:Content;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
}), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_PROFILE_URL = 'https://image.ohousecdn.com/i/bucketplace-v2-development/uploads/default_images/avatar.png';
const GlobalUserProfile = ({
  imageUrl = DEFAULT_PROFILE_URL,
  alt = ''
}) => {
  return jsxs(Box, {
    as: "span",
    display: "block",
    position: "relative",
    bdr: "50%",
    overflow: "hidden",
    children: [jsx(ProfileImage, {
      src: imageUrl,
      alt: alt,
      intrinsicInitialWidth: 24,
      intrinsicAspect: 1
    }), jsx(Border, {
      as: "span",
      display: "block",
      position: "absolute",
      inset: 0,
      bdr: "50%"
    })]
  });
};
const Border = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "e1nxy62p1"
} : {
  target: "e1nxy62p1",
  label: "Border"
})("border:0.5px solid ", ({
  theme
}) => theme.outline, ";");
const ProfileImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1nxy62p0"
} : {
  target: "e1nxy62p0",
  label: "ProfileImage"
})(process.env.NODE_ENV === "production" ? {
  name: "kxxzwl",
  styles: "vertical-align:middle;width:24px;height:24px;object-fit:cover"
} : {
  name: "kxxzwl",
  styles: "vertical-align:middle;width:24px;height:24px;object-fit:cover",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$b = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "1mh5jqu-GlobalLoginMenu",
  styles: "display:flex;align-items:center;label:GlobalLoginMenu;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
};
function GlobalLoginMenu({
  href,
  title
}) {
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  return jsxs(LinkComponent, {
    href: href,
    onClick: () => {
      log({
        key: 'primary.right.login',
        category: 'click'
      });
    },
    css: _ref$b,
    children: [jsx(GlobalUserProfile, {}), jsx(Box, {
      as: "span",
      px: 8,
      py: 4,
      children: jsx(Text$3, {
        variant: "body14L18",
        weight: 500,
        children: title
      })
    })]
  });
}

const GlobalUserMenu = ({
  profile,
  userMenu
}) => {
  return jsx(UserDropdownContentButton, {
    renderButton: ({
      onClick
    }) => jsx(Button$7, {
      type: "button",
      onClick: onClick,
      children: jsx(GlobalUserProfile, {
        imageUrl: profile?.imageUrl,
        alt: "Profile Menu"
      })
    }),
    userMenu: userMenu
  });
};
const Button$7 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "eq86tpe0"
} : {
  target: "eq86tpe0",
  label: "Button"
})(RESET_BUTTON, ";");

const GlobalScrapMenu = ({
  href,
  title
}) => {
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  return jsx(LinkComponent, {
    "aria-label": title,
    href: href,
    onClick: () => log({
      key: 'primary.right.scrap',
      category: 'click'
    }),
    children: jsx(ScrapIcon, {
      size: 24,
      fill: theme => theme.colors.foreground
    })
  });
};

const GlobalSecondaryBarTab = ({
  children
}) => {
  return jsx(TabContainer, {
    children: jsx(Flex, {
      as: "nav",
      direction: "row",
      overflow: "auto",
      children: children
    })
  });
};
const TabContainer = /*#__PURE__*/_styled(Container$G, process.env.NODE_ENV === "production" ? {
  target: "ew4qlmn0"
} : {
  target: "ew4qlmn0",
  label: "TabContainer"
})(MEDIA_QUERY.max('mobile', `
    padding: 0;
  `), ";");

function GlobalSecondaryBarTabItem({
  href,
  active,
  onHover,
  children,
  logData
}) {
  const LinkComponent = useLinkContext();
  const logClickEvent = () => {
    globalLog.logClickTab({
      section_idx: logData.params.index,
      section_id: logData.params.id
    });
  };
  return jsx(ImpressionTracker, {
    logData: {
      ...logData.params,
      type: 'topic',
      section: '서브 메뉴',
      section_id: 'LNB'
    },
    children: jsx(Flex, {
      position: "relative",
      onMouseEnter: onHover,
      miw: 75,
      flex: {
        mobile: '1',
        tablet: '0 1 auto'
      },
      children: jsxs(Flex, {
        as: LinkComponent,
        asProps: {
          href
        },
        display: "inline-flex",
        align: "center",
        justify: "center",
        py: 10,
        px: 6,
        onClick: logClickEvent,
        children: [jsx(TabText, {
          variant: "body15L24",
          weight: 700,
          color: active ? 'foreground' : 'foregroundWeak',
          whiteSpace: "nowrap",
          children: children
        }), active && jsx(Box, {
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          h: 2,
          bgc: "foreground"
        })]
      })
    })
  });
}
const TabText = /*#__PURE__*/_styled(Text$3, process.env.NODE_ENV === "production" ? {
  target: "e141rl5i0"
} : {
  target: "e141rl5i0",
  label: "TabText"
})(({
  theme
}) => /*#__PURE__*/css(HOVER$1`
      color: ${theme.colors.foreground};
    `, " ", FOCUS`
      color: ${theme.colors.foreground};
    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:TabText;")), ";");

function GlobalSecondaryBar({
  hasItems,
  isForceOpened,
  onHoverIn,
  onHoverOut,
  children
}) {
  return jsx(BaseSecondaryBar, {
    hasItems: hasItems,
    isForceOpened: isForceOpened,
    initialHeight: 44,
    onHoverIn: onHoverIn,
    onHoverOut: onHoverOut,
    children: children
  });
}
GlobalSecondaryBar.Tab = GlobalSecondaryBarTab;
GlobalSecondaryBar.TabItem = GlobalSecondaryBarTabItem;

const slideIn = keyframes`
  from {
    transform: translateX(50px);
  }
  to {
    transform: translateX(0);
  }
`;
function BaseSearchDrawer({
  className,
  defaultOpen = false,
  renderOpenButton,
  renderContents
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const drawerAnimation = {
    drawer: slideIn
  };
  const handleDrawerOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const handleDrawerClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  return jsxs("div", {
    css: className,
    children: [renderOpenButton({
      open: handleDrawerOpen
    }), jsx(Drawer, {
      open: isOpen,
      align: "right",
      onClose: handleDrawerClose,
      animationKeyframes: drawerAnimation,
      containerCss: /*#__PURE__*/css(safeAreaInset('bottom', 'padding-bottom'), " ", MEDIA_QUERY.min('tablet', `
            min-width: ${pxToRem(256)};
            max-width: ${pxToRem(326)};
            padding: ${pxToRem(30)};
          `), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:BaseSearchDrawer;")),
      children: renderContents({
        close: handleDrawerClose
      })
    })]
  });
}

function GlobalSearchDrawer({
  renderOpenButton,
  onSubmit,
  onSubmitItem,
  ...searchProps
}) {
  const {
    localeData
  } = useGNBData();
  return jsx(BaseSearchDrawer, {
    renderOpenButton: renderOpenButton,
    renderContents: ({
      close
    }) => jsx(NavigationSearch, {
      onSubmit: value => {
        close();
        onSubmit?.(value);
      },
      onSubmitItem: (item, isAutoComplete) => {
        close();
        onSubmitItem?.(item, isAutoComplete);
      },
      isInputAutoFocused: true,
      renderInputLeft: () => jsx(Button$6, {
        onClick: close,
        "aria-label": localeData?.search?.closeDrawer,
        children: jsx(ArrowLeftIcon, {
          size: 24,
          fill: theme => theme.colors.foreground
        })
      }),
      ...searchProps
    })
  });
}
const Button$6 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "evypqun0"
} : {
  target: "evypqun0",
  label: "Button"
})(RESET_BUTTON, " padding:8px;");

function GlobalSearch({
  ...props
}) {
  return jsxs(Box, {
    flex: 1,
    px: {
      mobile: 0,
      tablet: 8
    },
    children: [jsx(Search, {
      ...props
    }), jsx(GlobalSearchDrawer, {
      renderOpenButton: ({
        open
      }) => jsx(Button$5, {
        onClick: open,
        children: jsx(SearchIcon, {
          size: 24,
          fill: theme => theme.colors.foreground
        })
      }),
      ...props
    })]
  });
}
const Search = /*#__PURE__*/_styled(NavigationSearch, process.env.NODE_ENV === "production" ? {
  target: "eo4dvlk1"
} : {
  target: "eo4dvlk1",
  label: "Search"
})(MEDIA_QUERY.max('mobile', `
    display: none;
  `), ";");
const Button$5 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "eo4dvlk0"
} : {
  target: "eo4dvlk0",
  label: "Button"
})(RESET_BUTTON, " display:block;margin-left:auto;padding:8px;", MEDIA_QUERY.min('tablet', `
    display: none;
  `), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$a = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "riasdm-GlobalCartMenu",
  styles: "position:relative;label:GlobalCartMenu;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
};
const GlobalCartMenu = ({
  count,
  href,
  title
}) => {
  const LinkComponent = useLinkContext();
  const log = useLogContext();
  const handleClick = () => {
    log({
      key: 'primary.right.cart',
      category: 'click'
    });
  };
  return jsxs(LinkComponent, {
    "aria-label": title,
    href: href,
    onClick: handleClick,
    css: _ref$a,
    children: [!!count && count > 0 && jsx(StyledCartBadge, {
      value: count,
      size: 16
    }), jsx(CartIcon, {
      size: 24,
      fill: theme => theme.colors.foreground
    })]
  });
};
const StyledCartBadge = /*#__PURE__*/_styled(CircleBadge, process.env.NODE_ENV === "production" ? {
  target: "e1qxygwg0"
} : {
  target: "e1qxygwg0",
  label: "StyledCartBadge"
})(process.env.NODE_ENV === "production" ? {
  name: "2i1dfp",
  styles: "position:absolute;top:0;right:0;transform:translate(50%, -50%)"
} : {
  name: "2i1dfp",
  styles: "position:absolute;top:0;right:0;transform:translate(50%, -50%)",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});

function GlobalNavigationBar({
  logo,
  mobileMenuButton,
  menuSchema,
  fallbackMenuSchema,
  searchOptions,
  supplementary
}) {
  const {
    location
  } = useGNBData();
  const {
    isHovered,
    onHoverIn,
    onHoverOut,
    activeIds,
    currentSelectedIds,
    primaryEntries,
    secondaryEntries,
    secondaryItem,
    handlePrimaryHover,
    handleSecondaryHover,
    showTertiary,
    hasItemInActivePrimaryItem,
    hasItemInHoveredPrimaryItem
  } = useBarMenuState({
    menuSchema,
    fallbackMenuSchema
  });
  const hasFallbackMenuSchema = fallbackMenuSchema != null && fallbackMenuSchema.length > 0;
  const isLoggedIn = supplementary.userProfile?.userId != null;
  return jsxs("header", {
    children: [jsxs(GlobalPrimaryBar, {
      mobileMenuButton: mobileMenuButton,
      logo: {
        item: jsx(Box, {
          mr: 16,
          p: 2,
          pb: 4,
          children: jsx(Logo, {})
        }),
        href: logo?.href ?? 'https://www.ohouse.com'
      },
      onHoverIn: onHoverIn,
      onHoverOut: onHoverOut,
      children: [primaryEntries.length > 1 && jsx(GlobalPrimaryBar.Tab, {
        children: primaryEntries.map((item, index) => jsx(GlobalPrimaryBar.TabItem, {
          href: item.href,
          active: activeIds[0] === index,
          onHover: () => handlePrimaryHover(item, index),
          logData: {
            params: {
              index: index + 1,
              id: item.logId
            }
          },
          children: item.title
        }, index))
      }), searchOptions && jsx(GlobalSearch, {
        ...searchOptions
      }), jsxs(GlobalPrimaryBar.SubMenu, {
        children: [jsx(GlobalPrimaryBar.SubMenuItem, {
          order: {
            mobile: 1,
            tablet: 0
          },
          children: jsx(ChangeLocaleSection, {
            initialLocale: location?.locale ?? GLOBAL_DEFAULT_LOCALE
          })
        }), supplementary.scrap && jsx(GlobalPrimaryBar.SubMenuItem, {
          children: jsx(GlobalScrapMenu, {
            ...supplementary.scrap
          })
        }), supplementary.cart && jsx(GlobalPrimaryBar.SubMenuItem, {
          children: jsx(GlobalCartMenu, {
            ...supplementary.cart
          })
        }), !isLoggedIn && supplementary.signin && jsx(GlobalPrimaryBar.SubMenuItem, {
          display: {
            mobile: 'none',
            tablet: 'flex'
          },
          children: jsx(GlobalLoginMenu, {
            ...supplementary.signin
          })
        }), isLoggedIn && jsx(GlobalPrimaryBar.SubMenuItem, {
          display: {
            mobile: 'none',
            tablet: 'flex'
          },
          children: jsx(GlobalUserMenu, {
            profile: supplementary.userProfile,
            userMenu: supplementary.userMenu
          })
        })]
      })]
    }), jsx(GlobalSecondaryBar, {
      hasItems: hasItemInActivePrimaryItem || hasItemInHoveredPrimaryItem || hasFallbackMenuSchema,
      isForceOpened: isHovered && secondaryEntries.length > 0,
      onHoverIn: onHoverIn,
      onHoverOut: onHoverOut,
      children: jsx(GlobalSecondaryBar.Tab, {
        children: secondaryEntries.map((item, index) => jsx(GlobalSecondaryBar.TabItem, {
          href: item.href,
          active: currentSelectedIds[0] === activeIds[0] && activeIds[1] === index,
          onHover: () => handleSecondaryHover(item, index),
          logData: {
            params: {
              index,
              id: item.logId
            }
          },
          children: item.title
        }, index))
      })
    }), showTertiary && jsx(NavigationBarTertiary, {
      item: showTertiary && secondaryItem ? secondaryItem : null,
      isOpen: showTertiary,
      onMouseEnter: onHoverIn,
      onMouseLeave: onHoverOut
    })]
  });
}

function Navigation(props) {
  const {
    isGlobal
  } = useGNBData();
  const {
    logo,
    menuSchema,
    searchOptions,
    supplementary,
    fallbackMenuSchema,
    linkComponent,
    onLog,
    onAppDownload,
    location
  } = props;
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerToggle = useCallback(() => {
    setDrawerOpen(v => !v);
  }, []);
  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);
  const handleDrawerOpenButtonClick = useCallback(() => {
    onLog({
      key: 'drawer.button',
      category: 'click'
    });
    handleDrawerToggle();
  }, [handleDrawerToggle, onLog]);
  const isInApp = useIsInApp(location);
  if (isInApp) {
    return null;
  }
  return jsx(LinkProvider, {
    linkComponent: linkComponent,
    children: jsx(LogProvider, {
      onLog: onLog,
      children: isGlobal ? jsxs(Fragment, {
        children: [jsx(GlobalNavigationBar, {
          logo: logo,
          mobileMenuButton: jsx(GlobalMenuButton, {
            onClick: handleDrawerOpenButtonClick,
            children: jsx(MenuIcon, {
              size: 24,
              fill: theme => theme.colors.foreground
            })
          }),
          menuSchema: menuSchema,
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), jsx(GlobalNavigationDrawer, {
          open: isDrawerOpen,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      }) : jsxs(Fragment, {
        children: [jsx(LocalNavigationBar, {
          logo: logo,
          menuSchema: menuSchema,
          primaryLeftmost: jsx(Button$4, {
            type: "button",
            onClick: handleDrawerOpenButtonClick,
            children: jsx(Icon$2, {
              size: 24,
              name: "menu"
            })
          }),
          searchOptions: searchOptions,
          supplementary: supplementary,
          fallbackMenuSchema: fallbackMenuSchema
        }), jsx(LocalNavigationDrawer, {
          open: isDrawerOpen,
          logo: logo,
          menuSchema: menuSchema,
          supplementary: supplementary,
          onOpen: handleDrawerToggle,
          onClose: handleDrawerClose,
          onAppDownload: onAppDownload
        })]
      })
    })
  });
}
const Button$4 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e7erebj1"
} : {
  target: "e7erebj1",
  label: "Button"
})(RESET_BUTTON, " padding:", pxToRem(6), ";margin:", pxToRem(3), " ", pxToRem(1), ";color:", ({
  theme
}) => theme.content.base1, ";outline:none;");
const GlobalMenuButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e7erebj0"
} : {
  target: "e7erebj0",
  label: "GlobalMenuButton"
})(RESET_BUTTON, " padding:", pxToRem(8), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$9 = process.env.NODE_ENV === "production" ? {
  name: "1ic0q8",
  styles: "display:block;line-height:1"
} : {
  name: "1s9xtz7-StoreCategory",
  styles: "display:block;line-height:1;label:StoreCategory;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "d0zu4q",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;}"
} : {
  name: "12i7lqh-StoreCategory",
  styles: "position:relative;display:block;width:80px;height:80px;&>img{position:absolute;top:0;left:0;width:100%;border:0;};label:StoreCategory;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "11ldc4b",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;width:100px;padding:10px 0;font-size:14px;font-weight:bold;text-align:center"
} : {
  name: "13kytw8-StoreCategory",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;width:100px;padding:10px 0;font-size:14px;font-weight:bold;text-align:center;label:StoreCategory;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "laomuu",
  styles: "padding-right:60px"
} : {
  name: "1gjziyx-StoreCategory",
  styles: "padding-right:60px;label:StoreCategory;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
var _ref5 = process.env.NODE_ENV === "production" ? {
  name: "v61o11",
  styles: "max-width:1276px;padding:10px 0 10px 60px"
} : {
  name: "1wmzh4t-StoreCategory",
  styles: "max-width:1276px;padding:10px 0 10px 60px;label:StoreCategory;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
var _ref6 = process.env.NODE_ENV === "production" ? {
  name: "1qmr6ab",
  styles: "overflow:auto"
} : {
  name: "164muiv-StoreCategory",
  styles: "overflow:auto;label:StoreCategory;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
};
function StoreCategory({
  categories
}) {
  const Link = useLinkContext();
  const log = useLogContext();
  const theme = useTheme();
  return jsx("div", {
    css: _ref6,
    children: jsx("ul", {
      css: /*#__PURE__*/css("display:flex;justify-content:space-between;margin:0 auto;padding:10px 0 10px 40px;box-sizing:border-box;", MEDIA_QUERY.min('laptop', _ref5), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StoreCategory;")),
      children: categories.map((category, index) => jsx("li", {
        css: /*#__PURE__*/css("flex:0 0 auto;margin:0;padding:0 0 0 10px;color:", category.active ? theme.content.primary1.basic : theme.content.base1, ";&:last-of-type{padding-right:40px;", MEDIA_QUERY.min('laptop', _ref4), ";}&:hover{color:", theme.content.primary1.basic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:StoreCategory;")),
        children: jsxs(Link, {
          "data-testid": `category-${category.title}-link`,
          href: category.href,
          onClick: () => {
            log({
              key: 'tertiary.store.category.item',
              category: 'click',
              params: {
                id: category.logId,
                index
              }
            });
          },
          css: _ref3,
          children: [jsx("span", {
            css: _ref2,
            children: category.icon
          }), jsx("span", {
            css: _ref$9,
            children: category.title
          })]
        })
      }, category.title))
    })
  });
}

/* eslint-disable camelcase */

const TYPE_MAP = {
  'logo': () => ({
    click: {
      bucket: {
        section: '로고'
      }
    }
  }),
  // primary
  'primary.item': ({
    index,
    section_id,
    id,
    type
  }) => ({
    click: {
      bucket: {
        section: '메인 메뉴',
        index,
        section_id,
        id,
        type
      }
    }
  }),
  'primary.right.search.input': ({
    search_type
  }) => ({
    click: {
      bucket: {
        section: '검색'
      },
      amplitude: {
        type: '검색 필드 Clicked',
        search_type
      }
    }
  }),
  'primary.right.search.autocomplete.query': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '자동완성',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.autocomplete.history': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '자동완성_최근검색어',
        id,
        type,
        index
      }
    },
    impression: {
      bucket: {
        section: '자동완성_최근검색어',
        type
      }
    }
  }),
  'primary.right.search.autocomplete.category': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '추천 카테고리',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.autocomplete.navigation': ({
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section: '네비게이션',
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.autocomplete.navigation.global': ({
    section,
    id,
    type,
    index
  }) => ({
    click: {
      bucket: {
        section,
        id,
        type,
        index
      }
    },
    impression: {
      bucket: {
        section,
        id,
        type,
        index
      }
    }
  }),
  'primary.right.search.history': ({
    id,
    index
  }) => ({
    click: {
      bucket: {
        section: '최근 검색어',
        id,
        type: 'keyword',
        index
      }
    },
    impression: {
      bucket: {
        section: '최근 검색어',
        type: 'keyword'
      }
    }
  }),
  'primary.right.scrap': () => ({
    click: {
      bucket: {
        section: '스크랩북'
      },
      amplitude: {
        type: '스크랩북 Viewed',
        data: {
          source: {
            page: {
              tab: {
                main: '스크랩북'
              }
            },
            referrer: {
              type: '바로가기'
            }
          }
        }
      }
    }
  }),
  'primary.right.cart': () => ({
    click: {
      bucket: {
        section_id: 'TOPBAR',
        type: 'BUTTON',
        id: 'CART'
      }
    }
  }),
  'primary.right.notification': () => ({
    click: {
      bucket: {
        section: '알림'
      },
      amplitude: {
        type: '알림 리스트 Viewed'
      }
    }
  }),
  'primary.right.login': () => ({
    click: {
      bucket: {
        section: '로그인'
      }
    }
  }),
  'primary.right.signup': () => ({
    click: {
      bucket: {
        section: '회원가입'
      }
    }
  }),
  'primary.right.cs': () => ({
    click: {
      bucket: {
        section: '고객센터'
      }
    }
  }),
  'primary.right.user.dropdown': ({
    index,
    section_id
  }) => ({
    click: {
      bucket: {
        section: '유저 메뉴',
        index,
        type: 'menu',
        section_id
      }
    }
  }),
  'primary.right.mypage': () => ({
    click: {
      amplitude: {
        type: '계정 Viewed'
      }
    }
  }),
  'primary.right.logout': () => ({
    click: {
      amplitude: {
        type: '계정 Logout'
      }
    }
  }),
  'primary.right.upload': () => ({
    click: {
      bucket: {
        section: '글쓰기'
      }
    }
  }),
  'primary.right.upload.photo': () => ({
    click: {
      bucket: {
        section: '사진 올리기'
      }
    }
  }),
  // secondary
  'secondary.item': ({
    index,
    href,
    ...rest
  }) => ({
    click: {
      bucket: {
        index,
        url: typeof href === 'string' ? href : '/',
        ...rest
      }
    },
    impression: {
      bucket: {
        index,
        ...rest
      }
    }
  }),
  'secondary.interior': () => ({
    click: {
      bucket: {
        section: '3D인테리어'
      }
    }
  }),
  'secondary.more.button': () => ({
    click: {
      bucket: {
        section: '토픽',
        section_id: 'TOPIC',
        type: 'button',
        id: 'more_button'
      }
    }
  }),
  // tertiary
  'tertiary.store.category.item': ({
    id,
    index
  }) => ({
    click: {
      bucket: {
        section: '카테고리 메뉴',
        type: 'category',
        id,
        index
      }
    }
  }),
  // drawer
  'drawer.logo': () => ({
    click: {
      bucket: {
        section: 'drawer 로고'
      }
    }
  }),
  'drawer.button': () => ({
    click: {
      bucket: {
        section: '햄버거 메뉴'
      }
    }
  }),
  'drawer.main.item': ({
    index,
    section_id,
    id
  }) => ({
    click: {
      bucket: {
        section: '메인 메뉴',
        index,
        section_id,
        id
      }
    }
  }),
  'drawer.sub.item': ({
    index,
    href
  }) => ({
    click: {
      bucket: {
        section: '서브 메뉴',
        index,
        url: typeof href === 'string' ? href : '/'
      }
    }
  }),
  'drawer.user.item': ({
    index,
    section_id
  }) => ({
    click: {
      bucket: {
        section: '유저 메뉴',
        index,
        type: 'menu',
        section_id
      }
    }
  }),
  'drawer.user.profile': () => ({
    click: {
      bucket: {
        section: '유저 프로필'
      },
      amplitude: {
        type: '계정 Viewed'
      }
    }
  }),
  'popup.app.download': ({
    id
  }) => ({
    click: {
      bucket: {
        section: '웹투앱 유도 모달',
        type: 'BUTTON',
        id,
        section_id: 'WEBTOAPP_MODAL'
      }
    },
    impression: {
      bucket: {
        section: '웹투앱 유도 모달',
        type: 'MODAL',
        id,
        section_id: 'WEBTOAPP_MODAL'
      }
    }
  }),
  'banner.top.pc.click': ({
    index
  }) => ({
    click: {
      bucket: {
        section: '네비 배너',
        index
      }
    }
  }),
  'banner.top.mobile.click': () => ({
    click: {
      bucket: {
        section: '네비 배너'
      }
    }
  }),
  'banner.top.pc.close': () => ({
    click: {
      bucket: {
        section: '네비 배너 닫기'
      }
    }
  }),
  'banner.top.mobile.close': () => ({
    click: {
      bucket: {
        section: '네비 배너 닫기'
      }
    }
  })
};

const SEARCH_TYPE = {
  TOTAL: 'total',
  STORE: 'store',
  EXPERT: 'expert_user'
};

const GlobalBanner = ({
  linkComponent,
  getDeepLink,
  location,
  banner = {
    pcContentList: [],
    mobileImageSrc: ''
  },
  user,
  onClose,
  localeData
}) => {
  const handleLog = useCallback(({
    key,
    category,
    params
  }) => {
    const logData = TYPE_MAP[key](params || {})[category];
    const {
      bucket,
      amplitude
    } = logData || {};
    if (bucket) {
      switch (category) {
        case 'impression':
          {
            bucketImpressionLog(bucket);
            break;
          }
        case 'click':
        default:
          {
            bucketClickLog(bucket);
            break;
          }
      }
    }
    if (amplitude) {
      const {
        type,
        data
      } = amplitude;
      logAmplitude$1(`${type}`, data);
    }
  }, []);
  const handleAppOpen = useCallback(type => {
    window.location.href = getDeepLink({
      sub_id_1: type === 'banner.top.mobile.click' ? 'web_top_bnr' : 'web_bottom_bnr'
    });
  }, [getDeepLink]);
  return jsx(NavigationTopBanner, {
    location: location,
    pcContentList: banner.pcContentList,
    mobileImageSrc: banner.mobileImageSrc,
    linkComponent: linkComponent,
    onLog: handleLog,
    onAppOpen: handleAppOpen,
    isUserLoggedIn: !!user,
    onClosePCTopBanner: onClose?.pcTopBanner,
    onCloseMobileTopBanner: onClose?.mobileTopBanner,
    onCloseAppDownloadPopup: onClose?.appDownloadPopup,
    localeData: localeData
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$8 = process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "1szsjl2-FlagIcon",
  styles: "width:100%;height:100%;label:FlagIcon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
};
const FlagIcon = ({
  imageUrl,
  alt = '',
  size = 24
}) => {
  return jsx(Container$f, {
    as: "span",
    w: size,
    h: size,
    children: jsx(ResizeImage, {
      src: imageUrl,
      alt: alt,
      css: _ref$8,
      intrinsicInitialWidth: size,
      intrinsicAspect: 1
    })
  });
};
const Container$f = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "euw96tx0"
} : {
  target: "euw96tx0",
  label: "Container"
})("display:block;box-sizing:border-box;border-radius:50%;overflow:hidden;border:0.5px solid ", ({
  theme
}) => theme.colors.border, ";");

const IDFlagIcon = ({
  alt
}) => {
  return jsx(FlagIcon, {
    imageUrl: "https://prs.ohousecdn.com/apse1/global/global/v1-356929283580032.png",
    alt: alt
  });
};

const JPFlagIcon = ({
  alt
}) => {
  return jsx(FlagIcon, {
    imageUrl: "https://prs.ohousecdn.com/apne2/global/global/v1-356925365604416.png",
    alt: alt
  });
};

const USFlagIcon = ({
  alt
}) => {
  return jsx(FlagIcon, {
    imageUrl: "https://prs.ohousecdn.com/use1/global/global/v1-356929622110272.png",
    alt: alt
  });
};

const LANGUAGE_ITEMS = [{
  value: 'en',
  text: 'English'
}, {
  value: 'ja',
  text: '日本語'
}, {
  value: 'id',
  text: 'Bahasa Indonesia'
}];
// initialCountry가 가장 상단에 위치하도록 country 리스트를 가져옵니다.
const getCountries = ({
  localeData,
  initialCountry
}) => {
  const countryLabel = {
    US: localeData?.changeLocale?.countrySetting?.US ?? 'United states',
    JP: localeData?.changeLocale?.countrySetting?.JP ?? 'Japan',
    ID: localeData?.changeLocale?.countrySetting?.ID ?? 'Indonesia'
  };
  const defaultCountries = [{
    value: 'US',
    text: countryLabel.US,
    flagIcon: jsx(USFlagIcon, {
      alt: countryLabel.US
    })
  }, {
    value: 'JP',
    text: countryLabel.JP,
    flagIcon: jsx(JPFlagIcon, {
      alt: countryLabel.JP
    })
  }, {
    value: 'ID',
    text: countryLabel.ID,
    flagIcon: jsx(IDFlagIcon, {
      alt: countryLabel.ID
    })
  }];
  const index = defaultCountries.findIndex(country => country.value === initialCountry);
  const foundCountry = defaultCountries[index];
  if (foundCountry !== undefined) {
    return [foundCountry, ...defaultCountries.slice(0, index), ...defaultCountries.slice(index + 1)];
  } else {
    return defaultCountries;
  }
};

// initialLanguage가 가장 상단에 위치하도록 language 리스트를 가져옵니다.
const getLanguages = ({
  initialLanguage
}) => {
  const index = LANGUAGE_ITEMS.findIndex(language => language.value === initialLanguage);
  const foundLanguage = LANGUAGE_ITEMS[index];
  if (foundLanguage !== undefined) {
    return [foundLanguage, ...LANGUAGE_ITEMS.slice(0, index), ...LANGUAGE_ITEMS.slice(index + 1)];
  } else {
    return LANGUAGE_ITEMS;
  }
};
const ChangeLocaleContext = /*#__PURE__*/createContext(null);
function ChangeLocaleProvider({
  children,
  initialLocale,
  localeData
}) {
  const {
    initialLanguage,
    initialCountry,
    countries,
    languages
  } = useMemo(() => {
    const initialLanguage = getGlobalLanguageFromLocaleString(initialLocale);
    const initialCountry = getGlobalCountryFromLocaleString(initialLocale);
    const countries = getCountries({
      localeData,
      initialCountry
    });
    const languages = getLanguages({
      initialLanguage
    });
    return {
      initialLanguage,
      initialCountry,
      countries,
      languages
    };
  }, [localeData, initialLocale]);
  const [selectedLanguage, setSelectedLanguage] = useState(initialLanguage);
  const [selectedCountry, setSelectedCountry] = useState(initialCountry);
  const contextValue = useMemo(() => ({
    initialLanguage,
    initialCountry,
    selectedLanguage,
    selectedCountry,
    countries,
    languages,
    setSelectedLanguage,
    setSelectedCountry
  }), [initialLanguage, initialCountry, countries, languages, selectedLanguage, setSelectedLanguage, selectedCountry, setSelectedCountry]);
  return jsx(ChangeLocaleContext.Provider, {
    value: contextValue,
    children: children
  });
}
function useChangeLocaleData() {
  const changeLocaleContextValue = useContext(ChangeLocaleContext);
  if (changeLocaleContextValue === null) {
    throw new Error('The useChangeLocaleData must be used within a ChangeLocaleContext');
  }
  return {
    ...changeLocaleContextValue
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChangeLocaleLanguage = () => {
  const {
    selectedLanguage,
    setSelectedLanguage,
    languages
  } = useChangeLocaleData();
  const {
    localeData
  } = useGNBData();
  return jsxs(Container$e, {
    children: [jsx(SectionTitle$1, {
      children: localeData?.changeLocale?.languageSectionTitle ?? 'Language'
    }), languages.map(language => jsx("label", {
      children: jsx(Item$1, {
        size: "compact",
        children: jsx(RadioWithText, {
          id: `language-${language.value}`,
          onChange: e => {
            if (e.target.checked) {
              setSelectedLanguage(language.value);
            }
          },
          checked: selectedLanguage === language.value,
          children: language.text
        })
      })
    }, language.value))]
  });
};
const Container$e = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efs6ql12"
} : {
  target: "efs6ql12",
  label: "Container"
})();
const SectionTitle$1 = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "efs6ql11"
} : {
  target: "efs6ql11",
  label: "SectionTitle"
})("padding:16px 16px 12px 16px;", FONT_STYLE.body16L20, ";font-weight:700;text-align:left;");
const Item$1 = /*#__PURE__*/_styled(ListItem$1, process.env.NODE_ENV === "production" ? {
  target: "efs6ql10"
} : {
  target: "efs6ql10",
  label: "Item"
})(process.env.NODE_ENV === "production" ? {
  name: "kewzb2",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;height:48px;&:active{font-weight:700;}"
} : {
  name: "kewzb2",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;height:48px;&:active{font-weight:700;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChangeLocaleCountry = () => {
  const {
    selectedCountry,
    setSelectedCountry,
    countries
  } = useChangeLocaleData();
  const {
    localeData
  } = useGNBData();
  const [isOpened, setIsOpened] = useState(false);
  return jsxs(Container$d, {
    children: [jsxs(SectionTitle, {
      isOpened: isOpened,
      onClick: () => setIsOpened(value => !value),
      children: [localeData?.changeLocale?.countrySectionTitle ?? 'Country', jsx(StyledChevronDownIcon, {
        size: 18,
        fill: theme => theme.base.neutral500
      })]
    }), countries.map(country => jsx("label", {
      children: jsx(ItemContainer$1, {
        isOpened: isOpened,
        children: jsx(Item, {
          size: "compact",
          children: jsx(RadioWithText, {
            id: `country-${country.value}`,
            onChange: e => {
              if (e.target.checked) {
                setSelectedCountry(country.value);
              }
            },
            checked: selectedCountry === country.value,
            children: country.text
          })
        })
      })
    }, country.value))]
  });
};
const Container$d = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ufii544"
} : {
  target: "e1ufii544",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "15g9qpz",
  styles: "position:relative;overflow:hidden;cursor:pointer"
} : {
  name: "15g9qpz",
  styles: "position:relative;overflow:hidden;cursor:pointer",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
const SectionTitle = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1ufii543"
} : {
  target: "e1ufii543",
  label: "SectionTitle"
})("padding:0px 16px 12px 16px;", FONT_STYLE.body16L20, ";text-align:left;font-weight:700;", ({
  isOpened
}) => isOpened && `
    font-weight: 700;
    border-bottom: 0px;
    & svg {
      transform: rotate(180deg);
    }
  `, ";");
const Item = /*#__PURE__*/_styled(ListItem$1, process.env.NODE_ENV === "production" ? {
  target: "e1ufii542"
} : {
  target: "e1ufii542",
  label: "Item"
})(process.env.NODE_ENV === "production" ? {
  name: "kewzb2",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;height:48px;&:active{font-weight:700;}"
} : {
  name: "kewzb2",
  styles: "cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:left;height:48px;&:active{font-weight:700;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
const StyledChevronDownIcon = /*#__PURE__*/_styled(ChevronDownIcon$1, process.env.NODE_ENV === "production" ? {
  target: "e1ufii541"
} : {
  target: "e1ufii541",
  label: "StyledChevronDownIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "11bt2f5",
  styles: "position:absolute;top:0px;right:16px;transition:0.2s"
} : {
  name: "11bt2f5",
  styles: "position:absolute;top:0px;right:16px;transition:0.2s",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
});
const ItemContainer$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ufii540"
} : {
  target: "e1ufii540",
  label: "ItemContainer"
})("box-sizing:border-box;height:0px;opacity:0;transition:0.2s;white-space:pre-line;", ({
  isOpened
}) => isOpened && `
    height: auto;
    opacity: 1;
  `, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChangeLocaleContent = ({
  onClickConfirm
}) => {
  const {
    initialCountry,
    initialLanguage,
    selectedCountry,
    selectedLanguage
  } = useChangeLocaleData();
  const {
    localeData
  } = useGNBData();
  const handleClickConfirm = () => {
    onClickConfirm({
      country: selectedCountry,
      language: selectedLanguage
    });
  };
  return jsxs(Container$c, {
    children: [jsxs(SelectContainer, {
      children: [jsx(ChangeLocaleLanguage, {}), jsx(StyledDivider, {
        variant: "thin"
      }), jsx(ChangeLocaleCountry, {})]
    }), jsx(ButtonContainer, {
      children: jsx(StyledButton, {
        type: "button",
        size: 40,
        variant: "base1",
        full: true,
        onClick: () => handleClickConfirm(),
        disabled: initialCountry === selectedCountry && initialLanguage === selectedLanguage,
        children: localeData?.changeLocale?.confirmButton ?? 'Confirm'
      })
    })]
  });
};
const Container$c = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evev0c04"
} : {
  target: "evev0c04",
  label: "Container"
})("position:relative;display:flex;flex-direction:column;padding:8px;background-color:", ({
  theme
}) => theme.background.base, ";", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "1hm73hq",
  styles: "max-height:394px;padding:0px"
} : {
  name: "ggfzgq-Container",
  styles: "max-height:394px;padding:0px;label:Container;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
}), " z-index:", ZINDEX$1.snackbar, ";");
const SelectContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evev0c03"
} : {
  target: "evev0c03",
  label: "SelectContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1jasg0b",
  styles: "flex-grow:1;overflow-y:auto"
} : {
  name: "1jasg0b",
  styles: "flex-grow:1;overflow-y:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
});
const ButtonContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evev0c02"
} : {
  target: "evev0c02",
  label: "ButtonContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "14atq0m",
  styles: "padding:16px;flex-shrink:0"
} : {
  name: "14atq0m",
  styles: "padding:16px;flex-shrink:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
});
const StyledDivider = /*#__PURE__*/_styled(Divider, process.env.NODE_ENV === "production" ? {
  target: "evev0c01"
} : {
  target: "evev0c01",
  label: "StyledDivider"
})(process.env.NODE_ENV === "production" ? {
  name: "12jd8yt",
  styles: "margin:20px 0px"
} : {
  name: "12jd8yt",
  styles: "margin:20px 0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
});
const StyledButton = /*#__PURE__*/_styled(Button$9, process.env.NODE_ENV === "production" ? {
  target: "evev0c00"
} : {
  target: "evev0c00",
  label: "StyledButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "1j389vi",
  styles: "font-weight:700",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
});

const ChangeLocaleDropdown = ({
  dropdownRef,
  title,
  onClickConfirm,
  onClose
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  return jsx(DropdownWrapper, {
    "data-testid": "language-dropdown",
    ref: dropdownRef,
    children: isMobile ? jsx(Modal, {
      width: 600,
      onBlur: onClose,
      header: {
        title,
        onClose
      },
      children: jsx(ChangeLocaleContent, {
        onClickConfirm: onClickConfirm
      })
    }) : jsxs(Fragment, {
      children: [jsx(ChangeLocaleContent, {
        onClickConfirm: onClickConfirm
      }), jsx(Dim$1, {
        variant: "basic",
        onClick: onClose
      })]
    })
  });
};
const DropdownWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "euk4na40"
} : {
  target: "euk4na40",
  label: "DropdownWrapper"
})("position:absolute;top:calc(100% + 16px);right:0px;min-width:310px;overflow:hidden;background-color:", ({
  theme
}) => theme.background.base, ";border-radius:8px;box-shadow:0px 2px 10px 0px ", ({
  theme
}) => theme.shadow.darken, ";&>div>div{border:0px;}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ChangeLocaleButton = () => {
  const {
    initialCountry,
    initialLanguage,
    languages,
    countries
  } = useChangeLocaleData();
  const isMobile = useResponsive().breakpoint === 'mobile';
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const selectedCountryIcon = countries.find(item => item.value === initialCountry)?.flagIcon;
  const selectedLanguageText = useMemo(() => {
    return languages.find(item => item.value === initialLanguage)?.text ?? '';
  }, [languages, initialLanguage]);
  const redirectToNewUrlWithLocale = locale => {
    location.href = getUrlWithExchangeLocale(location.href, locale);
  };
  const handleClickLocaleButton = () => {
    globalLog.logClickChangeLocaleButton();
    setIsDropdownOpen(value => !value);
  };
  const handleClickDropdownConfirm = ({
    country,
    language
  }) => {
    setIsDropdownOpen(false);
    const newLocale = `${language}-${country}`;
    globalLog.logClickChangeLocaleSubmitButton({
      language,
      country
    });
    if (isAllowedGlobalLocale(newLocale)) {
      redirectToNewUrlWithLocale(newLocale);
    }
  };
  return jsxs(Box, {
    position: "relative",
    pl: {
      mobile: 0,
      tablet: 24
    },
    children: [jsxs(Button$3, {
      variant: "neutral-600",
      size: 14,
      rightIcon: isMobile ? undefined : ChevronDownIcon$1,
      onClick: handleClickLocaleButton,
      children: [selectedCountryIcon && jsx(Box, {
        as: "span",
        position: {
          mobile: 'static',
          tablet: 'absolute'
        },
        left: -24,
        w: 24,
        h: 24,
        children: selectedCountryIcon
      }), jsx(MobileVisuallyHidden, {
        children: selectedLanguageText
      })]
    }), isDropdownOpen && jsx(ChangeLocaleDropdown, {
      title: "",
      dropdownRef: dropdownRef,
      onClose: () => setIsDropdownOpen(false),
      onClickConfirm: handleClickDropdownConfirm
    })]
  });
};
const Button$3 = /*#__PURE__*/_styled(TextButton$1, process.env.NODE_ENV === "production" ? {
  target: "e15b5nbb1"
} : {
  target: "e15b5nbb1",
  label: "Button"
})("font-weight:500;", MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "96tuw5-Button",
  styles: "padding:0;label:Button;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
}), "@media (hover: hover) and (pointer: fine){&:hover::after{background-color:transparent;}}");
const MobileVisuallyHidden = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e15b5nbb0"
} : {
  target: "e15b5nbb0",
  label: "MobileVisuallyHidden"
})(MEDIA_QUERY.max('mobile', process.env.NODE_ENV === "production" ? {
  name: "njtxm6",
  styles: "position:absolute;width:1px;height:1px;margin:-1px;white-space:nowrap;clip:rect(0 0 0 0);overflow:hidden"
} : {
  name: "i25pbi-MobileVisuallyHidden",
  styles: "position:absolute;width:1px;height:1px;margin:-1px;white-space:nowrap;clip:rect(0 0 0 0);overflow:hidden;label:MobileVisuallyHidden;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
}), ";");

const ChangeLocaleSection = ({
  initialLocale = GLOBAL_DEFAULT_LOCALE
}) => {
  const {
    localeData
  } = useGNBData();
  return jsx(ChangeLocaleProvider, {
    localeData: localeData,
    initialLocale: initialLocale,
    children: jsx(ChangeLocaleButton, {})
  });
};

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];
      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules

var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
    visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...

      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false

  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument :
  // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot ||
    // step into the shadow DOM of the parent of a slotted node
    element.parentNode || (
    // DOM Element detected
    isShadowRoot(element) ? element.host : null) ||
    // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) ||
  // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }
  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block

function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);
    if (elementCss.position === 'fixed') {
      return null;
    }
  }
  var currentNode = getParentNode$1(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.

function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state,
    name = _ref.name,
    options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';
  if (!arrowElement || !popperOffsets) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state,
    options = _ref2.options;
  var _options$element = options.element,
    arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
  if (arrowElement == null) {
    return;
  } // CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules

var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
    y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
    popperRect = _ref2.popperRect,
    placement = _ref2.placement,
    variation = _ref2.variation,
    offsets = _ref2.offsets,
    position = _ref2.position,
    gpuAcceleration = _ref2.gpuAcceleration,
    adaptive = _ref2.adaptive,
    roundOffsets = _ref2.roundOffsets,
    isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
    x = _offsets$x === void 0 ? 0 : _offsets$x,
    _offsets$y = offsets.y,
    y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
      // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
      // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
    options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
    gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
    _options$adaptive = options.adaptive,
    adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
    _options$roundOffsets = options.roundOffsets,
    roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
    instance = _ref.instance,
    options = _ref.options;
  var _options$scroll = options.scroll,
    scroll = _options$scroll === void 0 ? true : _options$scroll,
    _options$resize = options.resize,
    resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }
  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules

var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
    overflow = _getComputedStyle.overflow,
    overflowX = _getComputedStyle.overflowX,
    overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList :
  // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`

function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents

function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
    element = _ref.element,
    placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$placement = _options.placement,
    placement = _options$placement === void 0 ? state.placement : _options$placement,
    _options$strategy = _options.strategy,
    strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
    _options$boundary = _options.boundary,
    boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
    _options$rootBoundary = _options.rootBoundary,
    rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
    _options$elementConte = _options.elementContext,
    elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
    _options$altBoundary = _options.altBoundary,
    altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
    _options$padding = _options.padding,
    padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }
  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    placement = _options.placement,
    boundary = _options.boundary,
    rootBoundary = _options.rootBoundary,
    padding = _options.padding,
    flipVariations = _options.flipVariations,
    _options$allowedAutoP = _options.allowedAutoPlacements,
    allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
    specifiedFallbackPlacements = options.fallbackPlacements,
    padding = options.padding,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    _options$flipVariatio = options.flipVariations,
    flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
    allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];
  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);
        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break") break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules

var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state,
    name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules

var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
    skidding = _ref[0],
    distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
    options = _ref2.options,
    name = _ref2.name;
  var _options$offset = options.offset,
    offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
    x = _data$state$placement.x,
    y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
    name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules

var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
    options = _ref.options,
    name = _ref.name;
  var _options$mainAxis = options.mainAxis,
    checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
    _options$altAxis = options.altAxis,
    checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
    boundary = options.boundary,
    rootBoundary = options.rootBoundary,
    altBoundary = options.altBoundary,
    padding = options.padding,
    _options$tether = options.tether,
    tether = _options$tether === void 0 ? true : _options$tether,
    _options$tetherOffset = options.tetherOffset,
    tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === 'x' ? top : left;
    var _altSide = mainAxis === 'x' ? bottom : right;
    var _offset = popperOffsets[altAxis];
    var _len = altAxis === 'y' ? 'height' : 'width';
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules

var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' ||
    // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }
    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
    _generatorOptions$def = _generatorOptions.defaultModifiers,
    defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
    _generatorOptions$def2 = _generatorOptions.defaultOptions,
    defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
          reference = _state$elements.reference,
          popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers

        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
            fn = _state$orderedModifie.fn,
            _state$orderedModifie2 = _state$orderedModifie.options,
            _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
            name = _state$orderedModifie.name;
          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      return instance;
    }
    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
          _ref$options = _ref.options,
          options = _ref$options === void 0 ? {} : _ref$options,
          effect = _ref.effect;
        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });
          var noopFn = function noopFn() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompare);

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (isEqual(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

const ConditionalPortal = ({
  usePortal,
  children
}) => {
  return usePortal ? /*#__PURE__*/createPortal(children, document.body) : children;
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DEFAULT_ARROW = {
  width: 14,
  height: 10,
  color: theme => theme.background.base
};
const InfoTip = ({
  children,
  renderOpener,
  onOpenChange,
  openOnHover,
  offsetTop = 4,
  arrow: arrowProps = {},
  forceOpen,
  forceClose,
  contentClassName,
  contentStyle,
  buttonStyle,
  usePortal = false
}) => {
  const buttonRef = useRef(null);
  const [arrowRef, setArrowRef] = useState(null);
  const [ref, setRef] = useState(null);
  const [isOpenState, setIsOpenState] = useState(false);
  const arrow = useMemo(() => ({
    ...DEFAULT_ARROW,
    ...arrowProps
  }), [arrowProps]);
  const {
    styles,
    attributes,
    state,
    update
  } = usePopper(buttonRef.current, ref, {
    placement: 'bottom',
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, offsetTop + arrow.height]
      }
    }, {
      name: 'arrow',
      enabled: true,
      options: {
        element: arrowRef
      }
    }]
  });

  // 버튼의 스타일이 변경될 때 popper 위치를 다시 계산함
  // e.g) 드래그 했을 때 버튼의 스타일이 변경되는 경우 대응
  useEffect(() => {
    update?.();
  }, [buttonStyle, update]);
  const handleOpen = useCallback(() => {
    setIsOpenState(true);
    onOpenChange?.(true);
  }, [onOpenChange]);
  const handleClose = useCallback(() => {
    setIsOpenState(false);
    onOpenChange?.(false);
  }, [onOpenChange]);
  const handleToggle = useCallback(() => {
    if (isOpenState) {
      handleClose();
      return;
    }
    handleOpen();
  }, [isOpenState, handleOpen, handleClose]);
  const handleMouseEnter = useCallback(() => {
    if (openOnHover) {
      handleOpen();
    }
  }, [openOnHover, handleOpen]);
  const handleMouseLeave = useCallback(() => {
    if (openOnHover) {
      handleClose();
    }
  }, [openOnHover, handleClose]);
  const isOpen = Boolean((isOpenState || forceOpen) && !forceClose);
  return jsxs(Fragment, {
    children: [jsx(ButtonWrapper, {
      ref: buttonRef,
      style: buttonStyle,
      children: renderOpener({
        isOpen,
        onToggle: handleToggle,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      })
    }), isOpen && jsx(ConditionalPortal, {
      usePortal: usePortal,
      children: jsx(CSSTransition$1, {
        in: ref !== null && isOpen,
        timeout: 200,
        classNames: {
          enterActive: 'open',
          enterDone: 'open open-active',
          appearDone: 'open',
          exit: 'exiting'
        },
        children: jsxs(StyledContent, {
          ref: setRef,
          style: {
            ...styles['popper'],
            ...contentStyle
          },
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          offset: offsetTop + arrow.height,
          className: classNames(state?.placement ?? 'auto', contentClassName),
          ...attributes['popper'],
          children: [jsx(Arrow$1, {
            ref: setArrowRef,
            style: styles['arrow'],
            placement: state?.placement ?? 'auto',
            arrow: arrow,
            "data-popper-arrow": true,
            className: state?.placement
          }), jsx(ChildrenWrapper, {
            style: styles['offset'],
            children: children
          })]
        })
      })
    })]
  });
};
const ButtonWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au3"
} : {
  target: "et5x4au3",
  label: "ButtonWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1kx8xpu",
  styles: "line-height:0;display:inline-block"
} : {
  name: "1kx8xpu",
  styles: "line-height:0;display:inline-block",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
});

// 화살표 팁과 Content 영역 사이에 마우스가 위치해도 열림 상태를 유지하기 위한 레이어
const cssBackLayer = process.env.NODE_ENV === "production" ? {
  name: "m00t7o",
  styles: "content:'';width:100%;height:100%;position:absolute;left:0;z-index:-1"
} : {
  name: "tzqjda-cssBackLayer",
  styles: "content:'';width:100%;height:100%;position:absolute;left:0;z-index:-1;label:cssBackLayer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};
const StyledContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au2"
} : {
  target: "et5x4au2",
  label: "StyledContent"
})("z-index:1;&[data-popper-placement^='bottom']{&:before{", cssBackLayer, " top:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='top']{&:before{", cssBackLayer, " bottom:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='right']{&:before{", cssBackLayer, " left:", ({
  offset
}) => pxToRem(-offset), ";}}&[data-popper-placement^='left']{&:before{", cssBackLayer, " right:", ({
  offset
}) => pxToRem(-offset), ";}}visibility:hidden;opacity:0;pointer-events:none;&.open{visibility:visible;opacity:1;transform:none;transition:0.2s opacity,0.2s transform;}&.open-active{pointer-events:auto;}&.exiting{transition:visibility 0.2s,0.2s opacity,0.2s transform;}");
const ChildrenWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au1"
} : {
  target: "et5x4au1",
  label: "ChildrenWrapper"
})();
var _ref$7 = process.env.NODE_ENV === "production" ? {
  name: "guiuzv",
  styles: "content:'';position:absolute;width:0;height:0;left:0"
} : {
  name: "1d4h9tq-common",
  styles: "content:'';position:absolute;width:0;height:0;left:0;label:common;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};
const generateArrow = (placement, arrow, theme) => {
  const common = _ref$7;
  if (placement.startsWith('bottom')) {
    return /*#__PURE__*/css(common, " border-bottom:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-left:", pxToRem(arrow.width / 2), " solid transparent;border-right:", pxToRem(arrow.width / 2), " solid transparent;", arrow.generateBorderStyle && /*#__PURE__*/css(arrow.generateBorderStyle('border-bottom'), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"));
  }
  if (placement.startsWith('top')) {
    return /*#__PURE__*/css(common, " border-top:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-left:", pxToRem(arrow.width / 2), " solid transparent;border-right:", pxToRem(arrow.width / 2), " solid transparent;", arrow.generateBorderStyle && /*#__PURE__*/css(arrow.generateBorderStyle('border-top'), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"));
  }
  if (placement.startsWith('right')) {
    return /*#__PURE__*/css(common, " border-right:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-bottom:", pxToRem(arrow.width / 2), " solid transparent;border-top:", pxToRem(arrow.width / 2), " solid transparent;", arrow.generateBorderStyle && /*#__PURE__*/css(arrow.generateBorderStyle('border-right'), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"));
  }
  return /*#__PURE__*/css(common, " border-left:", pxToRem(arrow.height), " solid ", arrow.color(theme), ";border-top:", pxToRem(arrow.width / 2), " solid transparent;border-bottom:", pxToRem(arrow.width / 2), " solid transparent;", arrow.generateBorderStyle && /*#__PURE__*/css(arrow.generateBorderStyle('border-left'), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:generateArrow;"));
};
const Arrow$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "et5x4au0"
} : {
  target: "et5x4au0",
  label: "Arrow"
})(({
  arrow
}) => arrow && `
    width: ${pxToRem(arrow.width)};
    height: ${pxToRem(arrow.height)};`, " ", ({
  arrow
}) => `
    &[class^="bottom"] {
      top: ${pxToRem(-arrow.height)};
    }
    &[class^="top"] {
      bottom: ${pxToRem(-arrow.height)};
    }
    &[class^="right"] {
      left: ${pxToRem(-arrow.height)};
    }
    &[class^="left"] {
      right: ${pxToRem(-arrow.height)};
    }
  `, "&:after{z-index:2;", ({
  placement,
  arrow,
  theme
}) => placement && generateArrow(placement, arrow, theme), ";}", ({
  arrow,
  placement,
  theme
}) => arrow.backLayerColor && /*#__PURE__*/css("&:before{z-index:1;", placement && generateArrow(placement, {
  ...arrow,
  color: theme => arrow.backLayerColor?.(theme) ?? theme.colors.background
}, theme), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:Arrow;")), ";");

const useFilterTags = ({
  schema,
  query,
  onChangeQuery
}) => {
  const [tags, setTags] = useState([]);
  const serializeTags = useCallback(tags => schema.map(schemaEntry => schemaEntry.serializer.serialize).reduce((prev, serialize) => ({
    ...prev,
    ...serialize(tags)
  }), {}), [schema]);
  const deserializeTags = useCallback(() => schema.map(schemaEntry => schemaEntry.serializer.deserialize).reduce((prev, deserialize) => [...prev, ...deserialize(query)], []), [schema, query]);
  const handleChangeTags = useCallback(tags => {
    const queryParams = serializeTags(tags);
    onChangeQuery({
      ...omitBy(queryParams, value => value == null)
    });
    setTags(tags);
  }, [serializeTags, onChangeQuery]);
  useEffect(() => {
    setTags(deserializeTags());
  }, [query, deserializeTags]);
  return {
    handleChangeTags,
    tags
  };
};

const useFilterListModal = ({
  schema,
  tags,
  handleChangeTags
}) => {
  const [selectedEntryId, setSelectedEntryId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedEntryId(null);
  }, []);
  const activeEntry = schema.find(entry => entry.id === selectedEntryId);
  const isSelectedByQuery = entry => {
    return tags.some(tag => entry.hasTag(tag));
  };
  const showResetButton = activeEntry ? isSelectedByQuery(activeEntry) && activeEntry.config?.showResetButtonOnSelected?.mobile : schema.some(entry => isSelectedByQuery(entry) && entry.config?.showResetButtonOnSelected?.mobile);
  const reset = showResetButton ? () => {
    if (!activeEntry) {
      handleChangeTags([]);
    } else {
      handleChangeTags(tags.filter(tag => tag.id !== activeEntry.id));
    }
  } : undefined;
  return {
    reset,
    selectedEntryId,
    selectEntry: setSelectedEntryId,
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal
  };
};

const defaultLocaleData = {
  filter: '필터',
  reset: '초기화',
  apply: '확인',
  showAllFilter: '전체 필터 보기'
};
const LocaleDataContext = /*#__PURE__*/createContext(defaultLocaleData);
function LocaleDataProvider({
  children,
  data
}) {
  return jsx(LocaleDataContext.Provider, {
    value: data,
    children: children
  });
}
function useLocaleData() {
  return useContext(LocaleDataContext);
}

const FilterKey = {
  /** 다중 선택 리스트 필터 ex)스타일 필터 */
  MULTI_SELECT_LIST: 'multiSelectList',
  /** 단일 선택 리스트 필터 ex)정렬 필터 */
  SINGLE_SELECT_LIST: 'singleSelectList',
  /** 범위 선택 리스트 필터 ex)예산 필터 */
  RANGE: 'range',
  /** 중첩 필터 ex)지역 필터 */
  NESTED: 'nested',
  /** 여러 필터를 그룹으로 묶어서 선택할 수 있는 필터  */
  /** 동시에 여러 필터를 선택할 수 있는 그룹 필터 ex) 컬러 필터의 벽/바닥 컬러 필터 */
  MULTI_SELECT_GROUP: 'multiSelectGroup',
  /** 그룹 필터 중 한개의 필터만 선택할 수 있는 그룹 필터 ex)컬러 필터 */
  SINGLE_SELECT_GROUP: 'singleSelectGroup',
  /** 다중 색상 선택 필터 */
  MULTI_SELECT_COLOR: 'multiSelectColor',
  /** 단일 색상 선택 필터 */
  SINGLE_SELECT_COLOR: 'singleSelectColor'
};

const ListPanelDropdownItem = ({
  buttonText,
  caption,
  onClick,
  isActive
}) => {
  return jsxs(ItemButton$4, {
    type: "button",
    onClick: onClick,
    children: [jsx(Title$2, {
      isActive: isActive,
      children: buttonText
    }), jsx(Caption$1, {
      children: caption
    })]
  });
};
const ItemButton$4 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1599rzu2"
} : {
  target: "e1599rzu2",
  label: "ItemButton"
})("width:100%;max-width:", pxToRem(375), ";min-width:", pxToRem(200), ";display:block;padding:", pxToRem(13), " ", pxToRem(15), ";color:inherit;text-align:left;cursor:pointer;", ({
  theme
}) => HOVER$1`
    background: ${theme.interactive.primary1.transparent};
  `, ";");
const Title$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1599rzu1"
} : {
  target: "e1599rzu1",
  label: "Title"
})("width:100%;", FONT_STYLE.body1_small, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : 'inherit', ";font-weight:", ({
  isActive
}) => isActive ? 700 : 400, ";");
const Caption$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1599rzu0"
} : {
  target: "e1599rzu0",
  label: "Caption"
})("width:100%;", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.base2, ";margin:", pxToRem(5), " 0;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ListPanelModalItem = ({
  buttonText,
  caption,
  isActive,
  onClick,
  icon
}) => {
  return jsxs(ItemButton$3, {
    type: "button",
    onClick: onClick,
    isActive: isActive,
    children: [jsxs(Right, {
      children: [jsx(Title$1, {
        isActive: isActive,
        children: buttonText
      }), caption && jsx(Caption, {
        children: caption
      })]
    }), jsx(IconWrapper$1, {
      children: icon
    })]
  });
};
const ItemButton$3 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc4"
} : {
  target: "e1tzdgxc4",
  label: "ItemButton"
})("width:100%;display:flex;justify-content:space-between;align-items:center;padding:", pxToRem(10), " ", pxToRem(13), ";background:", ({
  theme,
  isActive
}) => isActive ? theme.interactive.primary1.transparent : 'none', ";color:inherit;text-align:left;border-bottom:", pxToRem(1), " solid ", ({
  theme
}) => theme.border, ";", ({
  theme
}) => HOVER$1`
    background: ${theme.interactive.primary1.transparent};
  `, ";");
const Right = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc3"
} : {
  target: "e1tzdgxc3",
  label: "Right"
})(process.env.NODE_ENV === "production" ? {
  name: "b936mu",
  styles: "flex-basis:max-content;flex-shrink:0"
} : {
  name: "b936mu",
  styles: "flex-basis:max-content;flex-shrink:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});
const Title$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc2"
} : {
  target: "e1tzdgxc2",
  label: "Title"
})(FONT_STYLE.body1_small, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : 'inherit', ";font-weight:", ({
  isActive
}) => isActive ? 700 : 400, ";");
const Caption = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc1"
} : {
  target: "e1tzdgxc1",
  label: "Caption"
})("margin:", pxToRem(5), " 0;", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.base2, ";");
const IconWrapper$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1tzdgxc0"
} : {
  target: "e1tzdgxc0",
  label: "IconWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "pezd64",
  styles: "flex:1;display:flex;justify-content:flex-end"
} : {
  name: "pezd64",
  styles: "flex:1;display:flex;justify-content:flex-end",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
});

const ListPanel = ({
  entry,
  tags,
  onChangeTags
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const handleClickItem = value => {
    const newTag = {
      type: 'list',
      id: entry.id,
      value
    };
    const alreadySelectedTagIndex = tags.findIndex(tag => tag.id === newTag.id && tag.value === newTag.value);
    if (alreadySelectedTagIndex !== -1) {
      onChangeTags(tags.filter((_, index) => alreadySelectedTagIndex !== index));
      return;
    }
    if (entry.type === FilterKey.MULTI_SELECT_LIST) {
      onChangeTags([...tags, newTag]);
      return;
    }
    onChangeTags([...tags.filter(tag => tag.id !== newTag.id), newTag]);
  };

  /**
   * 쿼리 파라미터로 선택된 태그(tags)이거나 기본값으로 설정된 값인 경우 true를 반환
   */
  const isActiveItem = value => {
    const isSelected = tags.some(tag => tag.id === entry.id);
    if (!isSelected) {
      return entry.config?.defaultValue === value;
    }
    return tags.some(tag => tag.id === entry.id && tag.value === value);
  };
  const ListItem = isMobile ? ListPanelModalItem : ListPanelDropdownItem;
  return jsx(Fragment, {
    children: entry.options.map(option => jsx(ListItem, {
      buttonText: option.label,
      caption: option.caption,
      isActive: isActiveItem(option.value),
      onClick: () => handleClickItem(option.value)
    }, option.label))
  });
};

/**
 * 뉴턴-랩슨 방법을 사용하여 주어진 함수 `transform`이 목표 y 값 `yTarget`과 같아지도록 하는 x 값을 근사합니다.
 *
 * @param {function(number): number} transform - 근을 찾기 위한 함수.
 * @param {number} yTarget - 목표 y 값, 이 값에 해당하는 x 값을 찾고자 함.
 * @param {number} xStart - 초기 x 값 추정치.
 * @param {number} [iterations=30] - 최대 반복 횟수.
 * @param {number} [epsilon=1e-14] - 기울기의 허용 오차 (기울기가 이 값보다 작으면 반복을 중단).
 * @param {number} [tolerance=1e-7] - x 값 변화의 허용 오차 (변화가 이 값보다 작으면 반복을 중단).
 * @param {number} [derivateStep=1e-5] - 수치 미분을 위한 스텝 크기.
 * @returns {number} 근사된 x 값.
 */
function findApproximateValue(transform, yTarget, xStart, iterations = 30, epsilon = 1e-14, tolerance = 1e-7, derivateStep = 1e-5) {
  let xValue = xStart;
  for (let i = 0; i < iterations; ++i) {
    const yValue = transform(xValue) - yTarget;
    const ySlope = (transform(xValue + derivateStep) - transform(xValue)) / derivateStep;
    // 기울기가 너무 작아 계산할 수 없음.
    if (Math.abs(ySlope) < epsilon) {
      break;
    }
    const newXValue = xValue - yValue / ySlope;
    // 값이 범위 내에 있음; 반복을 종료.
    if (Math.abs(newXValue - xValue) <= tolerance * Math.abs(newXValue)) {
      break;
    }
    xValue = newXValue;
  }
  return xValue;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const RangeSliderInput = ({
  className,
  value,
  onChange,
  dual,
  min,
  max,
  left,
  right,
  projection = x => x,
  quantize = x => x,
  step = 1,
  'aria-label': ariaLabel = ''
}) => {
  const ref = useRef(null);
  const leftThumbRef = useRef(null);
  const rightThumbRef = useRef(null);
  const otherValueRef = useRef(null);
  const dualValueRef = useRef(dual ? value : null);
  const preventClickUntilRef = useRef(null);
  useEffect(() => {
    dualValueRef.current = dual ? value : null;
  }, [dual, value]);
  const projectValue = (value, fallback = 0) => {
    const leftmost = projection(min);
    const rightmost = projection(max);
    if (value == null) {
      return fallback;
    }
    return (projection(value) - leftmost) / (rightmost - leftmost);
  };
  const leftPos = dual ? projectValue(value && value.min, 0) : 0;
  const rightPos = dual ? projectValue(value && value.max, 1) : projectValue(value, 0.5);
  const leftValue = dual ? value && value.min : 0;
  const rightValue = dual ? value && value.max : value;
  const getNode = clientX => {
    if (ref.current == null) {
      return null;
    }
    if (!dual) {
      return rightThumbRef.current;
    }
    const bounds = ref.current.getBoundingClientRect();
    const pos = (clientX - bounds.left) / bounds.width;
    const leftmost = projection(min);
    const rightmost = projection(max);
    const actualPos = pos * (rightmost - leftmost) + leftmost;

    // Determine which end we should use.
    const valueMin = dualValueRef.current == null || dualValueRef.current.min == null ? min : dualValueRef.current.min;
    const valueMax = dualValueRef.current == null || dualValueRef.current.max == null ? max : dualValueRef.current.max;
    const valueCenter = (projection(valueMin) + projection(valueMax)) / 2;
    if (actualPos > valueCenter) {
      return rightThumbRef.current;
    }
    return leftThumbRef.current;
  };
  const setPos = clientX => {
    if (ref.current == null) {
      return;
    }
    const bounds = ref.current.getBoundingClientRect();
    // Convert position to value using inverse function...
    const pos = (clientX - bounds.left) / bounds.width;
    const leftmost = projection(min);
    const rightmost = projection(max);
    const actualPos = pos * (rightmost - leftmost) + leftmost;
    if (!dual) {
      const newValue = findApproximateValue(projection, actualPos, min);
      let recordedValue = newValue;
      if (quantize != null) {
        recordedValue = quantize(newValue);
      }
      if (Number.isNaN(recordedValue)) {
        return;
      }
      onChange(Math.min(Math.max(recordedValue, min), max));
      return;
    }

    // Determine which end we should use.
    const valueMin = dualValueRef.current == null || dualValueRef.current.min == null ? min : dualValueRef.current.min;
    const valueMax = dualValueRef.current == null || dualValueRef.current.max == null ? max : dualValueRef.current.max;
    const valueCenter = (projection(valueMin) + projection(valueMax)) / 2;
    const newValue = findApproximateValue(projection, actualPos, min);
    let recordedValue = newValue;
    if (quantize != null) {
      recordedValue = quantize(newValue);
    }
    if (Number.isNaN(recordedValue)) {
      return;
    }
    if (otherValueRef.current == null) {
      otherValueRef.current = actualPos > valueCenter ? valueMin : valueMax;
    }
    onChange({
      min: Math.max(Math.min(otherValueRef.current, recordedValue), min),
      max: Math.min(Math.max(otherValueRef.current, recordedValue), max)
    });
  };
  const handleMouseDown = e => {
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX ?? 0;
    if ('clientX' in e) {
      e.preventDefault();
      const focusNode = getNode(clientX);
      if (focusNode != null) {
        focusNode.focus();
      }
    }
    setPos(clientX);
    ['mousemove', 'touchmove'].forEach(type => window.addEventListener(type, handleMouseMove));
    ['mouseup', 'touchend', 'touchcancel'].forEach(type => window.addEventListener(type, handleMouseUp));
  };
  const handleMouseMove = e => {
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX ?? 0;
    if ('clientX' in e) {
      e.preventDefault();
      const focusNode = getNode(clientX);
      if (focusNode != null && document.activeElement !== focusNode) {
        focusNode.focus();
      }
    }
    setPos(clientX);
  };
  const handleMouseUp = e => {
    if ('clientX' in e) {
      e.preventDefault();
    }
    otherValueRef.current = null;
    ['mousemove', 'touchmove'].forEach(type => window.removeEventListener(type, handleMouseMove));
    ['mouseup', 'touchend', 'touchcancel'].forEach(type => window.removeEventListener(type, handleMouseUp));
    preventClickUntilRef.current = Date.now() + 50;
    window.addEventListener('click', handleClickCapture, true);
  };
  const handleClickCapture = e => {
    if (preventClickUntilRef.current && Date.now() < preventClickUntilRef.current) {
      e.stopPropagation();
    }
    window.removeEventListener('click', handleClickCapture, true);
  };
  const handleKeyDown = (isMin, e) => {
    let currentValue;
    let edited = false;
    if (dual) {
      if (value == null) {
        currentValue = isMin ? min : max;
      } else {
        currentValue = value[isMin ? 'min' : 'max'];
      }
    } else {
      currentValue = value;
    }
    switch (e.code) {
      case 'ArrowDown':
      case 'ArrowLeft':
        {
          // Decrease
          e.preventDefault();
          currentValue -= step;
          edited = true;
          break;
        }
      case 'ArrowUp':
      case 'ArrowRight':
        {
          // Increase
          e.preventDefault();
          currentValue += step;
          edited = true;
          break;
        }
      case 'PageUp':
        {
          // Decrease many times
          e.preventDefault();
          currentValue -= step * 10;
          edited = true;
          break;
        }
      case 'PageDown':
        {
          // Increase many times
          e.preventDefault();
          currentValue += step * 10;
          edited = true;
          break;
        }
      case 'Home':
        {
          // Set to min
          e.preventDefault();
          currentValue = min;
          edited = true;
          break;
        }
      case 'End':
        {
          // Set to max
          e.preventDefault();
          currentValue = max;
          edited = true;
          break;
        }
    }
    if (edited) {
      currentValue = Math.min(Math.max(quantize(currentValue), min), max);
      if (dual) {
        if (isMin) {
          onChange({
            max: value?.max,
            min: Math.min(currentValue, value?.max)
          });
        } else {
          onChange({
            min: value?.min,
            max: Math.max(currentValue, value?.min)
          });
        }
      } else {
        onChange(currentValue);
      }
    }
  };
  return jsxs("div", {
    className: className,
    children: [jsxs(Container$b, {
      onMouseDown: e => handleMouseDown(e.nativeEvent),
      onTouchStart: e => handleMouseDown(e.nativeEvent),
      children: [jsx(Background, {}), jsxs(BarContainer, {
        ref: ref,
        children: [jsx(Bar, {
          dual: dual,
          style: {
            left: `${leftPos * 100}%`,
            width: `${(rightPos - leftPos) * 100}%`
          }
        }), dual && jsx(Thumb, {
          style: {
            left: `${leftPos * 100}%`
          },
          role: "slider",
          tabIndex: 0,
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-valuenow": leftValue ?? min,
          "aria-label": `${ariaLabel} 최소`,
          ref: leftThumbRef,
          onKeyDown: e => handleKeyDown(true, e)
        }), jsx(Thumb, {
          style: {
            left: `${rightPos * 100}%`
          },
          role: "slider",
          tabIndex: 0,
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-valuenow": rightValue ?? max,
          "aria-label": ariaLabel + (dual ? ' 최대' : ''),
          ref: rightThumbRef,
          onKeyDown: e => handleKeyDown(false, e)
        })]
      })]
    }), jsxs(Footer, {
      children: [jsx(FooterItem, {
        children: left
      }), jsx(FooterItem, {
        children: right
      })]
    })]
  });
};
const Container$b = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv6"
} : {
  target: "evasvfv6",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1ltp2go",
  styles: "position:relative;padding:7px 0;height:10px"
} : {
  name: "1ltp2go",
  styles: "position:relative;padding:7px 0;height:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
const Background = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv5"
} : {
  target: "evasvfv5",
  label: "Background"
})(process.env.NODE_ENV === "production" ? {
  name: "cg6g99",
  styles: "position:absolute;top:7px;left:0;right:0;height:10px;border-radius:10px;background-color:#f5f5f5"
} : {
  name: "cg6g99",
  styles: "position:absolute;top:7px;left:0;right:0;height:10px;border-radius:10px;background-color:#f5f5f5",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
const BarContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv4"
} : {
  target: "evasvfv4",
  label: "BarContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "xf71sx",
  styles: "position:absolute;top:7px;left:12px;right:12px;height:10px"
} : {
  name: "xf71sx",
  styles: "position:absolute;top:7px;left:12px;right:12px;height:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
const Bar = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv3"
} : {
  target: "evasvfv3",
  label: "Bar"
})("position:absolute;height:10px;border-radius:10px;margin-left:", props => props.dual ? 0 : -12, "px;background-color:#c7effb;");
const Thumb = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv2"
} : {
  target: "evasvfv2",
  label: "Thumb"
})(process.env.NODE_ENV === "production" ? {
  name: "vvjryx",
  styles: "position:absolute;top:50%;margin:-12px 0 0 -12px;width:24px;height:24px;border-radius:100%;background-color:#35c5f0;transform:translateZ(0px);@media (hover: none){-webkit-tap-highlight-color:rgba(0, 0, 0, 0);&:active{background-color:#09addb;}}@media (hover: hover){&:hover,&:focus{background-color:#09addb;}}&:focus{outline:none;box-shadow:0 0 0 3px #6cd5f4;}"
} : {
  name: "vvjryx",
  styles: "position:absolute;top:50%;margin:-12px 0 0 -12px;width:24px;height:24px;border-radius:100%;background-color:#35c5f0;transform:translateZ(0px);@media (hover: none){-webkit-tap-highlight-color:rgba(0, 0, 0, 0);&:active{background-color:#09addb;}}@media (hover: hover){&:hover,&:focus{background-color:#09addb;}}&:focus{outline:none;box-shadow:0 0 0 3px #6cd5f4;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
const Footer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv1"
} : {
  target: "evasvfv1",
  label: "Footer"
})(process.env.NODE_ENV === "production" ? {
  name: "rtxflr",
  styles: "display:flex;justify-content:space-between;margin-top:10px"
} : {
  name: "rtxflr",
  styles: "display:flex;justify-content:space-between;margin-top:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});
const FooterItem = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evasvfv0"
} : {
  target: "evasvfv0",
  label: "FooterItem"
})(process.env.NODE_ENV === "production" ? {
  name: "15buy4s",
  styles: "font-size:13px;color:#9e9e9e;line-height:16px"
} : {
  name: "15buy4s",
  styles: "font-size:13px;color:#9e9e9e;line-height:16px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
});

const MULTIPLE_VALUE_SEPERATOR$1 = '^';
const createListTagSerializer = id => tags => {
  const values = tags.filter(v => v.id === id).map(v => v.value);
  if (values.length === 0) {
    return {};
  }
  return {
    [id]: values.join(MULTIPLE_VALUE_SEPERATOR$1)
  };
};
const createListTagDeserializer = id => query => {
  if (query[id] == null) {
    return [];
  }
  const values = query[id]?.split(MULTIPLE_VALUE_SEPERATOR$1) ?? [];
  return values.map(value => ({
    id,
    value,
    type: 'list'
  }));
};
const formatList = ({
  options,
  tag
}) => {
  const option = options.find(option => option.value === tag.value);
  if (option == null) {
    return '';
  }
  return option.label;
};
const createListSchema = ({
  type,
  label,
  id,
  options,
  config
}) => {
  const defaultTag = config?.defaultValue ? {
    id,
    value: config.defaultValue,
    type: 'list'
  } : null;
  return {
    type,
    id,
    label,
    options,
    config: {
      ...config,
      showResetButtonOnSelected: {
        pc: false,
        mobile: true
      },
      showCloseButtonOnSelected: {
        mobile: true
      }
    },
    serializer: {
      serialize: createListTagSerializer(id),
      deserialize: createListTagDeserializer(id)
    },
    hasTag: tag => tag.id === id && tag.value !== config?.defaultValue,
    renderTag: tag => {
      if (tag.type !== 'list' || tag.id !== id || config?.defaultValue === tag.value) {
        return null;
      }
      return formatList({
        options,
        tag
      });
    },
    renderSummary: (tag = defaultTag) => {
      if (!tag || tag.type !== 'list' || tag.id !== id) {
        return null;
      }
      return formatList({
        options,
        tag
      });
    }
  };
};

const formatRange = ({
  range,
  unselectedText,
  unit
}) => {
  if (!range) {
    return unselectedText;
  }
  if (range.max == null && range.min == null) {
    return unselectedText;
  }
  if (range.max != null && range.min != null) {
    return `${range.min} - ${range.max}${unit}`;
  }
  if (range.min) {
    return `${range.min}${unit} 이상`;
  }
  return `${range.max}${unit} 이하`;
};

/**
 * targetRange가 range에 포함되었는지 여부를 반환합니다.
 */
const isInclude = ({
  range,
  targetRange
}) => {
  if (!range) {
    return false;
  }
  return (range.min == null || range.min <= targetRange.min) && (range.max == null || range.max >= targetRange.max);
};

/**
 * 기존 범위에 새로운 범위를 추가한 범위를 반환합니다.
 */
const addRange = ({
  range,
  newRange
}) => {
  if (range == null) {
    return {
      min: newRange.min,
      max: newRange.max
    };
  }
  return omitBy({
    min: range.min == null ? null : Math.min(newRange?.min, range.min),
    max: range.max == null ? null : Math.max(newRange?.max, range.max)
  }, v => v == null);
};

/**
 *
 * @param options 전체 옵션
 * @param target
 * @returns target의 다음 옵션을 반환합니다.
 */
const findNextOption = (options, target) => {
  return options.find(option => option.value.min >= target.max)?.value;
};

/**
 *
 * @param options 전체 옵션
 * @param target
 * @returns target의 이전 옵션을 반환합니다.
 */
const findPreviousOption = (options, target) => {
  return [...options].reverse().find(option => option.value.max <= target.min)?.value;
};

/**
 * 규칙
 * - 기존에 선택한 범위가 없을 때
 *   - 선택한 범위를 추가합니다.
 * - 기존에 선택한 범위가 있을 때
 *   - 기존 범위의 양쪽 끝 범위를 선택한 경우, 선택한 범위를 제외합니다.
 *   - 양쪽 끝이 아닌 범위를 선택한 경우, 선택한 범위만을 반환합니다(나머지 범위는 제거)
 * - 기존 범위 밖에 범위를 선택했을 때
 *   - 해당 범위까지 추가해줍니다.
 */
const getRange = ({
  currentRange,
  newRange,
  entry
}) => {
  const defaultMin = entry.config.range.min;
  const defaultMax = entry.config.range.max;
  const currentMin = currentRange == null || currentRange.min == null ? defaultMin : currentRange.min;
  const currentMax = currentRange == null || currentRange.max == null ? defaultMax : currentRange.max;
  if (currentRange != null && isInclude({
    range: currentRange,
    targetRange: newRange
  })) {
    const isSelectCurrentRange = currentMin === newRange.min && currentMax === newRange.max;
    if (isSelectCurrentRange) {
      return {
        min: defaultMin,
        max: defaultMax
      };
    }
    const result = {
      min: currentMin,
      max: currentMax
    };
    const isSelectFirstMin = currentMin === newRange.min;
    if (isSelectFirstMin) {
      const nextOption = findNextOption(entry.options, newRange);
      if (nextOption != null) {
        result.min = nextOption.min;
      } else {
        result.min = newRange.max ?? entry.config.range.max;
      }
      return result;
    }
    const isSelectLastMax = currentMax === newRange.max;
    if (isSelectLastMax) {
      result.max = newRange.min;
      const target = findPreviousOption(entry.options, newRange);
      if (target != null) {
        result.max = target.max;
      } else {
        result.max = newRange.min;
      }
      return result;
    }
    return {
      min: newRange.min,
      max: newRange.max
    };
  }
  const addedRange = addRange({
    range: currentRange,
    newRange
  });
  if (addedRange.min == null || addedRange.max == null) {
    if (addedRange.min === entry.config.range.min) {
      return {
        min: addedRange.min,
        max: entry.config.range.max
      };
    }
    if (addedRange.max === entry.config.range.max) {
      return {
        min: entry.config.range.min,
        max: addedRange.max
      };
    }
  }
  return addedRange;
};

const createRangeTagSerializer = id => tags => {
  const value = tags.find(v => v.id === id);
  if (value == null || value.type !== 'range') {
    return {};
  }
  const queryParams = {
    [`${id}_min`]: value.value.min != null ? String(value.value.min) : null,
    [`${id}_max`]: value.value.max != null ? String(value.value.max) : null
  };
  return omitBy(queryParams, isNil);
};
const createRangeTagDeserializer = id => query => {
  const minValue = parseFloat(query[`${id}_min`] ?? '');
  const maxValue = parseFloat(query[`${id}_max`] ?? '');
  if (isNaN(minValue) && isNaN(maxValue)) {
    return [];
  }
  return [{
    type: 'range',
    id,
    value: omitBy({
      min: minValue || null,
      max: maxValue || null
    }, isNil)
  }];
};
const createRangeSchema = ({
  type,
  label,
  id,
  config,
  options
}) => {
  return {
    type,
    id,
    label,
    options,
    config: {
      ...config,
      showResetButtonOnSelected: {
        pc: true,
        mobile: true
      },
      showCloseButtonOnSelected: {
        mobile: true
      }
    },
    serializer: {
      serialize: createRangeTagSerializer(id),
      deserialize: createRangeTagDeserializer(id)
    },
    hasTag: tag => tag.id === id && tag.type === 'range' && !isEqual$2(tag.value, config.range),
    renderTag: tag => {
      if (tag.type !== 'range' || tag.id !== id) {
        return null;
      }
      return formatRange({
        range: isEqual$2(tag.value, config.range) ? null : tag.value,
        unselectedText: config.unselectedText,
        unit: config.unit
      });
    },
    renderSummary(tag) {
      if (!tag) {
        return null;
      }
      return this.renderTag(tag);
    }
  };
};

const createSerialize = converters => tags => {
  return converters.reduce((acc, converter) => ({
    ...acc,
    ...converter(tags)
  }), {});
};
const createDeserialize = converters => query => {
  return converters.map(converter => converter(query)).reduce((acc, tag) => [...acc, ...tag], []);
};
const createGroupSchema = ({
  id,
  schema,
  ...rest
}) => {
  return {
    id,
    schema,
    ...rest,
    serializer: {
      serialize: createSerialize(schema.map(entry => entry.serializer.serialize)),
      deserialize: createDeserialize(schema.map(entry => entry.serializer.deserialize))
    },
    hasTag: tag => schema.some(entry => entry.hasTag(tag)),
    renderTag: tag => schema.map(entry => entry.renderTag(tag)),
    renderSummary: tag => schema.map(entry => entry.renderSummary(tag))
  };
};

const DEFAULT_SIZE = 16;
const ColorIcon = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e66elua0"
} : {
  target: "e66elua0",
  label: "ColorIcon"
})("display:inline-flex;justify-content:center;align-items:center;width:", ({
  size
}) => pxToRem(size ?? DEFAULT_SIZE), ";height:", ({
  size
}) => pxToRem(size ?? DEFAULT_SIZE), ";background:", ({
  color
}) => color, ";box-sizing:border-box;border:", ({
  hasBorder,
  theme
}) => hasBorder ? `${pxToRem(1)} solid ${theme.border}` : 'none', ";border-radius:50%;");

const MULTIPLE_VALUE_SEPERATOR = '^';
const createColorTagSerializer = id => tags => {
  const values = tags.filter(v => v.id === id).map(v => v.value);
  if (values.length === 0) {
    return {};
  }
  return {
    [id]: values.join(MULTIPLE_VALUE_SEPERATOR)
  };
};
const createColorTagDeserializer = id => query => {
  if (query[id] == null) {
    return [];
  }
  const values = query[id]?.split(MULTIPLE_VALUE_SEPERATOR) ?? [];
  return values.map(value => ({
    id,
    value: Number(value),
    type: 'color'
  }));
};
const createColorSchema = ({
  id,
  config,
  options,
  type,
  label,
  ...rest
}) => {
  return {
    ...rest,
    type,
    id,
    label,
    options,
    serializer: {
      serialize: createColorTagSerializer(id),
      deserialize: createColorTagDeserializer(id)
    },
    hasTag: tag => tag.id === id,
    renderTag: tag => {
      if (tag.type !== 'color' || tag.id !== id) {
        return null;
      }
      const option = options.find(option => option.value.search === tag.value);
      if (!option) {
        return null;
      }
      if (type === 'singleSelectColor') {
        return jsxs(ColorIconContainer, {
          children: [jsx(ColorIcon, {
            size: 16,
            color: option.value.code,
            hasBorder: option.value.border
          }), label]
        });
      }
      return jsx(ColorIcon, {
        size: 16,
        color: option.value.code,
        hasBorder: option.value.border
      });
    },
    renderSummary: tag => {
      if (!tag || tag.type !== 'color' || tag.id !== id) {
        return null;
      }
      const option = options.find(option => option.value.search === tag.value);
      if (!option) {
        return null;
      }
      if (type === 'singleSelectColor') {
        return jsxs(ColorIconContainer, {
          children: [jsx(ColorIcon, {
            size: 16,
            color: option.value.code,
            hasBorder: option.value.border
          }), label]
        });
      }
      return jsx(ColorIcon, {
        size: 24,
        color: option.value.code,
        hasBorder: option.value.border
      });
    }
  };
};
const ColorIconContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1azwwbb0"
} : {
  target: "e1azwwbb0",
  label: "ColorIconContainer"
})("display:flex;align-items:center;gap:", pxToRem(4), ";");

const ButtonControl = ({
  entry,
  onChangeTags,
  tags
}) => {
  const currentRange = tags.find(tag => tag.id === entry.id);
  const handleClick = newRange => {
    if (currentRange && currentRange.type !== 'range') {
      return;
    }
    const range = getRange({
      currentRange: currentRange?.value,
      newRange,
      entry
    });
    onChangeTags(range);
  };
  return jsx(ButtonList, {
    children: entry.options.map(option => jsx(Button$2, {
      type: "button",
      isActive: isInclude({
        range: currentRange?.type === 'range' ? currentRange?.value : undefined,
        targetRange: option.value
      }),
      onClick: () => handleClick(option.value),
      children: option.label
    }, option.label))
  });
};
const ButtonList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ectpx291"
} : {
  target: "ectpx291",
  label: "ButtonList"
})("display:grid;grid-template-columns:repeat(4, 1fr);column-gap:", pxToRem(4), ";row-gap:", pxToRem(4), ";");
const Button$2 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ectpx290"
} : {
  target: "ectpx290",
  label: "Button"
})("height:", pxToRem(40), ";", FONT_STYLE.body2_small, ";border-radius:", pxToRem(4), ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.white : theme.content.base1, ";background:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.basic : theme.content.base5, ";", ({
  theme,
  isActive
}) => HOVER$1`
    background: ${isActive ? '#09addb' : theme.interactive.base5};
  `, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * max, min값이 default 값일 때 필드를 제거합니다.
 */
const convertRange = (range, defaultRange) => {
  const result = {
    min: range.min === defaultRange.min ? null : range.min,
    max: range.max === defaultRange.max ? null : range.max
  };
  if (result.min == null && result.max == null) {
    return null;
  }
  return omitBy(result, v => v == null);
};
const RangePanel = ({
  entry,
  tags,
  onChangeTags
}) => {
  const [sliderRange, setSliderRange] = useState(null);
  const {
    reset
  } = useLocaleData();
  const handleChangeTags = useCallback(value => {
    const newValue = convertRange(value, entry.config.range);
    if (newValue == null) {
      onChangeTags([...tags.filter(tag => tag.id !== entry.id)]);
      return;
    }
    onChangeTags([...tags.filter(tag => tag.id !== entry.id), {
      id: entry.id,
      type: 'range',
      value: newValue
    }]);
  }, [entry, onChangeTags, tags]);
  const debouncedOnChange = useMemo(() => debounce$1(handleChangeTags, 500), [handleChangeTags]);
  const handleButtonClick = useCallback(handleChangeTags, [handleChangeTags]);
  const handleSliderClick = useCallback(({
    min,
    max
  }) => {
    const value = omitBy({
      min,
      max
    }, v => v == null);
    debouncedOnChange(value);
    if (entry.config.hasSliderInput) {
      setSliderRange(value);
    }
  }, [debouncedOnChange, entry]);
  const getRange = useCallback(() => {
    const tag = tags.find(tag => tag.id === entry.id);
    if (tag && tag.type !== 'range') {
      return null;
    }
    return tag?.value == null ? null : tag.value;
  }, [tags, entry]);
  useEffect(() => {
    const range = getRange();
    if (range == null) {
      setSliderRange(null);
    }
  }, [getRange]);
  const handleReset = () => {
    onChangeTags(tags.filter(tag => tag.id !== entry.id));
  };
  const currentStateText = () => {
    const range = entry.config.hasSliderInput && sliderRange ? sliderRange : getRange();
    return formatRange({
      range: range ? convertRange(range, entry.config.range) : null,
      unselectedText: entry.config.unselectedText,
      unit: entry.config.unit
    });
  };
  const isSelected = !!tags.find(tag => tag.id === entry.id);
  const isMobile = useResponsive().breakpoint === 'mobile';
  const range = sliderRange ?? getRange();
  return jsxs(Container$a, {
    children: [jsxs(Header$1, {
      children: [jsx(CurrentState, {
        children: currentStateText()
      }), isSelected && !isMobile && entry.config.showResetButtonOnSelected?.pc && jsx(ResetButton$3, {
        type: "button",
        onClick: handleReset,
        children: reset
      })]
    }), entry.config.hasSliderInput && jsx(StyledRangeSliderInput, {
      min: entry.config.range.min,
      max: entry.config.range.max,
      dual: true,
      value: {
        min: range?.min,
        max: range?.max
      },
      projection: v => v,
      quantize: v => Math.round(v),
      left: entry.config.rangeStartText,
      right: entry.config.rangeEndText,
      onChange: handleSliderClick
    }), jsx(ButtonControl, {
      entry: entry,
      onChangeTags: handleButtonClick,
      tags: tags
    })]
  });
};
const Container$a = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n4"
} : {
  target: "ek7ao1n4",
  label: "Container"
})("width:100%;", MEDIA_QUERY.min('tablet', /*#__PURE__*/css("width:", pxToRem(375), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Container;"))), " padding:", pxToRem(20), " ", pxToRem(15), ";");
const Header$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n3"
} : {
  target: "ek7ao1n3",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "1066lcq",
  styles: "display:flex;justify-content:space-between;align-items:center"
} : {
  name: "1066lcq",
  styles: "display:flex;justify-content:space-between;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
});
const ResetButton$3 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n2"
} : {
  target: "ek7ao1n2",
  label: "ResetButton"
})(FONT_STYLE.body1_small, ";color:", ({
  theme
}) => theme.content.primary1.basic, ";", HOVER$1`
    opacity: 0.5;
  `, ";");
const CurrentState = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n1"
} : {
  target: "ek7ao1n1",
  label: "CurrentState"
})("font-weight:700;", FONT_STYLE.title2, ";text-align:left;padding:", pxToRem(14), " 0 ", pxToRem(20), ";");
const StyledRangeSliderInput = /*#__PURE__*/_styled(RangeSliderInput, process.env.NODE_ENV === "production" ? {
  target: "ek7ao1n0"
} : {
  target: "ek7ao1n0",
  label: "StyledRangeSliderInput"
})("margin-bottom:", pxToRem(38), ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref$6 = process.env.NODE_ENV === "production" ? {
  name: "3lrvfj",
  styles: "vertical-align:bottom"
} : {
  name: "t1w8fb-ColorButton",
  styles: "vertical-align:bottom;label:ColorButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
};
const ColorButton = ({
  isChecked,
  background,
  ...rest
}) => {
  return jsx(ColorIcon, {
    color: background.color,
    hasBorder: background.isWhitish,
    as: "button",
    size: 24,
    css: _ref$6,
    ...rest,
    children: isChecked && jsx(Icon$2, {
      name: "check_thick",
      size: 16,
      fill: theme => background.isWhitish ? theme.content.base1 : theme.content.white
    })
  });
};

const ColorPanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  const handleClick = optionValue => {
    const newTag = {
      id: entry.id,
      type: 'color',
      value: optionValue.search
    };
    const isAlreadySelected = tags.some(tag => tag.id === newTag.id && tag.value === newTag.value);
    if (isAlreadySelected) {
      onChangeTags(tags.filter(tag => !(tag.id === newTag.id && tag.value === newTag.value)));
      return;
    }
    if (entry.type === FilterKey.MULTI_SELECT_COLOR) {
      onChangeTags([newTag, ...tags]);
      return;
    }
    onChangeTags([newTag, ...tags.filter(tag => tag.id !== newTag.id)]);
  };
  return jsxs(Fragment, {
    children: [entry.label && jsx(Label, {
      children: entry.label
    }), jsx(List, {
      children: entry.options.map(option => jsx(StyledColorButton, {
        background: {
          color: option.value.code,
          isWhitish: !!option.value.border
        },
        isChecked: !!tags.find(tag => {
          return tag.id === entry.id && tag.value === option.value.search;
        }),
        onClick: () => {
          handleClick(option.value);
        }
      }, option.label))
    })]
  });
};
const List = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqyadn62"
} : {
  target: "eqyadn62",
  label: "List"
})("min-height:", pxToRem(50), ";padding:", pxToRem(5), " ", pxToRem(10), ";box-sizing:content-box;white-space:nowrap;overflow-x:auto;");
const StyledColorButton = /*#__PURE__*/_styled(ColorButton, process.env.NODE_ENV === "production" ? {
  target: "eqyadn61"
} : {
  target: "eqyadn61",
  label: "StyledColorButton"
})("margin:", pxToRem(5), ";");
const Label = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "eqyadn60"
} : {
  target: "eqyadn60",
  label: "Label"
})("padding:", pxToRem(5), " ", pxToRem(15), ";", FONT_STYLE.caption1, ";color:", ({
  theme
}) => theme.content.base1, ";");

const renderSinglePanel = props => {
  switch (props.entry.type) {
    case FilterKey.MULTI_SELECT_LIST:
    case FilterKey.SINGLE_SELECT_LIST:
      return jsx(ListPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    case FilterKey.RANGE:
      return jsx(RangePanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    case FilterKey.MULTI_SELECT_COLOR:
    case FilterKey.SINGLE_SELECT_COLOR:
      return jsx(ColorPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    default:
      return null;
  }
};
const SinglePanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  return jsx(Fragment, {
    children: renderSinglePanel({
      entry,
      onChangeTags,
      tags
    })
  });
};

const getIdsInGroup = entry => {
  if (entry.type !== FilterKey.SINGLE_SELECT_GROUP && entry.type !== FilterKey.MULTI_SELECT_GROUP) {
    return [entry.id];
  }
  return entry.schema.map(entry => getIdsInGroup(entry)).reduce((acc, ids) => [...acc, ...ids], []);
};
const GroupPanel = ({
  entry,
  onChangeTags,
  tags
}) => {
  const [activeGroupId, setActiveGroupId] = useState(null);
  const idListInGroup = getIdsInGroup(entry);
  const selectedGroupId = tags.find(tag => idListInGroup.includes(tag.id))?.id;
  const resetAllGroupTags = () => {
    if (!selectedGroupId) {
      return;
    }
    onChangeTags(tags.filter(tag => !idListInGroup.includes(tag.id)));
  };
  const isActiveGroup = entry => {
    if (activeGroupId) {
      return entry.id === activeGroupId;
    }
    return !!(selectedGroupId && getIdsInGroup(entry).includes(selectedGroupId));
  };
  if (entry.type === FilterKey.SINGLE_SELECT_GROUP) {
    return jsx(Fragment, {
      children: entry.schema.map(subEntry => jsxs(React__default.Fragment, {
        children: [jsxs(ExpanderController, {
          children: [jsx("span", {
            children: subEntry.label
          }), jsx(Toggle, {
            checked: isActiveGroup(subEntry),
            onCheck: checked => {
              setActiveGroupId(checked ? subEntry.id : null);
              resetAllGroupTags();
            }
          })]
        }), jsx(Expander, {
          isExpanded: isActiveGroup(subEntry),
          children: jsx(SinglePanel, {
            entry: {
              ...subEntry,
              label: subEntry.type === FilterKey.SINGLE_SELECT_GROUP || subEntry.type === FilterKey.MULTI_SELECT_GROUP ? subEntry.label : ''
            },
            onChangeTags: onChangeTags,
            tags: tags
          })
        })]
      }, subEntry.id))
    });
  }
  return jsx(Fragment, {
    children: entry.schema.map(entry => jsx(SinglePanel, {
      entry: entry,
      onChangeTags: onChangeTags,
      tags: tags
    }, entry.id))
  });
};
const ExpanderController = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekqfg9x1"
} : {
  target: "ekqfg9x1",
  label: "ExpanderController"
})(FONT_STYLE.body1_small, ";display:flex;justify-content:space-between;align-items:center;padding:", pxToRem(10.5), " ", pxToRem(15), ";");
const Expander = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekqfg9x0"
} : {
  target: "ekqfg9x0",
  label: "Expander"
})("height:", ({
  isExpanded
}) => isExpanded ? 'fit-content' : 0, ";overflow:hidden;");

const renderPanel = props => {
  switch (props.entry.type) {
    case FilterKey.MULTI_SELECT_GROUP:
    case FilterKey.SINGLE_SELECT_GROUP:
      return jsx(GroupPanel, {
        ...props,
        entry: props.entry,
        tags: props.tags
      });
    default:
      return jsx(SinglePanel, {
        ...props
      });
  }
};
const Panel = ({
  entry,
  onChangeTags,
  tags
}) => {
  return jsx(Container$9, {
    children: renderPanel({
      entry,
      onChangeTags,
      tags
    })
  });
};

// TODO
// InfoTip backlayer 수정 후 스타일 제거
const Container$9 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gi3ci50"
} : {
  target: "e1gi3ci50",
  label: "Container"
})("position:relative;z-index:1;text-align:start;max-height:", pxToRem(425), ";overflow:auto;color:", ({
  theme
}) => theme.content.base1, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const homeTransitionStyles = {
  entering: {
    opacity: 1,
    transition: 'opacity 0.2s'
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0,
    transition: 'opacity 0.2s'
  },
  exited: {
    opacity: 0
  }
};
const pageTransitionStyles = {
  entering: {
    opacity: 1,
    transform: 'translateX(0)',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  entered: {
    opacity: 1,
    transform: 'translateX(0)'
  },
  exiting: {
    opacity: 0,
    transform: 'translateX(50px)',
    transition: 'opacity 0.2s, transform 0.2s'
  },
  exited: {
    opacity: 0,
    transform: 'translateX(50px)'
  }
};
const PageWithFadeTransition = ({
  children,
  isHome,
  show
}) => {
  const transitionStyles = isHome ? homeTransitionStyles : pageTransitionStyles;
  const ref = useRef(null);
  return jsx(Transition$1, {
    in: show,
    timeout: 200,
    unmountOnExit: true,
    nodeRef: ref,
    children: state => {
      return jsx(Content, {
        ref: ref,
        style: transitionStyles[state],
        children: children
      });
    }
  });
};
const Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eq9zchc0"
} : {
  target: "eq9zchc0",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "1b4920d",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%"
} : {
  name: "1b4920d",
  styles: "position:absolute;top:0;left:0;width:100%;height:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const BaseModal = ({
  actionLeft,
  title,
  actionRight,
  onClose,
  isStartToClose,
  children,
  ...rest
}) => {
  return jsx(StyledModal, {
    ...rest,
    width: 400,
    height: "440px",
    hasInteraction: true,
    disableBackgroundScroll: true,
    isStartToClose: isStartToClose,
    onBlur: onClose,
    children: jsxs(Container$8, {
      children: [jsxs(Header, {
        children: [jsx(HeaderLeft, {
          children: actionLeft
        }), title, jsx(HeaderRight, {
          children: actionRight
        })]
      }), jsx(Body, {
        children: children
      })]
    })
  });
};
const slideUp = keyframes`
  from {
    transform: translateY(100px);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
`;
const StyledModal = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => prop !== 'isStartToClose',
  target: "e14xlalu5"
} : {
  shouldForwardProp: prop => prop !== 'isStartToClose',
  target: "e14xlalu5",
  label: "StyledModal"
})("opacity:", ({
  isStartToClose
}) => isStartToClose ? '0' : '1', ";transition:all .25s ease-out;>div{transform:", ({
  isStartToClose
}) => isStartToClose ? 'translateY(100px)' : 'none', ";transition:all .25s ease-out;animation:", slideUp, " .25s ease-out;}");
const Container$8 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu4"
} : {
  target: "e14xlalu4",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "1lghw08",
  styles: "position:relative;width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column"
} : {
  name: "1lghw08",
  styles: "position:relative;width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});
const Body = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu3"
} : {
  target: "e14xlalu3",
  label: "Body"
})("flex:1;position:relative;overflow-x:hidden;overflow-y:scroll;margin-bottom:", pxToRem(-1), ";margin-top:", pxToRem(1), ";");
const Header = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu2"
} : {
  target: "e14xlalu2",
  label: "Header"
})("position:relative;", FONT_STYLE.title4, ";font-weight:700;padding:", pxToRem(10), " 0;");
const HeaderLeft = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu1"
} : {
  target: "e14xlalu1",
  label: "HeaderLeft"
})("position:absolute;top:0;left:0;padding-left:", pxToRem(20.5), ";height:100%;display:flex;align-items:center;font-weight:400;");
const HeaderRight = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e14xlalu0"
} : {
  target: "e14xlalu0",
  label: "HeaderRight"
})("position:absolute;top:0;right:0;height:100%;padding-right:", pxToRem(15.5), ";display:flex;align-items:center;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MenuModal = ({
  menu,
  home,
  currentMenuKey,
  onChangeMenuKey,
  onClose,
  actions,
  ...rest
}) => {
  const showHome = currentMenuKey == null;
  const currentMenuItem = menu.find(item => item.key === currentMenuKey) ?? home;
  const handleBack = !showHome ? () => onChangeMenuKey?.(null) : undefined;
  return jsxs(BaseModal, {
    ...rest,
    actionLeft: handleBack && jsx(BackButton, {
      type: "button",
      onClick: handleBack,
      children: jsx(Icon$2, {
        name: "arrow_left",
        size: 24
      })
    }),
    actionRight: actions,
    title: currentMenuItem.label,
    onClose: onClose,
    children: [jsx(PageWithFadeTransition, {
      isHome: true,
      show: showHome,
      children: home.content
    }), menu.map(item => jsx(PageWithFadeTransition, {
      show: item.key === currentMenuKey,
      children: item.content
    }, item.key))]
  });
};
const BackButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1yjndi0"
} : {
  target: "e1yjndi0",
  label: "BackButton"
})(process.env.NODE_ENV === "production" ? {
  name: "opde7s",
  styles: "color:inherit"
} : {
  name: "opde7s",
  styles: "color:inherit",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

const FilterTag = ({
  onClick,
  showDeleteIcon = true,
  children
}) => {
  return jsxs(TagButton$1, {
    onClick: onClick,
    children: [children, showDeleteIcon && jsx(DeleteIcon, {
      size: 16
    })]
  });
};
const TagButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e6u93a41"
} : {
  target: "e6u93a41",
  label: "TagButton"
})("display:flex;align-items:center;height:", pxToRem(24), ";padding:", pxToRem(1), " ", pxToRem(8), " ", pxToRem(3), ";background-color:", ({
  theme
}) => theme.content.primary1.basic, ";color:", ({
  theme
}) => theme.content.white, ";font-size:", pxToRem(15), ";font-weight:700;line-height:", pxToRem(18), ";border-radius:", pxToRem(26), ";");
const DeleteIcon = /*#__PURE__*/_styled(DismissCircleIcon, process.env.NODE_ENV === "production" ? {
  target: "e6u93a40"
} : {
  target: "e6u93a40",
  label: "DeleteIcon"
})("margin:0 ", pxToRem(-4), " 0 ", pxToRem(7), ";vertical-align:", pxToRem(-1), ";");

const findTagLabel = (schema, tag) => {
  return schema.reduce((result, entry) => {
    if (result) {
      return result;
    }
    if (entry.type === 'multiSelectGroup' || entry.type === 'singleSelectGroup') {
      return findTagLabel(entry.schema, tag);
    }
    return entry.renderTag(tag);
  }, null);
};
const FilterTagList = ({
  className,
  handleChangeTags,
  tags,
  schema: schemaList
}) => {
  const {
    reset
  } = useLocaleData();
  const isMobile = useResponsive().breakpoint === 'mobile';
  const hideResetButton = useMemo(() => {
    return tags.length <= 1 && tags.some(tag => {
      return schemaList.some(schema => {
        if (schema.type === 'multiSelectList' || schema.type === 'singleSelectList') {
          return schema.config?.defaultValue === tag.value;
        }
        return false;
      });
    });
  }, [schemaList, tags]);
  return jsxs(ListContainer, {
    className: className,
    children: [tags.map((tag, index) => findTagLabel(schemaList, tag) == null ? null : jsx(FilterTagListItem, {
      children: jsx(FilterTag, {
        onClick: () => handleChangeTags(tags.filter((_, i) => i !== index)),
        children: findTagLabel(schemaList, tag)
      })
    }, `${tag.id}-${JSON.stringify(tag.value)}`)), !isMobile && !hideResetButton && jsx(FilterTagListItem, {
      children: jsx(ResetButton$2, {
        type: "button",
        onClick: () => handleChangeTags([]),
        children: reset
      })
    })]
  });
};
const ListContainer = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1pjrndz2"
} : {
  target: "e1pjrndz2",
  label: "ListContainer"
})("display:flex;flex-wrap:wrap;gap:", pxToRem(4), ";list-style:none;padding:", pxToRem(5), " 0;white-space:nowrap;overflow:auto;", MEDIA_QUERY.max('tablet', /*#__PURE__*/css("margin:0 ", pxToRem(-15), ";padding:", pxToRem(5), " ", pxToRem(15), ";flex-wrap:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:ListContainer;"))), ";");
const FilterTagListItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1pjrndz1"
} : {
  target: "e1pjrndz1",
  label: "FilterTagListItem"
})("padding:", pxToRem(2), " 0;&>button{border:", pxToRem(1), " solid transparent;}");
const ResetButton$2 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1pjrndz0"
} : {
  target: "e1pjrndz0",
  label: "ResetButton"
})("color:", ({
  theme
}) => theme.content.primary1.basic, ";padding:", pxToRem(2), " ", pxToRem(10), ";border:none;background:none;font-size:", pxToRem(15), ";line-height:", pxToRem(18), ";font-weight:700;text-align:center;");

const ZINDEX = 3;
const Dropdown = ({
  children,
  content,
  isOpen,
  onChangeOpen
}) => {
  return jsx(InfoTip, {
    renderOpener: ({
      onMouseEnter,
      onMouseLeave
    }) => /*#__PURE__*/React__default.cloneElement(children, {
      onMouseEnter,
      onMouseLeave
    }),
    onOpenChange: onChangeOpen,
    openOnHover: true,
    offsetTop: 8,
    forceClose: !isOpen,
    contentStyle: {
      zIndex: ZINDEX
    },
    children: jsx(Container$7, {
      children: content
    })
  });
};
const Container$7 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ejm8vx70"
} : {
  target: "ejm8vx70",
  label: "Container"
})("border-radius:", pxToRem(10), ";overflow:hidden;background:", ({
  theme
}) => theme.content.white, ";box-shadow:0 ", pxToRem(-1), " ", pxToRem(16), " rgba(0, 0, 0, 0.2);");

const FilterButton = ({
  icon,
  children,
  ...rest
}) => {
  return jsxs(Button$1, {
    type: "button",
    ...rest,
    children: [children, icon]
  });
};
const Button$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ebq8vr70"
} : {
  target: "ebq8vr70",
  label: "Button"
})("width:max-content;background:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.thin : theme.content.base5, ";color:", ({
  isActive,
  theme
}) => isActive ? theme.content.primary1.thick : theme.content.base2, ";border-radius:", pxToRem(4), ";", FONT_STYLE.body1_small, ";font-size:", pxToRem(15), ";font-weight:700;height:", pxToRem(34), ";padding:0 ", pxToRem(8), ";display:flex;align-items:center;gap:", pxToRem(5), ";");

const FilterSelectButton = ({
  icon,
  ...rest
}) => {
  return jsx(FilterButton, {
    icon: icon || jsx(Icon$2, {
      name: "chevron_thick_down",
      size: 12
    }),
    ...rest
  });
};

const FilterController = ({
  entry,
  isActive,
  tags,
  onChangeTags
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isOptionStartToClose, setIsOptionStartToClose] = useState(false);
  const {
    reset,
    apply
  } = useLocaleData();
  const closeOption = () => {
    setIsOptionStartToClose(true);
  };
  const handleClose = useCallback(() => {
    closeOption();
    setIsClicked(false);
  }, []);
  const handleChangeTags = useCallback(tags => {
    onChangeTags(tags);
    // 단일 선택 리스트일 때만 옵션 선택 시 선택 창이 닫힘
    // 그 외 타입은 모달의 확인 버튼 클릭하거나 dropdown 영역을 벗어났을 때 닫힘
    if (entry.type === FilterKey.SINGLE_SELECT_LIST) {
      handleClose();
    }
  }, [entry, onChangeTags, handleClose]);
  const handleChangeOpen = useCallback(isOpen => {
    setIsClicked(isOpen);
    setIsOptionOpen(isOpen);
  }, []);
  const showResetButton = isActive && entry.config?.showResetButtonOnSelected?.mobile;
  const showCloseButton = isActive && entry.config?.showCloseButtonOnSelected?.mobile;
  return jsxs(Fragment, {
    children: [jsx(Dropdown, {
      content: jsx(Panel, {
        entry: entry,
        onChangeTags: tags => {
          handleChangeTags(tags);
          if (entry.type === FilterKey.SINGLE_SELECT_LIST) {
            closeOption();
            setIsClicked(false);
          }
        },
        tags: tags
      }),
      onChangeOpen: !isMobile ? handleChangeOpen : undefined,
      isOpen: !isMobile && isOptionOpen,
      children: jsx(FilterSelectButton, {
        isActive: isActive,
        onClick: () => {
          if (!isMobile) {
            setIsClicked(prev => !prev);
          }
          setIsOptionOpen(prev => isMobile ? !prev : isClicked);
        },
        children: entry.label
      })
    }, entry.id), isMobile && isOptionOpen && jsx(BaseModal, {
      title: entry?.label,
      onClose: handleClose,
      isStartToClose: isOptionStartToClose,
      onTransitionEnd: () => {
        if (isOptionStartToClose) {
          setIsOptionOpen(false);
          setIsOptionStartToClose(false);
        }
      },
      actionRight: showResetButton && jsx(ResetButton$1, {
        type: "button",
        onClick: () => {
          onChangeTags(tags.filter(tag => tag.id !== entry?.id));
        },
        children: reset
      }),
      footer: showCloseButton ? {
        action: {
          primary: {
            text: apply,
            onClick: handleClose
          }
        }
      } : undefined,
      children: entry && jsx(Panel, {
        entry: entry,
        tags: tags,
        onChangeTags: onChangeTags
      })
    })]
  });
};
const ResetButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e2ma4e60"
} : {
  target: "e2ma4e60",
  label: "ResetButton"
})("color:", ({
  theme
}) => theme.content.primary1.basic, ";font-size:inherit;font-weight:inherit;line-height:inherit;");

const FilterListModalItem = ({
  buttonText,
  onClick,
  label
}) => {
  return jsx(ListPanelModalItem, {
    buttonText: buttonText,
    onClick: onClick,
    icon: jsxs(IconWrapper, {
      children: [jsx(SelectedValue, {
        children: label
      }), jsx(Icon$2, {
        name: "chevron_right",
        size: 18
      })]
    })
  });
};
const IconWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eecmxa11"
} : {
  target: "eecmxa11",
  label: "IconWrapper"
})("display:flex;gap:", pxToRem(4), ";font-weight:700;align-items:center;");
const SelectedValue = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "eecmxa10"
} : {
  target: "eecmxa10",
  label: "SelectedValue"
})("display:flex;align-items:center;color:", ({
  theme
}) => theme.content.primary1.basic, ";");

const RouteFilter = ({
  className,
  schema,
  query,
  onChangeQuery,
  localeData = defaultLocaleData
}) => {
  const isMobile = useResponsive().breakpoint === 'mobile';
  const {
    handleChangeTags,
    tags
  } = useFilterTags({
    schema,
    query,
    onChangeQuery
  });
  const {
    reset,
    selectedEntryId,
    selectEntry,
    isModalOpen,
    openModal,
    closeModal
  } = useFilterListModal({
    schema,
    tags,
    handleChangeTags
  });
  const [isStartToClose, setIsStartToClose] = useState(false);
  const isSelected = entry => {
    return tags.some(tag => entry.hasTag(tag));
  };
  const renderSummary = entry => {
    const activeTags = tags.filter(tag => entry.hasTag(tag));
    return activeTags.length === 0 ? entry.renderSummary() : activeTags.map(tag => entry.renderSummary(tag));
  };
  return jsxs(LocaleDataProvider, {
    data: localeData,
    children: [jsxs(Container$6, {
      className: className,
      "data-testid": "router-filter",
      children: [jsxs(FilterControllerList, {
        children: [isMobile && jsxs(AllFilterButton, {
          type: "button",
          onClick: openModal,
          children: [jsx(Icon$2, {
            name: "filter",
            size: 18,
            fill: theme => theme.content.base3
          }), jsx(HiddenText, {
            children: localeData.showAllFilter
          })]
        }), schema.map(entry => jsx(FilterController, {
          entry: entry,
          isActive: isSelected(entry),
          tags: tags,
          onChangeTags: handleChangeTags
        }, entry.id))]
      }), tags.length > 0 && jsx(StyledFilterTagList, {
        tags: tags,
        handleChangeTags: handleChangeTags,
        schema: schema
      })]
    }), isModalOpen && jsx(MenuModal, {
      isStartToClose: isStartToClose,
      onTransitionEnd: () => {
        if (isStartToClose) {
          closeModal();
          setIsStartToClose(false);
        }
      },
      actions: reset && jsx(ResetButton, {
        type: "button",
        onClick: reset,
        children: localeData.reset
      }),
      footer: {
        action: {
          primary: {
            text: localeData.apply,
            onClick: () => setIsStartToClose(true)
          }
        }
      },
      onClose: () => setIsStartToClose(true),
      onChangeMenuKey: selectEntry,
      menu: schema.map(entry => ({
        key: entry.id,
        label: entry.label,
        content: jsx(Panel, {
          entry: entry,
          tags: tags,
          onChangeTags: handleChangeTags
        })
      })),
      home: {
        label: localeData.filter,
        content: jsx(Fragment, {
          children: schema.map(entry => jsx(FilterListModalItem, {
            buttonText: entry.label,
            onClick: () => selectEntry(entry.id),
            label: jsx(TagLabelContainer, {
              children: renderSummary(entry)
            })
          }, entry.id))
        })
      },
      currentMenuKey: selectedEntryId
    })]
  });
};
const Container$6 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn46"
} : {
  target: "e1kmhkn46",
  label: "Container"
})();
const FilterControllerList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn45"
} : {
  target: "e1kmhkn45",
  label: "FilterControllerList"
})("display:flex;align-items:center;gap:", pxToRem(4), ";padding:", pxToRem(5), " 0;width:100%;overflow-x:auto;&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;");
const StyledFilterTagList = /*#__PURE__*/_styled(FilterTagList, process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn44"
} : {
  target: "e1kmhkn44",
  label: "StyledFilterTagList"
})("margin:", pxToRem(10), " 0 ", pxToRem(5), ";");
const ResetButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn43"
} : {
  target: "e1kmhkn43",
  label: "ResetButton"
})("color:", ({
  theme
}) => theme.content.primary1.basic, ";font-size:inherit;font-weight:inherit;line-height:inherit;");
const TagLabelContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn42"
} : {
  target: "e1kmhkn42",
  label: "TagLabelContainer"
})("display:flex;gap:", pxToRem(4), ";flex-wrap:wrap;justify-content:flex-end;");
const AllFilterButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn41"
} : {
  target: "e1kmhkn41",
  label: "AllFilterButton"
})("padding-right:", pxToRem(8), ";");
const HiddenText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1kmhkn40"
} : {
  target: "e1kmhkn40",
  label: "HiddenText"
})("border:0;clip:rect(0 0 0 0);width:", pxToRem(1), ";height:", pxToRem(1), ";overflow:hidden;padding:0;position:absolute;white-space:nowrap;");

function DropdownContent(props) {
  const {
    className,
    type = 'line',
    children
  } = props;
  return jsx(Container$5, {
    className: className,
    type: type,
    children: children
  });
}
const Container$5 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehyf9ps0"
} : {
  target: "ehyf9ps0",
  label: "Container"
})("position:relative;border:none;box-shadow:0 2px 6px 0 rgba(0, 0, 0, 0.2);background-color:", ({
  theme,
  type
}) => type === 'black' ? hexToRgba(theme.content.base0, 0.86) : hexToRgba(theme.colors.background, 0.86), ";color:", ({
  theme,
  type
}) => type === 'black' ? theme.colors.background : theme.content.base0, ";border-radius:4px;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TagMemoContent(props) {
  const {
    className,
    description,
    right
  } = props;
  return jsxs(ContentContent$1, {
    className: className,
    children: [jsx(ContentDescription, {
      children: description
    }), right != null && jsx(ContentRight$1, {
      children: right
    })]
  });
}
const ContentContent$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etqx5i82"
} : {
  target: "etqx5i82",
  label: "ContentContent"
})("display:flex;align-items:center;width:200px;max-width:280px;padding:10px;box-sizing:border-box;font-size:13px;line-height:17px;text-align:start;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "3abrc0",
  styles: "width:auto"
} : {
  name: "194zvvc-ContentContent",
  styles: "width:auto;label:ContentContent;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
}), ";");
const ContentDescription = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "etqx5i81"
} : {
  target: "etqx5i81",
  label: "ContentDescription"
})(process.env.NODE_ENV === "production" ? {
  name: "1xe0xpq",
  styles: "flex:1 1 auto;min-width:0;margin:0;padding:0;word-wrap:break-word"
} : {
  name: "1xe0xpq",
  styles: "flex:1 1 auto;min-width:0;margin:0;padding:0;word-wrap:break-word",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});
const ContentRight$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "etqx5i80"
} : {
  target: "etqx5i80",
  label: "ContentRight"
})(process.env.NODE_ENV === "production" ? {
  name: "hengoj",
  styles: "flex:0 0 auto;margin-left:16px"
} : {
  name: "hengoj",
  styles: "flex:0 0 auto;margin-left:16px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TagProductionContent(props) {
  const {
    className,
    tag,
    right
  } = props;
  const {
    production
  } = tag;
  if (production == null) {
    return null;
  }
  return jsxs(ContentContent, {
    className: className,
    children: [jsx(ContentImageContainer, {
      children: jsx(ContentImage, {
        src: production.originalImageUrl,
        intrinsicAspect: 1
      })
    }), jsxs(ContentSummary, {
      children: [jsxs(ContentBrand, {
        children: [tag.isLikely && jsx(ContentLikely, {
          children: "\uBE44\uC2B7\uD55C \uC0C1\uD488"
        }), production.brand.name]
      }), jsx(ContentName, {
        children: production.name
      }), jsx(ContentPrice, {
        children: production.sellingPrice === 0 ? '가격정보 없음' : `${formatComma(production.sellingPrice)}원`
      })]
    }), right != null && jsx(ContentRight, {
      children: right
    })]
  });
}
const ContentContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue8"
} : {
  target: "e82e9ue8",
  label: "ContentContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1oy203x",
  styles: "position:relative;display:flex;align-items:center;width:280px;padding:10px;box-sizing:border-box;background-color:#F7F9FA;border-radius:8px"
} : {
  name: "1oy203x",
  styles: "position:relative;display:flex;align-items:center;width:280px;padding:10px;box-sizing:border-box;background-color:#F7F9FA;border-radius:8px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentImageContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue7"
} : {
  target: "e82e9ue7",
  label: "ContentImageContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "aoms1q",
  styles: "position:relative;flex:0 0 auto;width:80px;height:80px;margin-right:12px;border-radius:2px;overflow:hidden"
} : {
  name: "aoms1q",
  styles: "position:relative;flex:0 0 auto;width:80px;height:80px;margin-right:12px;border-radius:2px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e82e9ue6"
} : {
  target: "e82e9ue6",
  label: "ContentImage"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentSummary = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue5"
} : {
  target: "e82e9ue5",
  label: "ContentSummary"
})(process.env.NODE_ENV === "production" ? {
  name: "17fh4sh",
  styles: "flex:1 0 0px"
} : {
  name: "17fh4sh",
  styles: "flex:1 0 0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentBrand = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue4"
} : {
  target: "e82e9ue4",
  label: "ContentBrand"
})(process.env.NODE_ENV === "production" ? {
  name: "1y21f7g",
  styles: "margin:0 0 2px;font-size:12px;line-height:17px;color:#757575"
} : {
  name: "1y21f7g",
  styles: "margin:0 0 2px;font-size:12px;line-height:17px;color:#757575",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentLikely = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue3"
} : {
  target: "e82e9ue3",
  label: "ContentLikely"
})("margin-right:1ch;font-weight:bold;color:", ({
  theme
}) => theme.colors.backgroundBrand, ";");
const ContentName = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue2"
} : {
  target: "e82e9ue2",
  label: "ContentName"
})(process.env.NODE_ENV === "production" ? {
  name: "1x5v22f",
  styles: "height:36px;font-size:14px;line-height:18px;color:#292929;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:2;word-wrap:break-word;-webkit-box-orient:vertical;overflow:hidden"
} : {
  name: "1x5v22f",
  styles: "height:36px;font-size:14px;line-height:18px;color:#292929;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:2;word-wrap:break-word;-webkit-box-orient:vertical;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentPrice = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue1"
} : {
  target: "e82e9ue1",
  label: "ContentPrice"
})(process.env.NODE_ENV === "production" ? {
  name: "1dt67t6",
  styles: "margin:6px 0 0;font-size:16px;font-weight:700;line-height:17px;color:#292929"
} : {
  name: "1dt67t6",
  styles: "margin:6px 0 0;font-size:16px;font-weight:700;line-height:17px;color:#292929",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});
const ContentRight = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e82e9ue0"
} : {
  target: "e82e9ue0",
  label: "ContentRight"
})(process.env.NODE_ENV === "production" ? {
  name: "oox8ot",
  styles: "flex:0 0 auto;margin-left:6px;color:#757575"
} : {
  name: "oox8ot",
  styles: "flex:0 0 auto;margin-left:6px;color:#757575",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});

var _g, _defs;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgIcWhitePlusTag = function SvgIcWhitePlusTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_white_plus_tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.08,
    d: "M17.5 9a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C8CC",
    fillRule: "evenodd",
    d: "M9.771 5.143H8.23V8.23H5.143v1.543h3.086v3.085H9.77V9.772h3.086V8.229H9.771z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_white_plus_tag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
var WhitePlusTagIcon = SvgIcWhitePlusTag;

const TAG_BUTTON_WIDTH = 18;
const TagButton = /*#__PURE__*/forwardRef(({
  themeColor,
  isActive,
  ...restProps
}, ref) => {
  return jsx(Button, {
    type: "button",
    ref: ref,
    themeColor: themeColor,
    isActive: isActive,
    "aria-label": "\uC0C1\uD488 \uD0DC\uADF8 \uBC84\uD2BC",
    ...restProps,
    children: themeColor === 'white' ? jsx(WhitePlusTagIcon, {}) : jsx(Icon$2, {
      name: "add_thick",
      size: 12,
      fill: color => color.content.white
    })
  });
});
const getBackgroundColor = (themeColor, color) => {
  if (themeColor === 'blue') {
    return color.content.primary1.basic;
  }
  if (themeColor === 'white') {
    return color.colors.background;
  }
  return color.content.base2;
};
const Button = /*#__PURE__*/_styled('button', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: prop => prop !== 'themeColor' && prop !== 'isActive',
  target: "e1qvzrsn0"
} : {
  shouldForwardProp: prop => prop !== 'themeColor' && prop !== 'isActive',
  target: "e1qvzrsn0",
  label: "Button"
})(RESET_BUTTON, ";width:", pxToRem(TAG_BUTTON_WIDTH), ";height:", pxToRem(TAG_BUTTON_WIDTH), ";padding:0;background:", ({
  themeColor,
  isActive,
  theme
}) => hexToRgba(getBackgroundColor(themeColor, theme), isActive ? 1 : 0.8), ";color:", ({
  theme,
  themeColor
}) => themeColor === 'white' ? hexToRgba(theme.base.neutral700, 0.1) : 'none', ";border:", ({
  theme,
  themeColor
}) => themeColor === 'white' ? `1px solid ${hexToRgba(theme.colors.background, 0.05)}` : 'none', ";border-radius:50%;display:flex;align-items:center;justify-content:center;");

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TAG_ITEM_DEFAULT_RENDER_CONTENT = props => {
  const {
    tag
  } = props;
  if ('production' in tag && tag.production != null && 'sellingPrice' in tag.production) {
    return jsx(DropdownContent, {
      type: "white",
      children: jsx(TagProductionContent, {
        tag: tag
      })
    });
  }
  return jsx(DropdownContent, {
    type: "black",
    children: jsx(TagMemoContent, {
      description: tag.description ?? ''
    })
  });
};
const getTagTheme = tag => {
  // 회색태그
  // 사용자 또는 운영자가 상품정보 없이 설명만 추가한 태그 (isLikely, onHide 상태와 관계없음)
  if ((tag.productionId == null || tag.productionId === 0) && tag.description) {
    return 'gray';
  }

  // 유사태그
  // 운영자가 CDP 이미지 하단 캐러셀 영역에 노출시키기 위한 태그 (CDP 이미지 안에서는 표시되지 않음)
  if (tag.isLikely) {
    return 'white';
  }

  // 노출태그
  // 사용자가 직접 등록했거나 운영자가 CDP 이미지에 노출시키기 위한 태그
  return 'blue';
};
function TagItem(props) {
  const {
    tag,
    index,
    className,
    contentStyles,
    onOpen,
    onClose,
    isOpen,
    isDragging,
    useHover,
    onClick,
    onMouseDown,
    onTouchStart,
    buttonRef,
    buttonProps,
    renderContent = TAG_ITEM_DEFAULT_RENDER_CONTENT,
    arrow
  } = props;

  // 태그 input 영역 클릭 시 이벤트 전파 방지
  const handleClickContent = e => {
    e.stopPropagation();
  };

  // div 태그에는 키보드 이벤트 핸들러도 있어야 한다는 접근성 에러 발생해서 추가해줌
  const handleKeyDown = e => {
    e.stopPropagation();
  };
  return jsx(StyledInfoTip, {
    usePortal: true,
    buttonStyle: {
      position: 'absolute',
      top: `${tag.positionY}%`,
      left: `${tag.positionX}%`,
      margin: '-12px 0px 0px -12px'
    },
    contentClassName: className,
    renderOpener: ({
      isOpen,
      onToggle,
      onMouseEnter,
      onMouseLeave
    }) => jsx(ItemButton$2, {
      type: "button",
      isActive: isOpen,
      themeColor: getTagTheme(tag),
      onClick: e => {
        if (onClick != null) {
          onClick(e);
        }
        if (!e.defaultPrevented) {
          e.preventDefault();
          onToggle();
        }
      },
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onTouchStart: onTouchStart,
      onMouseDown: onMouseDown,
      ref: buttonRef,
      ...(buttonProps || {})
    }),
    onOpenChange: isOpen => isOpen ? onOpen() : onClose(),
    forceOpen: isOpen,
    openOnHover: useHover,
    arrow: arrow,
    contentStyle: {
      display: isOpen ? 'block' : 'none',
      visibility: isDragging ? 'hidden' : 'visible',
      ...contentStyles
    },
    children: jsx("div", {
      onClick: handleClickContent,
      onKeyDown: handleKeyDown,
      children: isOpen && renderContent({
        tag,
        index
      })
    })
  });
}
const ItemButton$2 = /*#__PURE__*/_styled(TagButton, process.env.NODE_ENV === "production" ? {
  target: "epo50qn1"
} : {
  target: "epo50qn1",
  label: "ItemButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1qg9k8g",
  styles: "display:inline-block;margin:0;padding:0;border:none;font-size:0;cursor:pointer"
} : {
  name: "1qg9k8g",
  styles: "display:inline-block;margin:0;padding:0;border:none;font-size:0;cursor:pointer",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});
const StyledInfoTip = /*#__PURE__*/_styled(InfoTip, process.env.NODE_ENV === "production" ? {
  target: "epo50qn0"
} : {
  target: "epo50qn0",
  label: "StyledInfoTip"
})(process.env.NODE_ENV === "production" ? {
  name: "a4hmbt",
  styles: "position:absolute"
} : {
  name: "a4hmbt",
  styles: "position:absolute",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});

function useDraggable(value, onChange, onClick, getPos) {
  const [current, setCurrent] = useState(null);
  const touchingRef = useRef(false);
  const preventClickUntilRef = useRef(0);
  const handleMouseDown = useCallback(e => {
    if (onChange == null || touchingRef.current) {
      return;
    }
    let currentHandle;
    let changed = false;
    const handleMouseMove = e => {
      const currentPos = getPos(e.clientX, e.clientY);
      if (currentPos == null) {
        return;
      }
      currentHandle = {
        ...currentHandle,
        x: Math.min(100, Math.max(0, currentPos.x + currentHandle.offsetX)),
        y: Math.min(100, Math.max(0, currentPos.y + currentHandle.offsetY))
      };
      changed = true;
      setCurrent(currentHandle);
    };
    const handleMouseUp = () => {
      if (changed) {
        onChange({
          x: currentHandle.x,
          y: currentHandle.y
        });
        setCurrent(null);
        preventClickUntilRef.current = Date.now() + 100;
      }
      touchingRef.current = false;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
    // Calculate difference between tag's position and mouse position
    const currentPos = getPos(e.clientX, e.clientY);
    if (currentPos == null) {
      return;
    }
    currentHandle = {
      offsetX: value.x - currentPos.x,
      offsetY: value.y - currentPos.y,
      x: value.x,
      y: value.y
    };
    touchingRef.current = true;
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  }, [value, onChange, getPos]);
  const handleTouchStart = useCallback(e => {
    if (onChange == null || touchingRef.current) {
      return;
    }
    // eslint-disable-next-line prefer-destructuring
    const touch = e.changedTouches[0];
    let currentHandle;
    let changed = false;
    const handleTouchMove = e => {
      let currentTouch;
      const touches = e.changedTouches;
      for (let i = 0; i < touches.length; i += 1) {
        if (touches[i].identifier === touch.identifier) {
          currentTouch = touches[i];
        }
      }
      if (currentTouch == null) {
        return;
      }
      const currentPos = getPos(currentTouch.clientX, currentTouch.clientY);
      if (currentPos == null) {
        return;
      }
      currentHandle = {
        ...currentHandle,
        x: Math.min(100, Math.max(0, currentPos.x + currentHandle.offsetX)),
        y: Math.min(100, Math.max(0, currentPos.y + currentHandle.offsetY))
      };
      e.preventDefault();
      setCurrent(currentHandle);
      changed = true;
    };
    const handleTouchEnd = e => {
      let currentTouch;
      const touches = e.changedTouches;
      for (let i = 0; i < touches.length; i += 1) {
        if (touches[i].identifier === touch.identifier) {
          currentTouch = touches[i];
        }
      }
      if (currentTouch == null) {
        return;
      }
      if (changed) {
        onChange({
          x: currentHandle.x,
          y: currentHandle.y
        });
        setCurrent(null);
        preventClickUntilRef.current = Date.now() + 100;
      }
      touchingRef.current = false;
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
      window.removeEventListener('touchcancel', handleTouchEnd);
    };
    // Calculate difference between tag's position and mouse position
    const currentPos = getPos(touch.clientX, touch.clientY);
    if (currentPos == null) {
      return;
    }
    currentHandle = {
      offsetX: value.x - currentPos.x,
      offsetY: value.y - currentPos.y,
      x: value.x,
      y: value.y
    };
    touchingRef.current = true;
    window.addEventListener('touchmove', handleTouchMove, {
      passive: false
    });
    window.addEventListener('touchend', handleTouchEnd);
    window.addEventListener('touchcancel', handleTouchEnd);
  }, [value, onChange, getPos]);
  const handleClick = useCallback(e => {
    if (Date.now() < preventClickUntilRef.current) {
      e.preventDefault();
      return;
    }
    if (onClick != null) {
      onClick(e);
    }
  }, [onClick]);
  return {
    isDragging: current != null,
    value: current ?? value,
    onMouseDown: handleMouseDown,
    onTouchStartSync: handleTouchStart,
    onClick: handleClick
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ImageTagDraggableOverlayItem = /*#__PURE__*/React__default.memo(props => {
  const {
    className,
    tagContentStyles,
    tag,
    index,
    isOpen,
    onOpen,
    onClose,
    onChange,
    getPos,
    useHover,
    renderContent,
    disableInteraction,
    buttonProps,
    arrow
  } = props;
  const dragProps = useDraggable({
    x: tag.positionX,
    y: tag.positionY
  }, value => onChange(index, {
    ...tag,
    positionX: value.x,
    positionY: value.y
  }), null, getPos);
  const buttonRef = useRef(null);
  useEffect(() => {
    const button = buttonRef.current;
    if (button == null || disableInteraction) {
      return;
    }
    button.addEventListener('touchstart', dragProps.onTouchStartSync, {
      passive: false
    });
    return () => {
      button.removeEventListener('touchstart', dragProps.onTouchStartSync);
    };
  }, [buttonRef, dragProps.onTouchStartSync, disableInteraction]);
  return jsx(ItemTagItem, {
    className: className,
    contentStyles: tagContentStyles,
    index: index,
    tag: {
      ...tag,
      positionX: dragProps.value.x,
      positionY: dragProps.value.y
    },
    isOpen: isOpen,
    isDragging: dragProps.isDragging,
    onOpen: () => onOpen?.(index, tag),
    onClose: () => isOpen && onClose
    // eslint-disable-next-line react/jsx-handler-names
    ,
    onClick: dragProps.onClick
    // eslint-disable-next-line react/jsx-handler-names
    ,
    onMouseDown: e => {
      if (disableInteraction) {
        return;
      }
      dragProps.onMouseDown(e);
    },
    useHover: !dragProps.isDragging && useHover,
    buttonRef: buttonRef,
    renderContent: renderContent,
    buttonProps: buttonProps,
    arrow: arrow
  });
});
function ImageTagDraggableOverlay(props) {
  const {
    className,
    style,
    tagContentStyles,
    tags,
    activeIndex,
    onSelect,
    onClick,
    onChange,
    children,
    useHover,
    renderContent,
    divProps = {},
    buttonProps,
    disableInteraction
  } = props;
  const overlayRef = useRef(null);
  const getPos = useCallback((clientX, clientY) => {
    const overlay = overlayRef.current;
    if (overlay == null) {
      return {
        x: 0,
        y: 0
      };
    }
    const bounds = overlay.getBoundingClientRect();
    const positionX = (clientX - bounds.left) / bounds.width * 100;
    const positionY = (clientY - bounds.top) / bounds.height * 100;
    return {
      x: Math.max(0, Math.min(100, positionX)),
      y: Math.max(0, Math.min(100, positionY))
    };
  }, [overlayRef]);
  const handleOverlayClick = useCallback(e => {
    if (disableInteraction) {
      return;
    }
    // Only run this within image box (not in dropdown)
    if (overlayRef.current != null && e.target !== overlayRef.current && !overlayRef.current.contains(e.target)) {
      return;
    }
    if (e.defaultPrevented) {
      return;
    }
    const pos = getPos(e.clientX, e.clientY);
    if (onClick != null && pos != null) {
      onClick(pos.x, pos.y);
    }
  }, [disableInteraction, onClick, getPos]);
  const handleClose = useCallback(() => {
    onSelect(null, null);
  }, [onSelect]);
  return jsxs(OverlayOverlay, {
    className: className,
    style: style,
    ref: overlayRef,
    onClick: handleOverlayClick,
    ...divProps,
    children: [typeof children === 'function' ? children({
      getPos
    }) : children, tags.map((tag, i) => jsx(OverlayImageTagDraggableOverlayItem, {
      tag: tag,
      tagContentStyles: tagContentStyles,
      isOpen: i === activeIndex,
      index: i,
      onOpen: onSelect,
      onClose: handleClose,
      onChange: onChange,
      getPos: getPos,
      useHover: !!useHover,
      renderContent: renderContent,
      disableInteraction: disableInteraction,
      buttonProps: buttonProps
    }, tag.key || i))]
  });
}
const ItemTagItem = /*#__PURE__*/_styled(TagItem, process.env.NODE_ENV === "production" ? {
  target: "e1pl5i932"
} : {
  target: "e1pl5i932",
  label: "ItemTagItem"
})();
const OverlayOverlay = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1pl5i931"
} : {
  target: "e1pl5i931",
  label: "OverlayOverlay"
})(process.env.NODE_ENV === "production" ? {
  name: "1d8by72",
  styles: "position:relative;font-size:0"
} : {
  name: "1d8by72",
  styles: "position:relative;font-size:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
});
const OverlayImageTagDraggableOverlayItem = /*#__PURE__*/_styled(ImageTagDraggableOverlayItem, process.env.NODE_ENV === "production" ? {
  target: "e1pl5i930"
} : {
  target: "e1pl5i930",
  label: "OverlayImageTagDraggableOverlayItem"
})();

function useRefList() {
  const listRef = useRef(new Set());
  return [() => {
    let item = null;
    return current => {
      if (item != null) {
        listRef.current.delete(item);
      }
      if (current != null) {
        listRef.current.add(current);
      }
      item = current;
    };
  }, listRef];
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ProductionSelectPanelItem(props) {
  const {
    production,
    onSelect,
    size
  } = props;
  return jsxs(ItemItem$1, {
    type: "button",
    onClick: () => onSelect(),
    isLarge: size === 'lg',
    className: `item--${size}`,
    children: [jsx(ItemImageContainer, {
      children: jsx(ItemImage$1, {
        src: production.originalImageUrl,
        intrinsicAspect: 1
      })
    }), jsxs(ItemContent$1, {
      children: [jsx(ItemBrand, {
        children: production.brand.name
      }), jsx(ItemTitle, {
        children: production.name
      })]
    }), jsx(ItemRight$1, {
      children: jsx(ItemButton$1, {
        children: "\uC120\uD0DD"
      })
    })]
  });
}
const ItemButton$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "elpofgh7"
} : {
  target: "elpofgh7",
  label: "ItemButton"
})("padding:6px 15px;line-height:20px;font-size:14px;font-weight:400;letter-spacing:-0.3px;text-align:center;color:", ({
  theme
}) => theme.colors.foreground, ";background-color:", ({
  theme
}) => theme.colors.background, ";border:1px solid #DADDE0;border-radius:4px;transition:.1s background-color;");
var _ref$5 = process.env.NODE_ENV === "production" ? {
  name: "7xc8cv",
  styles: "padding:6px 30px"
} : {
  name: "m8g5j9-ItemItem",
  styles: "padding:6px 30px;label:ItemItem;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
};
const ItemItem$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "elpofgh6"
} : {
  target: "elpofgh6",
  label: "ItemItem"
})("display:flex;width:100%;align-items:center;margin:0;padding:5px 15px;", ({
  isLarge
}) => isLarge && _ref$5, " cursor:pointer;background:transparent;border:none;box-sizing:border-box;font:inherit;font-family:$font-default;text-align:left;transition:.1s background-color;", HOVER$1`
    background-color: #f7f8fa
  `, " ", HOVER$1`
    & ${ItemButton$1} {
      background-color: #F7F9FA;
    }
  `, ";");
const ItemImageContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "elpofgh5"
} : {
  target: "elpofgh5",
  label: "ItemImageContainer"
})("flex:0 0 auto;position:relative;width:70px;height:70px;margin-right:15px;border-radius:22px;overflow:hidden;&:after{content:'';position:absolute;display:block;top:0;left:0;width:100%;height:100%;box-sizing:border-box;border-radius:22px;border:1px solid rgba(", ({
  theme
}) => theme.colors.foregroundWeak, ", 0.33);}.item--lg &{width:90px;height:90px;border-radius:26px;}.item--lg &:after{border-radius:26px;}");
const ItemImage$1 = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "elpofgh4"
} : {
  target: "elpofgh4",
  label: "ItemImage"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0zrug",
  styles: "position:absolute;top:0;left:0;width:100%"
} : {
  name: "1r0zrug",
  styles: "position:absolute;top:0;left:0;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});
const ItemContent$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "elpofgh3"
} : {
  target: "elpofgh3",
  label: "ItemContent"
})(process.env.NODE_ENV === "production" ? {
  name: "h1w78m",
  styles: "flex:1 0 0px;align-self:stretch"
} : {
  name: "h1w78m",
  styles: "flex:1 0 0px;align-self:stretch",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});
const ItemBrand = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "elpofgh2"
} : {
  target: "elpofgh2",
  label: "ItemBrand"
})("color:", ({
  theme
}) => theme.colors.foregroundWeak, ";font-weight:500;font-size:12px;line-height:16px;letter-spacing:-0.3px;margin-bottom:2px;");
const ItemTitle = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "elpofgh1"
} : {
  target: "elpofgh1",
  label: "ItemTitle"
})("color:", ({
  theme
}) => theme.colors.foreground, ";font-size:14px;font-weight:500;line-height:18px;letter-spacing:-0.3px;height:38px;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:2;word-wrap:break-word;-webkit-box-orient:vertical;overflow:hidden;");
const ItemRight$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "elpofgh0"
} : {
  target: "elpofgh0",
  label: "ItemRight"
})(process.env.NODE_ENV === "production" ? {
  name: "13q2ceu",
  styles: "flex:0 0 auto;margin-left:18px"
} : {
  name: "13q2ceu",
  styles: "flex:0 0 auto;margin-left:18px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function useDebounce(value, onChange, delay = 400) {
  const [innerValue, setInnerValue] = useState(null);
  const handleChange = useCallback(e => {
    setInnerValue({
      value: e.target.value
    });
  }, []);
  const handleKeyDown = useCallback(e => {
    if (e.keyCode === 13 && innerValue != null) {
      onChange(innerValue.value);
      setInnerValue(null);
    }
  }, [innerValue, onChange]);
  useEffect(() => {
    if (innerValue == null) {
      return;
    }
    const timer = setTimeout(() => {
      onChange(innerValue.value);
      setInnerValue(null);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [innerValue, delay, onChange, setInnerValue]);
  return {
    value: innerValue != null ? innerValue.value : value,
    onChange: handleChange,
    onKeyDown: handleKeyDown
  };
}
const DEFAULT_RENDER_ITEM = props => jsx(ProductionSelectPanelItem, {
  size: "sm",
  ...props
});
function ProductionSelectPanel(props) {
  const {
    className,
    headerClassName,
    style,
    per,
    initialParams,
    onFetch,
    onSelect,
    placeholder,
    inputPlaceholder,
    header,
    searchRight,
    panelRef,
    renderItem = DEFAULT_RENDER_ITEM
  } = props;
  const [data, setData] = useState({
    params: null,
    productions: [],
    hasNext: false
  });
  const [params, setParams] = useState(initialParams);
  const handleSetKeyword = useCallback(keyword => {
    setParams(prev => ({
      ...prev,
      keyword
    }));
  }, []);
  const inputProps = useDebounce(params.keyword, handleSetKeyword);
  const {
    productions,
    hasNext,
    cursor
  } = data;
  const pendingRef = useRef(0);
  const inputRef = useRef(null);
  const contentRef = useRef(null);
  const handleRowsRendered = useCallback(async ({
    endItemIndex
  }) => {
    if (endItemIndex >= productions.length && hasNext && pendingRef.current === 0) {
      // Try to load next page
      pendingRef.current = 2;
      onFetch(params, cursor).then(v => {
        if (pendingRef.current === 2) {
          pendingRef.current = 0;
          setData({
            ...v,
            params,
            productions: [...data.productions, ...v.productions]
          });
        }
      });
    }
  }, [params, data, onFetch, cursor, productions.length, hasNext]);
  useEffect(() => {
    pendingRef.current = 1;
    onFetch(params, null).then(v => {
      pendingRef.current = 0;
      if (contentRef.current != null) {
        contentRef.current.scrollTop = 0;
      }
      setData({
        ...v,
        params
      });
    });
  }, [params, onFetch]);
  useImperativeHandle(panelRef, () => ({
    focusInput: () => {
      if (inputRef.current != null) {
        inputRef.current.focus();
      }
    }
  }));
  const selectedTab = data.tab?.options.find(option => option.value === data.tab?.selected);
  return jsxs(PanelPanel$1, {
    className: className,
    style: style,
    children: [jsxs(PanelHeader$1, {
      className: headerClassName,
      children: [jsxs(PanelSearch, {
        children: [jsx(PanelInputContainer, {
          children: jsx(PanelInput$1, {
            size: 40,
            placeholder: inputPlaceholder || '상품명, 브랜드를 검색',
            ...inputProps,
            value: inputProps.value || '',
            ref: inputRef,
            icon: {
              iconComponent: SearchIcon,
              onClick: () => {
                if (inputProps.value != null) {
                  handleSetKeyword(inputProps.value);
                }
              }
            }
          })
        }), searchRight != null && searchRight]
      }), header != null && jsx(PanelHeaderContent, {
        children: typeof header === 'function' ? header({
          params,
          onChange: setParams,
          tab: data.tab
        }) : header
      })]
    }), jsx(PanelContent$1, {
      ref: contentRef,
      contentEmpty: productions.length === 0,
      children: params !== data.params ? jsxs(PanelLoading, {
        children: [jsx(PanelSpinner, {}), jsx(PanelText, {
          children: "\uC0C1\uD488 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
        })]
      }) : jsxs(Fragment, {
        children: [productions.length === 0 && jsx(PanelEmpty, {
          children: placeholder(params)
        }), productions.length > 0 && jsx(VirtualizedList, {
          "data-testid": "production-list",
          grid: {
            mobile: 1,
            tablet: 1,
            laptop: 1,
            desktop: 1
          },
          count: productions.length + (hasNext ? per : 0),
          insertedItemList: selectedTab?.title || selectedTab?.description ? [{
            rowIndex: 0,
            component: jsxs(ListInfo, {
              children: [jsx(ListTitle, {
                children: selectedTab.title
              }), jsx(ListDescription, {
                children: selectedTab.description
              })]
            })
          }] : undefined,
          renderItem: index => {
            const production = productions[index];
            if (production != null) {
              return jsx(React__default.Fragment, {
                children: renderItem({
                  production,
                  onSelect: () => onSelect(production)
                })
              }, index);
            }
            return jsx("div", {});
          },
          tabId: "",
          disableSaveScroll: true,
          disableUseWindowScroll: true,
          loadItemList: handleRowsRendered
        })]
      })
    })]
  });
}
const PanelPanel$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt13"
} : {
  target: "e84qdlt13",
  label: "PanelPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelHeader$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt12"
} : {
  target: "e84qdlt12",
  label: "PanelHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "1jifx4c",
  styles: "flex:0 0 auto;padding:20px 15px 0"
} : {
  name: "1jifx4c",
  styles: "flex:0 0 auto;padding:20px 15px 0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelSearch = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt11"
} : {
  target: "e84qdlt11",
  label: "PanelSearch"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelInputContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt10"
} : {
  target: "e84qdlt10",
  label: "PanelInputContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "17fh4sh",
  styles: "flex:1 0 0px"
} : {
  name: "17fh4sh",
  styles: "flex:1 0 0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelInput$1 = /*#__PURE__*/_styled(Input$1, process.env.NODE_ENV === "production" ? {
  target: "e84qdlt9"
} : {
  target: "e84qdlt9",
  label: "PanelInput"
})(process.env.NODE_ENV === "production" ? {
  name: "mc6377",
  styles: "width:100%;input{width:100%;}"
} : {
  name: "mc6377",
  styles: "width:100%;input{width:100%;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelHeaderContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt8"
} : {
  target: "e84qdlt8",
  label: "PanelHeaderContent"
})(process.env.NODE_ENV === "production" ? {
  name: "19z8z74",
  styles: "margin:15px 0 0;text-align:center;line-height:0"
} : {
  name: "19z8z74",
  styles: "margin:15px 0 0;text-align:center;line-height:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
var _ref$4 = process.env.NODE_ENV === "production" ? {
  name: "16mmcnu",
  styles: "display:flex;flex-direction:column;justify-content:center"
} : {
  name: "femddd-PanelContent",
  styles: "display:flex;flex-direction:column;justify-content:center;label:PanelContent;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
};
const PanelContent$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt7"
} : {
  target: "e84qdlt7",
  label: "PanelContent"
})("flex:1 1 auto;padding:10px 0;overflow:auto;", ({
  contentEmpty
}) => contentEmpty && _ref$4, ";");
const ListInfo = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt6"
} : {
  target: "e84qdlt6",
  label: "ListInfo"
})(process.env.NODE_ENV === "production" ? {
  name: "1dvsdrc",
  styles: "padding:0 15px 10px"
} : {
  name: "1dvsdrc",
  styles: "padding:0 15px 10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const ListTitle = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt5"
} : {
  target: "e84qdlt5",
  label: "ListTitle"
})(FONT_STYLE.body15L24, ";font-weight:700;");
const ListDescription = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt4"
} : {
  target: "e84qdlt4",
  label: "ListDescription"
})(FONT_STYLE.detail12L20, ";");
const PanelLoading = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt3"
} : {
  target: "e84qdlt3",
  label: "PanelLoading"
})(process.env.NODE_ENV === "production" ? {
  name: "12ahplj",
  styles: "padding:30px 0;text-align:center"
} : {
  name: "12ahplj",
  styles: "padding:30px 0;text-align:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelSpinner = /*#__PURE__*/_styled(Loading, process.env.NODE_ENV === "production" ? {
  target: "e84qdlt2"
} : {
  target: "e84qdlt2",
  label: "PanelSpinner"
})(process.env.NODE_ENV === "production" ? {
  name: "13ksum9",
  styles: "margin:0 0 16px"
} : {
  name: "13ksum9",
  styles: "margin:0 0 16px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelText = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt1"
} : {
  target: "e84qdlt1",
  label: "PanelText"
})(process.env.NODE_ENV === "production" ? {
  name: "1xz0250",
  styles: "margin:0;font-size:13px;line-height:20px;color:#9e9e9e;text-align:center"
} : {
  name: "1xz0250",
  styles: "margin:0;font-size:13px;line-height:20px;color:#9e9e9e;text-align:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
const PanelEmpty = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e84qdlt0"
} : {
  target: "e84qdlt0",
  label: "PanelEmpty"
})(process.env.NODE_ENV === "production" ? {
  name: "ksf9wh",
  styles: "padding:30px 0;font-size:15px;line-height:23px;color:#9e9e9e;text-align:center"
} : {
  name: "ksf9wh",
  styles: "padding:30px 0;font-size:15px;line-height:23px;color:#9e9e9e;text-align:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});

let disableSSR = false;
function useNodeSize(ref, defaultSize = [240, 240]) {
  const [size, setSize] = useState(null);
  const handleRecalculate = useCallback(() => {
    const node = ref.current;
    if (node == null) {
      return;
    }
    const [currentNodeWidth, currentNodeHeight] = [node.clientWidth, node.clientHeight];
    setSize(size => {
      if (size == null || currentNodeWidth > size[0] || currentNodeHeight > size[1]) {
        return [Math.max(currentNodeWidth, defaultSize[0]), Math.max(currentNodeHeight, defaultSize[1])];
      }
      return size;
    });
  }, [ref, defaultSize]);
  useEffect(() => {
    let initId = requestAnimationFrame(() => {
      initId = null;
      disableSSR = true;
      handleRecalculate();
    });
    let recalcTimeoutId = null;
    const handleResize = () => {
      if (recalcTimeoutId != null) {
        window.clearTimeout(recalcTimeoutId);
      }
      recalcTimeoutId = window.setTimeout(() => {
        recalcTimeoutId = null;
        handleRecalculate();
      }, 500);
    };
    let resizeObserver = null;
    const targetNode = ref.current;
    if (window.ResizeObserver != null && targetNode != null) {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(targetNode);
    } else {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (initId != null) {
        cancelAnimationFrame(initId);
      }
      if (recalcTimeoutId != null) {
        window.clearTimeout(recalcTimeoutId);
      }
      if (resizeObserver != null) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [ref, handleRecalculate]);
  if (!disableSSR && size == null) {
    return defaultSize;
  }
  return size;
}

function calculateBounds(width, height, containerWidth, containerHeight) {
  const imageRatio = width / height;
  const containerRatio = containerWidth / containerHeight;
  if (imageRatio > containerRatio) {
    const heightPercent = containerRatio / imageRatio;
    return [0, (1 - heightPercent) / 2, 1, heightPercent];
  }
  const widthPercent = imageRatio / containerRatio;
  return [(1 - widthPercent) / 2, 0, widthPercent, 1];
}
function CoverResizeImage(props) {
  const {
    src,
    alt,
    size,
    maxSize,
    quality,
    focus,
    fit = 'cover',
    className,
    style,
    innerClassName,
    innerStyle,
    children
  } = props;
  const nodeRef = useRef(null);
  const imageRef = useRef(null);
  const actualSize = useNodeSize(nodeRef, size);
  const [imageSize, setImageSize] = useState([1, 1]);
  const getUrl = useCallback((multiplier = 1) => {
    if (actualSize == null) {
      return undefined;
    }
    const nextSize = actualSize.map((v, i) => {
      const value = v * multiplier;
      // @ts-ignore
      if (maxSize != null && maxSize[i] < value) {
        return maxSize[i];
      }
      return value;
    });
    const width = nextSize[0];
    const height = nextSize[1];
    const alignWidth = width ? getNearestSize(width) : undefined;
    const alignHeight = height ? getNearestSize(height) : undefined;
    return getImageUrl({
      src,
      width: alignWidth,
      height: alignHeight,
      mode: 'output',
      quality
    });
  }, [actualSize, maxSize, quality, src]);
  const imageUrl = getUrl(1);
  const srcSet = actualSize != null && src != null ? [1.5, 2, 3].map(size => `${getUrl(size)} ${size}x`).join(',') : undefined;
  const handleImageLoad = useCallback(() => {
    const image = imageRef.current;
    if (image == null) {
      return;
    }
    setImageSize([image.naturalWidth, image.naturalHeight]);
  }, []);
  return jsxs("div", {
    ref: nodeRef,
    className: className,
    style: {
      position: 'relative',
      ...(style ?? {})
    },
    children: [jsx("img", {
      className: innerClassName,
      src: imageUrl,
      alt: alt,
      srcSet: srcSet,
      onLoad: handleImageLoad,
      ref: imageRef,
      style: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        objectFit: fit,
        objectPosition: focus != null ? `${focus[0] * 100}% ${focus[1] * 100}%` : 'center center',
        ...(innerStyle ?? {})
      }
    }), typeof children === 'function' ? children({
      width: imageSize[0],
      height: imageSize[1],
      containerWidth: actualSize != null ? actualSize[0] : 0,
      containerHeight: actualSize != null ? actualSize[1] : 0,
      bounds: calculateBounds(imageSize[0], imageSize[1], actualSize != null ? actualSize[0] : 0, actualSize != null ? actualSize[1] : 0)
    }) : children]
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageTagEditAdminTagContentFormGroup(props) {
  const {
    className,
    label,
    htmlFor,
    useDiv,
    children
  } = props;
  const theme = useTheme();
  const content = jsxs(Fragment, {
    children: [label != null && jsx(GroupLabel, {
      children: label
    }), jsx(GroupContent, {
      children: jsx(GroupInput, {
        children: children
      })
    })]
  });
  if (useDiv) {
    return jsxs(Fragment, {
      children: [jsx(Global, {
        styles: cssGlobalStyles(theme)
      }), jsx(GroupFormGroup, {
        className: classNames(className, 'form-group'),
        children: content
      })]
    });
  }
  return jsxs(Fragment, {
    children: [jsx(Global, {
      styles: cssGlobalStyles(theme)
    }), jsx(LabelFormGroup, {
      className: classNames(className, 'form-group'),
      htmlFor: htmlFor,
      as: "label",
      children: content
    })]
  });
}
const cssFromGroup = /*#__PURE__*/css("display:block;margin:0 0 12px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "1o129hd",
  styles: "display:flex;align-items:flex-start"
} : {
  name: "704hxi-cssFromGroup",
  styles: "display:flex;align-items:flex-start;label:cssFromGroup;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
}), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:cssFromGroup;"));
const GroupLabel = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e18yxgt94"
} : {
  target: "e18yxgt94",
  label: "GroupLabel"
})("flex:0 0 auto;display:block;padding:5px 0 6px;font-size:13px;font-weight:bold;line-height:21px;", MEDIA_QUERY.min('tablet', process.env.NODE_ENV === "production" ? {
  name: "gapozv",
  styles: "min-width:64px"
} : {
  name: "1m8zxb2-GroupLabel",
  styles: "min-width:64px;label:GroupLabel;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
}), ";");
const GroupContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18yxgt93"
} : {
  target: "e18yxgt93",
  label: "GroupContent"
})(process.env.NODE_ENV === "production" ? {
  name: "eo9j86",
  styles: "flex:1 0 0px;min-width:0px"
} : {
  name: "eo9j86",
  styles: "flex:1 0 0px;min-width:0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
});
const GroupInput = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18yxgt92"
} : {
  target: "e18yxgt92",
  label: "GroupInput"
})(process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "4zleql",
  styles: "display:block",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
});
const GroupFormGroup = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e18yxgt91"
} : {
  target: "e18yxgt91",
  label: "GroupFormGroup"
})(cssFromGroup, ";");
const LabelFormGroup = /*#__PURE__*/_styled("label", process.env.NODE_ENV === "production" ? {
  target: "e18yxgt90"
} : {
  target: "e18yxgt90",
  label: "LabelFormGroup"
})(cssFromGroup, ";");
const cssGlobalStyles = theme => /*#__PURE__*/css(".error{display:block;margin:10px 0 0;font-size:13px;font-weight:bold;line-height:19px;color:", theme.colors.backgroundCritical, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:cssGlobalStyles;"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageTagEditAdminTagContentImpl(props, ref) {
  const {
    tag,
    index,
    getProductThumbnailLink,
    onGetProduction,
    onChange,
    onDelete,
    onClose
  } = props;
  const [productionId, setProductionId] = useState(tag.productionId);
  const [pending, setPending] = useState(false);
  const snackbar = useSnackbar();
  const getFieldProps = useCallback(name => ({
    onChange: newValue => onChange({
      ...tag,
      [name]: newValue
    }),
    value: tag[name],
    name
  }), [tag, onChange]);
  // 상품 직접 찾기와 productionSelectPanel에서 상품을 선택했을 때 호출됨
  const handleSetProduction = useCallback(production => {
    setProductionId(production.id);
    const tagHasCustomDescription = !!tag.description && (tag.productionId == null || tag.description !== `[${tag.brand}] ${tag.name}`);
    onChange({
      ...tag,
      production: {
        id: production.id,
        originalImageUrl: production.originalImageUrl,
        brand: production.brand,
        name: production.name,
        sellingPrice: production.sellingPrice
      },
      imageUrl: production.originalImageUrl,
      productionId: production.id,
      brand: production.brand.name,
      name: production.name,
      description: tagHasCustomDescription ? tag.description : `[${production.brand.name}] ${production.name}`
    });
  }, [tag, onChange]);
  const handleFindClick = useCallback(async () => {
    if (productionId == null) {
      return;
    }
    // Retrieve the production
    setPending(true);
    try {
      const production = await onGetProduction(productionId);
      if (production != null) {
        handleSetProduction(production);
      } else {
        snackbar.open({
          content: '상품번호가 존재하지 않습니다.'
        });
        onChange({
          ...tag,
          productionId: null,
          brand: '',
          name: ''
        });
      }
    } finally {
      setPending(false);
    }
  }, [tag, onChange, productionId, handleSetProduction, onGetProduction, snackbar]);
  const handleEmpty = useCallback(() => {
    setProductionId(null);
    onChange({
      ...tag,
      productionId: null,
      brand: null,
      name: null,
      description: null,
      onHide: false,
      isLikely: false
    });
  }, [tag, onChange]);
  const handleDelete = useCallback(() => {
    if (onDelete != null) {
      onDelete(index);
    }
  }, [onDelete, index]);

  // 휴먼에러로 인해 비슷한 상품이 노출되는 상황을 방지하기 위함
  const handleIsLikelyChange = checked => {
    onChange({
      ...tag,
      isLikely: checked,
      onHide: checked || tag.onHide
    });
  };

  // A ref handle to set the production from parent (this is not efficiently
  // implementable by lifting state up)
  useImperativeHandle(ref, () => ({
    setProduction: handleSetProduction
  }));
  return jsx(StyledDropdownContent, {
    children: jsxs(ImplPanel, {
      onSubmit: e => {
        e.preventDefault();
      },
      children: [jsxs(ImplContent, {
        children: [jsxs(ImplHeader, {
          children: [jsx(ImplHeaderLeft, {
            children: onDelete != null && jsx(ImplDeleteButton, {
              size: 14,
              variant: "primary",
              leftIcon: DeleteFilledIcon,
              onClick: handleDelete,
              children: "\uD0DC\uADF8 \uC0AD\uC81C"
            })
          }), jsx(ImplHeaderRight, {
            children: jsx(TextButton$1, {
              size: 14,
              type: "button",
              onClick: handleEmpty,
              variant: "neutral-600",
              children: "\uB0B4\uC6A9 \uBE44\uC6B0\uAE30"
            })
          })]
        }), jsx(ImageTagEditAdminTagContentFormGroup, {
          label: "\uC0C1\uD488\uBC88\uD638",
          useDiv: true,
          children: jsxs(ImplInputRow, {
            children: [jsx(ImplInputCol, {
              children: jsx(StyledInput, {
                value: productionId == null ? undefined : productionId,
                onChange: e => {
                  const value = e.target.value;
                  if (value === '') {
                    setProductionId(null);
                    return;
                  }
                  if (!isNaN(Number(value))) {
                    setProductionId(Number(value));
                  }
                },
                size: 32
              })
            }), jsx(ImplInputCol, {
              inputColSm: true,
              children: jsx(BoxButton, {
                size: 32,
                shape: "filled",
                variant: "primary",
                type: "button",
                onClick: handleFindClick,
                disabled: pending,
                children: "\uCC3E\uAE30"
              })
            })]
          })
        }), tag.productionId && jsx(ImageTagEditAdminTagContentFormGroup, {
          label: "\uC774\uBBF8\uC9C0",
          children: jsx("a", {
            href: getProductThumbnailLink(tag.productionId),
            target: "_blank",
            rel: "noreferrer",
            children: jsx(ThumbnailContainer, {
              children: (tag.imageUrl || tag.production?.originalImageUrl) && jsx(Thumbnail, {
                src: tag.imageUrl || tag.production?.originalImageUrl || '',
                intrinsicAspect: 1,
                intrinsicInitialWidth: 64
              })
            })
          })
        }), jsx(ImageTagEditAdminTagContentFormGroup, {
          label: "\uC0C1\uD488\uBA85",
          children: jsx(StyledInput, {
            value: getFieldProps('name').value ?? '',
            onChange: e => getFieldProps('name').onChange(e.target.value),
            name: getFieldProps('name').name,
            size: 32
          })
        }), jsx(ImageTagEditAdminTagContentFormGroup, {
          label: "\uBE0C\uB79C\uB4DC",
          children: jsx(StyledInput, {
            value: getFieldProps('brand').value ?? '',
            onChange: e => getFieldProps('brand').onChange(e.target.value),
            name: getFieldProps('brand').name,
            size: 32
          })
        }), jsx(ImageTagEditAdminTagContentFormGroup, {
          label: "\uC124\uBA85",
          children: jsx(StyledTextArea, {
            value: getFieldProps('description').value ?? '',
            onChange: e => getFieldProps('description').onChange(e.target.value),
            name: getFieldProps('description').name,
            maxRows: 3,
            autoHeight: true,
            maxLength: 100
          })
        }), jsxs(ImplCheckboxGroup, {
          children: [jsx(ImplCheckboxItem, {
            children: jsx(StyledCheckbox, {
              onCheck: handleIsLikelyChange,
              checked: getFieldProps('isLikely').value,
              children: "\uBE44\uC2B7\uD55C \uC0C1\uD488\uC73C\uB85C \uB4F1\uB85D"
            })
          }), jsx(ImplCheckboxItem, {
            children: jsx(StyledCheckbox, {
              onCheck: getFieldProps('onHide').onChange,
              checked: getFieldProps('onHide').value,
              children: "\uD0DC\uADF8 \uBBF8\uB178\uCD9C"
            })
          })]
        })]
      }), jsx(ImplFooter, {
        children: jsx(ImplButton, {
          variant: "primary",
          shape: "filled",
          size: 32,
          type: "button",
          onClick: onClose,
          children: "\uD655\uC778"
        })
      })]
    })
  });
}
const ImageTagEditAdminTagContent = /*#__PURE__*/React__default.forwardRef(ImageTagEditAdminTagContentImpl);
const StyledDropdownContent = /*#__PURE__*/_styled(DropdownContent, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke17"
} : {
  target: "e2yyqke17",
  label: "StyledDropdownContent"
})(process.env.NODE_ENV === "production" ? {
  name: "18ji2p4",
  styles: "width:300px"
} : {
  name: "18ji2p4",
  styles: "width:300px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplPanel = /*#__PURE__*/_styled("form", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke16"
} : {
  target: "e2yyqke16",
  label: "ImplPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "1khn195",
  styles: "box-sizing:border-box"
} : {
  name: "1khn195",
  styles: "box-sizing:border-box",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke15"
} : {
  target: "e2yyqke15",
  label: "ImplContent"
})(process.env.NODE_ENV === "production" ? {
  name: "8sfx4u",
  styles: "padding:20px 15px 15px"
} : {
  name: "8sfx4u",
  styles: "padding:20px 15px 15px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplHeader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke14"
} : {
  target: "e2yyqke14",
  label: "ImplHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "nb4h2m",
  styles: "display:flex;justify-content:space-between;align-items:center;margin:0 0 24px"
} : {
  name: "nb4h2m",
  styles: "display:flex;justify-content:space-between;align-items:center;margin:0 0 24px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplHeaderLeft = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke13"
} : {
  target: "e2yyqke13",
  label: "ImplHeaderLeft"
})();
const ImplDeleteButton = /*#__PURE__*/_styled(TextButton$1, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke12"
} : {
  target: "e2yyqke12",
  label: "ImplDeleteButton"
})("&&{color:", ({
  theme
}) => theme.colors.backgroundCritical, ";font-weight:700;}.left-icon{color:", ({
  theme
}) => theme.colors.backgroundCritical, ";}");
const ImplHeaderRight = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke11"
} : {
  target: "e2yyqke11",
  label: "ImplHeaderRight"
})();
const ThumbnailContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke10"
} : {
  target: "e2yyqke10",
  label: "ThumbnailContainer"
})("width:64px;height:64px;border-radius:16px;border:1px solid ", ({
  theme
}) => hexToRgba(theme.colors.background, 0.1), ";overflow:hidden;background:", ({
  theme
}) => theme.colors.backgroundDisabled, ";");
const Thumbnail = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke9"
} : {
  target: "e2yyqke9",
  label: "Thumbnail"
})(process.env.NODE_ENV === "production" ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : {
  name: "w1atjl",
  styles: "width:100%;height:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplInputRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke8"
} : {
  target: "e2yyqke8",
  label: "ImplInputRow"
})(process.env.NODE_ENV === "production" ? {
  name: "zc0imr",
  styles: "width:100%;display:flex;margin:0 -3px"
} : {
  name: "zc0imr",
  styles: "width:100%;display:flex;margin:0 -3px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
var _ref$3 = process.env.NODE_ENV === "production" ? {
  name: "ou8xsw",
  styles: "flex:0 0 auto"
} : {
  name: "g7xz16-ImplInputCol",
  styles: "flex:0 0 auto;label:ImplInputCol;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
};
const ImplInputCol = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke7"
} : {
  target: "e2yyqke7",
  label: "ImplInputCol"
})("min-width:0;margin:0 3px;flex:1 0 0px;", ({
  inputColSm
}) => inputColSm && _ref$3, ";");
const ImplCheckboxGroup = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke6"
} : {
  target: "e2yyqke6",
  label: "ImplCheckboxGroup"
})(process.env.NODE_ENV === "production" ? {
  name: "n2mfd8",
  styles: "display:flex;justify-content:flex-end;margin:0 -6px;color:#424242"
} : {
  name: "n2mfd8",
  styles: "display:flex;justify-content:flex-end;margin:0 -6px;color:#424242",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplCheckboxItem = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke5"
} : {
  target: "e2yyqke5",
  label: "ImplCheckboxItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1srf8tk",
  styles: "flex:0 0 auto;font-size:12px"
} : {
  name: "1srf8tk",
  styles: "flex:0 0 auto;font-size:12px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const StyledCheckbox = /*#__PURE__*/_styled(CheckboxWithText, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke4"
} : {
  target: "e2yyqke4",
  label: "StyledCheckbox"
})(process.env.NODE_ENV === "production" ? {
  name: "1o0y3ct",
  styles: "span{font-size:13px;padding-right:8px;}"
} : {
  name: "1o0y3ct",
  styles: "span{font-size:13px;padding-right:8px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const StyledInput = /*#__PURE__*/_styled(Input$1, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke3"
} : {
  target: "e2yyqke3",
  label: "StyledInput"
})("width:100%;background-color:", ({
  theme
}) => theme.colors.background, ";.input-wrapper{border:1px solid #dbdbdb;}input{", ODS_FONT_STYLE.detail13L18, ";height:auto;}");
const StyledTextArea = /*#__PURE__*/_styled(Textarea, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke2"
} : {
  target: "e2yyqke2",
  label: "StyledTextArea"
})("background-color:", ({
  theme
}) => theme.colors.background, ";padding:6px 12px;width:100%;textarea{", ODS_FONT_STYLE.detail13L18, ";margin:0;}");
const ImplFooter = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2yyqke1"
} : {
  target: "e2yyqke1",
  label: "ImplFooter"
})(process.env.NODE_ENV === "production" ? {
  name: "hef3m5",
  styles: "display:flex;border-top:1px solid #eaebef;justify-content:center;padding:12px 0"
} : {
  name: "hef3m5",
  styles: "display:flex;border-top:1px solid #eaebef;justify-content:center;padding:12px 0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
const ImplButton = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e2yyqke0"
} : {
  target: "e2yyqke0",
  label: "ImplButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1qlnqjd",
  styles: "&&{width:86px;margin:0 4px;}"
} : {
  name: "1qlnqjd",
  styles: "&&{width:86px;margin:0 4px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const isAdminViewProduct = product => {
  return 'statusBadge' in product;
};
function ImageTagEditAdminProductionItem(props) {
  const {
    production,
    onSelect,
    getProductThumbnailLink
  } = props;
  const thumbnailLink = getProductThumbnailLink(production.id);
  const isAdminView = isAdminViewProduct(production);
  return jsxs(ItemItem, {
    children: [jsx(Global, {
      styles: GLOBAL_STYLE$1
    }), jsx(ItemOverlay, {
      type: "button",
      onClick: () => onSelect()
    }), jsx(ItemHoverOverlay, {}), jsxs(ItemWithBadge, {
      children: [isAdminView && production.taggedBadge && jsx(ImageBadge, {
        children: production.taggedBadge
      }), jsxs(ItemContainer, {
        children: [jsx(ItemImage, {
          src: production.originalImageUrl,
          intrinsicAspect: 1
        }), jsx("a", {
          href: thumbnailLink,
          target: "_blank",
          rel: "noreferrer",
          className: "image-link",
          children: jsx(ItemLinkBadge, {
            children: "\uC0C1\uC138\uD398\uC774\uC9C0"
          })
        })]
      })]
    }), jsxs(ItemContent, {
      children: [jsx(ItemBold, {
        children: production.brand.name
      }), jsx(ItemNormal, {
        children: production.name
      }), isAdminView && jsx(ItemNormal, {
        children: production.orderDate
      }), isAdminView && jsx(ItemBadgeContainer, {
        children: production.statusBadge && jsx(ItemBadge, {
          children: production.statusBadge
        })
      })]
    }), jsx(ItemRight, {
      children: jsx(ItemButton, {
        children: "\uC120\uD0DD"
      })
    })]
  });
}
const ItemItem = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel14"
} : {
  target: "e1nxluel14",
  label: "ItemItem"
})(process.env.NODE_ENV === "production" ? {
  name: "15zktq1",
  styles: "position:relative;display:flex;width:100%;align-items:center;margin:0;padding:6px 30px;border:none;box-sizing:border-box;font:inherit;font-family:$font-default;text-align:left"
} : {
  name: "15zktq1",
  styles: "position:relative;display:flex;width:100%;align-items:center;margin:0;padding:6px 30px;border:none;box-sizing:border-box;font:inherit;font-family:$font-default;text-align:left",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemRight = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel13"
} : {
  target: "e1nxluel13",
  label: "ItemRight"
})(process.env.NODE_ENV === "production" ? {
  name: "mxrsyh",
  styles: "flex:0 0 auto;position:relative;margin-left:18px"
} : {
  name: "mxrsyh",
  styles: "flex:0 0 auto;position:relative;margin-left:18px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemButton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel12"
} : {
  target: "e1nxluel12",
  label: "ItemButton"
})("padding:6px 15px;line-height:20px;font-size:14px;font-weight:bold;text-align:center;color:", ({
  theme
}) => theme.colors.foregroundInverse, ";background-color:", ({
  theme
}) => theme.colors.foregroundBrand, ";border-radius:4px;transition:.1s background-color;");
const ItemHoverOverlay = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel11"
} : {
  target: "e1nxluel11",
  label: "ItemHoverOverlay"
})("display:block;position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0;background-color:", ({
  theme
}) => theme.colors.background, ";transition:.1s background-color;");
const ItemOverlay = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel10"
} : {
  target: "e1nxluel10",
  label: "ItemOverlay"
})("display:block;position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0;cursor:pointer;z-index:3;background:transparent;border:none;", HOVER$1`
    & ~ ${ItemRight} ${ItemButton} {
      background-color: #09addb;
      }
    `, " ", HOVER$1`
    & ~ ${ItemHoverOverlay} {
      background-color: #f7f8fa;
      }
    `, ";");
const ItemWithBadge = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel9"
} : {
  target: "e1nxluel9",
  label: "ItemWithBadge"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel8"
} : {
  target: "e1nxluel8",
  label: "ItemContainer"
})("flex:0 0 auto;position:relative;width:90px;height:90px;border-radius:26px;margin-right:15px;overflow:hidden;&:after{content:'';position:absolute;display:block;top:0;left:0;width:100%;height:100%;box-sizing:border-box;border-radius:22px;border-radius:26px;border:1px solid ", ({
  theme
}) => hexToRgba(theme.colors.foregroundWeak, 0.33), ";z-index:2;}");
const ItemImage = /*#__PURE__*/_styled(ResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e1nxluel7"
} : {
  target: "e1nxluel7",
  label: "ItemImage"
})(process.env.NODE_ENV === "production" ? {
  name: "1r0zrug",
  styles: "position:absolute;top:0;left:0;width:100%"
} : {
  name: "1r0zrug",
  styles: "position:absolute;top:0;left:0;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemLinkBadge = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel6"
} : {
  target: "e1nxluel6",
  label: "ItemLinkBadge"
})("position:absolute;bottom:0;left:0;width:100%;z-index:1;padding:1px 0 3px;font-size:12px;font-weight:normal;line-height:16px;text-align:center;color:", ({
  theme
}) => theme.colors.foregroundInverse, ";background-color:", ({
  theme
}) => hexToRgba(theme.content.base0, 0.6), ";opacity:0;transition:.1s opacity;");
const ItemContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel5"
} : {
  target: "e1nxluel5",
  label: "ItemContent"
})(process.env.NODE_ENV === "production" ? {
  name: "jipu2q",
  styles: "flex:1 0 0px;position:relative;align-self:center"
} : {
  name: "jipu2q",
  styles: "flex:1 0 0px;position:relative;align-self:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemBold = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel4"
} : {
  target: "e1nxluel4",
  label: "ItemBold"
})(process.env.NODE_ENV === "production" ? {
  name: "y19u28",
  styles: "color:#424242;font-size:11px;font-weight:bold;line-height:21px"
} : {
  name: "y19u28",
  styles: "color:#424242;font-size:11px;font-weight:bold;line-height:21px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemNormal = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel3"
} : {
  target: "e1nxluel3",
  label: "ItemNormal"
})(process.env.NODE_ENV === "production" ? {
  name: "zmkmjv",
  styles: "color:#424242;font-size:13px;font-weight:normal;line-height:19px;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:2;word-wrap:break-word;-webkit-box-orient:vertical;overflow:hidden"
} : {
  name: "zmkmjv",
  styles: "color:#424242;font-size:13px;font-weight:normal;line-height:19px;display:-webkit-box;text-overflow:ellipsis;-webkit-line-clamp:2;word-wrap:break-word;-webkit-box-orient:vertical;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemBadgeContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel2"
} : {
  target: "e1nxluel2",
  label: "ItemBadgeContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1mlefol",
  styles: "margin:12px -2px 0;line-height:0;font-size:0"
} : {
  name: "1mlefol",
  styles: "margin:12px -2px 0;line-height:0;font-size:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});
const ItemBadge = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel1"
} : {
  target: "e1nxluel1",
  label: "ItemBadge"
})("display:inline-block;margin:0 2px;padding:3px 5px;font-weight:bold;font-size:10px;line-height:14px;background-color:", ({
  theme
}) => theme.colors.foregroundWeak, ";color:", ({
  theme
}) => theme.colors.background, ";border-radius:4px;");
const ImageBadge = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1nxluel0"
} : {
  target: "e1nxluel0",
  label: "ImageBadge"
})("position:absolute;z-index:2;top:0;left:0;background:", ({
  theme
}) => theme.colors.foregroundWeak, ";border-top-left-radius:2px;border-bottom-right-radius:2px;color:", ({
  theme
}) => theme.colors.background, ";font-size:10px;font-weight:700;padding:5px;");
const GLOBAL_STYLE$1 = /*#__PURE__*/css(".image-link{display:block;position:absolute;top:0;left:0;right:0;bottom:0;z-index:4;cursor:pointer;", HOVER$1`
      ${ItemLinkBadge} {
        opacity: 1;
      }
    `, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:GLOBAL_STYLE;"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const renderPlaceholder = keyword => {
  return keyword !== '' ? jsxs(Fragment, {
    children: ["\uB9DE\uB294 \uC0C1\uD488\uC744 \uCC3E\uC9C0 \uBABB\uD588\uC5B4\uC694.", ' ', jsx("br", {}), "\uC624\uB298\uC758\uC9D1\uC5D0\uC11C \uAD6C\uB9E4\uD55C \uC0C1\uD488\uC774 \uC544\uB2C8\uB77C\uBA74", ' ', jsx("br", {}), "\uC9C1\uC811 \uB4F1\uB85D\uD560 \uC218 \uC788\uC5B4\uC694."]
  }) : jsxs(Fragment, {
    children: ["\uCD5C\uADFC \uD0DC\uADF8\uD558\uAC70\uB098 \uAD6C\uB9E4\uD55C \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.", jsx("br", {}), "\uC0C1\uD488\uC744 \uAC80\uC0C9\uD574\uBCF4\uC138\uC694."]
  });
};
function ImageTagEditAdmin(props) {
  const {
    className,
    tagContentStyles,
    style,
    imageUrl,
    tags: initialTags,
    onSubmit,
    onClose,
    per,
    initialParams,
    onFetch,
    onGetProduction,
    renderSearchHeader,
    getProductThumbnailLink,
    right,
    onSelectLog,
    onSubmitLog
  } = props;
  const [createContentRef, contentListRef] = useRefList();
  const [state, setState] = useState({
    index: null,
    tags: initialTags
  });
  const snackbar = useSnackbar();
  const handleContentSubmit = useCallback(() => {
    setState(state => {
      if (state.index == null) {
        return state;
      }
      const item = state.tags[state.index];
      if (item != null && !item.description && item.productionId == null) {
        return {
          ...state,
          index: null,
          tags: state.tags.filter((_, i) => i !== state.index)
        };
      }
      return state;
    });
  }, []);
  const handleOverlaySelect = useCallback(index => {
    if (index != null) {
      handleContentSubmit();
      setState(state => ({
        ...state,
        index
      }));
    }
    // index = null means closing, but we don't allow closing for now
  }, [handleContentSubmit]);
  const handleOverlayClose = useCallback(() => {
    handleContentSubmit();
    setState(state => ({
      ...state,
      index: null
    }));
  }, [handleContentSubmit]);
  const handleOverlayClick = useCallback((positionX, positionY) => {
    handleContentSubmit();
    if (state.index != null) {
      setState(state => ({
        ...state,
        index: null
      }));
    } else {
      setState(state => {
        const tags = [...state.tags, {
          positionX,
          positionY,
          description: null,
          brand: null,
          name: null,
          productionId: null,
          onHide: false,
          isLikely: false,
          key: String(Math.random() * 0x7FFFFFFF | 0)
        }];
        return {
          ...state,
          tags,
          index: tags.length - 1
        };
      });
    }
  }, [state, handleContentSubmit]);
  const handleOverlayChange = useCallback((index, tag) => {
    setState(state => ({
      ...state,
      tags: state.tags.map((v, i) => i === index ? tag : v)
    }));
  }, []);
  const handleContentChange = useCallback((index, tag) => {
    setState(state => ({
      ...state,
      tags: state.tags.map((v, i) => i === index ? tag : v)
    }));
  }, []);
  const handleDelete = useCallback(index => {
    setState(state => ({
      index: null,
      tags: state.tags.filter((_, i) => i !== index)
    }));
  }, []);
  const handleProductionSelect = useCallback(production => {
    if (contentListRef.current == null) {
      return;
    }
    if (onSelectLog) {
      onSelectLog();
    }
    if (contentListRef.current.size === 0) {
      snackbar.open({
        content: '사진을 클릭하여 상품 태그를 등록해주세요.'
      });
    }
    for (const ref of contentListRef.current) {
      ref.setProduction(production);
    }
  }, [onSelectLog, contentListRef, snackbar]);
  const handleSubmit = useCallback(() => {
    if (onSubmitLog) {
      onSubmitLog();
    }
    const isFilledTag = tag => {
      return tag.productionId != null || Boolean(tag.description);
    };
    const filteredTags = state.tags.filter(isFilledTag);
    onSubmit(filteredTags);
  }, [state.tags, onSubmit, onSubmitLog]);
  return jsxs(Fragment, {
    children: [jsx(Global, {
      styles: GLOBAL_STYLE
    }), jsxs(AdminContainer, {
      className: classNames(className, 'container'),
      style: {
        height: '100%',
        minHeight: '645px',
        ...style
      },
      children: [jsxs(AdminImageSection, {
        children: [jsxs(AdminHeader, {
          children: [jsx(AdminTitle, {
            children: "\uD0DC\uADF8\uB4F1\uB85D \uBC0F \uAD00\uB9AC"
          }), jsx(AdminHeaderRight, {
            children: right
          })]
        }), jsx(AdminImageContainer, {
          src: imageUrl,
          fit: "contain",
          children: ({
            bounds
          }) => jsx(AdminTagContainer, {
            tagContentStyles: tagContentStyles,
            style: {
              left: `${bounds[0] * 100}%`,
              top: `${bounds[1] * 100}%`,
              width: `${bounds[2] * 100}%`,
              height: `${bounds[3] * 100}%`
            },
            tags: state.tags,
            activeIndex: state.index,
            onSelect: handleOverlaySelect,
            onClick: handleOverlayClick,
            onChange: handleOverlayChange,
            renderContent: ({
              tag,
              index
            }) => jsx(ImageTagEditAdminTagContent, {
              tag: tag,
              index: index,
              getProductThumbnailLink: getProductThumbnailLink,
              onGetProduction: onGetProduction,
              onChange: tag => handleContentChange(index, tag),
              onDelete: handleDelete,
              onClose: handleOverlayClose,
              ref: createContentRef()
            })
          })
        })]
      }), jsxs(AdminRightSection, {
        children: [jsx(AdminSelectSection, {
          headerClassName: "select-section__header",
          header: renderSearchHeader,
          per: per,
          initialParams: initialParams,
          onFetch: onFetch,
          onSelect: handleProductionSelect,
          placeholder: params => renderPlaceholder(params.keyword),
          inputPlaceholder: "\uC0C1\uD488\uBA85/\uBE0C\uB79C\uB4DC/\uC0C1\uD488\uBC88\uD638",
          renderItem: props => jsx(ImageTagEditAdminProductionItem, {
            ...props,
            getProductThumbnailLink: getProductThumbnailLink
          })
        }), jsxs(AdminButtonSection, {
          children: [jsx(AdminButton, {
            type: "button",
            shape: "outlined",
            variant: "neutral-600",
            size: 44,
            onClick: onClose,
            children: "\uCDE8\uC18C"
          }), jsx(AdminButton, {
            type: "button",
            shape: "filled",
            variant: "primary",
            size: 44,
            onClick: handleSubmit,
            children: "\uC800\uC7A5"
          })]
        })]
      })]
    })]
  });
}
const AdminContainer = /*#__PURE__*/_styled("section", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp10"
} : {
  target: "e3oecjp10",
  label: "AdminContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminImageSection = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp9"
} : {
  target: "e3oecjp9",
  label: "AdminImageSection"
})(process.env.NODE_ENV === "production" ? {
  name: "86zfll",
  styles: "flex:1 0 0%;padding:30px 30px 40px;border-right:1px solid #dadce0"
} : {
  name: "86zfll",
  styles: "flex:1 0 0%;padding:30px 30px 40px;border-right:1px solid #dadce0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminHeader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp8"
} : {
  target: "e3oecjp8",
  label: "AdminHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "bcffy2",
  styles: "display:flex;align-items:center;justify-content:space-between"
} : {
  name: "bcffy2",
  styles: "display:flex;align-items:center;justify-content:space-between",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminTitle = /*#__PURE__*/_styled("h2", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp7"
} : {
  target: "e3oecjp7",
  label: "AdminTitle"
})(process.env.NODE_ENV === "production" ? {
  name: "8z71e0",
  styles: "flex:0 0 auto;margin:0;padding:0;color:#292929;font-size:20px;font-weight:bold;line-height:30px"
} : {
  name: "8z71e0",
  styles: "flex:0 0 auto;margin:0;padding:0;color:#292929;font-size:20px;font-weight:bold;line-height:30px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminHeaderRight = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp6"
} : {
  target: "e3oecjp6",
  label: "AdminHeaderRight"
})(process.env.NODE_ENV === "production" ? {
  name: "ou8xsw",
  styles: "flex:0 0 auto"
} : {
  name: "ou8xsw",
  styles: "flex:0 0 auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminImageContainer = /*#__PURE__*/_styled(CoverResizeImage, process.env.NODE_ENV === "production" ? {
  target: "e3oecjp5"
} : {
  target: "e3oecjp5",
  label: "AdminImageContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1njvjuz",
  styles: "margin:20px 0 0;width:100%;padding-bottom:100%"
} : {
  name: "1njvjuz",
  styles: "margin:20px 0 0;width:100%;padding-bottom:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminTagContainer = /*#__PURE__*/_styled(ImageTagDraggableOverlay, process.env.NODE_ENV === "production" ? {
  target: "e3oecjp4"
} : {
  target: "e3oecjp4",
  label: "AdminTagContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "ttn724",
  styles: "&&{position:absolute;}"
} : {
  name: "ttn724",
  styles: "&&{position:absolute;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminRightSection = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp3"
} : {
  target: "e3oecjp3",
  label: "AdminRightSection"
})(process.env.NODE_ENV === "production" ? {
  name: "1njp3oz",
  styles: "flex:0 0 auto;display:flex;flex-direction:column;width:40%"
} : {
  name: "1njp3oz",
  styles: "flex:0 0 auto;display:flex;flex-direction:column;width:40%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminSelectSection = /*#__PURE__*/_styled(ProductionSelectPanel, process.env.NODE_ENV === "production" ? {
  target: "e3oecjp2"
} : {
  target: "e3oecjp2",
  label: "AdminSelectSection"
})(process.env.NODE_ENV === "production" ? {
  name: "mgdz4",
  styles: "flex:1 0 0px;min-height:0px"
} : {
  name: "mgdz4",
  styles: "flex:1 0 0px;min-height:0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminButtonSection = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e3oecjp1"
} : {
  target: "e3oecjp1",
  label: "AdminButtonSection"
})(process.env.NODE_ENV === "production" ? {
  name: "i5y1d8",
  styles: "flex:0 0 auto;padding:15px 0;border-top:1px solid #dadce0;text-align:center;line-height:0"
} : {
  name: "i5y1d8",
  styles: "flex:0 0 auto;padding:15px 0;border-top:1px solid #dadce0;text-align:center;line-height:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const AdminButton = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e3oecjp0"
} : {
  target: "e3oecjp0",
  label: "AdminButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1wx2qam",
  styles: "&&{margin:0 5px;width:40%;max-width:160px;}"
} : {
  name: "1wx2qam",
  styles: "&&{margin:0 5px;width:40%;max-width:160px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});
const GLOBAL_STYLE = process.env.NODE_ENV === "production" ? {
  name: "qo9xk9",
  styles: ".select-section__header{padding:30px 30px 20px;}"
} : {
  name: "1iz99dp-GLOBAL_STYLE",
  styles: ".select-section__header{padding:30px 30px 20px;};label:GLOBAL_STYLE;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageTagEditAdminSearchHeader(props) {
  const {
    tab,
    params,
    onChange
  } = props;
  return jsxs(HeaderHeader, {
    children: [jsx(HeaderTop, {
      children: jsx(CheckboxWithText, {
        checked: params.excludeUnselling,
        onCheck: v => onChange({
          ...params,
          excludeUnselling: v
        }),
        children: "\uD310\uB9E4\uC0C1\uD488\uB9CC \uBCF4\uAE30"
      })
    }), jsx(HeaderBottom, {
      children: jsx(Tab, {
        children: tab?.options.map(option => jsx(TabItem, {
          isActive: option.value === tab.selected,
          onClick: () => onChange({
            ...params,
            [tab.id]: option.value
          }),
          children: option.label
        }, option.value))
      })
    })]
  });
}
const HeaderHeader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "er4h7x02"
} : {
  target: "er4h7x02",
  label: "HeaderHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "md8090",
  styles: "color:#424242"
} : {
  name: "md8090",
  styles: "color:#424242",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
});
const HeaderTop = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "er4h7x01"
} : {
  target: "er4h7x01",
  label: "HeaderTop"
})(process.env.NODE_ENV === "production" ? {
  name: "ocq262",
  styles: "width:fit-content;margin-bottom:10px"
} : {
  name: "ocq262",
  styles: "width:fit-content;margin-bottom:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
});
const HeaderBottom = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "er4h7x00"
} : {
  target: "er4h7x00",
  label: "HeaderBottom"
})();

function ImageTagEditAdminModal(props) {
  const {
    isOpen,
    onClose,
    ...remainingProps
  } = props;
  return isOpen ? jsx(Modal, {
    width: 1200,
    stretch: true,
    children: jsx(ImageTagEditAdmin, {
      tagContentStyles: {
        zIndex: ZINDEX$1.modal + 1
      },
      onClose: onClose,
      ...remainingProps
    })
  }) : null;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const renderNoResultMessage = keyword => {
  if (keyword !== '') {
    return jsxs(Fragment, {
      children: ["\uB9DE\uB294 \uC0C1\uD488\uC744 \uCC3E\uC9C0 \uBABB\uD588\uC5B4\uC694.", jsx("br", {}), "\uC624\uB298\uC758\uC9D1\uC5D0\uC11C \uAD6C\uB9E4\uD55C \uC0C1\uD488\uC774 \uC544\uB2C8\uB77C\uBA74", jsx("br", {}), "\uC9C1\uC811 \uB4F1\uB85D\uD560 \uC218 \uC788\uC5B4\uC694."]
    });
  }
  return jsxs(Fragment, {
    children: ["\uCD5C\uADFC \uAD6C\uB9E4\uD55C \uC0C1\uD488\uC774 \uC5C6\uC5B4\uC694.", jsx("br", {}), "\uAD6C\uB9E4\uD55C \uC0C1\uD488\uC774 \uC788\uB2E4\uBA74 \uC5EC\uAE30\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4."]
  });
};
const renderHeader = (props, onCustomOpen) => {
  return jsxs(PanelHeader, {
    children: [jsx(PanelCustomButton, {
      size: 14,
      type: "button",
      onClick: onCustomOpen,
      variant: "primary",
      children: "+ \uC0C1\uD488 \uC9C1\uC811 \uB4F1\uB85D"
    }), props.tab && jsx(ImageTagEditAdminSearchHeader, {
      ...props
    })]
  });
};
function ImageTagEditSelectPanel(props) {
  const {
    className,
    per,
    onFetch,
    onCustomOpen,
    onClose,
    onSelect
  } = props;
  const panelRef = useRef(null);
  useEffect(() => {
    const timerId = setTimeout(() => {
      const panel = panelRef.current;
      if (panel != null) {
        panel.focusInput();
      }
    }, 200);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  return jsx(ProductionSelectPanel, {
    className: className,
    panelRef: panelRef,
    per: per,
    onFetch: onFetch,
    onSelect: onSelect,
    initialParams: {
      keyword: '',
      excludeUnselling: false
    },
    placeholder: params => renderNoResultMessage(params.keyword),
    header: props => renderHeader(props, onCustomOpen),
    searchRight: jsx(PanelCancel, {
      type: "button",
      onClick: onClose,
      variant: "neutral-600",
      size: 14,
      children: "\uCDE8\uC18C"
    })
  });
}
const PanelHeader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ej0htig2"
} : {
  target: "ej0htig2",
  label: "PanelHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1azakc",
  styles: "text-align:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});
const PanelCustomButton = /*#__PURE__*/_styled(TextButton$1, process.env.NODE_ENV === "production" ? {
  target: "ej0htig1"
} : {
  target: "ej0htig1",
  label: "PanelCustomButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : {
  name: "1j389vi",
  styles: "font-weight:700",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});
const PanelCancel = /*#__PURE__*/_styled(TextButton$1, process.env.NODE_ENV === "production" ? {
  target: "ej0htig0"
} : {
  target: "ej0htig0",
  label: "PanelCancel"
})(process.env.NODE_ENV === "production" ? {
  name: "z42i28",
  styles: "flex:0 0 auto;margin:0 0 0 10px;padding:3px 5px"
} : {
  name: "z42i28",
  styles: "flex:0 0 auto;margin:0 0 0 10px;padding:3px 5px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const removeLineBreak = target => {
  return target.replace(/\n/g, '');
};
function ImageTagEditSelectCustomPanel(props) {
  const {
    className,
    onClose,
    onSubmit
  } = props;
  const [value, setValue] = useState('');
  const handleSubmit = useCallback(() => {
    onSubmit(value);
  }, [value, onSubmit]);
  const inputRef = useRef(null);
  useEffect(() => {
    const timerId = setTimeout(() => {
      if (inputRef.current != null) {
        inputRef.current.focus();
      }
    }, 200);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  const handleChange = value => {
    setValue(removeLineBreak(value));
  };
  return jsxs(PanelPanel, {
    className: className,
    children: [jsx(PanelContent, {
      children: jsx(PanelInput, {
        value: value,
        onChange: e => handleChange(e.target.value),
        placeholder: '상품명/브랜드/판매처 등을 알려주세요.\n(최대 100자)',
        maxLength: 100,
        maxCount: 100,
        hint: "",
        ref: inputRef
      })
    }), jsxs(PanelFooter, {
      children: [jsx(PanelButton, {
        size: 32,
        type: "button",
        onClick: onClose,
        variant: "primary",
        shape: "outlined",
        children: "\uCDE8\uC18C"
      }), jsx(PanelButton, {
        size: 32,
        type: "button",
        onClick: handleSubmit,
        disabled: value == null || value.trim() === '',
        variant: "primary",
        shape: "filled",
        children: "\uD655\uC778"
      })]
    })]
  });
}
const PanelPanel = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebm9auu4"
} : {
  target: "ebm9auu4",
  label: "PanelPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "rboi74",
  styles: "padding:20px 20px 25px"
} : {
  name: "rboi74",
  styles: "padding:20px 20px 25px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
const PanelContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebm9auu3"
} : {
  target: "ebm9auu3",
  label: "PanelContent"
})();
const PanelInput = /*#__PURE__*/_styled(TextareaWithCountHint, process.env.NODE_ENV === "production" ? {
  target: "ebm9auu2"
} : {
  target: "ebm9auu2",
  label: "PanelInput"
})(process.env.NODE_ENV === "production" ? {
  name: "1g7pal5",
  styles: "height:130px;resize:none"
} : {
  name: "1g7pal5",
  styles: "height:130px;resize:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
const PanelFooter = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebm9auu1"
} : {
  target: "ebm9auu1",
  label: "PanelFooter"
})(process.env.NODE_ENV === "production" ? {
  name: "1hdfqf9",
  styles: "margin:20px 0 0;text-align:center;line-height:0"
} : {
  name: "1hdfqf9",
  styles: "margin:20px 0 0;text-align:center;line-height:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
const PanelButton = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "ebm9auu0"
} : {
  target: "ebm9auu0",
  label: "PanelButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1o2o41v",
  styles: "&&{width:86px;margin:0 2px;box-sizing:border-box;}"
} : {
  name: "1o2o41v",
  styles: "&&{width:86px;margin:0 2px;box-sizing:border-box;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageTagEditSelectModal(props) {
  const {
    className,
    isOpen,
    onClose,
    per,
    onFetch,
    onSelect,
    onCustomSelect
  } = props;
  const [isCustomOpen, setCustomOpen] = useState(false);
  const handleCustomOpen = useCallback(() => {
    setCustomOpen(true);
  }, []);
  const handleCustomClose = useCallback(() => {
    setCustomOpen(false);
  }, []);
  if (!isOpen && isCustomOpen) {
    setCustomOpen(false);
  }
  if (!isOpen) {
    return null;
  }
  return jsxs(Modal, {
    "data-testid": "image-tag-edit-select-modal",
    className: className,
    stretch: true,
    height: "100%",
    width: 1200,
    hasGrabber: true,
    children: [jsx(ModalPanel, {
      onCustomOpen: handleCustomOpen,
      per: per,
      onFetch: onFetch,
      onSelect: onSelect,
      onClose: onClose
    }), jsx(CSSTransition$1, {
      timeout: 250,
      mountOnEnter: true,
      unmountOnExit: true,
      in: isCustomOpen,
      appear: isCustomOpen,
      classNames: {
        enterActive: 'open',
        enterDone: 'open',
        appearActive: 'open',
        appearDone: 'open',
        exit: ''
      },
      children: jsxs(ModalCustomContainer, {
        children: [jsx(ModalCustomBackdrop, {
          onClick: handleCustomClose
        }), jsx(ModalCustom, {
          onClose: handleCustomClose,
          onSubmit: onCustomSelect
        })]
      })
    })]
  });
}
const ModalPanel = /*#__PURE__*/_styled(ImageTagEditSelectPanel, process.env.NODE_ENV === "production" ? {
  target: "e17el6nk3"
} : {
  target: "e17el6nk3",
  label: "ModalPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "1dbzt1c",
  styles: "flex:1 1 auto;min-height:0px"
} : {
  name: "1dbzt1c",
  styles: "flex:1 1 auto;min-height:0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
const ModalCustomContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e17el6nk2"
} : {
  target: "e17el6nk2",
  label: "ModalCustomContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "11y7exz",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;justify-content:center;align-items:center"
} : {
  name: "11y7exz",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;justify-content:center;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
const ModalCustomBackdrop = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e17el6nk1"
} : {
  target: "e17el6nk1",
  label: "ModalCustomBackdrop"
})(process.env.NODE_ENV === "production" ? {
  name: "davjnf",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;background-color:transparent;transition:.2s background-color;.open &{background-color:rgba(0, 0, 0, 0.6);}"
} : {
  name: "davjnf",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;background-color:transparent;transition:.2s background-color;.open &{background-color:rgba(0, 0, 0, 0.6);}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
const ModalCustom = /*#__PURE__*/_styled(ImageTagEditSelectCustomPanel, process.env.NODE_ENV === "production" ? {
  target: "e17el6nk0"
} : {
  target: "e17el6nk0",
  label: "ModalCustom"
})("position:relative;flex:0 0 auto;width:100%;box-sizing:border-box;max-width:345px;margin:0 15px;background-color:", ({
  theme
}) => theme.colors.background, ";border-radius:8px;box-shadow:0 4px 10px 0 ", hexToRgba('#3f474d', 0.2), ";opacity:0;transform:translateY(-20px);transition:.25s opacity,.25s transform;.open &{opacity:1;transform:none;}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageTagEditTagContent(props) {
  // TODO: 추후 productions 페이지 host가 바뀌면 수정 필요
  const {
    tag,
    onDelete,
    host = 'https://ohou.se'
  } = props;
  if (tag.production != null) {
    return jsxs(ProductItem, {
      type: "white",
      children: [jsx(ItemLink, {
        href: `${host}/productions/${tag.productionId}/selling`,
        target: "_blank",
        onClick: e => e.stopPropagation(),
        rel: "noreferrer",
        children: jsx(ItemProductionContent, {
          tag: tag
        })
      }), jsx(ContentProductionDelete, {
        type: "button",
        title: "\uC0AD\uC81C",
        onClick: onDelete,
        children: "\uC0AD\uC81C"
      })]
    });
  }
  return jsx(MemoItem, {
    type: "white",
    children: jsx(ItemMemoContent, {
      description: tag.description ?? '',
      right: jsx(ContentMemoDelete, {
        type: "button",
        title: "\uC0AD\uC81C",
        onClick: onDelete,
        children: "\uC0AD\uC81C"
      })
    })
  });
}
const ProductItem = /*#__PURE__*/_styled(DropdownContent, process.env.NODE_ENV === "production" ? {
  target: "e3is7us6"
} : {
  target: "e3is7us6",
  label: "ProductItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1pdpjmn",
  styles: "display:flex;align-items:center;width:280px;border-radius:8px;background-color:#F7F9FA"
} : {
  name: "1pdpjmn",
  styles: "display:flex;align-items:center;width:280px;border-radius:8px;background-color:#F7F9FA",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
const MemoItem = /*#__PURE__*/_styled(DropdownContent, process.env.NODE_ENV === "production" ? {
  target: "e3is7us5"
} : {
  target: "e3is7us5",
  label: "MemoItem"
})(process.env.NODE_ENV === "production" ? {
  name: "okb6xc",
  styles: "border-radius:8px;background-color:#F7F9FA"
} : {
  name: "okb6xc",
  styles: "border-radius:8px;background-color:#F7F9FA",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
const ItemLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e3is7us4"
} : {
  target: "e3is7us4",
  label: "ItemLink"
})(process.env.NODE_ENV === "production" ? {
  name: "mt8cnj",
  styles: "flex:1 0 0px;display:block;min-width:0"
} : {
  name: "mt8cnj",
  styles: "flex:1 0 0px;display:block;min-width:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
const ItemProductionContent = /*#__PURE__*/_styled(TagProductionContent, process.env.NODE_ENV === "production" ? {
  target: "e3is7us3"
} : {
  target: "e3is7us3",
  label: "ItemProductionContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
const ItemMemoContent = /*#__PURE__*/_styled(TagMemoContent, process.env.NODE_ENV === "production" ? {
  target: "e3is7us2"
} : {
  target: "e3is7us2",
  label: "ItemMemoContent"
})(process.env.NODE_ENV === "production" ? {
  name: "xwr4ir",
  styles: "color:#2F3438"
} : {
  name: "xwr4ir",
  styles: "color:#2F3438",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
const ContentMemoDelete = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e3is7us1"
} : {
  target: "e3is7us1",
  label: "ContentMemoDelete"
})("display:inline-block;margin:0;background:none;border:none;transition:.1s color;font-size:14px;line-height:18px;letter-spacing:-0.3px;font-weight:500;color:", ({
  theme
}) => theme.colors.foregroundDisabled, ";cursor:pointer;", HOVER$1`
    color: #9e9e9e;
  `, " ", FOCUS`
    border-radius: 4px;
    box-shadow: 0 0 0 3px #a3e4f8;
  `, ";");
const ContentProductionDelete = /*#__PURE__*/_styled(ContentMemoDelete, process.env.NODE_ENV === "production" ? {
  target: "e3is7us0"
} : {
  target: "e3is7us0",
  label: "ContentProductionDelete"
})(process.env.NODE_ENV === "production" ? {
  name: "1cul0w",
  styles: "padding:2px 12px 2px 2px"
} : {
  name: "1cul0w",
  styles: "padding:2px 12px 2px 2px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageTagEditSelectDropDownContent(props) {
  const {
    className,
    per,
    onFetch,
    onSelect,
    onCustomSelect,
    onCustomOpen,
    onCustomClose,
    onClose
  } = props;
  const [isCustomOpen, setCustomOpen] = useState(false);
  const handleCustomOpen = useCallback(() => {
    onCustomOpen();
    setCustomOpen(true);
  }, [onCustomOpen]);
  const handleCustomClose = useCallback(() => {
    setCustomOpen(false);
    onCustomClose();
  }, [onCustomClose]);
  return jsxs(ContentDropdown, {
    className: className,
    children: [jsx(ContentPanel, {
      onCustomOpen: handleCustomOpen,
      per: per,
      onFetch: onFetch,
      onSelect: onSelect,
      onClose: onClose
    }), jsx(CSSTransition$1, {
      timeout: 250,
      mountOnEnter: true,
      unmountOnExit: true,
      in: isCustomOpen,
      appear: isCustomOpen,
      classNames: {
        enterActive: 'dropdown-content-custom-open',
        enterDone: 'dropdown-content-custom-open',
        appearActive: 'dropdown-content-custom-open',
        appearDone: 'dropdown-content-custom-open',
        exit: ''
      },
      children: jsxs(ContentCustomContainer, {
        children: [jsx(ContentCustomBackdrop, {
          onClick: handleCustomClose
        }), jsx(ContentCustom, {
          onClose: handleCustomClose,
          onSubmit: onCustomSelect
        })]
      })
    })]
  });
}
const BACKDROP_COLOR = 'rgba(0, 0, 0, 0.6)';
const ContentDropdown = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ej6zvd14"
} : {
  target: "ej6zvd14",
  label: "ContentDropdown"
})("width:375px;height:450px;background:", ({
  theme
}) => theme.colors.background, ";border:1px solid #dbdbdb;border-radius:6px;box-shadow:0 4px 10px 0 rgba(63, 71, 77, .2);");
const ContentPanel = /*#__PURE__*/_styled(ImageTagEditSelectPanel, process.env.NODE_ENV === "production" ? {
  target: "ej6zvd13"
} : {
  target: "ej6zvd13",
  label: "ContentPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "1nm199j",
  styles: "height:100%;flex:1 0 0px;min-height:0px"
} : {
  name: "1nm199j",
  styles: "height:100%;flex:1 0 0px;min-height:0px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
const ContentCustomContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ej6zvd12"
} : {
  target: "ej6zvd12",
  label: "ContentCustomContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "16bx91i",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;justify-content:center"
} : {
  name: "16bx91i",
  styles: "position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;justify-content:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
const ContentCustomBackdrop = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ej6zvd11"
} : {
  target: "ej6zvd11",
  label: "ContentCustomBackdrop"
})("position:absolute;top:0px;left:0px;right:0px;bottom:0px;background-color:transparent;transition:background-color .25s ease-in-out;border-radius:6px;.dropdown-content-custom-open &{background-color:", BACKDROP_COLOR, ";}");
const ContentCustom = /*#__PURE__*/_styled(ImageTagEditSelectCustomPanel, process.env.NODE_ENV === "production" ? {
  target: "ej6zvd10"
} : {
  target: "ej6zvd10",
  label: "ContentCustom"
})("position:relative;flex:0 0 auto;margin:0 15px;background-color:", ({
  theme
}) => theme.colors.background, ";border-radius:8px;box-shadow:0 4px 10px 0 ", hexToRgba('#3f474d', 0.2), ";opacity:0;transform:translateY(-20px);transition:.25s opacity,.25s transform;.dropdown-content-custom-open &{opacity:1;transform:none;}");

const TAG_EDIT_ITEM_DEFAULT_RENDER_CONTENT = props => jsx(ImageTagEditTagContent, {
  ...props
});
function ImageTagEdit(props) {
  const {
    className,
    style,
    tagContentStyles,
    tags,
    onChange,
    per,
    onFetch,
    disableInteraction,
    children,
    divProps,
    buttonProps,
    renderTagContent = TAG_EDIT_ITEM_DEFAULT_RENDER_CONTENT,
    onClickLog,
    onImpressionLog
  } = props;
  const [activeHandle, setActiveHandle] = useState(null);
  // ImageTagEditSelectDropDownContent에서 상품 직접 등록 클릭 후 직접 입력칸이 보이는지 여부
  const [isDropdownCustomOpen, setIsDropdownCustomOpen] = useState(false);
  const handleOverlaySelect = useCallback(index => {
    if (onClickLog) {
      onClickLog('select');
    }
    if (index != null) {
      setActiveHandle({
        type: 'tag',
        index
      });
    } else {
      setActiveHandle(null);
    }
  }, [onClickLog]);
  const handleOverlayClick = useCallback((positionX, positionY) => {
    if (onImpressionLog) {
      onImpressionLog();
    }
    if (activeHandle != null) {
      setActiveHandle(null);
      setIsDropdownCustomOpen(false);
    } else {
      setActiveHandle({
        type: 'new',
        // 뷰포트와 포인트 특성(터치 기반 입력장치인지)에 따라서 displayType이 결정됨
        // 모바일은 모달, PC는 드롭다운
        displayType: window.matchMedia('(max-width: 767px)').matches || window.matchMedia('(pointer: coarse)').matches ? 'modal' : 'dropdown',
        tag: {
          positionX,
          positionY,
          description: null,
          brand: null,
          name: null,
          productionId: null,
          onHide: false,
          isLikely: false,
          production: null,
          key: String(Math.random() * 0x7FFFFFFF | 0)
        }
      });
    }
  }, [activeHandle, onImpressionLog]);
  const handleOverlayChange = useCallback((index, tag) => {
    onChange(tags.map((v, i) => i === index ? tag : v));
  }, [tags, onChange]);
  const handleNewClose = useCallback(() => {
    if (onClickLog) {
      onClickLog('cancel');
    }
    setActiveHandle(null);
  }, [onClickLog]);
  const handleNewSelect = useCallback(production => {
    if (activeHandle == null || activeHandle.type !== 'new') {
      return;
    }
    if (onClickLog) {
      onClickLog('select');
    }
    const tag = {
      ...activeHandle.tag,
      brand: production.brand.name,
      name: production.name,
      productionId: production.id,
      production: {
        id: production.id,
        name: production.name,
        brand: production.brand,
        originalImageUrl: production.originalImageUrl,
        sellingPrice: production.sellingPrice
      }
    };
    onChange([...tags, tag]);
    setActiveHandle(null);
  }, [activeHandle, onChange, tags, onClickLog]);
  const handleNewCustomSelect = useCallback(description => {
    if (activeHandle == null || activeHandle.type !== 'new') {
      return;
    }
    const tag = {
      ...activeHandle.tag,
      description,
      brand: null,
      name: null,
      productionId: null,
      production: null
    };
    onChange([...tags, tag]);
    setActiveHandle(null);
  }, [activeHandle, onChange, tags]);
  const handleDelete = useCallback(index => {
    setActiveHandle(null);
    onChange(tags.filter((_, i) => i !== index));
  }, [onChange, tags]);
  return jsx(ImageTagDraggableOverlay, {
    className: className,
    style: style,
    tags: tags,
    activeIndex: activeHandle != null && activeHandle.type === 'tag' ? activeHandle.index : null,
    onSelect: handleOverlaySelect,
    onClick: handleOverlayClick,
    onChange: handleOverlayChange,
    renderContent: props => renderTagContent({
      ...props,
      onDelete: () => handleDelete(props.index)
    }),
    divProps: divProps,
    buttonProps: buttonProps,
    disableInteraction: disableInteraction,
    children: ({
      getPos
    }) => jsxs(Fragment, {
      children: [children, activeHandle != null && activeHandle.type === 'new' && jsx(ImageTagDraggableOverlayItem, {
        tagContentStyles: tagContentStyles,
        index: 0,
        tag: activeHandle.tag,
        onChange: (_, tag) => setActiveHandle(prev => {
          if (prev == null || prev.type !== 'new') {
            return prev;
          }
          return {
            ...prev,
            tag
          };
        }),
        getPos: getPos,
        isOpen: activeHandle.displayType === 'dropdown',
        useHover: false,
        arrow: {
          // ImageTagEditSelectDropdownContent의 CustomBackDrop 컴포넌트 배경색과 동일하게 맞춥니다.
          backLayerColor: theme => isDropdownCustomOpen ? theme.colors.background : undefined,
          color: theme => isDropdownCustomOpen ? BACKDROP_COLOR : theme.colors.background,
          generateBorderStyle: borderSide => `transition: .25s ${borderSide}-color ease-in-out`
        },
        renderContent: () => jsx(ImageTagEditSelectDropDownContent, {
          onSelect: handleNewSelect,
          onCustomOpen: () => setIsDropdownCustomOpen(true),
          onCustomSelect: handleNewCustomSelect,
          onCustomClose: () => setIsDropdownCustomOpen(false),
          onClose: handleNewClose,
          per: per,
          onFetch: onFetch
        }),
        disableInteraction: disableInteraction
      }), jsx(ImageTagEditSelectModal, {
        isOpen: activeHandle != null && activeHandle.type === 'new' && activeHandle.displayType === 'modal',
        onClose: handleNewClose,
        per: per,
        onFetch: onFetch,
        onSelect: handleNewSelect,
        onCustomSelect: handleNewCustomSelect
      })]
    })
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const MAX_DESCRIPTION_LENGTH = 20;
const formatDescription = description => {
  if (description.length > MAX_DESCRIPTION_LENGTH) {
    return `${description.substring(0, MAX_DESCRIPTION_LENGTH)}...`;
  }
  return description;
};
const DetailWriterCardProfile = ({
  nickname,
  profileImage,
  description,
  isPro,
  link
}) => {
  const hasLink = !!link;
  const WrapperComponent = hasLink ? WriterLink : WriterDiv;
  return jsxs(WrapperComponent, {
    ...(hasLink ? {
      as: link.component,
      href: link.href,
      onClick: () => {
        link.onClick?.();
      }
    } : {}),
    children: [jsx(StyledAvatar, {
      size: 40,
      src: profileImage
      // DetailWriterCardProfile 컴포넌트는 profileImage가 필수값이지만,
      // Avatar 컴포넌트의 placeholderIcon이 필수값이라 임의의 아이콘을 넣어줌
      ,
      placeholderIcon: PhotoIcon
    }), jsxs(Box, {
      as: "span",
      ml: 8,
      children: [jsxs(Nickname, {
        children: [nickname, isPro && jsx(ProBadge, {
          size: 16,
          variant: "dim_dark",
          children: "PRO"
        })]
      }), description && jsx(Description, {
        children: formatDescription(description)
      })]
    })]
  });
};
const cssWrapper = process.env.NODE_ENV === "production" ? {
  name: "1niy2qu",
  styles: "display:flex;align-items:center;padding:0;border:0;text-align:left;background:none"
} : {
  name: "ecy1tr-cssWrapper",
  styles: "display:flex;align-items:center;padding:0;border:0;text-align:left;background:none;label:cssWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
const WriterLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1x9p2a65"
} : {
  target: "e1x9p2a65",
  label: "WriterLink"
})(cssWrapper, ";");
const WriterDiv = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x9p2a64"
} : {
  target: "e1x9p2a64",
  label: "WriterDiv"
})(cssWrapper, ";");
const StyledAvatar = /*#__PURE__*/_styled(Avatar$1, process.env.NODE_ENV === "production" ? {
  target: "e1x9p2a63"
} : {
  target: "e1x9p2a63",
  label: "StyledAvatar"
})(process.env.NODE_ENV === "production" ? {
  name: "c38jfa",
  styles: "flex-shrink:0;margin:0;border:0.5px solid rgba(0, 0, 0, 0.08)"
} : {
  name: "c38jfa",
  styles: "flex-shrink:0;margin:0;border:0.5px solid rgba(0, 0, 0, 0.08)",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});
const Nickname = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1x9p2a62"
} : {
  target: "e1x9p2a62",
  label: "Nickname"
})(({
  theme
}) => /*#__PURE__*/css("display:flex;align-items:center;", FONT_STYLE.detail13L18, ";font-weight:700;color:", theme.content.base1, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Nickname;")));
const ProBadge = /*#__PURE__*/_styled(SquareBadge$1, process.env.NODE_ENV === "production" ? {
  target: "e1x9p2a61"
} : {
  target: "e1x9p2a61",
  label: "ProBadge"
})(process.env.NODE_ENV === "production" ? {
  name: "158icaa",
  styles: "margin-left:4px"
} : {
  name: "158icaa",
  styles: "margin-left:4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});
var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "s079uh",
  styles: "margin-top:2px"
} : {
  name: "5vanw9-Description",
  styles: "margin-top:2px;label:Description;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};
const Description = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1x9p2a60"
} : {
  target: "e1x9p2a60",
  label: "Description"
})(({
  theme
}) => /*#__PURE__*/css("display:block;", FONT_STYLE.detail13L18, ";color:", theme.content.base2, ";font-weight:500;letter-spacing:-0.3px;", MEDIA_QUERY.min('tablet', _ref$2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Description;")));

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const DetailWriterCardFollowButton = ({
  isFollowing,
  onFollow,
  onUnfollow,
  buttonType
}) => {
  const isTablet = useMedia(`(min-width: ${BREAK_POINT.tablet}px)`);
  if (buttonType === 'text') {
    return jsx(StyledTextButton, {
      size: 14,
      variant: isFollowing ? 'neutral-600' : 'primary',
      onClick: isFollowing ? onUnfollow : onFollow,
      children: isFollowing ? '팔로잉' : '팔로우'
    });
  }
  return jsx(StyledBoxButton, {
    variant: isFollowing ? 'neutral-600' : 'primary',
    size: isTablet ? 40 : 32,
    shape: isFollowing ? 'outlined' : 'filled',
    onClick: isFollowing ? onUnfollow : onFollow,
    children: isFollowing ? '팔로잉' : '팔로우'
  });
};
const StyledTextButton = /*#__PURE__*/_styled(TextButton$1, process.env.NODE_ENV === "production" ? {
  target: "e1dqhxjj1"
} : {
  target: "e1dqhxjj1",
  label: "StyledTextButton"
})(process.env.NODE_ENV === "production" ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : {
  name: "16ceglb",
  styles: "font-weight:600",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});
const StyledBoxButton = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e1dqhxjj0"
} : {
  target: "e1dqhxjj0",
  label: "StyledBoxButton"
})(process.env.NODE_ENV === "production" ? {
  name: "kcn2ll",
  styles: "font-weight:700;width:80px"
} : {
  name: "kcn2ll",
  styles: "font-weight:700;width:80px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});

const DetailWriterCard = ({
  className,
  profile,
  follow
}) => {
  return jsxs(Flex, {
    className: className,
    direction: "row",
    align: "center",
    justify: "space-between",
    children: [jsx(DetailWriterCardProfile, {
      ...profile
    }), follow && jsx(DetailWriterCardFollowButton, {
      ...follow
    })]
  });
};

const KeywordFilter = ({
  as,
  href,
  active,
  logData,
  keyword
}) => {
  const Component = as ?? 'a';
  const logFilterClick = () => {
    bucketClickLog({
      section_id: 'REC_KEYWORD',
      type: 'KEYWORD',
      id: keyword,
      index: logData?.index
    });
  };
  return jsx(Component, {
    href: href,
    onClick: () => logFilterClick(),
    children: jsx(StyledChip, {
      text: keyword,
      variant: active ? 'base1' : 'white'
    })
  });
};
const StyledChip = /*#__PURE__*/_styled(Chip, process.env.NODE_ENV === "production" ? {
  target: "e14vtpyl0"
} : {
  target: "e14vtpyl0",
  label: "StyledChip"
})(MEDIA_QUERY.max('mobile', `
    border-radius: 50px;
    height: 38px;
    padding: 10px 14px;
  `), ";");

const KeywordFilters = ({
  children
}) => {
  const carouselControlRef = useRef(null);
  const {
    matches: isCoarsePointer
  } = useMatchMedia('(pointer: coarse)');
  const activeItemIndex = Children.toArray(children).filter(isValidElement).findIndex(child => child.props.active);
  useEffect(() => {
    if (carouselControlRef.current && activeItemIndex !== undefined) {
      // CarouselScrollControl 내부 상태가 업데이트 된 이후에 스크롤 이동이 가능하여 비동기적으로 scrollTo를 호출합니다.
      requestAnimationFrame(() => {
        carouselControlRef.current?.scrollTo(activeItemIndex);
      });
    }
  }, [activeItemIndex]);
  return jsx(ClassNames, {
    children: ({
      css
    }) => jsx(CarouselScrollControl, {
      ref: carouselControlRef,
      hiddenBreakpoints: [],
      buttonClassName: css`
            & button {
              width: 38px;
              height: 38px;
            }
            & span {
              font-size: 18px;
            }  
          `,
      gradation: !isCoarsePointer,
      fixed: true,
      children: children
    })
  });
};
KeywordFilters.Item = KeywordFilter;

var ne=Object.defineProperty;var Q=Object.getOwnPropertySymbols;var me=Object.prototype.hasOwnProperty,pe=Object.prototype.propertyIsEnumerable;var E=(e,o,t)=>o in e?ne(e,o,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[o]=t,Z=(e,o)=>{for(var t in o||(o={}))me.call(o,t)&&E(e,t,o[t]);if(Q)for(var t of Q(o))pe.call(o,t)&&E(e,t,o[t]);return e};(e=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(e,{get:(o,t)=>(typeof require!="undefined"?require:o)[t]}):e)(function(e){if(typeof require!="undefined")return require.apply(this,arguments);throw Error('Dynamic require of "'+e+'" is not supported')});var f=(e,o,t)=>E(e,typeof o!="symbol"?o+"":o,t);var u={OFF:0,ERROR:10,WARN:20,INFO:30,DEBUG:40};var S=class{constructor(o){f(this,"id");f(this,"level");this.id=o.id,this.level=o.level;}getLevel(){return this.level}setLevel(o){this.level=o;}error(o,t){this.level<u.ERROR||console.error("[ERROR]",this.createLogSchema(u.ERROR,o,t));}warn(o,t){this.level<u.WARN||console.warn("[WARN]",this.createLogSchema(u.WARN,o,t));}info(o,t){this.level<u.INFO||console.info("[INFO]",this.createLogSchema(u.INFO,o,t));}debug(o,t){this.level<u.DEBUG||console.debug("[DEBUG]",this.createLogSchema(u.DEBUG,o,t));}createLogSchema(o,t,r){return JSON.stringify({id:this.id,level:o,message:t,data:r,timestamp:Date.now()})}};var $="bp-m-ver",P="bp-cid",T="bp-sid",A="bp-aid",v="bp-p-type",w="bp-p-ver",R="bp-a-name",x="bp-a-ver",I="bp-s-country",C="bp-locale",j="bp-tz",U="b_visitor_id",V=[$,P,T,A,v,w,R,x,I,C,j,U];function we(e,o){if(!b(o))return !1;let t=s(e),r=s(o);return r.major>t.major||r.major===t.major&&r.minor>t.minor||r.major===t.major&&r.minor===t.minor&&r.patch>=t.patch}function b(e){return /^\d+(\.\d+)+/.test(e)}function s(e){if(!b(e))return {major:0,minor:0,patch:0};let[o=0,t=0,r=0]=e.split(".").map(i=>Number.parseInt(i,10));return {major:o,minor:t,patch:r}}function y(e){return ["Android","iOS"].includes(e!=null?e:"")}var ee={parse:(e="")=>{let o=e.trim();return o===""?{}:o.split(";").map(t=>se(t)).reduce((t,[r,i])=>(r==null||i==null||(t[r.trim()]=i.trim()),t),{})},stringify:e=>Object.entries(e).filter(([o,t])=>t!==void 0).map(([o,t])=>`${o}=${t}`.trim()).join("; ")};function se(e){let[o,...t]=e.split("=");return [o,t.length<1?void 0:t.join("=")]}function a(e=3456e7){return Date.now()+e}function d(){return {"bp-m-ver":"","bp-cid":"","bp-sid":"","bp-aid":"","bp-p-type":"","bp-p-ver":"","bp-a-name":"","bp-a-ver":"","bp-s-country":"","bp-locale":"","bp-tz":"",b_visitor_id:""}}function O(e){let o=ee.parse(e);return Object.entries(o).reduce((t,[r,i])=>!r||!V.includes(r)?t:Object.assign(t,{[r]:i}),d())}function z(e){return new URL(e).host.split(".").slice(-2).join(".")}function Y(e){let o=C,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let r=a();return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(r).toUTCString()}`}}}function H(e){let o=I,t=e.value?e.value:"";return {name:o,value:t,cookie:()=>{let r=a(864e5);return `${o}=${t}; path=/; domain=${e.domain}; expires=${new Date(r).toUTCString()}`}}}var k=class e{constructor(o){f(this,"config");f(this,"data",new Map);this.config={serviceType:o.serviceType,env:o.env,cookieDomain:o.cookieDomain};}get(o){return this.data.get(o)}set(o,t){return this.data.set(o,t),t}clear(){this.data.clear();}diff(o){let t=[];for(let r of this.data.values())r.value&&o[r.name]!==r.value&&t.push(r);return t}clone(){let o=new e({serviceType:this.config.serviceType,env:this.config.env,cookieDomain:this.config.cookieDomain});for(let t of this.data.values())o.set(t.name,Z({},t));return o}toJSON(){let o={};for(let t of this.data.values())t.value&&(o[t.name]=t.value);return o}};new S({id:"metadata",level:u.OFF});

const getBpLocale = req => req.metadata?.data?.get(C)?.value;
const getBpSCountry = req => req.metadata?.data?.get(I)?.value;
const getBpPType = req => req.metadata?.data?.get(v)?.value;

/**
 * locale 없는 url의 redirect에 사용할 locale을 return 합니다.
 */
const getGlobalRedirectLocale = async ({
  req,
  localeInUrl
}) => {
  // 1. en-US, id-ID, ja-JP 등 허용하는 locale을 가진 주소로 접근 시 해당 값을 그대로 사용합니다.
  if (isAllowedGlobalLocale(localeInUrl)) {
    return localeInUrl;
  }
  const countryFromCookie = getBpSCountry(req) ?? null;

  // 2. en, ja, id 등 허용하는 language를 가진 주소로 접근한 경우
  if (isAllowedGlobalLanguage(localeInUrl)) {
    // 2-1. APP이고 metadata country 값이 존재한다면 해당 값을 사용합니다.
    const localeByMetadata = `${localeInUrl}-${countryFromCookie}`;
    if (y(getBpPType(req)) && countryFromCookie && isAllowedGlobalLocale(localeByMetadata)) {
      return localeByMetadata;
    }
    // 2-2. WEB이거나 metadata에 country값이 없다면, 언어에 맞는 기본 국가를 할당해서 사용합니다.
    const countryFromDefault = GLOBAL_LANGUAGE_TO_COUNTRY[localeInUrl];
    return `${localeInUrl}-${countryFromDefault}`;
  }

  // 3. metadata에 올바른 language와 country 값이 존재한다면 해당 값을 사용하고 없다면 DEFAULT_LANGUAGE, COUNTRY를 사용합니다.
  let languageFromMetadata = getBpLocale(req)?.split('-')[0] ?? null;
  if (languageFromMetadata?.toLocaleLowerCase() === 'in') {
    languageFromMetadata = 'id';
  }

  // 3-1. 둘 다 유효한 경우, 조합하여 전달합니다.
  if (isAllowedGlobalLanguage(languageFromMetadata) && isAllowedGlobalCountry(countryFromCookie)) {
    return `${languageFromMetadata}-${countryFromCookie}`;
  }

  // 3-2. 언어만 유효한 경우, 언어에 맞는 국가를 매칭하여 전달합니다.
  if (isAllowedGlobalLanguage(languageFromMetadata) && !isAllowedGlobalCountry(countryFromCookie)) {
    return `${languageFromMetadata}-${GLOBAL_LANGUAGE_TO_COUNTRY[languageFromMetadata]}`;
  }

  // 3-3. 국가만 유효한 경우, 국가에 맞는 언어를 매칭하여 전달합니다.
  if (!isAllowedGlobalLanguage(languageFromMetadata) && isAllowedGlobalCountry(countryFromCookie)) {
    return `${GLOBAL_COUNTRY_TO_LANGUAGE[countryFromCookie]}-${countryFromCookie}`;
  }

  // 3-4. 둘다 유효하지 않은 경우, DEFAULT_LOCALE을 사용합니다.
  return GLOBAL_DEFAULT_LOCALE;
};

function parseCookieEntry(input) {
  const [key, ...values] = input.split('=');
  return [key, values.length < 1 ? undefined : values.join('=')];
}
function parseCookie(input) {
  const trimmed = input.trim();
  if (trimmed === '') {
    return {};
  }
  return trimmed.split(';').map(record => parseCookieEntry(record)).reduce((acc, [key, value]) => {
    if (key == null || value == null) {
      return acc;
    }
    acc[key.trim()] = value.trim();
    return acc;
  }, {});
}
function stringifyCookie(input) {
  return Object.entries(input).map(([key, value]) => `${key}=${value}`.trim()).join('; ');
}

/**
 * 쿠키 헤더를 원하는 값으로 업데이트합니다.
 */
function updateCookieHeader({
  cookieHeader,
  newValues
}) {
  const cookies = parseCookie(cookieHeader);
  Object.entries(newValues).forEach(([key, value]) => {
    if (value) {
      cookies[key] = value;
    }
  });
  return stringifyCookie(cookies);
}

/**
 * 주어진 문자열이 로케일 형식을 갖추고 있는지 확인합니다.
 * @param localeCandidate - 로케일 형식을 확인할 문자열
 * @returns 로케일 형식이면 true, 아니면 false
 * @example
 * isLocaleFormat('en') // true
 * isLocaleFormat('en-US') // true
 * isLocaleFormat('ko-JP') // true
 * isLocaleFormat('ko-JP-123') // false
 * isLocaleFormat('ch') // false
 * isLocaleFormat('') // false
 */
const isLocaleFormat = localeCandidate => {
  // 앱 구버전에서 전달해주던 Language 형태의 로케일 값.
  const LANGUAGE_CASES = ['en', 'ja', 'id', 'ko'];
  if (!localeCandidate) {
    return false;
  }

  // 앱 구버전 대응을 위해 기존에 사용하던 language 형태의 값이 전달되는 경우도 변경이 필요한 케이스로 인식합니다.
  if (LANGUAGE_CASES.includes(localeCandidate)) {
    return true;
  }
  return /^[a-z]{2,3}-[A-Z]{2,3}$/.test(localeCandidate);
};

const globalMiddleware = {
  express: ({
    env
  }) => async (req, res, next) => {
    const relativeUrl = req.url;
    const goodsDetailDescriptionRegex = /.*\/goods\/[^/]+\/description.*/;

    // TODO:HACK: 상품상세설명 웹뷰 임시처리로 대응훅 제거 필요
    if (goodsDetailDescriptionRegex.test(relativeUrl)) {
      next();
      return;
    }
    if (isNextJsPageRequest(relativeUrl) && req.metadata) {
      const localeCandidate = getTextAtLocalePositionInUrl(relativeUrl);
      if (!localeCandidate || !isAllowedGlobalLocale(localeCandidate)) {
        const redirectLocale = await getGlobalRedirectLocale({
          req,
          localeInUrl: localeCandidate
        });
        let redirectUrl;

        // en, us, id 등 language만 있는 경우나, ch-JP 등 로케일의 형식을 갖춘 경우에는 해당 값을 지우고 새로운 locale을 사용합니다.
        if (isLocaleFormat(localeCandidate)) {
          redirectUrl = `${relativeUrl.replace(`/${localeCandidate}`, `/${redirectLocale}`)}`;
        } else {
          redirectUrl = `/${redirectLocale}${relativeUrl}`;
        }
        res.redirect(302, redirectUrl);
        return;
      }
      overrideMetadataCookie({
        req,
        res,
        locale: localeCandidate,
        env
      });
    }
    next();
  }
};

/**
 * bp-locale, bp-s-country 값을 덮어씌웁니다.
 */
const overrideMetadataCookie = ({
  req,
  res,
  locale,
  env
}) => {
  const setCookie = res.getHeader('set-cookie');
  const cookies = isArray$3(setCookie) ? setCookie : [];
  const cookieDomain = z(GLOBAL_DOMAINS[env]['home']);
  const [, country] = locale.split('-');
  const newBpSCountryCookie = H({
    domain: cookieDomain,
    value: country ?? ''
  }).cookie();
  const newBpLocaleCookie = Y({
    domain: cookieDomain,
    value: locale ?? ''
  }).cookie();
  res.setHeader('set-cookie', [...cookies, newBpSCountryCookie, newBpLocaleCookie]);
  req.headers.cookie = updateCookieHeader({
    cookieHeader: req.headers.cookie ?? '',
    newValues: {
      [C]: locale,
      [I]: country
    }
  });
};

const NOTICE_DISPLAYED_USER_LIST_KEY = 'notice-displayed-user-list';
function useNoticePolicyUpdate({
  active = true,
  user,
  noticeDisplayDate,
  policyChangeDate,
  policyUrl,
  storageKey = NOTICE_DISPLAYED_USER_LIST_KEY,
  localeData,
  duration,
  onImpression,
  onConfirm
}) {
  const snackbar = useSnackbar();
  const onImpressionRef = useCallbackRef(onImpression);
  const onConfirmRef = useCallbackRef(onConfirm);
  const getNoticeDisplayedUser = useCallback(() => {
    const storageItem = localStorage.getItem(storageKey);
    return storageItem ? JSON.parse(storageItem) : [];
  }, [storageKey]);
  const setNoticeDisplayedUserList = useCallback(userId => {
    const noticeDisplayedUserList = getNoticeDisplayedUser();
    localStorage.setItem(storageKey, JSON.stringify([...noticeDisplayedUserList, userId]));
  }, [getNoticeDisplayedUser, storageKey]);
  const isNoticeDisplayedUser = useCallback(userId => {
    const noticeDisplayedUserList = getNoticeDisplayedUser();
    return noticeDisplayedUserList.includes(userId);
  }, [getNoticeDisplayedUser]);
  useEffect(() => {
    const noticeDisplayStartDate = new Date(noticeDisplayDate);
    const noticeDisplayEndDate = addDays(noticeDisplayStartDate, 31);
    const now = new Date();
    const isNoticeDisplayPeriod = isAfter(now, noticeDisplayStartDate) && isBefore(now, noticeDisplayEndDate);
    if (!active || !user || !isNoticeDisplayPeriod) {
      return;
    }
    const isUserSignedUpBeforePolicyChange = isBefore(new Date(user.createdAt), new Date(policyChangeDate));
    if (!isNoticeDisplayedUser(user.userableId) && isUserSignedUpBeforePolicyChange) {
      onImpressionRef();
      snackbar.open({
        content: localeData?.noticePolicyUpdate ?? '개정된 이용약관을 확인해 보세요',
        duration,
        suffixButton: {
          title: localeData?.confirm ?? '확인하기',
          onClick: () => {
            onConfirmRef();
            window.open(policyUrl, '_blank');
          }
        }
      });
      setNoticeDisplayedUserList(user.userableId);
    }
  }, [isNoticeDisplayedUser, noticeDisplayDate, policyChangeDate, policyUrl, snackbar, setNoticeDisplayedUserList, user, active, localeData?.noticePolicyUpdate, localeData?.confirm, duration, onImpressionRef, onConfirmRef]);
}

const useGoogleReferrerTracking = () => {
  useEffect(() => {
    addGoogleReferrerTracking();
  }, []);
};
const addGoogleReferrerTracking = () => {
  if (typeof window === 'undefined') {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  if (document && document.referrer?.includes('google.com')) {
    window.dataLayer.push({
      utm_source: 'google',
      utm_medium: 'organic',
      utm_campaign: 'google_search',
      utm_id: document.querySelector('meta[name="bucket-log:page_id"]')?.getAttribute('content')
    });
  }
};

var _path$2;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.186 15v-3.93h.037L6.994 15h1.027V9H6.834v3.909h-.033L4.035 9H3v6zM12.794 13.96H10.11v-1.513h2.533v-.965H10.11v-1.447h2.684V9H8.87v6h3.924zM17.096 10.9h.037l1.125 4.1h1.17L21 9h-1.285l-.936 4.345h-.033L17.638 9H16.59l-1.108 4.345h-.033L14.518 9h-1.285l1.568 6h1.17z"
  })));
};
var NewIcon = SvgNew;

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const STATUS_MARKER_ICONS_MAPPING = {
  new: () => jsx(NewIconWrapper, {
    children: jsx(NewIcon, {})
  }),
  higher: () => jsx(IconFlipper, {
    children: jsx(IconColorizer, {
      className: "higher",
      children: jsx(Icon$2, {
        size: 24,
        name: "dropdown"
      })
    })
  }),
  lower: () => jsx(IconColorizer, {
    className: "lower",
    children: jsx(Icon$2, {
      size: 24,
      name: "dropdown"
    })
  }),
  constant: () => jsx(IconColorizer, {
    className: "constant",
    children: jsx(Icon$2, {
      size: 24,
      name: "unconverted"
    })
  })
};
function TrendingKeywordsEntry(props) {
  const {
    className,
    rank,
    status,
    title
  } = props;
  const marker = STATUS_MARKER_ICONS_MAPPING[status];
  return jsxs(Container$4, {
    className: className,
    children: [jsx(RankNumberGutter, {
      children: rank
    }), jsx(StatusMarker, {
      children: /*#__PURE__*/React__default.createElement(marker ?? STATUS_MARKER_ICONS_MAPPING['constant'])
    }), jsx(Title, {
      children: title
    })]
  });
}
const Container$4 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj6"
} : {
  target: "e1p2u4vj6",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
const RankNumberGutter = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj5"
} : {
  target: "e1p2u4vj5",
  label: "RankNumberGutter"
})("display:inline-block;", FONT_STYLE.subTitle1, ";font-style:normal;font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";text-align:center;margin-right:2px;min-width:20px;");
const StatusMarker = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj4"
} : {
  target: "e1p2u4vj4",
  label: "StatusMarker"
})(process.env.NODE_ENV === "production" ? {
  name: "ckw133",
  styles: "margin-right:6px;display:flex;align-items:center"
} : {
  name: "ckw133",
  styles: "margin-right:6px;display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
const Title = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj3"
} : {
  target: "e1p2u4vj3",
  label: "Title"
})("display:inline-block;", FONT_STYLE.subTitle1, ";flex:1 0 auto;font-style:normal;font-weight:400;color:", ({
  theme
}) => theme.content.base1, ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:104px;");
const IconFlipper = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj2"
} : {
  target: "e1p2u4vj2",
  label: "IconFlipper"
})(process.env.NODE_ENV === "production" ? {
  name: "1mnpgkl",
  styles: "display:block;transform:rotate(180deg)"
} : {
  name: "1mnpgkl",
  styles: "display:block;transform:rotate(180deg)",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
const IconColorizer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj1"
} : {
  target: "e1p2u4vj1",
  label: "IconColorizer"
})("display:block;>span{display:block;}&.higher{color:", ({
  theme
}) => theme.content.primary2.thick, ";}&.lower{color:", ({
  theme
}) => theme.content.primary1.thick, ";}&.constant{color:", ({
  theme
}) => theme.content.base3, ";}");
const NewIconWrapper = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1p2u4vj0"
} : {
  target: "e1p2u4vj0",
  label: "NewIconWrapper"
})("display:block;width:24px;height:24px;>svg{display:block;width:100%;height:auto;color:", ({
  theme
}) => theme.content.primary2.thick, ";}");

const STATUS_MAPPING = {
  1: 'higher',
  0: 'constant',
  [-1]: 'lower'
};
function mapTrendingKeywordStatus(keyword) {
  if (keyword.isNew) {
    return 'new';
  }
  return STATUS_MAPPING[Math.sign(keyword.diffRank)] ?? 'constant';
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TrendingKeywordsList(props) {
  const {
    className,
    entries,
    mode,
    linkComponent,
    baseUrl,
    onEntryClick
  } = props;
  const logDataFragment = {
    section: '인기 검색어 펼침',
    type: 'keyword',
    data: {
      keyword_popular: entries.map(keyword => keyword.displayKeyword)
    }
  };
  return jsx(Container$3, {
    className: className,
    children: jsx(ImpressionTracker, {
      logData: logDataFragment,
      children: jsx(KeywordEntryList, {
        mode: mode ?? 'grid',
        children: entries.map((keyword, index) => jsx(LinkStyled$1, {
          as: linkComponent,
          href: `${baseUrl ?? ''}/search/index?query=${encodeURIComponent(keyword.displayKeyword)}&input_source=integrated&search_affect_type=Issue`,
          onClick: () => {
            onEntryClick?.(keyword, index);
          },
          logData: {
            ...logDataFragment,
            id: keyword.displayKeyword,
            index
          },
          children: jsx(KeywordEntry, {
            rank: keyword.rank,
            status: mapTrendingKeywordStatus(keyword),
            title: keyword.displayKeyword
          })
        }, keyword.key))
      })
    })
  });
}
const Container$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekcs1el3"
} : {
  target: "ekcs1el3",
  label: "Container"
})();
const LinkStyled$1 = /*#__PURE__*/_styled(LogLink, process.env.NODE_ENV === "production" ? {
  target: "ekcs1el2"
} : {
  target: "ekcs1el2",
  label: "LinkStyled"
})("display:block;", ({
  theme
}) => /*#__PURE__*/css(HOVER$1`
      background-color: ${theme.background.groupedBase};
    `, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:LinkStyled;")), ";");
var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "1ety6b1",
  styles: "margin:0 4px;grid-template-columns:repeat(2, 1fr);& * div{margin:8px 12px;}"
} : {
  name: "1kesqm5-KeywordEntryList",
  styles: "margin:0 4px;grid-template-columns:repeat(2, 1fr);& * div{margin:8px 12px;};label:KeywordEntryList;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
};
const KeywordEntryList = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekcs1el1"
} : {
  target: "ekcs1el1",
  label: "KeywordEntryList"
})("display:grid;", ({
  mode
}) => mode === 'grid' && _ref$1, ";");
const KeywordEntry = /*#__PURE__*/_styled(TrendingKeywordsEntry, process.env.NODE_ENV === "production" ? {
  target: "ekcs1el0"
} : {
  target: "ekcs1el0",
  label: "KeywordEntry"
})(process.env.NODE_ENV === "production" ? {
  name: "uhy4xz",
  styles: "margin:8px 16px"
} : {
  name: "uhy4xz",
  styles: "margin:8px 16px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TRANSITION_DURATION = 400;
const ROLLING_INTERVAL = 1500 + TRANSITION_DURATION;
function _TrendingKeywordsRolling(props, ref) {
  const {
    className,
    entries,
    paused,
    linkComponent,
    baseUrl,
    onOpen,
    onMouseEnter,
    onMouseLeave
  } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (paused) {
      return;
    }
    const handle = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % entries.length);
    }, ROLLING_INTERVAL);
    return () => {
      clearInterval(handle);
    };
  }, [entries, paused]);
  useEffect(() => {
    setCurrentIndex(0);
  }, [entries]);
  const logDataFragment = {
    section: '인기 검색어',
    type: 'keyword',
    data: {
      keyword_popular: entries.map(keyword => keyword.displayKeyword)
    }
  };
  const currentKeyword = entries[currentIndex];
  const currentElement = currentKeyword != null ? jsx(LinkStyled, {
    as: linkComponent,
    href: `${baseUrl ?? ''}/search/index?query=${encodeURIComponent(currentKeyword.displayKeyword)}&input_source=integrated&search_affect_type=Issue`,
    logData: {
      ...logDataFragment,
      id: currentKeyword.displayKeyword,
      index: currentIndex
    },
    children: jsx(TrendingKeywordsEntry, {
      rank: currentKeyword.rank,
      status: mapTrendingKeywordStatus(currentKeyword),
      title: currentKeyword.displayKeyword
    })
  }) : null;
  return jsx(ImpressionTracker, {
    logData: logDataFragment,
    children: jsxs(Container$2, {
      className: className,
      ref: ref,
      children: [jsxs(RollingContainer, {
        children: [jsx(InvisibleSpacingMachine, {
          children: currentElement
        }), jsx(TransitionGroup$1, {
          children: jsx(CSSTransition$1, {
            timeout: TRANSITION_DURATION,
            classNames: "item",
            children: jsx(TransitionContainer, {
              children: currentElement
            })
          }, currentKeyword?.key)
        })]
      }), jsx(MenuToggleButton$1, {
        type: "button",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: () => onOpen(),
        children: jsx(Icon$2, {
          size: 18,
          name: "chevron_down"
        })
      })]
    })
  });
}
const TrendingKeywordsRolling = /*#__PURE__*/React__default.forwardRef(_TrendingKeywordsRolling);
const Container$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji5"
} : {
  target: "e1nb0uji5",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "ga3b11",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%"
} : {
  name: "ga3b11",
  styles: "display:flex;align-items:center;justify-content:space-between;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
const RollingContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji4"
} : {
  target: "e1nb0uji4",
  label: "RollingContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "s0wc5p",
  styles: "position:relative;margin-right:6px;overflow:hidden"
} : {
  name: "s0wc5p",
  styles: "position:relative;margin-right:6px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
const MenuToggleButton$1 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji3"
} : {
  target: "e1nb0uji3",
  label: "MenuToggleButton"
})(RESET_BUTTON, ";padding:6px;>span{display:block;color:", ({
  theme
}) => theme.content.base2, ";}");
const InvisibleSpacingMachine = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji2"
} : {
  target: "e1nb0uji2",
  label: "InvisibleSpacingMachine"
})(process.env.NODE_ENV === "production" ? {
  name: "6dhm9o",
  styles: "visibility:hidden"
} : {
  name: "6dhm9o",
  styles: "visibility:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
const TransitionContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji1"
} : {
  target: "e1nb0uji1",
  label: "TransitionContainer"
})("position:absolute;top:0;left:0;&.item-enter{transform:translateY(24px);opacity:0;}&.item-enter-active{opacity:1;transform:translateY(0);transition:opacity ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1),transform ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1);}&.item-exit{transform:translateY(0);opacity:1;}&.item-exit-active{transform:translateY(-24px);opacity:0;transition:opacity ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1),transform ", TRANSITION_DURATION, "ms cubic-bezier(0.25, 0.1, 0.25, 1);}");
const LinkStyled = /*#__PURE__*/_styled(LogLink, process.env.NODE_ENV === "production" ? {
  target: "e1nb0uji0"
} : {
  target: "e1nb0uji0",
  label: "LinkStyled"
})(process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "4zleql",
  styles: "display:block",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

function useToggle(options = {}) {
  const [open, setOpen] = useState(options.open ?? false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const handleClose = useCallback(() => setOpen(false), []);
  const handleToggle = useCallback(flag => {
    setOpen(prevState => flag ?? !prevState);
  }, []);
  return {
    open,
    handleOpen,
    handleClose,
    handleToggle
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function TrendingKeywordsDropdown(props) {
  const {
    className,
    entries,
    linkComponent,
    baseUrl
  } = props;
  const {
    open: dropdownOpened,
    handleOpen,
    handleClose
  } = useToggle({
    open: false
  });
  return jsx(Container$1, {
    className: className,
    children: jsx(DropdownPopper, {
      placement: "bottom-end",
      isForceClosed: !dropdownOpened,
      renderButton: ({
        onClick
      }) => jsx(TrendingKeywordsRolling, {
        entries: entries,
        paused: dropdownOpened,
        linkComponent: linkComponent,
        baseUrl: baseUrl,
        onOpen: () => {
          onClick();
          handleOpen();
        }
      }),
      children: jsxs(DropdownListPanel, {
        children: [jsxs(DropdownListHeader, {
          children: [jsx(DropdownListHeaderTitle, {
            children: "\uC778\uAE30 \uAC80\uC0C9\uC5B4"
          }), jsx(MenuToggleButton, {
            type: "button",
            onClick: () => {
              O$1({
                category: 'click',
                section: '인기 검색어 닫힘'
              });
              handleClose();
            },
            children: jsx(Icon$2, {
              size: 18,
              name: "chevron_down"
            })
          })]
        }), jsx(TrendingKeywordsList, {
          mode: "list",
          entries: entries,
          baseUrl: baseUrl,
          onEntryClick: handleClose
        })]
      })
    })
  });
}
const Container$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw5"
} : {
  target: "eft3pbw5",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
const DropdownPopper = /*#__PURE__*/_styled(Popper$1, process.env.NODE_ENV === "production" ? {
  target: "eft3pbw4"
} : {
  target: "eft3pbw4",
  label: "DropdownPopper"
})(process.env.NODE_ENV === "production" ? {
  name: "1iqaq9l",
  styles: "z-index:10000;&&>.popper-item{transform:translate3d(24px, -70px, 0);}"
} : {
  name: "1iqaq9l",
  styles: "z-index:10000;&&>.popper-item{transform:translate3d(24px, -70px, 0);}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
const DropdownListPanel = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw3"
} : {
  target: "eft3pbw3",
  label: "DropdownListPanel"
})("width:268px;background:", ({
  theme
}) => theme.background.base, ";padding:20px 0;");
const DropdownListHeader = /*#__PURE__*/_styled("header", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw2"
} : {
  target: "eft3pbw2",
  label: "DropdownListHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "mnvjsq",
  styles: "display:flex;align-items:center;justify-content:space-between;margin:0 16px 8px"
} : {
  name: "mnvjsq",
  styles: "display:flex;align-items:center;justify-content:space-between;margin:0 16px 8px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
const DropdownListHeaderTitle = /*#__PURE__*/_styled("h2", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw1"
} : {
  target: "eft3pbw1",
  label: "DropdownListHeaderTitle"
})(FONT_STYLE.title3, ";font-style:normal;font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";");
const MenuToggleButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "eft3pbw0"
} : {
  target: "eft3pbw0",
  label: "MenuToggleButton"
})(RESET_BUTTON, ";padding:6px;>span{display:block;color:", ({
  theme
}) => theme.content.base2, ";transform:rotate(180deg);}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const StylingShotProductCard = ({
  originalImageUrl,
  stats,
  name,
  originalPrice,
  sellingPrice,
  onClick
}) => {
  const {
    discountRate,
    price,
    showDiscountRate
  } = getProductPriceInfo({
    originalPrice,
    sellingPrice,
    type: 'Production'
  });
  return jsxs(ClickableFlex, {
    direction: "row",
    gap: 6,
    onClick: onClick,
    clickable: !!onClick,
    children: [jsx(Flex, {
      w: "42px",
      shrink: 0,
      bdr: "3.5px",
      overflow: "hidden",
      position: "relative",
      children: jsx(ImageBox, {
        children: jsx(Image, {
          src: getImageUrl({
            src: originalImageUrl,
            mode: 'cover'
          }),
          className: "thumbnail-image",
          alt: "\uC0C1\uD488-\uC378\uB124\uC77C-\uC774\uBBF8\uC9C0"
        })
      })
    }), jsxs(Flex, {
      w: "calc(100% - 48px)",
      children: [jsx(StylingShotProductName, {
        children: name
      }), jsx(Flex, {
        direction: "row",
        gap: 2,
        children: jsxs(Fragment, {
          children: [showDiscountRate && jsxs(Rate, {
            children: [discountRate, "%"]
          }), jsx(Amount, {
            children: price
          })]
        })
      }), jsx(StylingShotProductStats, {
        stats: stats
      })]
    })]
  });
};
const ClickableFlex = /*#__PURE__*/_styled(Flex, process.env.NODE_ENV === "production" ? {
  target: "ehu96h96"
} : {
  target: "ehu96h96",
  label: "ClickableFlex"
})("cursor:", ({
  clickable
}) => clickable ? 'pointer' : 'default', ";");
const StylingShotProductName = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehu96h95"
} : {
  target: "ehu96h95",
  label: "StylingShotProductName"
})(FONT_STYLE.detail13L18, " white-space:nowrap;text-overflow:ellipsis;overflow:hidden;");
const Rate = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "ehu96h94"
} : {
  target: "ehu96h94",
  label: "Rate"
})(FONT_STYLE.detail13L18, " font-weight:700;color:", ({
  theme
}) => theme.colors.foregroundBrand, ";");
const Amount = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "ehu96h93"
} : {
  target: "ehu96h93",
  label: "Amount"
})(FONT_STYLE.detail13L18, " font-weight:700;color:", ({
  theme
}) => theme.content.base1, ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;");
const StylingShotProductStats = /*#__PURE__*/_styled(Stats, process.env.NODE_ENV === "production" ? {
  target: "ehu96h92"
} : {
  target: "ehu96h92",
  label: "StylingShotProductStats"
})(FONT_STYLE.detail12L16, " margin:0;white-space:nowrap;");
const ImageBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehu96h91"
} : {
  target: "ehu96h91",
  label: "ImageBox"
})(process.env.NODE_ENV === "production" ? {
  name: "o7hklp",
  styles: "position:absolute;top:0;left:0;width:42px;height:42px;border-radius:3.5px;overflow:hidden"
} : {
  name: "o7hklp",
  styles: "position:absolute;top:0;left:0;width:42px;height:42px;border-radius:3.5px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
const Image = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "ehu96h90"
} : {
  target: "ehu96h90",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "4uwt2b",
  styles: "width:100%;height:100%;object-fit:cover"
} : {
  name: "4uwt2b",
  styles: "width:100%;height:100%;object-fit:cover",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

const calculateTagPosition = ({
  tagInfo,
  originalWidth,
  originalHeight,
  targetAspect
}) => {
  const originalAspect = originalWidth / originalHeight;
  if (originalAspect > targetAspect) {
    // 가로가 더 길다 → 세로 기준으로 크롭
    const newWidth = originalHeight * targetAspect;
    // 원본이미지에서 크롭된 이미지까지의 가로 상 위치
    const xOffsetPx = (originalWidth - newWidth) / 2;

    // 태그의 원래 위치 (px)
    const tagXPx = tagInfo.tagXPosition / 100 * originalWidth;

    // 크롭된 영역 내에서 위치 계산
    const newX = (tagXPx - xOffsetPx) / newWidth * 100;
    return {
      x: newX,
      y: tagInfo.tagYPosition // 세로는 그대로 유지
    };
  } else {
    // 세로가 더 길다 → 가로 기준으로 크롭
    const newHeight = originalWidth / targetAspect;
    // 원본이미지에서 크롭된 이미지까지의 세로 상 위치
    const yOffsetPx = (originalHeight - newHeight) / 2;
    const tagYPx = tagInfo.tagYPosition / 100 * originalHeight;
    const newY = (tagYPx - yOffsetPx) / newHeight * 100;
    return {
      x: tagInfo.tagXPosition,
      y: newY
    };
  }
};

const ASPECT_RATIO = 0.933;
const TAG_BUTTON_HALF_SIZE = TAG_BUTTON_WIDTH / 2;

/**
 * 태그 버튼을 이미지 위에 표시하는 컴포넌트
 * 이미지는 정방형으로 crop 되며, 태그 위치 정보는 crop 되기 전의 좌표를 기준으로 합니다.
 *
 * @param imageUrl - 이미지 URL
 * @param tagInfo - 태그 위치 정보 (백분율)
 * @param originalWidth - 원본 이미지 너비
 * @param originalHeight - 원본 이미지 높이
 * @param overlayComponent - 이미지 위에 표시할 컴포넌트 (예: 스크랩 버튼)
 * @param onClick - 배경 영역 클릭 핸들러
 * @param onClickTag - 태그 버튼 클릭 핸들러
 */
const ThumbnailWithTag = /*#__PURE__*/forwardRef(({
  imageUrl,
  imageAlt,
  tagInfo,
  originalWidth,
  originalHeight,
  overlayComponent,
  onClick,
  onClickTag,
  className
}, ref) => {
  const tagPosition = calculateTagPosition({
    tagInfo,
    originalWidth,
    originalHeight,
    targetAspect: ASPECT_RATIO
  });
  const handleClick = event => {
    // 태그나 오버레이 컴포넌트가 클릭된 경우 이벤트 전파 중단
    if (event.target.closest('[data-clickable]')) {
      event.stopPropagation();
      return;
    }
    onClick?.(event);
  };
  return jsxs(ClickableBox, {
    position: "relative",
    className: className,
    onClick: handleClick,
    clickable: !!onClick,
    children: [jsx(Box, {
      bdr: "4.76%",
      overflow: "hidden",
      children: jsx(AspectBox, {
        ref: ref,
        children: jsx(ResizeImage, {
          src: imageUrl,
          intrinsicAspect: ASPECT_RATIO,
          objectFit: "cover",
          alt: imageAlt
        })
      })
    }), jsx(Box, {
      position: "absolute",
      top: `calc(${tagPosition.y}% - ${TAG_BUTTON_HALF_SIZE}px)`,
      left: `calc(${tagPosition.x}% - ${TAG_BUTTON_HALF_SIZE}px)`,
      "data-clickable": true,
      children: jsx(TagButton, {
        themeColor: "blue",
        isActive: false,
        onClick: onClickTag
      })
    }), overlayComponent && jsx(Box, {
      "data-clickable": true,
      children: overlayComponent
    })]
  });
});
const ClickableBox = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "e1r1vnjr1"
} : {
  target: "e1r1vnjr1",
  label: "ClickableBox"
})("cursor:", ({
  clickable
}) => clickable ? 'pointer' : 'default', ";overflow:hidden;");
const AspectBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1r1vnjr0"
} : {
  target: "e1r1vnjr0",
  label: "AspectBox"
})("aspect-ratio:", ASPECT_RATIO, ";height:100%;");

const StylingShotInventoryItem = /*#__PURE__*/forwardRef(({
  thumbnail,
  productInfo,
  thumbnailRef
}, ref) => {
  return jsxs(Flex, {
    ref: ref,
    gap: 6,
    children: [jsx(ThumbnailWithTag, {
      ...thumbnail,
      ref: thumbnailRef
    }), jsx(StylingShotProductCard, {
      ...productInfo
    })]
  });
});

/**
 * @link https://www.figma.com/design/5nKHONI7amtYQyy9GE2YFn/-Viewer--%EC%8A%A4%ED%83%80%EC%9D%BC%EB%A7%81%EC%83%B7-%EA%B4%91%EA%B3%A0?node-id=245-7470&m=dev
 */
const AdsBadge = ({
  popperText
}) => {
  // TODO: popper의 isOpen state 사용
  const [isOpen, setIsOpen] = useState(false);
  return jsx(Popper$1, {
    placement: "bottom",
    renderButton: ({
      onClick
    }) => jsx(Flex, {
      bd: "1px solid border",
      w: "14px",
      h: "14px",
      bdr: "4px",
      p: "3px 6px",
      align: "center",
      justify: "center",
      onClick: () => {
        onClick();
        setIsOpen(true);
      },
      children: jsx(Text$3, {
        variant: "detail10L14",
        color: "foregroundWeak",
        children: "AD"
      })
    }),
    usePortal: false,
    isForceClosed: !isOpen,
    children: jsx(Box, {
      p: "12px 16px",
      maw: "311px",
      children: jsxs(Flex, {
        gap: 12,
        direction: "row",
        children: [jsx(Text$3, {
          color: "foreground",
          weight: 400,
          variant: "body16L20",
          children: popperText
        }), jsx(Box, {
          onClick: () => setIsOpen(false),
          children: jsx(DismissIcon, {
            size: 12,
            fill: theme => theme.content.base1
          })
        })]
      })
    })
  });
};

const useFollow = ({
  id,
  userId,
  isInitialFollowing = false,
  initialFollowCount = 0,
  onRedirectToSignIn,
  requestFollow,
  requestUnfollow,
  onFollow,
  onUnfollow,
  snackbarPlacement = 'basic',
  logData = {}
}) => {
  const snackbar = useSnackbar();
  const [pending, setPending] = useState(false);
  const [isFollowing, setIsFollowing] = useState(isInitialFollowing);
  const [count, setCount] = useState(initialFollowCount);
  const dispatchWebviewEvent = useWebviewEventDispatcher();
  const logFollow = () => {
    O$1({
      category: 'follow',
      type: 'user',
      id,
      ...logData
    });
  };
  const logUnfollow = () => {
    O$1({
      category: 'unfollow',
      type: 'user',
      id,
      ...logData
    });
  };
  const sendEventToWebview = eventType => {
    if (eventType === 'follow') {
      dispatchWebviewEvent({
        type: 'follow',
        contentType: 'User',
        contentId: id,
        performed: true,
        count: count + 1
      });
      return;
    }
    dispatchWebviewEvent({
      type: 'follow',
      contentType: 'User',
      contentId: id,
      performed: false,
      count: count - 1
    });
  };
  const handleFollow = async () => {
    if (!userId) {
      onRedirectToSignIn();
      return;
    }
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const response = await requestFollow({
        userId: id
      });
      if (response.success) {
        setIsFollowing(true);
        setCount(count => count + 1);
        logFollow();
        sendEventToWebview('follow');
        onFollow?.();
      } else {
        snackbar.open({
          content: '팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
          placement: snackbarPlacement
        });
      }
    } catch (error) {
      snackbar.open({
        content: '팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        placement: snackbarPlacement
      });
    } finally {
      setPending(false);
    }
  };
  const handleUnfollow = async () => {
    if (!userId) {
      onRedirectToSignIn();
      return;
    }
    if (pending) {
      return;
    }
    setPending(true);
    try {
      const response = await requestUnfollow({
        userId: id
      });
      if (response.success) {
        setIsFollowing(false);
        setCount(count => count - 1);
        logUnfollow();
        sendEventToWebview('unfollow');
        onUnfollow?.();
      } else {
        snackbar.open({
          content: '언팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
          placement: snackbarPlacement
        });
      }
    } catch (error) {
      snackbar.open({
        content: '언팔로우 도중 문제가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
        placement: snackbarPlacement
      });
    } finally {
      setPending(false);
    }
  };
  const handleToggleFollow = () => {
    if (isFollowing) {
      handleUnfollow();
      return;
    }
    handleFollow();
  };
  useWebviewEventListener('follow', event => {
    if (event.contentId !== id) {
      return;
    }
    setIsFollowing(event.performed);
    setCount(event.count);
    setPending(false);
  });
  return {
    follow: handleFollow,
    unfollow: handleUnfollow,
    toggle: handleToggleFollow,
    isFollowing,
    count,
    pending,
    isMe: id === userId
  };
};

const Follow = ({
  children,
  ...followProps
}) => {
  const followData = useFollow(followProps);
  return jsx(Fragment, {
    children: children(followData)
  });
};

const isSSR = () => {
    if (typeof window === 'undefined') {
        console.error('ChannelIO APIs are only executable on browser.');
        return true;
    }
    return false;
};
const isSDKLoaded = () => {
    if (!window.ChannelIO) {
        console.error('ChannelIO is not loaded. Please call loadScript() before calling ChannelIO APIs.');
        return false;
    }
    return true;
};
const safeChannelIO = (...args) => {
    if (isSSR() || !isSDKLoaded()) {
        return;
    }
    window.ChannelIO(...args);
};
/**
 * Loads the Channel SDK script into the document.
 * - Browser-only: This function can only be executed in a browser environment.
 * - Idempotent: If the Channel SDK script is already loaded, calling this function has no effect.
 */
function loadScript() {
    if (isSSR()) {
        return;
    }
    (function () {
        var w = window;
        if (!!w.ChannelIO) {
            return;
        }
        var ch = function () {
            var _a;
            (_a = ch.c) === null || _a === void 0 ? void 0 : _a.call(ch, arguments);
        };
        ch.q = [];
        ch.c = function (args) {
            var _a;
            (_a = ch.q) === null || _a === void 0 ? void 0 : _a.push(args);
        };
        w.ChannelIO = ch;
        function l() {
            if (w.ChannelIOInitialized) {
                return;
            }
            w.ChannelIOInitialized = true;
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
            var x = document.getElementsByTagName('script')[0];
            if (x.parentNode) {
                x.parentNode.insertBefore(s, x);
            }
        }
        if (document.readyState === 'complete') {
            l();
        }
        else {
            w.addEventListener('DOMContentLoaded', l);
            w.addEventListener('load', l);
        }
    })();
}
/**
 * Initializes the SDK, making `Channel button` and features like marketing pop-ups operational.
 *
 * @param {BootOption} option - Configuration options for initializing the SDK.
 * @param {Callback | undefined} callback - Function to be called after booting is complete. On failure, it receives an error object as its first argument and null as the second. On success, it receives null as the first argument and a user object as the second.
 * @see [Boot Glossary](https://developers.channel.io/docs/glossary#boot)
 * @see [Boot Option](https://developers.channel.io/docs/web-boot-option)
 * @see [User Object](https://developers.channel.io/docs/web-user-object)
 */
function boot(option, callback) {
    safeChannelIO('boot', option, callback);
}
/**
 * Displays the messenger interface.
 *
 * @see [ChannelIO: showmessenger API](https://developers.channel.io/docs/web-channelio#showmessenger)
 * @see [Messenger Glossary](https://developers.channel.io/docs/glossary#messenger)
 */
function showMessenger$1() {
    safeChannelIO('showMessenger');
}

new S({id:"metadata:server",level:u.OFF});

({initialized:!1,metadata:new k({serviceType:"OK",env:"dev",cookieDomain:""})});new S({id:"metadata:browser",level:u.OFF});

createContext(null);

const CHANNEL_TALK_PLUGIN_KEY = 'fd8a16bb-2dca-4e54-ab2e-6d8f55254918';
const CHANNEL_TALK_BOOT_KEY = 'channelTalkBoot';
const logContentClick = () => {
  bucketClickLog({
    type: 'BUTTON',
    id: 'HELP_CENTER',
    data: {
      is_boot: sessionStorage.getItem(CHANNEL_TALK_BOOT_KEY)
    }
  });
};
const showMessenger = ({
  onError
}) => {
  if (sessionStorage.getItem(CHANNEL_TALK_BOOT_KEY) === 'TRUE') {
    showMessenger$1();
  } else {
    onError?.();
  }
};
const ChannelTalk = {
  loadScript: () => {
    loadScript();
  },
  boot: ({
    user,
    serviceLanguage,
    serviceCountry,
    onBoot
  }) => {
    if (serviceCountry !== 'JP' || !user) {
      sessionStorage.removeItem(CHANNEL_TALK_BOOT_KEY);
      return;
    }
    boot({
      pluginKey: CHANNEL_TALK_PLUGIN_KEY,
      hideChannelButtonOnBoot: true,
      language: serviceLanguage,
      memberId: user.id,
      memberHash: user.memberHash,
      profile: {
        name: user.nickname,
        avatarUrl: user.profileImageUrl
      }
    }, (error, _) => {
      if (error) {
        console.error(error);
        sessionStorage.setItem(CHANNEL_TALK_BOOT_KEY, 'FALSE');
      } else {
        sessionStorage.setItem(CHANNEL_TALK_BOOT_KEY, 'TRUE');
        onBoot?.();
      }
    });
  },
  startContact: ({
    isLoggedIn,
    osType,
    version,
    serviceCountry,
    moveToLoginPage,
    onError
  }) => {
    if (serviceCountry !== 'JP') {
      return;
    }
    logContentClick();
    if (y(osType)) {
      if (version && we('25.4.0', version)) {
        sendBridgeAction('openChannelTalk', {});
      } else {
        if (isLoggedIn) {
          showMessenger({
            onError
          });
        } else {
          moveToLoginPage();
        }
      }
    } else {
      if (isLoggedIn) {
        showMessenger({
          onError
        });
      } else {
        moveToLoginPage();
      }
    }
  }
};

const OHOUSE_WEB_PLATFORM_VERSION = '9.0';
const getSearchPathname = searchType => {
  switch (searchType) {
    case SEARCH_TYPE.STORE:
      return 'commerce';
    case SEARCH_TYPE.EXPERT:
      return 'expert';
    case SEARCH_TYPE.TOTAL:
    default:
      return 'integrated';
  }
};
const buildSearchApiHeaders = guestId => {
  return {
    'ohouse-ab-key': guestId,
    'ohouse-os-type': 'WEB',
    'ohouse-platform-version': OHOUSE_WEB_PLATFORM_VERSION
  };
};
const SEARCH_ITEM_TYPE = ['query', 'category', 'consulting', 'history', 'navigation'];
const getDomesticAutoCompleteKeywords = async ({
  env,
  searchType,
  query,
  guestId
}) => {
  const searchPathname = getSearchPathname(searchType);

  /** @see {https://www.notion.so/ohouse/integrated-4a4eeee9b22340faa3dbb3b4e7c83f25?pvs=4} */
  const response = await fetchGet(`${API_AUTOCOMPLETE_HOST[env]}/${searchPathname}?query=${query}`, {
    headers: buildSearchApiHeaders(guestId)
  });
  const data = await response.json();
  return data;
};
const formatAutoCompleteKeywords = data => {
  const autoCompleteKeywords = humpsExports.camelizeKeys(data.results);
  return autoCompleteKeywords.map(item => ({
    type: item.dataType,
    value: item,
    query: item.orgDisplay
  })).filter(item => SEARCH_ITEM_TYPE.includes(item.type));
};

const defaultSignOut = async ({
  user,
  env
}) => {
  const isPro = user?.userableType === 'ExpertUser';
  const res = await fetchDelete(`${DOMAINS[env].home}/users/sign_out.json`, {
    data: {
      is_pro: isPro
    }
  }, {
    headers: {},
    credentials: 'include'
  });
  return res.json();
};

const filterHistory = (history, query) => {
  return typeof history === 'string' ? history !== query : history.query !== query;
};

/** 최근 검색어 데이터들을 다루는 storage를 생성합니다. */
const createSearchHistoryStorage = ({
  env,
  subdomain,
  serviceType
}) => {
  const SearchHistoryStorage = {
    get: () => {
      const matches = document.cookie.match(
      // eslint-disable-next-line prefer-regex-literals
      new RegExp('(?:^|; )searchHistory=([^;]*)'));
      if (matches) {
        try {
          return JSON.parse(decodeURIComponent(matches[1] ?? ''));
        } catch {
          return [];
        }
      }
      return [];
    },
    set: histories => {
      const value = encodeURIComponent(JSON.stringify(histories.slice(0, 5)));
      const cookieDomain = getCookieDomain(env, subdomain, serviceType);
      document.cookie = `searchHistory=${value}; domain=${cookieDomain}; max-age=2147483647; path=/`;
    },
    append: history => {
      const query = typeof history === 'string' ? history : history.query;
      SearchHistoryStorage.set([history, ...SearchHistoryStorage.get().filter(history => filterHistory(history, query))]);
    },
    remove: history => {
      const query = typeof history === 'string' ? history : history.query;
      SearchHistoryStorage.set(SearchHistoryStorage.get().filter(history => filterHistory(history, query)));
    },
    removeAll: () => {
      SearchHistoryStorage.set([]);
    }
  };
  return SearchHistoryStorage;
};

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return [decodeURIComponent(components.join(''))];
  } catch (err) {
    // Do nothing
  }
  if (components.length === 1) {
    return components;
  }
  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher) || [];
    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher) || [];
    }
    return input;
  }
}
function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': '\uFFFD\uFFFD',
    '%FF%FE': '\uFFFD\uFFFD'
  };
  var match = multiMatcher.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);
      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }
    match = multiMatcher.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap['%C2'] = '\uFFFD';
  var entries = Object.keys(replaceMap);
  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }
  return input;
}
var decodeUriComponent = function (encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }
  try {
    encodedURI = encodedURI.replace(/\+/g, ' ');

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = (string, separator) => {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }
  if (separator === '') {
    return [string];
  }
  const separatorIndex = string.indexOf(separator);
  if (separatorIndex === -1) {
    return [string];
  }
  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var filterObj = function (obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];
    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }
  return ret;
};

(function (exports) {

  const strictUriEncode$1 = strictUriEncode;
  const decodeComponent = decodeUriComponent;
  const splitOnFirst$1 = splitOnFirst;
  const filterObject = filterObj;
  const isNullOrUndefined = value => value === null || value === undefined;
  const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return key => (result, value) => {
          const index = result.length;
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[', index, ']'].join('')];
          }
          return [...result, [encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')];
        };
      case 'bracket':
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), '[]'].join('')];
          }
          return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
        };
      case 'colon-list-separator':
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, [encode(key, options), ':list='].join('')];
          }
          return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
        };
      case 'comma':
      case 'separator':
      case 'bracket-separator':
        {
          const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
          return key => (result, value) => {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            // Translate null to an empty string so that it doesn't serialize as 'null'
            value = value === null ? '' : value;
            if (result.length === 0) {
              return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
            }
            return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
          };
        }
      default:
        return key => (result, value) => {
          if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
            return result;
          }
          if (value === null) {
            return [...result, encode(key, options)];
          }
          return [...result, [encode(key, options), '=', encode(value, options)].join('')];
        };
    }
  }
  function parserForArrayFormat(options) {
    let result;
    switch (options.arrayFormat) {
      case 'index':
        return (key, value, accumulator) => {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }
          accumulator[key][result[1]] = value;
        };
      case 'bracket':
        return (key, value, accumulator) => {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'colon-list-separator':
        return (key, value, accumulator) => {
          result = /(:list)$/.exec(key);
          key = key.replace(/:list$/, '');
          if (!result) {
            accumulator[key] = value;
            return;
          }
          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
      case 'comma':
      case 'separator':
        return (key, value, accumulator) => {
          const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };
      case 'bracket-separator':
        return (key, value, accumulator) => {
          const isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, '');
          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }
          const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(item => decode(item, options));
          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };
      default:
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }
          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }
  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }
  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
    }
    return value;
  }
  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }
    return value;
  }
  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }
    if (typeof input === 'object') {
      return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map(key => input[key]);
    }
    return input;
  }
  function removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }
    return input;
  }
  function getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }
    return hash;
  }
  function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) {
      return '';
    }
    return input.slice(queryStart + 1);
  }
  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }
    return value;
  }
  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') {
      return ret;
    }
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) {
      return ret;
    }
    for (const param of query.split('&')) {
      if (param === '') {
        continue;
      }
      let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

      // Missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
      formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)) {
      const value = ret[key];
      if (typeof value === 'object' && value !== null) {
        for (const k of Object.keys(value)) {
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }
    if (options.sort === false) {
      return ret;
    }
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
      const value = ret[key];
      if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }
      return result;
    }, Object.create(null));
  }
  exports.extract = extract;
  exports.parse = parse;
  exports.stringify = (object, options) => {
    if (!object) {
      return '';
    }
    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = key => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object)) {
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) {
      keys.sort(options.sort);
    }
    return keys.map(key => {
      const value = object[key];
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return encode(key, options);
      }
      if (Array.isArray(value)) {
        if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
          return encode(key, options) + '[]';
        }
        return value.reduce(formatter(key), []).join('&');
      }
      return encode(key, options) + '=' + encode(value, options);
    }).filter(x => x.length > 0).join('&');
  };
  exports.parseUrl = (url, options) => {
    options = Object.assign({
      decode: true
    }, options);
    const [url_, hash] = splitOnFirst$1(url, '#');
    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };
  exports.stringifyUrl = (object, options) => {
    options = Object.assign({
      encode: true,
      strict: true,
      [encodeFragmentIdentifier]: true
    }, options);
    const url = removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = `?${queryString}`;
    }
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
  };
  exports.pick = (input, filter, options) => {
    options = Object.assign({
      parseFragmentIdentifier: true,
      [encodeFragmentIdentifier]: false
    }, options);
    const {
      url,
      query,
      fragmentIdentifier
    } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
      url,
      query: filterObject(query, filter),
      fragmentIdentifier
    }, options);
  };
  exports.exclude = (input, filter, options) => {
    const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);
    return exports.pick(input, exclusionFilter, options);
  };
})(queryString);

/**
 *  SEARCH_TYPE에 따라 다른 이동할 검색 페이지의 URL을 return합니다
 */
const getSearchURL = ({
  searchType,
  env,
  params,
  serviceType,
  locale
}) => {
  const queryParams = queryString.stringify(params);
  switch (serviceType) {
    case 'OG':
      return getGlobalSearchURL({
        searchType,
        env,
        queryParams,
        locale
      });
    case 'OK':
    default:
      return getDomesticSearchURL({
        searchType,
        env,
        queryParams
      });
  }
};
const getDomesticSearchURL = ({
  searchType,
  env,
  queryParams
}) => {
  const domain = DOMAINS[env].home;
  switch (searchType) {
    case SEARCH_TYPE.STORE:
      return `${domain}/productions/feed?${queryParams}`;
    case SEARCH_TYPE.EXPERT:
      return `${domain}/expert_users?${queryParams}`;
    case SEARCH_TYPE.TOTAL:
    default:
      return `${domain}/search/index?${queryParams}`;
  }
};
const getGlobalSearchURL = ({
  searchType,
  env,
  locale,
  queryParams
}) => {
  const domain = GLOBAL_DOMAINS[env].home;
  const country = getGlobalCountryFromLocaleString(locale);
  if (country === 'JP') {
    switch (searchType) {
      case SEARCH_TYPE.STORE:
        // 쇼핑 검색
        return `${domain}/${locale}/search/goods?${queryParams}`;
      default:
        // 통합 검색
        return `${domain}/${locale}/search?${queryParams}`;
    }
  }

  // ID/US
  return `${domain}/${locale}/search?${queryParams}`;
};

const setSearchAffectType = ({
  item,
  isAutoComplete
}) => {
  if (item.type === 'history') {
    return isAutoComplete ? 'Autohistory' : 'History';
  }
  return 'Autocomplete';
};

/**
 * '최근 검색어', '추천 검색어'를 통해 검색 후 이동할 페이지의 URL을 return합니다
 * @param {object} GetSearchTargetURLParams.item 검색할 아이템. 인터페이스는 디자인시스템 `SearchItem` 인터페이스 참고
 * @param {string} env 서비스 환경
 * @return {string} 검색 후 이동할 페이지 URL
 * */
const getSearchTargetURL = ({
  searchType,
  item,
  env,
  serviceType,
  locale,
  isAutoComplete
}) => {
  const searchItem = item.type === 'history' ? item.value : item;
  const params = {
    search_affect_type: setSearchAffectType({
      item,
      isAutoComplete
    })
  };
  if (typeof searchItem === 'string') {
    return getSearchURL({
      searchType,
      env,
      params: {
        ...params,
        query: searchItem
      },
      serviceType,
      locale
    });
  }
  switch (searchItem.type) {
    case 'query':
      {
        return getSearchURL({
          searchType,
          env,
          params: {
            ...params,
            query: searchItem.query
          },
          serviceType,
          locale
        });
      }
    case 'category':
      {
        return `${DOMAINS[env].home}/store/category?${queryString.stringify({
          category_id: searchItem.value.info.displayCategoryId,
          affect_type: 'StoreSearch',
          affect_id: 0,
          ...params
        })}`;
      }
    case 'consulting':
      {
        const [url, search] = searchItem.value.info.contentUrl.split('?');
        const query = search ? `${search}&${queryString.stringify(params)}` : queryString.stringify(params);
        return `${url}?${query}`;
      }
    case 'navigation':
      {
        if (item.type === 'history') {
          return getSearchURL({
            searchType,
            env,
            params: {
              ...params,
              query: searchItem.query
            },
            serviceType,
            locale
          });
        }
        return searchItem.value.info.deepLink;
      }
    default:
      {
        return `${DOMAINS[env].home}/search/index?${queryString.stringify({
          query: searchItem.query,
          ...params
        })}`;
      }
  }
};

const getSearchType = ({
  subdomain,
  pathname
}) => {
  const serviceType = getServiceType(subdomain, pathname);
  switch (serviceType) {
    case 'commerce':
      return SEARCH_TYPE$1.STORE;
    case 'o2o':
      return SEARCH_TYPE$1.EXPERT;
    default:
      return SEARCH_TYPE$1.TOTAL;
  }
};

const useGNBSearch = ({
  location,
  env,
  subdomain,
  hiddenSearchBar,
  serviceType = 'OK',
  autoComplete
}) => {
  const {
    locale
  } = location;
  const urlSearchParams = new URLSearchParams(location.search);
  const initialQuery = urlSearchParams.get('query');
  const {
    localeData
  } = useGNBData();
  const searchType = useMemo(() => getSearchType({
    subdomain,
    pathname: location.pathname
  }), [location.pathname, subdomain]);
  const historyStorage = useMemo(() => createSearchHistoryStorage({
    env,
    subdomain,
    serviceType
  }), [env, subdomain, serviceType]);
  const visitorId = useMemo(() => getCookie$1('b_visitor_id'), []);
  const isGlobal = checkIsGlobal({
    serviceType
  });

  /**
   * 유저가 검색시 api요청으로 응답받은 추천 자동완성 키워드 리스트를 return하는 함수
   */
  const handleFetch = useCallback(async query => {
    try {
      const response = await autoComplete({
        env,
        searchType,
        query,
        guestId: visitorId || ''
      });
      return formatAutoCompleteKeywords(response);
    } catch (error) {
      return [];
    }
  }, [env, searchType, visitorId, autoComplete]);

  /**
   * 유저가 직접 입력하여 검색하는 경우 실행하는 함수
   */
  const handleSubmit = useCallback(searchValue => {
    if (!searchValue) {
      return;
    }
    const url = getSearchURL({
      searchType,
      env,
      params: {
        query: searchValue,
        search_affect_type: 'Typing'
      },
      serviceType,
      locale
    });
    window.location.href = getURL(subdomain, env, url, serviceType);
  }, [env, searchType, serviceType, subdomain, locale]);

  /**
   * 유저가 '최근 검색어', '추천 검색어'를 클릭하는 경우 실행하는 함수
   */
  const handleSubmitItem = useCallback((item, isAutoComplete) => {
    const url = getSearchTargetURL({
      searchType,
      item,
      env,
      serviceType,
      locale,
      isAutoComplete
    });
    window.location.href = getURL(subdomain, env, url, serviceType);
  }, [searchType, env, subdomain, serviceType, locale]);
  return hiddenSearchBar ? undefined : {
    searchType,
    initialQuery: typeof initialQuery === 'string' ? initialQuery : undefined,
    historyStorage,
    onFetch: handleFetch,
    onSubmit: handleSubmit,
    onSubmitItem: handleSubmitItem,
    placeholder: isGlobal ? localeData?.search?.inputPlaceholder : undefined
  };
};

// src/AssetEllipsisBubbleSmall/AssetEllipsisBubbleSmall.tsx
var AssetEllipsisBubbleSmall = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(({
  size = "1em",
  ...props
}, ref) => {
  const _sizeW = size === "auto" ? "100%" : size;
  const _sizeH = size === "auto" ? void 0 : size;
  return /* @__PURE__ */jsxs$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _sizeW,
    height: _sizeH,
    fill: "none",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    children: [/* @__PURE__ */jsx$1("path", {
      fill: "#81D4FD",
      d: "M6.766 9.5a5.5 5.5 0 0 1 5.5-5.5h7a5.5 5.5 0 1 1 0 11h-7a5.5 5.5 0 0 1-5.5-5.5"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#C8E8F8",
      d: "M8 9a5.5 5.5 0 0 0-3.439 9.793c.264.211.439.521.439.86V22.5l3.757-2.348a1 1 0 0 1 .53-.152H15.5a5.5 5.5 0 1 0 0-11z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#47BBF5",
      d: "M13.677 14.5a5.75 5.75 0 0 0 0 11.5h6.763a1 1 0 0 1 .53.152l2.498 1.561a.3.3 0 0 0 .459-.254v-1.564c0-.366.204-.697.506-.905a5.75 5.75 0 0 0-3.256-10.49z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#fff",
      d: "M18.677 20.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M14.427 20.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M22.927 20.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
    })]
  });
}));
var AssetFaceSmilingSafetyHelmetAndStarSmall = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(({
  size = "1em",
  ...props
}, ref) => {
  const _sizeW = size === "auto" ? "100%" : size;
  const _sizeH = size === "auto" ? void 0 : size;
  return /* @__PURE__ */jsxs$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _sizeW,
    height: _sizeH,
    fill: "none",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    children: [/* @__PURE__ */jsx$1("path", {
      fill: "#FFC9B2",
      d: "M8.54 19.804a2.17 2.17 0 1 1-4.34 0 2.17 2.17 0 0 1 4.34 0M25.864 19.804a2.17 2.17 0 1 1-4.341 0 2.17 2.17 0 0 1 4.34 0"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#FFC9B3",
      fillRule: "evenodd",
      d: "M7.645 14.572a9.3 9.3 0 0 0-.967 4.177c0 4.833 3.52 8.75 8.353 8.75s8.354-3.917 8.354-8.75a9.3 9.3 0 0 0-.967-4.177z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsx$1("mask", {
      id: "face-smiling-safety-helmet-and-star-small_svg__a",
      width: 18,
      height: 14,
      x: 6,
      y: 14,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "alpha"
      },
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#FFC9B2",
        d: "M7.645 14.572a9.3 9.3 0 0 0-.967 4.177c0 4.833 3.52 8.75 8.353 8.75s8.354-3.917 8.354-8.75a9.3 9.3 0 0 0-.967-4.177z"
      })
    }), /* @__PURE__ */jsx$1("g", {
      mask: "url(#face-smiling-safety-helmet-and-star-small_svg__a)",
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#424242",
        d: "m7.236 18.894-.458 1.22L5.91 14.9h18.243l-.868 5.213-.458-1.22a3.475 3.475 0 0 0-3.254-2.255H10.49a3.475 3.475 0 0 0-3.254 2.255"
      })
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#424242",
      d: "M17.816 19.588a.88.88 0 1 1-1.758 0 .88.88 0 0 1 1.758 0M14.005 19.588a.88.88 0 1 1-1.758 0 .88.88 0 0 1 1.758 0"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#F16C6C",
      d: "M15.032 23.273a2.09 2.09 0 0 0 2.025-1.579c.07-.275-.167-.51-.452-.51h-3.147c-.284 0-.521.235-.452.51a2.09 2.09 0 0 0 2.025 1.58"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#FC8959",
      d: "M4.85 15.865c0-.9.73-1.63 1.63-1.63h17.103c.9 0 1.63.73 1.63 1.63v.325c0 .72-.584 1.304-1.304 1.304H6.154c-.72 0-1.303-.584-1.303-1.303z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#FC8959",
      fillRule: "evenodd",
      d: "M12.5 6.857c0-.294.18-.558.452-.667a5.75 5.75 0 0 1 4.268 0 .72.72 0 0 1 .451.647v3.154a.776.776 0 1 0 1.552 0V7.748c3.065 1.354 5.17 4.165 5.17 7.414H5.779c0-3.249 2.106-6.06 5.17-7.414v2.243a.776.776 0 0 0 1.552 0V6.857",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#FFB339",
      fillRule: "evenodd",
      d: "M23.094 2.889a.656.656 0 0 1 1.198 0l.437.98c.01.024.033.04.059.043l1.067.113c.564.06.792.759.37 1.139l-.797.718a.07.07 0 0 0-.023.07l.223 1.05a.656.656 0 0 1-.969.704l-.93-.537a.07.07 0 0 0-.072 0l-.93.537a.656.656 0 0 1-.97-.704l.223-1.05a.07.07 0 0 0-.022-.07l-.798-.718a.656.656 0 0 1 .37-1.14l1.068-.112a.07.07 0 0 0 .059-.043z",
      clipRule: "evenodd"
    })]
  });
}));
var AssetHouseAndMagnifyingGlassSmall = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(({
  size = "1em",
  ...props
}, ref) => {
  const _sizeW = size === "auto" ? "100%" : size;
  const _sizeH = size === "auto" ? void 0 : size;
  return /* @__PURE__ */jsxs$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _sizeW,
    height: _sizeH,
    fill: "none",
    viewBox: "0 0 30 31",
    ref,
    ...props,
    children: [/* @__PURE__ */jsx$1("path", {
      fill: "#81D4FD",
      d: "M13.16 4.406 22.573 9.5a.38.38 0 0 1 .198.334v2.655c0 4.377-.79 8.217-2.335 12.312a.475.475 0 0 1-.444.307H7.903c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-9.11c0-.578 0-.867.087-1.123.077-.226.203-.432.368-.605.187-.194.444-.327.957-.593z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#fff",
      d: "M14.858 12.7v-1.754a1.837 1.837 0 0 0-3.673 0V12.7c0 .225.182.408.408.408h2.857a.41.41 0 0 0 .408-.408"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#075B9F",
      fillRule: "evenodd",
      d: "M12.606 2.614a.82.82 0 0 1 .832 0L23.689 8.69a.41.41 0 0 1 .142.561l-.81 1.35a.41.41 0 0 1-.549.146l-9.051-5.068a.82.82 0 0 0-.798 0L3.57 10.746a.41.41 0 0 1-.55-.146l-.809-1.35a.41.41 0 0 1 .142-.561z",
      clipRule: "evenodd"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#074171",
      d: "M26.75 15.172a7 7 0 1 1-12.124 7 7 7 0 0 1 12.124-7M23.364 27.307a1 1 0 0 1 .366-1.366l1.732-1a1 1 0 0 1 1.366.366l1.175 2.035a1.5 1.5 0 0 1-.55 2.049l-.865.5a1.5 1.5 0 0 1-2.05-.55z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#074171",
      d: "m23.23 25.076 1.732-1 .766 1.326-1.732 1z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#fff",
      d: "M25.018 16.171a5 5 0 1 1-8.66 5 5 5 0 0 1 8.66-5"
    }), /* @__PURE__ */jsx$1("mask", {
      id: "house-and-magnifying-glass-small_svg__a",
      width: 11,
      height: 11,
      x: 15,
      y: 13,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "alpha"
      },
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#fff",
        d: "M25.018 16.171a5 5 0 1 1-8.66 5 5 5 0 0 1 8.66-5"
      })
    }), /* @__PURE__ */jsx$1("g", {
      mask: "url(#house-and-magnifying-glass-small_svg__a)",
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#C8E8F8",
        d: "M15 9.11h9v8.5a3.5 3.5 0 0 1-3.5 3.5H15z"
      })
    })]
  });
}));
var AssetPhotoRoomSmall = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(({
  size = "1em",
  ...props
}, ref) => {
  const _sizeW = size === "auto" ? "100%" : size;
  const _sizeH = size === "auto" ? void 0 : size;
  return /* @__PURE__ */jsxs$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _sizeW,
    height: _sizeH,
    fill: "none",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    children: [/* @__PURE__ */jsx$1("path", {
      fill: "#CCC",
      d: "M3 5.84a2.563 2.563 0 0 1 2.331-2.552 107 107 0 0 1 19.338 0A2.563 2.563 0 0 1 27 5.841V24.5a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#fff",
      d: "M5.5 6.884c0-.454.34-.836.79-.889a74.6 74.6 0 0 1 17.42 0c.45.053.79.435.79.889v15.645a2 2 0 0 1-2 2h-15a2 2 0 0 1-2-2z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#FFD0BC",
      d: "M6.75 7.933c0-.348.258-.642.603-.688a57.9 57.9 0 0 1 15.294 0c.345.046.603.34.603.688v13.842a1.5 1.5 0 0 1-1.5 1.5H8.25a1.5 1.5 0 0 1-1.5-1.5z"
    }), /* @__PURE__ */jsx$1("mask", {
      id: "photo-room-small_svg__a",
      width: 20,
      height: 8,
      x: 5,
      y: 16,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "alpha"
      },
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#1C4F6C",
        d: "M5 16.86 25 19v4.5H5z"
      })
    }), /* @__PURE__ */jsx$1("g", {
      mask: "url(#photo-room-small_svg__a)",
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#D1764F",
        d: "M6.75 7.933c0-.348.258-.642.603-.688a57.9 57.9 0 0 1 15.294 0c.345.046.603.34.603.688v13.842a1.5 1.5 0 0 1-1.5 1.5H8.25a1.5 1.5 0 0 1-1.5-1.5z"
      })
    }), /* @__PURE__ */jsx$1("mask", {
      id: "photo-room-small_svg__b",
      width: 6,
      height: 16,
      x: 5,
      y: 6,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "alpha"
      },
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#14AAFF",
        d: "M11 6v11.5L5.5 22 5 6z"
      })
    }), /* @__PURE__ */jsx$1("g", {
      mask: "url(#photo-room-small_svg__b)",
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#9A5030",
        d: "M6.75 7.933c0-.348.258-.642.603-.688a57.9 57.9 0 0 1 15.294 0c.345.046.603.34.603.688v13.842a1.5 1.5 0 0 1-1.5 1.5H8.25a1.5 1.5 0 0 1-1.5-1.5z"
      })
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#fff",
      d: "M14.063 8.95c0-.11.089-.19.198-.18l2.851.3c.11.012.2.111.2.221v2.4c0 .11-.09.191-.2.18l-2.85-.3a.23.23 0 0 1-.2-.221zM14.063 12.15c0-.11.089-.19.198-.18l2.851.3c.11.012.2.111.2.221v2.4c0 .11-.09.191-.2.18l-2.85-.3a.23.23 0 0 1-.2-.221zM17.776 9.34c0-.11.089-.19.198-.179l2.852.3c.11.011.198.11.198.22v2.4c0 .111-.089.191-.198.18l-2.852-.3a.23.23 0 0 1-.198-.22zM17.776 12.54c0-.11.089-.19.198-.179l2.852.3c.11.011.198.11.198.22v2.4c0 .111-.089.191-.198.18l-2.852-.3a.23.23 0 0 1-.198-.22z"
    })]
  });
}));
var AssetStarSmall = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(({
  size = "1em",
  ...props
}, ref) => {
  const _sizeW = size === "auto" ? "100%" : size;
  const _sizeH = size === "auto" ? void 0 : size;
  return /* @__PURE__ */jsx$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _sizeW,
    height: _sizeH,
    fill: "none",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    children: /* @__PURE__ */jsx$1("path", {
      fill: "#FFB339",
      fillRule: "evenodd",
      d: "M12.605 6.374c.924-2.073 3.866-2.073 4.79 0l1.749 3.922c.042.095.132.16.235.171l4.27.451c2.258.238 3.167 3.037 1.48 4.556l-3.19 2.875a.29.29 0 0 0-.09.277l.892 4.2c.47 2.22-1.91 3.95-3.876 2.816l-3.72-2.145a.29.29 0 0 0-.29 0l-3.72 2.145c-1.966 1.134-4.347-.595-3.876-2.816l.891-4.2a.29.29 0 0 0-.09-.277l-3.19-2.875c-1.686-1.52-.777-4.318 1.48-4.556l4.27-.45a.29.29 0 0 0 .237-.172z",
      clipRule: "evenodd"
    })
  });
}));
var AssetTextNoteAndPencilSmall = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(({
  size = "1em",
  ...props
}, ref) => {
  const _sizeW = size === "auto" ? "100%" : size;
  const _sizeH = size === "auto" ? void 0 : size;
  return /* @__PURE__ */jsxs$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _sizeW,
    height: _sizeH,
    fill: "none",
    viewBox: "0 0 30 30",
    ref,
    ...props,
    children: [/* @__PURE__ */jsx$1("path", {
      fill: "#CDCDFA",
      d: "M4.066 8.5a3.5 3.5 0 0 1 3.5-3.5h15a3.5 3.5 0 0 1 3.5 3.5v15a3.5 3.5 0 0 1-3.5 3.5h-15a3.5 3.5 0 0 1-3.5-3.5z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#0C2737",
      d: "M13.37 4.063a1.562 1.562 0 1 1 3.125 0v1.875a1.563 1.563 0 0 1-3.125 0zM8.33 4.063a1.563 1.563 0 0 1 3.126 0v1.875a1.562 1.562 0 1 1-3.125 0zM18.33 4.063a1.563 1.563 0 0 1 3.126 0v1.875a1.562 1.562 0 1 1-3.125 0z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#F4F4FF",
      d: "M7.102 14a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1M7.102 10.938a1 1 0 0 1 1-1h7.5a1 1 0 0 1 0 2h-7.5a1 1 0 0 1-1-1"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#6363D1",
      d: "m16.817 18.985 5.697-3.289 5.25 9.093a1.5 1.5 0 0 1-.549 2.05l-3.099 1.789a1.5 1.5 0 0 1-2.049-.55z"
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#F4F4FF",
      d: "m16.792 13.406.025 5.58 5.697-3.29-4.82-2.812a.6.6 0 0 0-.902.521"
    }), /* @__PURE__ */jsx$1("mask", {
      id: "text-note-and-pencil-small_svg__a",
      width: 7,
      height: 7,
      x: 16,
      y: 12,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "alpha"
      },
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#CDCDFA",
        d: "m16.792 13.406.025 5.58 5.697-3.29-4.82-2.812a.6.6 0 0 0-.902.521"
      })
    }), /* @__PURE__ */jsx$1("g", {
      mask: "url(#text-note-and-pencil-small_svg__a)",
      children: /* @__PURE__ */jsx$1("path", {
        fill: "#0C2737",
        d: "M14.093 12.012 18 9.756l2.256 3.907-3.907 2.255z"
      })
    }), /* @__PURE__ */jsx$1("path", {
      fill: "#CDCDFA",
      d: "m20.396 25.184 5.697-3.29 1.028 1.78-5.697 3.29z"
    })]
  });
}));

const GNBIcon = ({
  size = 24,
  name,
  ...props
}) => {
  return jsx(Icon$2, {
    ...props,
    size: size,
    name: name
  });
};
const GNBImage = ({
  width = 80,
  height = 80,
  alt = '',
  url
}) => {
  return jsx("img", {
    src: url,
    width: width,
    height: height,
    alt: alt
  });
};
const GNBSVG = ({
  name
}) => {
  switch (name) {
    case 'photo':
      return jsx(AssetPhotoRoomSmall, {});
    case 'project':
      return jsx(AssetHouseAndMagnifyingGlassSmall, {});
    case 'advice':
      return jsx(AssetTextNoteAndPencilSmall, {});
    case 'production':
      return jsx(AssetStarSmall, {});
    case 'remodeling':
      return jsx(AssetFaceSmilingSafetyHelmetAndStarSmall, {});
    case 'community':
      return jsx(AssetEllipsisBubbleSmall, {});
    default:
      return null;
  }
};

/**
 * type에 따라 디자인 시스템 Icon | SVG Icon | 이미지를 생성합니다.
 * @param media
 * @returns 디자인 시스템 Icon | SVG Icon | 이미지
 */
const createMedia = media => {
  switch (media.type) {
    case 'icon':
      {
        return jsx(GNBIcon, {
          ...media
        });
      }
    case 'image':
      {
        return jsx(GNBImage, {
          ...media
        });
      }
    case 'svg':
      {
        return jsx(GNBSVG, {
          ...media
        });
      }
    default:
      return null;
  }
};

/**
 * GNB의 메뉴 스키마를 생성합니다. level1 ~ level3까지 모든 메뉴를 생성합니다.
 * design-system Navigation을 warpping한 구조입니다.
 */
const createMenuSchema = ({
  menus,
  location
}) => {
  const createMenu = menu => {
    if (!menu) {
      return null;
    }
    const {
      title,
      href,
      matches,
      media,
      items,
      log,
      custom
    } = menu;
    const localePath = location.locale ? `/${location.locale}` : '';
    const currentURL = location.origin + localePath + location.pathname + location.search + location.hash;
    const active = matches.map(match => new RegExp(match)).some(regExp => regExp.test(currentURL));
    const entries = items?.map(item => createMenu(item)).filter(Boolean);
    const scrollableProps = custom === 'noScrollableEntries' ? {
      scrollableEntries: false
    } : {};
    return {
      title,
      href,
      icon: media && createMedia(media),
      entries: custom === 'store' ? entries.map(entry => ({
        ...entry,
        icon: null
      })) : entries,
      active,
      logId: log?.id,
      renderBarChild: custom === 'store' ? () => jsx(StoreCategory, {
        categories: entries
      }) : undefined,
      ...scrollableProps
    };
  };
  return menus.map(menu => createMenu(menu)).filter(Boolean);
};

/**
 * store: 쇼핑 > 카테고리 메뉴 하위로 tertinary menus를 보여줍니다.
 * noScrollableEntries: menu의 entries를 scroll UI가 아닌 별도의 UI로 보여줍니다.
 */

const SHORTCUT_TYPE = {
  cart: 'cart',
  cs: 'cs',
  notification: 'notification',
  scrap: 'scrap',
  seller: 'seller',
  signin: 'signin',
  signup: 'signup'
};

/**
 * 신규 /api/navigation API에 추가 정의된 response 타입
 * @see {@link https://docs.google.com/document/d/1LE9v_LcjKgnxiVOGjxXiG_q75dFpb_6pKnEJR2_yryI#heading=h.qofnrodkae26 웹 네비게이션 모듈화 BFF API }
 */

/** 유저 프로필 클릭 시 나오는 유저 메뉴를 create합니다. */
const createUserMenus = ({
  userMenus,
  onSignout,
  onContact
}) => {
  return userMenus.map(({
    title,
    href,
    position,
    showOn,
    action,
    bullet,
    log
  }) => {
    let onClick;
    if (action === 'signout') {
      onClick = onSignout;
    }
    if (action === 'contact') {
      onClick = onContact;
    }
    return {
      type: position,
      showOn,
      title,
      href: action === 'contact' ? undefined : href,
      bullet,
      onClick,
      logId: log?.id
    };
  });
};
/** 검색과 유저 프로필 사이에 있는 아이콘 메뉴를 create합니다. */
const createShortcuts = ({
  supplementary,
  user,
  subdomain,
  env,
  location,
  serviceType,
  onContact
}) => {
  const localePath = location.locale ? `/${location.locale}` : '';
  const url = [location.origin, localePath, location.pathname, location.search, location.hash].join('');
  const shortcuts = Object.entries(supplementary).reduce((prev, [key, value]) => {
    if (!Object.keys(SHORTCUT_TYPE).includes(key)) {
      return prev;
    }
    if (value?.action === 'contact') {
      return {
        ...prev,
        contact: {
          title: value?.title,
          href: null,
          onClick: onContact
        }
      };
    }
    return {
      ...prev,
      [key]: {
        title: value?.title,
        count: value?.count,
        href: value?.action === 'signin' ? getLoginURL(user, subdomain, env, url, serviceType, location.locale) : value?.href
      }
    };
  }, {});
  return shortcuts;
};
/** 글쓰기 버튼 클릭시 나오는 업로드 메뉴를 create합니다. */
const createUploadMenuLinks = uploadLinks => {
  return uploadLinks.map(({
    title,
    subtitle,
    href,
    media,
    log
  }) => {
    return {
      title,
      subtitle,
      href,
      icon: createMedia(media),
      logId: log?.id
    };
  });
};

/** 로그인 유저의 정보를 통해 유저 프로필 data를 create합니다. */
const createUserProfile = user => {
  if (!user) {
    return undefined;
  }
  return {
    userId: user.id,
    imageUrl: user.profileImageUrl,
    nickname: user.nickname,
    userableType: user.userableType
  };
};
const createSupplementary = ({
  user,
  supplementary,
  subdomain,
  env,
  location,
  serviceType,
  onSignout,
  onContact,
  secondaryRight
}) => {
  const userProfile = createUserProfile(user);
  const userMenus = createUserMenus({
    userMenus: supplementary.userMenus,
    onSignout,
    onContact
  });
  const uploadMenuLinks = createUploadMenuLinks(supplementary.uploads);
  const shortcuts = createShortcuts({
    supplementary,
    user,
    subdomain,
    env,
    location,
    serviceType,
    onContact
  });
  const showChangeLocaleButton = checkIsGlobal({
    serviceType
  });
  return {
    ...shortcuts,
    userProfile,
    userMenu: userMenus,
    uploadMenuLinks,
    secondaryRight,
    showChangeLocaleButton
  };
};

/**
 * 원하는 도메인에 대하여 fallback 메뉴를 생성합니다.
 */
const createFallbackMenuSchema = ({
  subdomain,
  searchMenus,
  location
}) => {
  const currentURLSearchParams = new URLSearchParams(location.search);
  const newURLSearchParams = new URLSearchParams();
  const queryParam = currentURLSearchParams.get('query');
  if (queryParam) {
    newURLSearchParams.set('query', queryParam);
  }
  const searchAffectTypeParam = currentURLSearchParams.get('search_affect_type');
  if (searchAffectTypeParam) {
    newURLSearchParams.set('search_affect_type', searchAffectTypeParam);
  }
  const suggestParam = currentURLSearchParams.get('suggest');
  if (suggestParam) {
    newURLSearchParams.set('suggest', suggestParam);
  }
  const search = newURLSearchParams.size === 0 ? '' : `?${newURLSearchParams.toString()}`;
  const searchMenuSchema = createMenuSchema({
    menus: searchMenus,
    location
  }).map(menu => {
    return {
      ...menu,
      active: !!queryParam && menu.active,
      href: `${menu.href}${search}`
    };
  });
  const getFallbackMenuSchema = () => {
    switch (subdomain) {
      case 'home':
        return searchMenuSchema;
      default:
        return [];
    }
  };
  return getFallbackMenuSchema();
};

const GNBInner = ({
  linkComponent,
  location,
  getDeepLink,
  env,
  logo,
  menus = [],
  supplementary = {
    userMenus: [],
    uploads: []
  },
  searchMenus = [],
  user,
  subdomain,
  secondaryRight,
  trendingKeywords,
  hiddenSearchBar = false,
  serviceType = 'OK',
  localeData,
  signOut = defaultSignOut,
  autoComplete = getDomesticAutoCompleteKeywords
}) => {
  const isGlobal = checkIsGlobal({
    serviceType
  });
  const {
    open
  } = useSnackbar();
  const handleSignout = useCallback(async () => {
    try {
      const data = await signOut({
        user,
        env
      });
      if (data.success) {
        signoutAirbridge();
        logAmplitude$1('계정 Logout');
        const url = isGlobal ? `${GLOBAL_DOMAINS[env].home}/${location.locale}` : DOMAINS[env].home;
        window.location.href = getURL(subdomain, env, url, serviceType);
      }
    } catch (e) {
      open({
        content: localeData?.failSignout ?? '로그아웃에 실패했습니다. 잠시 후 다시 시도해 주세요.'
      });
    }
  }, [signOut, user, env, isGlobal, subdomain, serviceType, open, localeData?.failSignout, location.locale]);
  const handleContact = useCallback(() => {
    const localePath = location.locale ? `/${location.locale}` : '';
    const url = [location.origin, localePath, location.pathname, location.search, location.hash].join('');
    ChannelTalk.startContact({
      isLoggedIn: Boolean(user),
      serviceCountry: serviceType === 'OG' ? getGlobalCountryFromLocaleString(location.locale) : 'KR',
      moveToLoginPage: () => {
        window.location.href = getLoginURL(user, subdomain, env, url, serviceType, location.locale);
      },
      onError: () => {
        open({
          content: localeData?.failContact ?? 'インターネット接続が不安定です'
        });
        q({
          type: 'SNACKBAR',
          id: 'ERROR_HELP_CENTER'
        });
      }
    });
  }, [user, serviceType, location.locale, env, location.hash, location.origin, location.pathname, location.search, subdomain, localeData?.failContact, open]);
  const searchOptions = useGNBSearch({
    location,
    env,
    subdomain,
    hiddenSearchBar,
    serviceType,
    autoComplete
  });
  const menuSchema = useMemo(() => createMenuSchema({
    menus,
    location
  }), [menus, location]);
  const fallbackMenuSchema = useMemo(() => createFallbackMenuSchema({
    subdomain,
    searchMenus,
    location
  }), [subdomain, searchMenus, location]);
  const supplementarySchema = createSupplementary({
    user,
    supplementary,
    subdomain,
    env,
    location,
    serviceType,
    secondaryRight: secondaryRight ?? (() => {
      if (searchOptions == null) {
        return null;
      }
      if (trendingKeywords == null || trendingKeywords.length < 1) {
        return null;
      }
      return jsx(TrendingKeywordsDropdown, {
        entries: trendingKeywords,
        linkComponent: linkComponent,
        baseUrl: DOMAINS[env].home
      });
    }),
    onSignout: handleSignout,
    onContact: handleContact
  });
  const handleLog = useCallback(({
    key,
    category,
    params
  }) => {
    const logData = TYPE_MAP[key](params || {})[category];
    const {
      bucket,
      amplitude
    } = logData || {};
    if (bucket) {
      switch (category) {
        case 'impression':
          {
            bucketImpressionLog(bucket);
            break;
          }
        case 'click':
        default:
          {
            bucketClickLog(bucket);
            break;
          }
      }
    }
    if (amplitude) {
      const {
        type,
        data
      } = amplitude;
      logAmplitude$1(`${type}`, data);
    }
  }, []);
  const handleAppDownload = useCallback(() => {
    window.location.href = getDeepLink({
      sub_id_1: 'web_left_bnr'
    });
  }, [getDeepLink]);
  const defaultLogo = useMemo(() => ({
    href: getURL(subdomain, env, DOMAINS[env].home, serviceType)
  }), [env, subdomain, serviceType]);
  return jsx(Navigation, {
    menuSchema: menuSchema,
    searchOptions: searchOptions,
    supplementary: supplementarySchema,
    linkComponent: linkComponent,
    fallbackMenuSchema: fallbackMenuSchema,
    onLog: handleLog,
    onAppDownload: handleAppDownload,
    location: location,
    logo: logo ?? defaultLogo
  });
};
const GNB = ({
  ...params
}) => {
  return jsx(GNBDataProvider, {
    value: {
      isGlobal: checkIsGlobal({
        serviceType: params.serviceType
      }),
      location: params.location,
      localeData: params.localeData
    },
    children: jsx(GNBInner, {
      ...params
    })
  });
};

const ShareHandlerContext = /*#__PURE__*/createContext(undefined);
function ShareHandlerProvider({
  children,
  value
}) {
  return jsx(ShareHandlerContext.Provider, {
    value: value,
    children: children
  });
}
function useShareHandler() {
  return useContext(ShareHandlerContext);
}

const ShareButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e1ftxrf30"
} : {
  target: "e1ftxrf30",
  label: "ShareButton"
})(RESET_BUTTON, ";width:", pxToRem(40), ";height:", pxToRem(40), ";margin:0 ", pxToRem(6), ";");
ShareButton.withComponent('a', process.env.NODE_ENV === "production" ? {
  target: "e1ftxrf31"
} : {
  target: "e1ftxrf31",
  label: "ShareAnchor"
});

var _circle$1, _path$1, _path2$1;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgIcShareUrl = function SvgIcShareUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAEDEF"
  })), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25 20.65H15v-1.3h10z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.35 20A4.65 4.65 0 0 1 15 15.35h3v1.3h-3a3.35 3.35 0 1 0 0 6.7h3v1.3h-3A4.65 4.65 0 0 1 10.35 20M29.65 20A4.65 4.65 0 0 0 25 15.35h-3v1.3h3a3.35 3.35 0 1 1 0 6.7h-3v1.3h3A4.65 4.65 0 0 0 29.65 20"
  })));
};
var UrlIcon = SvgIcShareUrl;

const isAndroid13OrAbove = cookie => {
  const parsedCookie = O(cookie);
  const bpPType = parsedCookie['bp-p-type'];
  const bpPVersion = parsedCookie['bp-p-ver'];
  if (bpPType === 'mWebAndroid') {
    const version = bpPVersion.split(', ').find(item => item.includes('Android'))?.split(' ')?.[1];
    return version != null && parseInt(version, 10) >= 13;
  }
  return bpPType === 'Android' && parseInt(bpPVersion, 10) >= 13;
};
function UrlCopyButton(props) {
  const {
    url,
    onShare,
    onError,
    localeData
  } = props;
  const snackbar = useSnackbar();
  const shareHandler = useShareHandler();
  const handleClick = useCallback(async () => {
    try {
      if (!url) {
        return onError?.(new Error('No URL provided to copy'));
      }
      await copyTextToClipboard(url);
      onShare?.(ShareType.URL_COPY);
      shareHandler?.(ShareType.URL_COPY);
      if (isAndroid13OrAbove(document.cookie)) {
        return;
      }
      snackbar.open({
        content: localeData?.clipboardSuccess ?? '클립보드에 복사되었습니다.'
      });
    } catch (err) {
      console.error(err);
      if (isAndroid13OrAbove(document.cookie)) {
        return;
      }
      snackbar.open({
        content: localeData?.clipboardFail ?? '클립보드 복사에 실패했습니다.'
      });
      onError?.(err);
    }
  }, [url, onShare, shareHandler, snackbar, localeData?.clipboardSuccess, localeData?.clipboardFail, onError]);
  return jsx(ShareButton, {
    type: "button",
    onClick: handleClick,
    children: jsx(UrlIcon, {
      "aria-label": "\uC8FC\uC18C \uBCF5\uC0AC"
    })
  });
}

var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgIcShareKakaotalk = function SvgIcShareKakaotalk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F9E000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#371C1D",
    d: "m17.095 18.06.75 2.13h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#371C1D",
    fillRule: "evenodd",
    d: "M6.842 19.253C6.842 13.591 12.664 9 19.846 9s13.003 4.59 13.003 10.253-5.821 10.253-13.003 10.253q-1.184-.001-2.31-.161c-.75.529-5.086 3.574-5.495 3.63 0 0-.168.066-.31-.018-.143-.084-.117-.304-.117-.304.043-.294 1.124-4.026 1.323-4.713-3.661-1.814-6.095-5.026-6.095-8.687m5.064 2.863c0 .395.336.716.75.716s.75-.321.75-.716v-4.457h1.17c.407 0 .737-.33.737-.735a.736.736 0 0 0-.736-.734h-3.842a.736.736 0 0 0-.736.734c0 .405.33.735.736.735h1.17zm6.704.375c.072.204.312.332.625.332.164 0 .327-.036.476-.104.207-.095.406-.358.178-1.067l-1.794-4.721c-.127-.36-.51-.73-1-.741-.49.01-.873.381-1 .74l-1.794 4.724c-.228.707-.03.97.177 1.065.15.068.313.104.477.104.313 0 .552-.127.624-.331l.372-.974h2.288zm1.767-.456c0 .38.323.688.719.688h2.407c.396 0 .719-.309.719-.688s-.323-.688-.719-.688h-1.594V16.94a.76.76 0 0 0-.766-.75.76.76 0 0 0-.766.75zm4.137.037a.751.751 0 0 0 1.5 0v-1.637l.26-.26 1.76 2.33a.75.75 0 0 0 .6.3.74.74 0 0 0 .646-.37.75.75 0 0 0 .08-.57.7.7 0 0 0-.128-.263l-1.847-2.446 1.71-1.71a.58.58 0 0 0 .165-.457.74.74 0 0 0-.22-.475.74.74 0 0 0-.517-.222c-.16 0-.308.06-.416.167l-2.093 2.093V16.94a.751.751 0 0 0-1.5 0z",
    clipRule: "evenodd"
  })));
};
var KakaoTalkIcon = SvgIcShareKakaotalk;

function KakaoTalkButton(props) {
  const {
    kakaoApi,
    templateId,
    templateArgs,
    onShare,
    onError
  } = props;
  const snackbar = useSnackbar();
  const shareHandler = useShareHandler();
  const handleClick = useCallback(() => {
    // Use optimistic handler, ignoring an action when not ready.
    if (kakaoApi == null) {
      return;
    }
    try {
      kakaoApi?.Share.sendCustom({
        templateId,
        templateArgs: templateArgs ?? {},
        installTalk: true
      });
      onShare?.(ShareType.KAKAO_TALK);
      shareHandler?.(ShareType.KAKAO_TALK);
    } catch (err) {
      console.error(err);
      snackbar.open({
        content: '카카오톡 공유에 실패했습니다.'
      });
      onError?.(err);
    }
  }, [kakaoApi, templateId, templateArgs, onShare, shareHandler, snackbar, onError]);
  return jsx(ShareButton, {
    role: "button",
    type: "button",
    onClick: handleClick,
    children: jsx(KakaoTalkIcon, {
      "aria-label": "\uCE74\uCE74\uC624\uD1A1 \uACF5\uC720"
    })
  });
}

let ShareType = /*#__PURE__*/function (ShareType) {
  ShareType["URL_COPY"] = "urlCopy";
  ShareType["KAKAO_TALK"] = "kakaoTalk";
  return ShareType;
}({});
function SharePopper(props) {
  const {
    targetElement,
    isOpen,
    onClose,
    onShare,
    children,
    className
  } = props;
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const {
    styles,
    attributes
  } = usePopper(targetElement, popperElement, {
    placement: 'bottom',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrowElement,
        padding: 8
      }
    }]
  });
  useEffect(() => {
    const handleClickWindow = ({
      target
    }) => {
      // eslint-disable-next-line react/prop-types
      if (targetElement?.contains(target)) {
        return;
      }
      onClose?.();
    };
    const handleClose = () => onClose?.();
    window.addEventListener('scroll', handleClose);
    window.addEventListener('click', handleClickWindow);
    return () => {
      window.removeEventListener('scroll', handleClose);
      window.removeEventListener('click', handleClickWindow);
    };
  }, [targetElement, onClose]);
  return jsx(CSSTransition$1, {
    in: isOpen,
    timeout: 200,
    css: /*#__PURE__*/css("z-index:", ZINDEX$1.snackbar, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SharePopper;")),
    classNames: {
      enterActive: 'open',
      enterDone: 'open'
    },
    children: jsxs(Popper, {
      ref: setPopperElement,
      style: styles['popper'],
      ...attributes['popper'],
      children: [jsx(Arrow, {
        ref: setArrowElement,
        style: styles['arrow']
      }), jsx(Container, {
        className: className,
        children: jsx(ShareHandlerProvider, {
          value: onShare,
          children: children
        })
      })]
    })
  });
}
SharePopper.UrlCopyButton = UrlCopyButton;
SharePopper.KakaoTalkButton = KakaoTalkButton;
const Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e5zrl1f2"
} : {
  target: "e5zrl1f2",
  label: "Container"
})("display:flex;align-items:center;margin:0 ", pxToRem(-6), ";");
const Arrow = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e5zrl1f1"
} : {
  target: "e5zrl1f1",
  label: "Arrow"
})("border:", pxToRem(7), " solid transparent;");
const Popper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e5zrl1f0"
} : {
  target: "e5zrl1f0",
  label: "Popper"
})("position:relative;padding:", pxToRem(16), ";white-space:nowrap;border-radius:", pxToRem(8), ";background:", ({
  theme
}) => theme.content.base6, ";box-shadow:rgb(0 0 0 / 12%) 0 ", pxToRem(2), " ", pxToRem(16), ";opacity:0;transition:.2s opacity,.2s margin;pointer-events:none;&[data-popper-placement^='bottom']{margin-top:-10px;", Arrow, "{bottom:100%;border-bottom-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='top']{margin-top:10px;", Arrow, "{top:100%;border-top-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='right']{margin-left:10px;", Arrow, "{right:100%;border-right-color:", ({
  theme
}) => theme.content.base6, ";}}&[data-popper-placement^='left']{margin-left:-10px;", Arrow, "{left:100%;border-left-color:", ({
  theme
}) => theme.content.base6, ";}}&.open{margin:0;opacity:1;pointer-events:auto;}");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1yc9uo8",
  styles: "overflow-wrap:break-word"
} : {
  name: "14dz18q-GlobalFooter",
  styles: "overflow-wrap:break-word;label:GlobalFooter;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const GlobalFooter = ({
  menus,
  socialLinks,
  companyMenus,
  LinkComponent = 'a',
  onContact
}) => {
  const logMenuClick = ({
    text
  }) => {
    O$1({
      category: 'CLICK',
      section_id: 'FOOTER',
      type: 'TEXT',
      id: text
    });
  };
  return jsx(Box, {
    w: "100%",
    as: "footer",
    bgc: "backgroundWeak",
    css: _ref,
    children: jsx(Container$G, {
      children: jsxs(Flex, {
        direction: {
          mobile: 'column-reverse',
          laptop: 'row'
        },
        gap: {
          mobile: 48,
          laptop: 16
        },
        pt: {
          mobile: 48,
          laptop: 60
        },
        pb: 60,
        children: [jsxs(Box, {
          flex: {
            mobile: '100%',
            laptop: '282px 0 0'
          },
          children: [jsx(Box, {
            pt: 2,
            pb: 4,
            pr: 2,
            pl: 2,
            children: jsx(Logo, {})
          }), jsx(Flex, {
            direction: "row",
            wrap: "wrap",
            align: "center",
            gap: 4,
            mt: 16,
            children: companyMenus?.map((companyMenu, index) => {
              return jsxs(Fragment$1, {
                children: [index > 0 && jsx(Ellipse, {
                  w: 4,
                  h: 4,
                  bgc: "foregroundDisabled"
                }), companyMenu.action === 'contact' ? jsx("button", {
                  onClick: () => {
                    logMenuClick({
                      text: companyMenu.title
                    });
                    onContact?.();
                  },
                  type: "button",
                  children: jsx(Text$3, {
                    variant: "body14L18",
                    color: "foregroundWeak",
                    children: companyMenu.title
                  })
                }) : jsx(LinkComponent, {
                  href: companyMenu.href,
                  target: "_blank",
                  rel: "noreferrer",
                  onClick: () => {
                    logMenuClick({
                      text: companyMenu.title
                    });
                  },
                  children: jsx(Text$3, {
                    variant: "body14L18",
                    color: "foregroundWeak",
                    children: companyMenu.title
                  })
                })]
              }, companyMenu.title);
            })
          }), jsx(Flex, {
            direction: "row",
            gap: 4,
            mt: 36,
            children: socialLinks?.map(socialLink => jsx(SocialLink, {
              onClick: () => logMenuClick({
                text: socialLink.type
              }),
              size: 40,
              ...socialLink
            }, socialLink.type))
          })]
        }), jsx(Flex, {
          direction: "column",
          gap: 48,
          flex: 1,
          children: menus?.map(section => jsxs(Flex, {
            direction: "column",
            gap: 16,
            children: [jsx(Heading, {
              level: 2,
              variant: "heading20",
              weight: 600,
              color: "foreground",
              children: section.title
            }), jsx(Flex, {
              direction: {
                mobile: 'column',
                tablet: 'row'
              },
              columnGap: 4,
              rowGap: 24,
              children: section.items?.map(menu => jsxs(Flex, {
                direction: "column",
                gap: 12,
                children: [jsx(Heading, {
                  level: 3,
                  variant: "body16L24",
                  weight: 600,
                  color: "foreground",
                  children: menu.title
                }), jsx(Menu, {
                  children: menu.items?.map((item, itemIndex, items) => jsx(MenuItem, {
                    as: "li",
                    mb: itemIndex === items.length - 1 ? 0 : 8,
                    children: jsx(LinkComponent, {
                      href: item.href,
                      onClick: () => logMenuClick({
                        text: item.title
                      }),
                      children: jsx(Text$3, {
                        variant: "body14L18",
                        color: "foregroundWeak",
                        children: item.title
                      })
                    })
                  }, item.title))
                })]
              }, menu.title))
            })]
          }, section.title))
        })]
      })
    })
  });
};
const Menu = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1fn8iqs2"
} : {
  target: "e1fn8iqs2",
  label: "Menu"
})("display:grid;padding:0;grid-auto-flow:column;grid-template-rows:repeat(10, auto);grid-template-columns:repeat(auto-fit, 120px);column-gap:8px;", MEDIA_QUERY.min('laptop', `
    grid-template-rows: repeat(5, auto);
    column-gap: 12px;
  `), ";");
const MenuItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1fn8iqs1"
} : {
  target: "e1fn8iqs1",
  label: "MenuItem"
})("width:120px;margin:0;padding:0;margin-bottom:", ({
  mb
}) => mb, "px;");
const Ellipse = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "e1fn8iqs0"
} : {
  target: "e1fn8iqs0",
  label: "Ellipse"
})(process.env.NODE_ENV === "production" ? {
  name: "18wgrk7",
  styles: "border-radius:50%"
} : {
  name: "18wgrk7",
  styles: "border-radius:50%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const CRITEO_ACCOUNT = 50838;

/**
 * criteo 전역 객체를 초기화합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * initCriteo(loginUser);
 * ```
 */
const initCriteo = user => {
  if (typeof window === 'undefined') {
    return;
  }
  const _window = window;
  const ua = navigator.userAgent.toLowerCase();
  const mobile = {
    isAndroid: ua.indexOf('android') > -1,
    isIos: ua.match(/(ipad|iphone|ipod)/g)
  };
  const type = mobile.isAndroid || mobile.isIos ? 'm' : 'd';
  _window.criteo_q = _window.criteo_q || [];
  _window.criteo_q.push({
    event: 'setAccount',
    account: CRITEO_ACCOUNT
  }, {
    event: 'setEmail',
    email: user ? `${user.id}@bucketplace.net` : ''
  }, {
    event: 'setSiteType',
    type
  });
};

const PIXEL_ID = '937204509645248';

/**
 * Facebook pixel script를 로드합니다.
 * @returns {string} facebook pixel load script
 * @example
 * ```
 * <Script
 *   id="load-facebook-pixel"
 *   strategy="beforeInteractive"
 *   dangerouslySetInnerHTML={{ __html: getFacebookPixelScript() }}
 * />
 * <noscript>
 *   <img
 *     width="1"
 *     height="1"
 *     style={{ display: 'none' }}
 *     src="https://www.facebook.com/tr?id=937204509645248&ev=PageView&noscript=1"
 *   />
 * </noscript>
 * ```
 */
const getFacebookPixelScript = (pixelId = PIXEL_ID) => {
  return `
    !(function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded =!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);})(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('set', 'autoConfig', 'false', '${pixelId}');
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
  `;
};
const FacebookPixelScript = ({
  pixelId,
  ScriptComponent
}) => jsxs(Fragment, {
  children: [/*#__PURE__*/createElement(ScriptComponent ?? 'script', {
    dangerouslySetInnerHTML: {
      __html: getFacebookPixelScript(pixelId)
    }
  }), jsx("noscript", {
    children: jsx("img", {
      width: "1",
      height: "1",
      style: {
        display: 'none'
      },
      src: "https://www.facebook.com/tr?id=937204509645248&ev=PageView&noscript=1"
    })
  })]
});

/**
 * Facebook pixel log를 전송합니다.
 * @see {@link https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking}
 * @param eventName 이벤트 이름
 * @param properties 로깅할 데이터
 * @example
 * ```
 * logFacebookPixel('AddToCart', {
 *   content_name: 'name',
 *   content_type: 'product',
 *   contents: [],
 *   currentcy: 'KRW',
 * });
 * ```
 */
const logFacebookPixel = (eventName, properties) => {
  if (!window.fbq) {
    return;
  }
  window.fbq('track', eventName, properties);
};

const KAKAO_ID = '7919701595446099671';
/**
 * kakao pixel 전역 객체를 초기화합니다.
 * @example
 * ```
 * <Script
 *   src="https://t1.daumcdn.net/adfit/static/kp.js"
 *   onLoad={() => initKakaoPixel()}
 * />
 * ```
 */
const initKakaoPixel = () => {
  if (!window.kakaoPixel) {
    return;
  }
  window.kakaoPixel(KAKAO_ID).pageView();
};

const NAVER_ID = 's_2e85116be219';
const OHOUSE_URL = 'ohou.se';
/**
 * naver analytics 전역 객체를 생성합니다.
 * @example
 * ```
 * <Script
 *   src="https://wcs.naver.net/wcslog.js"
 *   onLoad={() => initNaverAnalytics()}
 *   async
 * />
 * ```
 */
const initNaverAnalycis = () => {
  if (!window || window.wcs == null) {
    return;
  }
  if (!window.wcs_add) {
    window.wcs_add = {};
  }
  window.wcs_add['wa'] = NAVER_ID;
  if (!window._nasa) {
    window._nasa = {};
  }
  window.wcs.inflow(OHOUSE_URL);
  if (window.wcs_do) {
    window.wcs_do(window._nasa);
  }
};

const DEEP_LINK_HOST = 'https://link.ohou.se/@ohouse';
const GLOBAL_DEEP_LINK_HOST = 'https://link.ohouse.com/@globalohouse';

/**
 * query 에서 제외해야하는 blacklist
 */
const QUERY_BLACKLIST = ['airbridge_referrer', 'fallback_ios', 'fallback_android', 'short_id', 'https_deeplink', 'campaign', 'ad_group', 'ad_creative', 'term', 'deeplink_url', 'fallback_desktop', 'n_media', 'n_query', 'n_rank', 'n_ad_group', 'n_ad', 'n_keyword_id', 'n_keyword', 'n_campaign_type', 'n_ad_group_type', 'NaPm', 'routing_short_id', 'content', 'sub_id_1', 'sub_id_2', 'sub_id_3', 'campaign_id', 'ad_group_id', 'ad_creative_id', 'term_id'];

/** 사용하는 utm tags */
const UTM_TAGS = ['source', 'utm_source', 'utm_campaign', 'utm_content', 'utm_media', 'utm_term', 'utm_medium', 'bp_adset', 'bp_content', 'bp_sub_id', 'bp_sub_id_1', 'bp_sub_id_2'];

/**
 * 객체의 값에서 `/{}`, `_{}`, `{}`로 감싸진 문자열을 제거합니다.
 * 제거된 결과가 빈 문자열인 경우, 리턴되는 객체에서 해당 키를 삭제합니다.
 * @param query escape 처리할 객체
 * @return escape 처리된 객체
 * @example
 * escapeBracesInQuery({ test: 'foo_{bar}' })
 * escapeBracesInQuery({ test: 'foo/{bar}' })
 * escapeBracesInQuery({ test: 'foo{bar}' })
 * { test: 'foo' }
 * escapeBracesInQuery({ test: '{foo}' })
 * {}
 * ```
 */
const escapeBracesInQuery = query => {
  const trimmed = Object.fromEntries(Object.entries(query).map(([key, value]) => {
    return [key, value?.replace?.(/([/\\_]?{[^}]+})+/g, '')];
  }));
  return pickBy(trimmed, Boolean);
};

/**
 * sesisonStorage에서 ohsUtmData를 가져옵니다.
 * @returns UTM_TAGS가 포함된 object
 */
const getUtmData = () => {
  try {
    return JSON.parse(sessionStorage['ohsUtmData'] || '{}');
  } catch (e) {
    //
    return {};
  }
};

/**
 * NOTE This relies on document / window object. Therefore, SSR is not possible
 * with this - it's recommend to use location.href = getDeepLink() or
 * equivalent to defer retriving UTM data.
 * query에서 블랙리스트를 제외하고 utm tags 기반으로 deeplink를 생성
 * @param additionalParams 추가로 더 포함할 params
 * @param pathname pathname
 * @param query query
 * @param host 각 호스트 store.ohou.se, contents.ohou.se, o2o.ohou.se
 * @param fallbackDesktopUrl fallback url
 * @param isOwap owap 유무
 * @param isGlobal global 유무
 */
function getDeepLink({
  additionalParams,
  pathname,
  query,
  host,
  fallbackDesktopUrl,
  isOwap,
  isGlobal
} = {}) {
  const queryObj = getQuery(query ?? location.search);
  const essentialQuery = pickBy({
    ...omit(queryObj, [...UTM_TAGS, ...QUERY_BLACKLIST])
  }, value => value != null);
  const escapedQuery = escapeBracesInQuery(essentialQuery);
  const searchString = queryString.stringify(escapedQuery);
  const deepLinkPath = pathname ?? location.pathname;
  // NOTE: locale 구조 변경에 따라 앱 하위호환성을 위해 임시적으로 /en-US 등의 값을 /en 으로 바꿔줍니다.
  const path = `${convertLocaleToLanguageInPathname(deepLinkPath)}?${searchString}`;
  const utmData = getUtmData();
  const owapDeepLink = `ohouseapp://owap?url=https://${host}${path}&webviewType=page`;
  const deepLinkHost = isGlobal ? GLOBAL_DEEP_LINK_HOST : DEEP_LINK_HOST;
  const result = `${deepLinkHost}/${utmData['utm_source'] || 'web_organic'}?${queryString.stringify({
    deeplink_url: isOwap ? owapDeepLink : `${isGlobal ? 'ohouseglobalapp' : 'ohouseapp'}://${host}${path}`,
    // fallback_desktop을 공통으로 사용하려면 window.location.href 가 필요하지 않을까?
    fallback_desktop: fallbackDesktopUrl ?? window.location.href,
    campaign: queryObj['campaign'] || utmData['utm_campaign'],
    term: queryObj['term'] || utmData['utm_term'],
    client_id: te('visitor_id'),
    sub_id: queryObj['sub_id'] || utmData['bp_sub_id'],
    sub_id_1: 'ohouseWeb',
    sub_id_2: queryObj['sub_id_2'] || utmData['bp_sub_id_2'],
    sub_id_3: queryObj['sub_id_3'] || utmData['utm_medium'],
    ad_creative: queryObj['ad_creative'] || utmData['utm_content'],
    ad_group: queryObj['ad_group'] || utmData['bp_adset'],
    content: queryObj['content'] || utmData['bp_content'],
    ...(additionalParams ?? {})
  })}`;
  return result;
}
const convertLocaleToLanguageInPathname = pathname => {
  const splittedPathname = pathname.split('/');
  const localeString = splittedPathname[1] ?? '';
  if (isAllowedGlobalLocale(localeString)) {
    splittedPathname[1] = getGlobalLanguageFromLocaleString(localeString);
    return splittedPathname.join('/');
  }
  return pathname;
};

/**
 * 기존 있던 url에 query들을 연결시켜 주는 함수
 * @param url 기존 url
 * @param query 새로 붙일 query
 * @returns 연결된 url
 * @example
 * ```
 * joinLinkQuery('ohou.se/store?a=1&b=2', 'c=3&d=4')
 * ohou.se/store?a=1&b=2&c=3&d=4
 * ```
 */
const joinLinkQuery = (url, query) => {
  const pattern = /^([^?#]+)(\?[^?#]+)?(#.+?)?$/.exec(url);
  if (pattern == null) {
    return url;
  }
  const [, pathname, urlQuery, urlHash] = pattern;
  return pathname + (urlQuery ?? '') + (urlQuery != null ? '&' : '?') + query + (urlHash ?? '');
};

/**
 * 쿼리 문자열에서 utm 파라미터 객체를 추출합니다.
 * @param queryString utmData를 추출하고픈 target 쿼리 문자열
 * @return object 추출된 utm 파라미터 객체
 */
const getUtmDataFromUrl = queryString => {
  const query = getQuery(queryString ?? location.search);
  const utmQuery = pick$2(query, UTM_TAGS);
  return escapeBracesInQuery(utmQuery);
};

/**
 * 현재 url의 utmData를 추출하여 sessionStorage에 저장합니다.
 */
const setUtmData = () => {
  const urlData = getUtmDataFromUrl();
  if (isEmpty(urlData)) {
    return;
  }
  try {
    sessionStorage.setItem('ohsUtmData', JSON.stringify(urlData));
  } catch (e) {
    //
  }
};

const WP_TRACKING_ID = '47350';
const WP_TRACKING_TAG_TYPE = 'Home';
/**
 * wider planet script를 로드합니다.
 * @param user 로그인 유저 데이터
 * @example
 * ```
 * <div id="wp_tg_cts" style={{ display: 'none' }} />
 * <Script id="init-wp">
 *   { `${initWiderPlanet(navigation.loginUser)}` }
 * </Script>
 * <Script src="https://cdn-aitg.widerplanet.com/js/wp_astg_4.0.js" async />
 * ```
 */
const initWiderPlanet = user => {
  if (typeof window === 'undefined') {
    return;
  }
  window.wptg_tagscript_vars = window.wptg_tagscript_vars || [];
  window.wptg_tagscript_vars.push(() => {
    return {
      wp_hcuid: user?.id ?? '',
      ti: WP_TRACKING_ID,
      ty: WP_TRACKING_TAG_TYPE,
      device: navigator.userAgent.match(/ios|iphone|ipad|android/i) ? 'mobile' : 'web'
    };
  });
};

/**
 * 버킷로그 전역 객체를 초기화합니다.
 * 유저 정보가 있으면 버킷로그 데이터 큐에 유저 아이디를 넣습니다.
 * @param {User} user 로그인 유저 데이터
 * @example
 * ```
 * initBucketLog(user)
 * ```
 */
const initBucketLog = user => {
  if (typeof window === 'undefined') {
    return;
  }
  window.bucketLog = window.bucketLog || [];
  if (user) {
    window.bucketLog.push({
      user_id: user.id
    });
  }
};

/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
  log: 'log',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error'
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
  originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
  debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
  log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
  info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
  warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
  error: originalConsoleMethods.error.bind(globalConsole, PREFIX)
};
var DOCS_ORIGIN = 'https://docs.datadoghq.com';

function catchUserErrors(fn, errorMsg) {
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    try {
      return fn.apply(void 0, args);
    } catch (err) {
      display.error(errorMsg, err);
    }
  };
}

/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
  return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
  return +num.toFixed(decimals);
}
function isPercentage(value) {
  return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
  return typeof value === 'number';
}

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
  return {
    relative: relative,
    timeStamp: getCorrectedTimeStamp(relative)
  };
}
function timeStampToClocks(timeStamp) {
  return {
    relative: getRelativeTime(timeStamp),
    timeStamp: timeStamp
  };
}
function getCorrectedTimeStamp(relativeTime) {
  var correctedOrigin = dateNow() - performance.now();
  // apply correction only for positive drift
  if (correctedOrigin > getNavigationStart()) {
    return Math.round(addDuration(correctedOrigin, relativeTime));
  }
  return getTimeStamp(relativeTime);
}
function currentDrift() {
  return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
  if (!isNumber(duration)) {
    return duration;
  }
  return round(duration * 1e6, 0);
}
function dateNow() {
  // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
  // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
  // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
  // case ourselves.
  // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
  return new Date().getTime();
}
function timeStampNow() {
  return dateNow();
}
function relativeNow() {
  return performance.now();
}
function clocksNow() {
  return {
    relative: relativeNow(),
    timeStamp: timeStampNow()
  };
}
function clocksOrigin() {
  return {
    relative: 0,
    timeStamp: getNavigationStart()
  };
}
function elapsed(start, end) {
  return end - start;
}
function addDuration(a, b) {
  return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
  return timestamp - getNavigationStart();
}
function getTimeStamp(relativeTime) {
  return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
  return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
  if (navigationStart === undefined) {
    navigationStart = performance.timing.navigationStart;
  }
  return navigationStart;
}

var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
  // Accurate bytes count computations can degrade performances when there is a lot of events to process
  if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
    return candidate.length;
  }
  if (window.TextEncoder !== undefined) {
    return new TextEncoder().encode(candidate).length;
  }
  return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
  var length = buffers.reduce(function (total, buffer) {
    return total + buffer.length;
  }, 0);
  var result = new Uint8Array(length);
  var offset = 0;
  for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
    var buffer = buffers_1[_i];
    result.set(buffer, offset);
    offset += buffer.length;
  }
  return result;
}

function includes(candidate, search) {
  return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
  if (Array.from) {
    return Array.from(arrayLike);
  }
  var array = [];
  if (arrayLike instanceof Set) {
    arrayLike.forEach(function (item) {
      return array.push(item);
    });
  } else {
    for (var i = 0; i < arrayLike.length; i++) {
      array.push(arrayLike[i]);
    }
  }
  return array;
}
function find(array, predicate) {
  for (var i = 0; i < array.length; i += 1) {
    var item = array[i];
    if (predicate(item, i)) {
      return item;
    }
  }
  return undefined;
}
function findLast(array, predicate) {
  for (var i = array.length - 1; i >= 0; i -= 1) {
    var item = array[i];
    if (predicate(item, i, array)) {
      return item;
    }
  }
  return undefined;
}
function forEach(list, callback) {
  Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
  return Object.keys(object).map(function (key) {
    return object[key];
  });
}
function objectEntries(object) {
  return Object.keys(object).map(function (key) {
    return [key, object[key]];
  });
}
function startsWith(candidate, search) {
  return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
  return candidate.slice(-search.length) === search;
}
function assign(target) {
  var toAssign = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    toAssign[_i - 1] = arguments[_i];
  }
  toAssign.forEach(function (source) {
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

function shallowClone(object) {
  return assign({}, object);
}
function objectHasValue(object, value) {
  return Object.keys(object).some(function (key) {
    return object[key] === value;
  });
}
function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
  var newObject = {};
  for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
    var key = _a[_i];
    newObject[key] = fn(object[key]);
  }
  return newObject;
}

/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
  if (typeof globalThis === 'object') {
    return globalThis;
  }
  Object.defineProperty(Object.prototype, '_dd_temp_', {
    get: function () {
      return this;
    },
    configurable: true
  });
  // @ts-ignore _dd_temp is defined using defineProperty
  var globalObject = _dd_temp_;
  // @ts-ignore _dd_temp is defined using defineProperty
  delete Object.prototype._dd_temp_;
  if (typeof globalObject !== 'object') {
    // on safari _dd_temp_ is available on window but not globally
    // fallback on other browser globals check
    if (typeof self === 'object') {
      globalObject = self;
    } else if (typeof window === 'object') {
      globalObject = window;
    } else {
      globalObject = {};
    }
  }
  return globalObject;
}

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
  var browserWindow = getGlobalObject();
  var original;
  if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
    original = target[browserWindow.Zone.__symbol__(name)];
  }
  if (!original) {
    original = target[name];
  }
  return original;
}

var __spreadArray = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
  onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
  debugMode = newDebugMode;
}
function monitor(fn) {
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return callMonitored(fn, this, arguments);
  }; // consider output type has input type
}
function callMonitored(fn, context, args) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return fn.apply(context, args);
  } catch (e) {
    displayIfDebugEnabled(e);
    if (onMonitorErrorCollected) {
      try {
        onMonitorErrorCollected(e);
      } catch (e) {
        displayIfDebugEnabled(e);
      }
    }
  }
}
function displayIfDebugEnabled() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  if (debugMode) {
    display.error.apply(display, __spreadArray(['[MONITOR]'], args, false));
  }
}

function setTimeout$1(callback, delay) {
  return getZoneJsOriginalValue(getGlobalObject(), 'setTimeout')(monitor(callback), delay);
}
function clearTimeout$1(timeoutId) {
  getZoneJsOriginalValue(getGlobalObject(), 'clearTimeout')(timeoutId);
}
function setInterval$1(callback, delay) {
  return getZoneJsOriginalValue(getGlobalObject(), 'setInterval')(monitor(callback), delay);
}
function clearInterval$1(timeoutId) {
  getZoneJsOriginalValue(getGlobalObject(), 'clearInterval')(timeoutId);
}

var Observable = /** @class */function () {
  function Observable(onFirstSubscribe) {
    this.onFirstSubscribe = onFirstSubscribe;
    this.observers = [];
  }
  Observable.prototype.subscribe = function (f) {
    var _this = this;
    this.observers.push(f);
    if (this.observers.length === 1 && this.onFirstSubscribe) {
      this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
    }
    return {
      unsubscribe: function () {
        _this.observers = _this.observers.filter(function (other) {
          return f !== other;
        });
        if (!_this.observers.length && _this.onLastUnsubscribe) {
          _this.onLastUnsubscribe();
        }
      }
    };
  };
  Observable.prototype.notify = function (data) {
    this.observers.forEach(function (observer) {
      return observer(data);
    });
  };
  return Observable;
}();
function mergeObservables() {
  var observables = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    observables[_i] = arguments[_i];
  }
  return new Observable(function (globalObservable) {
    var subscriptions = observables.map(function (observable) {
      return observable.subscribe(function (data) {
        return globalObservable.notify(data);
      });
    });
    return function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.unsubscribe();
      });
    };
  });
}

// use lodash API
function throttle(fn, wait, options) {
  var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
  var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
  var inWaitPeriod = false;
  var pendingExecutionWithParameters;
  var pendingTimeoutId;
  return {
    throttled: function () {
      var parameters = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        parameters[_i] = arguments[_i];
      }
      if (inWaitPeriod) {
        pendingExecutionWithParameters = parameters;
        return;
      }
      if (needLeadingExecution) {
        fn.apply(void 0, parameters);
      } else {
        pendingExecutionWithParameters = parameters;
      }
      inWaitPeriod = true;
      pendingTimeoutId = setTimeout$1(function () {
        if (needTrailingExecution && pendingExecutionWithParameters) {
          fn.apply(void 0, pendingExecutionWithParameters);
        }
        inWaitPeriod = false;
        pendingExecutionWithParameters = undefined;
      }, wait);
    },
    cancel: function () {
      clearTimeout$1(pendingTimeoutId);
      inWaitPeriod = false;
      pendingExecutionWithParameters = undefined;
    }
  };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
  return placeholder ?
  // eslint-disable-next-line  no-bitwise
  (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function findCommaSeparatedValue(rawString, name) {
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
    if (match) {
      if (match[1] === name) {
        return match[2];
      }
    } else {
      break;
    }
  }
}
function findCommaSeparatedValues(rawString) {
  var result = new Map();
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
    if (match) {
      result.set(match[1], match[2]);
    } else {
      break;
    }
  }
  return result;
}
function safeTruncate(candidate, length, suffix) {
  if (suffix === void 0) {
    suffix = '';
  }
  var lastChar = candidate.charCodeAt(length - 1);
  var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
  var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
  if (candidate.length <= correctedLength) {
    return candidate;
  }
  return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}

function isIE() {
  return detectBrowserCached() === 0 /* Browser.IE */;
}
function isChromium() {
  return detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function isSafari() {
  return detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserCache;
function detectBrowserCached() {
  return browserCache !== null && browserCache !== void 0 ? browserCache : browserCache = detectBrowser();
}
// Exported only for tests
function detectBrowser(browserWindow) {
  var _a;
  if (browserWindow === void 0) {
    browserWindow = window;
  }
  var userAgent = browserWindow.navigator.userAgent;
  if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
    return 1 /* Browser.CHROMIUM */;
  }
  if (
  // navigator.vendor is deprecated, but it is the most resilient way we found to detect
  // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
  // useragent test as a semi-working fallback.
  ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 || /safari/i.test(userAgent) && !/chrome|android/i.test(userAgent)) {
    return 2 /* Browser.SAFARI */;
  }
  if (browserWindow.document.documentMode) {
    return 0 /* Browser.IE */;
  }
  return 3 /* Browser.OTHER */;
}

function setCookie(name, value, expireDelay, options) {
  var date = new Date();
  date.setTime(date.getTime() + expireDelay);
  var expires = "expires=".concat(date.toUTCString());
  var sameSite = options && options.crossSite ? 'none' : 'strict';
  var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
  var secure = options && options.secure ? ';secure' : '';
  var partitioned = options && options.partitioned ? ';partitioned' : '';
  document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure).concat(partitioned);
}
function getCookie(name) {
  return findCommaSeparatedValue(document.cookie, name);
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function getInitCookie(name) {
  if (!initCookieParsed) {
    initCookieParsed = findCommaSeparatedValues(document.cookie);
  }
  return initCookieParsed.get(name);
}
function deleteCookie(name, options) {
  setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
  if (document.cookie === undefined || document.cookie === null) {
    return false;
  }
  try {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_cookie_test_".concat(generateUUID());
    var testCookieValue = 'test';
    setCookie(testCookieName, testCookieValue, ONE_MINUTE, options);
    var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
    deleteCookie(testCookieName, options);
    return isCookieCorrectlySet;
  } catch (error) {
    display.error(error);
    return false;
  }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
  if (getCurrentSiteCache === undefined) {
    // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
    // the test cookie lifetime
    var testCookieName = "dd_site_test_".concat(generateUUID());
    var testCookieValue = 'test';
    var domainLevels = window.location.hostname.split('.');
    var candidateDomain = domainLevels.pop();
    while (domainLevels.length && !getCookie(testCookieName)) {
      candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
      setCookie(testCookieName, testCookieValue, ONE_SECOND, {
        domain: candidateDomain
      });
    }
    deleteCookie(testCookieName, {
      domain: candidateDomain
    });
    getCurrentSiteCache = candidateDomain;
  }
  return getCurrentSiteCache;
}

var SESSION_STORE_KEY = '_dd_s';

var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;

var SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var EXPIRED = '1';
function getExpiredSessionState() {
  return {
    isExpired: EXPIRED
  };
}
function isSessionInNotStartedState(session) {
  return isEmptyObject(session);
}
function isSessionStarted(session) {
  return !isSessionInNotStartedState(session);
}
function isSessionInExpiredState(session) {
  return session.isExpired !== undefined || !isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function isActiveSession(sessionState) {
  // created and expire can be undefined for versions which was not storing them
  // these checks could be removed when older versions will not be available/live anymore
  return (sessionState.created === undefined || dateNow() - Number(sessionState.created) < SESSION_TIME_OUT_DELAY) && (sessionState.expire === undefined || dateNow() < Number(sessionState.expire));
}
function expandSessionState(session) {
  session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
function toSessionString(session) {
  return objectEntries(session).map(function (_a) {
    var key = _a[0],
      value = _a[1];
    return "".concat(key, "=").concat(value);
  }).join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
  var session = {};
  if (isValidSessionString(sessionString)) {
    sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
      var matches = SESSION_ENTRY_REGEXP.exec(entry);
      if (matches !== null) {
        var key = matches[1],
          value = matches[2];
        session[key] = value;
      }
    });
  }
  return session;
}
function isValidSessionString(sessionString) {
  return !!sessionString && (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString));
}

var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY$1 = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
  var sessionString = getInitCookie(SESSION_STORE_KEY);
  if (!sessionString) {
    var oldSessionId = getInitCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getInitCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getInitCookie(OLD_LOGS_COOKIE_NAME);
    var session = {};
    if (oldSessionId) {
      session.id = oldSessionId;
    }
    if (oldLogsType && /^[01]$/.test(oldLogsType)) {
      session[LOGS_SESSION_KEY] = oldLogsType;
    }
    if (oldRumType && /^[012]$/.test(oldRumType)) {
      session[RUM_SESSION_KEY$1] = oldRumType;
    }
    if (isSessionStarted(session)) {
      expandSessionState(session);
      cookieStoreStrategy.persistSession(session);
    }
  }
}

function selectCookieStrategy(initConfiguration) {
  var cookieOptions = buildCookieOptions(initConfiguration);
  return areCookiesAuthorized(cookieOptions) ? {
    type: 'Cookie',
    cookieOptions: cookieOptions
  } : undefined;
}
function initCookieStrategy(cookieOptions) {
  var cookieStore = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: isChromium(),
    persistSession: persistSessionCookie(cookieOptions),
    retrieveSession: retrieveSessionCookie,
    expireSession: function () {
      return expireSessionCookie(cookieOptions);
    }
  };
  tryOldCookiesMigration(cookieStore);
  return cookieStore;
}
function persistSessionCookie(options) {
  return function (session) {
    setCookie(SESSION_STORE_KEY, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
  };
}
function expireSessionCookie(options) {
  setCookie(SESSION_STORE_KEY, toSessionString(getExpiredSessionState()), SESSION_TIME_OUT_DELAY, options);
}
function retrieveSessionCookie() {
  var sessionString = getCookie(SESSION_STORE_KEY);
  return toSessionState(sessionString);
}
function buildCookieOptions(initConfiguration) {
  var cookieOptions = {};
  cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
  cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
  cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
  if (initConfiguration.trackSessionAcrossSubdomains) {
    cookieOptions.domain = getCurrentSite();
  }
  return cookieOptions;
}

var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
  try {
    var id = generateUUID();
    var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
    localStorage.setItem(testKey, id);
    var retrievedId = localStorage.getItem(testKey);
    localStorage.removeItem(testKey);
    return id === retrievedId ? {
      type: 'LocalStorage'
    } : undefined;
  } catch (e) {
    return undefined;
  }
}
function initLocalStorageStrategy() {
  return {
    isLockEnabled: false,
    persistSession: persistInLocalStorage,
    retrieveSession: retrieveSessionFromLocalStorage,
    expireSession: expireSessionFromLocalStorage
  };
}
function persistInLocalStorage(sessionState) {
  localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
  var sessionString = localStorage.getItem(SESSION_STORE_KEY);
  return toSessionState(sessionString);
}
function expireSessionFromLocalStorage() {
  persistInLocalStorage(getExpiredSessionState());
}

var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
  var _a;
  if (numberOfRetries === void 0) {
    numberOfRetries = 0;
  }
  var isLockEnabled = sessionStoreStrategy.isLockEnabled,
    persistSession = sessionStoreStrategy.persistSession,
    expireSession = sessionStoreStrategy.expireSession;
  var persistWithLock = function (session) {
    return persistSession(assign({}, session, {
      lock: currentLock
    }));
  };
  var retrieveStore = function () {
    var session = sessionStoreStrategy.retrieveSession();
    var lock = session.lock;
    if (session.lock) {
      delete session.lock;
    }
    return {
      session: session,
      lock: lock
    };
  };
  if (!ongoingOperations) {
    ongoingOperations = operations;
  }
  if (operations !== ongoingOperations) {
    bufferedOperations.push(operations);
    return;
  }
  if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
    next(sessionStoreStrategy);
    return;
  }
  var currentLock;
  var currentStore = retrieveStore();
  if (isLockEnabled) {
    // if someone has lock, retry later
    if (currentStore.lock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
    // acquire lock
    currentLock = generateUUID();
    persistWithLock(currentStore.session);
    // if lock is not acquired, retry later
    currentStore = retrieveStore();
    if (currentStore.lock !== currentLock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
  }
  var processedSession = operations.process(currentStore.session);
  if (isLockEnabled) {
    // if lock corrupted after process, retry later
    currentStore = retrieveStore();
    if (currentStore.lock !== currentLock) {
      retryLater(operations, sessionStoreStrategy, numberOfRetries);
      return;
    }
  }
  if (processedSession) {
    if (isSessionInExpiredState(processedSession)) {
      expireSession();
    } else {
      expandSessionState(processedSession);
      isLockEnabled ? persistWithLock(processedSession) : persistSession(processedSession);
    }
  }
  if (isLockEnabled) {
    // correctly handle lock around expiration would require to handle this case properly at several levels
    // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
    if (!(processedSession && isSessionInExpiredState(processedSession))) {
      // if lock corrupted after persist, retry later
      currentStore = retrieveStore();
      if (currentStore.lock !== currentLock) {
        retryLater(operations, sessionStoreStrategy, numberOfRetries);
        return;
      }
      persistSession(currentStore.session);
      processedSession = currentStore.session;
    }
  }
  // call after even if session is not persisted in order to perform operations on
  // up-to-date session state value => the value could have been modified by another tab
  (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentStore.session);
  next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
  setTimeout$1(function () {
    processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
  }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
  ongoingOperations = undefined;
  var nextOperations = bufferedOperations.shift();
  if (nextOperations) {
    processSessionStoreOperations(nextOperations, sessionStore);
  }
}

/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = ONE_SECOND;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
  var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
  if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
    sessionStoreStrategyType = selectLocalStorageStrategy();
  }
  return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable();
  var sessionStateUpdateObservable = new Observable();
  var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie' ? initCookieStrategy(sessionStoreStrategyType.cookieOptions) : initLocalStorageStrategy();
  var expireSession = sessionStoreStrategy.expireSession;
  var watchSessionTimeoutId = setInterval$1(watchSession, STORAGE_POLL_DELAY);
  var sessionCache;
  startSession();
  var _a = throttle(function () {
      processSessionStoreOperations({
        process: function (sessionState) {
          if (isSessionInNotStartedState(sessionState)) {
            return;
          }
          var synchronizedSession = synchronizeSession(sessionState);
          expandOrRenewSessionState(synchronizedSession);
          return synchronizedSession;
        },
        after: function (sessionState) {
          if (isSessionStarted(sessionState) && !hasSessionInCache()) {
            renewSessionInCache(sessionState);
          }
          sessionCache = sessionState;
        }
      }, sessionStoreStrategy);
    }, STORAGE_POLL_DELAY),
    throttledExpandOrRenewSession = _a.throttled,
    cancelExpandOrRenewSession = _a.cancel;
  function expandSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        return hasSessionInCache() ? synchronizeSession(sessionState) : undefined;
      }
    }, sessionStoreStrategy);
  }
  /**
   * allows two behaviors:
   * - if the session is active, synchronize the session cache without updating the session store
   * - if the session is not active, clear the session store and expire the session cache
   */
  function watchSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        return isSessionInExpiredState(sessionState) ? getExpiredSessionState() : undefined;
      },
      after: synchronizeSession
    }, sessionStoreStrategy);
  }
  function synchronizeSession(sessionState) {
    if (isSessionInExpiredState(sessionState)) {
      sessionState = getExpiredSessionState();
    }
    if (hasSessionInCache()) {
      if (isSessionInCacheOutdated(sessionState)) {
        expireSessionInCache();
      } else {
        sessionStateUpdateObservable.notify({
          previousState: sessionCache,
          newState: sessionState
        });
        sessionCache = sessionState;
      }
    }
    return sessionState;
  }
  function startSession() {
    processSessionStoreOperations({
      process: function (sessionState) {
        if (isSessionInNotStartedState(sessionState)) {
          return getExpiredSessionState();
        }
      },
      after: function (sessionState) {
        sessionCache = sessionState;
      }
    }, sessionStoreStrategy);
  }
  function expandOrRenewSessionState(sessionState) {
    if (isSessionInNotStartedState(sessionState)) {
      return false;
    }
    var _a = computeSessionState(sessionState[productKey]),
      trackingType = _a.trackingType,
      isTracked = _a.isTracked;
    sessionState[productKey] = trackingType;
    delete sessionState.isExpired;
    if (isTracked && !sessionState.id) {
      sessionState.id = generateUUID();
      sessionState.created = String(dateNow());
    }
  }
  function hasSessionInCache() {
    return sessionCache[productKey] !== undefined;
  }
  function isSessionInCacheOutdated(sessionState) {
    return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
  }
  function expireSessionInCache() {
    sessionCache = getExpiredSessionState();
    expireObservable.notify();
  }
  function renewSessionInCache(sessionState) {
    sessionCache = sessionState;
    renewObservable.notify();
  }
  function updateSessionState(partialSessionState) {
    processSessionStoreOperations({
      process: function (sessionState) {
        return assign({}, sessionState, partialSessionState);
      },
      after: synchronizeSession
    }, sessionStoreStrategy);
  }
  return {
    expandOrRenewSession: throttledExpandOrRenewSession,
    expandSession: expandSession,
    getSession: function () {
      return sessionCache;
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStateUpdateObservable,
    restartSession: startSession,
    expire: function () {
      cancelExpandOrRenewSession();
      expireSession();
      synchronizeSession(getExpiredSessionState());
    },
    stop: function () {
      clearInterval$1(watchSessionTimeoutId);
    },
    updateSessionState: updateSessionState
  };
}

var TrackingConsent = {
  GRANTED: 'granted',
  NOT_GRANTED: 'not-granted'
};
function createTrackingConsentState(currentConsent) {
  var observable = new Observable();
  return {
    tryToInit: function (trackingConsent) {
      if (!currentConsent) {
        currentConsent = trackingConsent;
      }
    },
    update: function (trackingConsent) {
      currentConsent = trackingConsent;
      observable.notify();
    },
    isGranted: function () {
      return currentConsent === TrackingConsent.GRANTED;
    },
    observable: observable
  };
}

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
  if (typeof value !== 'object' || value === null) {
    return JSON.stringify(value);
  }
  // Note: The order matter here. We need to detach toJSON methods on parent classes before their
  // subclasses.
  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
  var restoreValueToJson = detachToJsonMethod(value);
  try {
    return JSON.stringify(value, replacer, space);
  } catch (_a) {
    return '<error: unable to serialize object>';
  } finally {
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    restoreValuePrototypeToJson();
    restoreValueToJson();
  }
}
function detachToJsonMethod(value) {
  var object = value;
  var objectToJson = object.toJSON;
  if (objectToJson) {
    delete object.toJSON;
    return function () {
      object.toJSON = objectToJson;
    };
  }
  return noop;
}

function normalizeUrl(url) {
  return buildUrl(url, location.href).href;
}
function isValidUrl(url) {
  try {
    return !!buildUrl(url);
  } catch (_a) {
    return false;
  }
}
function getPathName(url) {
  var pathname = buildUrl(url).pathname;
  return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function buildUrl(url, base) {
  var supportedURL = getSupportedUrl();
  if (supportedURL) {
    try {
      return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
    } catch (error) {
      throw new Error("Failed to construct URL: ".concat(String(error), " ").concat(jsonStringify({
        url: url,
        base: base
      })));
    }
  }
  if (base === undefined && !/:/.test(url)) {
    throw new Error("Invalid URL: '".concat(url, "'"));
  }
  var doc = document;
  var anchorElement = doc.createElement('a');
  if (base !== undefined) {
    doc = document.implementation.createHTMLDocument('');
    var baseElement = doc.createElement('base');
    baseElement.href = base;
    doc.head.appendChild(baseElement);
    doc.body.appendChild(anchorElement);
  }
  anchorElement.href = url;
  return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
  if (isURLSupported === undefined) {
    try {
      var url = new originalURL('http://test/path');
      isURLSupported = url.href === 'http://test/path';
    } catch (_a) {
      isURLSupported = false;
    }
  }
  return isURLSupported ? originalURL : undefined;
}

var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
var PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';

function createEndpointBuilder(initConfiguration, trackType, configurationTags) {
  var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
  return {
    build: function (api, payload) {
      var parameters = buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
      return buildUrlWithParameters(parameters);
    },
    urlPrefix: buildUrlWithParameters(''),
    trackType: trackType
  };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
  var path = "/api/v2/".concat(trackType);
  var proxy = initConfiguration.proxy;
  if (typeof proxy === 'string') {
    var normalizedProxyUrl_1 = normalizeUrl(proxy);
    return function (parameters) {
      return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
    };
  }
  if (typeof proxy === 'function') {
    return function (parameters) {
      return proxy({
        path: path,
        parameters: parameters
      });
    };
  }
  var host = buildEndpointHost(trackType, initConfiguration);
  return function (parameters) {
    return "https://".concat(host).concat(path, "?").concat(parameters);
  };
}
function buildEndpointHost(trackType, initConfiguration) {
  var _a = initConfiguration.site,
    site = _a === void 0 ? INTAKE_SITE_US1 : _a,
    internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
  if (trackType === 'logs' && initConfiguration.usePciIntake && site === INTAKE_SITE_US1) {
    return PCI_INTAKE_HOST_US1;
  }
  if (internalAnalyticsSubdomain && site === INTAKE_SITE_US1) {
    return "".concat(internalAnalyticsSubdomain, ".").concat(INTAKE_SITE_US1);
  }
  if (site === INTAKE_SITE_FED_STAGING) {
    return "http-intake.logs.".concat(site);
  }
  var domainParts = site.split('.');
  var extension = domainParts.pop();
  return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
  var clientToken = _a.clientToken,
    internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
  var retry = _b.retry,
    encoding = _b.encoding;
  var tags = ["sdk_version:".concat("5.23.0"), "api:".concat(api)].concat(configurationTags);
  if (retry) {
    tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
  }
  var parameters = ['ddsource=browser', "ddtags=".concat(encodeURIComponent(tags.join(','))), "dd-api-key=".concat(clientToken), "dd-evp-origin-version=".concat(encodeURIComponent("5.23.0")), 'dd-evp-origin=browser', "dd-request-id=".concat(generateUUID())];
  if (encoding) {
    parameters.push("dd-evp-encoding=".concat(encoding));
  }
  if (trackType === 'rum') {
    parameters.push("batch_time=".concat(timeStampNow()));
  }
  if (internalAnalyticsSubdomain) {
    parameters.reverse();
  }
  return parameters.join('&');
}

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
  var env = configuration.env,
    service = configuration.service,
    version = configuration.version,
    datacenter = configuration.datacenter;
  var tags = [];
  if (env) {
    tags.push(buildTag('env', env));
  }
  if (service) {
    tags.push(buildTag('service', service));
  }
  if (version) {
    tags.push(buildTag('version', version));
  }
  if (datacenter) {
    tags.push(buildTag('datacenter', datacenter));
  }
  return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
  // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
  // that the backend may not follow the exact same rules, so we only want to display an informal
  // warning.
  var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
  if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
    display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized. More details: ").concat(DOCS_ORIGIN, "/getting_started/tagging/#defining-tags"));
  }
  // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
  // by forging a value containing commas.
  var sanitizedValue = rawValue.replace(/,/g, '_');
  return "".concat(key, ":").concat(sanitizedValue);
}

function computeTransportConfiguration(initConfiguration) {
  var site = initConfiguration.site || INTAKE_SITE_US1;
  var tags = buildTags(initConfiguration);
  var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
  var intakeUrlPrefixes = computeIntakeUrlPrefixes(endpointBuilders, site);
  var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
  return assign({
    isIntakeUrl: function (url) {
      return intakeUrlPrefixes.some(function (intakeEndpoint) {
        return url.indexOf(intakeEndpoint) === 0;
      });
    },
    replica: replicaConfiguration,
    site: site
  }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
  return {
    logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
    rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
    sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay', tags)
  };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
  if (!initConfiguration.replica) {
    return;
  }
  var replicaConfiguration = assign({}, initConfiguration, {
    site: INTAKE_SITE_US1,
    clientToken: initConfiguration.replica.clientToken
  });
  var replicaEndpointBuilders = {
    logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
    rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags)
  };
  intakeUrlPrefixes.push.apply(intakeUrlPrefixes, objectValues(replicaEndpointBuilders).map(function (builder) {
    return builder.urlPrefix;
  }));
  return assign({
    applicationId: initConfiguration.replica.applicationId
  }, replicaEndpointBuilders);
}
function computeIntakeUrlPrefixes(endpointBuilders, site) {
  var intakeUrlPrefixes = objectValues(endpointBuilders).map(function (builder) {
    return builder.urlPrefix;
  });
  if (site === INTAKE_SITE_US1) {
    intakeUrlPrefixes.push("https://".concat(PCI_INTAKE_HOST_US1, "/"));
  }
  return intakeUrlPrefixes;
}

var DefaultPrivacyLevel = {
  ALLOW: 'allow',
  MASK: 'mask',
  MASK_USER_INPUT: 'mask-user-input'
};
var TraceContextInjection = {
  ALL: 'all',
  SAMPLED: 'sampled'
};
function checkIfString(tag, tagName) {
  if (tag !== undefined && tag !== null && typeof tag !== 'string') {
    display.error("".concat(tagName, " must be defined as a string"));
    return false;
  }
  return true;
}
function isDatadogSite(site) {
  return /(datadog|ddog|datad0g|dd0g)/.test(site);
}
function validateAndBuildConfiguration(initConfiguration) {
  var _a, _b, _c, _d, _e;
  if (!initConfiguration || !initConfiguration.clientToken) {
    display.error('Client Token is not configured, we will not send any data.');
    return;
  }
  if (initConfiguration.sessionSampleRate !== undefined && !isPercentage(initConfiguration.sessionSampleRate)) {
    display.error('Session Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetrySampleRate !== undefined && !isPercentage(initConfiguration.telemetrySampleRate)) {
    display.error('Telemetry Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetryConfigurationSampleRate !== undefined && !isPercentage(initConfiguration.telemetryConfigurationSampleRate)) {
    display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.telemetryUsageSampleRate !== undefined && !isPercentage(initConfiguration.telemetryUsageSampleRate)) {
    display.error('Telemetry Usage Sample Rate should be a number between 0 and 100');
    return;
  }
  if (!checkIfString(initConfiguration.version, 'Version')) {
    return;
  }
  if (!checkIfString(initConfiguration.env, 'Env')) {
    return;
  }
  if (!checkIfString(initConfiguration.service, 'Service')) {
    return;
  }
  if (initConfiguration.trackingConsent !== undefined && !objectHasValue(TrackingConsent, initConfiguration.trackingConsent)) {
    display.error('Tracking Consent should be either "granted" or "not-granted"');
    return;
  }
  if (initConfiguration.site && !isDatadogSite(initConfiguration.site)) {
    display.error("Site should be a valid Datadog site. Learn more here: ".concat(DOCS_ORIGIN, "/getting_started/site/."));
    return;
  }
  return assign({
    beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
    sessionStoreStrategyType: selectSessionStoreStrategyType(initConfiguration),
    sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
    telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
    telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
    telemetryUsageSampleRate: (_d = initConfiguration.telemetryUsageSampleRate) !== null && _d !== void 0 ? _d : 5,
    service: initConfiguration.service || undefined,
    silentMultipleInit: !!initConfiguration.silentMultipleInit,
    allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
    trackingConsent: (_e = initConfiguration.trackingConsent) !== null && _e !== void 0 ? _e : TrackingConsent.GRANTED,
    storeContextsAcrossPages: !!initConfiguration.storeContextsAcrossPages,
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * ONE_KIBI_BYTE,
    eventRateLimiterThreshold: 3000,
    maxTelemetryEventsPerPage: 15,
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * ONE_SECOND,
    /**
     * Logs intake limit
     */
    batchMessagesLimit: 50,
    messageBytesLimit: 256 * ONE_KIBI_BYTE
  }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
  return {
    session_sample_rate: initConfiguration.sessionSampleRate,
    telemetry_sample_rate: initConfiguration.telemetrySampleRate,
    telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
    telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
    use_before_send: !!initConfiguration.beforeSend,
    use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
    use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
    use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
    use_proxy: !!initConfiguration.proxy,
    silent_multiple_init: initConfiguration.silentMultipleInit,
    track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
    allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
    store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
    allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
    tracking_consent: initConfiguration.trackingConsent
  };
}

/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
  ExperimentalFeature["WRITABLE_RESOURCE_GRAPHQL"] = "writable_resource_graphql";
  ExperimentalFeature["CUSTOM_VITALS"] = "custom_vitals";
  ExperimentalFeature["TOLERANT_RESOURCE_TIMINGS"] = "tolerant_resource_timings";
  ExperimentalFeature["REMOTE_CONFIGURATION"] = "remote_configuration";
  ExperimentalFeature["UPDATE_VIEW_NAME"] = "update_view_name";
  ExperimentalFeature["PLUGINS"] = "plugins";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function initFeatureFlags(enableExperimentalFeatures) {
  if (Array.isArray(enableExperimentalFeatures)) {
    addExperimentalFeatures(enableExperimentalFeatures.filter(function (flag) {
      return objectHasValue(ExperimentalFeature, flag);
    }));
  }
}
function addExperimentalFeatures(enabledFeatures) {
  enabledFeatures.forEach(function (flag) {
    enabledExperimentalFeatures.add(flag);
  });
}
function isExperimentalFeatureEnabled(featureName) {
  return enabledExperimentalFeatures.has(featureName);
}
function getExperimentalFeatures() {
  return enabledExperimentalFeatures;
}

/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */
var UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
  var stack = [];
  var stackProperty = tryToGetString(ex, 'stack');
  var exString = String(ex);
  if (stackProperty && startsWith(stackProperty, exString)) {
    stackProperty = stackProperty.slice(exString.length);
  }
  if (stackProperty) {
    stackProperty.split('\n').forEach(function (line) {
      var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
      if (stackFrame) {
        if (!stackFrame.func && stackFrame.line) {
          stackFrame.func = UNKNOWN_FUNCTION;
        }
        stack.push(stackFrame);
      }
    });
  }
  return {
    message: tryToGetString(ex, 'message'),
    name: tryToGetString(ex, 'name'),
    stack: stack
  };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
  var parts = CHROME_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
  var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
  var submatch = CHROME_EVAL_RE.exec(parts[2]);
  if (isEval && submatch) {
    // throw out eval line/column and use top-most line/column number
    parts[2] = submatch[1]; // url
    parts[3] = submatch[2]; // line
    parts[4] = submatch[3]; // column
  }
  return {
    args: isNative ? [parts[2]] : [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[3] ? +parts[3] : undefined,
    url: !isNative ? parts[2] : undefined
  };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
  var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
  if (!parts) {
    return;
  }
  return {
    args: [],
    column: parts[3] ? +parts[3] : undefined,
    func: UNKNOWN_FUNCTION,
    line: parts[2] ? +parts[2] : undefined,
    url: parts[1]
  };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
  var parts = WINJS_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  return {
    args: [],
    column: parts[4] ? +parts[4] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: +parts[3],
    url: parts[2]
  };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
  var parts = GECKO_LINE_RE.exec(line);
  if (!parts) {
    return;
  }
  var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
  var submatch = GECKO_EVAL_RE.exec(parts[3]);
  if (isEval && submatch) {
    // throw out eval line/column and use top-most line number
    parts[3] = submatch[1];
    parts[4] = submatch[2];
    parts[5] = undefined; // no column when eval
  }
  return {
    args: parts[2] ? parts[2].split(',') : [],
    column: parts[5] ? +parts[5] : undefined,
    func: parts[1] || UNKNOWN_FUNCTION,
    line: parts[4] ? +parts[4] : undefined,
    url: parts[3]
  };
}
function tryToGetString(candidate, property) {
  if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
    return undefined;
  }
  var value = candidate[property];
  return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
  var stack = [{
    url: url,
    column: column,
    line: line
  }];
  var _a = tryToParseMessage(messageObj),
    name = _a.name,
    message = _a.message;
  return {
    name: name,
    message: message,
    stack: stack
  };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
  var _a;
  var name;
  var message;
  if ({}.toString.call(messageObj) === '[object String]') {
    _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
  }
  return {
    name: name,
    message: message
  };
}

/**
 * Creates a stacktrace without SDK internal frames.
 * Constraints:
 * - Has to be called at the utmost position of the call stack.
 * - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
  /**
   * Skip the two internal frames:
   * - SDK API (console.error, ...)
   * - this function
   * in order to keep only the user calls
   */
  var internalFramesToSkip = 2;
  var error = new Error();
  var formattedStack;
  // IE needs to throw the error to fill in the stack trace
  if (!error.stack) {
    try {
      throw error;
    } catch (e) {
    }
  }
  callMonitored(function () {
    var stackTrace = computeStackTrace(error);
    stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
    formattedStack = toStackTraceString(stackTrace);
  });
  return formattedStack;
}
function toStackTraceString(stack) {
  var result = formatErrorMessage(stack);
  stack.stack.forEach(function (frame) {
    var func = frame.func === '?' ? '<anonymous>' : frame.func;
    var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
    var line = frame.line ? ":".concat(frame.line) : '';
    var column = frame.line && frame.column ? ":".concat(frame.column) : '';
    result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
  });
  return result;
}
function formatErrorMessage(stack) {
  return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}

/**
 * Instruments a method on a object, calling the given callback before the original method is
 * invoked. The callback receives an object with information about the method call.
 *
 * This function makes sure that we are "good citizens" regarding third party instrumentations: when
 * removing the instrumentation, the original method is usually restored, but if a third party
 * instrumentation was set after ours, we keep it in place and just replace our instrumentation with
 * a noop.
 *
 * Note: it is generally better to instrument methods that are "owned" by the object instead of ones
 * that are inherited from the prototype chain. Example:
 * * do:    `instrumentMethod(Array.prototype, 'push', ...)`
 * * don't: `instrumentMethod([], 'push', ...)`
 *
 * This method is also used to set event handler properties (ex: window.onerror = ...), as it has
 * the same requirements as instrumenting a method:
 * * if the event handler is already set by a third party, we need to call it and not just blindly
 * override it.
 * * if the event handler is set by a third party after us, we need to keep it in place when
 * removing ours.
 *
 * @example
 *
 *  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
 *    console.log('Before calling fetch on', target, 'with parameters', parameters)
 *
 *    onPostCall((result) => {
 *      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
 *    })
 *  })
 */
function instrumentMethod(targetPrototype, method, onPreCall, _a) {
  var _b = _a === void 0 ? {} : _a,
    computeHandlingStack = _b.computeHandlingStack;
  var original = targetPrototype[method];
  if (typeof original !== 'function') {
    if (startsWith(method, 'on')) {
      original = noop;
    } else {
      return {
        stop: noop
      };
    }
  }
  var stopped = false;
  var instrumentation = function () {
    if (stopped) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return original.apply(this, arguments);
    }
    var parameters = arrayFrom(arguments);
    var postCallCallback;
    callMonitored(onPreCall, null, [{
      target: this,
      parameters: parameters,
      onPostCall: function (callback) {
        postCallCallback = callback;
      },
      handlingStack: computeHandlingStack ? createHandlingStack() : undefined
    }]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    var result = original.apply(this, parameters);
    if (postCallCallback) {
      callMonitored(postCallCallback, null, [result]);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return result;
  };
  targetPrototype[method] = instrumentation;
  return {
    stop: function () {
      stopped = true;
      // If the instrumentation has been removed by a third party, keep the last one
      if (targetPrototype[method] === instrumentation) {
        targetPrototype[method] = original;
      }
    }
  };
}
function instrumentSetter(targetPrototype, property, after) {
  var originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
  if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
    return {
      stop: noop
    };
  }
  var stoppedInstrumentation = noop;
  var instrumentation = function (target, value) {
    // put hooked setter into event loop to avoid of set latency
    setTimeout$1(function () {
      if (instrumentation !== stoppedInstrumentation) {
        after(target, value);
      }
    }, 0);
  };
  var instrumentationWrapper = function (value) {
    originalDescriptor.set.call(this, value);
    instrumentation(this, value);
  };
  Object.defineProperty(targetPrototype, property, {
    set: instrumentationWrapper
  });
  return {
    stop: function () {
      var _a;
      if (((_a = Object.getOwnPropertyDescriptor(targetPrototype, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
        Object.defineProperty(targetPrototype, property, originalDescriptor);
      }
      instrumentation = stoppedInstrumentation;
    }
  };
}

// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * ONE_KIBI_BYTE;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
  var _a;
  if (maxCharacterCount === void 0) {
    maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT;
  }
  // Unbind any toJSON function we may have on [] or {} prototypes
  var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
  var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
  // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
  var containerQueue = [];
  var visitedObjectsWithPath = new WeakMap();
  var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
  var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
  if (accumulatedCharacterCount > maxCharacterCount) {
    warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
    return undefined;
  }
  while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
    var containerToProcess = containerQueue.shift();
    var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
    // Arrays and Objects have to be handled distinctly to ensure
    // we do not pick up non-numerical properties from Arrays
    if (Array.isArray(containerToProcess.source)) {
      for (var key = 0; key < containerToProcess.source.length; key++) {
        var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
        if (targetData !== undefined) {
          accumulatedCharacterCount += JSON.stringify(targetData).length;
        } else {
          // When an element of an Array (targetData) is undefined, it is serialized as null:
          // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
          accumulatedCharacterCount += 4;
        }
        accumulatedCharacterCount += separatorLength;
        separatorLength = 1;
        if (accumulatedCharacterCount > maxCharacterCount) {
          warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
          break;
        }
        containerToProcess.target[key] = targetData;
      }
    } else {
      for (var key in containerToProcess.source) {
        if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
          var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
          // When a property of an object has an undefined value, it will be dropped during serialization:
          // JSON.stringify({a:undefined}) => '{}'
          if (targetData !== undefined) {
            accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
            separatorLength = 1;
          }
          if (accumulatedCharacterCount > maxCharacterCount) {
            warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
            break;
          }
          containerToProcess.target[key] = targetData;
        }
      }
    }
  }
  // Rebind detached toJSON functions
  restoreObjectPrototypeToJson();
  restoreArrayPrototypeToJson();
  return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
  // Start by handling toJSON, as we want to sanitize its output
  var sourceToSanitize = tryToApplyToJSON(source);
  if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
    return sanitizePrimitivesAndFunctions(sourceToSanitize);
  }
  var sanitizedSource = sanitizeObjects(sourceToSanitize);
  if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
    return sanitizedSource;
  }
  // Handle potential cyclic references
  // We need to use source as sourceToSanitize could be a reference to a new object
  // At this stage, we know the source is an object type
  var sourceAsObject = source;
  if (visitedObjectsWithPath.has(sourceAsObject)) {
    return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
  }
  // Add processed source to queue
  var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
  var target = Array.isArray(sourceToSanitize) ? [] : {};
  visitedObjectsWithPath.set(sourceAsObject, currentPath);
  queue.push({
    source: sourceToSanitize,
    target: target,
    path: currentPath
  });
  return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
  // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
  if (typeof value === 'bigint') {
    return "[BigInt] ".concat(value.toString());
  }
  // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
  // so it won't prevent stringify from serializing later
  if (typeof value === 'function') {
    return "[Function] ".concat(value.name || 'unknown');
  }
  // JSON.stringify() does not serialize symbols.
  if (typeof value === 'symbol') {
    return "[Symbol] ".concat(value.description || value.toString());
  }
  return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
  try {
    // Handle events - Keep a simple implementation to avoid breaking changes
    if (value instanceof Event) {
      return {
        isTrusted: value.isTrusted
      };
    }
    // Handle all remaining object types in a generic way
    var result = Object.prototype.toString.call(value);
    var match = result.match(/\[object (.*)\]/);
    if (match && match[1]) {
      return "[".concat(match[1], "]");
    }
  } catch (_a) {
    // If the previous serialization attempts failed, and we cannot convert using
    // Object.prototype.toString, declare the value unserializable
  }
  return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
  var object = value;
  if (object && typeof object.toJSON === 'function') {
    try {
      return object.toJSON();
    } catch (_a) {
      // If toJSON fails, we continue by trying to serialize the value manually
    }
  }
  return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
  display.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}

var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
  var stackTrace = _a.stackTrace,
    originalError = _a.originalError,
    handlingStack = _a.handlingStack,
    startClocks = _a.startClocks,
    nonErrorPrefix = _a.nonErrorPrefix,
    source = _a.source,
    handling = _a.handling;
  var isErrorInstance = originalError instanceof Error;
  var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
  var stack = hasUsableStack(isErrorInstance, stackTrace) ? toStackTraceString(stackTrace) : NO_ERROR_STACK_PRESENT_MESSAGE;
  var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
  var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
  var fingerprint = tryToGetFingerprint(originalError);
  return {
    startClocks: startClocks,
    source: source,
    handling: handling,
    handlingStack: handlingStack,
    originalError: originalError,
    type: type,
    message: message,
    stack: stack,
    causes: causes,
    fingerprint: fingerprint
  };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
  // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
  // TODO rework tracekit integration to avoid scattering error building logic
  return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name) ? stackTrace.message : !isErrorInstance ? "".concat(nonErrorPrefix, " ").concat(jsonStringify(sanitize(originalError))) : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
  if (stackTrace === undefined) {
    return false;
  }
  if (isErrorInstance) {
    return true;
  }
  // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
  // TODO rework tracekit integration to avoid generating those unusable stack
  return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
  return originalError instanceof Error && 'dd_fingerprint' in originalError ? String(originalError.dd_fingerprint) : undefined;
}
function flattenErrorCauses(error, parentSource) {
  var currentError = error;
  var causes = [];
  while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
    var stackTrace = computeStackTrace(currentError.cause);
    causes.push({
      message: currentError.cause.message,
      source: parentSource,
      type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
      stack: stackTrace && toStackTraceString(stackTrace)
    });
    currentError = currentError.cause;
  }
  return causes.length ? causes : undefined;
}

var ErrorSource = {
  AGENT: 'agent',
  CONSOLE: 'console',
  CUSTOM: 'custom',
  LOGGER: 'logger',
  NETWORK: 'network',
  SOURCE: 'source',
  REPORT: 'report'
};

function trackRuntimeError(errorObservable) {
  var handleRuntimeError = function (stackTrace, originalError) {
    var rawError = computeRawError({
      stackTrace: stackTrace,
      originalError: originalError,
      startClocks: clocksNow(),
      nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
      source: ErrorSource.SOURCE,
      handling: "unhandled" /* ErrorHandling.UNHANDLED */
    });
    errorObservable.notify(rawError);
  };
  var stopInstrumentingOnError = instrumentOnError(handleRuntimeError).stop;
  var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(handleRuntimeError).stop;
  return {
    stop: function () {
      stopInstrumentingOnError();
      stopInstrumentingOnUnhandledRejection();
    }
  };
}
function instrumentOnError(callback) {
  return instrumentMethod(window, 'onerror', function (_a) {
    var _b = _a.parameters,
      messageObj = _b[0],
      url = _b[1],
      line = _b[2],
      column = _b[3],
      errorObj = _b[4];
    var stackTrace;
    if (errorObj instanceof Error) {
      stackTrace = computeStackTrace(errorObj);
    } else {
      stackTrace = computeStackTraceFromOnErrorMessage(messageObj, url, line, column);
    }
    callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
  });
}
function instrumentUnhandledRejection(callback) {
  return instrumentMethod(window, 'onunhandledrejection', function (_a) {
    var e = _a.parameters[0];
    var reason = e.reason || 'Empty reason';
    var stack = computeStackTrace(reason);
    callback(stack, reason);
  });
}

function makePublicApi(stub) {
  var publicApi = assign({
    version: "5.23.0",
    // This API method is intentionally not monitored, since the only thing executed is the
    // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
    // we don't want to interfere with the user uncaught exceptions.
    onReady: function (callback) {
      callback();
    }
  }, stub);
  // Add a "hidden" property to set debug mode. We define it that way to hide it
  // as much as possible but of course it's not a real protection.
  Object.defineProperty(publicApi, '_setDebug', {
    get: function () {
      return setDebugMode;
    },
    enumerable: false
  });
  return publicApi;
}
function defineGlobal(global, name, api) {
  var existingGlobalVariable = global[name];
  if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) {
    display.warn('SDK is loaded more than once. This is unsupported and might have unexpected behavior.');
  }
  global[name] = api;
  if (existingGlobalVariable && existingGlobalVariable.q) {
    existingGlobalVariable.q.forEach(function (fn) {
      return catchUserErrors(fn, 'onReady callback threw an error:')();
    });
  }
}

function displayAlreadyInitializedError(sdkName, initConfiguration) {
  if (!initConfiguration.silentMultipleInit) {
    display.error("".concat(sdkName, " is already initialized."));
  }
}

// We want to use a real enum (i.e. not a const enum) here, to be able to iterate over it to automatically add _ddIsTrusted in e2e tests
// eslint-disable-next-line no-restricted-syntax
var DOM_EVENT;
(function (DOM_EVENT) {
  DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
  DOM_EVENT["CLICK"] = "click";
  DOM_EVENT["DBL_CLICK"] = "dblclick";
  DOM_EVENT["KEY_DOWN"] = "keydown";
  DOM_EVENT["LOAD"] = "load";
  DOM_EVENT["POP_STATE"] = "popstate";
  DOM_EVENT["SCROLL"] = "scroll";
  DOM_EVENT["TOUCH_START"] = "touchstart";
  DOM_EVENT["TOUCH_END"] = "touchend";
  DOM_EVENT["TOUCH_MOVE"] = "touchmove";
  DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
  DOM_EVENT["PAGE_SHOW"] = "pageshow";
  DOM_EVENT["FREEZE"] = "freeze";
  DOM_EVENT["RESUME"] = "resume";
  DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
  DOM_EVENT["POINTER_DOWN"] = "pointerdown";
  DOM_EVENT["POINTER_UP"] = "pointerup";
  DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
  DOM_EVENT["HASH_CHANGE"] = "hashchange";
  DOM_EVENT["PAGE_HIDE"] = "pagehide";
  DOM_EVENT["MOUSE_DOWN"] = "mousedown";
  DOM_EVENT["MOUSE_UP"] = "mouseup";
  DOM_EVENT["MOUSE_MOVE"] = "mousemove";
  DOM_EVENT["FOCUS"] = "focus";
  DOM_EVENT["BLUR"] = "blur";
  DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
  DOM_EVENT["RESIZE"] = "resize";
  DOM_EVENT["CHANGE"] = "change";
  DOM_EVENT["INPUT"] = "input";
  DOM_EVENT["PLAY"] = "play";
  DOM_EVENT["PAUSE"] = "pause";
  DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
  DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
  DOM_EVENT["STORAGE"] = "storage";
})(DOM_EVENT || (DOM_EVENT = {}));
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
  return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
  var _b = _a === void 0 ? {} : _a,
    once = _b.once,
    capture = _b.capture,
    passive = _b.passive;
  var listenerWithMonitor = monitor(function (event) {
    if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
      return;
    }
    if (once) {
      stop();
    }
    listener(event);
  });
  var options = passive ? {
    capture: capture,
    passive: passive
  } : capture;
  var add = getZoneJsOriginalValue(eventTarget, 'addEventListener');
  eventNames.forEach(function (eventName) {
    return add.call(eventTarget, eventName, listenerWithMonitor, options);
  });
  function stop() {
    var remove = getZoneJsOriginalValue(eventTarget, 'removeEventListener');
    eventNames.forEach(function (eventName) {
      return remove.call(eventTarget, eventName, listenerWithMonitor, options);
    });
  }
  return {
    stop: stop
  };
}

var RawReportType = {
  intervention: 'intervention',
  deprecation: 'deprecation',
  cspViolation: 'csp_violation'
};
function initReportObservable(configuration, apis) {
  var observables = [];
  if (includes(apis, RawReportType.cspViolation)) {
    observables.push(createCspViolationReportObservable(configuration));
  }
  var reportTypes = apis.filter(function (api) {
    return api !== RawReportType.cspViolation;
  });
  if (reportTypes.length) {
    observables.push(createReportObservable(reportTypes));
  }
  return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
  return new Observable(function (observable) {
    if (!window.ReportingObserver) {
      return;
    }
    var handleReports = monitor(function (reports, _) {
      return reports.forEach(function (report) {
        observable.notify(buildRawReportFromReport(report));
      });
    });
    var observer = new window.ReportingObserver(handleReports, {
      types: reportTypes,
      buffered: true
    });
    observer.observe();
    return function () {
      observer.disconnect();
    };
  });
}
function createCspViolationReportObservable(configuration) {
  return new Observable(function (observable) {
    var stop = addEventListener(configuration, document, DOM_EVENT.SECURITY_POLICY_VIOLATION, function (event) {
      observable.notify(buildRawReportFromCspViolation(event));
    }).stop;
    return stop;
  });
}
function buildRawReportFromReport(report) {
  var type = report.type,
    body = report.body;
  return {
    type: type,
    subtype: body.id,
    message: "".concat(type, ": ").concat(body.message),
    originalReport: report,
    stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
  };
}
function buildRawReportFromCspViolation(event) {
  var type = RawReportType.cspViolation;
  var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
  return {
    type: RawReportType.cspViolation,
    subtype: event.effectiveDirective,
    message: "".concat(type, ": ").concat(message),
    stack: buildStack(event.effectiveDirective, event.originalPolicy ? "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\"") : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    originalReport: event
  };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
  return sourceFile ? toStackTraceString({
    name: name,
    message: message,
    stack: [{
      func: '?',
      url: sourceFile,
      line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
      column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined
    }]
  }) : undefined;
}

function sendToExtension(type, payload) {
  var callback = window.__ddBrowserSdkExtensionCallback;
  if (callback) {
    callback({
      type: type,
      payload: payload
    });
  }
}

/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
  if (value === null) {
    return 'null';
  }
  if (Array.isArray(value)) {
    return 'array';
  }
  return typeof value;
}

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
  if (circularReferenceChecker === void 0) {
    circularReferenceChecker = createCircularReferenceChecker();
  }
  // ignore the source if it is undefined
  if (source === undefined) {
    return destination;
  }
  if (typeof source !== 'object' || source === null) {
    // primitive values - just return source
    return source;
  } else if (source instanceof Date) {
    return new Date(source.getTime());
  } else if (source instanceof RegExp) {
    var flags = source.flags ||
    // old browsers compatibility
    [source.global ? 'g' : '', source.ignoreCase ? 'i' : '', source.multiline ? 'm' : '', source.sticky ? 'y' : '', source.unicode ? 'u' : ''].join('');
    return new RegExp(source.source, flags);
  }
  if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
    // remove circular references
    return undefined;
  } else if (Array.isArray(source)) {
    var merged_1 = Array.isArray(destination) ? destination : [];
    for (var i = 0; i < source.length; ++i) {
      merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
    }
    return merged_1;
  }
  var merged = getType(destination) === 'object' ? destination : {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
    }
  }
  return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
  return mergeInto(undefined, value);
}
function combine() {
  var sources = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }
  var destination;
  for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
    var source = sources_1[_a];
    // Ignore any undefined or null sources.
    if (source === undefined || source === null) {
      continue;
    }
    destination = mergeInto(destination, source);
  }
  return destination;
}
function createCircularReferenceChecker() {
  if (typeof WeakSet !== 'undefined') {
    var set_1 = new WeakSet();
    return {
      hasAlreadyBeenSeen: function (value) {
        var has = set_1.has(value);
        if (!has) {
          set_1.add(value);
        }
        return has;
      }
    };
  }
  var array = [];
  return {
    hasAlreadyBeenSeen: function (value) {
      var has = array.indexOf(value) >= 0;
      if (!has) {
        array.push(value);
      }
      return has;
    }
  };
}

function getConnectivity() {
  var _a;
  var navigator = window.navigator;
  return {
    status: navigator.onLine ? 'connected' : 'not_connected',
    interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
    effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
  };
}

function removeItem(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */function () {
  function BoundedBuffer() {
    this.buffer = [];
  }
  BoundedBuffer.prototype.add = function (callback) {
    var length = this.buffer.push(callback);
    if (length > BUFFER_LIMIT) {
      this.buffer.splice(0, 1);
    }
  };
  BoundedBuffer.prototype.remove = function (callback) {
    removeItem(this.buffer, callback);
  };
  BoundedBuffer.prototype.drain = function (arg) {
    this.buffer.forEach(function (callback) {
      return callback(arg);
    });
    this.buffer.length = 0;
  };
  return BoundedBuffer;
}();

var TelemetryType = {
  log: 'log',
  configuration: 'configuration',
  usage: 'usage'
};

var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'https://d3uc069fcn7uxw.cloudfront.net', 'https://d20xtzwzcl0ceb.cloudfront.net', 'http://localhost', '<anonymous>'];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED];
// eslint-disable-next-line local-rules/disallow-side-effects
var preStartTelemetryBuffer = new BoundedBuffer();
var onRawTelemetryEventCollected = function (event) {
  preStartTelemetryBuffer.add(function () {
    return onRawTelemetryEventCollected(event);
  });
};
function startTelemetry(telemetryService, configuration) {
  var _a;
  var contextProvider;
  var observable = new Observable();
  var alreadySentEvents = new Set();
  var telemetryEnabled = !includes(TELEMETRY_EXCLUDED_SITES, configuration.site) && performDraw(configuration.telemetrySampleRate);
  var telemetryEnabledPerType = (_a = {}, _a[TelemetryType.log] = telemetryEnabled, _a[TelemetryType.configuration] = telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate), _a[TelemetryType.usage] = telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate), _a);
  var runtimeEnvInfo = getRuntimeEnvInfo();
  onRawTelemetryEventCollected = function (rawEvent) {
    var stringifiedEvent = jsonStringify(rawEvent);
    if (telemetryEnabledPerType[rawEvent.type] && alreadySentEvents.size < configuration.maxTelemetryEventsPerPage && !alreadySentEvents.has(stringifiedEvent)) {
      var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
      observable.notify(event_1);
      sendToExtension('telemetry', event_1);
      alreadySentEvents.add(stringifiedEvent);
    }
  };
  startMonitorErrorCollection(addTelemetryError);
  function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
    return combine({
      type: 'telemetry',
      date: timeStampNow(),
      service: telemetryService,
      version: "5.23.0",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: combine(event, {
        runtime_env: runtimeEnvInfo,
        connectivity: getConnectivity()
      }),
      experimental_features: arrayFrom(getExperimentalFeatures())
    }, contextProvider !== undefined ? contextProvider() : {});
  }
  return {
    setContextProvider: function (provider) {
      contextProvider = provider;
    },
    observable: observable,
    enabled: telemetryEnabled
  };
}
function getRuntimeEnvInfo() {
  return {
    is_local_file: window.location.protocol === 'file:',
    is_worker: 'WorkerGlobalScope' in self
  };
}
// need to be called after telemetry context is provided and observers are registered
function drainPreStartTelemetry() {
  preStartTelemetryBuffer.drain();
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === INTAKE_SITE_STAGING;
}
function addTelemetryDebug(message, context) {
  displayIfDebugEnabled(ConsoleApiName.debug, message, context);
  onRawTelemetryEventCollected(assign({
    type: TelemetryType.log,
    message: message,
    status: "debug" /* StatusType.debug */
  }, context));
}
function addTelemetryError(e, context) {
  onRawTelemetryEventCollected(assign({
    type: TelemetryType.log,
    status: "error" /* StatusType.error */
  }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
  onRawTelemetryEventCollected({
    type: TelemetryType.configuration,
    configuration: configuration
  });
}
function addTelemetryUsage(usage) {
  onRawTelemetryEventCollected({
    type: TelemetryType.usage,
    usage: usage
  });
}
function formatError(e) {
  if (e instanceof Error) {
    var stackTrace = computeStackTrace(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: toStackTraceString(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }
  return {
    error: {
      stack: NO_ERROR_STACK_PRESENT_MESSAGE
    },
    message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat(jsonStringify(e))
  };
}
function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return startsWith(frame.url, allowedFrameUrl);
    });
  });
  return stackTrace;
}

var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = ONE_MINUTE;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */function () {
  function ValueHistory(expireDelay, maxEntries) {
    var _this = this;
    this.expireDelay = expireDelay;
    this.maxEntries = maxEntries;
    this.entries = [];
    this.clearOldValuesInterval = setInterval$1(function () {
      return _this.clearOldValues();
    }, CLEAR_OLD_VALUES_INTERVAL);
  }
  /**
   * Add a value to the history associated with a start time. Returns a reference to this newly
   * added entry that can be removed or closed.
   */
  ValueHistory.prototype.add = function (value, startTime) {
    var _this = this;
    var entry = {
      value: value,
      startTime: startTime,
      endTime: END_OF_TIMES,
      remove: function () {
        removeItem(_this.entries, entry);
      },
      close: function (endTime) {
        entry.endTime = endTime;
      }
    };
    if (this.maxEntries && this.entries.length >= this.maxEntries) {
      this.entries.pop();
    }
    this.entries.unshift(entry);
    return entry;
  };
  /**
   * Return the latest value that was active during `startTime`, or the currently active value
   * if no `startTime` is provided. This method assumes that entries are not overlapping.
   *
   * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
   */
  ValueHistory.prototype.find = function (startTime, options) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }
    if (options === void 0) {
      options = {
        returnInactive: false
      };
    }
    for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
      var entry = _a[_i];
      if (entry.startTime <= startTime) {
        if (options.returnInactive || startTime <= entry.endTime) {
          return entry.value;
        }
        break;
      }
    }
  };
  /**
   * Helper function to close the currently active value, if any. This method assumes that entries
   * are not overlapping.
   */
  ValueHistory.prototype.closeActive = function (endTime) {
    var latestEntry = this.entries[0];
    if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
      latestEntry.close(endTime);
    }
  };
  /**
   * Return all values with an active period overlapping with the duration,
   * or all values that were active during `startTime` if no duration is provided,
   * or all currently active values if no `startTime` is provided.
   */
  ValueHistory.prototype.findAll = function (startTime, duration) {
    if (startTime === void 0) {
      startTime = END_OF_TIMES;
    }
    if (duration === void 0) {
      duration = 0;
    }
    var endTime = addDuration(startTime, duration);
    return this.entries.filter(function (entry) {
      return entry.startTime <= endTime && startTime <= entry.endTime;
    }).map(function (entry) {
      return entry.value;
    });
  };
  /**
   * Remove all entries from this collection.
   */
  ValueHistory.prototype.reset = function () {
    this.entries = [];
  };
  /**
   * Stop internal garbage collection of past entries.
   */
  ValueHistory.prototype.stop = function () {
    clearInterval$1(this.clearOldValuesInterval);
  };
  ValueHistory.prototype.clearOldValues = function () {
    var oldTimeThreshold = relativeNow() - this.expireDelay;
    while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
      this.entries.pop();
    }
  };
  return ValueHistory;
}();

var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
function startSessionManager(configuration, productKey, computeSessionState, trackingConsentState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable();
  // TODO - Improve configuration type and remove assertion
  var sessionStore = startSessionStore(configuration.sessionStoreStrategyType, productKey, computeSessionState);
  var sessionContextHistory = new ValueHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
  sessionStore.renewObservable.subscribe(function () {
    sessionContextHistory.add(buildSessionContext(), relativeNow());
    renewObservable.notify();
  });
  sessionStore.expireObservable.subscribe(function () {
    expireObservable.notify();
    sessionContextHistory.closeActive(relativeNow());
  });
  // We expand/renew session unconditionally as tracking consent is always granted when the session
  // manager is started.
  sessionStore.expandOrRenewSession();
  sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);
  trackingConsentState.observable.subscribe(function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    } else {
      sessionStore.expire();
    }
  });
  trackActivity(configuration, function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    }
  });
  trackVisibility(configuration, function () {
    return sessionStore.expandSession();
  });
  trackResume(configuration, function () {
    return sessionStore.restartSession();
  });
  function buildSessionContext() {
    return {
      id: sessionStore.getSession().id,
      trackingType: sessionStore.getSession()[productKey],
      isReplayForced: !!sessionStore.getSession().forcedReplay
    };
  }
  return {
    findSession: function (startTime, options) {
      return sessionContextHistory.find(startTime, options);
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
    expire: sessionStore.expire,
    updateSessionState: sessionStore.updateSessionState
  };
}
function trackActivity(configuration, expandOrRenewSession) {
  addEventListeners(configuration, window, [DOM_EVENT.CLICK, DOM_EVENT.TOUCH_START, DOM_EVENT.KEY_DOWN, DOM_EVENT.SCROLL], expandOrRenewSession, {
    capture: true,
    passive: true
  }).stop;
}
function trackVisibility(configuration, expandSession) {
  var expandSessionWhenVisible = function () {
    if (document.visibilityState === 'visible') {
      expandSession();
    }
  };
  addEventListener(configuration, document, DOM_EVENT.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
  setInterval$1(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
}
function trackResume(configuration, cb) {
  addEventListener(configuration, window, DOM_EVENT.RESUME, cb, {
    capture: true
  }).stop;
}

function isServerError(status) {
  return status >= 500;
}
function tryToClone(response) {
  try {
    return response.clone();
  } catch (e) {
    // clone can throw if the response has already been used by another instrumentation or is disturbed
    return;
  }
}

var MAX_ONGOING_BYTES_COUNT = 80 * ONE_KIBI_BYTE;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * ONE_MEBI_BYTE;
var MAX_BACKOFF_TIME = ONE_MINUTE;
var INITIAL_BACKOFF_TIME = ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
  if (state.transportStatus === 0 /* TransportStatus.UP */ && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) {
    send(payload, state, sendStrategy, {
      onSuccess: function () {
        return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError);
      },
      onFailure: function () {
        state.queuedPayloads.enqueue(payload);
        scheduleRetry(state, sendStrategy, trackType, reportError);
      }
    });
  } else {
    state.queuedPayloads.enqueue(payload);
  }
}
function scheduleRetry(state, sendStrategy, trackType, reportError) {
  if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
    return;
  }
  setTimeout$1(function () {
    var payload = state.queuedPayloads.first();
    send(payload, state, sendStrategy, {
      onSuccess: function () {
        state.queuedPayloads.dequeue();
        state.currentBackoffTime = INITIAL_BACKOFF_TIME;
        retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
      },
      onFailure: function () {
        state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
        scheduleRetry(state, sendStrategy, trackType, reportError);
      }
    });
  }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
  var onSuccess = _a.onSuccess,
    onFailure = _a.onFailure;
  state.bandwidthMonitor.add(payload);
  sendStrategy(payload, function (response) {
    state.bandwidthMonitor.remove(payload);
    if (!shouldRetryRequest(response)) {
      state.transportStatus = 0 /* TransportStatus.UP */;
      onSuccess();
    } else {
      // do not consider transport down if another ongoing request could succeed
      state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
      payload.retry = {
        count: payload.retry ? payload.retry.count + 1 : 1,
        lastFailureStatus: response.status
      };
      onFailure();
    }
  });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
  if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
    reportError({
      message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / ONE_MEBI_BYTE, "MiB"),
      source: ErrorSource.AGENT,
      startClocks: clocksNow()
    });
    state.queueFullReported = true;
  }
  var previousQueue = state.queuedPayloads;
  state.queuedPayloads = newPayloadQueue();
  while (previousQueue.size() > 0) {
    sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
  }
}
function shouldRetryRequest(response) {
  return response.type !== 'opaque' && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || isServerError(response.status));
}
function newRetryState() {
  return {
    transportStatus: 0 /* TransportStatus.UP */,
    currentBackoffTime: INITIAL_BACKOFF_TIME,
    bandwidthMonitor: newBandwidthMonitor(),
    queuedPayloads: newPayloadQueue(),
    queueFullReported: false
  };
}
function newPayloadQueue() {
  var queue = [];
  return {
    bytesCount: 0,
    enqueue: function (payload) {
      if (this.isFull()) {
        return;
      }
      queue.push(payload);
      this.bytesCount += payload.bytesCount;
    },
    first: function () {
      return queue[0];
    },
    dequeue: function () {
      var payload = queue.shift();
      if (payload) {
        this.bytesCount -= payload.bytesCount;
      }
      return payload;
    },
    size: function () {
      return queue.length;
    },
    isFull: function () {
      return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
    }
  };
}
function newBandwidthMonitor() {
  return {
    ongoingRequestCount: 0,
    ongoingByteCount: 0,
    canHandle: function (payload) {
      return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT && this.ongoingRequestCount < MAX_ONGOING_REQUESTS;
    },
    add: function (payload) {
      this.ongoingRequestCount += 1;
      this.ongoingByteCount += payload.bytesCount;
    },
    remove: function (payload) {
      this.ongoingRequestCount -= 1;
      this.ongoingByteCount -= payload.bytesCount;
    }
  };
}

function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
  var retryState = newRetryState();
  var sendStrategyForRetry = function (payload, onResponse) {
    return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
  };
  return {
    send: function (payload) {
      sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
    },
    /**
     * Since fetch keepalive behaves like regular fetch on Firefox,
     * keep using sendBeaconStrategy on exit
     */
    sendOnExit: function (payload) {
      sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
    }
  };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
  var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
  if (canUseBeacon) {
    try {
      var beaconUrl = endpointBuilder.build('beacon', payload);
      var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
      if (isQueued) {
        return;
      }
    } catch (e) {
      reportBeaconError(e);
    }
  }
  var xhrUrl = endpointBuilder.build('xhr', payload);
  sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
  if (!hasReportedBeaconError) {
    hasReportedBeaconError = true;
    addTelemetryError(e);
  }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
  var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
  if (canUseKeepAlive) {
    var fetchUrl = endpointBuilder.build('fetch', payload);
    fetch(fetchUrl, {
      method: 'POST',
      body: payload.data,
      keepalive: true,
      mode: 'cors'
    }).then(monitor(function (response) {
      return onResponse === null || onResponse === void 0 ? void 0 : onResponse({
        status: response.status,
        type: response.type
      });
    }), monitor(function () {
      var xhrUrl = endpointBuilder.build('xhr', payload);
      // failed to queue the request
      sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }));
  } else {
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data, onResponse);
  }
}
function isKeepAliveSupported() {
  // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
  try {
    return window.Request && 'keepalive' in new Request('http://a');
  } catch (_a) {
    return false;
  }
}
function sendXHR(configuration, url, data, onResponse) {
  var request = new XMLHttpRequest();
  request.open('POST', url, true);
  if (data instanceof Blob) {
    // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
    // automatically, so the intake request ends up being rejected with an HTTP status 415
    // Defining the header manually fixes this issue.
    request.setRequestHeader('Content-Type', data.type);
  }
  addEventListener(configuration, request, 'loadend', function () {
    onResponse === null || onResponse === void 0 ? void 0 : onResponse({
      status: request.status
    });
  }, {
    // prevent multiple onResponse callbacks
    // if the xhr instance is reused by a third party
    once: true
  });
  request.send(data);
}

function getEventBridge() {
  var eventBridgeGlobal = getEventBridgeGlobal();
  if (!eventBridgeGlobal) {
    return;
  }
  return {
    getCapabilities: function () {
      var _a;
      return JSON.parse(((_a = eventBridgeGlobal.getCapabilities) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal)) || '[]');
    },
    getPrivacyLevel: function () {
      var _a;
      return (_a = eventBridgeGlobal.getPrivacyLevel) === null || _a === void 0 ? void 0 : _a.call(eventBridgeGlobal);
    },
    getAllowedWebViewHosts: function () {
      return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
    },
    send: function (eventType, event, viewId) {
      var view = viewId ? {
        id: viewId
      } : undefined;
      eventBridgeGlobal.send(JSON.stringify({
        eventType: eventType,
        event: event,
        view: view
      }));
    }
  };
}
function bridgeSupports(capability) {
  var bridge = getEventBridge();
  return !!bridge && includes(bridge.getCapabilities(), capability);
}
function canUseEventBridge(currentHost) {
  var _a;
  if (currentHost === void 0) {
    currentHost = (_a = getGlobalObject().location) === null || _a === void 0 ? void 0 : _a.hostname;
  }
  var bridge = getEventBridge();
  return !!bridge && bridge.getAllowedWebViewHosts().some(function (allowedHost) {
    return currentHost === allowedHost || endsWith(currentHost, ".".concat(allowedHost));
  });
}
function getEventBridgeGlobal() {
  return getGlobalObject().DatadogEventBridge;
}

var PageExitReason = {
  HIDDEN: 'visibility_hidden',
  UNLOADING: 'before_unload',
  PAGEHIDE: 'page_hide',
  FROZEN: 'page_frozen'
};
function createPageExitObservable(configuration) {
  return new Observable(function (observable) {
    var stopListeners = addEventListeners(configuration, window, [DOM_EVENT.VISIBILITY_CHANGE, DOM_EVENT.FREEZE], function (event) {
      if (event.type === DOM_EVENT.VISIBILITY_CHANGE && document.visibilityState === 'hidden') {
        /**
         * Only event that guarantee to fire on mobile devices when the page transitions to background state
         * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
         */
        observable.notify({
          reason: PageExitReason.HIDDEN
        });
      } else if (event.type === DOM_EVENT.FREEZE) {
        /**
         * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
         * Allow to collect events happening between hidden and frozen state.
         */
        observable.notify({
          reason: PageExitReason.FROZEN
        });
      }
    }, {
      capture: true
    }).stop;
    var stopBeforeUnloadListener = addEventListener(configuration, window, DOM_EVENT.BEFORE_UNLOAD, function () {
      observable.notify({
        reason: PageExitReason.UNLOADING
      });
    }).stop;
    return function () {
      stopListeners();
      stopBeforeUnloadListener();
    };
  });
}
function isPageExitReason(reason) {
  return includes(objectValues(PageExitReason), reason);
}

var Batch = /** @class */function () {
  function Batch(encoder, request, flushController, messageBytesLimit) {
    var _this = this;
    this.encoder = encoder;
    this.request = request;
    this.flushController = flushController;
    this.messageBytesLimit = messageBytesLimit;
    this.upsertBuffer = {};
    this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) {
      return _this.flush(event);
    });
  }
  Batch.prototype.add = function (message) {
    this.addOrUpdate(message);
  };
  Batch.prototype.upsert = function (message, key) {
    this.addOrUpdate(message, key);
  };
  Batch.prototype.stop = function () {
    this.flushSubscription.unsubscribe();
  };
  Batch.prototype.flush = function (event) {
    var upsertMessages = objectValues(this.upsertBuffer).join('\n');
    this.upsertBuffer = {};
    var isPageExit = isPageExitReason(event.reason);
    var send = isPageExit ? this.request.sendOnExit : this.request.send;
    if (isPageExit &&
    // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
    // if the encoder is async we need to send two requests in some cases (one for encoded data
    // and the other for non-encoded data). But if it's not async, we don't have to worry about
    // it and always send a single request.
    this.encoder.isAsync) {
      var encoderResult = this.encoder.finishSync();
      // Send encoded messages
      if (encoderResult.outputBytesCount) {
        send(formatPayloadFromEncoder(encoderResult));
      }
      // Send messages that are not yet encoded at this point
      var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
      if (pendingMessages) {
        send({
          data: pendingMessages,
          bytesCount: computeBytesCount(pendingMessages)
        });
      }
    } else {
      if (upsertMessages) {
        this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
      }
      this.encoder.finish(function (encoderResult) {
        send(formatPayloadFromEncoder(encoderResult));
      });
    }
  };
  Batch.prototype.addOrUpdate = function (message, key) {
    var serializedMessage = jsonStringify(message);
    var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
    if (estimatedMessageBytesCount >= this.messageBytesLimit) {
      display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB. More details: ").concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting/#technical-limitations"));
      return;
    }
    if (this.hasMessageFor(key)) {
      this.remove(key);
    }
    this.push(serializedMessage, estimatedMessageBytesCount, key);
  };
  Batch.prototype.push = function (serializedMessage, estimatedMessageBytesCount, key) {
    var _this = this;
    this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
    if (key !== undefined) {
      this.upsertBuffer[key] = serializedMessage;
      this.flushController.notifyAfterAddMessage();
    } else {
      this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
        _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
      });
    }
  };
  Batch.prototype.remove = function (key) {
    var removedMessage = this.upsertBuffer[key];
    delete this.upsertBuffer[key];
    var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
    this.flushController.notifyAfterRemoveMessage(messageBytesCount);
  };
  Batch.prototype.hasMessageFor = function (key) {
    return key !== undefined && this.upsertBuffer[key] !== undefined;
  };
  return Batch;
}();
function formatPayloadFromEncoder(encoderResult) {
  var data;
  if (typeof encoderResult.output === 'string') {
    data = encoderResult.output;
  } else {
    data = new Blob([encoderResult.output], {
      // This will set the 'Content-Type: text/plain' header. Reasoning:
      // * The intake rejects the request if there is no content type.
      // * The browser will issue CORS preflight requests if we set it to 'application/json', which
      // could induce higher intake load (and maybe has other impacts).
      // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
      // new lines.
      type: 'text/plain'
    });
  }
  return {
    data: data,
    bytesCount: encoderResult.outputBytesCount,
    encoding: encoderResult.encoding
  };
}

/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
  var messagesLimit = _a.messagesLimit,
    bytesLimit = _a.bytesLimit,
    durationLimit = _a.durationLimit,
    pageExitObservable = _a.pageExitObservable,
    sessionExpireObservable = _a.sessionExpireObservable;
  var pageExitSubscription = pageExitObservable.subscribe(function (event) {
    return flush(event.reason);
  });
  var sessionExpireSubscription = sessionExpireObservable.subscribe(function () {
    return flush('session_expire');
  });
  var flushObservable = new Observable(function () {
    return function () {
      pageExitSubscription.unsubscribe();
      sessionExpireSubscription.unsubscribe();
    };
  });
  var currentBytesCount = 0;
  var currentMessagesCount = 0;
  function flush(flushReason) {
    if (currentMessagesCount === 0) {
      return;
    }
    var messagesCount = currentMessagesCount;
    var bytesCount = currentBytesCount;
    currentMessagesCount = 0;
    currentBytesCount = 0;
    cancelDurationLimitTimeout();
    flushObservable.notify({
      reason: flushReason,
      messagesCount: messagesCount,
      bytesCount: bytesCount
    });
  }
  var durationLimitTimeoutId;
  function scheduleDurationLimitTimeout() {
    if (durationLimitTimeoutId === undefined) {
      durationLimitTimeoutId = setTimeout$1(function () {
        flush('duration_limit');
      }, durationLimit);
    }
  }
  function cancelDurationLimitTimeout() {
    clearTimeout$1(durationLimitTimeoutId);
    durationLimitTimeoutId = undefined;
  }
  return {
    flushObservable: flushObservable,
    get messagesCount() {
      return currentMessagesCount;
    },
    /**
     * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right before adding the message, so no flush
     * event can happen after `notifyBeforeAddMessage` and before adding the message.
     *
     * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
     * actually added.
     */
    notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
      if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
        flush('bytes_limit');
      }
      // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
      // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
      // to notify when a flush is needed (for example on page exit).
      currentMessagesCount += 1;
      currentBytesCount += estimatedMessageBytesCount;
      scheduleDurationLimitTimeout();
    },
    /**
     * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
     *
     * This function can be called asynchronously after the message was added, but in this case it
     * should not be called if a flush event occurred in between.
     *
     * @param messageBytesCountDiff: the difference between the estimated message bytes count and
     * its actual bytes count once added to the pool.
     */
    notifyAfterAddMessage: function (messageBytesCountDiff) {
      if (messageBytesCountDiff === void 0) {
        messageBytesCountDiff = 0;
      }
      currentBytesCount += messageBytesCountDiff;
      if (currentMessagesCount >= messagesLimit) {
        flush('messages_limit');
      } else if (currentBytesCount >= bytesLimit) {
        flush('bytes_limit');
      }
    },
    /**
     * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
     *
     * This function needs to be called synchronously, right after removing the message, so no flush
     * event can happen after removing the message and before `notifyAfterRemoveMessage`.
     *
     * @param messageBytesCount: the message bytes count that was added to the pool. Should
     * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
     * `notifyAfterAddMessage`.
     */
    notifyAfterRemoveMessage: function (messageBytesCount) {
      currentBytesCount -= messageBytesCount;
      currentMessagesCount -= 1;
      if (currentMessagesCount === 0) {
        cancelDurationLimitTimeout();
      }
    }
  };
}

function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
  var primaryBatch = createBatch(configuration, primary);
  var replicaBatch = replica && createBatch(configuration, replica);
  function createBatch(configuration, _a) {
    var endpoint = _a.endpoint,
      encoder = _a.encoder;
    return new Batch(encoder, createHttpRequest(configuration, endpoint, configuration.batchBytesLimit, reportError), createFlushController({
      messagesLimit: configuration.batchMessagesLimit,
      bytesLimit: configuration.batchBytesLimit,
      durationLimit: configuration.flushTimeout,
      pageExitObservable: pageExitObservable,
      sessionExpireObservable: sessionExpireObservable
    }), configuration.messageBytesLimit);
  }
  return {
    flushObservable: primaryBatch.flushController.flushObservable,
    add: function (message, replicated) {
      if (replicated === void 0) {
        replicated = true;
      }
      primaryBatch.add(message);
      if (replicaBatch && replicated) {
        replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
      }
    },
    upsert: function (message, key) {
      primaryBatch.upsert(message, key);
      if (replicaBatch) {
        replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
      }
    },
    stop: function () {
      primaryBatch.stop();
      replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
    }
  };
}

function createIdentityEncoder() {
  var output = '';
  var outputBytesCount = 0;
  return {
    isAsync: false,
    get isEmpty() {
      return !output;
    },
    write: function (data, callback) {
      var additionalEncodedBytesCount = computeBytesCount(data);
      outputBytesCount += additionalEncodedBytesCount;
      output += data;
      if (callback) {
        callback(additionalEncodedBytesCount);
      }
    },
    finish: function (callback) {
      callback(this.finishSync());
    },
    finishSync: function () {
      var result = {
        output: output,
        outputBytesCount: outputBytesCount,
        rawBytesCount: outputBytesCount,
        pendingData: ''
      };
      output = '';
      outputBytesCount = 0;
      return result;
    },
    estimateEncodedBytesCount: function (data) {
      return data.length;
    }
  };
}

var AbstractLifeCycle = /** @class */function () {
  function AbstractLifeCycle() {
    this.callbacks = {};
  }
  AbstractLifeCycle.prototype.notify = function (eventType, data) {
    var eventCallbacks = this.callbacks[eventType];
    if (eventCallbacks) {
      eventCallbacks.forEach(function (callback) {
        return callback(data);
      });
    }
  };
  AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
    var _this = this;
    if (!this.callbacks[eventType]) {
      this.callbacks[eventType] = [];
    }
    this.callbacks[eventType].push(callback);
    return {
      unsubscribe: function () {
        _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) {
          return callback !== other;
        });
      }
    };
  };
  return AbstractLifeCycle;
}();

function createEventRateLimiter(eventType, limit, onLimitReached) {
  var eventCount = 0;
  var allowNextEvent = false;
  return {
    isLimitReached: function () {
      if (eventCount === 0) {
        setTimeout$1(function () {
          eventCount = 0;
        }, ONE_MINUTE);
      }
      eventCount += 1;
      if (eventCount <= limit || allowNextEvent) {
        allowNextEvent = false;
        return false;
      }
      if (eventCount === limit + 1) {
        allowNextEvent = true;
        try {
          onLimitReached({
            message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
            source: ErrorSource.AGENT,
            startClocks: clocksNow()
          });
        } finally {
          allowNextEvent = false;
        }
      }
      return true;
    }
  };
}

function runOnReadyState(configuration, expectedReadyState, callback) {
  if (document.readyState === expectedReadyState || document.readyState === 'complete') {
    callback();
  } else {
    var eventName = expectedReadyState === 'complete' ? DOM_EVENT.LOAD : DOM_EVENT.DOM_CONTENT_LOADED;
    addEventListener(configuration, window, eventName, callback, {
      once: true
    });
  }
}

var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
  if (!xhrObservable) {
    xhrObservable = createXhrObservable(configuration);
  }
  return xhrObservable;
}
function createXhrObservable(configuration) {
  return new Observable(function (observable) {
    var stopInstrumentingStart = instrumentMethod(XMLHttpRequest.prototype, 'open', openXhr).stop;
    var stopInstrumentingSend = instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
      sendXhr(call, configuration, observable);
    }, {
      computeHandlingStack: true
    }).stop;
    var stopInstrumentingAbort = instrumentMethod(XMLHttpRequest.prototype, 'abort', abortXhr).stop;
    return function () {
      stopInstrumentingStart();
      stopInstrumentingSend();
      stopInstrumentingAbort();
    };
  });
}
function openXhr(_a) {
  var xhr = _a.target,
    _b = _a.parameters,
    method = _b[0],
    url = _b[1];
  xhrContexts.set(xhr, {
    state: 'open',
    method: String(method).toUpperCase(),
    url: normalizeUrl(String(url))
  });
}
function sendXhr(_a, configuration, observable) {
  var xhr = _a.target,
    handlingStack = _a.handlingStack;
  var context = xhrContexts.get(xhr);
  if (!context) {
    return;
  }
  var startContext = context;
  startContext.state = 'start';
  startContext.startClocks = clocksNow();
  startContext.isAborted = false;
  startContext.xhr = xhr;
  startContext.handlingStack = handlingStack;
  var hasBeenReported = false;
  var stopInstrumentingOnReadyStateChange = instrumentMethod(xhr, 'onreadystatechange', function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      // Try to report the XHR as soon as possible, because the XHR may be mutated by the
      // application during a future event. For example, Angular is calling .abort() on
      // completed requests during an onreadystatechange event, so the status becomes '0'
      // before the request is collected.
      onEnd();
    }
  }).stop;
  var onEnd = function () {
    unsubscribeLoadEndListener();
    stopInstrumentingOnReadyStateChange();
    if (hasBeenReported) {
      return;
    }
    hasBeenReported = true;
    var completeContext = context;
    completeContext.state = 'complete';
    completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
    completeContext.status = xhr.status;
    observable.notify(shallowClone(completeContext));
  };
  var unsubscribeLoadEndListener = addEventListener(configuration, xhr, 'loadend', onEnd).stop;
  observable.notify(startContext);
}
function abortXhr(_a) {
  var xhr = _a.target;
  var context = xhrContexts.get(xhr);
  if (context) {
    context.isAborted = true;
  }
}

var fetchObservable;
function initFetchObservable() {
  if (!fetchObservable) {
    fetchObservable = createFetchObservable();
  }
  return fetchObservable;
}
function createFetchObservable() {
  return new Observable(function (observable) {
    if (!window.fetch) {
      return;
    }
    var stop = instrumentMethod(window, 'fetch', function (call) {
      return beforeSend(call, observable);
    }, {
      computeHandlingStack: true
    }).stop;
    return stop;
  });
}
function beforeSend(_a, observable) {
  var parameters = _a.parameters,
    onPostCall = _a.onPostCall,
    handlingStack = _a.handlingStack;
  var input = parameters[0],
    init = parameters[1];
  var methodFromParams = init && init.method;
  if (methodFromParams === undefined && input instanceof Request) {
    methodFromParams = input.method;
  }
  var method = methodFromParams !== undefined ? String(methodFromParams).toUpperCase() : 'GET';
  var url = input instanceof Request ? input.url : normalizeUrl(String(input));
  var startClocks = clocksNow();
  var context = {
    state: 'start',
    init: init,
    input: input,
    method: method,
    startClocks: startClocks,
    url: url,
    handlingStack: handlingStack
  };
  observable.notify(context);
  // Those properties can be changed by observable subscribers
  parameters[0] = context.input;
  parameters[1] = context.init;
  onPostCall(function (responsePromise) {
    return afterSend(observable, responsePromise, context);
  });
}
function afterSend(observable, responsePromise, startContext) {
  var reportFetch = function (response) {
    var context = startContext;
    context.state = 'resolve';
    if ('stack' in response || response instanceof Error) {
      context.status = 0;
      context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
      context.error = response;
    } else if ('status' in response) {
      context.response = response;
      context.responseType = response.type;
      context.status = response.status;
      context.isAborted = false;
    }
    observable.notify(context);
  };
  responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}

var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
  var consoleObservables = apis.map(function (api) {
    if (!consoleObservablesByApi[api]) {
      consoleObservablesByApi[api] = createConsoleObservable(api);
    }
    return consoleObservablesByApi[api];
  });
  return mergeObservables.apply(void 0, consoleObservables);
}
function createConsoleObservable(api) {
  return new Observable(function (observable) {
    var originalConsoleApi = globalConsole[api];
    globalConsole[api] = function () {
      var params = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
      }
      originalConsoleApi.apply(console, params);
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        observable.notify(buildConsoleLog(params, api, handlingStack));
      });
    };
    return function () {
      globalConsole[api] = originalConsoleApi;
    };
  });
}
function buildConsoleLog(params, api, handlingStack) {
  var message = params.map(function (param) {
    return formatConsoleParameters(param);
  }).join(' ');
  var stack;
  var fingerprint;
  var causes;
  if (api === ConsoleApiName.error) {
    var firstErrorParam = find(params, function (param) {
      return param instanceof Error;
    });
    stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
    fingerprint = tryToGetFingerprint(firstErrorParam);
    causes = firstErrorParam ? flattenErrorCauses(firstErrorParam, 'console') : undefined;
  }
  return {
    api: api,
    message: message,
    stack: stack,
    handlingStack: handlingStack,
    fingerprint: fingerprint,
    causes: causes
  };
}
function formatConsoleParameters(param) {
  if (typeof param === 'string') {
    return sanitize(param);
  }
  if (param instanceof Error) {
    return formatErrorMessage(computeStackTrace(param));
  }
  return jsonStringify(sanitize(param), undefined, 2);
}

function createContextManager(customerDataTracker) {
  var context = {};
  var changeObservable = new Observable();
  var contextManager = {
    getContext: function () {
      return deepClone(context);
    },
    setContext: function (newContext) {
      if (getType(newContext) === 'object') {
        context = sanitize(newContext);
        customerDataTracker.updateCustomerData(context);
      } else {
        contextManager.clearContext();
      }
      changeObservable.notify();
    },
    setContextProperty: function (key, property) {
      context[key] = sanitize(property);
      customerDataTracker.updateCustomerData(context);
      changeObservable.notify();
    },
    removeContextProperty: function (key) {
      delete context[key];
      customerDataTracker.updateCustomerData(context);
      changeObservable.notify();
    },
    clearContext: function () {
      context = {};
      customerDataTracker.resetCustomerData();
      changeObservable.notify();
    },
    changeObservable: changeObservable
  };
  return contextManager;
}

var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function storeContextManager(configuration, contextManager, productKey, customerDataType) {
  var storageKey = buildStorageKey(productKey, customerDataType);
  storageListeners.push(addEventListener(configuration, window, DOM_EVENT.STORAGE, function (_a) {
    var key = _a.key;
    if (storageKey === key) {
      synchronizeWithStorage();
    }
  }));
  contextManager.changeObservable.subscribe(dumpToStorage);
  contextManager.setContext(combine(getFromStorage(), contextManager.getContext()));
  function synchronizeWithStorage() {
    contextManager.setContext(getFromStorage());
  }
  function dumpToStorage() {
    localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
  }
  function getFromStorage() {
    var rawContext = localStorage.getItem(storageKey);
    return rawContext !== null ? JSON.parse(rawContext) : {};
  }
}
function buildStorageKey(productKey, customerDataType) {
  return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}

// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * ONE_KIBI_BYTE;
// We observed that the compression ratio is around 8 in general, but we also want to keep a margin
// because some data might not be compressed (ex: last view update on page exit). We chose 16KiB
// because it is also the limit of the 'batchBytesCount' that we use for RUM and Logs data, but this
// is a bit arbitrary.
var CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT = 16 * ONE_KIBI_BYTE;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createCustomerDataTrackerManager(compressionStatus) {
  if (compressionStatus === void 0) {
    compressionStatus = 2 /* CustomerDataCompressionStatus.Disabled */;
  }
  var customerDataTrackers = new Map();
  var alreadyWarned = false;
  function checkCustomerDataLimit(initialBytesCount) {
    if (initialBytesCount === void 0) {
      initialBytesCount = 0;
    }
    if (alreadyWarned || compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
      return;
    }
    var bytesCountLimit = compressionStatus === 2 /* CustomerDataCompressionStatus.Disabled */ ? CUSTOMER_DATA_BYTES_LIMIT : CUSTOMER_COMPRESSED_DATA_BYTES_LIMIT;
    var bytesCount = initialBytesCount;
    customerDataTrackers.forEach(function (tracker) {
      bytesCount += tracker.getBytesCount();
    });
    if (bytesCount > bytesCountLimit) {
      displayCustomerDataLimitReachedWarning(bytesCountLimit);
      alreadyWarned = true;
    }
  }
  return {
    /**
     * Creates a detached tracker. The manager will not store a reference to that tracker, and the
     * bytes count will be counted independently from other detached trackers.
     *
     * This is particularly useful when we don't know when the tracker will be unused, so we don't
     * leak memory (ex: when used in Logger instances).
     */
    createDetachedTracker: function () {
      var tracker = createCustomerDataTracker(function () {
        return checkCustomerDataLimit(tracker.getBytesCount());
      });
      return tracker;
    },
    /**
     * Creates a tracker if it doesn't exist, and returns it.
     */
    getOrCreateTracker: function (type) {
      if (!customerDataTrackers.has(type)) {
        customerDataTrackers.set(type, createCustomerDataTracker(checkCustomerDataLimit));
      }
      return customerDataTrackers.get(type);
    },
    setCompressionStatus: function (newCompressionStatus) {
      if (compressionStatus === 0 /* CustomerDataCompressionStatus.Unknown */) {
        compressionStatus = newCompressionStatus;
        checkCustomerDataLimit();
      }
    },
    getCompressionStatus: function () {
      return compressionStatus;
    },
    stop: function () {
      customerDataTrackers.forEach(function (tracker) {
        return tracker.stop();
      });
      customerDataTrackers.clear();
    }
  };
}
function createCustomerDataTracker(checkCustomerDataLimit) {
  var bytesCountCache = 0;
  // Throttle the bytes computation to minimize the impact on performance.
  // Especially useful if the user call context APIs synchronously multiple times in a row
  var _a = throttle(function (context) {
      bytesCountCache = computeBytesCount(jsonStringify(context));
      checkCustomerDataLimit();
    }, BYTES_COMPUTATION_THROTTLING_DELAY),
    computeBytesCountThrottled = _a.throttled,
    cancelComputeBytesCount = _a.cancel;
  var resetBytesCount = function () {
    cancelComputeBytesCount();
    bytesCountCache = 0;
  };
  return {
    updateCustomerData: function (context) {
      if (isEmptyObject(context)) {
        resetBytesCount();
      } else {
        computeBytesCountThrottled(context);
      }
    },
    resetCustomerData: resetBytesCount,
    getBytesCount: function () {
      return bytesCountCache;
    },
    stop: function () {
      cancelComputeBytesCount();
    }
  };
}
function displayCustomerDataLimitReachedWarning(bytesCountLimit) {
  display.warn("Customer data exceeds the recommended ".concat(bytesCountLimit / ONE_KIBI_BYTE, "KiB threshold. More details: ").concat(DOCS_ORIGIN, "/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-threshold-warning"));
}

/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
  var reader = stream.getReader();
  var chunks = [];
  var readBytesCount = 0;
  readMore();
  function readMore() {
    reader.read().then(monitor(function (result) {
      if (result.done) {
        onDone();
        return;
      }
      if (options.collectStreamBody) {
        chunks.push(result.value);
      }
      readBytesCount += result.value.length;
      if (readBytesCount > options.bytesLimit) {
        onDone();
      } else {
        readMore();
      }
    }), monitor(function (error) {
      return callback(error);
    }));
  }
  function onDone() {
    reader.cancel().catch(
    // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
    // as an unhandled rejection
    noop);
    var bytes;
    var limitExceeded;
    if (options.collectStreamBody) {
      var completeBuffer_1;
      if (chunks.length === 1) {
        // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
        // use it directly.
        completeBuffer_1 = chunks[0];
      } else {
        // else, we need to copy buffers into a larger buffer to concatenate them.
        completeBuffer_1 = new Uint8Array(readBytesCount);
        var offset_1 = 0;
        chunks.forEach(function (chunk) {
          completeBuffer_1.set(chunk, offset_1);
          offset_1 += chunk.length;
        });
      }
      bytes = completeBuffer_1.slice(0, options.bytesLimit);
      limitExceeded = completeBuffer_1.length > options.bytesLimit;
    }
    callback(undefined, bytes, limitExceeded);
  }
}

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
  return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getInitCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
  var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || getInitCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
  var value = window._DATADOG_SYNTHETICS_RESULT_ID || getInitCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
  return typeof value === 'string' ? value : undefined;
}

/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
  // We shallow clone only to prevent mutation of user data.
  var user = assign({}, newUser);
  var keys = ['id', 'name', 'email'];
  keys.forEach(function (key) {
    if (key in user) {
      user[key] = String(user[key]);
    }
  });
  return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
  var isValid = getType(newUser) === 'object';
  if (!isValid) {
    display.error('Unsupported user:', newUser);
  }
  return isValid;
}

function isMatchOption(item) {
  var itemType = getType(item);
  return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
  if (useStartsWith === void 0) {
    useStartsWith = false;
  }
  return list.some(function (item) {
    try {
      if (typeof item === 'function') {
        return item(value);
      } else if (item instanceof RegExp) {
        return item.test(value);
      } else if (typeof item === 'string') {
        return useStartsWith ? startsWith(value, item) : item === value;
      }
    } catch (e) {
      display.error(e);
    }
    return false;
  });
}

function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
  return {
    context: globalContextManager.getContext(),
    user: userContextManager.getContext(),
    hasReplay: recorderApi.isRecording() ? true : undefined
  };
}

function isTracingOption(item) {
  var expectedItem = item;
  return getType(expectedItem) === 'object' && isMatchOption(expectedItem.match) && Array.isArray(expectedItem.propagatorTypes);
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
  if (context.status === 0 && !context.isAborted) {
    context.traceId = undefined;
    context.spanId = undefined;
    context.traceSampled = undefined;
  }
}
function startTracer(configuration, sessionManager) {
  return {
    clearTracingIfNeeded: clearTracingIfNeeded,
    traceFetch: function (context) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        var _a;
        if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
          context.input = new Request(context.input);
          Object.keys(tracingHeaders).forEach(function (key) {
            context.input.headers.append(key, tracingHeaders[key]);
          });
        } else {
          context.init = shallowClone(context.init);
          var headers_1 = [];
          if (context.init.headers instanceof Headers) {
            context.init.headers.forEach(function (value, key) {
              headers_1.push([key, value]);
            });
          } else if (Array.isArray(context.init.headers)) {
            context.init.headers.forEach(function (header) {
              headers_1.push(header);
            });
          } else if (context.init.headers) {
            Object.keys(context.init.headers).forEach(function (key) {
              headers_1.push([key, context.init.headers[key]]);
            });
          }
          context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
        }
      });
    },
    traceXhr: function (context, xhr) {
      return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
        Object.keys(tracingHeaders).forEach(function (name) {
          xhr.setRequestHeader(name, tracingHeaders[name]);
        });
      });
    }
  };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
  if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
    return;
  }
  var tracingOption = find(configuration.allowedTracingUrls, function (tracingOption) {
    return matchList([tracingOption.match], context.url, true);
  });
  if (!tracingOption) {
    return;
  }
  context.traceSampled = !isNumber(configuration.traceSampleRate) || performDraw(configuration.traceSampleRate);
  if (!context.traceSampled && configuration.traceContextInjection !== TraceContextInjection.ALL) {
    return;
  }
  context.traceId = new TraceIdentifier();
  context.spanId = new TraceIdentifier();
  inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
  return getCrypto() !== undefined;
}
function getCrypto() {
  return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
  var tracingHeaders = {};
  propagatorTypes.forEach(function (propagatorType) {
    switch (propagatorType) {
      case 'datadog':
        {
          assign(tracingHeaders, {
            'x-datadog-origin': 'rum',
            'x-datadog-parent-id': spanId.toDecimalString(),
            'x-datadog-sampling-priority': traceSampled ? '1' : '0',
            'x-datadog-trace-id': traceId.toDecimalString()
          });
          break;
        }
      // https://www.w3.org/TR/trace-context/
      case 'tracecontext':
        {
          assign(tracingHeaders, {
            traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0')
          });
          break;
        }
      // https://github.com/openzipkin/b3-propagation
      case 'b3':
        {
          assign(tracingHeaders, {
            b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0')
          });
          break;
        }
      case 'b3multi':
        {
          assign(tracingHeaders, {
            'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
            'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
            'X-B3-Sampled': traceSampled ? '1' : '0'
          });
          break;
        }
    }
  });
  return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */function () {
  function TraceIdentifier() {
    this.buffer = new Uint8Array(8);
    getCrypto().getRandomValues(this.buffer);
    this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
  }
  TraceIdentifier.prototype.toString = function (radix) {
    var high = this.readInt32(0);
    var low = this.readInt32(4);
    var str = '';
    do {
      var mod = high % radix * 4294967296 + low;
      high = Math.floor(high / radix);
      low = Math.floor(mod / radix);
      str = (mod % radix).toString(radix) + str;
    } while (high || low);
    return str;
  };
  /**
   * Format used everywhere except the trace intake
   */
  TraceIdentifier.prototype.toDecimalString = function () {
    return this.toString(10);
  };
  /**
   * Format used by OTel headers
   */
  TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
    var traceId = this.toString(16);
    return Array(17 - traceId.length).join('0') + traceId;
  };
  TraceIdentifier.prototype.readInt32 = function (offset) {
    return this.buffer[offset] * 16777216 + (this.buffer[offset + 1] << 16) + (this.buffer[offset + 2] << 8) + this.buffer[offset + 3];
  };
  return TraceIdentifier;
}();
/* eslint-enable no-bitwise */

var DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration) {
  var _a, _b;
  if (!initConfiguration.applicationId) {
    display.error('Application ID is not configured, no RUM data will be collected.');
    return;
  }
  if (initConfiguration.sessionReplaySampleRate !== undefined && !isPercentage(initConfiguration.sessionReplaySampleRate)) {
    display.error('Session Replay Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.traceSampleRate !== undefined && !isPercentage(initConfiguration.traceSampleRate)) {
    display.error('Trace Sample Rate should be a number between 0 and 100');
    return;
  }
  if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
    display.error('Excluded Activity Urls should be an array');
    return;
  }
  var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
  if (!allowedTracingUrls) {
    return;
  }
  var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
  if (!baseConfiguration) {
    return;
  }
  return assign({
    applicationId: initConfiguration.applicationId,
    version: initConfiguration.version || undefined,
    actionNameAttribute: initConfiguration.actionNameAttribute,
    sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
    startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
    traceSampleRate: initConfiguration.traceSampleRate,
    allowedTracingUrls: allowedTracingUrls,
    excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
    workerUrl: initConfiguration.workerUrl,
    compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
    trackUserInteractions: !!initConfiguration.trackUserInteractions,
    trackViewsManually: !!initConfiguration.trackViewsManually,
    trackResources: !!initConfiguration.trackResources,
    trackLongTasks: !!initConfiguration.trackLongTasks,
    subdomain: initConfiguration.subdomain,
    defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel) ? initConfiguration.defaultPrivacyLevel : DefaultPrivacyLevel.MASK,
    enablePrivacyForActionName: !!initConfiguration.enablePrivacyForActionName,
    customerDataTelemetrySampleRate: 1,
    traceContextInjection: objectHasValue(TraceContextInjection, initConfiguration.traceContextInjection) ? initConfiguration.traceContextInjection : TraceContextInjection.ALL,
    plugins: isExperimentalFeatureEnabled(ExperimentalFeature.PLUGINS) && initConfiguration.plugins || []
  }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
  if (initConfiguration.allowedTracingUrls !== undefined) {
    if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
      display.error('Allowed Tracing URLs should be an array');
      return;
    }
    if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
      display.error('Service needs to be configured when tracing is enabled');
      return;
    }
    // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
    var tracingOptions_1 = [];
    initConfiguration.allowedTracingUrls.forEach(function (option) {
      if (isMatchOption(option)) {
        tracingOptions_1.push({
          match: option,
          propagatorTypes: DEFAULT_PROPAGATOR_TYPES
        });
      } else if (isTracingOption(option)) {
        tracingOptions_1.push(option);
      } else {
        display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
      }
    });
    return tracingOptions_1;
  }
  return [];
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
  var usedTracingPropagators = new Set();
  if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
    configuration.allowedTracingUrls.forEach(function (option) {
      if (isMatchOption(option)) {
        DEFAULT_PROPAGATOR_TYPES.forEach(function (propagatorType) {
          return usedTracingPropagators.add(propagatorType);
        });
      } else if (getType(option) === 'object' && Array.isArray(option.propagatorTypes)) {
        // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
        option.propagatorTypes.forEach(function (propagatorType) {
          return usedTracingPropagators.add(propagatorType);
        });
      }
    });
  }
  return arrayFrom(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
  var _a;
  var baseSerializedConfiguration = serializeConfiguration(configuration);
  return assign({
    session_replay_sample_rate: configuration.sessionReplaySampleRate,
    start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
    trace_sample_rate: configuration.traceSampleRate,
    trace_context_injection: configuration.traceContextInjection,
    action_name_attribute: configuration.actionNameAttribute,
    use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
    selected_tracing_propagators: getSelectedTracingPropagators(configuration),
    default_privacy_level: configuration.defaultPrivacyLevel,
    enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
    use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
    use_worker_url: !!configuration.workerUrl,
    compress_intake_requests: configuration.compressIntakeRequests,
    track_views_manually: configuration.trackViewsManually,
    track_user_interactions: configuration.trackUserInteractions,
    track_resources: configuration.trackResources,
    track_long_task: configuration.trackLongTasks,
    plugins: (_a = configuration.plugins) === null || _a === void 0 ? void 0 : _a.map(function (plugin) {
      var _a;
      return assign({
        name: plugin.name
      }, (_a = plugin.getConfigurationTelemetry) === null || _a === void 0 ? void 0 : _a.call(plugin));
    })
  }, baseSerializedConfiguration);
}

var REMOTE_CONFIGURATION_URL = 'https://d3uc069fcn7uxw.cloudfront.net/configuration';
function fetchAndApplyRemoteConfiguration(initConfiguration, callback) {
  fetchRemoteConfiguration(initConfiguration, function (remoteInitConfiguration) {
    callback(applyRemoteConfiguration(initConfiguration, remoteInitConfiguration));
  });
}
function applyRemoteConfiguration(initConfiguration, remoteInitConfiguration) {
  return assign({}, initConfiguration, remoteInitConfiguration);
}
function fetchRemoteConfiguration(configuration, callback) {
  var xhr = new XMLHttpRequest();
  addEventListener(configuration, xhr, 'load', function () {
    if (xhr.status === 200) {
      callback(JSON.parse(xhr.responseText));
    } else {
      displayRemoteConfigurationFetchingError();
    }
  });
  addEventListener(configuration, xhr, 'error', function () {
    displayRemoteConfigurationFetchingError();
  });
  xhr.open('GET', "".concat(REMOTE_CONFIGURATION_URL, "/").concat(encodeURIComponent(configuration.remoteConfigurationId), ".json"));
  xhr.send();
}
function displayRemoteConfigurationFetchingError() {
  display.error('Error fetching the remote configuration.');
}

function startVitalCollection(lifeCycle, pageStateHistory) {
  function isValid(vital) {
    return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, vital.startClocks.relative, vital.duration);
  }
  function addDurationVital(vital) {
    if (isValid(vital)) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processVital(vital, true));
    }
  }
  return {
    addDurationVital: addDurationVital,
    startDurationVital: function (startVital) {
      return createVitalInstance(function (vital) {
        addDurationVital(vital);
      }, startVital);
    }
  };
}
function createVitalInstance(stopCallback, vitalStart) {
  var startClocks = clocksNow();
  var stopClocks;
  return {
    stop: function (vitalStop) {
      if (stopClocks) {
        return;
      }
      stopClocks = clocksNow();
      stopCallback(buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks));
    }
  };
}
function buildDurationVital(vitalStart, startClocks, vitalStop, stopClocks) {
  var _a;
  if (vitalStop === void 0) {
    vitalStop = {};
  }
  return {
    name: vitalStart.name,
    type: "duration" /* VitalType.DURATION */,
    startClocks: startClocks,
    duration: elapsed(startClocks.timeStamp, stopClocks.timeStamp),
    context: combine(vitalStart.context, vitalStop.context),
    details: (_a = vitalStop.details) !== null && _a !== void 0 ? _a : vitalStart.details
  };
}
function processVital(vital, valueComputedBySdk) {
  var rawRumEvent = {
    date: vital.startClocks.timeStamp,
    vital: {
      id: generateUUID(),
      type: vital.type,
      name: vital.name,
      duration: toServerDuration(vital.duration),
      details: vital.details
    },
    type: "vital" /* RumEventType.VITAL */
  };
  if (valueComputedBySdk) {
    rawRumEvent._dd = {
      vital: {
        computed_value: true
      }
    };
  }
  return {
    rawRumEvent: rawRumEvent,
    startTime: vital.startClocks.relative,
    customerContext: vital.context,
    domainContext: {}
  };
}

function callPluginsMethod(plugins, methodName, parameter) {
  if (!plugins) {
    return;
  }
  for (var _i = 0, plugins_1 = plugins; _i < plugins_1.length; _i++) {
    var plugin = plugins_1[_i];
    var method = plugin[methodName];
    if (method) {
      method(parameter);
    }
  }
}

function createPreStartStrategy(_a, getCommonContext, trackingConsentState, doStartRum) {
  var ignoreInitIfSyntheticsWillInjectRum = _a.ignoreInitIfSyntheticsWillInjectRum,
    startDeflateWorker = _a.startDeflateWorker;
  var bufferApiCalls = new BoundedBuffer();
  var firstStartViewCall;
  var deflateWorker;
  var cachedInitConfiguration;
  var cachedConfiguration;
  var trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
  function tryStartRum() {
    if (!cachedInitConfiguration || !cachedConfiguration || !trackingConsentState.isGranted()) {
      return;
    }
    trackingConsentStateSubscription.unsubscribe();
    var initialViewOptions;
    if (cachedConfiguration.trackViewsManually) {
      if (!firstStartViewCall) {
        return;
      }
      // An initial view is always created when starting RUM.
      // When tracking views automatically, any startView call before RUM start creates an extra
      // view.
      // When tracking views manually, we use the ViewOptions from the first startView call as the
      // initial view options, and we remove the actual startView call so we don't create an extra
      // view.
      bufferApiCalls.remove(firstStartViewCall.callback);
      initialViewOptions = firstStartViewCall.options;
    }
    var startRumResult = doStartRum(cachedConfiguration, deflateWorker, initialViewOptions);
    bufferApiCalls.drain(startRumResult);
  }
  function doInit(initConfiguration) {
    var eventBridgeAvailable = canUseEventBridge();
    if (eventBridgeAvailable) {
      initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
    }
    // Update the exposed initConfiguration to reflect the bridge and remote configuration overrides
    cachedInitConfiguration = initConfiguration;
    addTelemetryConfiguration(serializeRumConfiguration(initConfiguration));
    if (cachedConfiguration) {
      displayAlreadyInitializedError('DD_RUM', initConfiguration);
      return;
    }
    var configuration = validateAndBuildRumConfiguration(initConfiguration);
    if (!configuration) {
      return;
    }
    if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
      display.warn('No storage available for session. We will not send any data.');
      return;
    }
    if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
      deflateWorker = startDeflateWorker(configuration, 'Datadog RUM',
      // Worker initialization can fail asynchronously, especially in Firefox where even CSP
      // issues are reported asynchronously. For now, the SDK will continue its execution even if
      // data won't be sent to Datadog. We could improve this behavior in the future.
      noop);
      if (!deflateWorker) {
        // `startDeflateWorker` should have logged an error message explaining the issue
        return;
      }
    }
    cachedConfiguration = configuration;
    // Instrumuent fetch to track network requests
    // This is needed in case the consent is not granted and some cutsomer
    // library (Apollo Client) is storing uninstrumented fetch to be used later
    // The subscrption is needed so that the instrumentation process is completed
    initFetchObservable().subscribe(noop);
    trackingConsentState.tryToInit(configuration.trackingConsent);
    tryStartRum();
  }
  var addDurationVital = function (vital) {
    bufferApiCalls.add(function (startRumResult) {
      return startRumResult.addDurationVital(vital);
    });
  };
  return {
    init: function (initConfiguration, publicApi) {
      if (!initConfiguration) {
        display.error('Missing configuration');
        return;
      }
      // Set the experimental feature flags as early as possible, so we can use them in most places
      initFeatureFlags(initConfiguration.enableExperimentalFeatures);
      // Expose the initial configuration regardless of initialization success.
      cachedInitConfiguration = initConfiguration;
      // If we are in a Synthetics test configured to automatically inject a RUM instance, we want
      // to completely discard the customer application RUM instance by ignoring their init() call.
      // But, we should not ignore the init() call from the Synthetics-injected RUM instance, so the
      // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
      if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
        return;
      }
      if (isExperimentalFeatureEnabled(ExperimentalFeature.PLUGINS)) {
        callPluginsMethod(initConfiguration.plugins, 'onInit', {
          initConfiguration: initConfiguration,
          publicApi: publicApi
        });
      }
      if (initConfiguration.remoteConfigurationId && isExperimentalFeatureEnabled(ExperimentalFeature.REMOTE_CONFIGURATION)) {
        fetchAndApplyRemoteConfiguration(initConfiguration, doInit);
      } else {
        doInit(initConfiguration);
      }
    },
    get initConfiguration() {
      return cachedInitConfiguration;
    },
    getInternalContext: noop,
    stopSession: noop,
    addTiming: function (name, time) {
      if (time === void 0) {
        time = timeStampNow();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addTiming(name, time);
      });
    },
    startView: function (options, startClocks) {
      if (startClocks === void 0) {
        startClocks = clocksNow();
      }
      var callback = function (startRumResult) {
        startRumResult.startView(options, startClocks);
      };
      bufferApiCalls.add(callback);
      if (!firstStartViewCall) {
        firstStartViewCall = {
          options: options,
          callback: callback
        };
        tryStartRum();
      }
    },
    updateViewName: function (name) {
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.updateViewName(name);
      });
    },
    addAction: function (action, commonContext) {
      if (commonContext === void 0) {
        commonContext = getCommonContext();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addAction(action, commonContext);
      });
    },
    addError: function (providedError, commonContext) {
      if (commonContext === void 0) {
        commonContext = getCommonContext();
      }
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addError(providedError, commonContext);
      });
    },
    addFeatureFlagEvaluation: function (key, value) {
      bufferApiCalls.add(function (startRumResult) {
        return startRumResult.addFeatureFlagEvaluation(key, value);
      });
    },
    startDurationVital: function (vitalStart) {
      return createVitalInstance(function (vital) {
        return addDurationVital(vital);
      }, vitalStart);
    },
    addDurationVital: addDurationVital
  };
}
function overrideInitConfigurationForBridge(initConfiguration) {
  var _a, _b;
  return assign({}, initConfiguration, {
    applicationId: '00000000-aaaa-0000-aaaa-000000000000',
    clientToken: 'empty',
    sessionSampleRate: 100,
    defaultPrivacyLevel: (_a = initConfiguration.defaultPrivacyLevel) !== null && _a !== void 0 ? _a : (_b = getEventBridge()) === null || _b === void 0 ? void 0 : _b.getPrivacyLevel()
  });
}

var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, options) {
  if (options === void 0) {
    options = {};
  }
  var customerDataTrackerManager = createCustomerDataTrackerManager(0 /* CustomerDataCompressionStatus.Unknown */);
  var globalContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */));
  var userContextManager = createContextManager(customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */));
  var trackingConsentState = createTrackingConsentState();
  function getCommonContext() {
    return buildCommonContext(globalContextManager, userContextManager, recorderApi);
  }
  var strategy = createPreStartStrategy(options, getCommonContext, trackingConsentState, function (configuration, deflateWorker, initialViewOptions) {
    if (isExperimentalFeatureEnabled(ExperimentalFeature.CUSTOM_VITALS)) {
      rumPublicApi.startDurationVital = monitor(function (name, options) {
        addTelemetryUsage({
          feature: 'start-duration-vital'
        });
        return strategy.startDurationVital({
          name: sanitize(name),
          context: sanitize(options === null || options === void 0 ? void 0 : options.context),
          details: sanitize(options === null || options === void 0 ? void 0 : options.details)
        });
      });
      rumPublicApi.addDurationVital = monitor(function (name, options) {
        addTelemetryUsage({
          feature: 'add-duration-vital'
        });
        strategy.addDurationVital({
          name: sanitize(name),
          type: "duration" /* VitalType.DURATION */,
          startClocks: timeStampToClocks(options.startTime),
          duration: options.duration,
          context: sanitize(options === null || options === void 0 ? void 0 : options.context),
          details: sanitize(options === null || options === void 0 ? void 0 : options.details)
        });
      });
      rumPublicApi.stopDurationVital = noop;
    }
    if (isExperimentalFeatureEnabled(ExperimentalFeature.UPDATE_VIEW_NAME)) {
      rumPublicApi.updateViewName = monitor(function (name) {
        strategy.updateViewName(name);
      });
    }
    if (configuration.storeContextsAcrossPages) {
      storeContextManager(configuration, globalContextManager, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
      storeContextManager(configuration, userContextManager, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
    }
    customerDataTrackerManager.setCompressionStatus(deflateWorker ? 1 /* CustomerDataCompressionStatus.Enabled */ : 2 /* CustomerDataCompressionStatus.Disabled */);
    var startRumResult = startRumImpl(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, deflateWorker && options.createDeflateEncoder ? function (streamId) {
      return options.createDeflateEncoder(configuration, deflateWorker, streamId);
    } : createIdentityEncoder, trackingConsentState);
    recorderApi.onRumStart(startRumResult.lifeCycle, configuration, startRumResult.session, startRumResult.viewContexts, deflateWorker);
    strategy = createPostStartStrategy(strategy, startRumResult);
    return startRumResult;
  });
  var startView = monitor(function (options) {
    var sanitizedOptions = typeof options === 'object' ? options : {
      name: options
    };
    strategy.startView(sanitizedOptions);
    addTelemetryUsage({
      feature: 'start-view'
    });
  });
  var rumPublicApi = makePublicApi({
    init: monitor(function (initConfiguration) {
      return strategy.init(initConfiguration, rumPublicApi);
    }),
    setTrackingConsent: monitor(function (trackingConsent) {
      trackingConsentState.update(trackingConsent);
      addTelemetryUsage({
        feature: 'set-tracking-consent',
        tracking_consent: trackingConsent
      });
    }),
    setGlobalContext: monitor(function (context) {
      globalContextManager.setContext(context);
      addTelemetryUsage({
        feature: 'set-global-context'
      });
    }),
    getGlobalContext: monitor(function () {
      return globalContextManager.getContext();
    }),
    setGlobalContextProperty: monitor(function (key, value) {
      globalContextManager.setContextProperty(key, value);
      addTelemetryUsage({
        feature: 'set-global-context'
      });
    }),
    removeGlobalContextProperty: monitor(function (key) {
      return globalContextManager.removeContextProperty(key);
    }),
    clearGlobalContext: monitor(function () {
      return globalContextManager.clearContext();
    }),
    getInternalContext: monitor(function (startTime) {
      return strategy.getInternalContext(startTime);
    }),
    getInitConfiguration: monitor(function () {
      return deepClone(strategy.initConfiguration);
    }),
    addAction: function (name, context) {
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        strategy.addAction({
          name: sanitize(name),
          context: sanitize(context),
          startClocks: clocksNow(),
          type: "custom" /* ActionType.CUSTOM */,
          handlingStack: handlingStack
        });
        addTelemetryUsage({
          feature: 'add-action'
        });
      });
    },
    addError: function (error, context) {
      var handlingStack = createHandlingStack();
      callMonitored(function () {
        strategy.addError({
          error: error,
          // Do not sanitize error here, it is needed unserialized by computeRawError()
          handlingStack: handlingStack,
          context: sanitize(context),
          startClocks: clocksNow()
        });
        addTelemetryUsage({
          feature: 'add-error'
        });
      });
    },
    addTiming: monitor(function (name, time) {
      // TODO: next major decide to drop relative time support or update its behaviour
      strategy.addTiming(sanitize(name), time);
    }),
    setUser: monitor(function (newUser) {
      if (checkUser(newUser)) {
        userContextManager.setContext(sanitizeUser(newUser));
      }
      addTelemetryUsage({
        feature: 'set-user'
      });
    }),
    getUser: monitor(function () {
      return userContextManager.getContext();
    }),
    setUserProperty: monitor(function (key, property) {
      var _a;
      var sanitizedProperty = sanitizeUser((_a = {}, _a[key] = property, _a))[key];
      userContextManager.setContextProperty(key, sanitizedProperty);
      addTelemetryUsage({
        feature: 'set-user'
      });
    }),
    removeUserProperty: monitor(function (key) {
      return userContextManager.removeContextProperty(key);
    }),
    clearUser: monitor(function () {
      return userContextManager.clearContext();
    }),
    startView: startView,
    stopSession: monitor(function () {
      strategy.stopSession();
      addTelemetryUsage({
        feature: 'stop-session'
      });
    }),
    addFeatureFlagEvaluation: monitor(function (key, value) {
      strategy.addFeatureFlagEvaluation(sanitize(key), sanitize(value));
      addTelemetryUsage({
        feature: 'add-feature-flag-evaluation'
      });
    }),
    getSessionReplayLink: monitor(function () {
      return recorderApi.getSessionReplayLink();
    }),
    startSessionReplayRecording: monitor(function (options) {
      recorderApi.start(options);
      addTelemetryUsage({
        feature: 'start-session-replay-recording',
        force: options === null || options === void 0 ? void 0 : options.force
      });
    }),
    stopSessionReplayRecording: monitor(function () {
      return recorderApi.stop();
    })
  });
  return rumPublicApi;
}
function createPostStartStrategy(preStartStrategy, startRumResult) {
  return assign({
    init: function (initConfiguration) {
      displayAlreadyInitializedError('DD_RUM', initConfiguration);
    },
    initConfiguration: preStartStrategy.initConfiguration
  }, startRumResult);
}

function createDOMMutationObservable() {
  var MutationObserver = getMutationObserverConstructor();
  return new Observable(function (observable) {
    if (!MutationObserver) {
      return;
    }
    var observer = new MutationObserver(monitor(function () {
      return observable.notify();
    }));
    observer.observe(document, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  });
}
function getMutationObserverConstructor() {
  var constructor;
  var browserWindow = window;
  // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
  // global MutationObserver constructor with a patched version to support the context propagation.
  // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
  // component: on some occasions, the callback is being called in an infinite loop, causing the
  // page to freeze (even if the callback is completely empty).
  //
  // To work around this issue, we try to get the original MutationObserver constructor stored by
  // Zone.js.
  //
  // [1] https://github.com/angular/angular/issues/26948
  // [2] https://github.com/angular/angular/issues/31712
  if (browserWindow.Zone) {
    // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
    //
    // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
    constructor = getZoneJsOriginalValue(browserWindow, 'MutationObserver');
    if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
      // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
      // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
      // instance in its properties[4]. Let's get the original MutationObserver constructor from
      // there.
      //
      // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
      var patchedInstance = new browserWindow.MutationObserver(noop);
      var originalInstance = getZoneJsOriginalValue(patchedInstance, 'originalInstance');
      constructor = originalInstance && originalInstance.constructor;
    }
  }
  if (!constructor) {
    constructor = browserWindow.MutationObserver;
  }
  return constructor;
}

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [["document" /* ResourceType.DOCUMENT */, function (initiatorType) {
  return FAKE_INITIAL_DOCUMENT === initiatorType;
}], ["xhr" /* ResourceType.XHR */, function (initiatorType) {
  return 'xmlhttprequest' === initiatorType;
}], ["fetch" /* ResourceType.FETCH */, function (initiatorType) {
  return 'fetch' === initiatorType;
}], ["beacon" /* ResourceType.BEACON */, function (initiatorType) {
  return 'beacon' === initiatorType;
}], ["css" /* ResourceType.CSS */, function (_, path) {
  return /\.css$/i.test(path);
}], ["js" /* ResourceType.JS */, function (_, path) {
  return /\.js$/i.test(path);
}], ["image" /* ResourceType.IMAGE */, function (initiatorType, path) {
  return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
}], ["font" /* ResourceType.FONT */, function (_, path) {
  return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
}], ["media" /* ResourceType.MEDIA */, function (initiatorType, path) {
  return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
}]];
function computeResourceKind(timing) {
  var url = timing.name;
  if (!isValidUrl(url)) {
    addTelemetryDebug("Failed to construct URL for \"".concat(timing.name, "\""));
    return "other" /* ResourceType.OTHER */;
  }
  var path = getPathName(url);
  for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
    var _a = RESOURCE_TYPES_1[_i],
      type = _a[0],
      isType = _a[1];
    if (isType(timing.initiatorType, path)) {
      return type;
    }
  }
  return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
  var numbers = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    numbers[_i] = arguments[_i];
  }
  for (var i = 1; i < numbers.length; i += 1) {
    if (numbers[i - 1] > numbers[i]) {
      return false;
    }
  }
  return true;
}
function isRequestKind(timing) {
  return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
  var duration = entry.duration,
    startTime = entry.startTime,
    responseEnd = entry.responseEnd;
  // Safari duration is always 0 on timings blocked by cross origin policies.
  if (duration === 0 && startTime < responseEnd) {
    return toServerDuration(elapsed(startTime, responseEnd));
  }
  return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
  if (!isValidEntry(entry)) {
    return undefined;
  }
  var startTime = entry.startTime,
    fetchStart = entry.fetchStart,
    redirectStart = entry.redirectStart,
    redirectEnd = entry.redirectEnd,
    domainLookupStart = entry.domainLookupStart,
    domainLookupEnd = entry.domainLookupEnd,
    connectStart = entry.connectStart,
    secureConnectionStart = entry.secureConnectionStart,
    connectEnd = entry.connectEnd,
    requestStart = entry.requestStart,
    responseStart = entry.responseStart,
    responseEnd = entry.responseEnd;
  var details = {
    download: formatTiming(startTime, responseStart, responseEnd),
    first_byte: formatTiming(startTime, requestStart, responseStart)
  };
  // Make sure a connection occurred
  if (fetchStart < connectEnd) {
    details.connect = formatTiming(startTime, connectStart, connectEnd);
    // Make sure a secure connection occurred
    if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) {
      details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
    }
  }
  // Make sure a domain lookup occurred
  if (fetchStart < domainLookupEnd) {
    details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
  }
  // Make sure a redirection occurred
  if (startTime < redirectEnd) {
    details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
  }
  return details;
}
function isValidEntry(entry) {
  if (isExperimentalFeatureEnabled(ExperimentalFeature.TOLERANT_RESOURCE_TIMINGS)) {
    return true;
  }
  // Ensure timings are in the right order. On top of filtering out potential invalid
  // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
  // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
  // it.
  var areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
  var areRedirectionTimingsInOrder = hasRedirection(entry) ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
  return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function hasRedirection(entry) {
  return entry.redirectEnd > entry.startTime;
}
function formatTiming(origin, start, end) {
  if (origin <= start && start <= end) {
    return {
      duration: toServerDuration(elapsed(start, end)),
      start: toServerDuration(elapsed(origin, start))
    };
  }
}
function computeSize(entry) {
  // Make sure a request actually occurred
  if (entry.startTime < entry.responseStart) {
    var encodedBodySize = entry.encodedBodySize,
      decodedBodySize = entry.decodedBodySize,
      transferSize = entry.transferSize;
    return {
      size: decodedBodySize,
      encoded_body_size: encodedBodySize,
      decoded_body_size: decodedBodySize,
      transfer_size: transferSize
    };
  }
  return {
    size: undefined,
    encoded_body_size: undefined,
    decoded_body_size: undefined,
    transfer_size: undefined
  };
}
function isAllowedRequestUrl(configuration, url) {
  return url && !configuration.isIntakeUrl(url);
}
var DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 24000;
function isLongDataUrl(url) {
  if (url.length <= MAX_ATTRIBUTE_VALUE_CHAR_LENGTH) {
    return false;
  } else if (url.substring(0, 5) === 'data:') {
    // Avoid String.match RangeError: Maximum call stack size exceeded
    url = url.substring(0, MAX_ATTRIBUTE_VALUE_CHAR_LENGTH);
    return true;
  }
  return false;
}
function sanitizeDataUrl(url) {
  return "".concat(url.match(DATA_URL_REGEX)[0], "[...]");
}
function computeRelativePerformanceTiming() {
  var result = {};
  var timing = performance.timing;
  for (var key in timing) {
    if (isNumber(timing[key])) {
      var numberKey = key;
      var timingElement = timing[numberKey];
      result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
    }
  }
  return result;
}

// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
  RumPerformanceEntryType["EVENT"] = "event";
  RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
  RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
  RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
  RumPerformanceEntryType["LONG_TASK"] = "longtask";
  RumPerformanceEntryType["NAVIGATION"] = "navigation";
  RumPerformanceEntryType["PAINT"] = "paint";
  RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function createPerformanceObservable(configuration, options) {
  return new Observable(function (observable) {
    var observer;
    var timeoutId;
    if (window.PerformanceObserver) {
      var isObserverInitializing_1 = true;
      var handlePerformanceEntries_1 = function (entries) {
        var rumPerformanceEntries = filterRumPerformanceEntries(configuration, entries);
        if (rumPerformanceEntries.length > 0) {
          observable.notify(rumPerformanceEntries);
        }
      };
      observer = new PerformanceObserver(monitor(function (entries) {
        // In Safari the performance observer callback is synchronous.
        // Because the buffered performance entry list can be quite large we delay the computation to prevent the SDK from blocking the main thread on init
        if (isObserverInitializing_1) {
          timeoutId = setTimeout$1(function () {
            return handlePerformanceEntries_1(entries.getEntries());
          });
        } else {
          handlePerformanceEntries_1(entries.getEntries());
        }
      }));
      try {
        observer.observe(options);
      } catch (_a) {
        // Some old browser versions (<= chrome 74 ) don't support the PerformanceObserver type and buffered options
        // In these cases, fallback to getEntriesByType and PerformanceObserver with entryTypes
        // TODO: remove this fallback in the next major version
        var fallbackSupportedEntryTypes = [RumPerformanceEntryType.RESOURCE, RumPerformanceEntryType.NAVIGATION, RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
        if (includes(fallbackSupportedEntryTypes, options.type)) {
          if (options.buffered) {
            timeoutId = setTimeout$1(function () {
              return handlePerformanceEntries_1(performance.getEntriesByType(options.type));
            });
          }
          observer.observe({
            entryTypes: [options.type]
          });
        }
      }
      isObserverInitializing_1 = false;
    }
    manageResourceTimingBufferFull(configuration);
    return function () {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
      if (timeoutId) {
        clearTimeout$1(timeoutId);
      }
    };
  });
}
var resourceTimingBufferFullListener;
function manageResourceTimingBufferFull(configuration) {
  if (!resourceTimingBufferFullListener && supportPerformanceObject$1() && 'addEventListener' in performance) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
    resourceTimingBufferFullListener = addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
      performance.clearResourceTimings();
    });
  }
  return function () {
    resourceTimingBufferFullListener === null || resourceTimingBufferFullListener === void 0 ? void 0 : resourceTimingBufferFullListener.stop();
  };
}
function supportPerformanceObject$1() {
  return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
  return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function filterRumPerformanceEntries(configuration, entries) {
  return entries.filter(function (entry) {
    return isAllowedResource(configuration, entry);
  });
}
function isAllowedResource(configuration, entry) {
  return entry.entryType === RumPerformanceEntryType.RESOURCE && isAllowedRequestUrl(configuration, entry.name);
}

function supportPerformanceObject() {
  return window.performance !== undefined && 'getEntries' in performance;
}
function startPerformanceCollection(lifeCycle, configuration) {
  var cleanupTasks = [];
  if (supportPerformanceObject()) {
    var performanceEntries_1 = performance.getEntries();
    // Because the performance entry list can be quite large
    // delay the computation to prevent the SDK from blocking the main thread on init
    setTimeout$1(function () {
      return handleRumPerformanceEntries(lifeCycle, performanceEntries_1);
    });
  }
  if (window.PerformanceObserver) {
    var handlePerformanceEntryList_1 = monitor(function (entries) {
      return handleRumPerformanceEntries(lifeCycle, entries.getEntries());
    });
    var mainEntries = [RumPerformanceEntryType.NAVIGATION, RumPerformanceEntryType.LONG_TASK, RumPerformanceEntryType.PAINT];
    var experimentalEntries = [RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT, RumPerformanceEntryType.FIRST_INPUT, RumPerformanceEntryType.LAYOUT_SHIFT, RumPerformanceEntryType.EVENT];
    try {
      // Experimental entries are not retrieved by performance.getEntries()
      // use a single PerformanceObserver with buffered flag by type
      // to get values that could happen before SDK init
      experimentalEntries.forEach(function (type) {
        var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
        observer.observe({
          type: type,
          buffered: true,
          // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
          // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
          durationThreshold: 40
        });
        cleanupTasks.push(function () {
          return observer.disconnect();
        });
      });
    } catch (e) {
      // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
      // In these cases, fallback to PerformanceObserver with entryTypes
      mainEntries.push.apply(mainEntries, experimentalEntries);
    }
    var mainObserver_1 = new PerformanceObserver(handlePerformanceEntryList_1);
    mainObserver_1.observe({
      entryTypes: mainEntries
    });
    cleanupTasks.push(function () {
      return mainObserver_1.disconnect();
    });
    if (supportPerformanceObject() && 'addEventListener' in performance) {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
      var removePerformanceListener = addEventListener(configuration, performance, 'resourcetimingbufferfull', function () {
        performance.clearResourceTimings();
      }).stop;
      cleanupTasks.push(removePerformanceListener);
    }
  }
  if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
    retrieveNavigationTiming(configuration, function (timing) {
      handleRumPerformanceEntries(lifeCycle, [timing]);
    });
  }
  if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
    var stopFirstInputTiming = retrieveFirstInputTiming(configuration, function (timing) {
      handleRumPerformanceEntries(lifeCycle, [timing]);
    }).stop;
    cleanupTasks.push(stopFirstInputTiming);
  }
  return {
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function retrieveNavigationTiming(configuration, callback) {
  function sendFakeTiming() {
    callback(assign(computeRelativePerformanceTiming(), {
      entryType: RumPerformanceEntryType.NAVIGATION
    }));
  }
  runOnReadyState(configuration, 'complete', function () {
    // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
    setTimeout$1(sendFakeTiming);
  });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
  var startTimeStamp = dateNow();
  var timingSent = false;
  var removeEventListeners = addEventListeners(configuration, window, [DOM_EVENT.CLICK, DOM_EVENT.MOUSE_DOWN, DOM_EVENT.KEY_DOWN, DOM_EVENT.TOUCH_START, DOM_EVENT.POINTER_DOWN], function (evt) {
    // Only count cancelable events, which should trigger behavior important to the user.
    if (!evt.cancelable) {
      return;
    }
    // This timing will be used to compute the "first Input delay", which is the delta between
    // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
    // (e.g. performance.now()).
    var timing = {
      entryType: RumPerformanceEntryType.FIRST_INPUT,
      processingStart: relativeNow(),
      processingEnd: relativeNow(),
      startTime: evt.timeStamp,
      duration: 0,
      // arbitrary value to avoid nullable duration and simplify INP logic
      name: ''
    };
    if (evt.type === DOM_EVENT.POINTER_DOWN) {
      sendTimingIfPointerIsNotCancelled(configuration, timing);
    } else {
      sendTiming(timing);
    }
  }, {
    passive: true,
    capture: true
  }).stop;
  return {
    stop: removeEventListeners
  };
  /**
   * Pointer events are a special case, because they can trigger main or compositor thread behavior.
   * We differentiate these cases based on whether or not we see a pointercancel event, which are
   * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
   * scrolling and pinch/zooming.
   */
  function sendTimingIfPointerIsNotCancelled(configuration, timing) {
    addEventListeners(configuration, window, [DOM_EVENT.POINTER_UP, DOM_EVENT.POINTER_CANCEL], function (event) {
      if (event.type === DOM_EVENT.POINTER_UP) {
        sendTiming(timing);
      }
    }, {
      once: true
    });
  }
  function sendTiming(timing) {
    if (!timingSent) {
      timingSent = true;
      removeEventListeners();
      // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
      // the time between now and when the page was loaded.
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
      // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
      var delay = timing.processingStart - timing.startTime;
      if (delay >= 0 && delay < dateNow() - startTimeStamp) {
        callback(timing);
      }
    }
  }
}
function handleRumPerformanceEntries(lifeCycle, entries) {
  var rumPerformanceEntries = entries.filter(function (entry) {
    return objectHasValue(RumPerformanceEntryType, entry.entryType);
  });
  var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) {
    return !isIncompleteNavigation(entry);
  });
  if (rumAllowedPerformanceEntries.length) {
    lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
  }
}
function isIncompleteNavigation(entry) {
  return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}

function getSyntheticsContext() {
  var testId = getSyntheticsTestId();
  var resultId = getSyntheticsResultId();
  if (testId && resultId) {
    return {
      test_id: testId,
      result_id: resultId,
      injected: willSyntheticsInjectRum()
    };
  }
}

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
  var clone = deepClone(object);
  var result = modifier(clone);
  objectEntries(modifiableFieldPaths).forEach(function (_a) {
    var fieldPath = _a[0],
      fieldType = _a[1];
    var newValue = get(clone, fieldPath);
    var newType = getType(newValue);
    if (newType === fieldType) {
      set(object, fieldPath, sanitize(newValue));
    } else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
      set(object, fieldPath, {});
    }
  });
  return result;
}
function get(object, path) {
  var current = object;
  for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
    var field = _a[_i];
    if (!isValidObjectContaining(current, field)) {
      return;
    }
    current = current[field];
  }
  return current;
}
function set(object, path, value) {
  var current = object;
  var fields = path.split('.');
  for (var i = 0; i < fields.length; i += 1) {
    var field = fields[i];
    if (!isValidObject(current)) {
      return;
    }
    if (i !== fields.length - 1) {
      current = current[field];
    } else {
      current[field] = value;
    }
  }
}
function isValidObject(object) {
  return getType(object) === 'object';
}
function isValidObjectContaining(object, field) {
  return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}

var VIEW_MODIFIABLE_FIELD_PATHS = {
  'view.name': 'string',
  'view.url': 'string',
  'view.referrer': 'string'
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
  context: 'object'
};
var ROOT_MODIFIABLE_FIELD_PATHS = {
  service: 'string',
  version: 'string'
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError) {
  var _a, _b;
  modifiableFieldPathsByEvent = (_a = {}, _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS, _a["error" /* RumEventType.ERROR */] = assign({
    'error.message': 'string',
    'error.stack': 'string',
    'error.resource.url': 'string',
    'error.fingerprint': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["resource" /* RumEventType.RESOURCE */] = assign({
    'resource.url': 'string'
  }, isExperimentalFeatureEnabled(ExperimentalFeature.WRITABLE_RESOURCE_GRAPHQL) ? {
    'resource.graphql': 'object'
  } : {}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["action" /* RumEventType.ACTION */] = assign({
    'action.target.name': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS, ROOT_MODIFIABLE_FIELD_PATHS), _a["long_task" /* RumEventType.LONG_TASK */] = assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS), _a["vital" /* RumEventType.VITAL */] = assign({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS), _a);
  var eventRateLimiters = (_b = {}, _b["error" /* RumEventType.ERROR */] = createEventRateLimiter("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError), _b["action" /* RumEventType.ACTION */] = createEventRateLimiter("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError), _b["vital" /* RumEventType.VITAL */] = createEventRateLimiter("vital" /* RumEventType.VITAL */, configuration.eventRateLimiterThreshold, reportError), _b);
  var syntheticsContext = getSyntheticsContext();
  lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
    var startTime = _a.startTime,
      rawRumEvent = _a.rawRumEvent,
      domainContext = _a.domainContext,
      savedCommonContext = _a.savedCommonContext,
      customerContext = _a.customerContext;
    var viewContext = viewContexts.findView(startTime);
    var urlContext = urlContexts.findUrl(startTime);
    var session = sessionManager.findTrackedSession(startTime);
    if (session && viewContext && urlContext) {
      var commonContext = savedCommonContext || getCommonContext();
      var actionId = actionContexts.findActionId(startTime);
      var rumContext = {
        _dd: {
          format_version: 2,
          drift: currentDrift(),
          configuration: {
            session_sample_rate: round(configuration.sessionSampleRate, 3),
            session_replay_sample_rate: round(configuration.sessionReplaySampleRate, 3)
          },
          browser_sdk_version: canUseEventBridge() ? "5.23.0" : undefined
        },
        application: {
          id: configuration.applicationId
        },
        date: timeStampNow(),
        service: viewContext.service || configuration.service,
        version: viewContext.version || configuration.version,
        source: 'browser',
        session: {
          id: session.id,
          type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciVisibilityContext.get() ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */
        },
        view: {
          id: viewContext.id,
          name: viewContext.name,
          url: urlContext.url,
          referrer: urlContext.referrer
        },
        action: needToAssembleWithAction(rawRumEvent) && actionId ? {
          id: actionId
        } : undefined,
        synthetics: syntheticsContext,
        ci_test: ciVisibilityContext.get(),
        display: displayContext.get(),
        connectivity: getConnectivity()
      };
      var serverRumEvent = combine(rumContext, rawRumEvent);
      serverRumEvent.context = combine(commonContext.context, customerContext);
      if (!('has_replay' in serverRumEvent.session)) {
        serverRumEvent.session.has_replay = commonContext.hasReplay;
      }
      if (serverRumEvent.type === 'view') {
        serverRumEvent.session.sampled_for_replay = session.sessionReplay === 1 /* SessionReplayState.SAMPLED */;
      }
      if (!isEmptyObject(commonContext.user)) {
        serverRumEvent.usr = commonContext.user;
      }
      if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
        if (isEmptyObject(serverRumEvent.context)) {
          delete serverRumEvent.context;
        }
        lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
      }
    }
  });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
  var _a;
  if (beforeSend) {
    var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
      return beforeSend(event, domainContext);
    });
    if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
      return false;
    }
    if (result === false) {
      display.warn("Can't dismiss view events using beforeSend!");
    }
  }
  var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
  return !rateLimitReached;
}
function needToAssembleWithAction(event) {
  return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}

/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
  return {
    get: function (startTime) {
      var viewContext = viewContexts.findView(startTime);
      var urlContext = urlContexts.findUrl(startTime);
      var session = sessionManager.findTrackedSession(startTime);
      if (session && viewContext && urlContext) {
        var actionId = actionContexts.findActionId(startTime);
        return {
          application_id: applicationId,
          session_id: session.id,
          user_action: actionId ? {
            id: actionId
          } : undefined,
          view: {
            id: viewContext.id,
            name: viewContext.name,
            referrer: urlContext.referrer,
            url: urlContext.url
          }
        };
      }
    }
  };
}

var LifeCycle = AbstractLifeCycle;

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
  var viewContextHistory = new ValueHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (view) {
    viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    viewContextHistory.closeActive(endClocks.relative);
  });
  lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (viewUpdate) {
    var currentView = viewContextHistory.find(viewUpdate.startClocks.relative);
    if (currentView && viewUpdate.name) {
      currentView.name = viewUpdate.name;
    }
  });
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    viewContextHistory.reset();
  });
  function buildViewContext(view) {
    return {
      service: view.service,
      version: view.version,
      id: view.id,
      name: view.name,
      startClocks: view.startClocks
    };
  }
  return {
    findView: function (startTime) {
      return viewContextHistory.find(startTime);
    },
    stop: function () {
      viewContextHistory.stop();
    }
  };
}

var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
  var tracer = startTracer(configuration, sessionManager);
  trackXhr(lifeCycle, configuration, tracer);
  trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
  var subscription = initXhrObservable(configuration).subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(configuration, context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceXhr(context, context.xhr);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
          duration: context.duration,
          method: context.method,
          requestIndex: context.requestIndex,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: "xhr" /* RequestType.XHR */,
          url: context.url,
          xhr: context.xhr,
          isAborted: context.isAborted,
          handlingStack: context.handlingStack
        });
        break;
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function trackFetch(lifeCycle, configuration, tracer) {
  var subscription = initFetchObservable().subscribe(function (rawContext) {
    var context = rawContext;
    if (!isAllowedRequestUrl(configuration, context.url)) {
      return;
    }
    switch (context.state) {
      case 'start':
        tracer.traceFetch(context);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7 /* LifeCycleEventType.REQUEST_STARTED */, {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;
      case 'resolve':
        waitForResponseToComplete(context, function (duration) {
          tracer.clearTracingIfNeeded(context);
          lifeCycle.notify(8 /* LifeCycleEventType.REQUEST_COMPLETED */, {
            duration: duration,
            method: context.method,
            requestIndex: context.requestIndex,
            responseType: context.responseType,
            spanId: context.spanId,
            startClocks: context.startClocks,
            status: context.status,
            traceId: context.traceId,
            traceSampled: context.traceSampled,
            type: "fetch" /* RequestType.FETCH */,
            url: context.url,
            response: context.response,
            init: context.init,
            input: context.input,
            isAborted: context.isAborted,
            handlingStack: context.handlingStack
          });
        });
        break;
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function getNextRequestIndex() {
  var result = nextRequestIndex;
  nextRequestIndex += 1;
  return result;
}
function waitForResponseToComplete(context, callback) {
  var clonedResponse = context.response && tryToClone(context.response);
  if (!clonedResponse || !clonedResponse.body) {
    // do not try to wait for the response if the clone failed, fetch error or null body
    callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
  } else {
    readBytesFromStream(clonedResponse.body, function () {
      callback(elapsed(context.startClocks.timeStamp, timeStampNow()));
    }, {
      bytesLimit: Number.POSITIVE_INFINITY,
      collectStreamBody: false
    });
  }
}

function discardNegativeDuration(duration) {
  return isNumber(duration) && duration < 0 ? undefined : duration;
}

function trackEventCounts(_a) {
  var lifeCycle = _a.lifeCycle,
    isChildEvent = _a.isChildEvent,
    _b = _a.onChange,
    callback = _b === void 0 ? noop : _b;
  var eventCounts = {
    errorCount: 0,
    longTaskCount: 0,
    resourceCount: 0,
    actionCount: 0,
    frustrationCount: 0
  };
  var subscription = lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    var _a;
    if (event.type === 'view' || event.type === 'vital' || !isChildEvent(event)) {
      return;
    }
    switch (event.type) {
      case "error" /* RumEventType.ERROR */:
        eventCounts.errorCount += 1;
        callback();
        break;
      case "action" /* RumEventType.ACTION */:
        eventCounts.actionCount += 1;
        if (event.action.frustration) {
          eventCounts.frustrationCount += event.action.frustration.type.length;
        }
        callback();
        break;
      case "long_task" /* RumEventType.LONG_TASK */:
        eventCounts.longTaskCount += 1;
        callback();
        break;
      case "resource" /* RumEventType.RESOURCE */:
        if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
          eventCounts.resourceCount += 1;
          callback();
        }
        break;
    }
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    },
    eventCounts: eventCounts
  };
}

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
  var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
  return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
  var pageActivityEndTimeoutId;
  var hasCompleted = false;
  var validationTimeoutId = setTimeout$1(monitor(function () {
    return complete({
      hadActivity: false
    });
  }), PAGE_ACTIVITY_VALIDATION_DELAY);
  var maxDurationTimeoutId = maxDuration !== undefined ? setTimeout$1(monitor(function () {
    return complete({
      hadActivity: true,
      end: timeStampNow()
    });
  }), maxDuration) : undefined;
  var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
    var isBusy = _a.isBusy;
    clearTimeout$1(validationTimeoutId);
    clearTimeout$1(pageActivityEndTimeoutId);
    var lastChangeTime = timeStampNow();
    if (!isBusy) {
      pageActivityEndTimeoutId = setTimeout$1(monitor(function () {
        return complete({
          hadActivity: true,
          end: lastChangeTime
        });
      }), PAGE_ACTIVITY_END_DELAY);
    }
  });
  var stop = function () {
    hasCompleted = true;
    clearTimeout$1(validationTimeoutId);
    clearTimeout$1(pageActivityEndTimeoutId);
    clearTimeout$1(maxDurationTimeoutId);
    pageActivitySubscription.unsubscribe();
  };
  function complete(event) {
    if (hasCompleted) {
      return;
    }
    stop();
    pageActivityEndCallback(event);
  }
  return {
    stop: stop
  };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
  return new Observable(function (observable) {
    var subscriptions = [];
    var firstRequestIndex;
    var pendingRequestsCount = 0;
    subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), createPerformanceObservable(configuration, {
      type: RumPerformanceEntryType.RESOURCE
    }).subscribe(function (entries) {
      if (entries.some(function (entry) {
        return !isExcludedUrl(configuration, entry.name);
      })) {
        notifyPageActivity();
      }
    }), lifeCycle.subscribe(7 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
      if (isExcludedUrl(configuration, startEvent.url)) {
        return;
      }
      if (firstRequestIndex === undefined) {
        firstRequestIndex = startEvent.requestIndex;
      }
      pendingRequestsCount += 1;
      notifyPageActivity();
    }), lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
      if (isExcludedUrl(configuration, request.url) || firstRequestIndex === undefined ||
      // If the request started before the tracking start, ignore it
      request.requestIndex < firstRequestIndex) {
        return;
      }
      pendingRequestsCount -= 1;
      notifyPageActivity();
    }));
    var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
    return function () {
      stopTrackingWindowOpen();
      subscriptions.forEach(function (s) {
        return s.unsubscribe();
      });
    };
    function notifyPageActivity() {
      observable.notify({
        isBusy: pendingRequestsCount > 0
      });
    }
  });
}
function isExcludedUrl(configuration, requestUrl) {
  return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
  return instrumentMethod(window, 'open', callback);
}

// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
  if (window.CSS && window.CSS.escape) {
    return window.CSS.escape(str);
  }
  // eslint-disable-next-line no-control-regex
  return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
    if (asCodePoint) {
      // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
      if (ch === '\0') {
        return '\uFFFD';
      }
      // Control characters and (dependent upon position) numbers get escaped as code points
      return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
    }
    // Other potentially-special ASCII characters get backslash-escaped
    return "\\".concat(ch);
  });
}
function elementMatches(element, selector) {
  if (element.matches) {
    return element.matches(selector);
  }
  // IE11 support
  if (element.msMatchesSelector) {
    return element.msMatchesSelector(selector);
  }
  return false;
}
/**
 * Return the parentElement of an node
 *
 * In cases where parentElement is not supported, such as in IE11 for SVG nodes, we fallback to parentNode
 */
function getParentElement(node) {
  if (node.parentElement) {
    return node.parentElement;
  }
  while (node.parentNode) {
    if (node.parentNode.nodeType === Node.ELEMENT_NODE) {
      return node.parentNode;
    }
    node = node.parentNode;
  }
  return null;
}
/**
 * Return the classList of an element or an array of classes if classList is not supported
 *
 * In cases where classList is not supported, such as in IE11 for SVG and MathML elements,
 * we fallback to using element.getAttribute('class').
 * We opt for element.getAttribute('class') over element.className because className returns an SVGAnimatedString for SVG elements.
 */
function getClassList(element) {
  var _a;
  if (element.classList) {
    return element.classList;
  }
  var classes = (_a = element.getAttribute('class')) === null || _a === void 0 ? void 0 : _a.trim();
  return classes ? classes.split(/\s+/) : [];
}
// ie11 supports WeakMap but not WeakSet
var PLACEHOLDER = 1;
var WeakSet$1 = /** @class */function () {
  function WeakSet(initialValues) {
    var _this = this;
    this.map = new WeakMap();
    if (initialValues) {
      initialValues.forEach(function (value) {
        return _this.map.set(value, PLACEHOLDER);
      });
    }
  }
  WeakSet.prototype.add = function (value) {
    this.map.set(value, PLACEHOLDER);
    return this;
  };
  WeakSet.prototype.delete = function (value) {
    return this.map.delete(value);
  };
  WeakSet.prototype.has = function (value) {
    return this.map.has(value);
  };
  return WeakSet;
}();

function isTextNode(node) {
  return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
  return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
  return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
  var shadowRoot = node;
  return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
  return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
  var child = node.firstChild;
  while (child) {
    callback(child);
    child = child.nextSibling;
  }
  if (isNodeShadowHost(node)) {
    callback(node.shadowRoot);
  }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
  return isNodeShadowRoot(node) ? node.host : node.parentNode;
}

var NodePrivacyLevel = {
  IGNORE: 'ignore',
  HIDDEN: 'hidden',
  ALLOW: DefaultPrivacyLevel.ALLOW,
  MASK: DefaultPrivacyLevel.MASK,
  MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_PREFIX = 'dd-privacy-';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
  INPUT: true,
  OUTPUT: true,
  TEXTAREA: true,
  SELECT: true,
  OPTION: true,
  DATALIST: true,
  OPTGROUP: true
};
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
  if (cache && cache.has(node)) {
    return cache.get(node);
  }
  var parentNode = getParentNode(node);
  var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
  var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
  var nodePrivacyLevel = reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
  if (cache) {
    cache.set(node, nodePrivacyLevel);
  }
  return nodePrivacyLevel;
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
  switch (parentNodePrivacyLevel) {
    // These values cannot be overridden
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return parentNodePrivacyLevel;
  }
  switch (childPrivacyLevel) {
    case NodePrivacyLevel.ALLOW:
    case NodePrivacyLevel.MASK:
    case NodePrivacyLevel.MASK_USER_INPUT:
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return childPrivacyLevel;
    default:
      return parentNodePrivacyLevel;
  }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
  // Only Element types can have a privacy level set
  if (!isElementNode(node)) {
    return;
  }
  // Overrules for replay purpose
  if (node.tagName === 'BASE') {
    return NodePrivacyLevel.ALLOW;
  }
  // Overrules to enforce end-user protection
  if (node.tagName === 'INPUT') {
    var inputElement = node;
    if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
      return NodePrivacyLevel.MASK;
    }
    if (inputElement.type === 'hidden') {
      return NodePrivacyLevel.MASK;
    }
    var autocomplete = inputElement.getAttribute('autocomplete');
    // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
    if (autocomplete && autocomplete.indexOf('cc-') === 0) {
      return NodePrivacyLevel.MASK;
    }
  }
  // Check HTML privacy attributes and classes
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.HIDDEN))) {
    return NodePrivacyLevel.HIDDEN;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK))) {
    return NodePrivacyLevel.MASK;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.MASK_USER_INPUT))) {
    return NodePrivacyLevel.MASK_USER_INPUT;
  }
  if (elementMatches(node, getPrivacySelector(NodePrivacyLevel.ALLOW))) {
    return NodePrivacyLevel.ALLOW;
  }
  if (shouldIgnoreElement(node)) {
    return NodePrivacyLevel.IGNORE;
  }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
  switch (privacyLevel) {
    case NodePrivacyLevel.MASK:
    case NodePrivacyLevel.HIDDEN:
    case NodePrivacyLevel.IGNORE:
      return true;
    case NodePrivacyLevel.MASK_USER_INPUT:
      return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
    default:
      return false;
  }
}
function isFormElement(node) {
  if (!node || node.nodeType !== node.ELEMENT_NODE) {
    return false;
  }
  var element = node;
  if (element.tagName === 'INPUT') {
    switch (element.type) {
      case 'button':
      case 'color':
      case 'reset':
      case 'submit':
        return false;
    }
  }
  return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) {
  return text.replace(/\S/g, TEXT_MASKING_CHAR);
};
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
  var _a;
  // The parent node may not be a html element which has a tagName attribute.
  // So just let it be undefined which is ok in this use case.
  var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
  var textContent = textNode.textContent || '';
  if (ignoreWhiteSpace && !textContent.trim()) {
    return;
  }
  var nodePrivacyLevel = parentNodePrivacyLevel;
  var isScript = parentTagName === 'SCRIPT';
  if (isScript) {
    // For perf reasons, we don't record script (heuristic)
    textContent = CENSORED_STRING_MARK;
  } else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    // Should never occur, but just in case, we set to CENSORED_MARK.
    textContent = CENSORED_STRING_MARK;
  } else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
    if (
    // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
    parentTagName === 'DATALIST' || parentTagName === 'SELECT' || parentTagName === 'OPTGROUP') {
      if (!textContent.trim()) {
        return;
      }
    } else if (parentTagName === 'OPTION') {
      // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
      textContent = CENSORED_STRING_MARK;
    } else {
      textContent = censorText(textContent);
    }
  }
  return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
  if (element.nodeName === 'SCRIPT') {
    return true;
  }
  if (element.nodeName === 'LINK') {
    var relAttribute = getLowerCaseAttribute('rel');
    return (
      // Link as script - Ignore only when rel=preload, modulepreload or prefetch
      /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script' ||
      // Favicons
      relAttribute === 'shortcut icon' || relAttribute === 'icon'
    );
  }
  if (element.nodeName === 'META') {
    var nameAttribute = getLowerCaseAttribute('name');
    var relAttribute = getLowerCaseAttribute('rel');
    var propertyAttribute = getLowerCaseAttribute('property');
    return (
      // Favicons
      /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === 'application-name' || relAttribute === 'icon' || relAttribute === 'apple-touch-icon' || relAttribute === 'shortcut icon' ||
      // Description
      nameAttribute === 'keywords' || nameAttribute === 'description' ||
      // Social
      /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === 'pinterest' ||
      // Robots
      nameAttribute === 'robots' || nameAttribute === 'googlebot' || nameAttribute === 'bingbot' ||
      // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
      // X-Translated-By
      element.hasAttribute('http-equiv') ||
      // Authorship
      nameAttribute === 'author' || nameAttribute === 'generator' || nameAttribute === 'framework' || nameAttribute === 'publisher' || nameAttribute === 'progid' || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) ||
      // Verification
      nameAttribute === 'google-site-verification' || nameAttribute === 'yandex-verification' || nameAttribute === 'csrf-token' || nameAttribute === 'p:domain_verify' || nameAttribute === 'verify-v1' || nameAttribute === 'verification' || nameAttribute === 'shopify-checkout-api-token'
    );
  }
  function getLowerCaseAttribute(name) {
    return (element.getAttribute(name) || '').toLowerCase();
  }
  return false;
}
function getPrivacySelector(privacyLevel) {
  return "[".concat(PRIVACY_ATTR_NAME, "=\"").concat(privacyLevel, "\"], .").concat(PRIVACY_CLASS_PREFIX).concat(privacyLevel);
}

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
var ACTION_NAME_PLACEHOLDER = 'Masked Element';
function getActionNameFromElement(element, _a, nodePrivacyLevel) {
  var enablePrivacyForActionName = _a.enablePrivacyForActionName,
    userProgrammaticAttribute = _a.actionNameAttribute;
  // Proceed to get the action name in two steps:
  // * first, get the name programmatically, explicitly defined by the user.
  // * then, use strategies that are known to return good results. Those strategies will be used on
  //   the element and a few parents, but it's likely that they won't succeed at all.
  // * if no name is found this way, use strategies returning less accurate names as a fallback.
  //   Those are much likely to succeed.
  var defaultActionName = getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) || userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
  if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
    return defaultActionName || ACTION_NAME_PLACEHOLDER;
  }
  return defaultActionName || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies, enablePrivacyForActionName) || getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies, enablePrivacyForActionName) || '';
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
  var elementWithAttribute;
  // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
  // without limit. It is up to the user to declare a relevant naming strategy.
  // If available, use element.closest() to match get the attribute from the element or any of its
  // parent.  Else fallback to a more traditional implementation.
  if (supportsElementClosest()) {
    elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
  } else {
    var element = targetElement;
    while (element) {
      if (element.hasAttribute(programmaticAttribute)) {
        elementWithAttribute = element;
        break;
      }
      element = getParentElement(element);
    }
  }
  if (!elementWithAttribute) {
    return;
  }
  var name = elementWithAttribute.getAttribute(programmaticAttribute);
  return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
// associated LABEL text
function (element, userProgrammaticAttribute, privacy) {
  // IE does not support element.labels, so we fallback to a CSS selector based on the element id
  // instead
  if (supportsLabelProperty()) {
    if ('labels' in element && element.labels && element.labels.length > 0) {
      return getTextualContent(element.labels[0], userProgrammaticAttribute);
    }
  } else if (element.id) {
    var label = element.ownerDocument && find(element.ownerDocument.querySelectorAll('label'), function (label) {
      return label.htmlFor === element.id;
    });
    return label && getTextualContent(label, userProgrammaticAttribute, privacy);
  }
},
// INPUT button (and associated) value
function (element) {
  if (element.nodeName === 'INPUT') {
    var input = element;
    var type = input.getAttribute('type');
    if (type === 'button' || type === 'submit' || type === 'reset') {
      return input.value;
    }
  }
},
// BUTTON, LABEL or button-like element text
function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
    return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
  }
}, function (element) {
  return element.getAttribute('aria-label');
},
// associated element text designated by the aria-labelledby attribute
function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  var labelledByAttribute = element.getAttribute('aria-labelledby');
  if (labelledByAttribute) {
    return labelledByAttribute.split(/\s+/).map(function (id) {
      return getElementById(element, id);
    }).filter(function (label) {
      return Boolean(label);
    }).map(function (element) {
      return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
    }).join(' ');
  }
}, function (element) {
  return element.getAttribute('alt');
}, function (element) {
  return element.getAttribute('name');
}, function (element) {
  return element.getAttribute('title');
}, function (element) {
  return element.getAttribute('placeholder');
},
// SELECT first OPTION text
function (element, userProgrammaticAttribute) {
  if ('options' in element && element.options.length > 0) {
    return getTextualContent(element.options[0], userProgrammaticAttribute);
  }
}];
var fallbackStrategies = [function (element, userProgrammaticAttribute, privacyEnabledActionName) {
  return getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName);
}];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies, privacyEnabledActionName) {
  var element = targetElement;
  var recursionCounter = 0;
  while (recursionCounter <= MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD') {
    for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
      var strategy = strategies_1[_i];
      var name_1 = strategy(element, userProgrammaticAttribute, privacyEnabledActionName);
      if (typeof name_1 === 'string') {
        var trimmedName = name_1.trim();
        if (trimmedName) {
          return truncate(normalizeWhitespace(trimmedName));
        }
      }
    }
    // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
    // be reconsidered in the future.
    if (element.nodeName === 'FORM') {
      break;
    }
    element = getParentElement(element);
    recursionCounter += 1;
  }
}
function normalizeWhitespace(s) {
  return s.replace(/\s+/g, ' ');
}
function truncate(s) {
  return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
  // Use the element ownerDocument here, because tests are executed in an iframe, so
  // document.getElementById won't work.
  return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute, privacyEnabledActionName) {
  if (element.isContentEditable) {
    return;
  }
  if ('innerText' in element) {
    var text_1 = element.innerText;
    var removeTextFromElements = function (query) {
      var list = element.querySelectorAll(query);
      for (var index = 0; index < list.length; index += 1) {
        var element_1 = list[index];
        if ('innerText' in element_1) {
          var textToReplace = element_1.innerText;
          if (textToReplace && textToReplace.trim().length > 0) {
            text_1 = text_1.replace(textToReplace, '');
          }
        }
      }
    };
    if (!supportsInnerTextScriptAndStyleRemoval()) {
      // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
      // be relatively fast and work in most cases.
      removeTextFromElements('script, style');
    }
    // remove the text of elements with programmatic attribute value
    removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
    if (userProgrammaticAttribute) {
      removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
    }
    if (privacyEnabledActionName) {
      // remove the text of elements with privacy override
      removeTextFromElements("".concat(getPrivacySelector(NodePrivacyLevel.HIDDEN), ", ").concat(getPrivacySelector(NodePrivacyLevel.MASK)));
    }
    return text_1;
  }
  return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
  return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
  if (supportsLabelPropertyResult === undefined) {
    supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
  }
  return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
  if (supportsElementClosestResult === undefined) {
    supportsElementClosestResult = 'closest' in HTMLElement.prototype;
  }
  return supportsElementClosestResult;
}

/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
// Common test attributes (list provided by google recorder)
'data-testid', 'data-test', 'data-qa', 'data-cy', 'data-test-id', 'data-qa-id', 'data-testing',
// FullStory decorator attributes:
'data-component', 'data-element', 'data-source-file'];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [getStableAttributeSelector, getClassSelector, getTagNameSelector];
function getSelectorFromElement(targetElement, actionNameAttribute) {
  if (!isConnected(targetElement)) {
    // We cannot compute a selector for a detached element, as we don't have access to all of its
    // parents, and we cannot determine if it's unique in the document.
    return;
  }
  var targetElementSelector;
  var currentElement = targetElement;
  while (currentElement && currentElement.nodeName !== 'HTML') {
    var globallyUniqueSelector = findSelector(currentElement, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
    if (globallyUniqueSelector) {
      return globallyUniqueSelector;
    }
    var uniqueSelectorAmongChildren = findSelector(currentElement, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
    targetElementSelector = uniqueSelectorAmongChildren || combineSelector(getPositionSelector(currentElement), targetElementSelector);
    currentElement = getParentElement(currentElement);
  }
  return targetElementSelector;
}
function isGeneratedValue(value) {
  // To compute the "URL path group", the backend replaces every URL path parts as a question mark
  // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
  // present.
  //
  // Here, we use the same strategy: if the value contains a digit, we consider it generated. This
  // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
  // CSS selectors so it should be fine most of the time.
  return /[0-9]/.test(value);
}
function getIDSelector(element) {
  if (element.id && !isGeneratedValue(element.id)) {
    return "#".concat(cssEscape(element.id));
  }
}
function getClassSelector(element) {
  if (element.tagName === 'BODY') {
    return;
  }
  var classList = getClassList(element);
  for (var i = 0; i < classList.length; i += 1) {
    var className = classList[i];
    if (isGeneratedValue(className)) {
      continue;
    }
    return "".concat(cssEscape(element.tagName), ".").concat(cssEscape(className));
  }
}
function getTagNameSelector(element) {
  return cssEscape(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
  if (actionNameAttribute) {
    var selector = getAttributeSelector(actionNameAttribute);
    if (selector) {
      return selector;
    }
  }
  for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
    var attributeName = STABLE_ATTRIBUTES_1[_i];
    var selector = getAttributeSelector(attributeName);
    if (selector) {
      return selector;
    }
  }
  function getAttributeSelector(attributeName) {
    if (element.hasAttribute(attributeName)) {
      return "".concat(cssEscape(element.tagName), "[").concat(attributeName, "=\"").concat(cssEscape(element.getAttribute(attributeName)), "\"]");
    }
  }
}
function getPositionSelector(element) {
  var sibling = getParentElement(element).firstElementChild;
  var elementIndex = 1;
  while (sibling && sibling !== element) {
    if (sibling.tagName === element.tagName) {
      elementIndex += 1;
    }
    sibling = sibling.nextElementSibling;
  }
  return "".concat(cssEscape(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
  for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
    var selectorGetter = selectorGetters_1[_i];
    var elementSelector = selectorGetter(element, actionNameAttribute);
    if (!elementSelector) {
      continue;
    }
    if (predicate(element, elementSelector, childSelector)) {
      return combineSelector(elementSelector, childSelector);
    }
  }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, elementSelector, childSelector) {
  return element.ownerDocument.querySelectorAll(combineSelector(elementSelector, childSelector)).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
 *
 * @param {Element} currentElement - the element being considered while iterating over the target
 * element ancestors.
 *
 * @param {string} currentElementSelector - a selector that matches the current element. That
 * selector is not a composed selector (i.e. it might be a single tag name, class name...).
 *
 * @param {string|undefined} childSelector - child selector is a selector that targets a descendant
 * of the current element. When undefined, the current element is the target element.
 *
 * # Scope selector usage
 *
 * When composed together, the final selector will be joined with `>` operators to make sure we
 * target direct descendants at each level. In this function, we'll use `querySelector` to check if
 * a selector matches descendants of the current element. But by default, the query selector match
 * elements at any level. Example:
 *
 * ```html
 * <main>
 *   <div>
 *     <span></span>
 *   </div>
 *   <marquee>
 *     <div>
 *       <span></span>
 *     </div>
 *   </marquee>
 * </main>
 * ```
 *
 * `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
 * selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
 * operator (`MAIN > DIV > SPAN`).
 *
 * To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
 * sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT CHILD_SELECTOR" returns a single element), regardless of whether the selector is
 * a direct descendant of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 *
 * [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
 *
 * # Performance considerations
 *
 * We compute selectors in performance-critical operations (ex: during a click), so we need to make
 * sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
 * check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
 *
 * Because we are iterating the DOM upward and we use that function at every level, we know the
 * child selector is already unique among the current element children, so we don't need to check
 * for the current element subtree.
 *
 * Instead, we can focus on the current element siblings. If we find a single element matching the
 * selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
 * (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
 */
function isSelectorUniqueAmongSiblings(currentElement, currentElementSelector, childSelector) {
  var isSiblingMatching;
  if (childSelector === undefined) {
    // If the child selector is undefined (meaning `currentElement` is the target element, not one
    // of its ancestor), we need to use `matches` to check if the sibling is matching the selector,
    // as `querySelector` only returns a descendant of the element.
    isSiblingMatching = function (sibling) {
      return elementMatches(sibling, currentElementSelector);
    };
  } else {
    var scopedSelector_1 = supportScopeSelector() ? combineSelector("".concat(currentElementSelector, ":scope"), childSelector) : combineSelector(currentElementSelector, childSelector);
    isSiblingMatching = function (sibling) {
      return sibling.querySelector(scopedSelector_1) !== null;
    };
  }
  var parent = getParentElement(currentElement);
  var sibling = parent.firstElementChild;
  while (sibling) {
    if (sibling !== currentElement && isSiblingMatching(sibling)) {
      return false;
    }
    sibling = sibling.nextElementSibling;
  }
  return true;
}
function combineSelector(parent, child) {
  return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
  if (supportScopeSelectorCache === undefined) {
    try {
      document.querySelector(':scope');
      supportScopeSelectorCache = true;
    } catch (_a) {
      supportScopeSelectorCache = false;
    }
  }
  return supportScopeSelectorCache;
}
/**
 * Polyfill-utility for the `isConnected` property not supported in IE11
 */
function isConnected(element) {
  if ('isConnected' in
  // cast is to make sure `element` is not inferred as `never` after the check
  element) {
    return element.isConnected;
  }
  return element.ownerDocument.documentElement.contains(element);
}

var MAX_DURATION_BETWEEN_CLICKS = ONE_SECOND;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
  var bufferedClicks = [];
  var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
  var maxDurationBetweenClicksTimeoutId;
  appendClick(firstClick);
  function appendClick(click) {
    click.stopObservable.subscribe(tryFinalize);
    bufferedClicks.push(click);
    clearTimeout$1(maxDurationBetweenClicksTimeoutId);
    maxDurationBetweenClicksTimeoutId = setTimeout$1(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
  }
  function tryFinalize() {
    if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) {
      return click.isStopped();
    })) {
      status = 2 /* ClickChainStatus.Finalized */;
      onFinalize(bufferedClicks);
    }
  }
  function dontAcceptMoreClick() {
    clearTimeout$1(maxDurationBetweenClicksTimeoutId);
    if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
      status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
      tryFinalize();
    }
  }
  return {
    tryAppend: function (click) {
      if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
        return false;
      }
      if (bufferedClicks.length > 0 && !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
        dontAcceptMoreClick();
        return false;
      }
      appendClick(click);
      return true;
    },
    stop: function () {
      dontAcceptMoreClick();
    }
  };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
  return first.target === second.target && mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS && first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS;
}
function mouseEventDistance(origin, other) {
  return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

function listenActionEvents(configuration, _a) {
  var onPointerDown = _a.onPointerDown,
    onPointerUp = _a.onPointerUp;
  var selectionEmptyAtPointerDown;
  var userActivity = {
    selection: false,
    input: false,
    scroll: false
  };
  var clickContext;
  var listeners = [addEventListener(configuration, window, DOM_EVENT.POINTER_DOWN, function (event) {
    if (isValidPointerEvent(event)) {
      selectionEmptyAtPointerDown = isSelectionEmpty();
      userActivity = {
        selection: false,
        input: false,
        scroll: false
      };
      clickContext = onPointerDown(event);
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.SELECTION_CHANGE, function () {
    if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
      userActivity.selection = true;
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.SCROLL, function () {
    userActivity.scroll = true;
  }, {
    capture: true,
    passive: true
  }), addEventListener(configuration, window, DOM_EVENT.POINTER_UP, function (event) {
    if (isValidPointerEvent(event) && clickContext) {
      // Use a scoped variable to make sure the value is not changed by other clicks
      var localUserActivity_1 = userActivity;
      onPointerUp(clickContext, event, function () {
        return localUserActivity_1;
      });
      clickContext = undefined;
    }
  }, {
    capture: true
  }), addEventListener(configuration, window, DOM_EVENT.INPUT, function () {
    userActivity.input = true;
  }, {
    capture: true
  })];
  return {
    stop: function () {
      listeners.forEach(function (listener) {
        return listener.stop();
      });
    }
  };
}
function isSelectionEmpty() {
  var selection = window.getSelection();
  return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
  return event.target instanceof Element &&
  // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
  // the future.
  event.isPrimary !== false;
}

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
  if (isRage(clicks)) {
    rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
    if (clicks.some(isDead)) {
      rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
    }
    if (rageClick.hasError) {
      rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
    }
    return {
      isRage: true
    };
  }
  var hasSelectionChanged = clicks.some(function (click) {
    return click.getUserActivity().selection;
  });
  clicks.forEach(function (click) {
    if (click.hasError) {
      click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
    }
    if (isDead(click) &&
    // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
    !hasSelectionChanged) {
      click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
    }
  });
  return {
    isRage: false
  };
}
function isRage(clicks) {
  if (clicks.some(function (click) {
    return click.getUserActivity().selection || click.getUserActivity().scroll;
  })) {
    return false;
  }
  for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
    if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= ONE_SECOND) {
      return true;
    }
  }
  return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR =
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' + 'textarea,' + 'select,' +
// contenteditable and their descendants don't always trigger meaningful changes when manipulated
'[contenteditable],' + '[contenteditable] *,' +
// canvas, as there is no good way to detect activity occurring on them
'canvas,' +
// links that are interactive (have an href attribute) or any of their descendants, as they can
// open a new tab or navigate to a hash without triggering a meaningful event
'a[href],' + 'a[href] *';
function isDead(click) {
  if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) {
    return false;
  }
  return !elementMatches(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}

// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * ONE_SECOND;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
  var history = new ValueHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
  var stopObservable = new Observable();
  var currentClickChain;
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    history.reset();
  });
  lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
  var stopActionEventsListener = listenActionEvents(configuration, {
    onPointerDown: function (pointerDownEvent) {
      return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
    },
    onPointerUp: function (_a, startEvent, getUserActivity) {
      var clickActionBase = _a.clickActionBase,
        hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
      startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
    }
  }).stop;
  var actionContexts = {
    findActionId: function (startTime) {
      return history.findAll(startTime);
    }
  };
  return {
    stop: function () {
      stopClickChain();
      stopObservable.notify();
      stopActionEventsListener();
    },
    actionContexts: actionContexts
  };
  function appendClickToClickChain(click) {
    if (!currentClickChain || !currentClickChain.tryAppend(click)) {
      var rageClick_1 = click.clone();
      currentClickChain = createClickChain(click, function (clicks) {
        finalizeClicks(clicks, rageClick_1);
      });
    }
  }
  function stopClickChain() {
    if (currentClickChain) {
      currentClickChain.stop();
    }
  }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
  var nodePrivacyLevel = configuration.enablePrivacyForActionName ? getNodePrivacyLevel(pointerDownEvent.target, configuration.defaultPrivacyLevel) : NodePrivacyLevel.ALLOW;
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return undefined;
  }
  var clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
  var hadActivityOnPointerDown = false;
  waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
  },
  // We don't care about the activity duration, we just want to know whether an activity did happen
  // within the "validation delay" or not. Limit the duration so the callback is called sooner.
  PAGE_ACTIVITY_VALIDATION_DELAY);
  return {
    clickActionBase: clickActionBase,
    hadActivityOnPointerDown: function () {
      return hadActivityOnPointerDown;
    }
  };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
  var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
  appendClickToClickChain(click);
  var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
    if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
      // If the clock is looking weird, just discard the click
      click.discard();
    } else {
      if (pageActivityEndEvent.hadActivity) {
        click.stop(pageActivityEndEvent.end);
      } else if (hadActivityOnPointerDown()) {
        click.stop(
        // using the click start as activity end, so the click will have some activity but its
        // duration will be 0 (as the activity started before the click start)
        click.startClocks.timeStamp);
      } else {
        click.stop();
      }
    }
  }, CLICK_ACTION_MAX_DURATION).stop;
  var viewEndedSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    click.stop(endClocks.timeStamp);
  });
  var stopSubscription = stopObservable.subscribe(function () {
    click.stop();
  });
  click.stopObservable.subscribe(function () {
    viewEndedSubscription.unsubscribe();
    stopWaitPageActivityEnd();
    stopSubscription.unsubscribe();
  });
}
function computeClickActionBase(event, nodePrivacyLevel, configuration) {
  var rect = event.target.getBoundingClientRect();
  return {
    type: "click" /* ActionType.CLICK */,
    target: {
      width: Math.round(rect.width),
      height: Math.round(rect.height),
      selector: getSelectorFromElement(event.target, configuration.actionNameAttribute)
    },
    position: {
      // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
      x: Math.round(event.clientX - rect.left),
      y: Math.round(event.clientY - rect.top)
    },
    name: getActionNameFromElement(event.target, configuration, nodePrivacyLevel)
  };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
  var id = generateUUID();
  var startClocks = clocksNow();
  var historyEntry = history.add(id, startClocks.relative);
  var eventCountsSubscription = trackEventCounts({
    lifeCycle: lifeCycle,
    isChildEvent: function (event) {
      return event.action !== undefined && (Array.isArray(event.action.id) ? includes(event.action.id, id) : event.action.id === id);
    }
  });
  var status = 0 /* ClickStatus.ONGOING */;
  var activityEndTime;
  var frustrationTypes = [];
  var stopObservable = new Observable();
  function stop(newActivityEndTime) {
    if (status !== 0 /* ClickStatus.ONGOING */) {
      return;
    }
    activityEndTime = newActivityEndTime;
    status = 1 /* ClickStatus.STOPPED */;
    if (activityEndTime) {
      historyEntry.close(getRelativeTime(activityEndTime));
    } else {
      historyEntry.remove();
    }
    eventCountsSubscription.stop();
    stopObservable.notify();
  }
  return {
    event: startEvent,
    stop: stop,
    stopObservable: stopObservable,
    get hasError() {
      return eventCountsSubscription.eventCounts.errorCount > 0;
    },
    get hasPageActivity() {
      return activityEndTime !== undefined;
    },
    getUserActivity: getUserActivity,
    addFrustration: function (frustrationType) {
      frustrationTypes.push(frustrationType);
    },
    startClocks: startClocks,
    isStopped: function () {
      return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */;
    },
    clone: function () {
      return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    },
    validate: function (domEvents) {
      stop();
      if (status !== 1 /* ClickStatus.STOPPED */) {
        return;
      }
      var _a = eventCountsSubscription.eventCounts,
        resourceCount = _a.resourceCount,
        errorCount = _a.errorCount,
        longTaskCount = _a.longTaskCount;
      var clickAction = assign({
        type: "click" /* ActionType.CLICK */,
        duration: activityEndTime && elapsed(startClocks.timeStamp, activityEndTime),
        startClocks: startClocks,
        id: id,
        frustrationTypes: frustrationTypes,
        counts: {
          resourceCount: resourceCount,
          errorCount: errorCount,
          longTaskCount: longTaskCount
        },
        events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
        event: startEvent
      }, clickActionBase);
      lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
      status = 2 /* ClickStatus.FINALIZED */;
    },
    discard: function () {
      stop();
      status = 2 /* ClickStatus.FINALIZED */;
    }
  };
}
function finalizeClicks(clicks, rageClick) {
  var isRage = computeFrustration(clicks, rageClick).isRage;
  if (isRage) {
    clicks.forEach(function (click) {
      return click.discard();
    });
    rageClick.stop(timeStampNow());
    rageClick.validate(clicks.map(function (click) {
      return click.event;
    }));
  } else {
    rageClick.discard();
    clicks.forEach(function (click) {
      return click.validate();
    });
  }
}

function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
  lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
    return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
  });
  var actionContexts = {
    findActionId: noop
  };
  if (configuration.trackUserInteractions) {
    actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
  }
  return {
    addAction: function (action, savedCommonContext) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, assign({
        savedCommonContext: savedCommonContext
      }, processAction(action, pageStateHistory)));
    },
    actionContexts: actionContexts
  };
}
function processAction(action, pageStateHistory) {
  var autoActionProperties = isAutoAction(action) ? {
    action: {
      id: action.id,
      loading_time: discardNegativeDuration(toServerDuration(action.duration)),
      frustration: {
        type: action.frustrationTypes
      },
      error: {
        count: action.counts.errorCount
      },
      long_task: {
        count: action.counts.longTaskCount
      },
      resource: {
        count: action.counts.resourceCount
      }
    },
    _dd: {
      action: {
        target: action.target,
        position: action.position
      }
    }
  } : undefined;
  var customerContext = !isAutoAction(action) ? action.context : undefined;
  var actionEvent = combine({
    action: {
      id: generateUUID(),
      target: {
        name: action.name
      },
      type: action.type
    },
    date: action.startClocks.timeStamp,
    type: "action" /* RumEventType.ACTION */,
    view: {
      in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, action.startClocks.relative)
    }
  }, autoActionProperties);
  var domainContext = isAutoAction(action) ? {
    events: action.events
  } : {};
  if (!isAutoAction(action) && action.handlingStack) {
    domainContext.handlingStack = action.handlingStack;
  }
  return {
    customerContext: customerContext,
    rawRumEvent: actionEvent,
    startTime: action.startClocks.relative,
    domainContext: domainContext
  };
}
function isAutoAction(action) {
  return action.type !== "custom" /* ActionType.CUSTOM */;
}

function trackConsoleError(errorObservable) {
  var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
    return errorObservable.notify({
      startClocks: clocksNow(),
      message: consoleError.message,
      stack: consoleError.stack,
      fingerprint: consoleError.fingerprint,
      source: ErrorSource.CONSOLE,
      handling: "handled" /* ErrorHandling.HANDLED */,
      handlingStack: consoleError.handlingStack
    });
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    }
  };
}

function trackReportError(configuration, errorObservable) {
  var subscription = initReportObservable(configuration, [RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
    var rawError = {
      startClocks: clocksNow(),
      message: reportError.message,
      stack: reportError.stack,
      type: reportError.subtype,
      source: ErrorSource.REPORT,
      handling: "unhandled" /* ErrorHandling.UNHANDLED */,
      originalError: reportError.originalReport
    };
    if (reportError.originalReport.type === 'securitypolicyviolation') {
      rawError.csp = {
        disposition: reportError.originalReport.disposition
      };
    }
    return errorObservable.notify(rawError);
  });
  return {
    stop: function () {
      subscription.unsubscribe();
    }
  };
}

function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
  var errorObservable = new Observable();
  trackConsoleError(errorObservable);
  trackRuntimeError(errorObservable);
  trackReportError(configuration, errorObservable);
  errorObservable.subscribe(function (error) {
    return lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
  });
  return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
  lifeCycle.subscribe(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
    var error = _a.error,
      customerContext = _a.customerContext,
      savedCommonContext = _a.savedCommonContext;
    lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, assign({
      customerContext: customerContext,
      savedCommonContext: savedCommonContext
    }, processError(error, pageStateHistory, featureFlagContexts)));
  });
  return {
    addError: function (_a, savedCommonContext) {
      var error = _a.error,
        handlingStack = _a.handlingStack,
        startClocks = _a.startClocks,
        customerContext = _a.context;
      var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
      var rawError = computeRawError({
        stackTrace: stackTrace,
        originalError: error,
        handlingStack: handlingStack,
        startClocks: startClocks,
        nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
        source: ErrorSource.CUSTOM,
        handling: "handled" /* ErrorHandling.HANDLED */
      });
      lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
        customerContext: customerContext,
        savedCommonContext: savedCommonContext,
        error: rawError
      });
    }
  };
}
function processError(error, pageStateHistory, featureFlagContexts) {
  var rawRumEvent = {
    date: error.startClocks.timeStamp,
    error: {
      id: generateUUID(),
      message: error.message,
      source: error.source,
      stack: error.stack,
      handling_stack: error.handlingStack,
      type: error.type,
      handling: error.handling,
      causes: error.causes,
      source_type: 'browser',
      fingerprint: error.fingerprint,
      csp: error.csp
    },
    type: "error" /* RumEventType.ERROR */,
    view: {
      in_foreground: pageStateHistory.wasInPageStateAt("active" /* PageState.ACTIVE */, error.startClocks.relative)
    }
  };
  var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
  if (featureFlagContext && !isEmptyObject(featureFlagContext)) {
    rawRumEvent.feature_flags = featureFlagContext;
  }
  var domainContext = {
    error: error.originalError,
    handlingStack: error.handlingStack
  };
  return {
    rawRumEvent: rawRumEvent,
    startTime: error.startClocks.relative,
    domainContext: domainContext
  };
}

function startLongTaskCollection(lifeCycle, configuration) {
  lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
        break;
      }
      if (!configuration.trackLongTasks) {
        break;
      }
      var startClocks = relativeToClocks(entry.startTime);
      var rawRumEvent = {
        date: startClocks.timeStamp,
        long_task: {
          id: generateUUID(),
          duration: toServerDuration(entry.duration)
        },
        type: "long_task" /* RumEventType.LONG_TASK */,
        _dd: {
          discarded: false
        }
      };
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
        rawRumEvent: rawRumEvent,
        startTime: startClocks.relative,
        domainContext: {
          performanceEntry: entry
        }
      });
    }
  });
}

var alreadyMatchedEntries = new WeakSet$1();
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - filter out timing that were already matched to a request
 * - then, if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
  if (!performance || !('getEntriesByName' in performance)) {
    return;
  }
  var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
  if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
    return;
  }
  var candidates = sameNameEntries.filter(function (entry) {
    return !alreadyMatchedEntries.has(entry);
  }).filter(function (entry) {
    return isValidEntry(entry);
  }).filter(function (entry) {
    return isBetween(entry, request.startClocks.relative, endTime({
      startTime: request.startClocks.relative,
      duration: request.duration
    }));
  });
  if (candidates.length === 1) {
    alreadyMatchedEntries.add(candidates[0]);
    return candidates[0].toJSON();
  }
  return;
}
function endTime(timing) {
  return addDuration(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
  var errorMargin = 1;
  return timing.startTime >= start - errorMargin && endTime(timing) <= addDuration(end, errorMargin);
}

var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
  var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
  if (!data || data.traceTime <= dateNow() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
    return undefined;
  }
  return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
  var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
  var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
  return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
  var comment = findTraceComment(document);
  if (!comment) {
    return undefined;
  }
  return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
  var traceTime = rawTraceTime && Number(rawTraceTime);
  if (!traceId || !traceTime) {
    return undefined;
  }
  return {
    traceId: traceId,
    traceTime: traceTime
  };
}
function findTraceComment(document) {
  // 1. Try to find the comment as a direct child of the document
  // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
  // value is not an array or string (here, a NodeList).
  for (var i = 0; i < document.childNodes.length; i += 1) {
    var comment = getTraceCommentFromNode(document.childNodes[i]);
    if (comment) {
      return comment;
    }
  }
  // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
  // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
  // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
  // reverse order, stopping if we come across a non-text node.
  if (document.body) {
    for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
      var node = document.body.childNodes[i];
      var comment = getTraceCommentFromNode(node);
      if (comment) {
        return comment;
      }
      if (!isTextNode(node)) {
        break;
      }
    }
  }
}
function getTraceCommentFromNode(node) {
  if (node && isCommentNode(node)) {
    var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
    if (match) {
      return match[1];
    }
  }
}

function retrieveInitialDocumentResourceTiming(configuration, callback) {
  runOnReadyState(configuration, 'interactive', function () {
    var timing;
    var forcedAttributes = {
      entryType: RumPerformanceEntryType.RESOURCE,
      initiatorType: FAKE_INITIAL_DOCUMENT,
      traceId: getDocumentTraceId(document),
      toJSON: function () {
        return assign({}, timing, {
          toJSON: undefined
        });
      }
    };
    if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) && performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
      var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
      timing = assign(navigationEntry.toJSON(), forcedAttributes);
    } else {
      var relativePerformanceTiming = computeRelativePerformanceTiming();
      timing = assign(relativePerformanceTiming, {
        decodedBodySize: 0,
        encodedBodySize: 0,
        transferSize: 0,
        renderBlockingStatus: 'non-blocking',
        duration: relativePerformanceTiming.responseEnd,
        name: window.location.href,
        startTime: 0
      }, forcedAttributes);
    }
    callback(timing);
  });
}

function startResourceCollection(lifeCycle, configuration, pageStateHistory) {
  lifeCycle.subscribe(8 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
    var rawEvent = processRequest(request, configuration, pageStateHistory);
    if (rawEvent) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
    }
  });
  var performanceResourceSubscription = createPerformanceObservable(configuration, {
    type: RumPerformanceEntryType.RESOURCE,
    buffered: true
  }).subscribe(function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (!isRequestKind(entry)) {
        var rawEvent = processResourceEntry(entry, configuration);
        if (rawEvent) {
          lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
      }
    }
  });
  retrieveInitialDocumentResourceTiming(configuration, function (timing) {
    var rawEvent = processResourceEntry(timing, configuration);
    if (rawEvent) {
      lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
    }
  });
  return {
    stop: function () {
      performanceResourceSubscription.unsubscribe();
    }
  };
}
function processRequest(request, configuration, pageStateHistory) {
  var matchingTiming = matchRequestTiming(request);
  var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
  var tracingInfo = computeRequestTracingInfo(request, configuration);
  if (!configuration.trackResources && !tracingInfo) {
    return;
  }
  var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
  var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
  var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      type: type,
      duration: duration,
      method: request.method,
      status_code: request.status,
      url: isLongDataUrl(request.url) ? sanitizeDataUrl(request.url) : request.url
    },
    type: "resource" /* RumEventType.RESOURCE */,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, correspondingTimingOverrides);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: matchingTiming,
      xhr: request.xhr,
      response: request.response,
      requestInput: request.input,
      requestInit: request.init,
      error: request.error,
      isAborted: request.isAborted,
      handlingStack: request.handlingStack
    }
  };
}
function processResourceEntry(entry, configuration) {
  var startClocks = relativeToClocks(entry.startTime);
  var tracingInfo = computeEntryTracingInfo(entry, configuration);
  if (!configuration.trackResources && !tracingInfo) {
    return;
  }
  var type = computeResourceKind(entry);
  var entryMetrics = computePerformanceEntryMetrics(entry);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      type: type,
      url: entry.name,
      status_code: discardZeroStatus(entry.responseStatus)
    },
    type: "resource" /* RumEventType.RESOURCE */,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, entryMetrics);
  return {
    startTime: startClocks.relative,
    rawRumEvent: resourceEvent,
    domainContext: {
      performanceEntry: entry
    }
  };
}
function computePerformanceEntryMetrics(timing) {
  var renderBlockingStatus = timing.renderBlockingStatus;
  return {
    resource: assign({
      duration: computePerformanceResourceDuration(timing),
      render_blocking_status: renderBlockingStatus
    }, computeSize(timing), computePerformanceResourceDetails(timing))
  };
}
function computeRequestTracingInfo(request, configuration) {
  var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
  if (!hasBeenTraced) {
    return undefined;
  }
  return {
    _dd: {
      span_id: request.spanId.toDecimalString(),
      trace_id: request.traceId.toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}
function computeEntryTracingInfo(entry, configuration) {
  var hasBeenTraced = entry.traceId;
  if (!hasBeenTraced) {
    return undefined;
  }
  return {
    _dd: {
      trace_id: entry.traceId,
      span_id: new TraceIdentifier().toDecimalString(),
      rule_psr: getRulePsr(configuration)
    }
  };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
  return isNumber(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
  return !pageStateHistory.wasInPageStateDuringPeriod("frozen" /* PageState.FROZEN */, startClocks.relative, duration) ? toServerDuration(duration) : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */
function discardZeroStatus(statusCode) {
  return statusCode === 0 ? undefined : statusCode;
}

function trackViewEventCounts(lifeCycle, viewId, onChange) {
  var _a = trackEventCounts({
      lifeCycle: lifeCycle,
      isChildEvent: function (event) {
        return event.view.id === viewId;
      },
      onChange: onChange
    }),
    stop = _a.stop,
    eventCounts = _a.eventCounts;
  return {
    stop: stop,
    eventCounts: eventCounts
  };
}

// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * ONE_MINUTE;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var fcpEntry = find(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.PAINT && entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp && entry.startTime < FCP_MAXIMUM_DELAY;
    });
    if (fcpEntry) {
      callback(fcpEntry.startTime);
    }
  }).unsubscribe;
  return {
    stop: unsubscribeLifeCycle
  };
}

/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var firstInputEntry = find(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
    });
    if (firstInputEntry) {
      var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
      var firstInputTargetSelector = void 0;
      if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
        firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
      }
      callback({
        // Ensure firstInputDelay to be positive, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
        delay: firstInputDelay >= 0 ? firstInputDelay : 0,
        time: firstInputEntry.startTime,
        targetSelector: firstInputTargetSelector
      });
    }
  }).unsubscribe;
  return {
    stop: unsubscribeLifeCycle
  };
}

function trackNavigationTimings(lifeCycle, callback) {
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType === RumPerformanceEntryType.NAVIGATION) {
        callback({
          domComplete: entry.domComplete,
          domContentLoaded: entry.domContentLoadedEventEnd,
          domInteractive: entry.domInteractive,
          loadEvent: entry.loadEventEnd,
          // In some cases the value reported is negative or is larger
          // than the current page time. Ignore these cases:
          // https://github.com/GoogleChrome/web-vitals/issues/137
          // https://github.com/GoogleChrome/web-vitals/issues/162
          firstByte: entry.responseStart >= 0 && entry.responseStart <= relativeNow() ? entry.responseStart : undefined
        });
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}

// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * ONE_MINUTE;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
  // Ignore entries that come after the first user interaction. According to the documentation, the
  // browser should not send largest-contentful-paint entries after a user interact with the page,
  // but the web-vitals reference implementation uses this as a safeguard.
  var firstInteractionTimestamp = Infinity;
  var stopEventListener = addEventListeners(configuration, eventTarget, [DOM_EVENT.POINTER_DOWN, DOM_EVENT.KEY_DOWN], function (event) {
    firstInteractionTimestamp = event.timeStamp;
  }, {
    capture: true,
    once: true
  }).stop;
  var biggestLcpSize = 0;
  var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    var lcpEntry = findLast(entries, function (entry) {
      return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < LCP_MAXIMUM_DELAY &&
      // Ensure to get the LCP entry with the biggest size, see
      // https://bugs.chromium.org/p/chromium/issues/detail?id=1516655
      entry.size > biggestLcpSize;
    });
    if (lcpEntry) {
      var lcpTargetSelector = void 0;
      if (lcpEntry.element) {
        lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
      }
      callback({
        value: lcpEntry.startTime,
        targetSelector: lcpTargetSelector
      });
      biggestLcpSize = lcpEntry.size;
    }
  }).unsubscribe;
  return {
    stop: function () {
      stopEventListener();
      unsubscribeLifeCycle();
    }
  };
}

function trackFirstHidden(configuration, eventTarget) {
  if (eventTarget === void 0) {
    eventTarget = window;
  }
  var timeStamp;
  var stopListeners;
  if (document.visibilityState === 'hidden') {
    timeStamp = 0;
  } else {
    timeStamp = Infinity;
    stopListeners = addEventListeners(configuration, eventTarget, [DOM_EVENT.PAGE_HIDE, DOM_EVENT.VISIBILITY_CHANGE], function (event) {
      if (event.type === DOM_EVENT.PAGE_HIDE || document.visibilityState === 'hidden') {
        timeStamp = event.timeStamp;
        stopListeners();
      }
    }, {
      capture: true
    }).stop;
  }
  return {
    get timeStamp() {
      return timeStamp;
    },
    stop: function () {
      stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
    }
  };
}

function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
  var initialViewMetrics = {};
  var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
    setLoadEvent(navigationTimings.loadEvent);
    initialViewMetrics.navigationTimings = navigationTimings;
    scheduleViewUpdate();
  }).stop;
  var firstHidden = trackFirstHidden(configuration);
  var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
    initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
    scheduleViewUpdate();
  }).stop;
  var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
    initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
    scheduleViewUpdate();
  }).stop;
  var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
    initialViewMetrics.firstInput = firstInput;
    scheduleViewUpdate();
  }).stop;
  function stop() {
    stopNavigationTracking();
    stopFCPTracking();
    stopLCPTracking();
    stopFIDTracking();
    firstHidden.stop();
  }
  return {
    stop: stop,
    initialViewMetrics: initialViewMetrics
  };
}

/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, viewStart, callback) {
  if (!isLayoutShiftSupported()) {
    return {
      stop: noop
    };
  }
  var maxClsValue = 0;
  // WeakRef is not supported in IE11 and Safari mobile, but so is the layout shift API, so this code won't be executed in these browsers
  var maxClsTarget;
  var maxClsStartTime;
  // if no layout shift happen the value should be reported as 0
  callback({
    value: 0
  });
  var window = slidingSessionWindow();
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
        var _a = window.update(entry),
          cumulatedValue = _a.cumulatedValue,
          isMaxValue = _a.isMaxValue;
        if (isMaxValue) {
          var target = getTargetFromSource(entry.sources);
          maxClsTarget = target ? new WeakRef(target) : undefined;
          maxClsStartTime = elapsed(viewStart, entry.startTime);
        }
        if (cumulatedValue > maxClsValue) {
          maxClsValue = cumulatedValue;
          var target = maxClsTarget === null || maxClsTarget === void 0 ? void 0 : maxClsTarget.deref();
          callback({
            value: round(maxClsValue, 4),
            targetSelector: target && getSelectorFromElement(target, configuration.actionNameAttribute),
            time: maxClsStartTime
          });
        }
      }
    }
  }).unsubscribe;
  return {
    stop: stop
  };
}
function getTargetFromSource(sources) {
  var _a;
  if (!sources) {
    return;
  }
  return (_a = find(sources, function (source) {
    return !!source.node && isElementNode(source.node);
  })) === null || _a === void 0 ? void 0 : _a.node;
}
var MAX_WINDOW_DURATION = 5 * ONE_SECOND;
var MAX_UPDATE_GAP = ONE_SECOND;
function slidingSessionWindow() {
  var cumulatedValue = 0;
  var startTime;
  var endTime;
  var maxValue = 0;
  return {
    update: function (entry) {
      var shouldCreateNewWindow = startTime === undefined || entry.startTime - endTime >= MAX_UPDATE_GAP || entry.startTime - startTime >= MAX_WINDOW_DURATION;
      var isMaxValue;
      if (shouldCreateNewWindow) {
        startTime = endTime = entry.startTime;
        maxValue = cumulatedValue = entry.value;
        isMaxValue = true;
      } else {
        cumulatedValue += entry.value;
        endTime = entry.startTime;
        isMaxValue = entry.value > maxValue;
        if (isMaxValue) {
          maxValue = entry.value;
        }
      }
      return {
        cumulatedValue: cumulatedValue,
        isMaxValue: isMaxValue
      };
    }
  };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
  return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}

/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */
var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
  if ('interactionCount' in performance || observer) {
    return;
  }
  observer = new window.PerformanceObserver(monitor(function (entries) {
    entries.getEntries().forEach(function (e) {
      var entry = e;
      if (entry.interactionId) {
        minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
        maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
        interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
      }
    });
  }));
  observer.observe({
    type: 'event',
    buffered: true,
    durationThreshold: 0
  });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
  return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};

// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
var MAX_INP_VALUE = 1 * ONE_MINUTE;
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
  if (!isInteractionToNextPaintSupported()) {
    return {
      getInteractionToNextPaint: function () {
        return undefined;
      },
      setViewEnd: noop,
      stop: noop
    };
  }
  var _a = trackViewInteractionCount(viewLoadingType),
    getViewInteractionCount = _a.getViewInteractionCount,
    stopViewInteractionCount = _a.stopViewInteractionCount;
  var viewEnd = Infinity;
  var longestInteractions = trackLongestInteractions(getViewInteractionCount);
  var interactionToNextPaint = -1;
  var interactionToNextPaintTargetSelector;
  var interactionToNextPaintStartTime;
  var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
      var entry = entries_1[_i];
      if ((entry.entryType === RumPerformanceEntryType.EVENT || entry.entryType === RumPerformanceEntryType.FIRST_INPUT) && entry.interactionId &&
      // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
      entry.startTime >= viewStart && entry.startTime <= viewEnd) {
        longestInteractions.process(entry);
      }
    }
    var newInteraction = longestInteractions.estimateP98Interaction();
    if (newInteraction && newInteraction.duration !== interactionToNextPaint) {
      interactionToNextPaint = newInteraction.duration;
      interactionToNextPaintStartTime = elapsed(viewStart, newInteraction.startTime);
      if (newInteraction.target && isElementNode(newInteraction.target)) {
        interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
      } else {
        interactionToNextPaintTargetSelector = undefined;
      }
    }
  }).unsubscribe;
  return {
    getInteractionToNextPaint: function () {
      // If no INP duration where captured because of the performanceObserver 40ms threshold
      // but the view interaction count > 0 then report 0
      if (interactionToNextPaint >= 0) {
        return {
          value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
          targetSelector: interactionToNextPaintTargetSelector,
          time: interactionToNextPaintStartTime
        };
      } else if (getViewInteractionCount()) {
        return {
          value: 0
        };
      }
    },
    setViewEnd: function (viewEndTime) {
      viewEnd = viewEndTime;
      stopViewInteractionCount();
    },
    stop: stop
  };
}
function trackLongestInteractions(getViewInteractionCount) {
  var longestInteractions = [];
  function sortAndTrimLongestInteractions() {
    longestInteractions.sort(function (a, b) {
      return b.duration - a.duration;
    }).splice(MAX_INTERACTION_ENTRIES);
  }
  return {
    /**
     * Process the performance entry:
     * - if its duration is long enough, add the performance entry to the list of worst interactions
     * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
     */
    process: function (entry) {
      var interactionIndex = longestInteractions.findIndex(function (interaction) {
        return entry.interactionId === interaction.interactionId;
      });
      var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
      if (interactionIndex !== -1) {
        if (entry.duration > longestInteractions[interactionIndex].duration) {
          longestInteractions[interactionIndex] = entry;
          sortAndTrimLongestInteractions();
        }
      } else if (longestInteractions.length < MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
        longestInteractions.push(entry);
        sortAndTrimLongestInteractions();
      }
    },
    /**
     * Compute the p98 longest interaction.
     * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
     */
    estimateP98Interaction: function () {
      var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
      return longestInteractions[interactionIndex];
    }
  };
}
function trackViewInteractionCount(viewLoadingType) {
  initInteractionCountPolyfill();
  var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
  var state = {
    stopped: false
  };
  function computeViewInteractionCount() {
    return getInteractionCount() - previousInteractionCount;
  }
  return {
    getViewInteractionCount: function () {
      if (state.stopped) {
        return state.interactionCount;
      }
      return computeViewInteractionCount();
    },
    stopViewInteractionCount: function () {
      state = {
        stopped: true,
        interactionCount: computeViewInteractionCount()
      };
    }
  };
}
function isInteractionToNextPaintSupported() {
  return supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) && window.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype;
}

function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
  var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
  var isWaitingForActivityLoadingTime = true;
  var loadingTimeCandidates = [];
  function invokeCallbackIfAllCandidatesAreReceived() {
    if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
      callback(Math.max.apply(Math, loadingTimeCandidates));
    }
  }
  var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
    if (isWaitingForActivityLoadingTime) {
      isWaitingForActivityLoadingTime = false;
      if (event.hadActivity) {
        loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
      }
      invokeCallbackIfAllCandidatesAreReceived();
    }
  }).stop;
  return {
    stop: stop,
    setLoadEvent: function (loadEvent) {
      if (isWaitingForLoadEvent) {
        isWaitingForLoadEvent = false;
        loadingTimeCandidates.push(loadEvent);
        invokeCallbackIfAllCandidatesAreReceived();
      }
    }
  };
}

function getScrollX() {
  var scrollX;
  var visual = window.visualViewport;
  if (visual) {
    scrollX = visual.pageLeft - visual.offsetLeft;
  } else if (window.scrollX !== undefined) {
    scrollX = window.scrollX;
  } else {
    scrollX = window.pageXOffset || 0;
  }
  return Math.round(scrollX);
}
function getScrollY() {
  var scrollY;
  var visual = window.visualViewport;
  if (visual) {
    scrollY = visual.pageTop - visual.offsetTop;
  } else if (window.scrollY !== undefined) {
    scrollY = window.scrollY;
  } else {
    scrollY = window.pageYOffset || 0;
  }
  return Math.round(scrollY);
}

var viewportObservable;
function initViewportObservable(configuration) {
  if (!viewportObservable) {
    viewportObservable = createViewportObservable(configuration);
  }
  return viewportObservable;
}
function createViewportObservable(configuration) {
  return new Observable(function (observable) {
    var updateDimension = throttle(function () {
      observable.notify(getViewportDimension());
    }, 200).throttled;
    return addEventListener(configuration, window, DOM_EVENT.RESIZE, updateDimension, {
      capture: true,
      passive: true
    }).stop;
  });
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
  var visual = window.visualViewport;
  if (visual) {
    return {
      width: Number(visual.width * visual.scale),
      height: Number(visual.height * visual.scale)
    };
  }
  return {
    width: Number(window.innerWidth || 0),
    height: Number(window.innerHeight || 0)
  };
}

/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = ONE_SECOND;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
  if (scrollValues === void 0) {
    scrollValues = createScrollValuesObservable(configuration);
  }
  var maxScrollDepth = 0;
  var maxScrollHeight = 0;
  var maxScrollHeightTime = 0;
  var subscription = scrollValues.subscribe(function (_a) {
    var scrollDepth = _a.scrollDepth,
      scrollTop = _a.scrollTop,
      scrollHeight = _a.scrollHeight;
    var shouldUpdate = false;
    if (scrollDepth > maxScrollDepth) {
      maxScrollDepth = scrollDepth;
      shouldUpdate = true;
    }
    if (scrollHeight > maxScrollHeight) {
      maxScrollHeight = scrollHeight;
      var now = relativeNow();
      maxScrollHeightTime = elapsed(viewStart.relative, now);
      shouldUpdate = true;
    }
    if (shouldUpdate) {
      callback({
        maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
        maxDepthScrollTop: scrollTop,
        maxScrollHeight: maxScrollHeight,
        maxScrollHeightTime: maxScrollHeightTime
      });
    }
  });
  return {
    stop: function () {
      return subscription.unsubscribe();
    }
  };
}
function computeScrollValues() {
  var scrollTop = getScrollY();
  var height = getViewportDimension().height;
  var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
  var scrollDepth = Math.round(height + scrollTop);
  return {
    scrollHeight: scrollHeight,
    scrollDepth: scrollDepth,
    scrollTop: scrollTop
  };
}
function createScrollValuesObservable(configuration, throttleDuration) {
  if (throttleDuration === void 0) {
    throttleDuration = THROTTLE_SCROLL_DURATION;
  }
  return new Observable(function (observable) {
    function notify() {
      observable.notify(computeScrollValues());
    }
    if (window.ResizeObserver) {
      var throttledNotify_1 = throttle(notify, throttleDuration, {
        leading: false,
        trailing: true
      });
      var observerTarget_1 = document.scrollingElement || document.documentElement;
      var resizeObserver_1 = new ResizeObserver(monitor(throttledNotify_1.throttled));
      resizeObserver_1.observe(observerTarget_1);
      var eventListener_1 = addEventListener(configuration, window, DOM_EVENT.SCROLL, throttledNotify_1.throttled, {
        passive: true
      });
      return function () {
        throttledNotify_1.cancel();
        resizeObserver_1.unobserve(observerTarget_1);
        eventListener_1.stop();
      };
    }
  });
}

function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
  var commonViewMetrics = {};
  var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
      commonViewMetrics.loadingTime = newLoadingTime;
      scheduleViewUpdate();
    }),
    stopLoadingTimeTracking = _a.stop,
    setLoadEvent = _a.setLoadEvent;
  var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
    commonViewMetrics.scroll = newScrollMetrics;
  }).stop;
  var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, viewStart.relative, function (cumulativeLayoutShift) {
    commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
    scheduleViewUpdate();
  }).stop;
  var _b = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType, lifeCycle),
    stopINPTracking = _b.stop,
    getInteractionToNextPaint = _b.getInteractionToNextPaint,
    setViewEnd = _b.setViewEnd;
  return {
    stop: function () {
      stopLoadingTimeTracking();
      stopCLSTracking();
      stopScrollMetricsTracking();
    },
    stopINPTracking: stopINPTracking,
    setLoadEvent: setLoadEvent,
    setViewEnd: setViewEnd,
    getCommonViewMetrics: function () {
      commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
      return commonViewMetrics;
    }
  };
}

var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
  var activeViews = new Set();
  var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, clocksOrigin(), initialViewOptions);
  startViewLifeCycle();
  var locationChangeSubscription;
  if (areViewsTrackedAutomatically) {
    locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
  }
  function startNewView(loadingType, startClocks, viewOptions) {
    var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
    activeViews.add(newlyCreatedView);
    newlyCreatedView.stopObservable.subscribe(function () {
      activeViews.delete(newlyCreatedView);
    });
    return newlyCreatedView;
  }
  function startViewLifeCycle() {
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
      // Renew view on session renewal
      currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
        name: currentView.name,
        service: currentView.service,
        version: currentView.version
      });
    });
    lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
      currentView.end({
        sessionIsActive: false
      });
    });
    // End the current view on page unload
    lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
      if (pageExitEvent.reason === PageExitReason.UNLOADING) {
        currentView.end();
      }
    });
  }
  function renewViewOnLocationChange(locationChangeObservable) {
    return locationChangeObservable.subscribe(function (_a) {
      var oldLocation = _a.oldLocation,
        newLocation = _a.newLocation;
      if (areDifferentLocation(oldLocation, newLocation)) {
        currentView.end();
        currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
      }
    });
  }
  return {
    addTiming: function (name, time) {
      if (time === void 0) {
        time = timeStampNow();
      }
      currentView.addTiming(name, time);
    },
    startView: function (options, startClocks) {
      currentView.end({
        endClocks: startClocks
      });
      currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
    },
    updateViewName: function (name) {
      currentView.updateViewName(name);
    },
    stop: function () {
      locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
      currentView.end();
      activeViews.forEach(function (view) {
        return view.stop();
      });
    }
  };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
  if (startClocks === void 0) {
    startClocks = clocksNow();
  }
  // Setup initial values
  var id = generateUUID();
  var stopObservable = new Observable();
  var customTimings = {};
  var documentVersion = 0;
  var endClocks;
  var location = shallowClone(initialLocation);
  var sessionIsActive = true;
  var name;
  var service;
  var version;
  if (viewOptions) {
    name = viewOptions.name;
    service = viewOptions.service || undefined;
    version = viewOptions.version || undefined;
  }
  var viewCreatedEvent = {
    id: id,
    name: name,
    startClocks: startClocks,
    service: service,
    version: version
  };
  lifeCycle.notify(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, viewCreatedEvent);
  lifeCycle.notify(3 /* LifeCycleEventType.VIEW_CREATED */, viewCreatedEvent);
  // Update the view every time the measures are changing
  var _a = throttle(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
      leading: false
    }),
    scheduleViewUpdate = _a.throttled,
    cancelScheduleViewUpdate = _a.cancel;
  var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks),
    setLoadEvent = _b.setLoadEvent,
    setViewEnd = _b.setViewEnd,
    stopCommonViewMetricsTracking = _b.stop,
    stopINPTracking = _b.stopINPTracking,
    getCommonViewMetrics = _b.getCommonViewMetrics;
  var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) : {
      stop: noop,
      initialViewMetrics: {}
    },
    stopInitialViewMetricsTracking = _c.stop,
    initialViewMetrics = _c.initialViewMetrics;
  var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate),
    stopEventCountsTracking = _d.stop,
    eventCounts = _d.eventCounts;
  // Session keep alive
  var keepAliveIntervalId = setInterval$1(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
  // Initial view update
  triggerViewUpdate();
  function triggerViewUpdate() {
    cancelScheduleViewUpdate();
    documentVersion += 1;
    var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
    lifeCycle.notify(4 /* LifeCycleEventType.VIEW_UPDATED */, {
      customTimings: customTimings,
      documentVersion: documentVersion,
      id: id,
      name: name,
      service: service,
      version: version,
      loadingType: loadingType,
      location: location,
      startClocks: startClocks,
      commonViewMetrics: getCommonViewMetrics(),
      initialViewMetrics: initialViewMetrics,
      duration: elapsed(startClocks.timeStamp, currentEnd),
      isActive: endClocks === undefined,
      sessionIsActive: sessionIsActive,
      eventCounts: eventCounts
    });
  }
  return {
    get name() {
      return name;
    },
    service: service,
    version: version,
    stopObservable: stopObservable,
    end: function (options) {
      var _this = this;
      var _a, _b;
      if (options === void 0) {
        options = {};
      }
      if (endClocks) {
        // view already ended
        return;
      }
      endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : clocksNow();
      sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
      lifeCycle.notify(5 /* LifeCycleEventType.VIEW_ENDED */, {
        endClocks: endClocks
      });
      lifeCycle.notify(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, {
        endClocks: endClocks
      });
      clearInterval$1(keepAliveIntervalId);
      setViewEnd(endClocks.relative);
      stopCommonViewMetricsTracking();
      triggerViewUpdate();
      setTimeout$1(function () {
        _this.stop();
      }, KEEP_TRACKING_AFTER_VIEW_DELAY);
    },
    stop: function () {
      stopInitialViewMetricsTracking();
      stopEventCountsTracking();
      stopINPTracking();
      stopObservable.notify();
    },
    addTiming: function (name, time) {
      if (endClocks) {
        return;
      }
      var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
      customTimings[sanitizeTiming(name)] = relativeTime;
      scheduleViewUpdate();
    },
    updateViewName: function (updatedName) {
      if (!isExperimentalFeatureEnabled(ExperimentalFeature.UPDATE_VIEW_NAME)) {
        return;
      }
      name = updatedName;
      triggerViewUpdate();
    }
  };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
  var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
  if (sanitized !== name) {
    display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
  }
  return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
  return currentLocation.pathname !== otherLocation.pathname || !isHashAnAnchor(otherLocation.hash) && getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash);
}
function isHashAnAnchor(hash) {
  var correspondingId = hash.substring(1);
  // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
  return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
  var index = hash.indexOf('?');
  return index < 0 ? hash : hash.slice(0, index);
}

function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
  lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
    return lifeCycle.notify(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
  });
  return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  var replayStats = recorderApi.getReplayStats(view.id);
  var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
  var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
  var viewEvent = {
    _dd: {
      document_version: view.documentVersion,
      replay_stats: replayStats,
      page_states: pageStates,
      configuration: {
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually
      }
    },
    date: view.startClocks.timeStamp,
    type: "view" /* RumEventType.VIEW */,
    view: {
      action: {
        count: view.eventCounts.actionCount
      },
      frustration: {
        count: view.eventCounts.frustrationCount
      },
      cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
      cumulative_layout_shift_time: toServerDuration((_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.time),
      cumulative_layout_shift_target_selector: (_c = view.commonViewMetrics.cumulativeLayoutShift) === null || _c === void 0 ? void 0 : _c.targetSelector,
      first_byte: toServerDuration((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.firstByte),
      dom_complete: toServerDuration((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domComplete),
      dom_content_loaded: toServerDuration((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domContentLoaded),
      dom_interactive: toServerDuration((_g = view.initialViewMetrics.navigationTimings) === null || _g === void 0 ? void 0 : _g.domInteractive),
      error: {
        count: view.eventCounts.errorCount
      },
      first_contentful_paint: toServerDuration(view.initialViewMetrics.firstContentfulPaint),
      first_input_delay: toServerDuration((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.delay),
      first_input_time: toServerDuration((_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.time),
      first_input_target_selector: (_k = view.initialViewMetrics.firstInput) === null || _k === void 0 ? void 0 : _k.targetSelector,
      interaction_to_next_paint: toServerDuration((_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.value),
      interaction_to_next_paint_time: toServerDuration((_m = view.commonViewMetrics.interactionToNextPaint) === null || _m === void 0 ? void 0 : _m.time),
      interaction_to_next_paint_target_selector: (_o = view.commonViewMetrics.interactionToNextPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
      is_active: view.isActive,
      name: view.name,
      largest_contentful_paint: toServerDuration((_p = view.initialViewMetrics.largestContentfulPaint) === null || _p === void 0 ? void 0 : _p.value),
      largest_contentful_paint_target_selector: (_q = view.initialViewMetrics.largestContentfulPaint) === null || _q === void 0 ? void 0 : _q.targetSelector,
      load_event: toServerDuration((_r = view.initialViewMetrics.navigationTimings) === null || _r === void 0 ? void 0 : _r.loadEvent),
      loading_time: discardNegativeDuration(toServerDuration(view.commonViewMetrics.loadingTime)),
      loading_type: view.loadingType,
      long_task: {
        count: view.eventCounts.longTaskCount
      },
      resource: {
        count: view.eventCounts.resourceCount
      },
      time_spent: toServerDuration(view.duration)
    },
    feature_flags: featureFlagContext && !isEmptyObject(featureFlagContext) ? featureFlagContext : undefined,
    display: view.commonViewMetrics.scroll ? {
      scroll: {
        max_depth: view.commonViewMetrics.scroll.maxDepth,
        max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
        max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
        max_scroll_height_time: toServerDuration(view.commonViewMetrics.scroll.maxScrollHeightTime)
      }
    } : undefined,
    session: {
      has_replay: replayStats ? true : undefined,
      is_active: view.sessionIsActive ? undefined : false
    },
    privacy: {
      replay_level: configuration.defaultPrivacyLevel
    }
  };
  if (!isEmptyObject(view.customTimings)) {
    viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
  }
  return {
    rawRumEvent: viewEvent,
    startTime: view.startClocks.relative,
    domainContext: {
      location: view.location
    }
  };
}

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
  var sessionManager = startSessionManager(configuration, RUM_SESSION_KEY, function (rawTrackingType) {
    return computeSessionState(configuration, rawTrackingType);
  }, trackingConsentState);
  sessionManager.expireObservable.subscribe(function () {
    lifeCycle.notify(9 /* LifeCycleEventType.SESSION_EXPIRED */);
  });
  sessionManager.renewObservable.subscribe(function () {
    lifeCycle.notify(10 /* LifeCycleEventType.SESSION_RENEWED */);
  });
  sessionManager.sessionStateUpdateObservable.subscribe(function (_a) {
    var previousState = _a.previousState,
      newState = _a.newState;
    if (!previousState.forcedReplay && newState.forcedReplay) {
      var sessionEntity = sessionManager.findSession();
      if (sessionEntity) {
        sessionEntity.isReplayForced = true;
      }
    }
  });
  return {
    findTrackedSession: function (startTime) {
      var session = sessionManager.findSession(startTime);
      if (!session || !isTypeTracked(session.trackingType)) {
        return;
      }
      return {
        id: session.id,
        sessionReplay: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ? 1 /* SessionReplayState.SAMPLED */ : session.isReplayForced ? 2 /* SessionReplayState.FORCED */ : 0 /* SessionReplayState.OFF */
      };
    },
    expire: sessionManager.expire,
    expireObservable: sessionManager.expireObservable,
    setForcedReplay: function () {
      return sessionManager.updateSessionState({
        forcedReplay: '1'
      });
    }
  };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
  var session = {
    id: '00000000-aaaa-0000-aaaa-000000000000',
    sessionReplay: bridgeSupports("records" /* BridgeCapability.RECORDS */) ? 1 /* SessionReplayState.SAMPLED */ : 0 /* SessionReplayState.OFF */
  };
  return {
    findTrackedSession: function () {
      return session;
    },
    expire: noop,
    expireObservable: new Observable(),
    setForcedReplay: noop
  };
}
function computeSessionState(configuration, rawTrackingType) {
  var trackingType;
  if (hasValidRumSession(rawTrackingType)) {
    trackingType = rawTrackingType;
  } else if (!performDraw(configuration.sessionSampleRate)) {
    trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
  } else if (!performDraw(configuration.sessionReplaySampleRate)) {
    trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
  } else {
    trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
  }
  return {
    trackingType: trackingType,
    isTracked: isTypeTracked(trackingType)
  };
}
function hasValidRumSession(trackingType) {
  return trackingType === "0" /* RumTrackingType.NOT_TRACKED */ || trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ || trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
}
function isTypeTracked(rumSessionType) {
  return rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ || rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
}

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
  var replica = configuration.replica;
  var batch = startBatchWithReplica(configuration, {
    endpoint: configuration.rumEndpointBuilder,
    encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */)
  }, replica && {
    endpoint: replica.rumEndpointBuilder,
    transformMessage: function (message) {
      return combine(message, {
        application: {
          id: replica.applicationId
        }
      });
    },
    encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */)
  }, reportError, pageExitObservable, sessionExpireObservable);
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
    if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
      batch.upsert(serverRumEvent, serverRumEvent.view.id);
    } else {
      batch.add(serverRumEvent);
    }
  });
  telemetryEventObservable.subscribe(function (event) {
    return batch.add(event, isTelemetryReplicationAllowed(configuration));
  });
  return batch;
}

function startRumEventBridge(lifeCycle) {
  var bridge = getEventBridge();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
    bridge.send('rum', serverRumEvent);
  });
}

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
  var urlContextHistory = new ValueHistory(URL_CONTEXT_TIME_OUT_DELAY);
  var previousViewUrl;
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
    var startClocks = _a.startClocks;
    var viewUrl = location.href;
    urlContextHistory.add(buildUrlContext({
      url: viewUrl,
      referrer: !previousViewUrl ? document.referrer : previousViewUrl
    }), startClocks.relative);
    previousViewUrl = viewUrl;
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    urlContextHistory.closeActive(endClocks.relative);
  });
  var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
    var newLocation = _a.newLocation;
    var current = urlContextHistory.find();
    if (current) {
      var changeTime = relativeNow();
      urlContextHistory.closeActive(changeTime);
      urlContextHistory.add(buildUrlContext({
        url: newLocation.href,
        referrer: current.referrer
      }), changeTime);
    }
  });
  function buildUrlContext(_a) {
    var url = _a.url,
      referrer = _a.referrer;
    return {
      url: url,
      referrer: referrer
    };
  }
  return {
    findUrl: function (startTime) {
      return urlContextHistory.find(startTime);
    },
    stop: function () {
      locationChangeSubscription.unsubscribe();
      urlContextHistory.stop();
    }
  };
}

function createLocationChangeObservable(configuration, location) {
  var currentLocation = shallowClone(location);
  return new Observable(function (observable) {
    var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
    var stopHashTracking = trackHash(configuration, onLocationChange).stop;
    function onLocationChange() {
      if (currentLocation.href === location.href) {
        return;
      }
      var newLocation = shallowClone(location);
      observable.notify({
        newLocation: newLocation,
        oldLocation: currentLocation
      });
      currentLocation = newLocation;
    }
    return function () {
      stopHistoryTracking();
      stopHashTracking();
    };
  });
}
function trackHistory(configuration, onHistoryChange) {
  var stopInstrumentingPushState = instrumentMethod(history, 'pushState', function (_a) {
    var onPostCall = _a.onPostCall;
    onPostCall(onHistoryChange);
  }).stop;
  var stopInstrumentingReplaceState = instrumentMethod(history, 'replaceState', function (_a) {
    var onPostCall = _a.onPostCall;
    onPostCall(onHistoryChange);
  }).stop;
  var removeListener = addEventListener(configuration, window, DOM_EVENT.POP_STATE, onHistoryChange).stop;
  return {
    stop: function () {
      stopInstrumentingPushState();
      stopInstrumentingReplaceState();
      removeListener();
    }
  };
}
function trackHash(configuration, onHashChange) {
  return addEventListener(configuration, window, DOM_EVENT.HASH_CHANGE, onHashChange);
}

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, customerDataTracker) {
  var featureFlagContexts = new ValueHistory(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
  lifeCycle.subscribe(2 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (_a) {
    var startClocks = _a.startClocks;
    featureFlagContexts.add({}, startClocks.relative);
    customerDataTracker.resetCustomerData();
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_a) {
    var endClocks = _a.endClocks;
    featureFlagContexts.closeActive(endClocks.relative);
  });
  return {
    findFeatureFlagEvaluations: function (startTime) {
      return featureFlagContexts.find(startTime);
    },
    addFeatureFlagEvaluation: function (key, value) {
      var currentContext = featureFlagContexts.find();
      if (currentContext) {
        currentContext[key] = value;
        customerDataTracker.updateCustomerData(currentContext);
      }
    },
    stop: function () {
      return customerDataTracker.stop();
    }
  };
}

var MEASURES_PERIOD_DURATION = 10 * ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batchFlushObservable) {
  var customerDataTelemetryEnabled = telemetry.enabled && performDraw(configuration.customerDataTelemetrySampleRate);
  if (!customerDataTelemetryEnabled) {
    return;
  }
  initCurrentPeriodMeasures();
  initCurrentBatchMeasures();
  // We measure the data of every view updates even if there could only be one per batch due to the upsert
  // It means that contexts bytes count sums can be higher than it really is
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    batchHasRumEvent = true;
    updateMeasure(currentBatchMeasures.globalContextBytes, customerDataTrackerManager.getOrCreateTracker(2 /* CustomerDataType.GlobalContext */).getBytesCount());
    updateMeasure(currentBatchMeasures.userContextBytes, customerDataTrackerManager.getOrCreateTracker(1 /* CustomerDataType.User */).getBytesCount());
    updateMeasure(currentBatchMeasures.featureFlagBytes, includes(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) ? customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */).getBytesCount() : 0);
  });
  batchFlushObservable.subscribe(function (_a) {
    var bytesCount = _a.bytesCount,
      messagesCount = _a.messagesCount;
    // Don't measure batch that only contains telemetry events to avoid batch sending loop
    // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
    if (!batchHasRumEvent) {
      return;
    }
    currentPeriodMeasures.batchCount += 1;
    updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
    updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
    mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
    mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
    mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
    initCurrentBatchMeasures();
  });
  setInterval$1(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
  if (currentPeriodMeasures.batchCount === 0) {
    return;
  }
  addTelemetryDebug('Customer data measures', currentPeriodMeasures);
  initCurrentPeriodMeasures();
}
function createMeasure() {
  return {
    min: Infinity,
    max: 0,
    sum: 0
  };
}
function updateMeasure(measure, value) {
  measure.sum += value;
  measure.min = Math.min(measure.min, value);
  measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
  target.sum += source.sum;
  target.min = Math.min(target.min, source.min);
  target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
  currentPeriodMeasures = {
    batchCount: 0,
    batchBytesCount: createMeasure(),
    batchMessagesCount: createMeasure(),
    globalContextBytes: createMeasure(),
    userContextBytes: createMeasure(),
    featureFlagBytes: createMeasure()
  };
}
function initCurrentBatchMeasures() {
  batchHasRumEvent = false;
  currentBatchMeasures = {
    globalContextBytes: createMeasure(),
    userContextBytes: createMeasure(),
    featureFlagBytes: createMeasure()
  };
}

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
  if (maxPageStateEntriesSelectable === void 0) {
    maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE;
  }
  var pageStateEntryHistory = new ValueHistory(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
  var currentPageState;
  addPageState(getPageState(), relativeNow());
  var stopEventListeners = addEventListeners(configuration, window, [DOM_EVENT.PAGE_SHOW, DOM_EVENT.FOCUS, DOM_EVENT.BLUR, DOM_EVENT.VISIBILITY_CHANGE, DOM_EVENT.RESUME, DOM_EVENT.FREEZE, DOM_EVENT.PAGE_HIDE], function (event) {
    addPageState(computePageState(event), event.timeStamp);
  }, {
    capture: true
  }).stop;
  function addPageState(nextPageState, startTime) {
    if (startTime === void 0) {
      startTime = relativeNow();
    }
    if (nextPageState === currentPageState) {
      return;
    }
    currentPageState = nextPageState;
    pageStateEntryHistory.closeActive(startTime);
    pageStateEntryHistory.add({
      state: currentPageState,
      startTime: startTime
    }, startTime);
  }
  var pageStateHistory = {
    findAll: function (eventStartTime, duration) {
      var pageStateEntries = pageStateEntryHistory.findAll(eventStartTime, duration);
      if (pageStateEntries.length === 0) {
        return;
      }
      var pageStateServerEntries = [];
      // limit the number of entries to return
      var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
      // loop page state entries backward to return the selected ones in desc order
      for (var index = pageStateEntries.length - 1; index >= limit; index--) {
        var pageState = pageStateEntries[index];
        // compute the start time relative to the event start time (ex: to be relative to the view start time)
        var relativeStartTime = elapsed(eventStartTime, pageState.startTime);
        pageStateServerEntries.push({
          state: pageState.state,
          start: toServerDuration(relativeStartTime)
        });
      }
      return pageStateServerEntries;
    },
    wasInPageStateAt: function (state, startTime) {
      return pageStateHistory.wasInPageStateDuringPeriod(state, startTime, 0);
    },
    wasInPageStateDuringPeriod: function (state, startTime, duration) {
      return pageStateEntryHistory.findAll(startTime, duration).some(function (pageState) {
        return pageState.state === state;
      });
    },
    addPageState: addPageState,
    stop: function () {
      stopEventListeners();
      pageStateEntryHistory.stop();
    }
  };
  return pageStateHistory;
}
function computePageState(event) {
  if (event.type === DOM_EVENT.FREEZE) {
    return "frozen" /* PageState.FROZEN */;
  } else if (event.type === DOM_EVENT.PAGE_HIDE) {
    return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
  }
  return getPageState();
}
function getPageState() {
  if (document.visibilityState === 'hidden') {
    return "hidden" /* PageState.HIDDEN */;
  }
  if (document.hasFocus()) {
    return "active" /* PageState.ACTIVE */;
  }
  return "passive" /* PageState.PASSIVE */;
}

function startDisplayContext(configuration) {
  var viewport = getViewportDimension();
  var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
    viewport = viewportDimension;
  }).unsubscribe;
  return {
    get: function () {
      return {
        viewport: viewport
      };
    },
    stop: unsubscribeViewport
  };
}

function createCookieObservable(configuration, cookieName) {
  var detectCookieChangeStrategy = window.cookieStore ? listenToCookieStoreChange(configuration) : watchCookieFallback;
  return new Observable(function (observable) {
    return detectCookieChangeStrategy(cookieName, function (event) {
      return observable.notify(event);
    });
  });
}
function listenToCookieStoreChange(configuration) {
  return function (cookieName, callback) {
    var listener = addEventListener(configuration, window.cookieStore, DOM_EVENT.CHANGE, function (event) {
      // Based on our experimentation, we're assuming that entries for the same cookie cannot be in both the 'changed' and 'deleted' arrays.
      // However, due to ambiguity in the specification, we asked for clarification: https://github.com/WICG/cookie-store/issues/226
      var changeEvent = find(event.changed, function (event) {
        return event.name === cookieName;
      }) || find(event.deleted, function (event) {
        return event.name === cookieName;
      });
      if (changeEvent) {
        callback(changeEvent.value);
      }
    });
    return listener.stop;
  };
}
var WATCH_COOKIE_INTERVAL_DELAY = ONE_SECOND;
function watchCookieFallback(cookieName, callback) {
  var previousCookieValue = findCommaSeparatedValue(document.cookie, cookieName);
  var watchCookieIntervalId = setInterval$1(function () {
    var cookieValue = findCommaSeparatedValue(document.cookie, cookieName);
    if (cookieValue !== previousCookieValue) {
      callback(cookieValue);
    }
  }, WATCH_COOKIE_INTERVAL_DELAY);
  return function () {
    clearInterval$1(watchCookieIntervalId);
  };
}

var CI_VISIBILITY_TEST_ID_COOKIE_NAME = 'datadog-ci-visibility-test-execution-id';
function startCiVisibilityContext(configuration, cookieObservable) {
  var _a;
  if (cookieObservable === void 0) {
    cookieObservable = createCookieObservable(configuration, CI_VISIBILITY_TEST_ID_COOKIE_NAME);
  }
  var testExecutionId = getInitCookie(CI_VISIBILITY_TEST_ID_COOKIE_NAME) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
  var cookieObservableSubscription = cookieObservable.subscribe(function (value) {
    testExecutionId = value;
  });
  return {
    get: function () {
      if (typeof testExecutionId === 'string') {
        return {
          test_execution_id: testExecutionId
        };
      }
    },
    stop: function () {
      return cookieObservableSubscription.unsubscribe();
    }
  };
}

function startRum(configuration, recorderApi, customerDataTrackerManager, getCommonContext, initialViewOptions, createEncoder,
// `startRum` and its subcomponents assume tracking consent is granted initially and starts
// collecting logs unconditionally. As such, `startRum` should be called with a
// `trackingConsentState` set to "granted".
trackingConsentState) {
  var cleanupTasks = [];
  var lifeCycle = new LifeCycle();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
    return sendToExtension('rum', event);
  });
  var telemetry = startRumTelemetry(configuration);
  telemetry.setContextProvider(function () {
    var _a, _b;
    return {
      application: {
        id: configuration.applicationId
      },
      session: {
        id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id
      },
      view: {
        id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id
      },
      action: {
        id: actionContexts.findActionId()
      }
    };
  });
  var reportError = function (error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var featureFlagContexts = startFeatureFlagContexts(lifeCycle, customerDataTrackerManager.getOrCreateTracker(0 /* CustomerDataType.FeatureFlag */));
  var pageExitObservable = createPageExitObservable(configuration);
  var pageExitSubscription = pageExitObservable.subscribe(function (event) {
    lifeCycle.notify(11 /* LifeCycleEventType.PAGE_EXITED */, event);
  });
  cleanupTasks.push(function () {
    return pageExitSubscription.unsubscribe();
  });
  var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle, trackingConsentState) : startRumSessionManagerStub();
  if (!canUseEventBridge()) {
    var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
    cleanupTasks.push(function () {
      return batch_1.stop();
    });
    startCustomerDataTelemetry(configuration, telemetry, lifeCycle, customerDataTrackerManager, batch_1.flushObservable);
  } else {
    startRumEventBridge(lifeCycle);
  }
  var domMutationObservable = createDOMMutationObservable();
  var locationChangeObservable = createLocationChangeObservable(configuration, location);
  var pageStateHistory = startPageStateHistory(configuration);
  var _a = startRumEventCollection(lifeCycle, configuration, location, session, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError),
    viewContexts = _a.viewContexts,
    urlContexts = _a.urlContexts,
    actionContexts = _a.actionContexts,
    addAction = _a.addAction,
    stopRumEventCollection = _a.stop;
  cleanupTasks.push(stopRumEventCollection);
  drainPreStartTelemetry();
  var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions),
    addTiming = _b.addTiming,
    startView = _b.startView,
    updateViewName = _b.updateViewName,
    stopViewCollection = _b.stop;
  cleanupTasks.push(stopViewCollection);
  var stopResourceCollection = startResourceCollection(lifeCycle, configuration, pageStateHistory).stop;
  cleanupTasks.push(stopResourceCollection);
  startLongTaskCollection(lifeCycle, configuration);
  var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
  startRequestCollection(lifeCycle, configuration, session);
  var stopPerformanceCollection = startPerformanceCollection(lifeCycle, configuration).stop;
  cleanupTasks.push(stopPerformanceCollection);
  var vitalCollection = startVitalCollection(lifeCycle, pageStateHistory);
  var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
  return {
    addAction: addAction,
    addError: addError,
    addTiming: addTiming,
    addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
    startView: startView,
    updateViewName: updateViewName,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts,
    session: session,
    stopSession: function () {
      return session.expire();
    },
    getInternalContext: internalContext.get,
    startDurationVital: vitalCollection.startDurationVital,
    addDurationVital: vitalCollection.addDurationVital,
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}
function startRumTelemetry(configuration) {
  var telemetry = startTelemetry("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
  if (canUseEventBridge()) {
    var bridge_1 = getEventBridge();
    telemetry.observable.subscribe(function (event) {
      return bridge_1.send('internal_telemetry', event);
    });
  }
  return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, pageStateHistory, locationChangeObservable, domMutationObservable, getCommonContext, reportError) {
  var viewContexts = startViewContexts(lifeCycle);
  var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
  var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory),
    addAction = _a.addAction,
    actionContexts = _a.actionContexts;
  var displayContext = startDisplayContext(configuration);
  var ciVisibilityContext = startCiVisibilityContext(configuration);
  startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, ciVisibilityContext, getCommonContext, reportError);
  return {
    viewContexts: viewContexts,
    pageStateHistory: pageStateHistory,
    urlContexts: urlContexts,
    addAction: addAction,
    actionContexts: actionContexts,
    stop: function () {
      ciVisibilityContext.stop();
      displayContext.stop();
      pageStateHistory.stop();
      urlContexts.stop();
      viewContexts.stop();
      pageStateHistory.stop();
    }
  };
}

function getSessionReplayUrl(configuration, _a) {
  var session = _a.session,
    viewContext = _a.viewContext,
    errorType = _a.errorType;
  var sessionId = session ? session.id : 'no-session-id';
  var parameters = [];
  if (errorType !== undefined) {
    parameters.push("error-type=".concat(errorType));
  }
  if (viewContext) {
    parameters.push("seed=".concat(viewContext.id));
    parameters.push("from=".concat(viewContext.startClocks.timeStamp));
  }
  var origin = getDatadogSiteUrl(configuration);
  var path = "/rum/replay/sessions/".concat(sessionId);
  return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
  var site = rumConfiguration.site;
  var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
  return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
  switch (configuration.site) {
    case INTAKE_SITE_US1:
    case INTAKE_SITE_EU1:
      return 'app';
    case INTAKE_SITE_STAGING:
      return 'dd';
    default:
      return undefined;
  }
}

var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
  return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
  getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
  getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
  getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
  return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function getOrCreateReplayStats(viewId) {
  if (!statsPerView) {
    statsPerView = new Map();
  }
  var replayStats;
  if (statsPerView.has(viewId)) {
    replayStats = statsPerView.get(viewId);
  } else {
    replayStats = {
      records_count: 0,
      segments_count: 0,
      segments_total_raw_size: 0
    };
    statsPerView.set(viewId, replayStats);
    if (statsPerView.size > MAX_STATS_HISTORY) {
      deleteOldestStats();
    }
  }
  return replayStats;
}
function deleteOldestStats() {
  if (!statsPerView) {
    return;
  }
  if (statsPerView.keys) {
    statsPerView.delete(statsPerView.keys().next().value);
  } else {
    // IE11 doesn't support map.keys
    var isFirst_1 = true;
    statsPerView.forEach(function (_value, key) {
      if (isFirst_1) {
        statsPerView.delete(key);
        isFirst_1 = false;
      }
    });
  }
}

var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
  return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
  var current = node;
  while (current) {
    if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
      return false;
    }
    current = getParentNode(current);
  }
  return true;
}
function getSerializedNodeId(node) {
  return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
  serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
  /*
   BROWSER SPEC NOTE: <input>, <select>
   For some <input> elements, the `value` is an exceptional property/attribute that has the
   value synced between el.value and el.getAttribute()
   input[type=button,checkbox,hidden,image,radio,reset,submit]
   */
  var tagName = element.tagName;
  var value = element.value;
  if (shouldMaskNode(element, nodePrivacyLevel)) {
    var type = element.type;
    if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
      // Overrule `MASK` privacy level for button-like element values, as they are used during replay
      // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
      return value;
    } else if (!value || tagName === 'OPTION') {
      // <Option> value provides no benefit
      return;
    }
    return CENSORED_STRING_MARK;
  }
  if (tagName === 'OPTION' || tagName === 'SELECT') {
    return element.value;
  }
  if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
    return;
  }
  return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
  return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
    var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
    if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
      return matchingSubstring;
    }
    var quote = singleQuote || doubleQuote || '';
    return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
  });
}
function makeUrlAbsolute(url, baseUrl) {
  try {
    return buildUrl(url, baseUrl).href;
  } catch (_) {
    return url;
  }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
  var processedTagName = tagName.toLowerCase().trim();
  if (TAG_NAME_REGEX.test(processedTagName)) {
    // if the tag name is odd and we cannot extract
    // anything from the string, then we return a
    // generic div
    return 'div';
  }
  return processedTagName;
}
function censoredImageForSize(width, height) {
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' style='background-color:silver'%3E%3C/svg%3E");
}

var RecordType = {
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Focus: 6,
  ViewEnd: 7,
  VisualViewport: 8,
  FrustrationRecord: 9
};
var NodeType = {
  Document: 0,
  DocumentType: 1,
  Element: 2,
  Text: 3,
  CDATA: 4,
  DocumentFragment: 11
};
var IncrementalSource = {
  Mutation: 0,
  MouseMove: 1,
  MouseInteraction: 2,
  Scroll: 3,
  ViewportResize: 4,
  Input: 5,
  TouchMove: 6,
  MediaInteraction: 7,
  StyleSheetRule: 8
  // CanvasMutation : 9,
  // Font : 10,
};
var MouseInteractionType = {
  MouseUp: 0,
  MouseDown: 1,
  Click: 2,
  ContextMenu: 3,
  DblClick: 4,
  Focus: 5,
  Blur: 6,
  TouchStart: 7,
  TouchEnd: 9
};
var MediaInteractionType = {
  Play: 0,
  Pause: 1
};

function serializeStyleSheets(cssStyleSheets) {
  if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
    return undefined;
  }
  return cssStyleSheets.map(function (cssStyleSheet) {
    var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
    var cssRules = Array.from(rules, function (cssRule) {
      return cssRule.cssText;
    });
    var styleSheet = {
      cssRules: cssRules,
      disabled: cssStyleSheet.disabled || undefined,
      media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined
    };
    return styleSheet;
  });
}

function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    // dup condition for direct access case
    return null;
  }
  var attributeValue = element.getAttribute(attributeName);
  if (nodePrivacyLevel === NodePrivacyLevel.MASK && attributeName !== PRIVACY_ATTR_NAME && !STABLE_ATTRIBUTES.includes(attributeName) && attributeName !== configuration.actionNameAttribute) {
    var tagName = element.tagName;
    switch (attributeName) {
      // Mask Attribute text content
      case 'title':
      case 'alt':
      case 'placeholder':
        return CENSORED_STRING_MARK;
    }
    // mask image URLs
    if (tagName === 'IMG' && (attributeName === 'src' || attributeName === 'srcset')) {
      // generate image with similar dimension than the original to have the same rendering behaviour
      var image = element;
      if (image.naturalWidth > 0) {
        return censoredImageForSize(image.naturalWidth, image.naturalHeight);
      }
      var _a = element.getBoundingClientRect(),
        width = _a.width,
        height = _a.height;
      if (width > 0 || height > 0) {
        return censoredImageForSize(width, height);
      }
      // if we can't get the image size, fallback to the censored image
      return CENSORED_IMG_MARK;
    }
    // mask source URLs
    if (tagName === 'SOURCE' && (attributeName === 'src' || attributeName === 'srcset')) {
      return CENSORED_IMG_MARK;
    }
    // mask <a> URLs
    if (tagName === 'A' && attributeName === 'href') {
      return CENSORED_STRING_MARK;
    }
    // mask data-* attributes
    if (attributeValue && startsWith(attributeName, 'data-')) {
      // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
      return CENSORED_STRING_MARK;
    }
    // mask iframe srcdoc
    if (tagName === 'IFRAME' && attributeName === 'srcdoc') {
      return CENSORED_STRING_MARK;
    }
  }
  if (!attributeValue || typeof attributeValue !== 'string') {
    return attributeValue;
  }
  // Minimum Fix for customer.
  if (isLongDataUrl(attributeValue)) {
    return sanitizeDataUrl(attributeValue);
  }
  return attributeValue;
}

function serializeAttributes(element, nodePrivacyLevel, options) {
  var _a;
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    return {};
  }
  var safeAttrs = {};
  var tagName = getValidTagName(element.tagName);
  var doc = element.ownerDocument;
  for (var i = 0; i < element.attributes.length; i += 1) {
    var attribute = element.attributes.item(i);
    var attributeName = attribute.name;
    var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
    if (attributeValue !== null) {
      safeAttrs[attributeName] = attributeValue;
    }
  }
  if (element.value && (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
    var formValue = getElementInputValue(element, nodePrivacyLevel);
    if (formValue !== undefined) {
      safeAttrs.value = formValue;
    }
  }
  /**
   * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
   */
  if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
    // For privacy=`MASK`, all the values would be the same, so skip.
    var optionElement = element;
    if (optionElement.selected) {
      safeAttrs.selected = optionElement.selected;
    }
  }
  // remote css
  if (tagName === 'link') {
    var stylesheet = Array.from(doc.styleSheets).find(function (s) {
      return s.href === element.href;
    });
    var cssText = getCssRulesString(stylesheet);
    if (cssText && stylesheet) {
      safeAttrs._cssText = cssText;
    }
  }
  // dynamic stylesheet
  if (tagName === 'style' && element.sheet) {
    var cssText = getCssRulesString(element.sheet);
    if (cssText) {
      safeAttrs._cssText = cssText;
    }
  }
  /**
   * Forms: input[type=checkbox,radio]
   * The `checked` property for <input> is a little bit special:
   * 1. el.checked is a setter that returns if truthy.
   * 2. getAttribute returns the string value
   * getAttribute('checked') does not sync with `Element.checked`, so use JS property
   * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
   */
  var inputElement = element;
  if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
    if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
      safeAttrs.checked = !!inputElement.checked;
    } else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
      delete safeAttrs.checked;
    }
  }
  /**
   * Serialize the media playback state
   */
  if (tagName === 'audio' || tagName === 'video') {
    var mediaElement = element;
    safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
  }
  /**
   * Serialize the scroll state for each element only for full snapshot
   */
  var scrollTop;
  var scrollLeft;
  var serializationContext = options.serializationContext;
  switch (serializationContext.status) {
    case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
      scrollTop = Math.round(element.scrollTop);
      scrollLeft = Math.round(element.scrollLeft);
      if (scrollTop || scrollLeft) {
        serializationContext.elementsScrollPositions.set(element, {
          scrollTop: scrollTop,
          scrollLeft: scrollLeft
        });
      }
      break;
    case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
      if (serializationContext.elementsScrollPositions.has(element)) {
        _a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft;
      }
      break;
  }
  if (scrollLeft) {
    safeAttrs.rr_scrollLeft = scrollLeft;
  }
  if (scrollTop) {
    safeAttrs.rr_scrollTop = scrollTop;
  }
  return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
  if (!cssStyleSheet) {
    return null;
  }
  var rules;
  try {
    rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
  } catch (_a) {
    // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
  }
  if (!rules) {
    return null;
  }
  var styleSheetCssText = Array.from(rules, isSafari() ? getCssRuleStringForSafari : getCssRuleString).join('');
  return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
  // Safari does not escape attribute selectors containing : properly
  // https://bugs.webkit.org/show_bug.cgi?id=184604
  if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
    // This regex replaces [foo:bar] by [foo\\:bar]
    var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
    return rule.cssText.replace(escapeColon, '$1\\$2');
  }
  return getCssRuleString(rule);
}
function getCssRuleString(rule) {
  // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
  // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
  // to the @import rule CSS text.
  return isCSSImportRule(rule) && getCssRulesString(rule.styleSheet) || rule.cssText;
}
function isCSSImportRule(rule) {
  return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
  return 'selectorText' in rule;
}

function serializeNodeWithId(node, options) {
  var serializedNode = serializeNode(node, options);
  if (!serializedNode) {
    return null;
  }
  // Try to reuse the previous id
  var id = getSerializedNodeId(node) || generateNextId();
  var serializedNodeWithId = serializedNode;
  serializedNodeWithId.id = id;
  setSerializedNodeId(node, id);
  if (options.serializedNodeIds) {
    options.serializedNodeIds.add(id);
  }
  return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
  return _nextId++;
}
function serializeChildNodes(node, options) {
  var result = [];
  forEachChildNodes(node, function (childNode) {
    var serializedChildNode = serializeNodeWithId(childNode, options);
    if (serializedChildNode) {
      result.push(serializedChildNode);
    }
  });
  return result;
}
function serializeNode(node, options) {
  switch (node.nodeType) {
    case node.DOCUMENT_NODE:
      return serializeDocumentNode(node, options);
    case node.DOCUMENT_FRAGMENT_NODE:
      return serializeDocumentFragmentNode(node, options);
    case node.DOCUMENT_TYPE_NODE:
      return serializeDocumentTypeNode(node);
    case node.ELEMENT_NODE:
      return serializeElementNode(node, options);
    case node.TEXT_NODE:
      return serializeTextNode(node, options);
    case node.CDATA_SECTION_NODE:
      return serializeCDataNode();
  }
}
function serializeDocumentNode(document, options) {
  return {
    type: NodeType.Document,
    childNodes: serializeChildNodes(document, options),
    adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets)
  };
}
function serializeDocumentFragmentNode(element, options) {
  var isShadowRoot = isNodeShadowRoot(element);
  if (isShadowRoot) {
    options.serializationContext.shadowRootsController.addShadowRoot(element);
  }
  return {
    type: NodeType.DocumentFragment,
    childNodes: serializeChildNodes(element, options),
    isShadowRoot: isShadowRoot,
    adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined
  };
}
function serializeDocumentTypeNode(documentType) {
  return {
    type: NodeType.DocumentType,
    name: documentType.name,
    publicId: documentType.publicId,
    systemId: documentType.systemId
  };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
  var _a;
  var tagName = getValidTagName(element.tagName);
  var isSVG = isSVGElement(element) || undefined;
  // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
  // parentNodePrivacyLevel option to avoid iterating over all parents
  var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
  if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
    var _b = element.getBoundingClientRect(),
      width = _b.width,
      height = _b.height;
    return {
      type: NodeType.Element,
      tagName: tagName,
      attributes: (_a = {
        rr_width: "".concat(width, "px"),
        rr_height: "".concat(height, "px")
      }, _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN, _a),
      childNodes: [],
      isSVG: isSVG
    };
  }
  // Ignore Elements like Script and some Link, Metas
  if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
    return;
  }
  var attributes = serializeAttributes(element, nodePrivacyLevel, options);
  var childNodes = [];
  if (hasChildNodes(element) &&
  // Do not serialize style children as the css rules are already in the _cssText attribute
  tagName !== 'style') {
    // OBJECT POOLING OPTIMIZATION:
    // We should not create a new object systematically as it could impact performances. Try to reuse
    // the same object as much as possible, and clone it only if we need to.
    var childNodesSerializationOptions = void 0;
    if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
      childNodesSerializationOptions = options;
    } else {
      childNodesSerializationOptions = assign({}, options, {
        parentNodePrivacyLevel: nodePrivacyLevel,
        ignoreWhiteSpace: tagName === 'head'
      });
    }
    childNodes = serializeChildNodes(element, childNodesSerializationOptions);
  }
  return {
    type: NodeType.Element,
    tagName: tagName,
    attributes: attributes,
    childNodes: childNodes,
    isSVG: isSVG
  };
}
function isSVGElement(el) {
  return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
  var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
  if (textContent === undefined) {
    return;
  }
  return {
    type: NodeType.Text,
    textContent: textContent
  };
}
function serializeCDataNode() {
  return {
    type: NodeType.CDATA,
    textContent: ''
  };
}

function serializeDocument(document, configuration, serializationContext) {
  // We are sure that Documents are never ignored, so this function never returns null
  return serializeNodeWithId(document, {
    serializationContext: serializationContext,
    parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
    configuration: configuration
  });
}

function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function getEventTarget(event) {
  if (event.composed === true && isNodeShadowHost(event.target)) {
    return event.composedPath()[0];
  }
  return event.target;
}

/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
  return Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE || Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE;
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
  var visualViewport = window.visualViewport;
  var normalized = {
    layoutViewportX: clientX,
    layoutViewportY: clientY,
    visualViewportX: clientX,
    visualViewportY: clientY
  };
  if (!visualViewport) {
    // On old browsers, we cannot normalize, so fallback to clientX/Y
    return normalized;
  } else if (isVisualViewportFactoredIn(visualViewport)) {
    // Typically Mobile Devices
    normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
    normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
  } else {
    // Typically Desktop Devices
    normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
    normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
  }
  return normalized;
};
var getVisualViewport = function (visualViewport) {
  return {
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width
  };
};

function assembleIncrementalSnapshot(source, data) {
  return {
    data: assign({
      source: source
    }, data),
    type: RecordType.IncrementalSnapshot,
    timestamp: timeStampNow()
  };
}

var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function trackMove(configuration, moveCb) {
  var _a = throttle(function (event) {
      var target = getEventTarget(event);
      if (hasSerializedNode(target)) {
        var coordinates = tryToComputeCoordinates(event);
        if (!coordinates) {
          return;
        }
        var position = {
          id: getSerializedNodeId(target),
          timeOffset: 0,
          x: coordinates.x,
          y: coordinates.y
        };
        moveCb(assembleIncrementalSnapshot(isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove, {
          positions: [position]
        }));
      }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
      trailing: false
    }),
    updatePosition = _a.throttled,
    cancelThrottle = _a.cancel;
  var removeListener = addEventListeners(configuration, document, [DOM_EVENT.MOUSE_MOVE, DOM_EVENT.TOUCH_MOVE], updatePosition, {
    capture: true,
    passive: true
  }).stop;
  return {
    stop: function () {
      removeListener();
      cancelThrottle();
    }
  };
}
function tryToComputeCoordinates(event) {
  var _a = isTouchEvent(event) ? event.changedTouches[0] : event,
    x = _a.clientX,
    y = _a.clientY;
  if (window.visualViewport) {
    var _b = convertMouseEventToLayoutCoordinates(x, y),
      visualViewportX = _b.visualViewportX,
      visualViewportY = _b.visualViewportY;
    x = visualViewportX;
    y = visualViewportY;
  }
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    if (event.isTrusted) {
      addTelemetryDebug('mouse/touch event without x/y');
    }
    return undefined;
  }
  return {
    x: x,
    y: y
  };
}

var _a;
var eventTypeToMouseInteraction = (_a = {},
// Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
// allows to reference such records from Frustration records.
//
// In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
// used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
// `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
// convey such interaction. This would cleanly solve the issue since we would have
// `PointerInteraction/Up` records that we could reference from `Frustration` records.
_a[DOM_EVENT.POINTER_UP] = MouseInteractionType.MouseUp, _a[DOM_EVENT.MOUSE_DOWN] = MouseInteractionType.MouseDown, _a[DOM_EVENT.CLICK] = MouseInteractionType.Click, _a[DOM_EVENT.CONTEXT_MENU] = MouseInteractionType.ContextMenu, _a[DOM_EVENT.DBL_CLICK] = MouseInteractionType.DblClick, _a[DOM_EVENT.FOCUS] = MouseInteractionType.Focus, _a[DOM_EVENT.BLUR] = MouseInteractionType.Blur, _a[DOM_EVENT.TOUCH_START] = MouseInteractionType.TouchStart, _a[DOM_EVENT.TOUCH_END] = MouseInteractionType.TouchEnd, _a);
function trackMouseInteraction(configuration, mouseInteractionCb, recordIds) {
  var handler = function (event) {
    var target = getEventTarget(event);
    if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    var id = getSerializedNodeId(target);
    var type = eventTypeToMouseInteraction[event.type];
    var interaction;
    if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
      var coordinates = tryToComputeCoordinates(event);
      if (!coordinates) {
        return;
      }
      interaction = {
        id: id,
        type: type,
        x: coordinates.x,
        y: coordinates.y
      };
    } else {
      interaction = {
        id: id,
        type: type
      };
    }
    var record = assign({
      id: recordIds.getIdForEvent(event)
    }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
    mouseInteractionCb(record);
  };
  return addEventListeners(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
    capture: true,
    passive: true
  });
}

var SCROLL_OBSERVER_THRESHOLD = 100;
function trackScroll(configuration, scrollCb, elementsScrollPositions, target) {
  if (target === void 0) {
    target = document;
  }
  var _a = throttle(function (event) {
      var target = getEventTarget(event);
      if (!target || getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
        return;
      }
      var id = getSerializedNodeId(target);
      var scrollPositions = target === document ? {
        scrollTop: getScrollY(),
        scrollLeft: getScrollX()
      } : {
        scrollTop: Math.round(target.scrollTop),
        scrollLeft: Math.round(target.scrollLeft)
      };
      elementsScrollPositions.set(target, scrollPositions);
      scrollCb(assembleIncrementalSnapshot(IncrementalSource.Scroll, {
        id: id,
        x: scrollPositions.scrollLeft,
        y: scrollPositions.scrollTop
      }));
    }, SCROLL_OBSERVER_THRESHOLD),
    updatePosition = _a.throttled,
    cancelThrottle = _a.cancel;
  var removeListener = addEventListener(configuration, target, DOM_EVENT.SCROLL, updatePosition, {
    capture: true,
    passive: true
  }).stop;
  return {
    stop: function () {
      removeListener();
      cancelThrottle();
    }
  };
}

function trackViewportResize(configuration, viewportResizeCb) {
  var viewportResizeSubscription = initViewportObservable(configuration).subscribe(function (data) {
    viewportResizeCb(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, data));
  });
  return {
    stop: function () {
      viewportResizeSubscription.unsubscribe();
    }
  };
}

function trackMediaInteraction(configuration, mediaInteractionCb) {
  return addEventListeners(configuration, document, [DOM_EVENT.PLAY, DOM_EVENT.PAUSE], function (event) {
    var target = getEventTarget(event);
    if (!target || getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
      return;
    }
    mediaInteractionCb(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, {
      id: getSerializedNodeId(target),
      type: event.type === DOM_EVENT.PLAY ? MediaInteractionType.Play : MediaInteractionType.Pause
    }));
  }, {
    capture: true,
    passive: true
  });
}

function trackStyleSheet(styleSheetCb) {
  function checkStyleSheetAndCallback(styleSheet, callback) {
    if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
      callback(getSerializedNodeId(styleSheet.ownerNode));
    }
  }
  var instrumentationStoppers = [instrumentMethod(CSSStyleSheet.prototype, 'insertRule', function (_a) {
    var styleSheet = _a.target,
      _b = _a.parameters,
      rule = _b[0],
      index = _b[1];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        adds: [{
          rule: rule,
          index: index
        }]
      }));
    });
  }), instrumentMethod(CSSStyleSheet.prototype, 'deleteRule', function (_a) {
    var styleSheet = _a.target,
      index = _a.parameters[0];
    checkStyleSheetAndCallback(styleSheet, function (id) {
      return styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
        id: id,
        removes: [{
          index: index
        }]
      }));
    });
  })];
  if (typeof CSSGroupingRule !== 'undefined') {
    instrumentGroupingCSSRuleClass(CSSGroupingRule);
  } else {
    instrumentGroupingCSSRuleClass(CSSMediaRule);
    instrumentGroupingCSSRuleClass(CSSSupportsRule);
  }
  function instrumentGroupingCSSRuleClass(cls) {
    instrumentationStoppers.push(instrumentMethod(cls.prototype, 'insertRule', function (_a) {
      var styleSheet = _a.target,
        _b = _a.parameters,
        rule = _b[0],
        index = _b[1];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index || 0);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            adds: [{
              rule: rule,
              index: path
            }]
          }));
        }
      });
    }), instrumentMethod(cls.prototype, 'deleteRule', function (_a) {
      var styleSheet = _a.target,
        index = _a.parameters[0];
      checkStyleSheetAndCallback(styleSheet.parentStyleSheet, function (id) {
        var path = getPathToNestedCSSRule(styleSheet);
        if (path) {
          path.push(index);
          styleSheetCb(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, {
            id: id,
            removes: [{
              index: path
            }]
          }));
        }
      });
    }));
  }
  return {
    stop: function () {
      instrumentationStoppers.forEach(function (stopper) {
        return stopper.stop();
      });
    }
  };
}
function getPathToNestedCSSRule(rule) {
  var path = [];
  var currentRule = rule;
  while (currentRule.parentRule) {
    var rules_1 = Array.from(currentRule.parentRule.cssRules);
    var index_1 = rules_1.indexOf(currentRule);
    path.unshift(index_1);
    currentRule = currentRule.parentRule;
  }
  // A rule may not be attached to a stylesheet
  if (!currentRule.parentStyleSheet) {
    return;
  }
  var rules = Array.from(currentRule.parentStyleSheet.cssRules);
  var index = rules.indexOf(currentRule);
  path.unshift(index);
  return path;
}

function trackFocus(configuration, focusCb) {
  return addEventListeners(configuration, window, [DOM_EVENT.FOCUS, DOM_EVENT.BLUR], function () {
    focusCb({
      data: {
        has_focus: document.hasFocus()
      },
      type: RecordType.Focus,
      timestamp: timeStampNow()
    });
  });
}

function trackFrustration(lifeCycle, frustrationCb, recordIds) {
  var frustrationSubscription = lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
    var _a, _b, _c;
    if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ && data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ && ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) && 'events' in data.domainContext && ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
      frustrationCb({
        timestamp: data.rawRumEvent.date,
        type: RecordType.FrustrationRecord,
        data: {
          frustrationTypes: data.rawRumEvent.action.frustration.type,
          recordIds: data.domainContext.events.map(function (e) {
            return recordIds.getIdForEvent(e);
          })
        }
      });
    }
  });
  return {
    stop: function () {
      frustrationSubscription.unsubscribe();
    }
  };
}

function trackViewEnd(lifeCycle, viewEndCb) {
  var viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, function () {
    viewEndCb({
      timestamp: timeStampNow(),
      type: RecordType.ViewEnd
    });
  });
  return {
    stop: function () {
      viewEndSubscription.unsubscribe();
    }
  };
}

function trackInput(configuration, inputCb, target) {
  if (target === void 0) {
    target = document;
  }
  var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
  var lastInputStateMap = new WeakMap();
  var isShadowRoot = target !== document;
  var stopEventListeners = addEventListeners(configuration, target,
  // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
  // roots since it will be handled by the event listener that we did add to the document. Only
  // the 'change' event is blocked and needs to be handled on shadow roots.
  isShadowRoot ? [DOM_EVENT.CHANGE] : [DOM_EVENT.INPUT, DOM_EVENT.CHANGE], function (event) {
    var target = getEventTarget(event);
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      onElementChange(target);
    }
  }, {
    capture: true,
    passive: true
  }).stop;
  var stopPropertySetterInstrumentation;
  if (!isShadowRoot) {
    var instrumentationStoppers_1 = [instrumentSetter(HTMLInputElement.prototype, 'value', onElementChange), instrumentSetter(HTMLInputElement.prototype, 'checked', onElementChange), instrumentSetter(HTMLSelectElement.prototype, 'value', onElementChange), instrumentSetter(HTMLTextAreaElement.prototype, 'value', onElementChange), instrumentSetter(HTMLSelectElement.prototype, 'selectedIndex', onElementChange)];
    stopPropertySetterInstrumentation = function () {
      instrumentationStoppers_1.forEach(function (stopper) {
        return stopper.stop();
      });
    };
  } else {
    stopPropertySetterInstrumentation = noop;
  }
  return {
    stop: function () {
      stopPropertySetterInstrumentation();
      stopEventListeners();
    }
  };
  function onElementChange(target) {
    var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
      return;
    }
    var type = target.type;
    var inputState;
    if (type === 'radio' || type === 'checkbox') {
      if (shouldMaskNode(target, nodePrivacyLevel)) {
        return;
      }
      inputState = {
        isChecked: target.checked
      };
    } else {
      var value = getElementInputValue(target, nodePrivacyLevel);
      if (value === undefined) {
        return;
      }
      inputState = {
        text: value
      };
    }
    // Can be multiple changes on the same node within the same batched mutation observation.
    cbWithDedup(target, inputState);
    // If a radio was checked, other radios with the same name attribute will be unchecked.
    var name = target.name;
    if (type === 'radio' && name && target.checked) {
      forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(cssEscape(name), "\"]")), function (el) {
        if (el !== target) {
          // TODO: Consider the privacy implications for various differing input privacy levels
          cbWithDedup(el, {
            isChecked: false
          });
        }
      });
    }
  }
  /**
   * There can be multiple changes on the same node within the same batched mutation observation.
   */
  function cbWithDedup(target, inputState) {
    if (!hasSerializedNode(target)) {
      return;
    }
    var lastInputState = lastInputStateMap.get(target);
    if (!lastInputState || lastInputState.text !== inputState.text || lastInputState.isChecked !== inputState.isChecked) {
      lastInputStateMap.set(target, inputState);
      inputCb(assembleIncrementalSnapshot(IncrementalSource.Input, assign({
        id: getSerializedNodeId(target)
      }, inputState)));
    }
  }
}

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
/**
 * Minimum duration to wait before processing mutations. This is used to batch mutations together
 * and be able to deduplicate them to save processing time and bandwidth.
 * 16ms is the duration of a frame at 60fps that ensure fluid UI.
 */
var MUTATION_PROCESS_MIN_DELAY = 16;
function createMutationBatch(processMutationBatch) {
  var cancelScheduledFlush = noop;
  var pendingMutations = [];
  function flush() {
    cancelScheduledFlush();
    processMutationBatch(pendingMutations);
    pendingMutations = [];
  }
  var _a = throttle(flush, MUTATION_PROCESS_MIN_DELAY, {
      leading: false
    }),
    throttledFlush = _a.throttled,
    cancelThrottle = _a.cancel;
  return {
    addMutations: function (mutations) {
      if (pendingMutations.length === 0) {
        cancelScheduledFlush = requestIdleCallback(throttledFlush, {
          timeout: MUTATION_PROCESS_MAX_DELAY
        });
      }
      pendingMutations.push.apply(pendingMutations, mutations);
    },
    flush: flush,
    stop: function () {
      cancelScheduledFlush();
      cancelThrottle();
    }
  };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
  if (window.requestIdleCallback && window.cancelIdleCallback) {
    var id_1 = window.requestIdleCallback(monitor(callback), opts);
    return function () {
      return window.cancelIdleCallback(id_1);
    };
  }
  var id = window.requestAnimationFrame(monitor(callback));
  return function () {
    return window.cancelAnimationFrame(id);
  };
}

/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function trackMutation(mutationCallback, configuration, shadowRootsController, target) {
  var MutationObserver = getMutationObserverConstructor();
  if (!MutationObserver) {
    return {
      stop: noop,
      flush: noop
    };
  }
  var mutationBatch = createMutationBatch(function (mutations) {
    processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
  });
  var observer = new MutationObserver(monitor(mutationBatch.addMutations));
  observer.observe(target, {
    attributeOldValue: true,
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return {
    stop: function () {
      observer.disconnect();
      mutationBatch.stop();
    },
    flush: function () {
      mutationBatch.flush();
    }
  };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
  var nodePrivacyLevelCache = new Map();
  mutations.filter(function (mutation) {
    return mutation.type === 'childList';
  }).forEach(function (mutation) {
    mutation.removedNodes.forEach(function (removedNode) {
      traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
    });
  });
  // Discard any mutation with a 'target' node that:
  // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
  // part of a mutation occurring in a parent Node
  // * should be hidden or ignored
  var filteredMutations = mutations.filter(function (mutation) {
    return mutation.target.isConnected && nodeAndAncestorsHaveSerializedNode(mutation.target) && getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache) !== NodePrivacyLevel.HIDDEN;
  });
  var _a = processChildListMutations(filteredMutations.filter(function (mutation) {
      return mutation.type === 'childList';
    }), configuration, shadowRootsController, nodePrivacyLevelCache),
    adds = _a.adds,
    removes = _a.removes,
    hasBeenSerialized = _a.hasBeenSerialized;
  var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
  }), configuration, nodePrivacyLevelCache);
  var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
    return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
  }), configuration, nodePrivacyLevelCache);
  if (!texts.length && !attributes.length && !removes.length && !adds.length) {
    return;
  }
  mutationCallback(assembleIncrementalSnapshot(IncrementalSource.Mutation, {
    adds: adds,
    removes: removes,
    texts: texts,
    attributes: attributes
  }));
}
function processChildListMutations(mutations, configuration, shadowRootsController, nodePrivacyLevelCache) {
  // First, we iterate over mutations to collect:
  //
  // * nodes that have been added in the document and not removed by a subsequent mutation
  // * nodes that have been removed from the document but were not added in a previous mutation
  //
  // For this second category, we also collect their previous parent (mutation.target) because we'll
  // need it to emit a 'remove' mutation.
  //
  // Those two categories may overlap: if a node moved from a position to another, it is reported as
  // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
  // the node will be in both sets.
  var addedAndMovedNodes = new Set();
  var removedNodes = new Map();
  var _loop_1 = function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      addedAndMovedNodes.add(node);
    });
    mutation.removedNodes.forEach(function (node) {
      if (!addedAndMovedNodes.has(node)) {
        removedNodes.set(node, mutation.target);
      }
      addedAndMovedNodes.delete(node);
    });
  };
  for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
    var mutation = mutations_1[_i];
    _loop_1(mutation);
  }
  // Then, we sort nodes that are still in the document by topological order, for two reasons:
  //
  // * We will serialize each added nodes with their descendants. We don't want to serialize a node
  // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
  // a precedent node.
  //
  // * To emit "add" mutations, we need references to the parent and potential next sibling of each
  // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
  // siblings, we want to iterate from last to first. This will ensure that any "next" node is
  // already serialized and have an id.
  var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
  sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
  // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
  // node ids in a set to be able to skip subsequent related mutations.
  var serializedNodeIds = new Set();
  var addedNodeMutations = [];
  for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
    var node = sortedAddedAndMovedNodes_1[_a];
    if (hasBeenSerialized(node)) {
      continue;
    }
    var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
      continue;
    }
    var serializedNode = serializeNodeWithId(node, {
      serializedNodeIds: serializedNodeIds,
      parentNodePrivacyLevel: parentNodePrivacyLevel,
      serializationContext: {
        status: 2 /* SerializationContextStatus.MUTATION */,
        shadowRootsController: shadowRootsController
      },
      configuration: configuration
    });
    if (!serializedNode) {
      continue;
    }
    var parentNode = getParentNode(node);
    addedNodeMutations.push({
      nextId: getNextSibling(node),
      parentId: getSerializedNodeId(parentNode),
      node: serializedNode
    });
  }
  // Finally, we emit remove mutations.
  var removedNodeMutations = [];
  removedNodes.forEach(function (parent, node) {
    if (hasSerializedNode(node)) {
      removedNodeMutations.push({
        parentId: getSerializedNodeId(parent),
        id: getSerializedNodeId(node)
      });
    }
  });
  return {
    adds: addedNodeMutations,
    removes: removedNodeMutations,
    hasBeenSerialized: hasBeenSerialized
  };
  function hasBeenSerialized(node) {
    return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
  }
  function getNextSibling(node) {
    var nextSibling = node.nextSibling;
    while (nextSibling) {
      if (hasSerializedNode(nextSibling)) {
        return getSerializedNodeId(nextSibling);
      }
      nextSibling = nextSibling.nextSibling;
    }
    return null;
  }
}
function processCharacterDataMutations(mutations, configuration, nodePrivacyLevelCache) {
  var _a;
  var textMutations = [];
  // Deduplicate mutations based on their target node
  var handledNodes = new Set();
  var filteredMutations = mutations.filter(function (mutation) {
    if (handledNodes.has(mutation.target)) {
      return false;
    }
    handledNodes.add(mutation.target);
    return true;
  });
  // Emit mutations
  for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
    var mutation = filteredMutations_1[_i];
    var value = mutation.target.textContent;
    if (value === mutation.oldValue) {
      continue;
    }
    var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
      continue;
    }
    textMutations.push({
      id: getSerializedNodeId(mutation.target),
      // TODO: pass a valid "ignoreWhiteSpace" argument
      value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null
    });
  }
  return textMutations;
}
function processAttributesMutations(mutations, configuration, nodePrivacyLevelCache) {
  var attributeMutations = [];
  // Deduplicate mutations based on their target node and changed attribute
  var handledElements = new Map();
  var filteredMutations = mutations.filter(function (mutation) {
    var handledAttributes = handledElements.get(mutation.target);
    if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
      return false;
    }
    if (!handledAttributes) {
      handledElements.set(mutation.target, new Set([mutation.attributeName]));
    } else {
      handledAttributes.add(mutation.attributeName);
    }
    return true;
  });
  // Emit mutations
  var emittedMutations = new Map();
  for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
    var mutation = filteredMutations_2[_i];
    var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
    if (uncensoredValue === mutation.oldValue) {
      continue;
    }
    var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel, nodePrivacyLevelCache);
    var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
    var transformedValue = void 0;
    if (mutation.attributeName === 'value') {
      var inputValue = getElementInputValue(mutation.target, privacyLevel);
      if (inputValue === undefined) {
        continue;
      }
      transformedValue = inputValue;
    } else if (typeof attributeValue === 'string') {
      transformedValue = attributeValue;
    } else {
      transformedValue = null;
    }
    var emittedMutation = emittedMutations.get(mutation.target);
    if (!emittedMutation) {
      emittedMutation = {
        id: getSerializedNodeId(mutation.target),
        attributes: {}
      };
      attributeMutations.push(emittedMutation);
      emittedMutations.set(mutation.target, emittedMutation);
    }
    emittedMutation.attributes[mutation.attributeName] = transformedValue;
  }
  return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
  nodes.sort(function (a, b) {
    var position = a.compareDocumentPosition(b);
    /* eslint-disable no-bitwise */
    if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    } else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
      return 1;
    } else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
      return -1;
    }
    /* eslint-enable no-bitwise */
    return 0;
  });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
  if (isNodeShadowHost(removedNode)) {
    shadowDomRemovedCallback(removedNode.shadowRoot);
  }
  forEachChildNodes(removedNode, function (childNode) {
    return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback);
  });
}

function createElementsScrollPositions() {
  var scrollPositionsByElement = new WeakMap();
  return {
    set: function (element, scrollPositions) {
      if (element === document && !document.scrollingElement) {
        // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
        // in some cases scrolling elements can not be defined, we don't support those for now
        return;
      }
      scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
    },
    get: function (element) {
      return scrollPositionsByElement.get(element);
    },
    has: function (element) {
      return scrollPositionsByElement.has(element);
    }
  };
}

var initShadowRootsController = function (configuration, callback, elementsScrollPositions) {
  var controllerByShadowRoot = new Map();
  var shadowRootsController = {
    addShadowRoot: function (shadowRoot) {
      if (controllerByShadowRoot.has(shadowRoot)) {
        return;
      }
      var mutationTracker = trackMutation(callback, configuration, shadowRootsController, shadowRoot);
      // The change event does not bubble up across the shadow root, we have to listen on the shadow root
      var inputTracker = trackInput(configuration, callback, shadowRoot);
      // The scroll event does not bubble up across the shadow root, we have to listen on the shadow root
      var scrollTracker = trackScroll(configuration, callback, elementsScrollPositions, shadowRoot);
      controllerByShadowRoot.set(shadowRoot, {
        flush: function () {
          return mutationTracker.flush();
        },
        stop: function () {
          mutationTracker.stop();
          inputTracker.stop();
          scrollTracker.stop();
        }
      });
    },
    removeShadowRoot: function (shadowRoot) {
      var entry = controllerByShadowRoot.get(shadowRoot);
      if (!entry) {
        // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
        return;
      }
      entry.stop();
      controllerByShadowRoot.delete(shadowRoot);
    },
    stop: function () {
      controllerByShadowRoot.forEach(function (_a) {
        var stop = _a.stop;
        return stop();
      });
    },
    flush: function () {
      controllerByShadowRoot.forEach(function (_a) {
        var flush = _a.flush;
        return flush();
      });
    }
  };
  return shadowRootsController;
};

function startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, fullSnapshotCallback) {
  var takeFullSnapshot = function (timestamp, serializationContext) {
    if (timestamp === void 0) {
      timestamp = timeStampNow();
    }
    if (serializationContext === void 0) {
      serializationContext = {
        status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
        elementsScrollPositions: elementsScrollPositions,
        shadowRootsController: shadowRootsController
      };
    }
    var _a = getViewportDimension(),
      width = _a.width,
      height = _a.height;
    var records = [{
      data: {
        height: height,
        href: window.location.href,
        width: width
      },
      type: RecordType.Meta,
      timestamp: timestamp
    }, {
      data: {
        has_focus: document.hasFocus()
      },
      type: RecordType.Focus,
      timestamp: timestamp
    }, {
      data: {
        node: serializeDocument(document, configuration, serializationContext),
        initialOffset: {
          left: getScrollX(),
          top: getScrollY()
        }
      },
      type: RecordType.FullSnapshot,
      timestamp: timestamp
    }];
    if (window.visualViewport) {
      records.push({
        data: getVisualViewport(window.visualViewport),
        type: RecordType.VisualViewport,
        timestamp: timestamp
      });
    }
    return records;
  };
  fullSnapshotCallback(takeFullSnapshot());
  var unsubscribe = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
    flushMutations();
    fullSnapshotCallback(takeFullSnapshot(view.startClocks.timeStamp, {
      shadowRootsController: shadowRootsController,
      status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
      elementsScrollPositions: elementsScrollPositions
    }));
  }).unsubscribe;
  return {
    stop: unsubscribe
  };
}

function initRecordIds() {
  var recordIds = new WeakMap();
  var nextId = 1;
  return {
    getIdForEvent: function (event) {
      if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
      }
      return recordIds.get(event);
    }
  };
}

function record(options) {
  var emit = options.emit,
    configuration = options.configuration,
    lifeCycle = options.lifeCycle;
  // runtime checks for user options
  if (!emit) {
    throw new Error('emit function is required');
  }
  var emitAndComputeStats = function (record) {
    emit(record);
    sendToExtension('record', {
      record: record
    });
    var view = options.viewContexts.findView();
    addRecord(view.id);
  };
  var elementsScrollPositions = createElementsScrollPositions();
  var shadowRootsController = initShadowRootsController(configuration, emitAndComputeStats, elementsScrollPositions);
  var stopFullSnapshots = startFullSnapshots(elementsScrollPositions, shadowRootsController, lifeCycle, configuration, flushMutations, function (records) {
    return records.forEach(function (record) {
      return emitAndComputeStats(record);
    });
  }).stop;
  function flushMutations() {
    shadowRootsController.flush();
    mutationTracker.flush();
  }
  var recordIds = initRecordIds();
  var mutationTracker = trackMutation(emitAndComputeStats, configuration, shadowRootsController, document);
  var trackers = [mutationTracker, trackMove(configuration, emitAndComputeStats), trackMouseInteraction(configuration, emitAndComputeStats, recordIds), trackScroll(configuration, emitAndComputeStats, elementsScrollPositions, document), trackViewportResize(configuration, emitAndComputeStats), trackInput(configuration, emitAndComputeStats), trackMediaInteraction(configuration, emitAndComputeStats), trackStyleSheet(emitAndComputeStats), trackFocus(configuration, emitAndComputeStats), trackViewportResize(configuration, emitAndComputeStats), trackFrustration(lifeCycle, emitAndComputeStats, recordIds), trackViewEnd(lifeCycle, function (viewEndRecord) {
    flushMutations();
    emitAndComputeStats(viewEndRecord);
  })];
  return {
    stop: function () {
      shadowRootsController.stop();
      trackers.forEach(function (tracker) {
        return tracker.stop();
      });
      stopFullSnapshots();
    },
    flushMutations: flushMutations,
    shadowRootsController: shadowRootsController
  };
}

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
  var formData = new FormData();
  formData.append('segment', new Blob([data], {
    type: 'application/octet-stream'
  }), "".concat(metadata.session.id, "-").concat(metadata.start));
  var metadataAndSegmentSizes = assign({
    raw_segment_size: rawSegmentBytesCount,
    compressed_segment_size: data.byteLength
  }, metadata);
  var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
  formData.append('event', new Blob([serializedMetadataAndSegmentSizes], {
    type: 'application/json'
  }));
  return {
    data: formData,
    bytesCount: data.byteLength
  };
}

var Segment = /** @class */function () {
  function Segment(encoder, context, creationReason) {
    this.encoder = encoder;
    this.encodedBytesCount = 0;
    var viewId = context.view.id;
    this.metadata = assign({
      start: Infinity,
      end: -Infinity,
      creation_reason: creationReason,
      records_count: 0,
      has_full_snapshot: false,
      index_in_view: getSegmentsCount(viewId),
      source: 'browser'
    }, context);
    addSegment(viewId);
  }
  Segment.prototype.addRecord = function (record, callback) {
    var _this = this;
    var _a;
    this.metadata.start = Math.min(this.metadata.start, record.timestamp);
    this.metadata.end = Math.max(this.metadata.end, record.timestamp);
    this.metadata.records_count += 1;
    (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
    var prefix = this.encoder.isEmpty ? '{"records":[' : ',';
    this.encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
      _this.encodedBytesCount += additionalEncodedBytesCount;
      callback(_this.encodedBytesCount);
    });
  };
  Segment.prototype.flush = function (callback) {
    var _this = this;
    if (this.encoder.isEmpty) {
      throw new Error('Empty segment flushed');
    }
    this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"));
    this.encoder.finish(function (encoderResult) {
      addWroteData(_this.metadata.view.id, encoderResult.rawBytesCount);
      callback(_this.metadata, encoderResult);
    });
  };
  return Segment;
}();

var SEGMENT_DURATION_LIMIT = 30 * ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
  return doStartSegmentCollection(lifeCycle, function () {
    return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts);
  }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
  var state = {
    status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
    nextSegmentCreationReason: 'init'
  };
  var unsubscribeViewCreated = lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_CREATED */, function () {
    flushSegment('view_change');
  }).unsubscribe;
  var unsubscribePageExited = lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
    flushSegment(pageExitEvent.reason);
  }).unsubscribe;
  function flushSegment(flushReason) {
    if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
      state.segment.flush(function (metadata, encoderResult) {
        var payload = buildReplayPayload(encoderResult.output, metadata, encoderResult.rawBytesCount);
        if (isPageExitReason(flushReason)) {
          httpRequest.sendOnExit(payload);
        } else {
          httpRequest.send(payload);
        }
      });
      clearTimeout$1(state.expirationTimeoutId);
    }
    if (flushReason !== 'stop') {
      state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: flushReason
      };
    } else {
      state = {
        status: 2 /* SegmentCollectionStatus.Stopped */
      };
    }
  }
  return {
    addRecord: function (record) {
      if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
        return;
      }
      if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
        var context = getSegmentContext();
        if (!context) {
          return;
        }
        state = {
          status: 1 /* SegmentCollectionStatus.SegmentPending */,
          segment: new Segment(encoder, context, state.nextSegmentCreationReason),
          expirationTimeoutId: setTimeout$1(function () {
            flushSegment('segment_duration_limit');
          }, SEGMENT_DURATION_LIMIT)
        };
      }
      state.segment.addRecord(record, function (encodedBytesCount) {
        if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
          flushSegment('segment_bytes_limit');
        }
      });
    },
    stop: function () {
      flushSegment('stop');
      unsubscribeViewCreated();
      unsubscribePageExited();
    }
  };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
  var session = sessionManager.findTrackedSession();
  var viewContext = viewContexts.findView();
  if (!session || !viewContext) {
    return undefined;
  }
  return {
    application: {
      id: applicationId
    },
    session: {
      id: session.id
    },
    view: {
      id: viewContext.id
    }
  };
}

function startRecordBridge(viewContexts) {
  var bridge = getEventBridge();
  return {
    addRecord: function (record) {
      // Get the current active view, not at the time of the record, aligning with the segment logic.
      // This approach could potentially associate the record to an incorrect view, in case the record date is in the past (e.g. frustration records).
      // However the risk is minimal. We could address the issue when potential negative impact are identified.
      var view = viewContexts.findView();
      bridge.send('record', record, view.id);
    }
  };
}

function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
  var cleanupTasks = [];
  var reportError = function (error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var replayRequest = httpRequest || createHttpRequest(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
  var addRecord;
  if (!canUseEventBridge()) {
    var segmentCollection = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder);
    addRecord = segmentCollection.addRecord;
    cleanupTasks.push(segmentCollection.stop);
  } else {
    addRecord = startRecordBridge(viewContexts).addRecord;
  }
  var stopRecording = record({
    emit: addRecord,
    configuration: configuration,
    lifeCycle: lifeCycle,
    viewContexts: viewContexts
  }).stop;
  cleanupTasks.push(stopRecording);
  return {
    stop: function () {
      cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}

/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
  return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && typeof URL.createObjectURL === 'function' && 'forEach' in NodeList.prototype
  );
}

function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
  var session = sessionManager.findTrackedSession();
  var errorType = getErrorType(session, isRecordingStarted);
  var viewContext = viewContexts.findView();
  return getSessionReplayUrl(configuration, {
    viewContext: viewContext,
    errorType: errorType,
    session: session
  });
}
function getErrorType(session, isRecordingStarted) {
  if (!isBrowserSupported()) {
    return 'browser-not-supported';
  }
  if (!session) {
    // possibilities:
    // - rum sampled out
    // - session expired (edge case)
    return 'rum-not-tracked';
  }
  if (session.sessionReplay === 0 /* SessionReplayState.OFF */) {
    // possibilities
    // - replay sampled out
    return 'incorrect-session-plan';
  }
  if (!isRecordingStarted) {
    return 'replay-not-started';
  }
}

function createDeflateEncoder(configuration, worker, streamId) {
  var rawBytesCount = 0;
  var compressedData = [];
  var compressedDataTrailer;
  var nextWriteActionId = 0;
  var pendingWriteActions = [];
  var removeMessageListener = addEventListener(configuration, worker, 'message', function (_a) {
    var workerResponse = _a.data;
    if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
      return;
    }
    rawBytesCount += workerResponse.additionalBytesCount;
    compressedData.push(workerResponse.result);
    compressedDataTrailer = workerResponse.trailer;
    var nextPendingAction = pendingWriteActions.shift();
    if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
      if (nextPendingAction.writeCallback) {
        nextPendingAction.writeCallback(workerResponse.result.byteLength);
      } else if (nextPendingAction.finishCallback) {
        nextPendingAction.finishCallback();
      }
    } else {
      removeMessageListener();
      addTelemetryDebug('Worker responses received out of order.');
    }
  }).stop;
  function consumeResult() {
    var output = compressedData.length === 0 ? new Uint8Array(0) : concatBuffers(compressedData.concat(compressedDataTrailer));
    var result = {
      rawBytesCount: rawBytesCount,
      output: output,
      outputBytesCount: output.byteLength,
      encoding: 'deflate'
    };
    rawBytesCount = 0;
    compressedData = [];
    return result;
  }
  function sendResetIfNeeded() {
    if (nextWriteActionId > 0) {
      worker.postMessage({
        action: 'reset',
        streamId: streamId
      });
      nextWriteActionId = 0;
    }
  }
  return {
    isAsync: true,
    get isEmpty() {
      return nextWriteActionId === 0;
    },
    write: function (data, callback) {
      worker.postMessage({
        action: 'write',
        id: nextWriteActionId,
        data: data,
        streamId: streamId
      });
      pendingWriteActions.push({
        id: nextWriteActionId,
        writeCallback: callback,
        data: data
      });
      nextWriteActionId += 1;
    },
    finish: function (callback) {
      sendResetIfNeeded();
      if (!pendingWriteActions.length) {
        callback(consumeResult());
      } else {
        // Make sure we do not call any write callback
        pendingWriteActions.forEach(function (pendingWriteAction) {
          delete pendingWriteAction.writeCallback;
        });
        // Wait for the last action to finish before calling the finish callback
        pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function () {
          return callback(consumeResult());
        };
      }
    },
    finishSync: function () {
      sendResetIfNeeded();
      var pendingData = pendingWriteActions.map(function (pendingWriteAction) {
        // Make sure we do not call any write or finish callback
        delete pendingWriteAction.writeCallback;
        delete pendingWriteAction.finishCallback;
        return pendingWriteAction.data;
      }).join('');
      return assign(consumeResult(), {
        pendingData: pendingData
      });
    },
    estimateEncodedBytesCount: function (data) {
      // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
      // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
      // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
      // requests of the expected size.
      return data.length / 8;
    },
    stop: function () {
      removeMessageListener();
    }
  };
}

var INITIALIZATION_TIME_OUT_DELAY = 10 * ONE_SECOND;
function createDeflateWorker(configuration) {
  return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.23.0\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = {
  status: 0 /* DeflateWorkerStatus.Nil */
};
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = createDeflateWorker;
  }
  if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
    // doStartDeflateWorker updates the state to "loading" or "error"
    doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
  }
  switch (state.status) {
    case 1 /* DeflateWorkerStatus.Loading */:
      state.initializationFailureCallbacks.push(onInitializationFailure);
      return state.worker;
    case 3 /* DeflateWorkerStatus.Initialized */:
      return state.worker;
  }
}
function getDeflateWorkerStatus() {
  return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
  if (createDeflateWorkerImpl === void 0) {
    createDeflateWorkerImpl = createDeflateWorker;
  }
  try {
    var worker = createDeflateWorkerImpl(configuration);
    var removeErrorListener_1 = addEventListener(configuration, worker, 'error', function (error) {
      onError(configuration, source, error);
    }).stop;
    var removeMessageListener_1 = addEventListener(configuration, worker, 'message', function (_a) {
      var data = _a.data;
      if (data.type === 'errored') {
        onError(configuration, source, data.error, data.streamId);
      } else if (data.type === 'initialized') {
        onInitialized(data.version);
      }
    }).stop;
    worker.postMessage({
      action: 'init'
    });
    setTimeout$1(function () {
      return onTimeout(source);
    }, INITIALIZATION_TIME_OUT_DELAY);
    var stop_1 = function () {
      removeErrorListener_1();
      removeMessageListener_1();
    };
    state = {
      status: 1 /* DeflateWorkerStatus.Loading */,
      worker: worker,
      stop: stop_1,
      initializationFailureCallbacks: []
    };
  } catch (error) {
    onError(configuration, source, error);
  }
}
function onTimeout(source) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
    display.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
    state.initializationFailureCallbacks.forEach(function (callback) {
      return callback();
    });
    state = {
      status: 2 /* DeflateWorkerStatus.Error */
    };
  }
}
function onInitialized(version) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
    state = {
      status: 3 /* DeflateWorkerStatus.Initialized */,
      worker: state.worker,
      stop: state.stop,
      version: version
    };
  }
}
function onError(configuration, source, error, streamId) {
  if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
    display.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
    if (error instanceof Event || error instanceof Error && isMessageCspRelated(error.message)) {
      var baseMessage = void 0;
      if (configuration.workerUrl) {
        baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
      } else {
        baseMessage = 'Please make sure CSP is correctly configured.';
      }
      display.error("".concat(baseMessage, " See documentation at ").concat(DOCS_ORIGIN, "/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
    } else {
      addTelemetryError(error);
    }
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
      state.initializationFailureCallbacks.forEach(function (callback) {
        return callback();
      });
    }
    state = {
      status: 2 /* DeflateWorkerStatus.Error */
    };
  } else {
    addTelemetryError(error, {
      worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
      stream_id: streamId
    });
  }
}
function isMessageCspRelated(message) {
  return includes(message, 'Content Security Policy') ||
  // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
  includes(message, "requires 'TrustedScriptURL'");
}

function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
  if (canUseEventBridge() && !bridgeSupports("records" /* BridgeCapability.RECORDS */) || !isBrowserSupported()) {
    return {
      start: noop,
      stop: noop,
      getReplayStats: function () {
        return undefined;
      },
      onRumStart: noop,
      isRecording: function () {
        return false;
      },
      getSessionReplayLink: function () {
        return undefined;
      }
    };
  }
  var state = {
    status: 1 /* RecorderStatus.IntentToStart */
  };
  var startStrategy = function () {
    state = {
      status: 1 /* RecorderStatus.IntentToStart */
    };
  };
  var stopStrategy = function () {
    state = {
      status: 0 /* RecorderStatus.Stopped */
    };
  };
  var getSessionReplayLinkStrategy = noop;
  return {
    start: function (options) {
      return startStrategy(options);
    },
    stop: function () {
      return stopStrategy();
    },
    getSessionReplayLink: function () {
      return getSessionReplayLinkStrategy();
    },
    onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts, worker) {
      if (configuration.startSessionReplayRecordingManually) {
        state = {
          status: 0 /* RecorderStatus.Stopped */
        };
      }
      lifeCycle.subscribe(9 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
        if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
          stopStrategy();
          state = {
            status: 1 /* RecorderStatus.IntentToStart */
          };
        }
      });
      // Stop the recorder on page unload to avoid sending records after the page is ended.
      lifeCycle.subscribe(11 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        if (pageExitEvent.reason === PageExitReason.UNLOADING) {
          stopStrategy();
        }
      });
      lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        if (state.status === 1 /* RecorderStatus.IntentToStart */) {
          startStrategy();
        }
      });
      var cachedDeflateEncoder;
      function getOrCreateDeflateEncoder() {
        if (!cachedDeflateEncoder) {
          if (!worker) {
            worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
              stopStrategy();
            }, createDeflateWorkerImpl);
          }
          if (worker) {
            cachedDeflateEncoder = createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */);
          }
        }
        return cachedDeflateEncoder;
      }
      startStrategy = function (options) {
        var session = sessionManager.findTrackedSession();
        if (!session || session.sessionReplay === 0 /* SessionReplayState.OFF */ && !(options === null || options === void 0 ? void 0 : options.force)) {
          state = {
            status: 1 /* RecorderStatus.IntentToStart */
          };
          return;
        }
        if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
          return;
        }
        state = {
          status: 2 /* RecorderStatus.Starting */
        };
        runOnReadyState(configuration, 'interactive', function () {
          if (state.status !== 2 /* RecorderStatus.Starting */) {
            return;
          }
          var deflateEncoder = getOrCreateDeflateEncoder();
          if (!deflateEncoder) {
            state = {
              status: 0 /* RecorderStatus.Stopped */
            };
            return;
          }
          var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, deflateEncoder).stop;
          state = {
            status: 3 /* RecorderStatus.Started */,
            stopRecording: stopRecording
          };
        });
        if ((options === null || options === void 0 ? void 0 : options.force) && session.sessionReplay === 0 /* SessionReplayState.OFF */) {
          sessionManager.setForcedReplay();
        }
      };
      stopStrategy = function () {
        if (state.status === 0 /* RecorderStatus.Stopped */) {
          return;
        }
        if (state.status === 3 /* RecorderStatus.Started */) {
          state.stopRecording();
        }
        state = {
          status: 0 /* RecorderStatus.Stopped */
        };
      };
      getSessionReplayLinkStrategy = function () {
        return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
      };
      if (state.status === 1 /* RecorderStatus.IntentToStart */) {
        startStrategy();
      }
    },
    isRecording: function () {
      // The worker is started optimistically, meaning we could have started to record but its
      // initialization fails a bit later. This could happen when:
      // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
      // throw an exception when instantiating the worker, and IE doesn't care about CSP)
      // * the browser fails to load the worker in case the workerUrl is used
      // * an unexpected error occurs in the Worker before initialization, ex:
      //   * a runtime exception collected by monitor()
      //   * a syntax error notified by the browser via an error event
      // * the worker is unresponsive for some reason and timeouts
      //
      // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
      // an important part of the Datadog App:
      // * If we have a false positive (we set has_replay: true even if no replay data is present),
      // we might display broken links to the Session Replay player.
      // * If we have a false negative (we don't set has_replay: true even if replay data is
      // available), it is less noticeable because no link will be displayed.
      //
      // Thus, it is better to have false negative, so let's make sure the worker is correctly
      // initialized before advertizing that we are recording.
      //
      // In the future, when the compression worker will also be used for RUM data, this will be
      // less important since no RUM event will be sent when the worker fails to initialize.
      return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
    },
    getReplayStats: function (viewId) {
      return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
    }
  };
}

// Keep the following in sync with packages/rum-slim/src/entries/main.ts
var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi, {
  startDeflateWorker: startDeflateWorker,
  createDeflateEncoder: createDeflateEncoder
});
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);

/**
 * datadogRum 초기화
 * @see {@link https://docs.datadoghq.com/real_user_monitoring/browser/}
 * @param {InitDatadogRumParam} datadogRumConfig
 * @example
 * ```
 * initDatadogRum({
 *   applicationId: '66451c75-004a-4a0a-ae4c-02d685d69a6c',
 *   clientToken: 'pub016ce1bb00dd9537751b302853449132',
 *   env: 'dev' | 'qa' | 'prod'
 *   service: 'store-web',
 *   sessionSampleRate: 5,
 *   sessionReplaySampleRate: 5,
 * });
 * ```
 */
const initDatadogRum = ({
  applicationId,
  clientToken,
  service,
  env,
  version = '',
  sessionSampleRate,
  sessionReplaySampleRate
}) => {
  if (typeof window === 'undefined' || !['qa', 'prod'].includes(env ?? '')) {
    return;
  }
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service,
    env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  if (sessionReplaySampleRate > 0) {
    datadogRum.startSessionReplayRecording();
  }
};

const getGoogleTagManagerScript = gtmId => {
  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}')`;
};
function GoogleTagManagerScript({
  gtmId,
  ScriptComponent,
  scriptProps
}) {
  return jsxs(Fragment, {
    children: [/*#__PURE__*/createElement(ScriptComponent ?? 'script', {
      ...scriptProps,
      dangerouslySetInnerHTML: {
        __html: getGoogleTagManagerScript(gtmId)
      }
    }), jsx("noscript", {
      children: jsx("iframe", {
        src: `https://www.googletagmanager.com/ns.html?id=${gtmId}`,
        height: "0",
        width: "0",
        style: {
          display: 'none',
          visibility: 'hidden'
        }
      })
    })]
  });
}

export { AIRBRIDGE, API_AUTOCOMPLETE_HOST, AdsBadge, AppDownloadPopupWithQR, BACKDROP_COLOR, BadgeList, Badges, BaseFeedItem, BlockedPage, COUNTRY_TO_LANGUAGE, COUPON_PUBLISH_DONE_MESSAGE, CUSTOM_COUPON_PUBLISH_MESSAGE, CardFeedItem, CardFeedItemPlaceholder, CardPlaceholder, ChangeLocaleSection, ChannelTalk, ChipListModule, CommerceProductCard, index as CommerceProductCardComponents, Container$q as Container, ContentFeedItem, ContentFeedItemPlaceholder, CouponErrorCode, DEEP_LINK_HOST, DEFAULT_OG_IMAGE, DELIVERY_PAYMENT, DELIVERY_SERVICE_CODE, DELIVERY_TARGET_TYPE, DELIVERY_TARGET_TYPE_NAME, DELIVERY_TRACKING_STATUS, DOMAINS, DeliveryBadge, DeliveryOrderInfo, DeliveryStartAt, DeliverySummary, DeliveryTimeLine, DeliveryTrackingLoadFail, DeliveryTrackingTemplate, DetailWriterCard, DropdownContent, FEED_ITEM_DESKTOP_ASPECT_RATIO, FEED_ITEM_MOBILE_ASPECT_RATIO, FacebookPixelScript, FeedItem, FeedItemOverlayElement, FeedItemPlaceholder, FeedItemThumbnail$1 as FeedItemThumbnail, FeedPlaceholder, FilterKey, Follow, GLOBAL_AIRBRIDGE, GLOBAL_API_GATEWAY, GLOBAL_COUNTRY_TO_LANGUAGE, GLOBAL_DEEP_LINK_HOST, GLOBAL_DEFAULT_COUNTRY, GLOBAL_DEFAULT_LANGUAGE, GLOBAL_DEFAULT_LOCALE, GLOBAL_DEFAULT_METADATA, GLOBAL_DOMAINS, GLOBAL_INFO, GLOBAL_LANGUAGE_TO_COUNTRY, GLOBAL_PREFERRED_LOCALES, GNB, GlobalBanner, GlobalFooter, GoogleTagManagerScript, HTTPError, IconWithTextBadge, ImageTagDraggableOverlay, ImageTagDraggableOverlayItem, ImageTagEdit, ImageTagEditAdmin, ImageTagEditAdminModal, ImageTagEditAdminProductionItem, ImageTagEditAdminSearchHeader, ImageTagEditAdminTagContent, ImageTagEditAdminTagContentFormGroup, ImageTagEditSelectCustomPanel, ImageTagEditSelectDropDownContent, ImageTagEditSelectModal, ImageTagEditSelectPanel, ImageTagEditTagContent, ImpressionTracker, Info$1 as Info, InfoPlaceholder, InfoTip, KAKAO_TEMPLATE_ID, KeywordFilters, LANGUAGE_TO_COUNTRY, LogLink, LogoIcon$1 as LogoIcon, NOTICE_DISPLAYED_USER_LIST_KEY, Price, PricePlaceholder, ProductCard, ProductCardScrap, ProductionSelectPanel, QUERY_BLACKLIST, RangeSliderInput, RouteFilter, SHIPMENT_TYPE, SHORTCUT_TYPE, STORE_ITEM_TYPE, Scrap$1 as Scrap, ScrapBookSelectModal, SharePopper, ShareType, SoldOutBanner, Stats, StatsPlaceholder, StylingShotInventoryItem, TAG_BUTTON_WIDTH, TAG_ITEM_DEFAULT_RENDER_CONTENT, TagButton, TagItem, TagMemoContent, TagProductionContent, Thumbnail$2 as Thumbnail, ThumbnailBadge, ThumbnailPlaceholder, Timer, TrendingKeywordsDropdown, TrendingKeywordsEntry, TrendingKeywordsList, TrendingKeywordsRolling, USERABLE_TYPE, UTM_TAGS, UrlCopyButton, addRange, bucketClickLog, bucketImpressionLog, checkIsGlobal, convertDealToProduct, convertGoodsSummaryToProduct, convertGoodsToProduct, convertLandingUrlByHost, convertLocaleToLanguageInPathname, convertStoreItemToProduct, convertThumbnailBadgeToBadge, countries, createColorSchema, createColorTagDeserializer, createColorTagSerializer, createDeserialize, createGroupSchema, createListSchema, createListTagDeserializer, createListTagSerializer, createProductScrapData, createRangeSchema, createRangeTagDeserializer, createRangeTagSerializer, createSearchHistoryStorage, createSerialize, escapeBracesInQuery, fetchDelete, fetchGet, fetchPatch, fetchPost, fetchPut, fetchSugar, findNextOption, findPreviousOption, formatPhoneNumber, formatPriceByCurrency, formatRange, formatTimeStringFromTotalSeconds, getAmplitude, getBestCardPromotion, getBrandHomeKakaoTemplate, getCardPromotionBadges, getCardPromotionTitle, getClientIp, getCookieDomain, getCouponBadge, getCouponBadgeTitle, getCouponsPublishMessage, getDeepLink, getDeliveryTackingNoticeFormat, getDiscountPrice, getExhibitionKakaoTemplate, getFacebookPixelScript, getGlobalCountryFromLocaleString, getGlobalLanguageFromLocaleString, getLoginURL, getMaxDiscountCouponMold, getMinBaseAmountCouponMold, getProductPriceInfo, getPublishCartCouponStatus, getPublishCouponsMessage, getPublishProductCouponStatus, getRange, getSearchTargetURL, getSearchType, getSearchURL, getServiceType, getShortenPrice, getTagTheme, getTextAtLocalePositionInUrl, getURL, getUrlWithExchangeLocale, getUtmData, getUtmDataFromUrl, globalCountries, globalLanguages, globalLocales, globalMiddleware, initAirbridge, initBraze, initBucketLog, initCriteo, initDatadogRum, initKakaoPixel, initNaverAnalycis, initWiderPlanet, isAllowEnv, isAllowedGlobalCountry, isAllowedGlobalLanguage, isAllowedGlobalLocale, isAndroid13OrAbove, isInclude, isNextJsPageRequest, isPreferredGlobalLocale, joinLinkQuery, languages, locales, logAirbridge, logAmplitude$1 as logAmplitude, logAppBraze, logBraze, logFacebookPixel, removeViewableImpressionLog, sendImpressionLog, sendViewableImpressionLog, serializePathToString, setSearchAffectType, setUtmData, shouldShowDeliveryBadge, signinAirbridge, signoutAirbridge, signupAirbridge, useCallbackRef, useGoogleReferrerTracking, useImpressionLog, useIntersectionObserver, useKakaoAPI, useMergeRef, useNoticePolicyUpdate, useProductCardLogData, useToggle$1 as useToggle, useUploadTimeFormatter, useViewableImpressionLog, useWebviewEventDispatcher, useWebviewEventListener };
//# sourceMappingURL=index.es.js.map
